var gd = Object.defineProperty;
var md = (t, r, e) => r in t ? gd(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e;
var dr = (t, r, e) => (md(t, typeof r != "symbol" ? r + "" : r, e), e);
/*!
    DivKit v32.26.0
    https://github.com/divkit/divkit
    @licence Apache-2.0
*/
function T() {
}
const Ss = (t) => t;
function ui(t, r) {
  for (const e in r)
    t[e] = r[e];
  return (
    /** @type {T & S} */
    t
  );
}
function uf(t) {
  return t();
}
function $l() {
  return /* @__PURE__ */ Object.create(null);
}
function Qr(t) {
  t.forEach(uf);
}
function zr(t) {
  return typeof t == "function";
}
function bd(t, r) {
  return t != t ? r == r : t !== r || t && typeof t == "object" || typeof t == "function";
}
let Oo;
function Zn(t, r) {
  return t === r ? !0 : (Oo || (Oo = document.createElement("a")), Oo.href = r, t === Oo.href);
}
function Vr(t, r) {
  return t != t ? r == r : t !== r;
}
function yd(t) {
  return Object.keys(t).length === 0;
}
function B(t, ...r) {
  if (t == null) {
    for (const n of r)
      n(void 0);
    return T;
  }
  const e = t.subscribe(...r);
  return e.unsubscribe ? () => e.unsubscribe() : e;
}
function ol(t) {
  let r;
  return B(t, (e) => r = e)(), r;
}
function mn(t, r, e) {
  t.$$.on_destroy.push(B(r, e));
}
function Vs(t, r, e, n) {
  if (t) {
    const i = cf(t, r, e, n);
    return t[0](i);
  }
}
function cf(t, r, e, n) {
  return t[1] && n ? ui(e.ctx.slice(), t[1](n(r))) : e.ctx;
}
function Is(t, r, e, n) {
  if (t[2] && n) {
    const i = t[2](n(e));
    if (r.dirty === void 0)
      return i;
    if (typeof i == "object") {
      const o = [], s = Math.max(r.dirty.length, i.length);
      for (let a = 0; a < s; a += 1)
        o[a] = r.dirty[a] | i[a];
      return o;
    }
    return r.dirty | i;
  }
  return r.dirty;
}
function Ds(t, r, e, n, i, o) {
  if (i) {
    const s = cf(r, e, n, o);
    t.p(s, i);
  }
}
function Ts(t) {
  if (t.ctx.length > 32) {
    const r = [], e = t.ctx.length / 32;
    for (let n = 0; n < e; n++)
      r[n] = -1;
    return r;
  }
  return -1;
}
function Gs(t, r, e) {
  return t.set(e), r;
}
function Fs(t) {
  return t && zr(t.destroy) ? t.destroy : T;
}
function ea(t) {
  const r = typeof t == "string" && t.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return r ? [parseFloat(r[1]), r[2] || "px"] : [
    /** @type {number} */
    t,
    "px"
  ];
}
const ff = typeof window < "u";
let Vl = ff ? () => window.performance.now() : () => Date.now(), Il = ff ? (t) => requestAnimationFrame(t) : T;
const co = /* @__PURE__ */ new Set();
function df(t) {
  co.forEach((r) => {
    r.c(t) || (co.delete(r), r.f());
  }), co.size !== 0 && Il(df);
}
function Dl(t) {
  let r;
  return co.size === 0 && Il(df), {
    promise: new Promise((e) => {
      co.add(r = { c: t, f: e });
    }),
    abort() {
      co.delete(r);
    }
  };
}
const wi = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : (
  // @ts-ignore Node typings have this
  global
);
function Tt(t, r) {
  t.appendChild(r);
}
function _f(t) {
  if (!t)
    return document;
  const r = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return r && /** @type {ShadowRoot} */
  r.host ? (
    /** @type {ShadowRoot} */
    r
  ) : t.ownerDocument;
}
function wd(t) {
  const r = Be("style");
  return r.textContent = "/* empty */", vd(_f(t), r), r.sheet;
}
function vd(t, r) {
  return Tt(
    /** @type {Document} */
    t.head || t,
    r
  ), r.sheet;
}
function x(t, r, e) {
  t.insertBefore(r, e || null);
}
function Z(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function gn(t, r) {
  for (let e = 0; e < t.length; e += 1)
    t[e] && t[e].d(r);
}
function Be(t) {
  return document.createElement(t);
}
function En(t) {
  return document.createElementNS("http://www.w3.org/2000/svg", t);
}
function ei(t) {
  return document.createTextNode(t);
}
function wr() {
  return ei(" ");
}
function $t() {
  return ei("");
}
function Ge(t, r, e, n) {
  return t.addEventListener(r, e, n), () => t.removeEventListener(r, e, n);
}
function m(t, r, e) {
  e == null ? t.removeAttribute(r) : t.getAttribute(r) !== e && t.setAttribute(r, e);
}
const kd = ["width", "height"];
function Di(t, r) {
  const e = Object.getOwnPropertyDescriptors(t.__proto__);
  for (const n in r)
    r[n] == null ? t.removeAttribute(n) : n === "style" ? t.style.cssText = r[n] : n === "__value" ? t.value = t[n] = r[n] : e[n] && e[n].set && kd.indexOf(n) === -1 ? t[n] = r[n] : m(t, n, r[n]);
}
function Ed(t, r) {
  Object.keys(r).forEach((e) => {
    Ad(t, e, r[e]);
  });
}
function Ad(t, r, e) {
  const n = r.toLowerCase();
  n in t ? t[n] = typeof t[n] == "boolean" && e === "" ? !0 : e : r in t ? t[r] = typeof t[r] == "boolean" && e === "" ? !0 : e : m(t, r, e);
}
function zi(t) {
  return /-/.test(t) ? Ed : Di;
}
function jd(t) {
  return Array.from(t.childNodes);
}
function Ti(t, r) {
  r = "" + r, t.data !== r && (t.data = /** @type {string} */
  r);
}
function ta(t, r) {
  t.value = r == null ? "" : r;
}
function q(t, r, e, n) {
  e == null ? t.style.removeProperty(r) : t.style.setProperty(r, e, "");
}
function ra(t, r, e) {
  for (let n = 0; n < t.options.length; n += 1) {
    const i = t.options[n];
    if (i.__value === r) {
      i.selected = !0;
      return;
    }
  }
  (!e || r !== void 0) && (t.selectedIndex = -1);
}
function Cd(t) {
  const r = t.querySelector(":checked");
  return r && r.__value;
}
function pf(t, r, { bubbles: e = !1, cancelable: n = !1 } = {}) {
  return new CustomEvent(t, { detail: r, bubbles: e, cancelable: n });
}
function na(t, r) {
  return new t(r);
}
const ds = /* @__PURE__ */ new Map();
let _s = 0;
function Sd(t) {
  let r = 5381, e = t.length;
  for (; e--; )
    r = (r << 5) - r ^ t.charCodeAt(e);
  return r >>> 0;
}
function Vd(t, r) {
  const e = { stylesheet: wd(r), rules: {} };
  return ds.set(t, e), e;
}
function ps(t, r, e, n, i, o, s, a = 0) {
  const l = 16.666 / n;
  let u = `{
`;
  for (let w = 0; w <= 1; w += l) {
    const E = r + (e - r) * o(w);
    u += w * 100 + `%{${s(E, 1 - E)}}
`;
  }
  const c = u + `100% {${s(e, 1 - e)}}
}`, f = `__svelte_${Sd(c)}_${a}`, _ = _f(t), { stylesheet: g, rules: y } = ds.get(_) || Vd(_, t);
  y[f] || (y[f] = !0, g.insertRule(`@keyframes ${f} ${c}`, g.cssRules.length));
  const p = t.style.animation || "";
  return t.style.animation = `${p ? `${p}, ` : ""}${f} ${n}ms linear ${i}ms 1 both`, _s += 1, f;
}
function hs(t, r) {
  const e = (t.style.animation || "").split(", "), n = e.filter(
    r ? (o) => o.indexOf(r) < 0 : (o) => o.indexOf("__svelte") === -1
    // remove all Svelte animations
  ), i = e.length - n.length;
  i && (t.style.animation = n.join(", "), _s -= i, _s || Id());
}
function Id() {
  Il(() => {
    _s || (ds.forEach((t) => {
      const { ownerNode: r } = t.stylesheet;
      r && Z(r);
    }), ds.clear());
  });
}
let Do;
function Io(t) {
  Do = t;
}
function mo() {
  if (!Do)
    throw new Error("Function called outside component initialization");
  return Do;
}
function Jn(t) {
  mo().$$.on_mount.push(t);
}
function Ms(t) {
  mo().$$.after_update.push(t);
}
function bn(t) {
  mo().$$.on_destroy.push(t);
}
function Dd() {
  const t = mo();
  return (r, e, { cancelable: n = !1 } = {}) => {
    const i = t.$$.callbacks[r];
    if (i) {
      const o = pf(
        /** @type {string} */
        r,
        e,
        { cancelable: n }
      );
      return i.slice().forEach((s) => {
        s.call(t, o);
      }), !o.defaultPrevented;
    }
    return !0;
  };
}
function Yi(t, r) {
  return mo().$$.context.set(t, r), r;
}
function Xr(t) {
  return mo().$$.context.get(t);
}
function Dn(t, r) {
  const e = t.$$.callbacks[r.type];
  e && e.slice().forEach((n) => n.call(this, r));
}
const lo = [], Or = [];
let fo = [];
const ia = [], hf = /* @__PURE__ */ Promise.resolve();
let sl = !1;
function gf() {
  sl || (sl = !0, hf.then(mf));
}
function jn() {
  return gf(), hf;
}
function Yn(t) {
  fo.push(t);
}
const Ys = /* @__PURE__ */ new Set();
let io = 0;
function mf() {
  if (io !== 0)
    return;
  const t = Do;
  do {
    try {
      for (; io < lo.length; ) {
        const r = lo[io];
        io++, Io(r), Td(r.$$);
      }
    } catch (r) {
      throw lo.length = 0, io = 0, r;
    }
    for (Io(null), lo.length = 0, io = 0; Or.length; )
      Or.pop()();
    for (let r = 0; r < fo.length; r += 1) {
      const e = fo[r];
      Ys.has(e) || (Ys.add(e), e());
    }
    fo.length = 0;
  } while (lo.length);
  for (; ia.length; )
    ia.pop()();
  sl = !1, Ys.clear(), Io(t);
}
function Td(t) {
  if (t.fragment !== null) {
    t.update(), Qr(t.before_update);
    const r = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, r), t.after_update.forEach(Yn);
  }
}
function Fd(t) {
  const r = [], e = [];
  fo.forEach((n) => t.indexOf(n) === -1 ? r.push(n) : e.push(n)), e.forEach((n) => n()), fo = r;
}
let Co;
function Tl() {
  return Co || (Co = Promise.resolve(), Co.then(() => {
    Co = null;
  })), Co;
}
function Ki(t, r, e) {
  t.dispatchEvent(pf(`${r ? "intro" : "outro"}${e}`));
}
const Ko = /* @__PURE__ */ new Set();
let hi;
function _r() {
  hi = {
    r: 0,
    c: [],
    p: hi
    // parent group
  };
}
function pr() {
  hi.r || Qr(hi.c), hi = hi.p;
}
function K(t, r) {
  t && t.i && (Ko.delete(t), t.i(r));
}
function ae(t, r, e, n) {
  if (t && t.o) {
    if (Ko.has(t))
      return;
    Ko.add(t), hi.c.push(() => {
      Ko.delete(t), n && (e && t.d(1), n());
    }), t.o(r);
  } else
    n && n();
}
const Fl = { duration: 0 };
function Ps(t, r, e) {
  const n = { direction: "in" };
  let i = r(t, e, n), o = !1, s, a, l = 0;
  function u() {
    s && hs(t, s);
  }
  function c() {
    const {
      delay: _ = 0,
      duration: g = 300,
      easing: y = Ss,
      tick: p = T,
      css: w
    } = i || Fl;
    w && (s = ps(t, 0, 1, g, _, y, w, l++)), p(0, 1);
    const E = Vl() + _, Q = E + g;
    a && a.abort(), o = !0, Yn(() => Ki(t, !0, "start")), a = Dl((J) => {
      if (o) {
        if (J >= Q)
          return p(1, 0), Ki(t, !0, "end"), u(), o = !1;
        if (J >= E) {
          const M = y((J - E) / g);
          p(M, 1 - M);
        }
      }
      return o;
    });
  }
  let f = !1;
  return {
    start() {
      f || (f = !0, hs(t), zr(i) ? (i = i(n), Tl().then(c)) : c());
    },
    invalidate() {
      f = !1;
    },
    end() {
      o && (u(), o = !1);
    }
  };
}
function bf(t, r, e) {
  const n = { direction: "out" };
  let i = r(t, e, n), o = !0, s;
  const a = hi;
  a.r += 1;
  let l;
  function u() {
    const {
      delay: c = 0,
      duration: f = 300,
      easing: _ = Ss,
      tick: g = T,
      css: y
    } = i || Fl;
    y && (s = ps(t, 1, 0, f, c, _, y));
    const p = Vl() + c, w = p + f;
    Yn(() => Ki(t, !1, "start")), "inert" in t && (l = /** @type {HTMLElement} */
    t.inert, t.inert = !0), Dl((E) => {
      if (o) {
        if (E >= w)
          return g(0, 1), Ki(t, !1, "end"), --a.r || Qr(a.c), !1;
        if (E >= p) {
          const Q = _((E - p) / f);
          g(1 - Q, Q);
        }
      }
      return o;
    });
  }
  return zr(i) ? Tl().then(() => {
    i = i(n), u();
  }) : u(), {
    end(c) {
      c && "inert" in t && (t.inert = l), c && i.tick && i.tick(1, 0), o && (s && hs(t, s), o = !1);
    }
  };
}
function oa(t, r, e, n) {
  let o = r(t, e, { direction: "both" }), s = n ? 0 : 1, a = null, l = null, u = null, c;
  function f() {
    u && hs(t, u);
  }
  function _(y, p) {
    const w = (
      /** @type {Program['d']} */
      y.b - s
    );
    return p *= Math.abs(w), {
      a: s,
      b: y.b,
      d: w,
      duration: p,
      start: y.start,
      end: y.start + p,
      group: y.group
    };
  }
  function g(y) {
    const {
      delay: p = 0,
      duration: w = 300,
      easing: E = Ss,
      tick: Q = T,
      css: J
    } = o || Fl, M = {
      start: Vl() + p,
      b: y
    };
    y || (M.group = hi, hi.r += 1), "inert" in t && (y ? c !== void 0 && (t.inert = c) : (c = /** @type {HTMLElement} */
    t.inert, t.inert = !0)), a || l ? l = M : (J && (f(), u = ps(t, s, y, w, p, E, J)), y && Q(0, 1), a = _(M, w), Yn(() => Ki(t, y, "start")), Dl((ge) => {
      if (l && ge > l.start && (a = _(l, w), l = null, Ki(t, a.b, "start"), J && (f(), u = ps(
        t,
        s,
        a.b,
        a.duration,
        0,
        E,
        o.css
      ))), a) {
        if (ge >= a.end)
          Q(s = a.b, 1 - s), Ki(t, a.b, "end"), l || (a.b ? f() : --a.group.r || Qr(a.group.c)), a = null;
        else if (ge >= a.start) {
          const le = ge - a.start;
          s = a.a + a.d * E(le / a.duration), Q(s, 1 - s);
        }
      }
      return !!(a || l);
    }));
  }
  return {
    run(y) {
      zr(o) ? Tl().then(() => {
        o = o({ direction: y ? "in" : "out" }), g(y);
      }) : g(y);
    },
    end() {
      f(), a = l = null;
    }
  };
}
function lr(t) {
  return (t == null ? void 0 : t.length) !== void 0 ? t : Array.from(t);
}
function yf(t, r) {
  ae(t, 1, 1, () => {
    r.delete(t.key);
  });
}
function wf(t, r, e, n, i, o, s, a, l, u, c, f) {
  let _ = t.length, g = o.length, y = _;
  const p = {};
  for (; y--; )
    p[t[y].key] = y;
  const w = [], E = /* @__PURE__ */ new Map(), Q = /* @__PURE__ */ new Map(), J = [];
  for (y = g; y--; ) {
    const H = f(i, o, y), ee = e(H);
    let X = s.get(ee);
    X ? J.push(() => X.p(H, r)) : (X = u(ee, H), X.c()), E.set(ee, w[y] = X), ee in p && Q.set(ee, Math.abs(y - p[ee]));
  }
  const M = /* @__PURE__ */ new Set(), ge = /* @__PURE__ */ new Set();
  function le(H) {
    K(H, 1), H.m(a, c), s.set(H.key, H), c = H.first, g--;
  }
  for (; _ && g; ) {
    const H = w[g - 1], ee = t[_ - 1], X = H.key, I = ee.key;
    H === ee ? (c = H.first, _--, g--) : E.has(I) ? !s.has(X) || M.has(X) ? le(H) : ge.has(I) ? _-- : Q.get(X) > Q.get(I) ? (ge.add(X), le(H)) : (M.add(I), _--) : (l(ee, s), _--);
  }
  for (; _--; ) {
    const H = t[_];
    E.has(H.key) || l(H, s);
  }
  for (; g; )
    le(w[g - 1]);
  return Qr(J), w;
}
function vi(t, r) {
  const e = {}, n = {}, i = { $$scope: 1 };
  let o = t.length;
  for (; o--; ) {
    const s = t[o], a = r[o];
    if (a) {
      for (const l in s)
        l in a || (n[l] = 1);
      for (const l in a)
        i[l] || (e[l] = a[l], i[l] = 1);
      t[o] = a;
    } else
      for (const l in s)
        i[l] = 1;
  }
  for (const s in n)
    s in e || (e[s] = void 0);
  return e;
}
function vf(t) {
  return typeof t == "object" && t !== null ? t : {};
}
function Zt(t) {
  t && t.c();
}
function Kt(t, r, e) {
  const { fragment: n, after_update: i } = t.$$;
  n && n.m(r, e), Yn(() => {
    const o = t.$$.on_mount.map(uf).filter(zr);
    t.$$.on_destroy ? t.$$.on_destroy.push(...o) : Qr(o), t.$$.on_mount = [];
  }), i.forEach(Yn);
}
function Xt(t, r) {
  const e = t.$$;
  e.fragment !== null && (Fd(e.after_update), Qr(e.on_destroy), e.fragment && e.fragment.d(r), e.on_destroy = e.fragment = null, e.ctx = []);
}
function Md(t, r) {
  t.$$.dirty[0] === -1 && (lo.push(t), gf(), t.$$.dirty.fill(0)), t.$$.dirty[r / 31 | 0] |= 1 << r % 31;
}
function xr(t, r, e, n, i, o, s = null, a = [-1]) {
  const l = Do;
  Io(t);
  const u = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: T,
    not_equal: i,
    bound: $l(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(r.context || (l ? l.$$.context : [])),
    // everything else
    callbacks: $l(),
    dirty: a,
    skip_bound: !1,
    root: r.target || l.$$.root
  };
  s && s(u.root);
  let c = !1;
  if (u.ctx = e ? e(t, r.props || {}, (f, _, ...g) => {
    const y = g.length ? g[0] : _;
    return u.ctx && i(u.ctx[f], u.ctx[f] = y) && (!u.skip_bound && u.bound[f] && u.bound[f](y), c && Md(t, f)), _;
  }) : [], u.update(), c = !0, Qr(u.before_update), u.fragment = n ? n(u.ctx) : !1, r.target) {
    if (r.hydrate) {
      const f = jd(r.target);
      u.fragment && u.fragment.l(f), f.forEach(Z);
    } else
      u.fragment && u.fragment.c();
    r.intro && K(t.$$.fragment), Kt(t, r.target, r.anchor), mf();
  }
  Io(l);
}
class $r {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    dr(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    dr(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    Xt(this, 1), this.$destroy = T;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(r, e) {
    if (!zr(e))
      return T;
    const n = this.$$.callbacks[r] || (this.$$.callbacks[r] = []);
    return n.push(e), () => {
      const i = n.indexOf(e);
      i !== -1 && n.splice(i, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(r) {
    this.$$set && !yd(r) && (this.$$.skip_bound = !0, this.$$set(r), this.$$.skip_bound = !1);
  }
}
const Pd = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Pd);
const oo = [];
function Nd(t, r) {
  return {
    subscribe: gi(t, r).subscribe
  };
}
function gi(t, r = T) {
  let e;
  const n = /* @__PURE__ */ new Set();
  function i(a) {
    if (bd(t, a) && (t = a, e)) {
      const l = !oo.length;
      for (const u of n)
        u[1](), oo.push(u, t);
      if (l) {
        for (let u = 0; u < oo.length; u += 2)
          oo[u][0](oo[u + 1]);
        oo.length = 0;
      }
    }
  }
  function o(a) {
    i(a(t));
  }
  function s(a, l = T) {
    const u = [a, l];
    return n.add(u), n.size === 1 && (e = r(i, o) || T), a(t), () => {
      n.delete(u), n.size === 0 && e && (e(), e = null);
    };
  }
  return { set: i, update: o, subscribe: s };
}
function bo(t, r, e) {
  const n = !Array.isArray(t), i = n ? [t] : t;
  if (!i.every(Boolean))
    throw new Error("derived() expects stores as input, got a falsy value");
  const o = r.length < 2;
  return Nd(e, (s, a) => {
    let l = !1;
    const u = [];
    let c = 0, f = T;
    const _ = () => {
      if (c)
        return;
      f();
      const y = r(n ? u[0] : u, s, a);
      o ? s(y) : f = zr(y) ? y : T;
    }, g = i.map(
      (y, p) => B(
        y,
        (w) => {
          u[p] = w, c &= ~(1 << p), l && _();
        },
        () => {
          c |= 1 << p;
        }
      )
    );
    return l = !0, _(), function() {
      Qr(g), f(), l = !1;
    };
  });
}
const zd = "appkit-root_platform_desktop", Od = "appkit-root__clickable", Ld = "appkit-root", Rd = "appkit-root__selectable", Bd = "appkit-root__unselectable", ur = {
  root_platform_desktop: zd,
  root__clickable: Od,
  "root__clickable-no-transition": "appkit-root__clickable-no-transition",
  "root__any-actions": "appkit-root__any-actions",
  root: Ld,
  root__selectable: Rd,
  root__unselectable: Bd,
  "root_restrict-scroll": "appkit-root_restrict-scroll",
  "root_disabled-context-menu": "appkit-root_disabled-context-menu"
}, _n = Symbol("root");
function R(t, r = {}) {
  const e = t;
  return e.level = r.level || "error", r.additional && (e.additional = r.additional), e;
}
const Hd = "appkit-outer", Wd = "appkit-root__clickable", Ud = "appkit-outer_width_content", Gd = "appkit-outer_height_content", Yd = "appkit-outer__border", qd = "appkit-outer_visibility_invisible", Jd = "appkit-outer_visibility_gone", gs = {
  outer: Hd,
  root__clickable: Wd,
  "root__clickable-no-transition": "appkit-root__clickable-no-transition",
  "outer_hide-on-transition-in": "appkit-outer_hide-on-transition-in",
  "outer_halign-self_start": "appkit-outer_halign-self_start",
  "outer_halign-self_center": "appkit-outer_halign-self_center",
  "outer_halign-self_end": "appkit-outer_halign-self_end",
  "outer_halign-self_stretch": "appkit-outer_halign-self_stretch",
  "outer_valign-self_start": "appkit-outer_valign-self_start",
  "outer_valign-self_center": "appkit-outer_valign-self_center",
  "outer_valign-self_end": "appkit-outer_valign-self_end",
  "outer_valign-self_stretch": "appkit-outer_valign-self_stretch",
  "outer_parent-flex_vertical": "appkit-outer_parent-flex_vertical",
  "outer_parent-flex_horizontal": "appkit-outer_parent-flex_horizontal",
  "outer_valign-self_baseline": "appkit-outer_valign-self_baseline",
  outer_width_content: Ud,
  outer_height_content: Gd,
  "outer_width-constrained": "appkit-outer_width-constrained",
  "outer_parent-grid": "appkit-outer_parent-grid",
  "outer_height-constrained": "appkit-outer_height-constrained",
  "outer_parent-overlap": "appkit-outer_parent-overlap",
  "outer_scroll-snap_start": "appkit-outer_scroll-snap_start",
  "outer_scroll-snap_center": "appkit-outer_scroll-snap_center",
  "outer_scroll-snap_end": "appkit-outer_scroll-snap_end",
  outer__border: Yd,
  outer_visibility_invisible: qd,
  outer_visibility_gone: Jd,
  "outer_has-action-animation": "appkit-outer_has-action-animation",
  "outer_has-custom-focus": "appkit-outer_has-custom-focus"
};
function Rt(t) {
  if (!t)
    return;
  let r = "";
  for (const e in t)
    if (t.hasOwnProperty(e)) {
      if (!t[e] && t[e] !== 0)
        continue;
      r && (r += ";"), r += e + ":" + String(t[e]);
    }
  return r || void 0;
}
function Re(t) {
  if (typeof t != "number" && typeof t != "string" || !t)
    return "0";
  const r = Number(t);
  return Number.isNaN(r) ? "0" : Math.ceil(r * 1e3) / 1e4 + "em";
}
function dn(t) {
  let r = Re(t);
  return r === "0" && (r += "em"), r;
}
function kf(t, r) {
  for (; t.length < r; )
    t = "0" + t;
  return t;
}
function Tr(t, r = 1, e = "transparent") {
  if (t = (typeof t == "string" && t || "").toLowerCase(), t.charAt(0) !== "#")
    return e;
  const n = si(t);
  return n ? (n.a *= r, Ml(n)) : e;
}
function Kd(t, r, e = "transparent") {
  if (t = (typeof t == "string" && t || "").toLowerCase(), t.charAt(0) !== "#")
    return e;
  const n = si(t);
  return n ? (n.a = r, Ml(n)) : e;
}
function Ml(t) {
  return t.a === 255 ? `#${[t.r, t.g, t.b].map((r) => kf(Math.round(r).toString(16), 2)).join("")}` : `rgba(${t.r},${t.g},${t.b},${(t.a / 255).toFixed(2)})`;
}
function si(t) {
  const r = (
    // #AARRGGBB
    t.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i) || // #ARGB
    t.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])$/i) || // #RRGGBB
    t.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i) || // #RGB
    t.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)
  );
  if (r) {
    if (r.length === 5) {
      const [u, c, f, _, g] = r, y = f.length === 2 ? f : f + f, p = _.length === 2 ? _ : _ + _, w = g.length === 2 ? g : g + g, E = c.length === 2 ? c : c + c;
      return {
        a: parseInt(E, 16),
        r: parseInt(y, 16),
        g: parseInt(p, 16),
        b: parseInt(w, 16)
      };
    }
    const [e, n, i, o] = r, s = n.length === 2 ? n : n + n, a = i.length === 2 ? i : i + i, l = o.length === 2 ? o : o + o;
    return {
      a: 255,
      r: parseInt(s, 16),
      g: parseInt(a, 16),
      b: parseInt(l, 16)
    };
  }
  return null;
}
function ll(t) {
  let r = String(t);
  return r.indexOf("&") > -1 && (r = r.replace(/&/g, "&amp;")), r.indexOf("<") > -1 && (r = r.replace(/</g, "&lt;")), r.indexOf(">") > -1 && (r = r.replace(/>/g, "&gt;")), r.indexOf('"') > -1 && (r = r.replace(/"/g, "&quot;")), r;
}
const ki = Boolean;
function Ns(t, r) {
  if (t.length === 1 && t[0].type === "solid")
    return Zd({
      bg: t[0]
    });
  const e = t.map((n) => {
    if (n.type === "solid")
      return Xd({
        bg: n
      });
    if (n.type === "gradient")
      return Qd({
        bg: n
      });
    if (n.type === "image")
      return e_({
        bg: n,
        direction: r
      });
    if (n.type === "radial_gradient")
      return $d({
        bg: n
      });
  }).filter(ki).reverse().reduce(function(n, i) {
    return n.image.push(i.image), n.size.push(i.size || "auto"), n.position.push(i.pos || "50% 50%"), n;
  }, {
    image: [],
    size: [],
    position: []
  });
  return {
    image: e.image.join(","),
    size: e.size.join(","),
    position: e.position.join(",")
  };
}
function Xd(t) {
  const r = Tr(t.bg.color || "transparent");
  return {
    size: void 0,
    pos: void 0,
    image: `linear-gradient(to bottom,${r},${r})`
  };
}
function Zd(t) {
  return {
    color: Tr(t.bg.color || "transparent"),
    size: "auto",
    position: "50% 50%"
  };
}
function Ef(t) {
  return t.every((n) => n.color && typeof n.position == "number" && n.position >= 0 && n.position <= 1) ? t.sort((n, i) => Math.abs(n.position - i.position) < 1e-6 ? 0 : n.position - i.position).map((n) => `${Tr(n.color)} ${(n.position * 100).toFixed(2)}%`).join(",") : void 0;
}
function Qd(t) {
  var n, i, o, s;
  if (!Array.isArray((n = t.bg) == null ? void 0 : n.colors) && !Array.isArray((i = t.bg) == null ? void 0 : i.color_map))
    return;
  const r = (o = t.bg.colors) == null ? void 0 : o.filter(ki);
  if (!(r != null && r.length) && !((s = t.bg) != null && s.color_map))
    return;
  let e;
  if (t.bg.color_map) {
    const a = Ef(t.bg.color_map);
    if (!a)
      return;
    e = "linear-gradient(" + (90 - Number(t.bg.angle || 0) + "deg") + "," + a + ")";
  } else {
    if (!r)
      return;
    e = "linear-gradient(" + (90 - Number(t.bg.angle || 0) + "deg") + "," + r.map((a) => Tr(a)).join(",") + ")";
  }
  return {
    size: void 0,
    pos: void 0,
    image: e
  };
}
const xd = {
  nearest_corner: "closest-corner",
  farthest_corner: "farthest-corner",
  nearest_side: "closest-side",
  farthest_side: "farthest-side"
};
function sa(t) {
  if (t && typeof t == "object" && "type" in t && t.value !== void 0) {
    if (t.type === "fixed")
      return dn(t.value);
    if (t.type === "relative")
      return `${Number(t.value) * 100}%`;
  }
  return "50%";
}
function $d(t) {
  var a, l, u, c;
  if (!Array.isArray((a = t.bg) == null ? void 0 : a.colors) && !Array.isArray((l = t.bg) == null ? void 0 : l.color_map))
    return;
  const r = (u = t.bg.colors) == null ? void 0 : u.filter(ki);
  if (!(r != null && r.length) && !((c = t.bg) != null && c.color_map))
    return;
  let e;
  if (t.bg.color_map ? e = Ef(t.bg.color_map) : r && (e = r.map((f) => Tr(f)).join(",")), !e)
    return;
  const n = t.bg.radius;
  let i;
  n && typeof n == "object" && "type" in n && n.value !== void 0 && (n.type === "fixed" ? i = dn(n.value) : n.type === "relative" && (i = xd[n.value]));
  const o = sa(t.bg.center_x), s = sa(t.bg.center_y);
  return {
    size: void 0,
    pos: void 0,
    image: `radial-gradient(circle ${i || "farthest-corner"} at ${o} ${s},` + e + ")"
  };
}
function e_(t) {
  var e;
  const r = (e = t.bg) == null ? void 0 : e.image_url;
  if (r)
    return {
      size: Af(t.bg.scale),
      pos: jf(t.bg, t.direction),
      image: 'url("' + ll(r) + '")'
    };
}
function Af(t) {
  return t === "fit" ? "contain" : t === "stretch" ? "fill" : t === "no_scale" ? "none" : "cover";
}
function jf(t, r) {
  let e, n;
  return t.content_alignment_horizontal === "left" || r === "ltr" && t.content_alignment_horizontal === "start" || r === "rtl" && t.content_alignment_horizontal === "end" ? e = "0%" : t.content_alignment_horizontal === "right" || r === "ltr" && t.content_alignment_horizontal === "end" || r === "rtl" && t.content_alignment_horizontal === "start" ? e = "100%" : e = "50%", t.content_alignment_vertical === "top" ? n = "0%" : t.content_alignment_vertical === "bottom" ? n = "100%" : n = "50%", e + " " + n;
}
function Kr(t, r) {
  const e = Number(t);
  return Number.isNaN(e) || e < 0 ? r : e;
}
function la(t, r, e) {
  return typeof r == "number" && (t && r > 0 && r <= 100 || !t && r >= 0 && r < 100) ? r : e;
}
function t_(t) {
  return t.is_enabled !== 0 && t.is_enabled !== !1 && t.index !== void 0;
}
function r_(t, {
  visibilityActions: r,
  disappearActions: e,
  rootCtx: n,
  componentContext: i
}) {
  const o = [];
  r && r.forEach((g) => {
    o.push({
      type: "visibility",
      index: o.length,
      action: g,
      visible: !1,
      count: 0,
      finished: !1
    });
  }), e && e.forEach((g) => {
    o.push({
      type: "disappear",
      index: o.length,
      action: g,
      // false, so disappear only works after the element becomes visible
      visible: !1,
      count: 0,
      finished: !1
    });
  });
  const s = o.map((g, y) => {
    const p = g.type === "visibility";
    return i.getDerivedFromVars({
      index: y,
      visibility_percentage: g.action.visibility_percentage,
      visibility_duration: p ? g.action.visibility_duration : g.action.disappear_duration,
      log_limit: g.action.log_limit,
      is_enabled: g.action.is_enabled
    }, void 0, !0);
  });
  let a;
  const l = () => {
    a && a.disconnect(), o.forEach((g) => {
      g.timer && clearTimeout(g.timer);
    });
  }, u = bo(s, (g) => g);
  let c;
  const f = (g) => {
    const y = g.type === "visibility";
    i.execAnyActions([g.action], {
      logType: y ? "visible" : "disappear",
      node: t,
      processUrls: !1
    });
  }, _ = u.subscribe((g) => {
    c = g.filter(t_);
    const y = {};
    c.forEach((E) => {
      y[E.index] = E;
    }), l();
    const p = [...new Set(c.map((E) => {
      const Q = o[E.index].type === "visibility";
      return la(
        Q,
        E.visibility_percentage,
        Q ? 50 : 0
      ) / 100;
    }))];
    if (!p.length)
      return;
    const w = (E) => {
      E.forEach((Q) => {
        c.forEach((J) => {
          const M = o[J.index], ge = M.type === "visibility", le = la(
            ge,
            J.visibility_percentage,
            ge ? 50 : 0
          );
          let H;
          le === 0 ? H = Q.intersectionRatio >= 1e-12 : H = Q.intersectionRatio >= le / 100, (ge ? !M.visible && H : M.visible && !H) ? M.finished || (M.timer = setTimeout(() => {
            ++M.count;
            const I = J.log_limit === 0 ? 1 / 0 : J.log_limit || 1;
            M.count >= I && (M.finished = !0), f(M);
          }, Kr(J.visibility_duration, 800))) : (ge ? !H : H) && M.timer && clearTimeout(M.timer), M.visible = H;
        });
      });
    };
    a = new IntersectionObserver(w, {
      threshold: p
    }), a.observe(t);
  });
  return {
    destroy() {
      c == null || c.forEach((g) => {
        const y = o[g.index];
        !y || y.type !== "disappear" || !y.visible || y.finished || n.registerTimeout(window.setTimeout(() => {
          f(y);
        }, g.visibility_duration));
      }), l(), _();
    }
  };
}
function aa(t, r) {
  r && t.push(r);
}
function jt(t, r, e) {
  const n = [];
  aa(n, r[t]);
  for (const i in e)
    if (e.hasOwnProperty(i)) {
      const o = e[i];
      if (o) {
        const s = `${t}_${i}` + (typeof o == "string" ? `_${o}` : "");
        aa(n, r[s]);
      }
    }
  return n.join(" ");
}
function n_(t, r, e, n) {
  var i;
  return (i = r.componentDevtool) == null || i.call(r, {
    type: "mount",
    node: t,
    json: e.json,
    origJson: e.origJson,
    templateContext: e.templateContext,
    componentContext: e,
    devapi: n
  }), {
    update(o) {
      var s;
      (s = r.componentDevtool) == null || s.call(r, {
        type: "update",
        node: t,
        json: o.json,
        origJson: o.origJson,
        templateContext: o.templateContext,
        componentContext: o
      });
    },
    destroy() {
      var o;
      (o = r.componentDevtool) == null || o.call(r, {
        type: "destroy",
        node: t,
        json: e.json,
        origJson: e.origJson,
        templateContext: e.templateContext,
        componentContext: e
      });
    }
  };
}
const ms = n_, Pl = Symbol("state");
function li(t, r) {
  var s, a;
  const e = t.top || 0, n = ((s = r === "ltr" ? t.end : t.start) != null ? s : t.right) || 0, i = t.bottom || 0, o = ((a = r === "ltr" ? t.start : t.end) != null ? a : t.left) || 0;
  return e === 0 && n === 0 && i === 0 && o === 0 ? "" : Re(e) + " " + Re(n) + " " + Re(i) + " " + Re(o);
}
function zs(t) {
  if (typeof t != "number" && typeof t != "string")
    return !1;
  const r = Number(t);
  return !Number.isNaN(r);
}
function zn(t) {
  return zs(t) && t >= 0;
}
function bs(t, r, e) {
  var i, o;
  if (!t)
    return e;
  const n = [
    t.top,
    (i = r === "ltr" ? t.end : t.start) != null ? i : t.right,
    t.bottom,
    (o = r === "ltr" ? t.start : t.end) != null ? o : t.left
  ];
  for (let s = 0; s < n.length; ++s)
    if (n[s] && !zn(n[s]))
      return e;
  return li(t, r);
}
function i_(t, r) {
  return !zn(t) || t === void 0 || t > 1 ? r : Number(t);
}
const o_ = Object.prototype.hasOwnProperty;
function yo(t, r) {
  if (Object.is(t, r))
    return !0;
  if (typeof t != "object" || t === null || typeof r != "object" || r === null)
    return Object.is(t, r);
  const e = Object.keys(t), n = Object.keys(r);
  if (e.length !== n.length)
    return !1;
  for (let i = 0; i < e.length; i++) {
    const o = e[i];
    if (!o_.call(r, o) || !yo(t[o], r[o]))
      return !1;
  }
  return !0;
}
function Ni(t, r) {
  return yo(t, r) ? r : t;
}
function s_(t, r) {
  return t === "visible" || t === "invisible" || t === "gone" ? t : r;
}
function Cf(t, r) {
  return t === "linear" || t === "ease" || t === "ease_in_out" || t === "ease_in" || t === "ease_out" ? t : r;
}
function uo(t, r) {
  const e = Number(t);
  return Number.isNaN(e) ? r : e;
}
function Nl(t) {
  const r = [];
  return t.name === "set" ? (t.items || []).forEach((e) => {
    r.push(...Nl(e));
  }) : r.push(t), r;
}
function wo(t, r) {
  if (!t || typeof t != "object")
    return r;
  const e = [
    "top",
    "right",
    "bottom",
    "left"
  ];
  for (let n = 0; n < e.length; ++n)
    if (t[e[n]] && !zn(t[e[n]]))
      return r;
  return t;
}
function l_(t, r) {
  if (!t && !r)
    return {};
  if (!r)
    return t;
  if (!t)
    return r;
  const e = {};
  return [
    "top",
    "right",
    "bottom",
    "left",
    "start",
    "end"
  ].forEach((n) => {
    const i = t[n];
    i && (e[n] = i);
    const o = r[n];
    o && (e[n] = (e[n] || 0) + o);
  }), e;
}
function a_(t, r) {
  const e = [
    t["top-left"],
    t["top-right"],
    t["bottom-right"],
    t["bottom-left"]
  ];
  for (let n = 0; n < e.length; ++n)
    if (e[n] && !zn(e[n]))
      return r;
  return t;
}
function Xo(t, r = 0, e = 10) {
  return [
    t["top-left"],
    t["top-right"],
    t["bottom-right"],
    t["bottom-left"]
  ].map((n) => Re((n || r) / e * 10)).join(" ");
}
function u_(t) {
  var r, e, n, i, o, s;
  return Re(((e = (r = t.offset) == null ? void 0 : r.x) == null ? void 0 : e.value) || 0) + " " + Re(((i = (n = t.offset) == null ? void 0 : n.y) == null ? void 0 : i.value) || 0) + " " + Re((o = t.blur) != null ? o : 2) + " " + Tr(t.color || "#000000", (s = t.alpha) != null ? s : 0.19);
}
function c_(t, r) {
  var e, n, i, o, s, a;
  return "drop-shadow(" + Tr(t.color || "#000000", (e = t.alpha) != null ? e : 0.19) + " " + Re((((i = (n = t.offset) == null ? void 0 : n.x) == null ? void 0 : i.value) || 0) * 10 / r) + " " + Re((((s = (o = t.offset) == null ? void 0 : o.y) == null ? void 0 : s.value) || 0) * 10 / r) + " " + Re(((a = t.blur) != null ? a : 2) * 10 / r) + ")";
}
function ys(t) {
  return t.is_enabled !== 0 && t.is_enabled !== !1;
}
let qs;
function Os() {
  return typeof matchMedia > "u" ? !1 : (qs || (qs = window.matchMedia("(prefers-reduced-motion)")), qs.matches);
}
const f_ = 8, d_ = (t, r, e, n) => {
  let i;
  return (e || n) && typeof ResizeObserver < "u" && (i = new ResizeObserver(async () => {
    let o = 0;
    const s = {}, a = (u, c) => {
      if (u) {
        const f = r.getVariable(u, "integer");
        if (f) {
          if (c = Math.round(c), s[u] || (s[u] = /* @__PURE__ */ new Set()), !s[u].has(c))
            return f.setValue(c), s[u].add(c), !0;
        } else {
          const _ = new Error("Missing variable");
          _.level = "error", _.additional = {
            variableName: u
          }, r.logError(_);
        }
      }
      return !1;
    }, l = () => {
      if (!t)
        return !1;
      const u = t.getBoundingClientRect(), c = a(e, u.width), f = a(n, u.height);
      return c || f;
    };
    for (; l(); ) {
      if (++o > f_) {
        const u = new Error("Recursive layout in size_provider");
        u.level = "warn", u.additional = {
          widthVariableName: e,
          heightVariableName: n
        }, r.logError(u);
        break;
      }
      await jn();
    }
  }), i.observe(t)), i;
}, zl = Symbol("enabled");
function Tn(t, r) {
  return t === 1 || t === 0 || t === !1 || t === !0 ? !!t : r;
}
function po(t) {
  return [
    t.state_description,
    t.description,
    t.hint
  ].filter(Boolean).join(", ");
}
const ua = 1, Oi = 2, __ = "appkit-actionable__button", ca = {
  actionable__button: __
};
function p_() {
}
const Zi = Symbol("action");
function al(t) {
  if (t.startsWith("tel:"))
    return "tel";
  if (t.startsWith("/"))
    return "https";
  const r = /^([^/]+):\/\//.exec(t);
  return r && r[1] || "";
}
function ul(t, r) {
  return r.has(t);
}
function h_(t) {
  let r = (
    /*containerElement*/
    t[7]
  ), e, n, i = (
    /*containerElement*/
    t[7] && Js(t)
  );
  return {
    c() {
      i && i.c(), e = $t();
    },
    m(o, s) {
      i && i.m(o, s), x(o, e, s), n = !0;
    },
    p(o, s) {
      /*containerElement*/
      o[7] ? r ? Vr(
        r,
        /*containerElement*/
        o[7]
      ) ? (i.d(1), i = Js(o), r = /*containerElement*/
      o[7], i.c(), i.m(e.parentNode, e)) : i.p(o, s) : (i = Js(o), r = /*containerElement*/
      o[7], i.c(), i.m(e.parentNode, e)) : r && (i.d(1), i = null, r = /*containerElement*/
      o[7]);
    },
    i(o) {
      n || (K(i, o), n = !0);
    },
    o(o) {
      ae(i, o), n = !1;
    },
    d(o) {
      o && Z(e), i && i.d(o);
    }
  };
}
function g_(t) {
  var f;
  let r, e, n, i, o, s;
  const a = (
    /*#slots*/
    t[31].default
  ), l = Vs(
    a,
    t,
    /*$$scope*/
    t[30],
    null
  );
  let u = [
    {
      class: e = /*cls*/
      t[2] + " " + ca.actionable__button + " " + ur["root__any-actions"] + ` ${/*isNativeActionAnimation*/
      t[6] ? ur.root__clickable : ur["root__clickable-no-transition"]} ${ur.root__unselectable} ` + /*longTapActions*/
      ((f = t[1]) != null && f.length ? ur["root_disabled-context-menu"] : "")
    },
    { style: (
      /*style*/
      t[3]
    ) },
    { role: (
      /*role*/
      t[11]
    ) },
    { "aria-checked": (
      /*isChecked*/
      t[15]
    ) },
    { type: "button" },
    {
      tabindex: n = /*componentContext*/
      t[0].fakeElement === Oi ? -1 : null
    },
    /*attrs*/
    t[4]
  ], c = {};
  for (let _ = 0; _ < u.length; _ += 1)
    c = ui(c, u[_]);
  return {
    c() {
      r = Be("button"), l && l.c(), Di(r, c);
    },
    m(_, g) {
      x(_, r, g), l && l.m(r, null), r.autofocus && r.focus(), t[48](r), i = !0, o || (s = [
        Fs(
          /*use*/
          t[5].call(null, r)
        ),
        Ge(
          r,
          "click",
          /*click_handler_1*/
          t[37]
        ),
        Ge(
          r,
          "keydown",
          /*onKeydown*/
          t[17]
        ),
        Ge(
          r,
          "focus",
          /*focus_handler_1*/
          t[38]
        ),
        Ge(
          r,
          "blur",
          /*blur_handler_1*/
          t[39]
        ),
        Ge(
          r,
          "pointerdown",
          /*pointerdown_handler_1*/
          t[40]
        ),
        Ge(
          r,
          "wheel",
          /*wheel_handler_1*/
          t[41]
        )
      ], o = !0);
    },
    p(_, g) {
      var y;
      l && l.p && (!i || g[0] & /*$$scope*/
      1073741824) && Ds(
        l,
        a,
        _,
        /*$$scope*/
        _[30],
        i ? Is(
          a,
          /*$$scope*/
          _[30],
          g,
          null
        ) : Ts(
          /*$$scope*/
          _[30]
        ),
        null
      ), Di(r, c = vi(u, [
        (!i || g[0] & /*cls, isNativeActionAnimation, longTapActions*/
        70 && e !== (e = /*cls*/
        _[2] + " " + ca.actionable__button + " " + ur["root__any-actions"] + ` ${/*isNativeActionAnimation*/
        _[6] ? ur.root__clickable : ur["root__clickable-no-transition"]} ${ur.root__unselectable} ` + /*longTapActions*/
        ((y = _[1]) != null && y.length ? ur["root_disabled-context-menu"] : ""))) && { class: e },
        (!i || g[0] & /*style*/
        8) && { style: (
          /*style*/
          _[3]
        ) },
        (!i || g[0] & /*role*/
        2048) && { role: (
          /*role*/
          _[11]
        ) },
        (!i || g[0] & /*isChecked*/
        32768) && { "aria-checked": (
          /*isChecked*/
          _[15]
        ) },
        { type: "button" },
        (!i || g[0] & /*componentContext*/
        1 && n !== (n = /*componentContext*/
        _[0].fakeElement === Oi ? -1 : null)) && { tabindex: n },
        g[0] & /*attrs*/
        16 && /*attrs*/
        _[4]
      ]));
    },
    i(_) {
      i || (K(l, _), i = !0);
    },
    o(_) {
      ae(l, _), i = !1;
    },
    d(_) {
      _ && Z(r), l && l.d(_), t[48](null), o = !1, Qr(s);
    }
  };
}
function m_(t) {
  var f;
  let r, e, n, i, o, s;
  const a = (
    /*#slots*/
    t[31].default
  ), l = Vs(
    a,
    t,
    /*$$scope*/
    t[30],
    null
  );
  let u = [
    { href: (
      /*href*/
      t[9]
    ) },
    { target: (
      /*target*/
      t[13]
    ) },
    { style: (
      /*style*/
      t[3]
    ) },
    { role: (
      /*role*/
      t[11]
    ) },
    { "aria-checked": (
      /*isChecked*/
      t[15]
    ) },
    {
      class: e = /*cls*/
      t[2] + " " + ur["root__any-actions"] + " " + /*isNativeActionAnimation*/
      (t[6] ? ur.root__clickable : ur["root__clickable-no-transition"]) + " " + /*longTapActions*/
      ((f = t[1]) != null && f.length ? ur["root_disabled-context-menu"] : "")
    },
    {
      tabindex: n = /*componentContext*/
      t[0].fakeElement === Oi ? -1 : null
    },
    /*attrs*/
    t[4]
  ], c = {};
  for (let _ = 0; _ < u.length; _ += 1)
    c = ui(c, u[_]);
  return {
    c() {
      r = Be("a"), l && l.c(), Di(r, c);
    },
    m(_, g) {
      x(_, r, g), l && l.m(r, null), t[47](r), i = !0, o || (s = [
        Fs(
          /*use*/
          t[5].call(null, r)
        ),
        Ge(
          r,
          "click",
          /*click_handler*/
          t[32]
        ),
        Ge(
          r,
          "keydown",
          /*onKeydown*/
          t[17]
        ),
        Ge(
          r,
          "focus",
          /*focus_handler*/
          t[33]
        ),
        Ge(
          r,
          "blur",
          /*blur_handler*/
          t[34]
        ),
        Ge(
          r,
          "pointerdown",
          /*pointerdown_handler*/
          t[35]
        ),
        Ge(
          r,
          "wheel",
          /*wheel_handler*/
          t[36]
        )
      ], o = !0);
    },
    p(_, g) {
      var y;
      l && l.p && (!i || g[0] & /*$$scope*/
      1073741824) && Ds(
        l,
        a,
        _,
        /*$$scope*/
        _[30],
        i ? Is(
          a,
          /*$$scope*/
          _[30],
          g,
          null
        ) : Ts(
          /*$$scope*/
          _[30]
        ),
        null
      ), Di(r, c = vi(u, [
        (!i || g[0] & /*href*/
        512) && { href: (
          /*href*/
          _[9]
        ) },
        (!i || g[0] & /*target*/
        8192) && { target: (
          /*target*/
          _[13]
        ) },
        (!i || g[0] & /*style*/
        8) && { style: (
          /*style*/
          _[3]
        ) },
        (!i || g[0] & /*role*/
        2048) && { role: (
          /*role*/
          _[11]
        ) },
        (!i || g[0] & /*isChecked*/
        32768) && { "aria-checked": (
          /*isChecked*/
          _[15]
        ) },
        (!i || g[0] & /*cls, isNativeActionAnimation, longTapActions*/
        70 && e !== (e = /*cls*/
        _[2] + " " + ur["root__any-actions"] + " " + /*isNativeActionAnimation*/
        (_[6] ? ur.root__clickable : ur["root__clickable-no-transition"]) + " " + /*longTapActions*/
        ((y = _[1]) != null && y.length ? ur["root_disabled-context-menu"] : ""))) && { class: e },
        (!i || g[0] & /*componentContext*/
        1 && n !== (n = /*componentContext*/
        _[0].fakeElement === Oi ? -1 : null)) && { tabindex: n },
        g[0] & /*attrs*/
        16 && /*attrs*/
        _[4]
      ]));
    },
    i(_) {
      i || (K(l, _), i = !0);
    },
    o(_) {
      ae(l, _), i = !1;
    },
    d(_) {
      _ && Z(r), l && l.d(_), t[47](null), o = !1, Qr(s);
    }
  };
}
function Js(t) {
  var f;
  let r, e, n, i, o, s;
  const a = (
    /*#slots*/
    t[31].default
  ), l = Vs(
    a,
    t,
    /*$$scope*/
    t[30],
    null
  );
  let u = [
    {
      class: e = /*cls*/
      t[2] + " " + /*longTapActions*/
      ((f = t[1]) != null && f.length ? ur["root_disabled-context-menu"] : "") + " " + /*hasAnyActions*/
      (t[14] ? ur["root__any-actions"] : "")
    },
    { style: (
      /*style*/
      t[3]
    ) },
    { role: (
      /*role*/
      t[11]
    ) },
    { "aria-checked": (
      /*isChecked*/
      t[15]
    ) },
    {
      "aria-hidden": n = /*ariaHidden*/
      t[12] || void 0
    },
    /*attrs*/
    t[4]
  ], c = {};
  for (let _ = 0; _ < u.length; _ += 1)
    c = ui(c, u[_]);
  return {
    c() {
      r = Be(
        /*containerElement*/
        t[7]
      ), l && l.c(), zi(
        /*containerElement*/
        t[7]
      )(r, c);
    },
    m(_, g) {
      x(_, r, g), l && l.m(r, null), t[49](r), i = !0, o || (s = [
        Fs(
          /*use*/
          t[5].call(null, r)
        ),
        Ge(
          r,
          "click",
          /*click_handler_2*/
          t[42]
        ),
        Ge(
          r,
          "keydown",
          /*onKeydown*/
          t[17]
        ),
        Ge(
          r,
          "focus",
          /*focus_handler_2*/
          t[43]
        ),
        Ge(
          r,
          "blur",
          /*blur_handler_2*/
          t[44]
        ),
        Ge(
          r,
          "pointerdown",
          /*pointerdown_handler_2*/
          t[45]
        ),
        Ge(
          r,
          "wheel",
          /*wheel_handler_2*/
          t[46]
        )
      ], o = !0);
    },
    p(_, g) {
      var y;
      l && l.p && (!i || g[0] & /*$$scope*/
      1073741824) && Ds(
        l,
        a,
        _,
        /*$$scope*/
        _[30],
        i ? Is(
          a,
          /*$$scope*/
          _[30],
          g,
          null
        ) : Ts(
          /*$$scope*/
          _[30]
        ),
        null
      ), zi(
        /*containerElement*/
        _[7]
      )(r, c = vi(u, [
        (!i || g[0] & /*cls, longTapActions, hasAnyActions*/
        16390 && e !== (e = /*cls*/
        _[2] + " " + /*longTapActions*/
        ((y = _[1]) != null && y.length ? ur["root_disabled-context-menu"] : "") + " " + /*hasAnyActions*/
        (_[14] ? ur["root__any-actions"] : ""))) && { class: e },
        (!i || g[0] & /*style*/
        8) && { style: (
          /*style*/
          _[3]
        ) },
        (!i || g[0] & /*role*/
        2048) && { role: (
          /*role*/
          _[11]
        ) },
        (!i || g[0] & /*isChecked*/
        32768) && { "aria-checked": (
          /*isChecked*/
          _[15]
        ) },
        (!i || g[0] & /*ariaHidden*/
        4096 && n !== (n = /*ariaHidden*/
        _[12] || void 0)) && {
          "aria-hidden": n
        },
        g[0] & /*attrs*/
        16 && /*attrs*/
        _[4]
      ]));
    },
    i(_) {
      i || (K(l, _), i = !0);
    },
    o(_) {
      ae(l, _), i = !1;
    },
    d(_) {
      _ && Z(r), l && l.d(_), t[49](null), o = !1, Qr(s);
    }
  };
}
function b_(t) {
  let r, e, n, i;
  const o = [m_, g_, h_], s = [];
  function a(l, u) {
    return (
      /*href*/
      l[9] ? 0 : (
        /*hasJSAction*/
        l[10] ? 1 : 2
      )
    );
  }
  return r = a(t), e = s[r] = o[r](t), {
    c() {
      e.c(), n = $t();
    },
    m(l, u) {
      s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? s[r].p(l, u) : (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr(), e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n));
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), s[r].d(l);
    }
  };
}
const fa = 8, da = 400, Ks = 400, y_ = /* @__PURE__ */ new Set(["button", "image", "checkbox", "radio", "header"]);
function _a(t) {
  t.preventDefault();
}
function w_(t, r, e) {
  let n, i, o = T, s = () => (o(), o = B(n, (W) => e(29, i = W)), n);
  t.$$.on_destroy.push(() => o());
  let { $$slots: a = {}, $$scope: l } = r, { componentContext: u } = r, { id: c = "" } = r, { actions: f = void 0 } = r, { doubleTapActions: _ = void 0 } = r, { longTapActions: g = void 0 } = r, { pressStartActions: y = void 0 } = r, { pressEndActions: p = void 0 } = r, { hoverStartActions: w = void 0 } = r, { hoverEndActions: E = void 0 } = r, { cls: Q = "" } = r, { style: J = null } = r, { attrs: M = void 0 } = r, { use: ge = p_ } = r, { customAction: le = null } = r, { isNativeActionAnimation: H = !0 } = r, { hasInnerFocusable: ee = !1 } = r, { customAccessibility: X = void 0 } = r, { captureFocusOnAction: I = !0 } = r, { containerElement: P = "span" } = r;
  const O = Xr(_n), U = Xr(Zi);
  Yi(Zi, {
    hasAction() {
      return !!(U.hasAction() || f != null && f.length || (X == null ? void 0 : X.mode) === "exclude");
    }
  });
  let me, nt = "", _e, Me = -1, tt = -1, We = null, Ne = !1, Ft = !1, Ve = !1, Oe, Pe, yt, ye, Ke = !1;
  function je() {
    return (i == null ? void 0 : i.some((W) => {
      if (W != null && W.typed)
        return !0;
      const Et = W == null ? void 0 : W.url;
      if (!Et || Et.startsWith("javascript:"))
        return !1;
      const It = al(Et);
      return It && !ul(It, O.getBuiltinProtocols());
    })) || !1;
  }
  async function te(W, Et) {
    f && (W && je() && W.preventDefault(), u.execAnyActions(f, { node: me, processUrls: Et }));
  }
  async function ot(W) {
    if (U.hasAction() || W.button !== void 0 && W.button !== 0)
      return;
    const Et = Date.now();
    if (Me > 0 && Et > Me + da) {
      W.preventDefault();
      return;
    }
    if (_ != null && _.length && tt > 0 && Et - tt < Ks) {
      W.preventDefault(), u.execAnyActions(_, { processUrls: !0, node: me }), tt = -1;
      return;
    }
    if (tt = Et, _ != null && _.length && Me > 0 && Et < Me + Ks) {
      W.preventDefault(), clearTimeout(Pe), Pe = window.setTimeout(
        () => {
          te(void 0, !0);
        },
        Ks
      );
      return;
    }
    (le == null ? void 0 : le(W)) === !1 ? W.preventDefault() : te(W, !1);
  }
  function ce(W) {
    U.hasAction() || (We = { x: W.clientX, y: W.clientY }, Ne = !1, Me = Date.now(), Oe && clearTimeout(Oe), clearTimeout(Pe), u.execAnyActions(y, { node: me }));
  }
  function pt(W) {
    We && (Math.abs(We.x - W.clientX) > fa || Math.abs(We.y - W.clientY) > fa) && (Ne = !0);
  }
  function Ct(W) {
    U.hasAction() || !We || Me < 0 || (!Ne && Date.now() - Me >= da && (W.stopImmediatePropagation(), u.execAnyActions(g, { processUrls: !0, node: me })), Oe && clearTimeout(Oe), Oe = window.setTimeout(
      () => {
        We = null, Me = -1;
      },
      100
    ), u.execAnyActions(p, { node: me }));
  }
  function re() {
    U.hasAction() || u.execAnyActions(w, { node: me });
  }
  function $() {
    U.hasAction() || u.execAnyActions(E, { node: me });
  }
  function pe(W) {
    const Et = W.target;
    Et instanceof HTMLElement && (Et.tagName === "INPUT" || Et.contentEditable === "true") || W.ctrlKey || W.metaKey || W.altKey || W.shiftKey || W.key === "Enter" && Array.isArray(f) && f.length && (u.execAnyActions(f), W.preventDefault());
  }
  Jn(() => {
    c && !ee && O.registerFocusable(c, {
      focus() {
        me && (nt || Ft) && me.focus();
      }
    });
  }), bn(() => {
    typeof window < "u" && (window.removeEventListener("pointermove", pt), window.removeEventListener("pointerup", Ct), window.removeEventListener("pointercancel", Ct)), c && !ee && O.unregisterFocusable(c), Oe && clearTimeout(Oe), Pe && clearTimeout(Pe);
  });
  function Bt(W) {
    Dn.call(this, t, W);
  }
  function De(W) {
    Dn.call(this, t, W);
  }
  function ft(W) {
    Dn.call(this, t, W);
  }
  function Mt(W) {
    Dn.call(this, t, W);
  }
  function He(W) {
    Dn.call(this, t, W);
  }
  function ht(W) {
    Dn.call(this, t, W);
  }
  function qt(W) {
    Dn.call(this, t, W);
  }
  function fe(W) {
    Dn.call(this, t, W);
  }
  function Vt(W) {
    Dn.call(this, t, W);
  }
  function be(W) {
    Dn.call(this, t, W);
  }
  function $e(W) {
    Dn.call(this, t, W);
  }
  function Ce(W) {
    Dn.call(this, t, W);
  }
  function Xe(W) {
    Dn.call(this, t, W);
  }
  function Jt(W) {
    Dn.call(this, t, W);
  }
  function bt(W) {
    Dn.call(this, t, W);
  }
  function Qt(W) {
    Or[W ? "unshift" : "push"](() => {
      me = W, e(8, me);
    });
  }
  function rt(W) {
    Or[W ? "unshift" : "push"](() => {
      me = W, e(8, me);
    });
  }
  function ir(W) {
    Or[W ? "unshift" : "push"](() => {
      me = W, e(8, me);
    });
  }
  return t.$$set = (W) => {
    "componentContext" in W && e(0, u = W.componentContext), "id" in W && e(18, c = W.id), "actions" in W && e(19, f = W.actions), "doubleTapActions" in W && e(20, _ = W.doubleTapActions), "longTapActions" in W && e(1, g = W.longTapActions), "pressStartActions" in W && e(21, y = W.pressStartActions), "pressEndActions" in W && e(22, p = W.pressEndActions), "hoverStartActions" in W && e(23, w = W.hoverStartActions), "hoverEndActions" in W && e(24, E = W.hoverEndActions), "cls" in W && e(2, Q = W.cls), "style" in W && e(3, J = W.style), "attrs" in W && e(4, M = W.attrs), "use" in W && e(5, ge = W.use), "customAction" in W && e(25, le = W.customAction), "isNativeActionAnimation" in W && e(6, H = W.isNativeActionAnimation), "hasInnerFocusable" in W && e(26, ee = W.hasInnerFocusable), "customAccessibility" in W && e(27, X = W.customAccessibility), "captureFocusOnAction" in W && e(28, I = W.captureFocusOnAction), "containerElement" in W && e(7, P = W.containerElement), "$$scope" in W && e(30, l = W.$$scope);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & /*customAccessibility*/
    134217728 && e(12, Ke = (X == null ? void 0 : X.mode) === "exclude"), t.$$.dirty[0] & /*componentContext, actions*/
    524289 && s(e(16, n = u.getDerivedFromVars(f, void 0, !0))), t.$$.dirty[0] & /*$processedActions, customAction, href, ariaHidden, componentContext*/
    570429953) {
      if (Array.isArray(i) && (i != null && i.length))
        for (let W = 0; W < i.length; ++W) {
          const Et = i[W].url;
          if (console.log("url 13333333", Et), Et) {
            e(9, nt = Et), e(13, _e = i[W].target || void 0);
            break;
          }
        }
      e(10, Ft = !!le), (nt || Array.isArray(i) && (i != null && i.length)) && (U.hasAction() || Ke) ? (e(9, nt = ""), u.logError(R(new Error("Actionable element is forbidden inside other actionable element or inside accessibility mode=exlucde"), {
        level: "warn",
        additional: { actions: i }
      }))) : nt && !nt.startsWith("javascript:") && !ul(al(nt), O.getBuiltinProtocols()) ? (e(9, nt = ""), e(10, Ft = !0)) : !nt && Array.isArray(i) && (i != null && i.length) && (e(10, Ft = !0), i.some((W) => W.url || W.typed || W.menu_items) || u.logError(R(new Error("The component has a list of actions, but does not have a real action"), {
        level: "warn",
        additional: { actions: i }
      })));
    }
    t.$$.dirty[0] & /*customAccessibility, href, hasJSAction, role*/
    134221312 && (X != null && X.type && y_.has(X.type) ? X.type === "header" ? e(11, yt = "heading") : e(11, yt = X.type) : nt ? e(11, yt = void 0) : Ft && e(11, yt = "button"), (yt === "checkbox" || yt === "radio") && typeof (X == null ? void 0 : X.is_checked) == "boolean" ? e(15, ye = X.is_checked) : e(15, ye = void 0)), t.$$.dirty[0] & /*node, href, hasJSAction, doubleTapActions, longTapActions, pressStartActions, pressEndActions, hoverStartActions, hoverEndActions, captureFocusOnAction*/
    300943106 && me && (nt || Ft || _ != null && _.length ? me.addEventListener("click", ot) : me.removeEventListener("click", ot), _ != null && _.length || g != null && g.length || y != null && y.length || p != null && p.length ? (me.addEventListener("pointerdown", ce, { passive: !0 }), window.addEventListener("pointermove", pt, { passive: !0 }), window.addEventListener("pointerup", Ct, { passive: !0 }), window.addEventListener("pointercancel", Ct, { passive: !0 })) : (me.removeEventListener("pointerdown", ce), window.removeEventListener("pointerup", Ct), window.removeEventListener("pointermove", pt), window.removeEventListener("pointercancel", Ct)), w != null && w.length ? me.addEventListener("pointerenter", re) : me.removeEventListener("pointerenter", re), E != null && E.length ? me.addEventListener("pointerleave", $) : me.removeEventListener("pointerleave", $), I === !1 ? me.addEventListener("mousedown", _a) : me.removeEventListener("mousedown", _a), e(14, Ve = !!(nt || Ft || _ != null && _.length || g != null && g.length || y != null && y.length || p != null && p.length || w != null && w.length || E != null && E.length)));
  }, [
    u,
    g,
    Q,
    J,
    M,
    ge,
    H,
    P,
    me,
    nt,
    Ft,
    yt,
    Ke,
    _e,
    Ve,
    ye,
    n,
    pe,
    c,
    f,
    _,
    y,
    p,
    w,
    E,
    le,
    ee,
    X,
    I,
    i,
    l,
    a,
    Bt,
    De,
    ft,
    Mt,
    He,
    ht,
    qt,
    fe,
    Vt,
    be,
    $e,
    Ce,
    Xe,
    Jt,
    bt,
    Qt,
    rt,
    ir
  ];
}
class Ls extends $r {
  constructor(r) {
    super(), xr(
      this,
      r,
      w_,
      b_,
      Vr,
      {
        componentContext: 0,
        id: 18,
        actions: 19,
        doubleTapActions: 20,
        longTapActions: 1,
        pressStartActions: 21,
        pressEndActions: 22,
        hoverStartActions: 23,
        hoverEndActions: 24,
        cls: 2,
        style: 3,
        attrs: 4,
        use: 5,
        customAction: 25,
        isNativeActionAnimation: 6,
        hasInnerFocusable: 26,
        customAccessibility: 27,
        captureFocusOnAction: 28,
        containerElement: 7
      },
      null,
      [-1, -1, -1]
    );
  }
}
const qi = {
  "outer-background": "appkit-outer-background",
  "outer-background_clip": "appkit-outer-background_clip",
  "outer-background__item": "appkit-outer-background__item",
  "outer-background__item_hidden": "appkit-outer-background__item_hidden"
};
function Hn(t) {
  return zs(t) && t > 0;
}
function Sf(t, r) {
  return t.map((e) => {
    if (!e) {
      r(R(new Error("Incorrect filter"), {
        level: "warn"
      }));
      return;
    }
    if (e.type === "blur") {
      if (Hn(e.radius))
        return `blur(${dn(e.radius / 2)})`;
    } else {
      if (e.type === "rtl_mirror")
        return;
      r(R(new Error("Unknown filter"), {
        level: "warn",
        additional: {
          filter: e.type
        }
      }));
    }
  }).filter(Boolean).join(" ");
}
function pa(t, r, e) {
  const n = t.slice();
  return n[6] = r[e], n;
}
function v_(t) {
  let r, e;
  return {
    c() {
      r = Be("span"), m(r, "class", qi["outer-background__item"]), m(r, "style", e = Rt(
        /*item*/
        t[6].style
      ));
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i & /*styles*/
      2 && e !== (e = Rt(
        /*item*/
        n[6].style
      )) && m(r, "style", e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function k_(t) {
  let r, e, n, i, o;
  return {
    c() {
      r = Be("img"), Zn(r.src, e = /*item*/
      t[6].image_url) || m(r, "src", e), m(r, "alt", ""), m(r, "aria-hidden", "true"), m(r, "loading", "lazy"), m(r, "decoding", "async"), m(r, "class", qi["outer-background__item"]), m(r, "style", n = Rt(
        /*item*/
        t[6].style
      ));
    },
    m(s, a) {
      x(s, r, a), i || (o = Ge(
        r,
        "error",
        /*onImgError*/
        t[2]
      ), i = !0);
    },
    p(s, a) {
      a & /*styles*/
      2 && !Zn(r.src, e = /*item*/
      s[6].image_url) && m(r, "src", e), a & /*styles*/
      2 && n !== (n = Rt(
        /*item*/
        s[6].style
      )) && m(r, "style", n);
    },
    d(s) {
      s && Z(r), i = !1, o();
    }
  };
}
function ha(t) {
  let r;
  function e(o, s) {
    return (
      /*item*/
      o[6].image_url ? k_ : v_
    );
  }
  let n = e(t), i = n(t);
  return {
    c() {
      i.c(), r = $t();
    },
    m(o, s) {
      i.m(o, s), x(o, r, s);
    },
    p(o, s) {
      n === (n = e(o)) && i ? i.p(o, s) : (i.d(1), i = n(o), i && (i.c(), i.m(r.parentNode, r)));
    },
    d(o) {
      o && Z(r), i.d(o);
    }
  };
}
function E_(t) {
  let r, e, n = lr(
    /*styles*/
    t[1]
  ), i = [];
  for (let o = 0; o < n.length; o += 1)
    i[o] = ha(pa(t, n, o));
  return {
    c() {
      r = Be("span");
      for (let o = 0; o < i.length; o += 1)
        i[o].c();
      m(r, "class", e = qi["outer-background"] + /*radius*/
      (t[0] ? " " + qi["outer-background_clip"] : "")), q(
        r,
        "border-radius",
        /*radius*/
        t[0]
      );
    },
    m(o, s) {
      x(o, r, s);
      for (let a = 0; a < i.length; a += 1)
        i[a] && i[a].m(r, null);
    },
    p(o, [s]) {
      if (s & /*styles, onImgError*/
      6) {
        n = lr(
          /*styles*/
          o[1]
        );
        let a;
        for (a = 0; a < n.length; a += 1) {
          const l = pa(o, n, a);
          i[a] ? i[a].p(l, s) : (i[a] = ha(l), i[a].c(), i[a].m(r, null));
        }
        for (; a < i.length; a += 1)
          i[a].d(1);
        i.length = n.length;
      }
      s & /*radius*/
      1 && e !== (e = qi["outer-background"] + /*radius*/
      (o[0] ? " " + qi["outer-background_clip"] : "")) && m(r, "class", e), s & /*radius*/
      1 && q(
        r,
        "border-radius",
        /*radius*/
        o[0]
      );
    },
    i: T,
    o: T,
    d(o) {
      o && Z(r), gn(i, o);
    }
  };
}
function A_(t, r, e) {
  let n, { direction: i } = r, { componentContext: o } = r, { background: s = [] } = r, { radius: a = "" } = r;
  function l(u) {
    u.target && "classList" in u.target && u.target.classList.add(qi["outer-background__item_hidden"]);
  }
  return t.$$set = (u) => {
    "direction" in u && e(3, i = u.direction), "componentContext" in u && e(4, o = u.componentContext), "background" in u && e(5, s = u.background), "radius" in u && e(0, a = u.radius);
  }, t.$$.update = () => {
    t.$$.dirty & /*background, direction, componentContext*/
    56 && e(1, n = s.map((u) => {
      const c = {}, f = { style: c };
      if (u.type === "nine_patch_image" && u.insets)
        c["border-image"] = `url("${u.image_url}") ${u.insets.top || 0} ${u.insets.right || 0} ${u.insets.bottom || 0} ${u.insets.left || 0} fill`, c["border-image-width"] = "auto";
      else {
        const _ = Ns([u], i);
        u.type === "solid" && (c["background-color"] = _.color), u.type === "gradient" && (c["background-image"] = _.image), u.type === "image" && (c.opacity = Number(u.alpha), f.image_url = u.image_url, c["object-fit"] = _.size, c["object-position"] = _.position, Array.isArray(u.filters) && u.filters.length && (c.filter = Sf(u.filters, o.logError), i === "rtl" && u.filters.some((g) => g.type === "rtl_mirror") && (c.transform = "scale(-1,1)")));
      }
      return f;
    }));
  }, [a, n, l, i, o, s];
}
class j_ extends $r {
  constructor(r) {
    super(), xr(this, r, A_, E_, Vr, {
      direction: 3,
      componentContext: 4,
      background: 5,
      radius: 0
    });
  }
}
const C_ = (t) => ({
  hasCustomFocus: t[0] & /*hasCustomFocus*/
  8192
}), ga = (t) => ({
  focusHandler: (
    /*focusHandler*/
    t[45]
  ),
  blurHandler: (
    /*blurHandler*/
    t[46]
  ),
  hasCustomFocus: (
    /*hasCustomFocus*/
    t[13]
  )
});
function ma(t) {
  let r, e;
  return r = new Ls({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      id: (
        /*componentContext*/
        t[0].json.id
      ),
      use: (
        /*useAction*/
        t[44]
      ),
      cls: (
        /*cls*/
        t[1] + " " + jt(
          "outer",
          gs,
          /*mods*/
          t[25]
        ) + /*customClass*/
        (t[41] ? ` ${/*customClass*/
        t[41]}` : "")
      ),
      style: Rt(
        /*stl*/
        t[24]
      ),
      actions: (
        /*actions*/
        t[20]
      ),
      doubleTapActions: (
        /*doubleTapActions*/
        t[21]
      ),
      longTapActions: (
        /*longTapActions*/
        t[22]
      ),
      pressStartActions: (
        /*pressStartActions*/
        t[8]
      ),
      pressEndActions: (
        /*pressEndActions*/
        t[9]
      ),
      hoverStartActions: (
        /*hoverStartActions*/
        t[10]
      ),
      hoverEndActions: (
        /*hoverEndActions*/
        t[11]
      ),
      attrs: (
        /*attrs*/
        t[16]
      ),
      hasInnerFocusable: (
        /*hasInnerFocusable*/
        t[3]
      ),
      isNativeActionAnimation: !/*actionAnimationList*/
      t[12].length || wa(
        /*actionAnimationList*/
        t[12]
      ),
      customAccessibility: (
        /*$jsonAccessibility*/
        t[15]
      ),
      captureFocusOnAction: (
        /*captureFocusOnAction*/
        t[23]
      ),
      containerElement: (
        /*containerElement*/
        t[2]
      ),
      $$slots: { default: [S_] },
      $$scope: { ctx: t }
    }
  }), r.$on(
    "focus",
    /*focusHandler*/
    t[45]
  ), r.$on(
    "blur",
    /*blurHandler*/
    t[46]
  ), r.$on(
    "pointerdown",
    /*pointerdown_handler*/
    t[125]
  ), r.$on(
    "wheel",
    /*wheel_handler*/
    t[126]
  ), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*componentContext*/
      1 && (o.id = /*componentContext*/
      n[0].json.id), i[0] & /*cls, mods*/
      33554434 | i[1] & /*customClass*/
      1024 && (o.cls = /*cls*/
      n[1] + " " + jt(
        "outer",
        gs,
        /*mods*/
        n[25]
      ) + /*customClass*/
      (n[41] ? ` ${/*customClass*/
      n[41]}` : "")), i[0] & /*stl*/
      16777216 && (o.style = Rt(
        /*stl*/
        n[24]
      )), i[0] & /*actions*/
      1048576 && (o.actions = /*actions*/
      n[20]), i[0] & /*doubleTapActions*/
      2097152 && (o.doubleTapActions = /*doubleTapActions*/
      n[21]), i[0] & /*longTapActions*/
      4194304 && (o.longTapActions = /*longTapActions*/
      n[22]), i[0] & /*pressStartActions*/
      256 && (o.pressStartActions = /*pressStartActions*/
      n[8]), i[0] & /*pressEndActions*/
      512 && (o.pressEndActions = /*pressEndActions*/
      n[9]), i[0] & /*hoverStartActions*/
      1024 && (o.hoverStartActions = /*hoverStartActions*/
      n[10]), i[0] & /*hoverEndActions*/
      2048 && (o.hoverEndActions = /*hoverEndActions*/
      n[11]), i[0] & /*attrs*/
      65536 && (o.attrs = /*attrs*/
      n[16]), i[0] & /*hasInnerFocusable*/
      8 && (o.hasInnerFocusable = /*hasInnerFocusable*/
      n[3]), i[0] & /*actionAnimationList*/
      4096 && (o.isNativeActionAnimation = !/*actionAnimationList*/
      n[12].length || wa(
        /*actionAnimationList*/
        n[12]
      )), i[0] & /*$jsonAccessibility*/
      32768 && (o.customAccessibility = /*$jsonAccessibility*/
      n[15]), i[0] & /*captureFocusOnAction*/
      8388608 && (o.captureFocusOnAction = /*captureFocusOnAction*/
      n[23]), i[0] & /*containerElement*/
      4 && (o.containerElement = /*containerElement*/
      n[2]), i[0] & /*borderElemStyle, hasBorder, hasCustomFocus, componentContext, $direction, background, backgroundRadius, hasSeparateBg*/
      155889 | i[4] & /*$$scope*/
      8 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function ba(t) {
  let r, e;
  return r = new j_({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      direction: (
        /*$direction*/
        t[14]
      ),
      background: (
        /*background*/
        t[6]
      ),
      radius: (
        /*backgroundRadius*/
        t[5]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*$direction*/
      16384 && (o.direction = /*$direction*/
      n[14]), i[0] & /*background*/
      64 && (o.background = /*background*/
      n[6]), i[0] & /*backgroundRadius*/
      32 && (o.radius = /*backgroundRadius*/
      n[5]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function ya(t) {
  let r, e;
  return {
    c() {
      r = Be("span"), m(r, "class", gs.outer__border), m(r, "style", e = Rt(
        /*borderElemStyle*/
        t[4]
      ));
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i[0] & /*borderElemStyle*/
      16 && e !== (e = Rt(
        /*borderElemStyle*/
        n[4]
      )) && m(r, "style", e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function S_(t) {
  let r, e, n, i = (
    /*hasSeparateBg*/
    t[7] && ba(t)
  );
  const o = (
    /*#slots*/
    t[124].default
  ), s = Vs(
    o,
    t,
    /*$$scope*/
    t[127],
    ga
  );
  let a = (
    /*hasBorder*/
    t[17] && ya(t)
  );
  return {
    c() {
      i && i.c(), r = $t(), s && s.c(), a && a.c(), e = $t();
    },
    m(l, u) {
      i && i.m(l, u), x(l, r, u), s && s.m(l, u), a && a.m(l, u), x(l, e, u), n = !0;
    },
    p(l, u) {
      /*hasSeparateBg*/
      l[7] ? i ? (i.p(l, u), u[0] & /*hasSeparateBg*/
      128 && K(i, 1)) : (i = ba(l), i.c(), K(i, 1), i.m(r.parentNode, r)) : i && (_r(), ae(i, 1, 1, () => {
        i = null;
      }), pr()), s && s.p && (!n || u[0] & /*hasCustomFocus*/
      8192 | u[4] & /*$$scope*/
      8) && Ds(
        s,
        o,
        l,
        /*$$scope*/
        l[127],
        n ? Is(
          o,
          /*$$scope*/
          l[127],
          u,
          C_
        ) : Ts(
          /*$$scope*/
          l[127]
        ),
        ga
      ), /*hasBorder*/
      l[17] ? a ? a.p(l, u) : (a = ya(l), a.c(), a.m(e.parentNode, e)) : a && (a.d(1), a = null);
    },
    i(l) {
      n || (K(i), K(s, l), n = !0);
    },
    o(l) {
      ae(i), ae(s, l), n = !1;
    },
    d(l) {
      l && (Z(r), Z(e)), i && i.d(l), s && s.d(l), a && a.d(l);
    }
  };
}
function V_(t) {
  let r, e, n = !/*hasWidthError*/
  t[18] && !/*hasHeightError*/
  t[19] && ma(t);
  return {
    c() {
      n && n.c(), r = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, r, o), e = !0;
    },
    p(i, o) {
      !/*hasWidthError*/
      i[18] && !/*hasHeightError*/
      i[19] ? n ? (n.p(i, o), o[0] & /*hasWidthError, hasHeightError*/
      786432 && K(n, 1)) : (n = ma(i), n.c(), K(n, 1), n.m(r.parentNode, r)) : n && (_r(), ae(n, 1, 1, () => {
        n = null;
      }), pr());
    },
    i(i) {
      e || (K(n), e = !0);
    },
    o(i) {
      ae(n), e = !1;
    },
    d(i) {
      i && Z(r), n && n.d(i);
    }
  };
}
const I_ = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
}, D_ = {
  left: "end",
  center: "center",
  right: "start",
  start: "start",
  end: "end"
}, T_ = {
  top: "start",
  center: "center",
  bottom: "end",
  baseline: "baseline"
}, Xs = (t) => `The component id with the "${t}" property for state change is missing. Either specify the id, or specify the "transition_trigger" property without "state_change" value.`;
function wa(t) {
  return t.some((r) => r.name === "native");
}
function F_(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee, X, I, P = T, O = () => (P(), P = B(Q, (Fe) => e(109, I = Fe)), Q), U, me = T, nt = () => (me(), me = B(E, (Fe) => e(110, U = Fe)), E), _e, Me = T, tt = () => (Me(), Me = B(J, (Fe) => e(111, _e = Fe)), J), We, Ne = T, Ft = () => (Ne(), Ne = B(w, (Fe) => e(112, We = Fe)), w), Ve, Oe, Pe = T, yt = () => (Pe(), Pe = B(p, (Fe) => e(113, Oe = Fe)), p), ye, Ke = T, je = () => (Ke(), Ke = B(o, (Fe) => e(114, ye = Fe)), o), te, ot = T, ce = () => (ot(), ot = B(y, (Fe) => e(15, te = Fe)), y), pt, Ct = T, re = () => (Ct(), Ct = B(g, (Fe) => e(115, pt = Fe)), g), $, pe = T, Bt = () => (pe(), pe = B(_, (Fe) => e(116, $ = Fe)), _), De, ft = T, Mt = () => (ft(), ft = B(f, (Fe) => e(117, De = Fe)), f), He, ht = T, qt = () => (ht(), ht = B(l, (Fe) => e(118, He = Fe)), l), fe, Vt = T, be = () => (Vt(), Vt = B(c, (Fe) => e(119, fe = Fe)), c), $e, Ce = T, Xe = () => (Ce(), Ce = B(u, (Fe) => e(120, $e = Fe)), u), Jt, bt = T, Qt = () => (bt(), bt = B(a, (Fe) => e(121, Jt = Fe)), a), rt, ir = T, W = () => (ir(), ir = B(s, (Fe) => e(122, rt = Fe)), s), Et;
  t.$$.on_destroy.push(() => P()), t.$$.on_destroy.push(() => me()), t.$$.on_destroy.push(() => Me()), t.$$.on_destroy.push(() => Ne()), t.$$.on_destroy.push(() => Pe()), t.$$.on_destroy.push(() => Ke()), t.$$.on_destroy.push(() => ot()), t.$$.on_destroy.push(() => Ct()), t.$$.on_destroy.push(() => pe()), t.$$.on_destroy.push(() => ft()), t.$$.on_destroy.push(() => ht()), t.$$.on_destroy.push(() => Vt()), t.$$.on_destroy.push(() => Ce()), t.$$.on_destroy.push(() => bt()), t.$$.on_destroy.push(() => ir());
  let { $$slots: It = {}, $$scope: Ye } = r, { componentContext: L } = r, { cls: Le = "" } = r, { style: gt = void 0 } = r, { layoutParams: qe = {} } = r, { customDescription: Te = !1 } = r, { customPaddings: cr = !1 } = r, { customActions: ke = "" } = r, { additionalPaddings: hr = null } = r, { heightByAspect: ie = !1 } = r, { parentOf: ze = void 0 } = r, { parentOfSimpleMode: Ot = void 0 } = r, { replaceItems: Yt = void 0 } = r, { containerElement: Ht = "span" } = r, { hasInnerFocusable: wt = !1 } = r, { alwaysCustomFocus: Wt = !1 } = r, { devapi: Lt = void 0 } = r;
  const Gt = Xr(_n), tr = Xr(Pl), { isEnabled: or } = Xr(zl);
  mn(t, or, (Fe) => e(123, Et = Fe));
  const mr = Gt.direction;
  mn(t, mr, (Fe) => e(14, Ve = Fe));
  let zt, Ut, st = null, et = [], nr = {}, Ar = {}, br = !1, yr = 1, jr = "transparent", kr = 0, Ir = {
    "top-left": 0,
    "top-right": 0,
    "bottom-right": 0,
    "bottom-left": 0
  }, gr = "", Er = null, Ze = "", ne = {}, we, it, ut, dt = 0, Cr = 0, vt = 0, v = !1, V = !1, Y = {}, he, d, G, Ie = 0, Je = 0, ar = 0, C = !1, Qe = !1, mt = 1, lt, Dt, sr, Yr, qr = [], Ur = !1, Vn = !1, ue, ln, Lr, pn = [], Cn = [], b = [], k = [], j = [], N = [], D = [], Ue = [], de = [], _t = [], at = "", Se, Pt, ct, fr, Fr = !1, Mr = "visible", tn = 0, fn = 0, yn, ri, Wn, In = !1, St = !0, h, A, z, S = null, oe;
  function se() {
    e(66, Er = null), e(67, Ze = ""), e(84, mt = 1), e(96, Fr = !1), e(97, Mr = "visible"), e(98, tn = 0), e(99, fn = 0), e(100, yn = void 0), e(101, ri = void 0), e(23, St = !0), qr = L.fakeElement ? [] : L.json.transition_triggers || ["state_change", "visibility_change"], e(87, Ur = qr.indexOf("state_change") !== -1), Vn = qr.indexOf("visibility_change") !== -1, zt && Ei(zt), A == null || A(), Et && e(103, A = Gt.processVariableTriggers(L, L.json.variable_triggers));
  }
  function At(Fe, Pr) {
    if (!Array.isArray(ze) || !Yt || Ot && (Array.isArray(Pr) ? Pr.length : 0) !== 1)
      return;
    const vr = ze.findIndex((Rr) => (Rr == null ? void 0 : Rr.id) === Fe), An = ze.slice();
    An.splice(vr, 1, ...(Pr || []).map((Rr) => ({ json: Rr, id: Rr == null ? void 0 : Rr.id }))), e(47, ze = An), Yt(An.map((Rr) => Rr == null ? void 0 : Rr.json));
  }
  function kt(Fe) {
    const Pr = uo(Fe.start_value, 1), vr = uo(Fe.end_value, 1), An = Kr(Fe.start_delay, 0), Rr = Os() ? 0 : Kr(Fe.duration, 300), Mn = Cf(Fe.interpolator, "ease_in_out").replace(/_/g, "-");
    switch (Fe.name) {
      case "fade":
        return e(92, Se = Pr), e(93, Pt = vr), `opacity ${Rr}ms ${Mn} ${An}ms`;
      case "scale":
        return e(94, ct = Pr), e(95, fr = vr), `transform ${Rr}ms ${Mn} ${An}ms`;
      case "native":
      case "no_animation":
        return "";
      default:
        return L.logError(R(new Error("Unknown action_animation name"), {
          additional: { animation: Fe.name }
        })), "";
    }
  }
  async function Zr(Fe) {
    e(97, Mr = Fe);
    const Pr = Fe === "visible" ? "in" : "out", vr = Pr === "in" ? L.json.transition_in : L.json.transition_out;
    if (Vn && vr) {
      let An;
      Fe === "gone" && (An = zt.getBoundingClientRect()), await jn(), Pr === "in" && e(89, ln = !0), tr.runVisibilityTransition(
        {
          ...L.json,
          visibility: "visible"
        },
        L,
        vr,
        zt,
        Pr,
        An
      ).then(() => {
        Pr === "in" && e(89, ln = !1);
      }).catch((Rr) => {
        throw Pr === "in" && e(89, ln = !1), Rr;
      });
    }
  }
  function Dr() {
    if (st && zt) {
      const Fe = Gt.getExtensionContext(L);
      st.forEach((Pr) => {
        var vr;
        (vr = Pr.unmountView) == null || vr.call(Pr, zt, Fe);
      }), st = null;
    }
  }
  function Jr() {
    if (st != null && st.length) {
      const Fe = Gt.getExtensionContext(L);
      st.forEach((Pr) => {
        var vr;
        (vr = Pr.updateView) == null || vr.call(Pr, zt, Fe);
      });
    }
    S && S.update(L);
  }
  function Ei(Fe) {
    var Eo, Ao, jo;
    z == null || z.destroy(), e(59, zt = Fe), Ur && L.json.transition_in && (L.id ? tr.registerChildWithTransitionIn(L.json, L, L.json.transition_in, Fe).then(() => {
      e(88, ue = !1);
    }).catch((Mi) => {
      throw e(88, ue = !1), Mi;
    }) : L.logError(R(new Error(Xs("transition_in")), { level: "warn" }))), Ur && L.json.transition_out && (L.id ? tr.registerChildWithTransitionOut(L.json, L, L.json.transition_out, Fe) : L.logError(R(new Error(Xs("transition_out")), { level: "warn" }))), L.fakeElement || (L.json.transition_change && !L.id && L.logError(R(new Error(Xs("transition_change")), { level: "warn" })), tr.registerChildWithTransitionChange(L.json, L, L.json.transition_change, Fe).then(() => {
      e(90, Lr = !1);
    }).catch((Mi) => {
      throw e(90, Lr = !1), Mi;
    }));
    const Pr = !L.fakeElement || L.fakeElement === Oi, vr = Pr ? L.json.visibility_actions || L.json.visibility_action && [L.json.visibility_action] : [], An = Pr ? L.json.disappear_actions : [];
    let Rr;
    (Array.isArray(vr) && vr.length || Array.isArray(An) && An.length) && (Rr = r_(Fe, {
      visibilityActions: vr,
      disappearActions: An,
      rootCtx: Gt,
      componentContext: L
    }));
    const Mn = L.id;
    return Mn && (oe == null || oe(), oe = Gt.registerId(Mn, {
      context: () => L,
      node: () => zt
    }), tr.registerChild(Mn)), (Eo = L.json.tooltips) == null || Eo.forEach((Mi) => {
      Gt.registerTooltip(Fe, Mi);
    }), Wn && (Wn.disconnect(), Wn = void 0), Wn = d_(zt, L, (Ao = L.json.layout_provider) == null ? void 0 : Ao.width_variable_name, (jo = L.json.layout_provider) == null ? void 0 : jo.height_variable_name), ms && !L.fakeElement && (S = ms(Fe, Gt, L, Lt)), z = {
      destroy() {
        oe && (oe(), oe = void 0), Mn && tr.unregisterChild(Mn), Rr && Rr.destroy(), S && S.destroy();
      }
    }, z;
  }
  function fi() {
    L.json.focus && ((Wt || !ol(Gt.isPointerFocus)) && e(13, In = !0), L.execAnyActions(k));
  }
  function Ae() {
    L.json.focus && (e(13, In = !1), L.execAnyActions(j));
  }
  Ms(Jr), bn(() => {
    var Fe;
    et.forEach((Pr) => {
      Gt.unregisterParentOf(Pr);
    }), e(60, et = []), Wn && (Wn.disconnect(), Wn = void 0), (Fe = L.json.tooltips) == null || Fe.forEach((Pr) => {
      Gt.unregisterTooltip(Pr);
    }), A == null || A(), Dr();
  });
  function xt(Fe) {
    Dn.call(this, t, Fe);
  }
  function an(Fe) {
    Dn.call(this, t, Fe);
  }
  return t.$$set = (Fe) => {
    "componentContext" in Fe && e(0, L = Fe.componentContext), "cls" in Fe && e(1, Le = Fe.cls), "style" in Fe && e(48, gt = Fe.style), "layoutParams" in Fe && e(49, qe = Fe.layoutParams), "customDescription" in Fe && e(50, Te = Fe.customDescription), "customPaddings" in Fe && e(51, cr = Fe.customPaddings), "customActions" in Fe && e(52, ke = Fe.customActions), "additionalPaddings" in Fe && e(53, hr = Fe.additionalPaddings), "heightByAspect" in Fe && e(54, ie = Fe.heightByAspect), "parentOf" in Fe && e(47, ze = Fe.parentOf), "parentOfSimpleMode" in Fe && e(55, Ot = Fe.parentOfSimpleMode), "replaceItems" in Fe && e(56, Yt = Fe.replaceItems), "containerElement" in Fe && e(2, Ht = Fe.containerElement), "hasInnerFocusable" in Fe && e(3, wt = Fe.hasInnerFocusable), "alwaysCustomFocus" in Fe && e(57, Wt = Fe.alwaysCustomFocus), "devapi" in Fe && e(58, Lt = Fe.devapi), "$$scope" in Fe && e(127, Ye = Fe.$$scope);
  }, t.$$.update = () => {
    var Fe, Pr, vr, An, Rr, Mn, Eo, Ao, jo, Mi, xl;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(41, n = L.json["custom-class"] || ""), t.$$.dirty[0] & /*componentContext*/
    1 && e(108, i = L.origJson), t.$$.dirty[3] & /*origJson*/
    32768 && i && se(), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[3] & /*$isEnabled, prevTriggersUnsubscribe*/
    1073742848 && (Et ? (A == null || A(), e(103, A = Gt.processVariableTriggers(L, L.json.variable_triggers))) : A == null || A()), t.$$.dirty[0] & /*componentContext*/
    1 && je(e(40, o = L.getDerivedFromVars(L.json.focus))), t.$$.dirty[0] & /*componentContext*/
    1 && W(e(39, s = L.getDerivedFromVars(L.json.border))), t.$$.dirty[0] & /*componentContext*/
    1 && Qt(e(38, a = L.getDerivedFromVars(L.json.paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && qt(e(37, l = L.getDerivedFromVars(L.json.margins))), t.$$.dirty[0] & /*componentContext*/
    1 && Xe(e(36, u = L.getDerivedFromVars(L.json.width))), t.$$.dirty[0] & /*componentContext*/
    1 && be(e(35, c = L.getDerivedFromVars(L.json.alignment_horizontal))), t.$$.dirty[0] & /*componentContext*/
    1 && Mt(e(34, f = L.getDerivedFromVars(L.json.height))), t.$$.dirty[0] & /*componentContext*/
    1 && Bt(e(33, _ = L.getDerivedFromVars(L.json.alignment_vertical))), t.$$.dirty[0] & /*componentContext*/
    1 && re(e(32, g = L.getDerivedFromVars(L.json.alpha))), t.$$.dirty[0] & /*componentContext*/
    1 && ce(e(31, y = L.getDerivedFromVars(L.json.accessibility))), t.$$.dirty[0] & /*componentContext*/
    1 && yt(e(30, p = L.getDerivedFromVars(L.json.background))), t.$$.dirty[0] & /*componentContext*/
    1 && Ft(e(29, w = L.getDerivedFromVars(L.json.action_animation))), t.$$.dirty[0] & /*componentContext*/
    1 && nt(e(28, E = L.getDerivedFromVars(L.json.visibility))), t.$$.dirty[0] & /*componentContext*/
    1 && O(e(27, Q = L.getDerivedFromVars(L.json.transform))), t.$$.dirty[0] & /*componentContext*/
    1 && tt(e(26, J = L.getDerivedFromVars(L.json.capture_focus_on_action))), t.$$.dirty[1] & /*prevChilds, parentOf, parentOfSimpleMode*/
    553713664 && (et.forEach((Nt) => {
      Gt.unregisterParentOf(Nt);
    }), e(60, et = []), ze && ze.forEach((Nt) => {
      Nt != null && Nt.id && (et.push(Nt.id), Gt.registerParentOf(Nt.id, {
        replaceWith: At,
        isSingleMode: !!Ot
      }));
    })), t.$$.dirty[0] & /*hasCustomFocus, borderElemStyle*/
    8208 | t.$$.dirty[1] & /*borderStyle*/
    1073741824 | t.$$.dirty[2] & /*strokeWidth, strokeColor, cornersRadius, cornerRadius*/
    15 | t.$$.dirty[3] & /*$jsonFocus, $jsonBorder*/
    538968064) {
      const Nt = In && (ye != null && ye.border) ? ye.border : rt;
      let Br = {}, rn = {}, wn = !1, en = "";
      if (Nt) {
        if (Tn(Nt.has_shadow, !1)) {
          const nn = Nt.shadow;
          nn ? Br["box-shadow"] = u_(nn) : Br["box-shadow"] = "0 1px 2px 0 rgba(0,0,0,.18), 0 0 0 1px rgba(0,0,0,.07)";
        }
        if (Nt.stroke) {
          wn = !0, e(62, yr = Kr(Nt.stroke.width, yr)), e(63, jr = Tr(Nt.stroke.color, 1, jr));
          const nn = ((Fe = Nt.stroke.style) == null ? void 0 : Fe.type) === "dashed" ? "dashed" : "solid";
          rn["--divkit-border"] = `${Re(yr + 1)} ${nn} ${jr}`;
        }
        if (Nt.corners_radius && typeof Nt.corners_radius == "object") {
          e(65, Ir = a_(Nt.corners_radius, Ir)), Br["border-radius"] = Xo(Ir);
          const nn = {};
          ["top-left", "top-right", "bottom-right", "bottom-left"].forEach((Rn) => {
            nn[Rn] = (Ir[Rn] || 0) + 1;
          }), rn["--divkit-border-radius"] = Xo(nn);
        } else
          Nt.corner_radius && (e(64, kr = Kr(Nt.corner_radius, kr)), e(65, Ir = {
            "top-left": kr,
            "top-right": kr,
            "bottom-right": kr,
            "bottom-left": kr
          }), Br["border-radius"] = Re(kr), rn["--divkit-border-radius"] = Re(kr + 1));
        if (wn && yr && (Nt.corners_radius || Nt.corner_radius)) {
          let nn = { ...Ir };
          ["top-left", "top-right", "bottom-right", "bottom-left"].forEach((Rn) => {
            nn[Rn] = (nn[Rn] || 0) + yr / 2;
          }), en = Xo(nn);
        }
      }
      e(61, nr = Ni(Br, nr)), e(4, Ar = Ni(rn, Ar)), e(17, br = wn), e(5, gr = en);
    }
    if (t.$$.dirty[1] & /*customPaddings*/
    1048576 | t.$$.dirty[2] & /*selfPadding*/
    16 | t.$$.dirty[3] & /*$jsonPaddings*/
    268435456 && e(66, Er = wo(
      Jt && !cr ? Jt : void 0,
      Er
    )), t.$$.dirty[0] & /*$direction*/
    16384 | t.$$.dirty[1] & /*additionalPaddings*/
    4194304 | t.$$.dirty[2] & /*selfPadding*/
    16 && e(105, M = li(l_(Er, hr), Ve)), t.$$.dirty[0] & /*$direction*/
    16384 | t.$$.dirty[2] & /*margin*/
    32 | t.$$.dirty[3] & /*$jsonMargins*/
    33554432 && e(67, Ze = bs(He, Ve, Ze)), t.$$.dirty[0] & /*componentContext, $direction*/
    16385 | t.$$.dirty[1] & /*layoutParams*/
    262144 | t.$$.dirty[2] & /*widthNum, widthMods*/
    1088 | t.$$.dirty[3] & /*$jsonWidth, $jsonMargins, $jsonAlignmentHorizontal*/
    234881024) {
      let Nt, Br, rn, wn, en = {}, nn = 0, Rn = 0, Ai = !1, ji = !1;
      const vn = (Pr = L.json.width) == null ? void 0 : Pr.type;
      if (vn === "fixed")
        e(72, dt = Kr($e == null ? void 0 : $e.value, dt)), Br = Re(dt);
      else if (vn === "wrap_content" || (vn === "match_parent" || !vn) && qe.parentHorizontalWrapContent) {
        if (Nt = "content", (vn === "wrap_content" && ($e != null && $e.constrained) || (vn === "match_parent" || !vn) && qe.parentHorizontalWrapContent) && (en["width-constrained"] = !0, qe.parentContainerOrientation === "horizontal" && (Rn = 1)), vn === "wrap_content") {
          const Gr = $e;
          let Sn, kn;
          Gr.min_size && zn(Gr.min_size.value) && (Sn = Gr.min_size.value), Gr.max_size && zn(Gr.max_size.value) && (kn = Gr.max_size.value), Sn !== void 0 && kn !== void 0 && Sn > kn && (L.logError(R(new Error("Element has incorrect width constraints (min size is bigger than max size)."), {
            additional: {
              id: L.json.id,
              minSize: Sn + "dp",
              maxSize: kn + "dp"
            }
          })), Sn = kn = void 0), Sn !== void 0 && (rn = Re(Sn)), kn !== void 0 && (wn = Re(kn));
        }
        (vn === "match_parent" || !vn) && L.logError(R(new Error("Incorrect child size. Container with wrap_content size contains child with match_parent size along the main axis"), { level: "warn" }));
      } else if (Nt = "parent", qe.parentContainerOrientation === "vertical" && qe.parentContainerWrap && (ji = !0, L.logError(R(new Error("Cannot place a match_parent items on the cross-axis of wrap"), { level: "error" }))), qe.parentLayoutOrientation === "vertical" || qe.parentContainerOrientation === "vertical" && qe.parentContainerKnownWidth || qe.stretchWidth) {
        const Gr = (An = (vr = Ve === "ltr" ? He == null ? void 0 : He.start : He == null ? void 0 : He.end) != null ? vr : He == null ? void 0 : He.left) != null ? An : 0, Sn = (Mn = (Rr = Ve === "ltr" ? He == null ? void 0 : He.end : He == null ? void 0 : He.start) != null ? Rr : He == null ? void 0 : He.right) != null ? Mn : 0, kn = `calc(100% - ${dn(Gr + Sn)})`;
        qe.stretchWidth ? (Br = "0", rn = kn) : Br = kn;
      } else
        qe.parentContainerOrientation === "horizontal" && (nn = $e && "weight" in $e && $e.weight || 1, qe.parentContainerWrap && (Ai = !0));
      if (Nt === "parent")
        en["halign-self"] = "stretch";
      else {
        const Gr = fe;
        Gr === "left" || Gr === "center" || Gr === "right" || Gr === "start" || Gr === "end" ? en["halign-self"] = (Ve === "ltr" ? I_ : D_)[Gr] : en["halign-self"] = qe.parentHAlign || "start";
      }
      Nt && (en.width = Nt), e(69, we = Br), e(70, it = rn), e(71, ut = wn), e(73, Cr = nn), e(74, vt = Rn), e(68, ne = Ni(en, ne)), e(75, v = Ai), e(18, V = ji);
    }
    if (t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*heightByAspect, layoutParams*/
    8650752 | t.$$.dirty[2] & /*heightNum, heightMods*/
    278528 | t.$$.dirty[3] & /*$jsonHeight, $jsonMargins, $jsonAlignmentVertical*/
    58720256) {
      let Nt, Br, rn, wn, en = {}, nn = 0, Rn = 0, Ai = !1, ji = !1;
      const vn = (Eo = L.json.height) == null ? void 0 : Eo.type;
      if (!ie)
        if (vn === "fixed")
          e(80, Ie = Kr(De == null ? void 0 : De.value, Ie)), Br = Re(Ie);
        else if (vn === "match_parent" && !qe.parentVerticalWrapContent)
          if (Nt = "parent", qe.parentContainerOrientation === "horizontal" && qe.parentContainerWrap && (ji = !0, L.logError(R(new Error("Cannot place a match_parent items on the cross-axis of wrap"), { level: "error" }))), qe.parentLayoutOrientation === "horizontal" || qe.parentContainerOrientation === "horizontal" && qe.parentContainerKnownHeight || qe.stretchHeight) {
            const Gr = (Ao = He == null ? void 0 : He.top) != null ? Ao : 0, Sn = (jo = He == null ? void 0 : He.bottom) != null ? jo : 0, kn = `calc(100% - ${dn(Gr + Sn)})`;
            qe.stretchHeight ? (Br = "0", rn = kn) : Br = kn;
          } else
            qe.parentContainerOrientation === "vertical" && (nn = (De == null ? void 0 : De.weight) || 1, qe.parentContainerWrap && (Ai = !0));
        else {
          if (Nt = "content", (vn === "wrap_content" && (De != null && De.constrained) || vn === "match_parent" && qe.parentVerticalWrapContent) && (en["height-constrained"] = !0, qe.parentContainerOrientation === "vertical" && (Rn = 1)), vn === "wrap_content") {
            const Gr = De;
            let Sn, kn;
            Gr.min_size && zn(Gr.min_size.value) && (Sn = Gr.min_size.value), Gr.max_size && zn(Gr.max_size.value) && (kn = Gr.max_size.value), Sn !== void 0 && kn !== void 0 && Sn > kn && (L.logError(R(new Error("Element has incorrect height constraints (min size is bigger than max size)."), {
              additional: {
                id: L.json.id,
                minSize: Sn + "dp",
                maxSize: kn + "dp"
              }
            })), Sn = kn = void 0), Sn !== void 0 && (rn = Re(Sn)), kn !== void 0 && (wn = Re(kn));
          }
          vn === "match_parent" && L.logError(R(new Error("Incorrect child size. Container with wrap_content size contains child with match_parent size along the main axis"), { level: "warn" }));
        }
      if (Nt === "parent")
        en["valign-self"] = "stretch";
      else {
        const Gr = $;
        Gr === "top" || Gr === "center" || Gr === "bottom" || Gr === "baseline" && qe.parentContainerOrientation === "horizontal" ? en["valign-self"] = T_[Gr] : en["valign-self"] = qe.parentVAlign || "start";
      }
      Nt && (en.height = Nt), e(77, he = Br), e(78, d = rn), e(79, G = wn), e(81, Je = nn), e(82, ar = Rn), e(76, Y = Ni(en, Y)), e(83, C = Ai), e(19, Qe = ji);
    }
    if (t.$$.dirty[1] & /*layoutParams*/
    262144 && e(107, ge = qe.overlapParent ? !0 : void 0), t.$$.dirty[1] & /*layoutParams*/
    262144 && e(106, le = qe.gridArea ? `${qe.gridArea.y + 1}/${qe.gridArea.x + 1}/span ${qe.gridArea.rowSpan}/span ${qe.gridArea.colSpan}` : void 0), t.$$.dirty[2] & /*alpha*/
    4194304 | t.$$.dirty[3] & /*$jsonAlpha*/
    4194304 && (e(84, mt = i_(pt, mt)), e(85, lt = mt === 1 ? void 0 : mt)), t.$$.dirty[0] & /*$jsonAccessibility*/
    32768 | t.$$.dirty[1] & /*customDescription*/
    524288 && (e(16, Ut = void 0), te && !Te)) {
      const Nt = po(te);
      Nt && (e(16, Ut = {}), e(16, Ut["aria-label"] = Nt, Ut));
    }
    if (t.$$.dirty[0] & /*hasCustomFocus, background, backgroundRadius, hasSeparateBg, $direction*/
    24800 | t.$$.dirty[3] & /*$jsonFocus, $jsonBackground*/
    3145728 && (e(6, Dt = In && (ye != null && ye.background) ? ye.background : Oe), e(86, sr = {}), e(7, Yr = !1), Array.isArray(Dt) && (e(7, Yr = Dt.some((Nt) => Nt.type === "image" || Nt.type === "nine_patch_image") || !!gr), !Yr))) {
      const Nt = Ns(Dt, Ve);
      e(86, sr["background-color"] = Nt.color, sr), e(86, sr["background-image"] = Nt.image, sr), e(86, sr["background-size"] = Nt.size, sr), e(86, sr["background-position"] = Nt.position, sr), e(86, sr["background-repeat"] = "no-repeat", sr);
    }
    if (t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[2] & /*hasStateChangeTrigger*/
    33554432 && (e(88, ue = void 0), Ur && L.id && L.json.transition_in && Gt.isRunning("stateChange") && e(88, ue = !0)), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[2] & /*hasStateChangeTrigger*/
    33554432 && (e(90, Lr = void 0), Ur && L.id && Gt.isRunning("stateChange") && tr.hasTransitionChange(L.id) && e(90, Lr = !0)), t.$$.dirty[0] & /*componentContext, pressStartActions, pressEndActions, hoverStartActions, hoverEndActions*/
    3841 | t.$$.dirty[1] & /*customActions*/
    2097152) {
      const Nt = L.json;
      let Br = Nt.actions || Nt.action && [Nt.action] || [], rn = Nt.doubletap_actions || [], wn = Nt.longtap_actions || [], en = ((Mi = Nt.focus) == null ? void 0 : Mi.on_focus) || [], nn = ((xl = Nt.focus) == null ? void 0 : xl.on_blur) || [], Rn = Nt.press_start_actions || [], Ai = Nt.press_end_actions || [], ji = Nt.hover_start_actions || [], vn = Nt.hover_end_actions || [];
      L.fakeElement && L.fakeElement !== Oi ? (Br = [], rn = [], wn = [], en = [], nn = []) : (Array.isArray(Br) || (Br = [], L.logError(R(new Error("Actions should be array")))), Array.isArray(rn) || (rn = [], L.logError(R(new Error("DoubleTapActions should be array")))), Array.isArray(wn) || (wn = [], L.logError(R(new Error("LongTapActions should be array")))), Array.isArray(en) || (en = [], L.logError(R(new Error("FocusActions should be array")))), Array.isArray(nn) || (nn = [], L.logError(R(new Error("BlurActions should be array")))), Array.isArray(Rn) || (Rn = [], L.logError(R(new Error("PressStartActions should be array")))), Array.isArray(Ai) || (Ai = [], L.logError(R(new Error("PressEndActions should be array")))), Array.isArray(ji) || (ji = [], L.logError(R(new Error("HoverStartActions should be array")))), Array.isArray(vn) || (vn = [], L.logError(R(new Error("HoverEndActions should be array"))))), (Br.length || rn.length || wn.length || N.length || D.length || Ue.length || de.length) && ke && (Br = [], rn = [], wn = [], e(8, N = []), e(9, D = []), e(10, Ue = []), e(11, de = []), L.logError(R(new Error(`Cannot use action on component "${ke}"`)))), e(20, pn = Br), e(21, Cn = rn), e(22, b = wn), k = en, j = nn, e(8, N = Rn), e(9, D = Ai), e(10, Ue = ji), e(11, de = vn);
    }
    if (t.$$.dirty[0] & /*actionAnimationList*/
    4096 | t.$$.dirty[3] & /*$jsonActionAnimation*/
    524288 && We && (e(12, _t = Nl(We)), e(91, at = _t.map(kt).filter(Boolean).join(", "))), t.$$.dirty[3] & /*$jsonCaptureFocusOnAction*/
    262144 && typeof _e == "boolean" && e(23, St = _e), t.$$.dirty[3] & /*visibility, $jsonVisibility, isVisibilityInited*/
    131096) {
      const Nt = Mr, Br = s_(U, Mr);
      Nt !== Br && (Fr && (Mr === "visible" || Br === "visible") ? Zr(Br) : e(97, Mr = Br)), Fr || e(96, Fr = !0);
    }
    if (t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*currentNode*/
    268435456 | t.$$.dirty[3] & /*prevExtensionsVal*/
    512 && L.json && zt && !yo(L.json.extensions, h)) {
      let Nt = e(102, h = L.json.extensions);
      jn().then(() => {
        if (!(Nt !== h || !zt) && (Dr(), Array.isArray(L.json.extensions))) {
          const Br = Gt.getExtensionContext(L);
          st = L.json.extensions.map((rn) => {
            var nn;
            const wn = rn.id;
            if (!wn)
              return;
            const en = Gt.getExtension(wn, rn.params);
            return en && ((nn = en.mountView) == null || nn.call(en, zt, Br)), en;
          }).filter(ki);
        }
      });
    }
    if (t.$$.dirty[0] & /*hasCustomFocus, componentContext*/
    8193 | t.$$.dirty[1] & /*layoutParams*/
    262144 | t.$$.dirty[2] & /*widthMods, heightMods, stateChangingInProgress, visibilityChangingInProgress, transitionChangeInProgress, actionAnimationTransition*/
    1006649408 | t.$$.dirty[3] & /*parentOverlapMod, visibility*/
    16400 && e(25, H = {
      ...ne,
      ...Y,
      "parent-overlap": ge,
      "scroll-snap": qe.scrollSnap,
      "hide-on-transition-in": ue || ln || Lr,
      visibility: Mr,
      "has-action-animation": !!at,
      "parent-flex": qe.parentContainerOrientation || void 0,
      "parent-grid": !!qe.gridArea || void 0,
      "has-custom-focus": !!(In && L.json.focus)
    }), t.$$.dirty[3] & /*$jsonTransform, pivotXNum, pivotYNum*/
    65632 && I && I.rotation !== void 0) {
      const Nt = I.pivot_x || { type: "pivot-percentage", value: 50 };
      e(98, tn = uo(Nt.value, tn));
      const Br = Nt.type === "pivot-fixed" ? Re(tn) : `${tn}%`, rn = I.pivot_y || { type: "pivot-percentage", value: 50 };
      e(99, fn = uo(rn.value, fn));
      const wn = rn.type === "pivot-fixed" ? Re(fn) : `${fn}%`;
      e(100, yn = `${Br} ${wn}`), e(101, ri = `rotate(${I.rotation}deg)`);
    }
    t.$$.dirty[2] & /*widthFill, heightFill, widthFlexGrow, heightFlexGrow*/
    2631680 && e(104, ee = v || C ? "100%" : Cr || Je ? 0 : void 0), t.$$.dirty[1] & /*style, borderStyle*/
    1073872896 | t.$$.dirty[2] & /*backgroundStyle, width, widthMin, widthMax, height, heightMin, heightMax, margin, opacity, actionAnimationTransition, widthFlexGrow, heightFlexGrow, widthFlexShrink, heightFlexShrink, animationOpacityStart*/
    1637587872 | t.$$.dirty[3] & /*gridArea, padding, transformOrigin, transform, flexBasis, animationOpacityEnd, animationScaleStart, animationScaleEnd*/
    14727 && e(24, X = {
      ...gt,
      ...sr,
      ...nr,
      width: we,
      "min-width": it,
      "max-width": ut,
      height: he,
      "min-height": d,
      // input max-height
      "max-height": G || (gt == null ? void 0 : gt["max-height"]),
      "grid-area": le,
      padding: M,
      margin: Ze,
      opacity: lt,
      transition: at,
      "transform-origin": yn,
      transform: ri,
      "flex-grow": Cr || Je || void 0,
      "flex-shrink": vt || ar ? 1 : void 0,
      "flex-basis": ee,
      "--divkit-animation-opacity-start": Se,
      "--divkit-animation-opacity-end": Pt,
      "--divkit-animation-scale-start": ct,
      "--divkit-animation-scale-end": fr
    });
  }, [
    L,
    Le,
    Ht,
    wt,
    Ar,
    gr,
    Dt,
    Yr,
    N,
    D,
    Ue,
    de,
    _t,
    In,
    Ve,
    te,
    Ut,
    br,
    V,
    Qe,
    pn,
    Cn,
    b,
    St,
    X,
    H,
    J,
    Q,
    E,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    n,
    or,
    mr,
    Ei,
    fi,
    Ae,
    ze,
    gt,
    qe,
    Te,
    cr,
    ke,
    hr,
    ie,
    Ot,
    Yt,
    Wt,
    Lt,
    zt,
    et,
    nr,
    yr,
    jr,
    kr,
    Ir,
    Er,
    Ze,
    ne,
    we,
    it,
    ut,
    dt,
    Cr,
    vt,
    v,
    Y,
    he,
    d,
    G,
    Ie,
    Je,
    ar,
    C,
    mt,
    lt,
    sr,
    Ur,
    ue,
    ln,
    Lr,
    at,
    Se,
    Pt,
    ct,
    fr,
    Fr,
    Mr,
    tn,
    fn,
    yn,
    ri,
    h,
    A,
    ee,
    M,
    le,
    ge,
    i,
    I,
    U,
    _e,
    We,
    Oe,
    ye,
    pt,
    $,
    De,
    He,
    fe,
    $e,
    Jt,
    rt,
    Et,
    It,
    xt,
    an,
    Ye
  ];
}
class On extends $r {
  constructor(r) {
    super(), xr(
      this,
      r,
      F_,
      V_,
      Vr,
      {
        componentContext: 0,
        cls: 1,
        style: 48,
        layoutParams: 49,
        customDescription: 50,
        customPaddings: 51,
        customActions: 52,
        additionalPaddings: 53,
        heightByAspect: 54,
        parentOf: 47,
        parentOfSimpleMode: 55,
        replaceItems: 56,
        containerElement: 2,
        hasInnerFocusable: 3,
        alwaysCustomFocus: 57,
        devapi: 58
      },
      null,
      [-1, -1, -1, -1, -1]
    );
  }
}
const M_ = "appkit-text", P_ = "appkit-text_halign_start", N_ = "appkit-text_halign_center", z_ = "appkit-text_halign_end", O_ = "appkit-text_valign_start", L_ = "appkit-text_valign_center", R_ = "appkit-text_valign_end", B_ = "appkit-text_valign_baseline", H_ = "appkit-text__inner", W_ = "appkit-text_singleline", U_ = "appkit-text_multiline", G_ = "appkit-text_truncate_none", Y_ = "appkit-text__inner_gradient", q_ = "appkit-text__image", J_ = "appkit-text__image_hidden", xn = {
  "text-range": "appkit-text-range",
  text: M_,
  text_halign_start: P_,
  text_halign_center: N_,
  text_halign_end: z_,
  text_valign_start: O_,
  text_valign_center: L_,
  text_valign_end: R_,
  text_valign_baseline: B_,
  text__inner: H_,
  text_singleline: W_,
  text_multiline: U_,
  text_truncate_none: G_,
  "text__inner_has-cloud-bg": "appkit-text__inner_has-cloud-bg",
  "text__inner_cloud-bg": "appkit-text__inner_cloud-bg",
  text__inner_gradient: Y_,
  "text__image-wrapper": "appkit-text__image-wrapper",
  "text__image-wrapper_crop": "appkit-text__image-wrapper_crop",
  "text__image-wrapper_align_top": "appkit-text__image-wrapper_align_top",
  "text__image-wrapper_align_center": "appkit-text__image-wrapper_align_center",
  "text__image-wrapper_align_bottom": "appkit-text__image-wrapper_align_bottom",
  "text__image-wrapper_align_baseline": "appkit-text__image-wrapper_align_baseline",
  text__image: q_,
  text__image_hidden: J_,
  "text_has-focus-color": "appkit-text_has-focus-color"
}, _i = {
  "text-range": "appkit-text-range",
  "text-range_cloud": "appkit-text-range_cloud",
  "text-range_singleline": "appkit-text-range_singleline",
  "text-range__top-offset": "appkit-text-range__top-offset",
  "text-range_decoration_both": "appkit-text-range_decoration_both",
  "text-range_decoration_underline": "appkit-text-range_decoration_underline",
  "text-range_decoration_strike": "appkit-text-range_decoration_strike",
  "text-range_decoration_none": "appkit-text-range_decoration_none",
  "text-range_align_top": "appkit-text-range_align_top",
  "text-range_align_center": "appkit-text-range_align_center",
  "text-range_align_bottom": "appkit-text-range_align_bottom",
  "text-range_align_baseline": "appkit-text-range_align_baseline",
  "text-range__cloud-svg": "appkit-text-range__cloud-svg",
  "text-range_relative-vertical-align": "appkit-text-range_relative-vertical-align",
  "text-range_has-particles-mask": "appkit-text-range_has-particles-mask",
  "text-range__mask-animation": "appkit-text-range__mask-animation",
  "text-range_mask-animated": "appkit-text-range_mask-animated",
  "divkit-mask-particles-0": "appkit-divkit-mask-particles-0",
  "divkit-mask-particles-1": "appkit-divkit-mask-particles-1",
  "divkit-mask-particles-2": "appkit-divkit-mask-particles-2",
  "divkit-mask-particles-3": "appkit-divkit-mask-particles-3",
  "divkit-mask-particles-4": "appkit-divkit-mask-particles-4",
  "divkit-mask-particles-5": "appkit-divkit-mask-particles-5"
};
function Gn(t, r) {
  const e = Number(t);
  return Number.isNaN(e) || e <= 0 ? r : e;
}
function K_(t) {
  if (t === "light" || t === "medium" || t === "bold" || t === "regular")
    return t === "medium" ? 500 : t === "bold" ? 700 : t === "light" ? 300 : 400;
}
function ho(t, r, e) {
  return typeof r == "number" && r > 0 ? r : K_(t) || e;
}
function cl(t, r) {
  if (!t)
    return {};
  const e = {};
  for (const n of ["left", "top", "right", "bottom", "start", "end"]) {
    const i = t[n];
    i && (e[n] = i * r);
  }
  return e;
}
function va(t) {
  let r, e, n, i, o, s, a;
  return {
    c() {
      r = En("svg"), e = En("defs"), n = En("filter"), i = En("feGaussianBlur"), o = En("feColorMatrix"), a = En("feBlend"), m(i, "in", "SourceGraphic"), m(i, "result", "blurred"), m(i, "stdDeviation", "3"), m(o, "in", "blurred"), m(o, "result", "withMatrix"), m(o, "type", "matrix"), m(o, "values", s = "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 " + 2 * /*borderRadius*/
      t[5] + " -" + /*borderRadius*/
      t[5]), m(a, "in", "SourceGraphic"), m(a, "in2", "withMatrix"), m(
        n,
        "id",
        /*cloudFilterId*/
        t[11]
      ), m(r, "class", _i["text-range__cloud-svg"]);
    },
    m(l, u) {
      x(l, r, u), Tt(r, e), Tt(e, n), Tt(n, i), Tt(n, o), Tt(n, a);
    },
    p(l, u) {
      u[0] & /*borderRadius*/
      32 && s !== (s = "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 " + 2 * /*borderRadius*/
      l[5] + " -" + /*borderRadius*/
      l[5]) && m(o, "values", s);
    },
    d(l) {
      l && Z(r);
    }
  };
}
function ka(t) {
  let r;
  return {
    c() {
      r = Be("span"), m(r, "class", _i["text-range__top-offset"]), q(
        r,
        "margin-top",
        /*topOffset*/
        t[9]
      );
    },
    m(e, n) {
      x(e, r, n);
    },
    p(e, n) {
      n[0] & /*topOffset*/
      512 && q(
        r,
        "margin-top",
        /*topOffset*/
        e[9]
      );
    },
    d(e) {
      e && Z(r);
    }
  };
}
function Ea(t) {
  let r, e, n, i, o, s;
  return {
    c() {
      r = Be("div"), e = Be("div"), n = Be("div"), i = Be("div"), o = Be("div"), s = Be("div"), m(r, "class", _i["text-range__mask-animation"]), m(e, "class", _i["text-range__mask-animation"]), m(n, "class", _i["text-range__mask-animation"]), m(i, "class", _i["text-range__mask-animation"]), m(o, "class", _i["text-range__mask-animation"]), m(s, "class", _i["text-range__mask-animation"]);
    },
    m(a, l) {
      x(a, r, l), x(a, e, l), x(a, n, l), x(a, i, l), x(a, o, l), x(a, s, l);
    },
    d(a) {
      a && (Z(r), Z(e), Z(n), Z(i), Z(o), Z(s));
    }
  };
}
function X_(t) {
  let r = (
    /*text*/
    (t[1] || "​") + ""
  ), e, n = (
    /*maskColor*/
    t[4] && Ea()
  );
  return {
    c() {
      n && n.c(), e = ei(r);
    },
    m(i, o) {
      n && n.m(i, o), x(i, e, o);
    },
    p(i, o) {
      /*maskColor*/
      i[4] ? n || (n = Ea(), n.c(), n.m(e.parentNode, e)) : n && (n.d(1), n = null), o[0] & /*text*/
      2 && r !== (r = /*text*/
      (i[1] || "​") + "") && Ti(e, r);
    },
    d(i) {
      i && Z(e), n && n.d(i);
    }
  };
}
function Z_(t) {
  let r, e, n, i, o = (
    /*cloudBg*/
    t[3] && /*hasCloudBg*/
    t[6] && va(t)
  ), s = (
    /*topOffset*/
    t[9] && ka(t)
  );
  return n = new Ls({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      cls: jt(
        "text-range",
        _i,
        /*mods*/
        t[8]
      ),
      actions: (
        /*actions*/
        t[2]
      ),
      style: Rt(
        /*style*/
        t[7]
      ),
      $$slots: { default: [X_] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      o && o.c(), r = $t(), s && s.c(), e = $t(), Zt(n.$$.fragment);
    },
    m(a, l) {
      o && o.m(a, l), x(a, r, l), s && s.m(a, l), x(a, e, l), Kt(n, a, l), i = !0;
    },
    p(a, l) {
      /*cloudBg*/
      a[3] && /*hasCloudBg*/
      a[6] ? o ? o.p(a, l) : (o = va(a), o.c(), o.m(r.parentNode, r)) : o && (o.d(1), o = null), /*topOffset*/
      a[9] ? s ? s.p(a, l) : (s = ka(a), s.c(), s.m(e.parentNode, e)) : s && (s.d(1), s = null);
      const u = {};
      l[0] & /*componentContext*/
      1 && (u.componentContext = /*componentContext*/
      a[0]), l[0] & /*mods*/
      256 && (u.cls = jt(
        "text-range",
        _i,
        /*mods*/
        a[8]
      )), l[0] & /*actions*/
      4 && (u.actions = /*actions*/
      a[2]), l[0] & /*style*/
      128 && (u.style = Rt(
        /*style*/
        a[7]
      )), l[0] & /*text, maskColor*/
      18 | l[1] & /*$$scope*/
      32 && (u.$$scope = { dirty: l, ctx: a }), n.$set(u);
    },
    i(a) {
      i || (K(n.$$.fragment, a), i = !0);
    },
    o(a) {
      ae(n.$$.fragment, a), i = !1;
    },
    d(a) {
      a && (Z(r), Z(e)), o && o.d(a), s && s.d(a), Xt(n, a);
    }
  };
}
function Q_(t, r, e) {
  let n, i, o, s, a, l, u, c, f, { componentContext: _ } = r, { text: g } = r, { rootFontSize: y } = r, { textStyles: p = {} } = r, { singleline: w = !1 } = r, { actions: E = void 0 } = r, { cloudBg: Q = !1 } = r, { cloudBgId: J = "" } = r, { customLineHeight: M = null } = r;
  const ge = Xr(_n), le = ge.direction;
  mn(t, le, (Oe) => e(34, f = Oe));
  const H = Q && J || ge.genId("text-range") || "";
  let ee = "none", X = 12, I = 1.25, P = "", O, U = "", me = "", nt, _e = null, Me, tt, We = !1, Ne, Ft, Ve;
  return t.$$set = (Oe) => {
    "componentContext" in Oe && e(0, _ = Oe.componentContext), "text" in Oe && e(1, g = Oe.text), "rootFontSize" in Oe && e(12, y = Oe.rootFontSize), "textStyles" in Oe && e(13, p = Oe.textStyles), "singleline" in Oe && e(14, w = Oe.singleline), "actions" in Oe && e(2, E = Oe.actions), "cloudBg" in Oe && e(3, Q = Oe.cloudBg), "cloudBgId" in Oe && e(15, J = Oe.cloudBgId), "customLineHeight" in Oe && e(16, M = Oe.customLineHeight);
  }, t.$$.update = () => {
    var Oe, Pe, yt, ye, Ke, je, te, ot;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && _.json && (e(17, ee = "none"), e(18, X = 12), e(19, I = 1.25), e(20, P = ""), e(21, O = void 0), e(22, U = ""), e(23, me = ""), e(24, nt = void 0), e(25, _e = null), e(26, Me = void 0), e(27, tt = void 0), e(28, We = !1), e(4, Ne = void 0), e(29, Ft = void 0), e(30, Ve = void 0)), t.$$.dirty[0] & /*textStyles*/
    8192) {
      let ce = "none";
      (p.underline || p.strike) && (p.underline === "single" && p.strike === "single" ? ce = "both" : p.underline === "single" ? ce = "underline" : p.strike === "single" && (ce = "strike")), e(17, ee = ce);
    }
    if (t.$$.dirty[0] & /*textStyles, fontSize*/
    270336 && e(18, X = Gn(p.font_size, X)), t.$$.dirty[0] & /*textStyles, fontSize*/
    270336 && Hn(p.line_height) && e(19, I = Number(p.line_height) / X), t.$$.dirty[0] & /*textStyles*/
    8192 && zn(p.letter_spacing) && e(20, P = Re(p.letter_spacing)), t.$$.dirty[0] & /*textStyles, fontWeight*/
    2105344 && (e(21, O = ho(p.font_weight, p.font_weight_value, O)), typeof p.font_family == "string" && p.font_family ? e(22, U = ge.typefaceProvider(p.font_family, { fontWeight: O || 400 })) : e(22, U = "")), t.$$.dirty[0] & /*textStyles, color*/
    8396800 && e(23, me = Tr(p.text_color, 1, me)), t.$$.dirty[0] & /*textStyles*/
    8192 && e(9, n = p.top_offset ? Re(p.top_offset) : ""), t.$$.dirty[0] & /*textStyles*/
    8192 && e(6, i = ((Oe = p.background) == null ? void 0 : Oe.type) === "cloud"), t.$$.dirty[0] & /*textStyles*/
    8192 && e(32, o = ((Pe = p.background) == null ? void 0 : Pe.type) === "cloud" ? p.background.paddings : void 0), t.$$.dirty[0] & /*textStyles, cloudBg, hasCloudBg, fontSize*/
    270408 | t.$$.dirty[1] & /*$direction*/
    8) {
      const ce = p.mask, pt = !!(ce && (ce.type === "solid" || ce.type === "particles") && ce.is_enabled !== !1 && ce.color);
      if (Q || pt ? e(24, nt = "transparent") : e(24, nt = void 0), e(28, We = !1), e(4, Ne = void 0), e(29, Ft = void 0), e(30, Ve = void 0), Q)
        i ? e(27, tt = Kd(p.background.color, 255, "transparent")) : e(27, tt = void 0);
      else if (ce && pt) {
        if (ce.type === "solid")
          e(27, tt = Tr(ce.color));
        else if (ce.type === "particles") {
          const Ct = Gn((yt = ce.particle_size) == null ? void 0 : yt.value, 1), re = Re(Ct * 10 / X), $ = Gn(ce.density, 0.8), pe = Tr(ce.color);
          e(27, tt = void 0), e(4, Ne = pe), e(29, Ft = re), e(30, Ve = String($)), e(28, We = ce.is_animated === !0);
        }
      } else
        ((ye = p.background) == null ? void 0 : ye.type) === "solid" ? e(27, tt = Ns([p.background], f).color) : e(27, tt = void 0);
    }
    t.$$.dirty[0] & /*textStyles*/
    8192 && ((Ke = p.border) != null && Ke.stroke && p.border.stroke.color && Tr(p.border.stroke.color) !== "transparent" && Hn(p.border.stroke.width) && ((je = p.background) == null ? void 0 : je.type) !== "cloud" ? e(25, _e = {
      color: p.border.stroke.color,
      width: p.border.stroke.width,
      corner_radius: p.border.corner_radius
    }) : e(25, _e = null)), t.$$.dirty[0] & /*cloudBg, hasCloudBg, textStyles, border*/
    33562696 && e(5, s = Q ? i && p.background.corner_radius || 0 : _e ? Gn(_e.corner_radius, 0) : 0), t.$$.dirty[0] & /*textStyles, fontSize*/
    270336 && e(31, a = p.text_shadow ? c_(p.text_shadow, X) : void 0), t.$$.dirty[0] & /*textStyles*/
    8192 && typeof p.baseline_offset == "number" && e(26, Me = p.baseline_offset), t.$$.dirty[0] & /*textStyles*/
    8192 && e(33, l = typeof p.baseline_offset == "number" ? void 0 : p.alignment_vertical), t.$$.dirty[0] & /*singleline, decoration, hasCloudBg, customLineHeight, verticalAlign, maskColor, maskAnimated*/
    335757392 | t.$$.dirty[1] & /*customVerticalAlign*/
    4 && e(8, u = {
      singleline: w,
      decoration: ee,
      align: l,
      cloud: i,
      "relative-vertical-align": !!(M && Me),
      "has-particles-mask": !!Ne,
      "mask-animated": We
    }), t.$$.dirty[0] & /*fontSize, rootFontSize, lineHeight, letterSpacing, fontWeight, fontFamily, customLineHeight, verticalAlign, cloudBg, hasCloudBg, cloudBgId, colorOverride, color, background, textStyles, border, borderRadius, maskColor, maskSize, maskDensity*/
    1878896760 | t.$$.dirty[1] & /*customVerticalAlign, cloudPadding, $direction, shadow*/
    15 && e(7, c = {
      "font-size": Re(X * 10 / y),
      "line-height": l ? "normal" : I,
      "letter-spacing": P,
      "font-weight": O,
      "font-family": U,
      "vertical-align": M || Me === void 0 ? void 0 : Re(Me * 10 / X),
      top: M && Me !== void 0 ? Re(-Me * 10 / X) : void 0,
      margin: o ? li(cl(o, -10 / X), f) : void 0,
      padding: o ? li(cl(o, 10 / X), f) : void 0,
      filter: Q && i && !J ? `url(#${H})` : a,
      color: nt || me,
      background: tt,
      opacity: Q && i && !J ? ((ot = (te = si(p.background.color)) == null ? void 0 : te.a) != null ? ot : 255) / 255 : void 0,
      /**
      * box-shadow instead of border because:
      * 1) Doesn't take space as border does
      * 2) There should not be a border-radius on line breaks, but there should be a border
      */
      "box-shadow": _e ? `inset 0 0 0 ${Re(_e.width * 10 / X)} ${_e.color}` : void 0,
      "border-radius": s ? Re(s * 10 / X) : void 0,
      "font-feature-settings": p.font_feature_settings || void 0,
      "--divkit-text-mask-color": Ne,
      "--divkit-text-mask-size": Ft,
      "--divkit-text-mask-density": Ve
    });
  }, [
    _,
    g,
    E,
    Q,
    Ne,
    s,
    i,
    c,
    u,
    n,
    le,
    H,
    y,
    p,
    w,
    J,
    M,
    ee,
    X,
    I,
    P,
    O,
    U,
    me,
    nt,
    _e,
    Me,
    tt,
    We,
    Ft,
    Ve,
    a,
    o,
    l,
    f
  ];
}
class Ol extends $r {
  constructor(r) {
    super(), xr(
      this,
      r,
      Q_,
      Z_,
      Vr,
      {
        componentContext: 0,
        text: 1,
        rootFontSize: 12,
        textStyles: 13,
        singleline: 14,
        actions: 2,
        cloudBg: 3,
        cloudBgId: 15,
        customLineHeight: 16
      },
      null,
      [-1, -1]
    );
  }
}
function Ll(t, r, e) {
  return t === "left" || t === "center" || t === "right" || t === "start" || t === "end" ? t === "left" ? r === "ltr" ? "start" : "end" : t === "right" ? r === "ltr" ? "end" : "start" : t : e;
}
function Rl(t, r) {
  return t === "top" || t === "center" || t === "bottom" || t === "baseline" ? t === "top" ? "start" : t === "bottom" ? "end" : t : r;
}
function x_(t) {
  return String(t != null ? t : "");
}
function Vf(t, r) {
  return t === "source_in" || t === "source_atop" || t === "darken" || t === "lighten" || t === "multiply" || t === "screen" ? t : r;
}
function Bl(t, r) {
  let e;
  return function(...n) {
    e !== null && clearTimeout(e), e = setTimeout(() => {
      t.apply(this, n), e = null;
    }, r);
  };
}
function $_(t, r) {
  let e = null;
  const n = () => {
    const a = getComputedStyle(t), l = parseFloat(a.lineHeight);
    t.style.webkitLineClamp = "", t.style.maxHeight = "";
    const u = t.offsetHeight, c = t.scrollHeight;
    let f = Math.max(1, Math.floor(u / l));
    r.maxLines && r.maxLines < f && (f = r.maxLines), c > f * l + 1e-9 && (t.style.webkitLineClamp = String(f), t.style.maxHeight = l * f + "px");
  }, i = Bl(n, 50), o = () => {
    e && (e.disconnect(), e = null);
  }, s = () => {
    if (o(), r.enabled) {
      if (n(), typeof ResizeObserver < "u") {
        e = new ResizeObserver(i);
        const a = t.parentElement;
        a && e.observe(a);
      }
    } else
      t.style.webkitLineClamp = String(r.lineClamp || "");
  };
  return s(), {
    update(a) {
      r = a, s();
    },
    destroy() {
      o();
    }
  };
}
const { Boolean: If } = wi;
function Aa(t, r, e) {
  const n = t.slice();
  return n[71] = r[e], n;
}
function ja(t, r, e) {
  const n = t.slice();
  return n[71] = r[e], n;
}
function Ca(t) {
  let r = (
    /*htmlTag*/
    t[9]
  ), e, n = (
    /*htmlTag*/
    t[9] && Zs(t)
  );
  return {
    c() {
      n && n.c(), e = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, e, o);
    },
    p(i, o) {
      /*htmlTag*/
      i[9] ? r ? Vr(
        r,
        /*htmlTag*/
        i[9]
      ) ? (n.d(1), n = Zs(i), r = /*htmlTag*/
      i[9], n.c(), n.m(e.parentNode, e)) : n.p(i, o) : (n = Zs(i), r = /*htmlTag*/
      i[9], n.c(), n.m(e.parentNode, e)) : r && (n.d(1), n = null, r = /*htmlTag*/
      i[9]);
    },
    i: T,
    o(i) {
      ae(n, i);
    },
    d(i) {
      i && Z(e), n && n.d(i);
    }
  };
}
function ep(t) {
  let r, e, n, i, o;
  return {
    c() {
      r = Be("span"), e = Be("span"), m(e, "class", n = jt("text__image-wrapper", xn, {
        align: (
          /*item*/
          t[71].image.verticalAlign
        ),
        crop: (
          /*customLineHeight*/
          t[11] !== null
        )
      })), m(e, "style", i = Rt({
        width: (
          /*item*/
          t[71].image.width
        ),
        height: (
          /*customLineHeight*/
          t[11] && /*item*/
          t[71].image.verticalAlign !== "baseline" ? (
            /*customLineHeight*/
            t[11] + "em"
          ) : void 0
        )
      })), m(r, "style", o = Rt(
        /*item*/
        t[71].image.wrapperStyle
      ));
    },
    m(s, a) {
      x(s, r, a), Tt(r, e);
    },
    p(s, a) {
      a[0] & /*renderList, customLineHeight*/
      10240 && n !== (n = jt("text__image-wrapper", xn, {
        align: (
          /*item*/
          s[71].image.verticalAlign
        ),
        crop: (
          /*customLineHeight*/
          s[11] !== null
        )
      })) && m(e, "class", n), a[0] & /*renderList, customLineHeight*/
      10240 && i !== (i = Rt({
        width: (
          /*item*/
          s[71].image.width
        ),
        height: (
          /*customLineHeight*/
          s[11] && /*item*/
          s[71].image.verticalAlign !== "baseline" ? (
            /*customLineHeight*/
            s[11] + "em"
          ) : void 0
        )
      })) && m(e, "style", i), a[0] & /*renderList*/
      8192 && o !== (o = Rt(
        /*item*/
        s[71].image.wrapperStyle
      )) && m(r, "style", o);
    },
    i: T,
    o: T,
    d(s) {
      s && Z(r);
    }
  };
}
function tp(t) {
  let r, e, n = (
    /*item*/
    t[71].text && Sa(t)
  );
  return {
    c() {
      n && n.c(), r = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, r, o), e = !0;
    },
    p(i, o) {
      /*item*/
      i[71].text ? n ? (n.p(i, o), o[0] & /*renderList*/
      8192 && K(n, 1)) : (n = Sa(i), n.c(), K(n, 1), n.m(r.parentNode, r)) : n && (_r(), ae(n, 1, 1, () => {
        n = null;
      }), pr());
    },
    i(i) {
      e || (K(n), e = !0);
    },
    o(i) {
      ae(n), e = !1;
    },
    d(i) {
      i && Z(r), n && n.d(i);
    }
  };
}
function Sa(t) {
  let r, e;
  return r = new Ol({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      text: (
        /*item*/
        t[71].text
      ),
      rootFontSize: (
        /*fontSize*/
        t[3]
      ),
      textStyles: (
        /*item*/
        t[71].textStyles
      ),
      singleline: (
        /*singleline*/
        t[8]
      ),
      cloudBg: !0,
      cloudBgId: (
        /*wholeTextCloudBgId*/
        t[14]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*renderList*/
      8192 && (o.text = /*item*/
      n[71].text), i[0] & /*fontSize*/
      8 && (o.rootFontSize = /*fontSize*/
      n[3]), i[0] & /*renderList*/
      8192 && (o.textStyles = /*item*/
      n[71].textStyles), i[0] & /*singleline*/
      256 && (o.singleline = /*singleline*/
      n[8]), i[0] & /*wholeTextCloudBgId*/
      16384 && (o.cloudBgId = /*wholeTextCloudBgId*/
      n[14]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Va(t) {
  let r, e, n, i;
  const o = [tp, ep], s = [];
  function a(l, u) {
    return "text" in /*item*/
    l[71] ? 0 : (
      /*item*/
      l[71].image ? 1 : -1
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function Zs(t) {
  let r, e, n, i, o = lr(
    /*renderList*/
    t[13]
  ), s = [];
  for (let c = 0; c < o.length; c += 1)
    s[c] = Va(ja(t, o, c));
  const a = (c) => ae(s[c], 1, 1, () => {
    s[c] = null;
  });
  let l = [
    {
      class: e = jt("text__inner", xn, {
        .../*innerMods*/
        t[19],
        "cloud-bg": !0
      })
    },
    {
      style: n = Rt({
        .../*style*/
        t[18],
        padding: (
          /*cloudPadding*/
          t[17]
        ),
        filter: (
          /*wholeTextCloudBgId*/
          t[14] ? `url(#${/*wholeTextCloudBgId*/
          t[14]})` : void 0
        ),
        opacity: (
          /*wholeTextCloudBgOpacity*/
          t[15]
        )
      })
    }
  ], u = {};
  for (let c = 0; c < l.length; c += 1)
    u = ui(u, l[c]);
  return {
    c() {
      r = Be(
        /*htmlTag*/
        t[9]
      );
      for (let c = 0; c < s.length; c += 1)
        s[c].c();
      zi(
        /*htmlTag*/
        t[9]
      )(r, u);
    },
    m(c, f) {
      x(c, r, f);
      for (let _ = 0; _ < s.length; _ += 1)
        s[_] && s[_].m(r, null);
      i = !0;
    },
    p(c, f) {
      if (f[0] & /*componentContext, renderList, fontSize, singleline, wholeTextCloudBgId, customLineHeight*/
      26889) {
        o = lr(
          /*renderList*/
          c[13]
        );
        let _;
        for (_ = 0; _ < o.length; _ += 1) {
          const g = ja(c, o, _);
          s[_] ? (s[_].p(g, f), K(s[_], 1)) : (s[_] = Va(g), s[_].c(), K(s[_], 1), s[_].m(r, null));
        }
        for (_r(), _ = o.length; _ < s.length; _ += 1)
          a(_);
        pr();
      }
      zi(
        /*htmlTag*/
        c[9]
      )(r, u = vi(l, [
        (!i || f[0] & /*innerMods*/
        524288 && e !== (e = jt("text__inner", xn, {
          .../*innerMods*/
          c[19],
          "cloud-bg": !0
        }))) && { class: e },
        (!i || f[0] & /*style, cloudPadding, wholeTextCloudBgId, wholeTextCloudBgOpacity*/
        442368 && n !== (n = Rt({
          .../*style*/
          c[18],
          padding: (
            /*cloudPadding*/
            c[17]
          ),
          filter: (
            /*wholeTextCloudBgId*/
            c[14] ? `url(#${/*wholeTextCloudBgId*/
            c[14]})` : void 0
          ),
          opacity: (
            /*wholeTextCloudBgOpacity*/
            c[15]
          )
        }))) && { style: n }
      ]));
    },
    i(c) {
      if (!i) {
        for (let f = 0; f < o.length; f += 1)
          K(s[f]);
        i = !0;
      }
    },
    o(c) {
      s = s.filter(If);
      for (let f = 0; f < s.length; f += 1)
        ae(s[f]);
      i = !1;
    },
    d(c) {
      c && Z(r), gn(s, c);
    }
  };
}
function rp(t) {
  let r, e;
  return r = new Ol({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      text: (
        /*text*/
        t[2]
      ),
      rootFontSize: (
        /*fontSize*/
        t[3]
      ),
      textStyles: (
        /*rootTextStyles*/
        t[7]
      ),
      singleline: (
        /*singleline*/
        t[8]
      ),
      customLineHeight: (
        /*customLineHeight*/
        t[11]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*text*/
      4 && (o.text = /*text*/
      n[2]), i[0] & /*fontSize*/
      8 && (o.rootFontSize = /*fontSize*/
      n[3]), i[0] & /*rootTextStyles*/
      128 && (o.textStyles = /*rootTextStyles*/
      n[7]), i[0] & /*singleline*/
      256 && (o.singleline = /*singleline*/
      n[8]), i[0] & /*customLineHeight*/
      2048 && (o.customLineHeight = /*customLineHeight*/
      n[11]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function np(t) {
  let r, e, n = lr(
    /*renderList*/
    t[13]
  ), i = [];
  for (let s = 0; s < n.length; s += 1)
    i[s] = Da(Aa(t, n, s));
  const o = (s) => ae(i[s], 1, 1, () => {
    i[s] = null;
  });
  return {
    c() {
      for (let s = 0; s < i.length; s += 1)
        i[s].c();
      r = $t();
    },
    m(s, a) {
      for (let l = 0; l < i.length; l += 1)
        i[l] && i[l].m(s, a);
      x(s, r, a), e = !0;
    },
    p(s, a) {
      if (a[0] & /*componentContext, renderList, fontSize, singleline, customLineHeight*/
      10505 | a[1] & /*onImgError*/
      256) {
        n = lr(
          /*renderList*/
          s[13]
        );
        let l;
        for (l = 0; l < n.length; l += 1) {
          const u = Aa(s, n, l);
          i[l] ? (i[l].p(u, a), K(i[l], 1)) : (i[l] = Da(u), i[l].c(), K(i[l], 1), i[l].m(r.parentNode, r));
        }
        for (_r(), l = n.length; l < i.length; l += 1)
          o(l);
        pr();
      }
    },
    i(s) {
      if (!e) {
        for (let a = 0; a < n.length; a += 1)
          K(i[a]);
        e = !0;
      }
    },
    o(s) {
      i = i.filter(If);
      for (let a = 0; a < i.length; a += 1)
        ae(i[a]);
      e = !1;
    },
    d(s) {
      s && Z(r), gn(i, s);
    }
  };
}
function ip(t) {
  let r, e, n, i, o, s, a, l, u, c, f, _, g, y = [
    { class: i = xn.text__image },
    {
      src: o = /*item*/
      t[71].image.url
    },
    {
      loading: s = /*item*/
      t[71].image.preloadRequired ? "eager" : "lazy"
    },
    { decoding: "async" },
    {
      alt: a = /*item*/
      t[71].image.description
    },
    /*item*/
    t[71].image.a11yAttrs,
    {
      style: l = Rt({
        height: (
          /*item*/
          t[71].image.height
        ),
        filter: (
          /*item*/
          t[71].image.svgFilterId ? `url(#${/*item*/
          t[71].image.svgFilterId})` : void 0
        )
      })
    }
  ], p = {};
  for (let w = 0; w < y.length; w += 1)
    p = ui(p, y[w]);
  return {
    c() {
      r = Be("span"), e = Be("span"), n = Be("img"), Di(n, p), m(e, "class", u = jt("text__image-wrapper", xn, {
        align: (
          /*item*/
          t[71].image.verticalAlign
        ),
        crop: (
          /*customLineHeight*/
          t[11] !== null
        )
      })), m(e, "style", c = Rt({
        width: (
          /*item*/
          t[71].image.width
        ),
        height: (
          /*customLineHeight*/
          t[11] && /*item*/
          t[71].image.verticalAlign !== "baseline" ? (
            /*customLineHeight*/
            t[11] + "em"
          ) : void 0
        )
      })), m(r, "style", f = Rt(
        /*item*/
        t[71].image.wrapperStyle
      ));
    },
    m(w, E) {
      x(w, r, E), Tt(r, e), Tt(e, n), _ || (g = Ge(
        n,
        "error",
        /*onImgError*/
        t[39]
      ), _ = !0);
    },
    p(w, E) {
      Di(n, p = vi(y, [
        { class: i },
        E[0] & /*renderList*/
        8192 && !Zn(n.src, o = /*item*/
        w[71].image.url) && { src: o },
        E[0] & /*renderList*/
        8192 && s !== (s = /*item*/
        w[71].image.preloadRequired ? "eager" : "lazy") && { loading: s },
        { decoding: "async" },
        E[0] & /*renderList*/
        8192 && a !== (a = /*item*/
        w[71].image.description) && { alt: a },
        E[0] & /*renderList*/
        8192 && /*item*/
        w[71].image.a11yAttrs,
        E[0] & /*renderList*/
        8192 && l !== (l = Rt({
          height: (
            /*item*/
            w[71].image.height
          ),
          filter: (
            /*item*/
            w[71].image.svgFilterId ? `url(#${/*item*/
            w[71].image.svgFilterId})` : void 0
          )
        })) && { style: l }
      ])), E[0] & /*renderList, customLineHeight*/
      10240 && u !== (u = jt("text__image-wrapper", xn, {
        align: (
          /*item*/
          w[71].image.verticalAlign
        ),
        crop: (
          /*customLineHeight*/
          w[11] !== null
        )
      })) && m(e, "class", u), E[0] & /*renderList, customLineHeight*/
      10240 && c !== (c = Rt({
        width: (
          /*item*/
          w[71].image.width
        ),
        height: (
          /*customLineHeight*/
          w[11] && /*item*/
          w[71].image.verticalAlign !== "baseline" ? (
            /*customLineHeight*/
            w[11] + "em"
          ) : void 0
        )
      })) && m(e, "style", c), E[0] & /*renderList*/
      8192 && f !== (f = Rt(
        /*item*/
        w[71].image.wrapperStyle
      )) && m(r, "style", f);
    },
    i: T,
    o: T,
    d(w) {
      w && Z(r), _ = !1, g();
    }
  };
}
function op(t) {
  let r, e, n = (
    /*item*/
    t[71].text && Ia(t)
  );
  return {
    c() {
      n && n.c(), r = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, r, o), e = !0;
    },
    p(i, o) {
      /*item*/
      i[71].text ? n ? (n.p(i, o), o[0] & /*renderList*/
      8192 && K(n, 1)) : (n = Ia(i), n.c(), K(n, 1), n.m(r.parentNode, r)) : n && (_r(), ae(n, 1, 1, () => {
        n = null;
      }), pr());
    },
    i(i) {
      e || (K(n), e = !0);
    },
    o(i) {
      ae(n), e = !1;
    },
    d(i) {
      i && Z(r), n && n.d(i);
    }
  };
}
function Ia(t) {
  let r, e;
  return r = new Ol({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      text: (
        /*item*/
        t[71].text
      ),
      rootFontSize: (
        /*fontSize*/
        t[3]
      ),
      textStyles: (
        /*item*/
        t[71].textStyles
      ),
      singleline: (
        /*singleline*/
        t[8]
      ),
      actions: (
        /*item*/
        t[71].actions
      ),
      customLineHeight: (
        /*customLineHeight*/
        t[11]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*renderList*/
      8192 && (o.text = /*item*/
      n[71].text), i[0] & /*fontSize*/
      8 && (o.rootFontSize = /*fontSize*/
      n[3]), i[0] & /*renderList*/
      8192 && (o.textStyles = /*item*/
      n[71].textStyles), i[0] & /*singleline*/
      256 && (o.singleline = /*singleline*/
      n[8]), i[0] & /*renderList*/
      8192 && (o.actions = /*item*/
      n[71].actions), i[0] & /*customLineHeight*/
      2048 && (o.customLineHeight = /*customLineHeight*/
      n[11]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Da(t) {
  let r, e, n, i;
  const o = [op, ip], s = [];
  function a(l, u) {
    return "text" in /*item*/
    l[71] ? 0 : (
      /*item*/
      l[71].image ? 1 : -1
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function Qs(t) {
  let r, e, n, i, o, s, a, l, u;
  const c = [np, rp], f = [];
  function _(p, w) {
    return (
      /*renderList*/
      p[13].length ? 0 : 1
    );
  }
  e = _(t), n = f[e] = c[e](t);
  let g = [
    {
      class: i = jt(
        "text__inner",
        xn,
        /*innerMods*/
        t[19]
      )
    },
    {
      style: o = Rt(
        /*style*/
        t[18]
      )
    }
  ], y = {};
  for (let p = 0; p < g.length; p += 1)
    y = ui(y, g[p]);
  return {
    c() {
      r = Be(
        /*htmlTag*/
        t[9]
      ), n.c(), zi(
        /*htmlTag*/
        t[9]
      )(r, y);
    },
    m(p, w) {
      x(p, r, w), f[e].m(r, null), a = !0, l || (u = Fs(s = $_.call(null, r, {
        enabled: (
          /*$jsonAutoEllipsize*/
          t[10]
        ),
        lineClamp: typeof /*lineClamp*/
        t[4] == "number" ? (
          /*lineClamp*/
          t[4]
        ) : void 0,
        maxLines: (
          /*maxLines*/
          t[12]
        )
      })), l = !0);
    },
    p(p, w) {
      let E = e;
      e = _(p), e === E ? f[e].p(p, w) : (_r(), ae(f[E], 1, 1, () => {
        f[E] = null;
      }), pr(), n = f[e], n ? n.p(p, w) : (n = f[e] = c[e](p), n.c()), K(n, 1), n.m(r, null)), zi(
        /*htmlTag*/
        p[9]
      )(r, y = vi(g, [
        (!a || w[0] & /*innerMods*/
        524288 && i !== (i = jt(
          "text__inner",
          xn,
          /*innerMods*/
          p[19]
        ))) && { class: i },
        (!a || w[0] & /*style*/
        262144 && o !== (o = Rt(
          /*style*/
          p[18]
        ))) && { style: o }
      ])), s && zr(s.update) && w[0] & /*$jsonAutoEllipsize, lineClamp, maxLines*/
      5136 && s.update.call(null, {
        enabled: (
          /*$jsonAutoEllipsize*/
          p[10]
        ),
        lineClamp: typeof /*lineClamp*/
        p[4] == "number" ? (
          /*lineClamp*/
          p[4]
        ) : void 0,
        maxLines: (
          /*maxLines*/
          p[12]
        )
      });
    },
    i(p) {
      a || (K(n), a = !0);
    },
    o(p) {
      ae(n), a = !1;
    },
    d(p) {
      p && Z(r), f[e].d(), l = !1, u();
    }
  };
}
function sp(t) {
  let r, e = (
    /*htmlTag*/
    t[9]
  ), n, i, o = (
    /*hasCloudBg*/
    t[6] && Ca(t)
  ), s = (
    /*htmlTag*/
    t[9] && Qs(t)
  );
  return {
    c() {
      o && o.c(), r = wr(), s && s.c(), n = $t();
    },
    m(a, l) {
      o && o.m(a, l), x(a, r, l), s && s.m(a, l), x(a, n, l), i = !0;
    },
    p(a, l) {
      /*hasCloudBg*/
      a[6] ? o ? (o.p(a, l), l[0] & /*hasCloudBg*/
      64 && K(o, 1)) : (o = Ca(a), o.c(), K(o, 1), o.m(r.parentNode, r)) : o && (_r(), ae(o, 1, 1, () => {
        o = null;
      }), pr()), /*htmlTag*/
      a[9] ? e ? Vr(
        e,
        /*htmlTag*/
        a[9]
      ) ? (s.d(1), s = Qs(a), e = /*htmlTag*/
      a[9], s.c(), s.m(n.parentNode, n)) : s.p(a, l) : (s = Qs(a), e = /*htmlTag*/
      a[9], s.c(), s.m(n.parentNode, n)) : e && (s.d(1), s = null, e = /*htmlTag*/
      a[9]);
    },
    i(a) {
      i || (K(o), i = !0);
    },
    o(a) {
      ae(o), ae(s, a), i = !1;
    },
    d(a) {
      a && (Z(r), Z(n)), o && o.d(a), s && s.d(a);
    }
  };
}
function lp(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "text",
        xn,
        /*mods*/
        t[20]
      ) + " " + /*selectable*/
      (t[5] ? ur.root__selectable : ur.root__unselectable),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      containerElement: (
        /*containerElement*/
        t[16]
      ),
      $$slots: { default: [sp] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods, selectable*/
      1048608 && (o.cls = jt(
        "text",
        xn,
        /*mods*/
        n[20]
      ) + " " + /*selectable*/
      (n[5] ? ur.root__selectable : ur.root__unselectable)), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*containerElement*/
      65536 && (o.containerElement = /*containerElement*/
      n[16]), i[0] & /*innerMods, style, htmlTag, $jsonAutoEllipsize, lineClamp, maxLines, renderList, componentContext, fontSize, singleline, customLineHeight, text, rootTextStyles, cloudPadding, wholeTextCloudBgId, wholeTextCloudBgOpacity, hasCloudBg*/
      983005 | i[2] & /*$$scope*/
      16384 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function ap(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee, X, I, P, O, U, me, nt = T, _e = () => (nt(), nt = B(Q, (Ze) => e(52, me = Ze)), Q), Me, tt = T, We = () => (tt(), tt = B(o, (Ze) => e(53, Me = Ze)), o), Ne, Ft = T, Ve = () => (Ft(), Ft = B(i, (Ze) => e(54, Ne = Ze)), i), Oe, Pe = T, yt = () => (Pe(), Pe = B(w, (Ze) => e(55, Oe = Ze)), w), ye, Ke = T, je = () => (Ke(), Ke = B(p, (Ze) => e(56, ye = Ze)), p), te, ot = T, ce = () => (ot(), ot = B(y, (Ze) => e(57, te = Ze)), y), pt, Ct = T, re = () => (Ct(), Ct = B(g, (Ze) => e(58, pt = Ze)), g), $, pe = T, Bt = () => (pe(), pe = B(_, (Ze) => e(59, $ = Ze)), _), De, ft = T, Mt = () => (ft(), ft = B(u, (Ze) => e(60, De = Ze)), u), He, ht = T, qt = () => (ht(), ht = B(f, (Ze) => e(61, He = Ze)), f), fe, Vt = T, be = () => (Vt(), Vt = B(c, (Ze) => e(62, fe = Ze)), c), $e, Ce = T, Xe = () => (Ce(), Ce = B(E, (Ze) => e(10, $e = Ze)), E), Jt, bt = T, Qt = () => (bt(), bt = B(l, (Ze) => e(63, Jt = Ze)), l), rt, ir = T, W = () => (ir(), ir = B(a, (Ze) => e(64, rt = Ze)), a), Et, It = T, Ye = () => (It(), It = B(s, (Ze) => e(65, Et = Ze)), s), L, Le = T, gt = () => (Le(), Le = B(J, (Ze) => e(66, L = Ze)), J), qe, Te = T, cr = () => (Te(), Te = B(n, (Ze) => e(67, qe = Ze)), n);
  t.$$.on_destroy.push(() => nt()), t.$$.on_destroy.push(() => tt()), t.$$.on_destroy.push(() => Ft()), t.$$.on_destroy.push(() => Pe()), t.$$.on_destroy.push(() => Ke()), t.$$.on_destroy.push(() => ot()), t.$$.on_destroy.push(() => Ct()), t.$$.on_destroy.push(() => pe()), t.$$.on_destroy.push(() => ft()), t.$$.on_destroy.push(() => ht()), t.$$.on_destroy.push(() => Vt()), t.$$.on_destroy.push(() => Ce()), t.$$.on_destroy.push(() => bt()), t.$$.on_destroy.push(() => ir()), t.$$.on_destroy.push(() => It()), t.$$.on_destroy.push(() => Le()), t.$$.on_destroy.push(() => Te());
  let { componentContext: ke } = r, { layoutParams: hr = void 0 } = r;
  const ie = Xr(_n), ze = ie.direction;
  mn(t, ze, (Ze) => e(51, U = Ze));
  let Ot = "", Yt = 12, Ht = 1.25, wt = null, Wt = "", Lt, Gt = "", tr = !1, or = "start", mr = "start", zt = "", Ut = "", st = "", et = !1, nr = [], Ar = !1, br = "", yr, jr = [], kr = {}, Ir = "span";
  function gr(Ze, ne, we, it) {
    var he, d;
    let ut = [];
    if (jr.forEach(([G, Ie]) => {
      ie.removeSvgFilter(G, Ie);
    }), jr = [], !(Array.isArray(ne) && ne.length || Array.isArray(we) && we.length && Ze)) {
      e(13, nr = []);
      return;
    }
    const dt = Ze;
    let Cr = ne || [{ start: 0, end: dt.length }], vt = we || [], v = 0, V = [], Y = [];
    Cr.forEach((G) => {
      const Ie = G.start || 0, Je = G.end || Ze.length, ar = {
        top_offset: 0,
        ...G,
        start: Ie,
        end: Je
      };
      Y.push({
        index: Ie,
        range: ar,
        type: "rangeStart",
        isStart: !0
      }), Y.push({
        index: Je,
        range: ar,
        type: "rangeEnd"
      });
    }), vt.forEach((G, Ie) => {
      G.start !== void 0 && G.url && G.start <= dt.length && Y.push({
        index: G.indexing_direction === "reversed" ? Ze.length - G.start : G.start,
        image: G,
        type: "image",
        arrayIndex: Ie
      });
    }), Y.sort((G, Ie) => G.index === Ie.index ? G.type !== Ie.type ? G.type === "image" ? -1 : Ie.type === "image" ? 1 : G.type < Ie.type ? -1 : 1 : G.type === "image" && Ie.type === "image" ? Ie.arrayIndex - G.arrayIndex : G.type === "rangeStart" && Ie.type === "rangeStart" ? G.range.end - Ie.range.end : G.type === "rangeStart" ? 1 : Ie.type === "rangeStart" ? -1 : G.type !== "image" && Ie.type !== "image" ? G.range.start - Ie.range.start : 0 : G.index - Ie.index), Y.forEach((G) => {
      var ar, C, Qe, mt;
      let Ie = G.type === "image" ? null : G.range, Je = G.index;
      if (Je > v) {
        let lt = Object.assign({ ...it }, ...V);
        V.length && V[V.length - 1].start !== v && (lt.top_offset = 0), ut.push({
          text: dt.substring(v, Je),
          textStyles: lt,
          actions: G.type === "rangeEnd" && ((C = (ar = G.range) == null ? void 0 : ar.actions) == null ? void 0 : C.filter(ys)) || void 0
        });
      }
      if (G.type === "rangeStart" && Ie)
        V.push(Ie);
      else if (G.type === "rangeEnd")
        V = V.filter((lt) => lt !== G.range);
      else if (G.type === "image") {
        let lt = Object.assign({ ...it }, ...V), Dt = Re((G.image.width && G.image.width.value || 20) * 10 / (lt.font_size || 12)), sr = Re((G.image.height && G.image.height.value || 20) * 10 / (lt.font_size || 12));
        const Yr = {
          "font-size": Re((Number(lt.font_size) || 12) * 10 / Yt)
        };
        let qr = "";
        const Ur = G.image.tint_color, Vn = Vf(G.image.tint_mode, "source_in");
        if (Ur) {
          const pn = Tr(G.image.tint_color);
          qr = ie.addSvgFilter(pn, Vn), jr.push([pn, Vn]);
        }
        const ue = {}, ln = (Qe = G.image.accessibility) == null ? void 0 : Qe.type, Lr = ((mt = G.image.accessibility) == null ? void 0 : mt.description) || "";
        (ln === "button" || ln === "image") && Lr ? ue.role = ln : (!Lr || ln === "none") && (ue["aria-hidden"] = "true"), ut.push({
          image: {
            url: G.image.url,
            width: Dt,
            height: sr,
            wrapperStyle: Yr,
            svgFilterId: qr,
            preloadRequired: !!G.image.preload_required,
            verticalAlign: G.image.alignment_vertical,
            description: Lr,
            a11yAttrs: ue
          }
        });
      }
      v = Je;
    }), v < dt.length && ut.push({
      text: dt.substring(v),
      textStyles: { ...it }
    }), e(13, nr = ut), e(6, Ar = ut.some((G) => {
      var Ie;
      return "text" in G && ((Ie = G.textStyles.background) == null ? void 0 : Ie.type) === "cloud";
    })), e(14, br = Ar && ut.length === 1 ? ie.genId("text-whole-bg") : ""), e(15, yr = br ? ((d = (he = si(ut[0].textStyles.background.color)) == null ? void 0 : he.a) != null ? d : 255) / 255 : void 0);
  }
  function Er(Ze) {
    Ze.target && "classList" in Ze.target && Ze.target.classList.add(xn.text__image_hidden);
  }
  return bn(() => {
    jr.forEach(([Ze, ne]) => {
      ie.removeSvgFilter(Ze, ne);
    });
  }), t.$$set = (Ze) => {
    "componentContext" in Ze && e(0, ke = Ze.componentContext), "layoutParams" in Ze && e(1, hr = Ze.layoutParams);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & /*componentContext*/
    1 && ke.json && (e(3, Yt = 12), e(40, Ht = 1.25), e(11, wt = null), e(41, Wt = ""), e(12, Lt = void 0), e(4, Gt = ""), e(42, tr = !1), e(43, or = "start"), e(44, mr = "start"), e(45, zt = ""), e(47, st = ""), e(5, et = !1)), t.$$.dirty[0] & /*componentContext*/
    1 && cr(e(37, n = ke.getDerivedFromVars(ke.json.text))), t.$$.dirty[0] & /*componentContext*/
    1 && Ve(e(36, i = ke.getDerivedFromVars(ke.json.ranges))), t.$$.dirty[0] & /*componentContext*/
    1 && We(e(35, o = ke.getDerivedFromVars(ke.json.images))), t.$$.dirty[0] & /*componentContext*/
    1 && Ye(e(34, s = ke.getDerivedFromVars({
      font_size: ke.json.font_size,
      letter_spacing: ke.json.letter_spacing,
      font_weight: ke.json.font_weight,
      font_weight_value: ke.json.font_weight_value,
      font_family: ke.json.font_family,
      text_color: ke.json.text_color,
      underline: ke.json.underline,
      strike: ke.json.strike,
      line_height: ke.json.line_height,
      text_shadow: ke.json.text_shadow,
      font_feature_settings: ke.json.font_feature_settings
    }))), t.$$.dirty[0] & /*componentContext*/
    1 && W(e(33, a = ke.getDerivedFromVars(ke.json.font_size))), t.$$.dirty[0] & /*componentContext*/
    1 && Qt(e(32, l = ke.getDerivedFromVars(ke.json.line_height))), t.$$.dirty[0] & /*componentContext*/
    1 && Mt(e(31, u = ke.getDerivedFromVars(ke.json.max_lines))), t.$$.dirty[0] & /*componentContext*/
    1 && be(e(30, c = ke.getDerivedFromVars(ke.json.text_alignment_horizontal))), t.$$.dirty[0] & /*componentContext*/
    1 && qt(e(29, f = ke.getDerivedFromVars(ke.json.text_alignment_vertical))), t.$$.dirty[0] & /*componentContext*/
    1 && Bt(e(28, _ = ke.getDerivedFromVars(ke.json.text_color))), t.$$.dirty[0] & /*componentContext*/
    1 && re(e(27, g = ke.getDerivedFromVars(ke.json.focused_text_color))), t.$$.dirty[0] & /*componentContext*/
    1 && ce(e(26, y = ke.getDerivedFromVars(ke.json.truncate))), t.$$.dirty[0] & /*componentContext*/
    1 && je(e(25, p = ke.getDerivedFromVars(ke.json.text_gradient))), t.$$.dirty[0] & /*componentContext*/
    1 && yt(e(24, w = ke.getDerivedFromVars(ke.json.selectable))), t.$$.dirty[0] & /*componentContext*/
    1 && Xe(e(23, E = ke.getDerivedFromVars(ke.json.auto_ellipsize))), t.$$.dirty[0] & /*componentContext*/
    1 && _e(e(22, Q = ke.getDerivedFromVars(ke.json.paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && gt(e(21, J = ke.getDerivedFromVars(ke.json.heading_type))), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[2] & /*$jsonText*/
    32 && (typeof ke.json.text == "string" ? e(2, Ot = x_(qe)) : (e(2, Ot = ""), ke.logError(R(new Error("Incorrect text value type"))))), t.$$.dirty[2] & /*$jsonHeadingType*/
    16 && e(9, M = (() => {
      const Ze = L;
      if (Ze && typeof Ze == "string") {
        const ne = Ze.toLowerCase();
        if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(ne))
          return ne;
      }
      return "p";
    })()), t.$$.dirty[0] & /*htmlTag*/
    512 && e(16, Ir = M !== "span" ? "div" : "span"), t.$$.dirty[1] & /*$jsonTextGradient, $direction*/
    34603008) {
      let Ze = "";
      if (ye) {
        const ne = Ns([ye], U);
        ne.image && (Ze = ne.image);
      }
      e(47, st = Ze);
    }
    if (t.$$.dirty[1] & /*gradient*/
    65536 | t.$$.dirty[2] & /*$jsonRootTextStyles*/
    8 && e(7, kr = st ? { ...Et, text_color: "" } : Et), t.$$.dirty[0] & /*fontSize*/
    8 | t.$$.dirty[2] & /*$jsonTextSize*/
    4 && e(3, Yt = Gn(rt, Yt)), t.$$.dirty[0] & /*fontSize*/
    8 | t.$$.dirty[1] & /*lineHeight*/
    512 | t.$$.dirty[2] & /*$jsonLineHeight*/
    2) {
      const Ze = Jt;
      Hn(Ze) ? (e(40, Ht = Number(Ze) / Yt), e(11, wt = Ht)) : e(11, wt = null);
    }
    if (t.$$.dirty[1] & /*$jsonMaxLines*/
    536870912 && e(8, ge = De === 1), t.$$.dirty[0] & /*$jsonAutoEllipsize*/
    1024 | t.$$.dirty[1] & /*$jsonMaxLines, lineHeight*/
    536871424) {
      let Ze = "", ne, we = "", it = !1;
      if (De && De > 1) {
        const ut = Number(De);
        Ze = ut * Ht + "em", ne = ut, we = ut, it = !0;
      } else
        $e && De !== 1 && (it = !0);
      e(41, Wt = Ze), e(12, Lt = ne), e(4, Gt = we), e(42, tr = it);
    }
    if (t.$$.dirty[1] & /*$direction, halign*/
    1052672 | t.$$.dirty[2] & /*$jsonHAlign*/
    1 && e(43, or = Ll(fe, U, or)), t.$$.dirty[1] & /*$jsonVAlign, valign*/
    1073750016 && e(44, mr = Rl(He, mr)), t.$$.dirty[0] & /*text*/
    4 | t.$$.dirty[1] & /*$jsonRanges*/
    8388608 && e(50, le = !Ne || Ot && Ne.length === 1 && Ne[0] && (!Ne[0].start || Ne[0].start === 0) && (!Ne[0].end || typeof Ne[0].end == "number" && Ne[0].end >= Ot.length)), t.$$.dirty[1] & /*gradient, $jsonTextColor, $jsonRanges*/
    276889600 && e(49, H = !!(!st && $) != !!(Ne && Ne[0] && Ne[0].text_color)), t.$$.dirty[1] & /*$jsonMaxLines, isAllTextSameColor, isOnlyOneColorDefined, $jsonTextColor, $jsonRanges, rootTextColor*/
    814497792) {
      let Ze = "";
      De && le && H && (Ze = Tr($ || Ne && Ne[0] && Ne[0].text_color, 1, zt)), e(45, zt = Ze);
    }
    t.$$.dirty[1] & /*$jsonFocusTextColor, focusTextColor*/
    134250496 && e(46, Ut = Tr(pt, 1, Ut)), t.$$.dirty[1] & /*$jsonTruncate*/
    67108864 && e(48, ee = te === "none" ? "none" : ""), t.$$.dirty[0] & /*selectable*/
    32 | t.$$.dirty[1] & /*$jsonSelectable*/
    16777216 && e(5, et = Tn(Oe, et)), t.$$.dirty[0] & /*text, rootTextStyles*/
    132 | t.$$.dirty[1] & /*$jsonRanges, $jsonImages*/
    12582912 && gr(Ot, Ne, Me, kr), t.$$.dirty[0] & /*singleline*/
    256 | t.$$.dirty[1] & /*multiline, halign, valign, truncate, focusTextColor*/
    178176 && e(20, X = {
      singleline: ge,
      multiline: tr,
      halign: or,
      valign: mr,
      truncate: ee,
      "has-focus-color": !!Ut
    }), t.$$.dirty[0] & /*hasCloudBg*/
    64 | t.$$.dirty[1] & /*gradient*/
    65536 && e(19, I = {
      gradient: !!st,
      "has-cloud-bg": Ar
    }), t.$$.dirty[0] & /*fontSize, lineClamp*/
    24 | t.$$.dirty[1] & /*lineHeight, maxHeight, rootTextColor, gradient, focusTextColor*/
    116224 && e(18, P = {
      "font-size": Re(Yt),
      "line-height": Ht,
      "max-height": Wt,
      "-webkit-line-clamp": Gt,
      color: zt,
      "background-image": st,
      "--divkit-text-focus-color": Ut
    }), t.$$.dirty[0] & /*fontSize*/
    8 | t.$$.dirty[1] & /*$jsonPaddings, $direction*/
    3145728 && e(17, O = li(cl(wo(me, {}) || {}, 10 / Yt), U));
  }, [
    ke,
    hr,
    Ot,
    Yt,
    Gt,
    et,
    Ar,
    kr,
    ge,
    M,
    $e,
    wt,
    Lt,
    nr,
    br,
    yr,
    Ir,
    O,
    P,
    I,
    X,
    J,
    Q,
    E,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    i,
    n,
    ze,
    Er,
    Ht,
    Wt,
    tr,
    or,
    mr,
    zt,
    Ut,
    st,
    ee,
    H,
    le,
    U,
    me,
    Me,
    Ne,
    Oe,
    ye,
    te,
    pt,
    $,
    De,
    He,
    fe,
    Jt,
    rt,
    Et,
    L,
    qe
  ];
}
class up extends $r {
  constructor(r) {
    super(), xr(this, r, ap, lp, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1]);
  }
}
const cp = "appkit-container", fp = "appkit-container_wrap", dp = "appkit-container_overflow_visible", _p = "appkit-container_orientation_vertical", pp = "appkit-container_valign_start", hp = "appkit-container_valign_center", gp = "appkit-container_valign_end", mp = "appkit-container_halign_start", bp = "appkit-container_halign_center", yp = "appkit-container_halign_end", wp = "appkit-container_orientation_horizontal", vp = "appkit-container_orientation_overlap", Ta = {
  container: cp,
  container_wrap: fp,
  container_overflow_visible: dp,
  container_orientation_vertical: _p,
  container_valign_start: pp,
  container_valign_center: hp,
  container_valign_end: gp,
  "container_valign_space-between": "appkit-container_valign_space-between",
  "container_valign_space-around": "appkit-container_valign_space-around",
  "container_valign_space-evenly": "appkit-container_valign_space-evenly",
  container_halign_start: mp,
  container_halign_center: bp,
  container_halign_end: yp,
  "container_halign_space-between": "appkit-container_halign_space-between",
  "container_halign_space-around": "appkit-container_halign_space-around",
  "container_halign_space-evenly": "appkit-container_halign_space-evenly",
  container_orientation_horizontal: wp,
  container_orientation_overlap: vp,
  "container_fixed-container": "appkit-container_fixed-container",
  "container_responsive-mobile-vertical": "appkit-container_responsive-mobile-vertical",
  "container_responsive-mobile-horizontal": "appkit-container_responsive-mobile-horizontal",
  "container_responsive-mobile-has-height": "appkit-container_responsive-mobile-has-height",
  "container_responsive-tablet-vertical": "appkit-container_responsive-tablet-vertical",
  "container_responsive-tablet-horizontal": "appkit-container_responsive-tablet-horizontal",
  "container_responsive-tablet-has-height": "appkit-container_responsive-tablet-has-height"
};
function Fa(t) {
  return {
    top: Number(t == null ? void 0 : t.top) || 0,
    right: Number(t == null ? void 0 : t.right) || 0,
    bottom: Number(t == null ? void 0 : t.bottom) || 0,
    left: Number(t == null ? void 0 : t.left) || 0
  };
}
function Ma(t, r, e) {
  const n = ((r == null ? void 0 : r.margins.left) || 0) + ((r == null ? void 0 : r.margins.right) || 0), i = ((r == null ? void 0 : r.margins.top) || 0) + ((r == null ? void 0 : r.margins.bottom) || 0);
  r != null && r.show_at_start && (e ? t.top = r.style.height + i : t.left = r.style.width + n), r != null && r.show_at_end && (e ? t.bottom = r.style.height + i : t.right = r.style.width + n);
}
function kp(t, r, e) {
  const n = {};
  return Ma(n, r, t === "vertical"), Ma(n, e, t === "horizontal"), n;
}
function Ep({
  orientation: t,
  separator: r,
  lineSeparator: e,
  itemSpacing: n,
  lineSpacing: i
}) {
  let o;
  const s = ((r == null ? void 0 : r.margins.left) || 0) + ((r == null ? void 0 : r.margins.right) || 0), a = ((r == null ? void 0 : r.margins.top) || 0) + ((r == null ? void 0 : r.margins.bottom) || 0), l = ((e == null ? void 0 : e.margins.left) || 0) + ((e == null ? void 0 : e.margins.right) || 0), u = ((e == null ? void 0 : e.margins.top) || 0) + ((e == null ? void 0 : e.margins.bottom) || 0);
  return t === "horizontal" ? o = [
    e != null && e.show_between ? e.style.height + u : i,
    r != null && r.show_between ? r.style.width + s : n
  ] : o = [
    r != null && r.show_between ? r.style.height + a : n,
    e != null && e.show_between ? e.style.width + l : i
  ], o.map(Re).join(" ");
}
function Ap(t) {
  var e;
  const r = (e = t.width) == null ? void 0 : e.type;
  return r !== "wrap_content" && r !== "fixed";
}
function jp(t) {
  var e;
  return ((e = t.height) == null ? void 0 : e.type) === "match_parent";
}
function Cp(t, r) {
  return t === "vertical" || t === "horizontal" || t === "overlap" ? t : r;
}
function Sp(t) {
  var r, e, n;
  return {
    width: Kr((r = t.item_width) == null ? void 0 : r.value, 10),
    height: Kr((e = t.item_height) == null ? void 0 : e.value, 10),
    radius: Kr((n = t.corner_radius) == null ? void 0 : n.value, 5)
  };
}
function Vp(t) {
  var e;
  const r = Kr((e = t.radius) == null ? void 0 : e.value, 10) * 2;
  return {
    width: r,
    height: r,
    radius: r
  };
}
function Ip(t, r, e) {
  var l;
  const n = {}, i = r.stroke || (e == null ? void 0 : e.stroke), o = i != null && i.color ? Tr(i.color) : "", s = i != null && i.width ? Number((l = i.width) != null ? l : 1) : "";
  n.width = t.width, n.height = t.height, n.borderRadius = t.radius;
  const a = r.background_color || (e == null ? void 0 : e.color);
  return n.background = Tr(a), o && s && (n.boxShadow = `inset 0 0 0 ${Re(s)} ${o}`), n;
}
function Qn(t, r, e) {
  if (!t || !t.shape || !t.shape.type || !r.includes(t.shape.type) || t.type !== "shape_drawable")
    return e;
  let n;
  if (t.shape.type === "rounded_rectangle")
    n = Sp(t.shape);
  else if (t.shape.type === "circle")
    n = Vp(t.shape);
  else
    return e;
  return Ip(n, t.shape, {
    color: t.color,
    stroke: t.stroke
  });
}
let So;
function Pa() {
  if (typeof document > "u" && (So = !0), So !== void 0)
    return So;
  const t = document.createElement("div");
  return t.style.position = "absolute", t.style.display = "flex", t.style.flexDirection = "column", t.style.gap = "1px", t.appendChild(document.createElement("div")), t.appendChild(document.createElement("div")), document.body.appendChild(t), So = t.scrollHeight === 1, document.body.removeChild(t), So;
}
function Dp(t, r) {
  return t === "top" || t === "center" || t === "bottom" || t === "baseline" || t === "space-between" || t === "space-around" || t === "space-evenly" ? t === "top" ? "start" : t === "bottom" ? "end" : t : r;
}
function Tp(t, r, e) {
  return t === "left" || t === "center" || t === "right" || t === "space-between" || t === "space-around" || t === "space-evenly" || t === "start" || t === "end" ? t === "left" ? r === "ltr" ? "start" : "end" : t === "right" ? r === "ltr" ? "end" : "start" : t : e;
}
function Fp() {
}
function Ji(t) {
  return {
    subscribe(r) {
      return r(t), Fp;
    }
  };
}
function Hl(t, r, e, n) {
  const i = [], o = n.prototypes;
  return o && t.forEach((s, a) => {
    if (s === null || typeof s != "object")
      return;
    const l = r.preparePrototypeVariables(n.data_element_name || "it", s, a);
    let u, c;
    for (let f = 0; f < o.length; ++f) {
      const _ = o[f];
      if (!_.div)
        continue;
      if (_.selector === void 0) {
        u = _.div, c = e.getJsonWithVars(_.id, l);
        break;
      }
      if (e.getJsonWithVars(_.selector, l)) {
        u = _.div, c = e.getJsonWithVars(_.id, l);
        break;
      }
    }
    u && i.push({
      div: u,
      id: c,
      vars: l,
      key: c || { index: a, data: s }
    });
  }), i;
}
const To = {
  "container-separator": "appkit-container-separator",
  "container-separator__item": "appkit-container-separator__item",
  "container-separator__shape": "appkit-container-separator__shape"
};
function Mp(t, r) {
  let e = 0, n, i = !1;
  return function() {
    const o = Date.now();
    return !e || Math.abs(o - e) > r ? (e = o, n = t.apply(this, arguments)) : (i || (i = !0, setTimeout(() => {
      i = !1, n = t.apply(this, arguments);
    }, r)), n);
  };
}
function Pp(t) {
  const r = t.getBoundingClientRect(), e = getComputedStyle(t);
  return {
    top: r.top - parseFloat(e.marginTop),
    right: r.right + parseFloat(e.marginRight),
    bottom: r.bottom + parseFloat(e.marginBottom),
    left: r.left - parseFloat(e.marginLeft)
  };
}
const { window: Np } = wi;
function Na(t, r, e) {
  const n = t.slice();
  return n[16] = r[e], n;
}
function za(t) {
  let r, e, n = `${/*item*/
  t[16].style.width}px`, i = `${/*item*/
  t[16].style.height}px`, o = `${/*item*/
  t[16].style.borderRadius}px`, s, a = `${/*item*/
  t[16].left}px`, l = `${/*item*/
  t[16].top}px`, u = `${/*item*/
  t[16].width}px`, c = `${/*item*/
  t[16].height}px`;
  return {
    c() {
      r = Be("div"), e = Be("div"), s = wr(), m(e, "class", To["container-separator__shape"]), q(e, "width", n), q(e, "height", i), q(e, "border-radius", o), q(
        e,
        "background",
        /*item*/
        t[16].style.background
      ), q(
        e,
        "box-shadow",
        /*item*/
        t[16].style.boxShadow
      ), m(r, "class", To["container-separator__item"]), q(r, "left", a), q(r, "top", l), q(r, "width", u), q(r, "height", c);
    },
    m(f, _) {
      x(f, r, _), Tt(r, e), Tt(r, s);
    },
    p(f, _) {
      _ & /*separators*/
      2 && n !== (n = `${/*item*/
      f[16].style.width}px`) && q(e, "width", n), _ & /*separators*/
      2 && i !== (i = `${/*item*/
      f[16].style.height}px`) && q(e, "height", i), _ & /*separators*/
      2 && o !== (o = `${/*item*/
      f[16].style.borderRadius}px`) && q(e, "border-radius", o), _ & /*separators*/
      2 && q(
        e,
        "background",
        /*item*/
        f[16].style.background
      ), _ & /*separators*/
      2 && q(
        e,
        "box-shadow",
        /*item*/
        f[16].style.boxShadow
      ), _ & /*separators*/
      2 && a !== (a = `${/*item*/
      f[16].left}px`) && q(r, "left", a), _ & /*separators*/
      2 && l !== (l = `${/*item*/
      f[16].top}px`) && q(r, "top", l), _ & /*separators*/
      2 && u !== (u = `${/*item*/
      f[16].width}px`) && q(r, "width", u), _ & /*separators*/
      2 && c !== (c = `${/*item*/
      f[16].height}px`) && q(r, "height", c);
    },
    d(f) {
      f && Z(r);
    }
  };
}
function zp(t) {
  let r, e, n, i = lr(
    /*separators*/
    t[1]
  ), o = [];
  for (let s = 0; s < i.length; s += 1)
    o[s] = za(Na(t, i, s));
  return {
    c() {
      r = Be("div");
      for (let s = 0; s < o.length; s += 1)
        o[s].c();
      m(r, "class", To["container-separator"]);
    },
    m(s, a) {
      x(s, r, a);
      for (let l = 0; l < o.length; l += 1)
        o[l] && o[l].m(r, null);
      t[13](r), e || (n = Ge(
        Np,
        "resize",
        /*throttledUpdated*/
        t[2]
      ), e = !0);
    },
    p(s, [a]) {
      if (a & /*separators*/
      2) {
        i = lr(
          /*separators*/
          s[1]
        );
        let l;
        for (l = 0; l < i.length; l += 1) {
          const u = Na(s, i, l);
          o[l] ? o[l].p(u, a) : (o[l] = za(u), o[l].c(), o[l].m(r, null));
        }
        for (; l < o.length; l += 1)
          o[l].d(1);
        o.length = i.length;
      }
    },
    i: T,
    o: T,
    d(s) {
      s && Z(r), gn(o, s), t[13](null), e = !1, n();
    }
  };
}
const Op = 10;
function xs(t, r, e, n, i, o) {
  const s = r.margins.left, a = r.margins.right, l = r.margins.top, u = r.margins.bottom;
  o ? t.push({
    top: e.bottom + l,
    left: i.left + s,
    width: Math.max(0, i.right - i.left - s - a),
    height: n.top - e.bottom - l - u,
    style: r.style
  }) : t.push({
    top: i.top + l,
    left: e.right + s,
    width: n.left - e.right - s - a,
    height: Math.max(0, i.bottom - i.top - l - u),
    style: r.style
  });
}
function Oa(t, r, e, n, i, o) {
  const s = {
    top: Math.min(...e.map((a) => a.top)),
    right: Math.max(...e.map((a) => a.right)),
    bottom: Math.max(...e.map((a) => a.bottom)),
    left: Math.min(...e.map((a) => a.left))
  };
  if (r != null && r.show_at_start) {
    let a, l;
    i === "space-around" || i === "space-evenly" ? (a = o.left - r.style.width, l = o.top - r.style.height) : (a = e[0].left - r.style.width - r.margins.left - r.margins.right, l = e[0].top - r.style.height - r.margins.top - r.margins.bottom), xs(
      t,
      r,
      // only right and bottom is used
      { right: a, bottom: l },
      e[0],
      s,
      n
    );
  }
  if (r != null && r.show_between)
    for (let a = 0; a < e.length - 1; ++a)
      xs(t, r, e[a], e[a + 1], s, n);
  if (r != null && r.show_at_end) {
    const a = e[e.length - 1];
    let l, u;
    i === "space-around" || i === "space-evenly" ? (l = o.bottom + r.style.height, u = o.right + r.style.width) : (l = a.bottom + r.style.height + r.margins.top + r.margins.bottom, u = a.right + r.style.width + r.margins.left + r.margins.right), xs(
      t,
      r,
      a,
      // only top and left is used
      { top: l, left: u },
      s,
      n
    );
  }
}
function Lp(t, r, e) {
  let n, { orientation: i } = r, { separator: o } = r, { lineSeparator: s } = r, { contentHAlign: a } = r, { contentVAlign: l } = r, { direction: u } = r;
  const c = Mp(E, Op);
  let f = [], _, g = !1, y = null, p = null;
  function w(J) {
    J.some((M) => {
      var le;
      const ge = (le = M.target) == null ? void 0 : le.classList;
      return !(ge != null && ge.contains(To["container-separator__shape"])) && !(ge != null && ge.contains(To["container-separator"]));
    }) && c();
  }
  function E() {
    if (!n)
      return;
    const J = n.getBoundingClientRect(), M = window.getComputedStyle(n), ge = {
      top: J.top + parseFloat(M.paddingTop),
      right: J.right - parseFloat(M.paddingRight),
      bottom: J.bottom - parseFloat(M.paddingBottom),
      left: J.left + parseFloat(M.paddingLeft)
    };
    e(1, f = []);
    let le = [...n.children].filter((X) => X !== _ && X instanceof HTMLElement && !X.classList.contains(gs.outer__border) && getComputedStyle(X).display !== "none"), H = [];
    for (; le.length; ) {
      const X = [], I = le.shift();
      X.push(I);
      let P = I.getBoundingClientRect(), O = P.left, U = P.right, me = P.bottom;
      for (; le.length; ) {
        let nt = le[0], _e = nt.getBoundingClientRect();
        if (i === "vertical") {
          if (_e.top < me)
            break;
        } else if (u === "ltr" ? _e.left < U : _e.right > O)
          break;
        U = Math.max(U, _e.right), O = Math.min(O, _e.left), me = Math.max(me, _e.bottom), X.push(nt), le.shift();
      }
      H.push(X);
    }
    const ee = [];
    H.forEach((X) => {
      const I = X.map((O) => Pp(O));
      u === "rtl" && i === "horizontal" && I.reverse(), o && Oa(
        f,
        o,
        I,
        i === "vertical",
        i === "vertical" ? l : a,
        ge
      );
      const P = {
        top: Math.min(...I.map((O) => O.top)),
        right: Math.max(...I.map((O) => O.right)),
        bottom: Math.max(...I.map((O) => O.bottom)),
        left: Math.min(...I.map((O) => O.left))
      };
      ee.push(P);
    }), u === "rtl" && i === "vertical" && ee.reverse(), s && Oa(
      f,
      s,
      ee,
      i === "horizontal",
      i === "vertical" ? a : l,
      ge
    ), f.forEach((X) => {
      X.top -= J.top, X.left -= J.left;
    });
  }
  Jn(() => {
    e(9, g = !0);
  }), bn(() => {
    e(9, g = !1);
  });
  function Q(J) {
    Or[J ? "unshift" : "push"](() => {
      _ = J, e(0, _);
    });
  }
  return t.$$set = (J) => {
    "orientation" in J && e(3, i = J.orientation), "separator" in J && e(4, o = J.separator), "lineSeparator" in J && e(5, s = J.lineSeparator), "contentHAlign" in J && e(6, a = J.contentHAlign), "contentVAlign" in J && e(7, l = J.contentVAlign), "direction" in J && e(8, u = J.direction);
  }, t.$$.update = () => {
    t.$$.dirty & /*node*/
    1 && e(12, n = (_ == null ? void 0 : _.parentElement) || null), t.$$.dirty & /*mounted, parentElement, mutationObserver, resizeObserver*/
    7680 && (g && n || y || p) && (y && (y.disconnect(), e(10, y = null)), p && (p.disconnect(), e(11, p = null)), g && n && (typeof MutationObserver < "u" && (e(10, y = new MutationObserver(w)), y.observe(n, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    })), typeof ResizeObserver < "u" && (e(11, p = new ResizeObserver(c)), p.observe(n)))), t.$$.dirty & /*mounted, parentElement*/
    4608 && g && n && c();
  }, [
    _,
    f,
    c,
    i,
    o,
    s,
    a,
    l,
    u,
    g,
    y,
    p,
    n,
    Q
  ];
}
class Rp extends $r {
  constructor(r) {
    super(), xr(this, r, Lp, zp, Vr, {
      orientation: 3,
      separator: 4,
      lineSeparator: 5,
      contentHAlign: 6,
      contentVAlign: 7,
      direction: 8
    });
  }
}
const { Boolean: Bp } = wi;
function La(t, r, e) {
  const n = t.slice();
  return n[63] = r[e], n;
}
function Ra(t) {
  let r, e;
  return r = new ti({
    props: {
      componentContext: (
        /*item*/
        t[63]
      ),
      layoutParams: (
        /*childLayoutParams*/
        t[8]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*items*/
      512 && (o.componentContext = /*item*/
      n[63]), i[0] & /*childLayoutParams*/
      256 && (o.layoutParams = /*childLayoutParams*/
      n[8]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Ba(t) {
  let r, e;
  return r = new Rp({
    props: {
      direction: (
        /*$direction*/
        t[10]
      ),
      separator: (
        /*separator*/
        t[5]
      ),
      lineSeparator: (
        /*lineSeparator*/
        t[6]
      ),
      orientation: (
        /*orientation*/
        t[2]
      ),
      contentHAlign: (
        /*contentHAlign*/
        t[4]
      ),
      contentVAlign: (
        /*contentVAlign*/
        t[3]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*$direction*/
      1024 && (o.direction = /*$direction*/
      n[10]), i[0] & /*separator*/
      32 && (o.separator = /*separator*/
      n[5]), i[0] & /*lineSeparator*/
      64 && (o.lineSeparator = /*lineSeparator*/
      n[6]), i[0] & /*orientation*/
      4 && (o.orientation = /*orientation*/
      n[2]), i[0] & /*contentHAlign*/
      16 && (o.contentHAlign = /*contentHAlign*/
      n[4]), i[0] & /*contentVAlign*/
      8 && (o.contentVAlign = /*contentVAlign*/
      n[3]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Hp(t) {
  let r, e, n, i = lr(
    /*items*/
    t[9]
  ), o = [];
  for (let l = 0; l < i.length; l += 1)
    o[l] = Ra(La(t, i, l));
  const s = (l) => ae(o[l], 1, 1, () => {
    o[l] = null;
  });
  let a = (
    /*separator*/
    (t[5] || /*lineSeparator*/
    t[6]) && Ba(t)
  );
  return {
    c() {
      for (let l = 0; l < o.length; l += 1)
        o[l].c();
      r = wr(), a && a.c(), e = $t();
    },
    m(l, u) {
      for (let c = 0; c < o.length; c += 1)
        o[c] && o[c].m(l, u);
      x(l, r, u), a && a.m(l, u), x(l, e, u), n = !0;
    },
    p(l, u) {
      if (u[0] & /*items, childLayoutParams*/
      768) {
        i = lr(
          /*items*/
          l[9]
        );
        let c;
        for (c = 0; c < i.length; c += 1) {
          const f = La(l, i, c);
          o[c] ? (o[c].p(f, u), K(o[c], 1)) : (o[c] = Ra(f), o[c].c(), K(o[c], 1), o[c].m(r.parentNode, r));
        }
        for (_r(), c = i.length; c < o.length; c += 1)
          s(c);
        pr();
      }
      /*separator*/
      l[5] || /*lineSeparator*/
      l[6] ? a ? (a.p(l, u), u[0] & /*separator, lineSeparator*/
      96 && K(a, 1)) : (a = Ba(l), a.c(), K(a, 1), a.m(e.parentNode, e)) : a && (_r(), ae(a, 1, 1, () => {
        a = null;
      }), pr());
    },
    i(l) {
      if (!n) {
        for (let u = 0; u < i.length; u += 1)
          K(o[u]);
        K(a), n = !0;
      }
    },
    o(l) {
      o = o.filter(Bp);
      for (let u = 0; u < o.length; u += 1)
        ae(o[u]);
      ae(a), n = !1;
    },
    d(l) {
      l && (Z(r), Z(e)), gn(o, l), a && a.d(l);
    }
  };
}
function Wp(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "container",
        Ta,
        /*mods*/
        t[12]
      ),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      style: (
        /*style*/
        t[13]
      ),
      additionalPaddings: (
        /*additionalPaddings*/
        t[14]
      ),
      heightByAspect: !!/*aspect*/
      t[7],
      parentOf: (
        /*items*/
        t[9]
      ),
      replaceItems: (
        /*replaceItems*/
        t[31]
      ),
      $$slots: { default: [Hp] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      4096 && (o.cls = jt(
        "container",
        Ta,
        /*mods*/
        n[12]
      )), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*style*/
      8192 && (o.style = /*style*/
      n[13]), i[0] & /*additionalPaddings*/
      16384 && (o.additionalPaddings = /*additionalPaddings*/
      n[14]), i[0] & /*aspect*/
      128 && (o.heightByAspect = !!/*aspect*/
      n[7]), i[0] & /*items*/
      512 && (o.parentOf = /*items*/
      n[9]), i[0] & /*$direction, separator, lineSeparator, orientation, contentHAlign, contentVAlign, items, childLayoutParams*/
      1916 | i[2] & /*$$scope*/
      16 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
const Up = {
  start: "start",
  center: "center",
  end: "end",
  // 'space-*' values doesn't supported for cross-axis in wrap-container
  "space-between": "start",
  "space-around": "start",
  "space-evenly": "start"
}, Gp = {
  start: "start",
  center: "center",
  end: "end",
  baseline: "baseline",
  // 'space-*' doesn't supported for cross-axis in wrap-container
  "space-between": "start",
  "space-around": "start",
  "space-evenly": "start"
}, Ha = ["rounded_rectangle", "circle"];
function Yp(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee, X, I, P, O = T, U = () => (O(), O = B(E, (et) => e(45, P = et)), E), me, nt = T, _e = () => (nt(), nt = B(J, (et) => e(46, me = et)), J), Me, tt = T, We = () => (tt(), tt = B(w, (et) => e(47, Me = et)), w), Ne, Ft = T, Ve = () => (Ft(), Ft = B(p, (et) => e(48, Ne = et)), p), Oe, Pe = T, yt = () => (Pe(), Pe = B(Q, (et) => e(49, Oe = et)), Q), ye, Ke = T, je = () => (Ke(), Ke = B(y, (et) => e(50, ye = et)), y), te, ot = T, ce = () => (ot(), ot = B(f, (et) => e(51, te = et)), f), pt, Ct = T, re = () => (Ct(), Ct = B(c, (et) => e(52, pt = et)), c), $, pe = T, Bt = () => (pe(), pe = B(g, (et) => e(53, $ = et)), g), De, ft = T, Mt = () => (ft(), ft = B(_, (et) => e(54, De = et)), _), He, ht, qt = T, fe = () => (qt(), qt = B(u, (et) => e(55, ht = et)), u), Vt, be = T, $e = () => (be(), be = B(l, (et) => e(56, Vt = et)), l), Ce, Xe = T, Jt = () => (Xe(), Xe = B(cr, (et) => e(57, Ce = et)), cr), bt, Qt = T, rt = () => (Qt(), Qt = B(a, (et) => e(58, bt = et)), a), ir, W = T, Et = () => (W(), W = B(s, (et) => e(59, ir = et)), s), It, Ye = T, L = () => (Ye(), Ye = B(o, (et) => e(60, It = et)), o);
  t.$$.on_destroy.push(() => O()), t.$$.on_destroy.push(() => nt()), t.$$.on_destroy.push(() => tt()), t.$$.on_destroy.push(() => Ft()), t.$$.on_destroy.push(() => Pe()), t.$$.on_destroy.push(() => Ke()), t.$$.on_destroy.push(() => ot()), t.$$.on_destroy.push(() => Ct()), t.$$.on_destroy.push(() => pe()), t.$$.on_destroy.push(() => ft()), t.$$.on_destroy.push(() => qt()), t.$$.on_destroy.push(() => be()), t.$$.on_destroy.push(() => Xe()), t.$$.on_destroy.push(() => Qt()), t.$$.on_destroy.push(() => W()), t.$$.on_destroy.push(() => Ye());
  let { componentContext: Le } = r, { layoutParams: gt = void 0 } = r;
  const qe = Xr(_n), Te = qe.direction;
  mn(t, Te, (et) => e(10, He = et));
  let cr, ke = "vertical", hr = "start", ie = "start", ze = null, Ot = null, Yt, Ht = {}, wt = 0, Wt = 0, Lt = !1;
  function Gt() {
    e(2, ke = "vertical"), e(3, hr = "start"), e(4, ie = "start"), e(7, Yt = void 0), e(32, wt = 0), e(33, Wt = 0), e(34, Lt = !1);
  }
  function tr(et) {
    e(0, Le = e(35, mr = {
      ...Le,
      json: {
        ...Le.json,
        items: et.filter(ki)
      }
    }));
  }
  let or = [], mr, zt = {}, Ut, st;
  return bn(() => {
    or.forEach((et) => {
      et.destroy();
    });
  }), t.$$set = (et) => {
    "componentContext" in et && e(0, Le = et.componentContext), "layoutParams" in et && e(1, gt = et.layoutParams);
  }, t.$$.update = () => {
    var et, nr, Ar, br, yr, jr, kr, Ir, gr, Er, Ze;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(44, n = Le.origJson), t.$$.dirty[1] & /*origJson*/
    8192 && n && Gt(), t.$$.dirty[0] & /*componentContext*/
    1 && e(43, i = Le.json.items), t.$$.dirty[0] & /*componentContext*/
    1 && L(e(29, o = typeof ((et = Le.json.item_builder) == null ? void 0 : et.data) == "string" ? Le.getDerivedFromVars((nr = Le.json.item_builder) == null ? void 0 : nr.data, void 0, !0) : (Ar = Le.json.item_builder) != null && Ar.data ? Ji(Le.json.item_builder.data) : void 0)), t.$$.dirty[0] & /*componentContext*/
    1 && Et(e(28, s = Le.getDerivedFromVars(Le.json.orientation))), t.$$.dirty[0] & /*componentContext*/
    1 && rt(e(27, a = Le.getDerivedFromVars(Le.json.layout_mode))), t.$$.dirty[0] & /*componentContext*/
    1 && $e(e(26, l = Le.getDerivedFromVars(Le.json.content_alignment_vertical))), t.$$.dirty[0] & /*componentContext*/
    1 && fe(e(25, u = Le.getDerivedFromVars(Le.json.content_alignment_horizontal))), t.$$.dirty[0] & /*componentContext*/
    1 && re(e(24, c = Le.getDerivedFromVars(Le.json.separator))), t.$$.dirty[0] & /*componentContext*/
    1 && ce(e(23, f = Le.getDerivedFromVars(Le.json.line_separator))), t.$$.dirty[0] & /*componentContext*/
    1 && Mt(e(22, _ = Le.getDerivedFromVars(Le.json.item_spacing))), t.$$.dirty[0] & /*componentContext*/
    1 && Bt(e(21, g = Le.getDerivedFromVars(Le.json.line_spacing))), t.$$.dirty[0] & /*componentContext*/
    1 && je(e(20, y = Le.getDerivedFromVars(Le.json.aspect))), t.$$.dirty[0] & /*componentContext*/
    1 && Ve(e(19, p = Le.getDerivedFromVars(Le.json.width))), t.$$.dirty[0] & /*componentContext*/
    1 && We(e(18, w = Le.getDerivedFromVars(Le.json.height))), t.$$.dirty[0] & /*componentContext*/
    1 && U(e(17, E = Le.getDerivedFromVars(Le.json.clip_to_bounds))), t.$$.dirty[0] & /*componentContext*/
    1 && yt(e(16, Q = Le.getDerivedFromVars(Le.json.max_width))), t.$$.dirty[0] & /*componentContext*/
    1 && _e(e(15, J = Le.getDerivedFromVars(Le.json.responsive))), t.$$.dirty[0] & /*componentContext, items*/
    513 | t.$$.dirty[1] & /*$jsonItemBuilderData, jsonItems, prevContext*/
    536875024) {
      let ne = [];
      if (Le.json.item_builder && Array.isArray(It) && Array.isArray(Le.json.item_builder.prototypes)) {
        const dt = Le.json.item_builder;
        ne = Hl(It, qe, Le, dt);
      } else
        ne = (Array.isArray(i) && i || []).map((dt, Cr) => ({
          div: dt,
          key: dt.id || { index: Cr, data: dt }
        }));
      const we = new Set(or), it = /* @__PURE__ */ new Map();
      let ut = !1;
      mr === Le && or.forEach((dt) => {
        dt.key && (typeof dt.key == "string" && it.has(dt.key) ? ut || (ut = !0, Le.logError(R(new Error("Duplicate key for child elements inside item_builder"), { additional: { key: dt.key } }))) : it.set(
          typeof dt.key == "string" ? dt.key : dt.key.index,
          dt
        ));
      }), e(9, or = ne.map((dt, Cr) => {
        let vt = !ut && it.get(dt.id), v = it.get(Cr);
        return !vt && !dt.id && typeof dt.key == "object" && typeof (v == null ? void 0 : v.key) == "object" && yo(v.key.data, dt.key.data) && (vt = v), vt ? (we.delete(vt), vt) : Le.produceChildContext(dt.div, {
          path: Cr,
          variables: dt.vars,
          id: dt.id,
          key: dt.key
        });
      }));
      for (const dt of we)
        dt.destroy();
      e(35, mr = Le);
    }
    if (t.$$.dirty[0] & /*items, componentContext*/
    513) {
      let ne = [];
      or.forEach((we) => {
        ne.push(Le.getDerivedFromVars({
          width: we.json.width,
          height: we.json.height
        }));
      }), Jt(e(11, cr = bo(ne, (we) => [...we])));
    }
    if (t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[1] & /*$jsonOrientation*/
    268435456 && e(2, ke = Cp(ir, ke)), t.$$.dirty[1] & /*$jsonLayoutMode*/
    134217728 && e(38, M = bt === "wrap"), t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[1] & /*wrap*/
    128 && e(42, ge = ke !== "horizontal" && !M), t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[1] & /*wrap*/
    128 && e(41, le = ke !== "vertical" && !M), t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[1] & /*$childStore*/
    67108864 && e(40, H = ke === "overlap" && !Ce.every(Ap)), t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[1] & /*$childStore*/
    67108864 && e(39, ee = ke === "overlap" && !Ce.every(jp)), t.$$.dirty[0] & /*contentVAlign*/
    8 | t.$$.dirty[1] & /*$jsonContentVAlign*/
    33554432 && e(3, hr = Dp(Vt, hr)), t.$$.dirty[0] & /*$direction, contentHAlign*/
    1040 | t.$$.dirty[1] & /*$jsonContentHAlign*/
    16777216 && e(4, ie = Tp(ht, He, ie)), t.$$.dirty[1] & /*$jsonItemSpacing, itemSpacing*/
    8388610 && e(32, wt = Kr(De, wt)), t.$$.dirty[1] & /*$jsonLineSpacing, lineSpacing*/
    4194308 && e(33, Wt = Kr($, Wt)), t.$$.dirty[0] & /*orientation, separator, componentContext*/
    37 | t.$$.dirty[1] & /*$jsonSeparator, itemSpacing*/
    2097154)
      if (pt != null && pt.style && ke !== "overlap" && Pa()) {
        const ne = Qn(pt.style, Ha, (ze == null ? void 0 : ze.style) || null);
        ne ? (e(5, ze = {
          show_at_start: !!((br = pt.show_at_start) != null && br),
          show_at_end: !!((yr = pt.show_at_end) != null && yr),
          show_between: !!((jr = pt.show_between) == null || jr),
          style: ne,
          margins: Fa(pt.margins)
        }), ze.show_between && wt && Le.logError(R(new Error("item_spacing will be ignored due to the 'separator' property."), { level: "warn" }))) : e(5, ze = null);
      } else
        e(5, ze = null);
    if (t.$$.dirty[0] & /*orientation, lineSeparator, componentContext*/
    69 | t.$$.dirty[1] & /*$jsonLineSeparator, lineSpacing*/
    1048580)
      if (te != null && te.style && ke !== "overlap" && Pa()) {
        const ne = Qn(te.style, Ha, (Ot == null ? void 0 : Ot.style) || null);
        ne ? (e(6, Ot = {
          show_at_start: !!((kr = te.show_at_start) != null && kr),
          show_at_end: !!((Ir = te.show_at_end) != null && Ir),
          show_between: !!((gr = te.show_between) == null || gr),
          style: ne,
          margins: Fa(te.margins)
        }), Ot.show_between && Wt && Le.logError(R(new Error("line_spacing will be ignored due to the 'line_separator' property."), { level: "warn" }))) : e(6, Ot = null);
      } else
        e(6, Ot = null);
    if (t.$$.dirty[0] & /*separator, lineSeparator, orientation*/
    100 && e(14, X = ze || Ot ? kp(ke, ze, Ot) : null), t.$$.dirty[1] & /*$jsonAspect*/
    524288) {
      const ne = ye == null ? void 0 : ye.ratio;
      ne && Hn(ne) ? e(7, Yt = ne) : e(7, Yt = void 0);
    }
    if (t.$$.dirty[1] & /*$jsonMaxWidth*/
    262144) {
      const ne = Oe == null ? void 0 : Oe.type;
      e(34, Lt = ne === "fixed");
    }
    if (t.$$.dirty[0] & /*orientation, contentHAlign, contentVAlign, layoutParams, aspect, childLayoutParams*/
    414 | t.$$.dirty[1] & /*wrap, $jsonWidth, $jsonHeight, supportWidthWrapContent, supportHeightWrapContent, stretchWidth, stretchHeight*/
    200576) {
      let ne = {};
      ke === "overlap" && (ne.overlapParent = !0), ke !== "horizontal" && (ne.parentHAlign = M ? "start" : Up[ie]), ke !== "vertical" && (ne.parentVAlign = M ? "start" : Gp[hr]);
      const we = (Ne == null ? void 0 : Ne.type) === "wrap_content" || (Ne == null ? void 0 : Ne.type) === "match_parent" && (gt == null ? void 0 : gt.parentHorizontalWrapContent), it = !Me || Me.type === "wrap_content" || Me.type === "match_parent" && (gt == null ? void 0 : gt.parentVerticalWrapContent);
      !ge && we && (ne.parentHorizontalWrapContent = !0), !Yt && !le && it && (ne.parentVerticalWrapContent = !0), we || (ne.parentContainerKnownWidth = !0), it || (ne.parentContainerKnownHeight = !0), ne.stretchWidth = H, ne.stretchHeight = ee, ke === "horizontal" && (ne.parentContainerOrientation = "horizontal"), ke === "vertical" && (ne.parentContainerOrientation = "vertical"), M && (ne.parentContainerWrap = !0), e(8, Ht = Ni(ne, Ht));
    }
    if (t.$$.dirty[0] & /*orientation, contentVAlign, contentHAlign*/
    28 | t.$$.dirty[1] & /*$jsonResponsive, wrap, $jsonClipToBounds, isFixedContainer, responsiveMobileHeight, responsiveTabletHeight*/
    49384) {
      let ne, we;
      if (e(36, Ut = void 0), e(37, st = void 0), me) {
        const it = me == null ? void 0 : me.mobile, ut = me == null ? void 0 : me.tablet;
        if (it != null && it.orientation && (ne = String(it.orientation)), ut != null && ut.orientation && (we = String(ut.orientation)), ((Er = it == null ? void 0 : it.height) == null ? void 0 : Er.type) === "fixed" && it.height.value !== void 0) {
          const dt = Kr(it.height.value, 0);
          e(36, Ut = dt > 0 ? dt : void 0);
        }
        if (((Ze = ut == null ? void 0 : ut.height) == null ? void 0 : Ze.type) === "fixed" && ut.height.value !== void 0) {
          const dt = Kr(ut.height.value, 0);
          e(37, st = dt > 0 ? dt : void 0);
        }
      }
      e(12, zt = {
        orientation: ke,
        valign: hr,
        halign: ie,
        wrap: M,
        overflow: P === !1 || P === 0 ? "visible" : void 0,
        "fixed-container": Lt,
        "responsive-mobile-vertical": ne === "vertical",
        "responsive-mobile-horizontal": ne === "horizontal",
        "responsive-tablet-vertical": we === "vertical",
        "responsive-tablet-horizontal": we === "horizontal",
        "responsive-mobile-has-height": Ut !== void 0,
        "responsive-tablet-has-height": st !== void 0
      });
    }
    t.$$.dirty[0] & /*separator, lineSeparator, orientation, aspect*/
    228 | t.$$.dirty[1] & /*itemSpacing, lineSpacing, responsiveMobileHeight, responsiveTabletHeight*/
    102 && e(13, I = {
      gap: ze || Ot || wt || Wt ? Ep({
        orientation: ke,
        separator: ze,
        lineSeparator: Ot,
        itemSpacing: wt,
        lineSpacing: Wt
      }) : void 0,
      "aspect-ratio": Yt,
      "--responsive-mobile-height": Ut !== void 0 ? Re(Ut) : void 0,
      "--responsive-tablet-height": st !== void 0 ? Re(st) : void 0
    });
  }, [
    Le,
    gt,
    ke,
    hr,
    ie,
    ze,
    Ot,
    Yt,
    Ht,
    or,
    He,
    cr,
    zt,
    I,
    X,
    J,
    Q,
    E,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    Te,
    tr,
    wt,
    Wt,
    Lt,
    mr,
    Ut,
    st,
    M,
    ee,
    H,
    le,
    ge,
    i,
    n,
    P,
    me,
    Me,
    Ne,
    Oe,
    ye,
    te,
    pt,
    $,
    De,
    ht,
    Vt,
    Ce,
    bt,
    ir,
    It
  ];
}
class qp extends $r {
  constructor(r) {
    super(), xr(this, r, Yp, Wp, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1]);
  }
}
const Jp = "appkit-separator", Kp = "appkit-separator_orientation_horizontal", Xp = "appkit-separator_orientation_vertical", Zp = "appkit-separator__inner", fl = {
  separator: Jp,
  separator_orientation_horizontal: Kp,
  separator_orientation_vertical: Xp,
  separator__inner: Zp
};
function Wl(t, r) {
  return t === "vertical" || t === "horizontal" ? t : r;
}
function Wa(t) {
  let r, e;
  return {
    c() {
      r = Be("span"), m(r, "class", fl.separator__inner), m(r, "style", e = Rt(
        /*style*/
        t[3]
      ));
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i & /*style*/
      8 && e !== (e = Rt(
        /*style*/
        n[3]
      )) && m(r, "style", e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function Qp(t) {
  let r, e = (
    /*hasContent*/
    t[4] && Wa(t)
  );
  return {
    c() {
      e && e.c(), r = $t();
    },
    m(n, i) {
      e && e.m(n, i), x(n, r, i);
    },
    p(n, i) {
      /*hasContent*/
      n[4] ? e ? e.p(n, i) : (e = Wa(n), e.c(), e.m(r.parentNode, r)) : e && (e.d(1), e = null);
    },
    d(n) {
      n && Z(r), e && e.d(n);
    }
  };
}
function xp(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "separator",
        fl,
        /*mods*/
        t[2]
      ),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      $$slots: { default: [Qp] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*mods*/
      4 && (o.cls = jt(
        "separator",
        fl,
        /*mods*/
        n[2]
      )), i & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i & /*$$scope, style, hasContent*/
      8216 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function $p(t, r, e) {
  let n, i, o, s, a, l, u, c, f = T, _ = () => (f(), f = B(i, (Q) => e(11, c = Q)), i);
  t.$$.on_destroy.push(() => f());
  let { componentContext: g } = r, { layoutParams: y = void 0 } = r, p = "horizontal", w = "rgba(0,0,0,0.08)";
  function E() {
    e(6, p = "horizontal"), e(7, w = "rgba(0,0,0,0.08)");
  }
  return t.$$set = (Q) => {
    "componentContext" in Q && e(0, g = Q.componentContext), "layoutParams" in Q && e(1, y = Q.layoutParams);
  }, t.$$.update = () => {
    t.$$.dirty & /*componentContext*/
    1 && e(10, n = g.origJson), t.$$.dirty & /*origJson*/
    1024 && n && E(), t.$$.dirty & /*componentContext*/
    1 && _(e(5, i = g.getDerivedFromVars(g.json.delimiter_style))), t.$$.dirty & /*$jsonDelimiterStyle, orientation*/
    2112 && e(6, p = Wl(c == null ? void 0 : c.orientation, p)), t.$$.dirty & /*$jsonDelimiterStyle*/
    2048 && e(4, o = !(c != null && c.color && (c.color === "transparent" || c.color.length === 9 && c.color.indexOf("#00") === 0))), t.$$.dirty & /*$jsonDelimiterStyle, background*/
    2176 && e(7, w = Tr(c == null ? void 0 : c.color, 1, w)), t.$$.dirty & /*orientation*/
    64 && e(9, s = p === "horizontal" ? "100%" : Re(1)), t.$$.dirty & /*orientation*/
    64 && e(8, a = p === "horizontal" ? Re(1) : "100%"), t.$$.dirty & /*background, width, height*/
    896 && e(3, l = { background: w, width: s, height: a }), t.$$.dirty & /*orientation*/
    64 && e(2, u = { orientation: p });
  }, [
    g,
    y,
    u,
    l,
    o,
    i,
    p,
    w,
    a,
    s,
    n,
    c
  ];
}
class eh extends $r {
  constructor(r) {
    super(), xr(this, r, $p, xp, Vr, { componentContext: 0, layoutParams: 1 });
  }
}
const th = "appkit-image", rh = "appkit-image__image", nh = "appkit-image_error", ih = "appkit-image_aspect", oh = "appkit-image_loaded", Fo = {
  image: th,
  "image_is-width-content": "appkit-image_is-width-content",
  "image_is-height-content": "appkit-image_is-height-content",
  image__image: rh,
  image_error: nh,
  "image_is-rtl-mirror": "appkit-image_is-rtl-mirror",
  "image__aspect-wrapper": "appkit-image__aspect-wrapper",
  "image_aspect-content": "appkit-image_aspect-content",
  "image_aspect-valign_top": "appkit-image_aspect-valign_top",
  "image_aspect-valign_bottom": "appkit-image_aspect-valign_bottom",
  image_aspect: ih,
  image_loaded: oh,
  "divkit-image-appearance": "appkit-divkit-image-appearance",
  "image_before-appearance": "appkit-image_before-appearance"
};
function sh(t, r, e) {
  const n = t.content_alignment_horizontal, i = t.content_alignment_vertical;
  return n && n !== "left" && n !== "center" && n !== "right" && n !== "start" && n !== "end" || i && i !== "top" && i !== "center" && i !== "bottom" ? e : jf({
    content_alignment_horizontal: n,
    content_alignment_vertical: i
  }, r);
}
function Df(t) {
  return t.startsWith("data:") ? ll(t) : `data:image/jpg;base64,${ll(t)}`;
}
function lh(t, r, e) {
  let { componentContext: n } = r;
  const i = Xr(_n);
  let o = null;
  function s() {
    o && o.update(n);
  }
  return Jn(() => {
    ms && !n.fakeElement && (o = ms(null, i, n));
  }), Ms(s), bn(() => {
    o && o.destroy();
  }), t.$$set = (a) => {
    "componentContext" in a && e(0, n = a.componentContext);
  }, [n];
}
class ci extends $r {
  constructor(r) {
    super(), xr(this, r, lh, null, Vr, { componentContext: 0 });
  }
}
function ah(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function uh(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "image",
        Fo,
        /*mods*/
        t[11]
      ),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      customDescription: !0,
      $$slots: { default: [dh] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      2048 && (o.cls = jt(
        "image",
        Fo,
        /*mods*/
        n[11]
      )), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*svgFilterId, aspectPaddingTop, aspectPaddingBottom, state, imageUrl, $jsonPreloadRequired, highPrority, style, alt, img, mods*/
      536878844 | i[2] & /*$$scope*/
      8192 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function ch(t) {
  let r, e, n, i, o, s, a, l;
  return {
    c() {
      r = Be("img"), m(r, "class", Fo.image__image), Zn(r.src, e = /*state*/
      t[2] === Xi ? Mo : (
        /*imageUrl*/
        t[3]
      )) || m(r, "src", e), m(r, "loading", n = /*$jsonPreloadRequired*/
      t[29] || /*highPrority*/
      t[9] ? "eager" : "lazy"), m(r, "decoding", i = /*highPrority*/
      t[9] ? "sync" : "async"), m(r, "style", o = Rt(
        /*style*/
        t[10]
      )), m(
        r,
        "alt",
        /*alt*/
        t[12]
      ), m(r, "aria-hidden", s = /*alt*/
      t[12] ? null : "true");
    },
    m(u, c) {
      x(u, r, c), t[70](r), a || (l = [
        Ge(
          r,
          "load",
          /*onLoad*/
          t[31]
        ),
        Ge(
          r,
          "error",
          /*onError*/
          t[32]
        )
      ], a = !0);
    },
    p(u, c) {
      c[0] & /*state, imageUrl*/
      12 && !Zn(r.src, e = /*state*/
      u[2] === Xi ? Mo : (
        /*imageUrl*/
        u[3]
      )) && m(r, "src", e), c[0] & /*$jsonPreloadRequired, highPrority*/
      536871424 && n !== (n = /*$jsonPreloadRequired*/
      u[29] || /*highPrority*/
      u[9] ? "eager" : "lazy") && m(r, "loading", n), c[0] & /*highPrority*/
      512 && i !== (i = /*highPrority*/
      u[9] ? "sync" : "async") && m(r, "decoding", i), c[0] & /*style*/
      1024 && o !== (o = Rt(
        /*style*/
        u[10]
      )) && m(r, "style", o), c[0] & /*alt*/
      4096 && m(
        r,
        "alt",
        /*alt*/
        u[12]
      ), c[0] & /*alt*/
      4096 && s !== (s = /*alt*/
      u[12] ? null : "true") && m(r, "aria-hidden", s);
    },
    d(u) {
      u && Z(r), t[70](null), a = !1, Qr(l);
    }
  };
}
function fh(t) {
  let r, e, n, i, o, s, a, l = `${/*aspectPaddingTop*/
  t[4]}%`, u = `${/*aspectPaddingBottom*/
  t[5]}%`, c, f;
  return {
    c() {
      r = Be("span"), e = Be("img"), m(e, "class", Fo.image__image), Zn(e.src, n = /*state*/
      t[2] === Xi ? Mo : (
        /*imageUrl*/
        t[3]
      )) || m(e, "src", n), m(e, "loading", i = /*$jsonPreloadRequired*/
      t[29] || /*highPrority*/
      t[9] ? "eager" : "lazy"), m(e, "decoding", o = /*highPrority*/
      t[9] ? "sync" : "async"), m(e, "style", s = Rt(
        /*style*/
        t[10]
      )), m(
        e,
        "alt",
        /*alt*/
        t[12]
      ), m(e, "aria-hidden", a = /*alt*/
      t[12] ? null : "true"), m(r, "class", Fo["image__aspect-wrapper"]), q(r, "padding-top", l), q(r, "padding-bottom", u);
    },
    m(_, g) {
      x(_, r, g), Tt(r, e), t[69](e), c || (f = [
        Ge(
          e,
          "load",
          /*onLoad*/
          t[31]
        ),
        Ge(
          e,
          "error",
          /*onError*/
          t[32]
        )
      ], c = !0);
    },
    p(_, g) {
      g[0] & /*state, imageUrl*/
      12 && !Zn(e.src, n = /*state*/
      _[2] === Xi ? Mo : (
        /*imageUrl*/
        _[3]
      )) && m(e, "src", n), g[0] & /*$jsonPreloadRequired, highPrority*/
      536871424 && i !== (i = /*$jsonPreloadRequired*/
      _[29] || /*highPrority*/
      _[9] ? "eager" : "lazy") && m(e, "loading", i), g[0] & /*highPrority*/
      512 && o !== (o = /*highPrority*/
      _[9] ? "sync" : "async") && m(e, "decoding", o), g[0] & /*style*/
      1024 && s !== (s = Rt(
        /*style*/
        _[10]
      )) && m(e, "style", s), g[0] & /*alt*/
      4096 && m(
        e,
        "alt",
        /*alt*/
        _[12]
      ), g[0] & /*alt*/
      4096 && a !== (a = /*alt*/
      _[12] ? null : "true") && m(e, "aria-hidden", a), g[0] & /*aspectPaddingTop*/
      16 && l !== (l = `${/*aspectPaddingTop*/
      _[4]}%`) && q(r, "padding-top", l), g[0] & /*aspectPaddingBottom*/
      32 && u !== (u = `${/*aspectPaddingBottom*/
      _[5]}%`) && q(r, "padding-bottom", u);
    },
    d(_) {
      _ && Z(r), t[69](null), c = !1, Qr(f);
    }
  };
}
function Ua(t) {
  let r;
  function e(o, s) {
    return (
      /*mods*/
      o[11].aspect ? fh : ch
    );
  }
  let n = e(t), i = n(t);
  return {
    c() {
      i.c(), r = $t();
    },
    m(o, s) {
      i.m(o, s), x(o, r, s);
    },
    p(o, s) {
      n === (n = e(o)) && i ? i.p(o, s) : (i.d(1), i = n(o), i && (i.c(), i.m(r.parentNode, r)));
    },
    d(o) {
      o && Z(r), i.d(o);
    }
  };
}
function dh(t) {
  let r = (
    /*svgFilterId*/
    t[6]
  ), e, n = Ua(t);
  return {
    c() {
      n.c(), e = $t();
    },
    m(i, o) {
      n.m(i, o), x(i, e, o);
    },
    p(i, o) {
      o[0] & /*svgFilterId*/
      64 && Vr(r, r = /*svgFilterId*/
      i[6]) ? (n.d(1), n = Ua(i), n.c(), n.m(e.parentNode, e)) : n.p(i, o);
    },
    d(i) {
      i && Z(e), n.d(i);
    }
  };
}
function _h(t) {
  let r, e, n, i;
  const o = [uh, ah], s = [];
  function a(l, u) {
    return (
      /*hasError*/
      l[8] ? -1 : 0
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
const Mo = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", ph = "empty://", hh = "rgba(0,0,0,0.08)", Ui = 0, $s = 1, Xi = 2;
function gh(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee, X, I = T, P = () => (I(), I = B(E, (we) => e(53, X = we)), E), O, U, me = T, nt = () => (me(), me = B(w, (we) => e(55, U = we)), w), _e, Me = T, tt = () => (Me(), Me = B(p, (we) => e(56, _e = we)), p), We, Ne = T, Ft = () => (Ne(), Ne = B(y, (we) => e(57, We = we)), y), Ve, Oe = T, Pe = () => (Oe(), Oe = B(f, (we) => e(58, Ve = we)), f), yt, ye = T, Ke = () => (ye(), ye = B(g, (we) => e(59, yt = we)), g), je, te = T, ot = () => (te(), te = B(_, (we) => e(60, je = we)), _), ce, pt = T, Ct = () => (pt(), pt = B(c, (we) => e(61, ce = we)), c), re, $ = T, pe = () => ($(), $ = B(u, (we) => e(62, re = we)), u), Bt, De = T, ft = () => (De(), De = B(l, (we) => e(63, Bt = we)), l), Mt, He = T, ht = () => (He(), He = B(a, (we) => e(64, Mt = we)), a), qt, fe = T, Vt = () => (fe(), fe = B(s, (we) => e(65, qt = we)), s), be, $e = T, Ce = () => ($e(), $e = B(J, (we) => e(66, be = we)), J), Xe, Jt = T, bt = () => (Jt(), Jt = B(i, (we) => e(67, Xe = we)), i), Qt, rt = T, ir = () => (rt(), rt = B(o, (we) => e(68, Qt = we)), o), W, Et = T, It = () => (Et(), Et = B(Q, (we) => e(29, W = we)), Q);
  t.$$.on_destroy.push(() => I()), t.$$.on_destroy.push(() => me()), t.$$.on_destroy.push(() => Me()), t.$$.on_destroy.push(() => Ne()), t.$$.on_destroy.push(() => Oe()), t.$$.on_destroy.push(() => ye()), t.$$.on_destroy.push(() => te()), t.$$.on_destroy.push(() => pt()), t.$$.on_destroy.push(() => $()), t.$$.on_destroy.push(() => De()), t.$$.on_destroy.push(() => He()), t.$$.on_destroy.push(() => fe()), t.$$.on_destroy.push(() => $e()), t.$$.on_destroy.push(() => Jt()), t.$$.on_destroy.push(() => rt()), t.$$.on_destroy.push(() => Et());
  let { componentContext: Ye } = r, { layoutParams: L = void 0 } = r;
  const Le = Xr(_n), gt = Le.direction;
  mn(t, gt, (we) => e(54, O = we));
  let qe, Te = Ui, cr = !1, ke = hh, hr = !1, ie, ze = "", Ot = "none", Yt = "50% 50%", Ht = "0", wt = "0", Wt = !1, Lt = "center", Gt, tr = "source_in", or = "", mr = "", zt = 0, Ut = 0, st = 0, et = "", nr = "", Ar = !1, br = !1, yr = !1;
  function jr() {
    e(38, Wt = !1), e(36, Ot = "none"), e(37, Yt = "50% 50%"), e(41, tr = "source_in"), e(49, br = !1), e(9, yr = !1);
  }
  function kr(we) {
    e(2, Te = Ui);
  }
  function Ir(we) {
    e(37, Yt = sh(we, O, Yt));
  }
  function gr() {
    Te === Ui && e(2, Te = $s);
  }
  function Er() {
    Te === Ui && e(2, Te = Xi);
  }
  bn(() => {
    Le.removeSvgFilter(Gt, tr);
  });
  function Ze(we) {
    Or[we ? "unshift" : "push"](() => {
      qe = we, e(7, qe);
    });
  }
  function ne(we) {
    Or[we ? "unshift" : "push"](() => {
      qe = we, e(7, qe);
    });
  }
  return t.$$set = (we) => {
    "componentContext" in we && e(0, Ye = we.componentContext), "layoutParams" in we && e(1, L = we.layoutParams);
  }, t.$$.update = () => {
    var we;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(52, n = Ye.origJson), t.$$.dirty[1] & /*origJson*/
    2097152 && n && jr(), t.$$.dirty[0] & /*componentContext*/
    1 && bt(e(28, i = Ye.getDerivedFromVars(Ye.json.image_url))), t.$$.dirty[0] & /*componentContext*/
    1 && ir(e(27, o = Ye.getDerivedFromVars(Ye.json.gif_url))), t.$$.dirty[0] & /*componentContext*/
    1 && Vt(e(26, s = Ye.getDerivedFromVars(Ye.json.width))), t.$$.dirty[0] & /*componentContext*/
    1 && ht(e(25, a = Ye.getDerivedFromVars(Ye.json.height))), t.$$.dirty[0] & /*componentContext*/
    1 && ft(e(24, l = Ye.getDerivedFromVars(Ye.json.preview))), t.$$.dirty[0] & /*componentContext*/
    1 && pe(e(23, u = Ye.getDerivedFromVars(Ye.json.placeholder_color))), t.$$.dirty[0] & /*componentContext*/
    1 && Ct(e(22, c = Ye.getDerivedFromVars(Ye.json.scale))), t.$$.dirty[0] & /*componentContext*/
    1 && Pe(e(21, f = Ye.getDerivedFromVars({
      content_alignment_horizontal: Ye.json.content_alignment_horizontal,
      content_alignment_vertical: Ye.json.content_alignment_vertical
    }))), t.$$.dirty[0] & /*componentContext*/
    1 && ot(e(20, _ = Ye.getDerivedFromVars(Ye.json.accessibility))), t.$$.dirty[0] & /*componentContext*/
    1 && Ke(e(19, g = Ye.getDerivedFromVars(Ye.json.aspect))), t.$$.dirty[0] & /*componentContext*/
    1 && Ft(e(18, y = Ye.getDerivedFromVars(Ye.json.tint_color))), t.$$.dirty[0] & /*componentContext*/
    1 && tt(e(17, p = Ye.getDerivedFromVars(Ye.json.tint_mode))), t.$$.dirty[0] & /*componentContext*/
    1 && nt(e(16, w = Ye.getDerivedFromVars(Ye.json.appearance_animation))), t.$$.dirty[0] & /*componentContext*/
    1 && P(e(15, E = Ye.getDerivedFromVars(Ye.json.filters))), t.$$.dirty[0] & /*componentContext*/
    1 && It(e(14, Q = Ye.getDerivedFromVars(Ye.json.preload_required))), t.$$.dirty[0] & /*componentContext*/
    1 && Ce(e(13, J = Ye.getDerivedFromVars(Ye.json.high_priority_preview_show))), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*isEmpty*/
    4 | t.$$.dirty[2] & /*$jsonGifUrl, $jsonImageUrl*/
    96) {
      let it = Ye.json.type === "gif" ? Qt : Xe;
      e(33, cr = it === ph), cr && (it = Mo), e(3, ie = it);
    }
    if (t.$$.dirty[0] & /*imageUrl*/
    8 && kr(), t.$$.dirty[1] & /*highPriorityPreview*/
    262144 | t.$$.dirty[2] & /*$jsonHighPriorityPreviewShow*/
    16 && e(49, br = Tn(be, br)), t.$$.dirty[0] & /*imageUrl, componentContext*/
    9 && (ie ? e(8, hr = !1) : (e(8, hr = !0), Ye.logError(R(new Error(`Missing "${Ye.json.type === "gif" ? "gif_url" : "image_url"}" for "${Ye.json.type}"`))))), t.$$.dirty[2] & /*$jsonWidth*/
    8 && e(51, M = (qt == null ? void 0 : qt.type) === "wrap_content"), t.$$.dirty[2] & /*$jsonHeight*/
    4 && e(50, ge = (Mt == null ? void 0 : Mt.type) === "wrap_content"), t.$$.dirty[0] & /*state*/
    4 | t.$$.dirty[1] & /*isEmpty, highPriorityPreview*/
    262148 | t.$$.dirty[2] & /*$jsonPreview*/
    2) {
      const it = Bt;
      (Te === Ui || Te === Xi || cr) && it ? (e(35, ze = `url("${Df(it)}")`), e(9, yr = br)) : (e(35, ze = ""), e(9, yr = !1));
    }
    if (t.$$.dirty[0] & /*state*/
    4 | t.$$.dirty[1] & /*isEmpty, placeholderColor*/
    12 | t.$$.dirty[2] & /*$jsonPlaceholderColor*/
    1 && (Te === Ui || Te === Xi || cr ? e(34, ke = Tr(re, 1, ke)) : e(34, ke = "")), t.$$.dirty[1] & /*$jsonScale, scale*/
    1073741856 && e(36, Ot = Af(ce) || Ot), t.$$.dirty[1] & /*$jsonPosition*/
    134217728 && Ir(Ve), t.$$.dirty[1] & /*$jsonA11y*/
    536870912 && e(12, le = (je == null ? void 0 : je.description) || ""), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*$jsonAspect, aspectContent, $jsonPosition*/
    402653312) {
      e(39, Lt = "center"), e(4, Ht = "0"), e(5, wt = "0");
      const it = yt == null ? void 0 : yt.ratio;
      if (it && Hn(it)) {
        const ut = 100 / Number(it);
        e(38, Wt = ((we = Ye.json.width) == null ? void 0 : we.type) === "wrap_content"), Wt ? Ve.content_alignment_vertical === "top" ? (e(5, wt = ut.toFixed(2)), e(39, Lt = "top")) : Ve.content_alignment_vertical === "bottom" ? (e(4, Ht = ut.toFixed(2)), e(39, Lt = "bottom")) : e(4, Ht = e(5, wt = (ut / 2).toFixed(2))) : e(5, wt = ut.toFixed(2));
      } else
        e(5, wt = "0");
    }
    if (t.$$.dirty[1] & /*$jsonTintColor, $jsonTintMode, tintMode, tintColor*/
    100664832) {
      const it = We, ut = it ? Tr(it) : void 0, dt = Vf(_e, tr);
      (ut !== Gt || dt !== tr) && (Le.removeSvgFilter(Gt, tr), e(6, or = ut ? Le.addSvgFilter(ut, dt) : ""), e(40, Gt = ut), e(41, tr = dt));
    }
    if (t.$$.dirty[1] & /*$jsonAppearanceAnimation*/
    16777216 && U && U.type === "fade") {
      const it = U;
      e(42, mr = Cf(it.interpolator, "ease_in_out").replace(/_/g, "-")), e(45, st = Kr(it.duration, 300)), e(44, Ut = Kr(it.start_delay, 0)), e(43, zt = Kr(it.alpha, 0));
    }
    if (t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*$jsonFilters, $direction*/
    12582912) {
      let it = "", ut = "";
      Array.isArray(X) && X.length && (it = Sf(X, Ye.logError)), it && (ut = "polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%)"), e(46, et = it), e(47, nr = ut), e(48, Ar = O === "rtl" && Array.isArray(X) && X.some((dt) => dt.type === "rtl_mirror"));
    }
    t.$$.dirty[0] & /*aspectPaddingBottom, aspectPaddingTop, state*/
    52 | t.$$.dirty[1] & /*aspectContent, aspectContentVAlign, isWidthContent, isHeightContent, animationInterpolator, isRTLMirror*/
    1706368 && e(11, H = {
      aspect: wt !== "0" || Ht !== "0",
      "aspect-content": Wt,
      "aspect-valign": Lt !== "center" ? Lt : void 0,
      "is-width-content": M,
      "is-height-content": ge,
      loaded: Te === $s,
      "before-appearance": !!mr && Te === Ui,
      "is-rtl-mirror": Ar
    }), t.$$.dirty[0] & /*state, svgFilterId*/
    68 | t.$$.dirty[1] & /*backgroundImage, placeholderColor, scale, filterClipPath, position, filter, animationInterpolator, animationFadeStart, animationDelay, animationDuration*/
    129144 && e(10, ee = {
      // Image preview shows, if loading of original image is failed
      "background-image": ze,
      "background-color": ze ? void 0 : ke,
      "background-size": Ot,
      "clip-path": nr || void 0,
      "object-fit": Ot,
      "object-position": Yt,
      filter: [
        Te === $s && or ? `url(#${or})` : "",
        et
      ].filter(Boolean).join(" "),
      "--divkit-appearance-interpolator": mr || void 0,
      "--divkit-appearance-fade-start": mr ? zt : void 0,
      "--divkit-appearance-delay": mr ? `${Ut}ms` : void 0,
      "--divkit-appearance-duration": mr ? `${st}ms` : void 0
    });
  }, [
    Ye,
    L,
    Te,
    ie,
    Ht,
    wt,
    or,
    qe,
    hr,
    yr,
    ee,
    H,
    le,
    J,
    Q,
    E,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    i,
    W,
    gt,
    gr,
    Er,
    cr,
    ke,
    ze,
    Ot,
    Yt,
    Wt,
    Lt,
    Gt,
    tr,
    mr,
    zt,
    Ut,
    st,
    et,
    nr,
    Ar,
    br,
    ge,
    M,
    n,
    X,
    O,
    U,
    _e,
    We,
    Ve,
    yt,
    je,
    ce,
    re,
    Bt,
    Mt,
    qt,
    be,
    Xe,
    Qt,
    Ze,
    ne
  ];
}
class Ga extends $r {
  constructor(r) {
    super(), xr(this, r, gh, _h, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1]);
  }
}
const mh = "appkit-grid", bh = "appkit-grid_halign_start", yh = "appkit-grid_halign_center", wh = "appkit-grid_halign_end", vh = "appkit-grid_valign_start", kh = "appkit-grid_valign_center", Eh = "appkit-grid_valign_end", Ya = {
  grid: mh,
  grid_halign_start: bh,
  grid_halign_center: yh,
  grid_halign_end: wh,
  grid_valign_start: vh,
  grid_valign_center: kh,
  grid_valign_end: Eh
};
function qa(t) {
  return t > 0 && t < 1;
}
function Ja(t) {
  return String(Math.ceil(t * 1e3) / 1e3);
}
function Ka(t, r, e, n) {
  if (t.some(qa)) {
    const l = Math.max(...t.filter(qa).map((u) => 1 / u));
    t = t.map((u) => u * l);
  }
  const i = t.every(Boolean);
  let o = 0, s = 0;
  const a = [];
  if (i) {
    s = t.reduce((l, u) => l + u, 0);
    for (let l = 0; l < n; ++l) {
      if (!r[l])
        continue;
      const u = r[l] / t[l] * s;
      u > o && (o = u);
    }
  }
  for (let l = 0; l < n; ++l)
    o && !e[l] ? a[l] = `minmax(${Re(o * t[l] / s)},${Ja(t[l])}fr)` : i || !e[l] && t[l] ? a[l] = `${Ja(t[l])}fr` : a[l] = "auto";
  return a.join(" ");
}
function Xa(t, r, e) {
  const n = t.slice();
  return n[33] = r[e], n;
}
function Ah(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function jh(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "grid",
        Ya,
        /*mods*/
        t[7]
      ),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      style: (
        /*style*/
        t[6]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      parentOf: (
        /*items*/
        t[2]
      ),
      replaceItems: (
        /*replaceItems*/
        t[12]
      ),
      $$slots: { default: [Ch] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      128 && (o.cls = jt(
        "grid",
        Ya,
        /*mods*/
        n[7]
      )), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*style*/
      64 && (o.style = /*style*/
      n[6]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*items*/
      4 && (o.parentOf = /*items*/
      n[2]), i[0] & /*resultItems*/
      32 | i[1] & /*$$scope*/
      32 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Za(t) {
  let r, e;
  return r = new ti({
    props: {
      componentContext: (
        /*item*/
        t[33].componentContext
      ),
      layoutParams: (
        /*item*/
        t[33].layoutParams
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*resultItems*/
      32 && (o.componentContext = /*item*/
      n[33].componentContext), i[0] & /*resultItems*/
      32 && (o.layoutParams = /*item*/
      n[33].layoutParams), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Ch(t) {
  let r, e, n = lr(
    /*resultItems*/
    t[5]
  ), i = [];
  for (let s = 0; s < n.length; s += 1)
    i[s] = Za(Xa(t, n, s));
  const o = (s) => ae(i[s], 1, 1, () => {
    i[s] = null;
  });
  return {
    c() {
      for (let s = 0; s < i.length; s += 1)
        i[s].c();
      r = $t();
    },
    m(s, a) {
      for (let l = 0; l < i.length; l += 1)
        i[l] && i[l].m(s, a);
      x(s, r, a), e = !0;
    },
    p(s, a) {
      if (a[0] & /*resultItems*/
      32) {
        n = lr(
          /*resultItems*/
          s[5]
        );
        let l;
        for (l = 0; l < n.length; l += 1) {
          const u = Xa(s, n, l);
          i[l] ? (i[l].p(u, a), K(i[l], 1)) : (i[l] = Za(u), i[l].c(), K(i[l], 1), i[l].m(r.parentNode, r));
        }
        for (_r(), l = n.length; l < i.length; l += 1)
          o(l);
        pr();
      }
    },
    i(s) {
      if (!e) {
        for (let a = 0; a < n.length; a += 1)
          K(i[a]);
        e = !0;
      }
    },
    o(s) {
      i = i.filter(Boolean);
      for (let a = 0; a < i.length; a += 1)
        ae(i[a]);
      e = !1;
    },
    d(s) {
      s && Z(r), gn(i, s);
    }
  };
}
function Sh(t) {
  let r, e, n, i;
  const o = [jh, Ah], s = [];
  function a(l, u) {
    return (
      /*hasError*/
      l[3] ? -1 : 0
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function Vh(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _ = T, g = () => (_(), _ = B(a, (je) => e(27, f = je)), a), y, p = T, w = () => (p(), p = B(s, (je) => e(28, y = je)), s), E, Q = T, J = () => (Q(), Q = B(U, (je) => e(29, E = je)), U), M, ge = T, le = () => (ge(), ge = B(o, (je) => e(30, M = je)), o);
  t.$$.on_destroy.push(() => _()), t.$$.on_destroy.push(() => p()), t.$$.on_destroy.push(() => Q()), t.$$.on_destroy.push(() => ge());
  let { componentContext: H } = r, { layoutParams: ee = void 0 } = r;
  const I = Xr(_n).direction;
  mn(t, I, (je) => e(26, c = je));
  let P = !1, O = 0, U, me, nt = [], _e = [], Me = [], tt = [], We = [], Ne = [], Ft = 0, Ve = "start", Oe = "start", Pe = [], yt;
  function ye() {
    e(3, P = !1), e(13, O = 0), e(21, Ve = "start"), e(22, Oe = "start");
  }
  function Ke(je) {
    e(0, H = e(23, yt = {
      ...H,
      json: {
        ...H.json,
        items: je.filter(ki)
      }
    }));
  }
  return bn(() => {
    Pe.forEach((je) => {
      je.destroy();
    });
  }), t.$$set = (je) => {
    "componentContext" in je && e(0, H = je.componentContext), "layoutParams" in je && e(1, ee = je.layoutParams);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(25, n = H.origJson), t.$$.dirty[0] & /*origJson*/
    33554432 && n && ye(), t.$$.dirty[0] & /*componentContext*/
    1 && e(24, i = Array.isArray(H.json.items) && H.json.items || []), t.$$.dirty[0] & /*componentContext*/
    1 && le(e(10, o = H.getDerivedFromVars(H.json.column_count))), t.$$.dirty[0] & /*componentContext*/
    1 && w(e(9, s = H.getDerivedFromVars(H.json.content_alignment_vertical))), t.$$.dirty[0] & /*componentContext*/
    1 && g(e(8, a = H.getDerivedFromVars(H.json.content_alignment_horizontal))), t.$$.dirty[0] & /*$jsonColumnCount, columnCount, componentContext*/
    1073750017 && (e(13, O = Gn(M, O)), O < 1 ? (e(3, P = !0), H.logError(R(new Error("Incorrect column_count for grid")))) : e(3, P = !1)), t.$$.dirty[0] & /*items, prevContext, componentContext, jsonItems*/
    25165829) {
      const je = new Set(Pe), te = /* @__PURE__ */ new Map();
      yt === H && Pe.forEach((ot) => {
        te.set(ot.json, ot);
      }), e(2, Pe = i.map((ot, ce) => {
        const pt = te.get(ot);
        return pt ? (je.delete(pt), pt) : H.produceChildContext(ot, { path: ce });
      }));
      for (const ot of je)
        ot.destroy();
      e(23, yt = H);
    }
    if (t.$$.dirty[0] & /*items, componentContext*/
    5) {
      let je = [];
      Pe.forEach((te) => {
        je.push(H.getDerivedFromVars({
          rowSpan: te.json.row_span,
          columnSpan: te.json.column_span,
          width: te.json.width,
          height: te.json.height
        }));
      }), J(e(4, U = bo(je, (te) => [...te])));
    }
    if (t.$$.dirty[0] & /*items, $childStore, columnCount, columnsWeight, rowsWeight, columnsMinWidth, rowsMinHeight*/
    537124868) {
      const je = {};
      let te = 0, ot = 0;
      e(14, nt = []), e(15, _e = []), e(16, Me = []), e(17, tt = []), e(18, We = []), e(19, Ne = []);
      let ce = 0;
      e(5, me = Pe.map((pt, Ct) => {
        var ht, qt, fe, Vt;
        const re = E[Ct], $ = Math.min(O, Number(re.columnSpan) || 1), pe = Number(re.rowSpan) || 1, Bt = ((ht = re.width) == null ? void 0 : ht.type) === "match_parent" ? Number(re.width.weight || 1) / $ : 0, De = ((qt = re.height) == null ? void 0 : qt.type) === "match_parent" ? Number(re.height.weight || 1) / pe : 0, ft = ((fe = re.width) == null ? void 0 : fe.type) === "fixed" && re.width.value ? Number(re.width.value) / $ : 0, Mt = ((Vt = re.height) == null ? void 0 : Vt.type) === "fixed" && re.height.value ? Number(re.height.value) / pe : 0;
        for (; ; ) {
          let be = !0;
          e:
            for (let $e = te; $e < te + $; ++$e)
              for (let Ce = ot; Ce < ot + pe; ++Ce)
                if (je[$e + "_" + Ce]) {
                  be = !1;
                  break e;
                }
          if (be)
            break;
          ++te, te > O - $ && (te = 0, ++ot);
        }
        const He = { x: te, y: ot, colSpan: $, rowSpan: pe };
        for (let be = te; be < te + $; ++be)
          for (let $e = ot; $e < ot + pe; ++$e)
            je[be + "_" + $e] = !0, (!nt[be] || nt[be] < Bt) && e(14, nt[be] = Bt, nt), (!_e[$e] || _e[$e] < De) && e(15, _e[$e] = De, _e), $ === 1 && (!Me[be] || Me[be] < ft) && e(16, Me[be] = ft, Me), pe === 1 && (!tt[$e] || tt[$e] < Mt) && e(17, tt[$e] = Mt, tt), $ === 1 && ft && e(18, We[be] = ft, We), pe === 1 && Mt && e(19, Ne[be] = Mt, Ne);
        return ce = Math.max(ce, ot + pe), {
          componentContext: pt,
          layoutParams: { gridArea: He }
        };
      })), e(20, Ft = Math.max(ot + 1, ce));
    }
    t.$$.dirty[0] & /*$jsonContentVAlign, contentVAlign*/
    270532608 && e(21, Ve = Rl(y, Ve)), t.$$.dirty[0] & /*$jsonContentHAlign, $direction, contentHAlign*/
    205520896 && e(22, Oe = Ll(f, c, Oe)), t.$$.dirty[0] & /*contentVAlign, contentHAlign*/
    6291456 && e(7, l = {
      valign: Ve,
      halign: Oe
    }), t.$$.dirty[0] & /*columnsWeight, columnsMinWidth, columnsWidth, columnCount, rowsWeight, rowsMinHeight, rowsHeight, rowCount*/
    2088960 && e(6, u = {
      "grid-template-columns": Ka(nt, Me, We, O),
      "grid-template-rows": Ka(_e, tt, Ne, Ft)
    });
  }, [
    H,
    ee,
    Pe,
    P,
    U,
    me,
    u,
    l,
    a,
    s,
    o,
    I,
    Ke,
    O,
    nt,
    _e,
    Me,
    tt,
    We,
    Ne,
    Ft,
    Ve,
    Oe,
    yt,
    i,
    n,
    c,
    f,
    y,
    E,
    M
  ];
}
class Ih extends $r {
  constructor(r) {
    super(), xr(this, r, Vh, Sh, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1]);
  }
}
const Dh = "appkit-gallery", Th = "appkit-gallery__scroller", Fh = "appkit-gallery_scrollbar_none", Mh = "appkit-gallery_orientation_horizontal", Ph = "appkit-gallery_orientation_vertical", Nh = "appkit-gallery__items", zh = "appkit-gallery__arrow", oi = {
  gallery: Dh,
  gallery__scroller: Th,
  gallery_scrollbar_none: Fh,
  gallery_orientation_horizontal: Mh,
  gallery_orientation_vertical: Ph,
  "gallery_scroll-snap": "appkit-gallery_scroll-snap",
  "gallery__items-grid": "appkit-gallery__items-grid",
  gallery__items: Nh,
  gallery__arrow: zh,
  "gallery__arrow-icon-path": "appkit-gallery__arrow-icon-path"
}, Oh = "appkit-arrow", Lh = "appkit-arrow__icon", Rh = "appkit-arrow_left", Bh = "appkit-arrow_right", $n = {
  arrow: Oh,
  arrow__icon: Lh,
  arrow_left: Rh,
  arrow_right: Bh
};
function Hh(t, r) {
  return t === "start" || t === "center" || t === "end" ? t : r;
}
function Wh(t) {
  const r = [];
  let e = t[0], n = 1;
  for (let i = 1; i <= t.length; i++)
    t[i] !== e ? (r.push(n > 1 ? `repeat(${n}, ${e})` : e), e = t[i], n = 1) : n++;
  return r.join(" ");
}
function pi(t, r) {
  let e = t % r;
  return e < 0 && (e += r), e;
}
const { Boolean: Tf } = wi;
function Qa(t, r, e) {
  const n = t.slice();
  return n[82] = r[e], n[83] = r, n[84] = e, n;
}
function xa(t, r, e) {
  const n = t.slice();
  return n[85] = r[e], n;
}
function $a(t) {
  let r;
  return {
    c() {
      r = Be("div"), m(r, "class", oi.gallery__gap), q(
        r,
        "width",
        /*orientation*/
        t[4] === "horizontal" ? (
          /*gridGap*/
          t[12]
        ) : void 0
      ), q(
        r,
        "height",
        /*orientation*/
        t[4] !== "horizontal" ? (
          /*gridGap*/
          t[12]
        ) : void 0
      );
    },
    m(e, n) {
      x(e, r, n);
    },
    p(e, n) {
      n[0] & /*orientation, gridGap*/
      4112 && q(
        r,
        "width",
        /*orientation*/
        e[4] === "horizontal" ? (
          /*gridGap*/
          e[12]
        ) : void 0
      ), n[0] & /*orientation, gridGap*/
      4112 && q(
        r,
        "height",
        /*orientation*/
        e[4] !== "horizontal" ? (
          /*gridGap*/
          e[12]
        ) : void 0
      );
    },
    d(e) {
      e && Z(r);
    }
  };
}
function eu(t) {
  let r, e, n, i = (
    /*item*/
    t[85].hasGapBefore && $a(t)
  );
  return e = new ti({
    props: {
      componentContext: (
        /*item*/
        t[85].componentContext
      ),
      layoutParams: (
        /*childLayoutParams*/
        t[6]
      )
    }
  }), {
    c() {
      i && i.c(), r = wr(), Zt(e.$$.fragment);
    },
    m(o, s) {
      i && i.m(o, s), x(o, r, s), Kt(e, o, s), n = !0;
    },
    p(o, s) {
      /*item*/
      o[85].hasGapBefore ? i ? i.p(o, s) : (i = $a(o), i.c(), i.m(r.parentNode, r)) : i && (i.d(1), i = null);
      const a = {};
      s[0] & /*itemsGrid*/
      262144 && (a.componentContext = /*item*/
      o[85].componentContext), s[0] & /*childLayoutParams*/
      64 && (a.layoutParams = /*childLayoutParams*/
      o[6]), e.$set(a);
    },
    i(o) {
      n || (K(e.$$.fragment, o), n = !0);
    },
    o(o) {
      ae(e.$$.fragment, o), n = !1;
    },
    d(o) {
      o && Z(r), i && i.d(o), Xt(e, o);
    }
  };
}
function tu(t) {
  let r, e, n, i, o, s, a = (
    /*rowIndex*/
    t[84]
  ), l, u = lr(
    /*itemsRow*/
    t[82]
  ), c = [];
  for (let y = 0; y < u.length; y += 1)
    c[y] = eu(xa(t, u, y));
  const f = (y) => ae(c[y], 1, 1, () => {
    c[y] = null;
  }), _ = () => (
    /*div1_binding*/
    t[68](r, a)
  ), g = () => (
    /*div1_binding*/
    t[68](null, a)
  );
  return {
    c() {
      r = Be("div");
      for (let y = 0; y < c.length; y += 1)
        c[y].c();
      e = wr(), n = Be("div"), o = wr(), m(n, "style", i = Rt(
        /*lastPaddingSize*/
        t[13]
      )), m(r, "class", oi.gallery__items), m(r, "style", s = Rt(
        /*columnStyle*/
        t[16]
      ));
    },
    m(y, p) {
      x(y, r, p);
      for (let w = 0; w < c.length; w += 1)
        c[w] && c[w].m(r, null);
      Tt(r, e), Tt(r, n), Tt(r, o), _(), l = !0;
    },
    p(y, p) {
      if (t = y, p[0] & /*itemsGrid, childLayoutParams, orientation, gridGap*/
      266320) {
        u = lr(
          /*itemsRow*/
          t[82]
        );
        let w;
        for (w = 0; w < u.length; w += 1) {
          const E = xa(t, u, w);
          c[w] ? (c[w].p(E, p), K(c[w], 1)) : (c[w] = eu(E), c[w].c(), K(c[w], 1), c[w].m(r, e));
        }
        for (_r(), w = u.length; w < c.length; w += 1)
          f(w);
        pr();
      }
      (!l || p[0] & /*lastPaddingSize*/
      8192 && i !== (i = Rt(
        /*lastPaddingSize*/
        t[13]
      ))) && m(n, "style", i), (!l || p[0] & /*columnStyle*/
      65536 && s !== (s = Rt(
        /*columnStyle*/
        t[16]
      ))) && m(r, "style", s), a !== /*rowIndex*/
      t[84] && (g(), a = /*rowIndex*/
      t[84], _());
    },
    i(y) {
      if (!l) {
        for (let p = 0; p < u.length; p += 1)
          K(c[p]);
        l = !0;
      }
    },
    o(y) {
      c = c.filter(Tf);
      for (let p = 0; p < c.length; p += 1)
        ae(c[p]);
      l = !1;
    },
    d(y) {
      y && Z(r), gn(c, y), g();
    }
  };
}
function ru(t) {
  let r, e, n = (
    /*hasScrollLeft*/
    t[10] && /*shouldCheckArrows*/
    t[8] && nu(t)
  ), i = (
    /*hasScrollRight*/
    t[11] && /*shouldCheckArrows*/
    t[8] && iu(t)
  );
  return {
    c() {
      n && n.c(), r = wr(), i && i.c(), e = $t();
    },
    m(o, s) {
      n && n.m(o, s), x(o, r, s), i && i.m(o, s), x(o, e, s);
    },
    p(o, s) {
      /*hasScrollLeft*/
      o[10] && /*shouldCheckArrows*/
      o[8] ? n ? n.p(o, s) : (n = nu(o), n.c(), n.m(r.parentNode, r)) : n && (n.d(1), n = null), /*hasScrollRight*/
      o[11] && /*shouldCheckArrows*/
      o[8] ? i ? i.p(o, s) : (i = iu(o), i.c(), i.m(e.parentNode, e)) : i && (i.d(1), i = null);
    },
    d(o) {
      o && (Z(r), Z(e)), n && n.d(o), i && i.d(o);
    }
  };
}
function nu(t) {
  let r, e, n, i = !/*leftClass*/
  t[32] && Uh();
  return {
    c() {
      r = Be("div"), i && i.c(), m(
        r,
        "class",
        /*leftClass*/
        t[32] || `${oi.gallery__arrow} ${$n.arrow} ${$n.arrow_left}`
      );
    },
    m(o, s) {
      x(o, r, s), i && i.m(r, null), e || (n = Ge(
        r,
        "click",
        /*click_handler*/
        t[71]
      ), e = !0);
    },
    p: T,
    d(o) {
      o && Z(r), i && i.d(), e = !1, n();
    }
  };
}
function Uh(t) {
  let r, e;
  return {
    c() {
      r = En("svg"), e = En("path"), m(e, "class", oi["gallery__arrow-icon-path"]), m(e, "d", "m10 16 8.3 8 1.03-1-4-6-.7-1 .7-1 4-6-1.03-1z"), m(r, "class", $n.arrow__icon), m(r, "xmlns", "http://www.w3.org/2000/svg"), m(r, "width", "32"), m(r, "height", "32"), m(r, "viewBox", "0 0 32 32"), m(r, "fill", "none");
    },
    m(n, i) {
      x(n, r, i), Tt(r, e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function iu(t) {
  let r, e, n, i = !/*rightClass*/
  t[33] && Gh();
  return {
    c() {
      r = Be("div"), i && i.c(), m(
        r,
        "class",
        /*rightClass*/
        t[33] || `${oi.gallery__arrow} ${$n.arrow} ${$n.arrow_right}`
      );
    },
    m(o, s) {
      x(o, r, s), i && i.m(r, null), e || (n = Ge(
        r,
        "click",
        /*click_handler_1*/
        t[72]
      ), e = !0);
    },
    p: T,
    d(o) {
      o && Z(r), i && i.d(), e = !1, n();
    }
  };
}
function Gh(t) {
  let r, e;
  return {
    c() {
      r = En("svg"), e = En("path"), m(e, "class", oi["gallery__arrow-icon-path"]), m(e, "d", "M22 16l-8.3 8-1.03-1 4-6 .7-1-.7-1-4-6 1.03-1 8.3 8z"), m(r, "class", $n.arrow__icon), m(r, "xmlns", "http://www.w3.org/2000/svg"), m(r, "width", "32"), m(r, "height", "32"), m(r, "viewBox", "0 0 32 32"), m(r, "fill", "none");
    },
    m(n, i) {
      x(n, r, i), Tt(r, e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function Yh(t) {
  let r, e, n, i, o, s, a, l, u, c, f = lr(
    /*itemsGrid*/
    t[18]
  ), _ = [];
  for (let p = 0; p < f.length; p += 1)
    _[p] = tu(Qa(t, f, p));
  const g = (p) => ae(_[p], 1, 1, () => {
    _[p] = null;
  });
  let y = (
    /*orientation*/
    t[4] === "horizontal" && ru(t)
  );
  return {
    c() {
      r = Be("div"), e = Be("div");
      for (let p = 0; p < _.length; p += 1)
        _[p].c();
      s = wr(), y && y.c(), a = $t(), m(e, "class", oi["gallery__items-grid"]), m(e, "style", n = Rt(
        /*gridStyle*/
        t[17]
      )), m(r, "class", i = oi.gallery__scroller + " " + /*$jsonRestrictParentScroll*/
      (t[30] ? ur["root_restrict-scroll"] : "")), m(r, "style", o = Rt(
        /*scrollerStyle*/
        t[5]
      ));
    },
    m(p, w) {
      x(p, r, w), Tt(r, e);
      for (let E = 0; E < _.length; E += 1)
        _[E] && _[E].m(e, null);
      t[69](e), t[70](r), x(p, s, w), y && y.m(p, w), x(p, a, w), l = !0, u || (c = Ge(r, "scroll", function() {
        zr(
          /*shouldCheckArrows*/
          t[8] ? (
            /*updateArrowsVisibility*/
            t[36]
          ) : null
        ) && /*shouldCheckArrows*/
        (t[8] ? (
          /*updateArrowsVisibility*/
          t[36]
        ) : null).apply(this, arguments);
      }), u = !0);
    },
    p(p, w) {
      if (t = p, w[0] & /*columnStyle, galleryItemsWrappers, lastPaddingSize, itemsGrid, childLayoutParams, orientation, gridGap*/
      340560) {
        f = lr(
          /*itemsGrid*/
          t[18]
        );
        let E;
        for (E = 0; E < f.length; E += 1) {
          const Q = Qa(t, f, E);
          _[E] ? (_[E].p(Q, w), K(_[E], 1)) : (_[E] = tu(Q), _[E].c(), K(_[E], 1), _[E].m(e, null));
        }
        for (_r(), E = f.length; E < _.length; E += 1)
          g(E);
        pr();
      }
      (!l || w[0] & /*gridStyle*/
      131072 && n !== (n = Rt(
        /*gridStyle*/
        t[17]
      ))) && m(e, "style", n), (!l || w[0] & /*$jsonRestrictParentScroll*/
      1073741824 && i !== (i = oi.gallery__scroller + " " + /*$jsonRestrictParentScroll*/
      (t[30] ? ur["root_restrict-scroll"] : ""))) && m(r, "class", i), (!l || w[0] & /*scrollerStyle*/
      32 && o !== (o = Rt(
        /*scrollerStyle*/
        t[5]
      ))) && m(r, "style", o), /*orientation*/
      t[4] === "horizontal" ? y ? y.p(t, w) : (y = ru(t), y.c(), y.m(a.parentNode, a)) : y && (y.d(1), y = null);
    },
    i(p) {
      if (!l) {
        for (let w = 0; w < f.length; w += 1)
          K(_[w]);
        l = !0;
      }
    },
    o(p) {
      _ = _.filter(Tf);
      for (let w = 0; w < _.length; w += 1)
        ae(_[w]);
      l = !1;
    },
    d(p) {
      p && (Z(r), Z(s), Z(a)), gn(_, p), t[69](null), t[70](null), y && y.d(p), u = !1, c();
    }
  };
}
function qh(t) {
  let r, e, n, i;
  return r = new On({
    props: {
      cls: jt(
        "gallery",
        oi,
        /*mods*/
        t[15]
      ),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      customPaddings: !0,
      customActions: "gallery",
      parentOf: (
        /*items*/
        t[7]
      ),
      replaceItems: (
        /*replaceItems*/
        t[34]
      ),
      $$slots: { default: [Yh] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(o, s) {
      Kt(r, o, s), e = !0, n || (i = Ge(window, "resize", function() {
        zr(
          /*shouldCheckArrows*/
          t[8] ? (
            /*updateArrowsVisibilityDebounced*/
            t[37]
          ) : null
        ) && /*shouldCheckArrows*/
        (t[8] ? (
          /*updateArrowsVisibilityDebounced*/
          t[37]
        ) : null).apply(this, arguments);
      }), n = !0);
    },
    p(o, s) {
      t = o;
      const a = {};
      s[0] & /*mods*/
      32768 && (a.cls = jt(
        "gallery",
        oi,
        /*mods*/
        t[15]
      )), s[0] & /*componentContext*/
      1 && (a.componentContext = /*componentContext*/
      t[0]), s[0] & /*layoutParams*/
      2 && (a.layoutParams = /*layoutParams*/
      t[1]), s[0] & /*items*/
      128 && (a.parentOf = /*items*/
      t[7]), s[0] & /*hasScrollRight, shouldCheckArrows, hasScrollLeft, orientation, $jsonRestrictParentScroll, scrollerStyle, scroller, gridStyle, itemsGridElem, itemsGrid, columnStyle, galleryItemsWrappers, lastPaddingSize, childLayoutParams, gridGap*/
      1074216828 | s[2] & /*$$scope*/
      67108864 && (a.$$scope = { dirty: s, ctx: t }), r.$set(a);
    },
    i(o) {
      e || (K(r.$$.fragment, o), e = !0);
    },
    o(o) {
      ae(r.$$.fragment, o), e = !1;
    },
    d(o) {
      Xt(r, o), n = !1, i();
    }
  };
}
function Jh(t, r, e) {
  let n = 0, i = [], o = [];
  for (let s = 0; s < t.length; ++s)
    i[n] || (i[n] = []), i[n].push({
      index: s,
      hasGapBefore: o[n] && r[s].visibility !== "gone",
      componentContext: t[s]
    }), !o[n] && r[s].visibility !== "gone" && (o[n] = !0), ++n >= e && (n = 0);
  return i;
}
function Kh(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee = T, X = () => (ee(), ee = B(p, (ne) => e(56, H = ne)), p), I, P = T, O = () => (P(), P = B(y, (ne) => e(57, I = ne)), y), U, me = T, nt = () => (me(), me = B(_, (ne) => e(58, U = ne)), _), _e, Me = T, tt = () => (Me(), Me = B(ze, (ne) => e(59, _e = ne)), ze), We, Ne = T, Ft = () => (Ne(), Ne = B(f, (ne) => e(60, We = ne)), f), Ve, Oe = T, Pe = () => (Oe(), Oe = B(c, (ne) => e(61, Ve = ne)), c), yt, ye = T, Ke = () => (ye(), ye = B(u, (ne) => e(62, yt = ne)), u), je, te = T, ot = () => (te(), te = B(l, (ne) => e(63, je = ne)), l), ce, pt = T, Ct = () => (pt(), pt = B(a, (ne) => e(64, ce = ne)), a), re, $ = T, pe = () => ($(), $ = B(s, (ne) => e(65, re = ne)), s), Bt, De, ft = T, Mt = () => (ft(), ft = B(o, (ne) => e(67, De = ne)), o), He, ht = T, qt = () => (ht(), ht = B(g, (ne) => e(30, He = ne)), g);
  t.$$.on_destroy.push(() => ee()), t.$$.on_destroy.push(() => P()), t.$$.on_destroy.push(() => me()), t.$$.on_destroy.push(() => Me()), t.$$.on_destroy.push(() => Ne()), t.$$.on_destroy.push(() => Oe()), t.$$.on_destroy.push(() => ye()), t.$$.on_destroy.push(() => te()), t.$$.on_destroy.push(() => pt()), t.$$.on_destroy.push(() => $()), t.$$.on_destroy.push(() => ft()), t.$$.on_destroy.push(() => ht());
  let { componentContext: fe } = r, { layoutParams: Vt = void 0 } = r;
  const be = Xr(_n), $e = be.direction;
  mn(t, $e, (ne) => e(55, le = ne));
  let Ce, Xe = [], Jt = !1, bt = !1, Qt = null, rt, ir = !1;
  const W = be.getCustomization("galleryLeftClass"), Et = be.getCustomization("galleryRightClass");
  let It, Ye = 1, L = "horizontal", Le = "start", gt, qe = 8, Te, cr, ke = "", hr, ie = [], ze, Ot = {}, Yt = !1, Ht = {}, wt = 0;
  function Wt() {
    e(42, Ye = 1), e(4, L = "horizontal"), e(43, Le = "start"), e(44, qe = 8), e(47, ke = "");
  }
  function Lt(ne) {
    e(0, fe = e(51, or = {
      ...fe,
      json: {
        ...fe.json,
        items: ne.filter(ki)
      }
    }));
  }
  const Gt = be.isDesktop;
  mn(t, Gt, (ne) => e(66, Bt = ne));
  let tr = [], or;
  function mr() {
    if (!Ce)
      return;
    let ne = Ce.scrollLeft;
    le === "rtl" && (ne *= -1);
    const we = Ce.scrollWidth, it = Ce.offsetWidth;
    le === "ltr" ? (e(10, Jt = ne > 2), e(11, bt = ne + it < we - 2)) : (e(11, bt = ne > 2), e(10, Jt = ne + it < we - 2));
  }
  const zt = Bl(mr, 50);
  function Ut(ne) {
    Ce.scroll({
      left: Ce.scrollLeft + Ce.offsetWidth * 0.75 * (ne === "right" ? 1 : -1),
      behavior: "smooth"
    });
  }
  function st() {
    let ne = [], we = Xe[0].children.length;
    for (let it = 0; it < we; it += 2)
      for (let ut = 0; ut < Ye; ++ut) {
        const dt = Xe[ut].children[it];
        dt && ne.push(dt);
      }
    return ne;
  }
  function et(ne, we = !0) {
    const ut = L === "horizontal" ? "left" : "top";
    Ce.scroll({
      [ut]: ne,
      behavior: we ? "smooth" : "instant"
    });
  }
  function nr(ne, we, { animated: it = !0, extraOffset: ut = 0, overflow: dt = "clamp" } = {}) {
    const Cr = L === "horizontal", vt = Cr ? "offsetLeft" : "offsetTop";
    we > ne.length - 1 ? we = dt === "ring" ? pi(we, ne.length) : ne.length - 1 : we < 0 && (we = dt === "ring" ? pi(we, ne.length) : 0);
    const v = ne[we];
    if (v) {
      let V;
      if (le === "ltr" || !Cr)
        V = v[vt] + 0.01 - qe / 2;
      else {
        const Y = Ce.offsetWidth;
        V = v[vt] + v.offsetWidth + 0.01 - qe / 2 - Y;
      }
      if (ut) {
        V += ut;
        const Y = Cr ? Ce.scrollWidth - Ce.offsetWidth : Ce.scrollHeight - Ce.offsetHeight;
        V > Y && (dt === "clamp" ? V = Y : dt === "ring" && (V = pi(V, Y))), V < 0 && (dt === "clamp" ? V = 0 : dt === "ring" && (V = pi(V, Y)));
      }
      et(V, it);
    }
  }
  function Ar(ne, { overflow: we = "clamp", animated: it = !0 } = {}) {
    const ut = L === "horizontal", dt = le === "ltr" || !ut ? 1 : -1, Cr = ut ? Ce.scrollLeft : Ce.scrollTop, vt = ut ? Ce.scrollWidth - Ce.offsetWidth : Ce.scrollHeight - Ce.offsetHeight;
    let v = Cr * dt + ne;
    v > vt ? we === "clamp" ? v = vt : we === "ring" && (v = pi(v, vt)) : v < 0 && (we === "clamp" ? v = 0 : we === "ring" && (v = pi(v, vt))), et(v * dt, it);
  }
  function br(ne, we) {
    return L === "horizontal" ? we.right > ne.left && ne.right > we.left : we.bottom > ne.top && ne.bottom > we.top;
  }
  function yr(ne, we) {
    return L === "horizontal" ? we.left >= ne.left && we.right <= ne.right : we.top >= ne.top && we.bottom <= ne.bottom;
  }
  function jr(ne) {
    const we = st(), it = Ce.getBoundingClientRect(), ut = we.findIndex((vt) => yr(it, vt.getBoundingClientRect()));
    if (ut !== -1)
      return ut;
    const dt = we.map((vt) => br(it, vt.getBoundingClientRect())), Cr = dt.findIndex(Boolean);
    return Cr !== -1 ? ne === "prev" && dt.filter(Boolean).length === 2 ? Cr + 1 : Cr : ne === "prev" ? 1 : we.length - 2;
  }
  Jn(() => {
    if (e(40, ir = !0), mr(), wt) {
      const ne = st();
      nr(ne, wt, { animated: !1 });
    }
  }), bn(() => {
    e(40, ir = !1), tr.forEach((ne) => {
      ne.destroy();
    }), It && !fe.fakeElement && (be.unregisterInstance(It), e(41, It = void 0));
  });
  function kr(ne, we) {
    Or[ne ? "unshift" : "push"](() => {
      Xe[we] = ne, e(9, Xe);
    });
  }
  function Ir(ne) {
    Or[ne ? "unshift" : "push"](() => {
      rt = ne, e(3, rt);
    });
  }
  function gr(ne) {
    Or[ne ? "unshift" : "push"](() => {
      Ce = ne, e(2, Ce);
    });
  }
  const Er = () => Ut("left"), Ze = () => Ut("right");
  return t.$$set = (ne) => {
    "componentContext" in ne && e(0, fe = ne.componentContext), "layoutParams" in ne && e(1, Vt = ne.layoutParams);
  }, t.$$.update = () => {
    var ne, we, it, ut, dt, Cr;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(54, n = fe.origJson), t.$$.dirty[1] & /*origJson*/
    8388608 && n && Wt(), t.$$.dirty[0] & /*componentContext*/
    1 && e(53, i = Array.isArray(fe.json.items) && fe.json.items || []), t.$$.dirty[0] & /*componentContext*/
    1 && Mt(e(29, o = typeof ((ne = fe.json.item_builder) == null ? void 0 : ne.data) == "string" ? fe.getDerivedFromVars((we = fe.json.item_builder) == null ? void 0 : we.data, void 0, !0) : (it = fe.json.item_builder) != null && it.data ? Ji(fe.json.item_builder.data) : void 0)), t.$$.dirty[0] & /*componentContext*/
    1 && pe(e(28, s = fe.getDerivedFromVars(fe.json.column_count))), t.$$.dirty[0] & /*componentContext*/
    1 && Ct(e(27, a = fe.getDerivedFromVars(fe.json.orientation))), t.$$.dirty[0] & /*componentContext*/
    1 && ot(e(26, l = fe.getDerivedFromVars(fe.json.cross_content_alignment))), t.$$.dirty[0] & /*componentContext*/
    1 && Ke(e(25, u = fe.getDerivedFromVars(fe.json.item_spacing))), t.$$.dirty[0] & /*componentContext*/
    1 && Pe(e(24, c = fe.getDerivedFromVars(fe.json.cross_spacing))), t.$$.dirty[0] & /*componentContext*/
    1 && Ft(e(23, f = fe.getDerivedFromVars(fe.json.paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && nt(e(22, _ = fe.getDerivedFromVars(fe.json.scroll_mode))), t.$$.dirty[0] & /*componentContext*/
    1 && qt(e(21, g = fe.getDerivedFromVars(fe.json.restrict_parent_scroll))), t.$$.dirty[0] & /*componentContext*/
    1 && O(e(20, y = fe.getDerivedFromVars(fe.json.scrollbar))), t.$$.dirty[0] & /*componentContext*/
    1 && X(e(19, p = fe.getDerivedFromVars(fe.json.default_item))), t.$$.dirty[0] & /*componentContext, items*/
    129 | t.$$.dirty[1] & /*jsonItems, prevContext*/
    5242880 | t.$$.dirty[2] & /*$jsonItemBuilderData*/
    32) {
      let vt = [];
      if (fe.json.item_builder && Array.isArray(De) && Array.isArray(fe.json.item_builder.prototypes)) {
        const he = fe.json.item_builder;
        vt = Hl(De, be, fe, he);
      } else
        vt = (Array.isArray(i) && i || []).map((he, d) => ({
          div: he,
          key: he.id || { index: d, data: he }
        }));
      const v = new Set(tr), V = /* @__PURE__ */ new Map();
      let Y = !1;
      or === fe && tr.forEach((he) => {
        he.key && (typeof he.key == "string" && V.has(he.key) ? Y || (Y = !0, fe.logError(R(new Error("Duplicate key for child elements inside item_builder"), { additional: { key: he.key } }))) : V.set(
          typeof he.key == "string" ? he.key : he.key.index,
          he
        ));
      }), e(7, tr = vt.map((he, d) => {
        let G = !Y && V.get(he.id), Ie = V.get(d);
        return !G && !he.id && typeof he.key == "object" && typeof (Ie == null ? void 0 : Ie.key) == "object" && yo(Ie.key.data, he.key.data) && (G = Ie), G ? (v.delete(G), G) : fe.produceChildContext(he.div, {
          path: d,
          variables: he.vars,
          id: he.id,
          key: he.key
        });
      }));
      for (const he of v)
        he.destroy();
      e(51, or = fe);
    }
    if (t.$$.dirty[1] & /*mounted*/
    512 | t.$$.dirty[2] & /*$isDesktop*/
    16 && e(8, w = Bt && ir), t.$$.dirty[0] & /*shouldCheckArrows, itemsGridElem*/
    264 | t.$$.dirty[1] & /*resizeObserver*/
    256 && (w ? typeof ResizeObserver < "u" && (e(39, Qt = new ResizeObserver(() => {
      zt();
    })), Qt.observe(rt)) : Qt && (Qt.disconnect(), e(39, Qt = null))), t.$$.dirty[1] & /*columns*/
    2048 | t.$$.dirty[2] & /*$jsonColumnCount*/
    8 && e(42, Ye = Gn(re, Ye)), t.$$.dirty[0] & /*orientation*/
    16 | t.$$.dirty[2] & /*$jsonOrientation*/
    4 && e(4, L = Wl(ce, L)), t.$$.dirty[1] & /*align*/
    4096 | t.$$.dirty[2] & /*$jsonCrossContentAlignment*/
    2 && e(43, Le = Hh(je, Le)), t.$$.dirty[1] & /*itemSpacing*/
    8192 | t.$$.dirty[2] & /*$jsonItemSpacing*/
    1 && (e(44, qe = Kr(yt, qe)), e(12, gt = Re(qe))), t.$$.dirty[1] & /*$jsonCrossSpacing, itemSpacing, crossSpacing*/
    1073782784 && (e(46, cr = Kr(Ve, qe)), e(45, Te = Re(cr))), t.$$.dirty[0] & /*orientation*/
    16 | t.$$.dirty[1] & /*$jsonPaddings, $direction, padding*/
    553713664) {
      e(47, ke = bs(We, le, ke));
      const vt = L === "horizontal" ? (dt = (ut = We == null ? void 0 : We.end) != null ? ut : We == null ? void 0 : We[le === "ltr" ? "right" : "left"]) != null ? dt : 0 : (Cr = We == null ? void 0 : We.bottom) != null ? Cr : 0, v = Re(vt);
      e(13, hr = {
        width: L === "horizontal" ? v : "1px",
        height: L === "horizontal" ? "1px" : v,
        "margin-right": L === "horizontal" && le === "ltr" ? "-" + v : void 0,
        "margin-left": L === "horizontal" && le === "rtl" ? "-" + v : void 0,
        "margin-bottom": L === "vertical" ? "-" + v : void 0
      });
    }
    if (t.$$.dirty[0] & /*orientation*/
    16 && e(52, E = L === "horizontal" ? "grid-template-columns" : "grid-template-rows"), t.$$.dirty[0] & /*items, orientation*/
    144) {
      let vt = [];
      tr.forEach((v) => {
        const V = L === "horizontal" ? "width" : "height";
        vt.push(v.getDerivedFromVars({
          size: v.json[V],
          visibility: v.json.visibility
        }));
      }), tt(e(14, ze = bo(vt, (v) => [...v])));
    }
    if (t.$$.dirty[0] & /*items*/
    128 | t.$$.dirty[1] & /*$childStore, columns*/
    268437504 && e(18, Q = Jh(tr, _e, Ye)), t.$$.dirty[0] & /*orientation*/
    16 | t.$$.dirty[1] & /*columns, templateSizes, $childStore*/
    268568576 && (e(48, ie = []), Ye > 1 || _e.forEach((vt, v) => {
      var V;
      vt.visibility !== "gone" && (!vt.size && L === "horizontal" || ((V = vt.size) == null ? void 0 : V.type) === "match_parent" ? ie.push("100%") : ie.push("max-content"), v + 1 < _e.length && ie.push("auto"));
    }), ie.push("auto")), t.$$.dirty[0] & /*orientation, scrollerStyle, childLayoutParams*/
    112 | t.$$.dirty[1] & /*align, $jsonScrollMode, itemSpacing, columns*/
    134232064) {
      const vt = {};
      let v = {};
      if (e(49, Yt = !1), L === "horizontal" ? v.parentVAlign = Le : v.parentHAlign = Le, U === "paging") {
        e(49, Yt = !0), v.scrollSnap = "start";
        const V = L === "horizontal" ? "scroll-padding-left" : "scroll-padding-top";
        vt[V] = Re(qe / 2);
      }
      Ye === 1 && (v.parentLayoutOrientation = L), e(5, Ot = Ni(vt, Ot)), e(6, Ht = Ni(v, Ht));
    }
    t.$$.dirty[1] & /*padding, crossGridGap*/
    81920 && e(17, J = { padding: ke, "grid-gap": Te }), t.$$.dirty[1] & /*gridTemplate, templateSizes*/
    2228224 && e(16, M = {
      [E]: Wh(ie)
    }), t.$$.dirty[0] & /*orientation*/
    16 | t.$$.dirty[1] & /*scrollSnap, $jsonScrollbar*/
    67371008 && e(15, ge = {
      orientation: L,
      "scroll-snap": Yt,
      scrollbar: I === "auto" ? "auto" : "none"
    }), t.$$.dirty[1] & /*$jsonDefaultItem, defaultItem*/
    34078720 && e(50, wt = Kr(H, wt)), t.$$.dirty[0] & /*componentContext*/
    1 && fe.json && zt(), t.$$.dirty[0] & /*componentContext, orientation, scroller*/
    21 | t.$$.dirty[1] & /*prevId, $direction*/
    16778240 && fe.json && (It && (be.unregisterInstance(It), e(41, It = void 0)), fe.id && !fe.fakeElement && (e(41, It = fe.id), be.registerInstance(It, {
      setCurrentItem(vt, v) {
        const V = st();
        if (vt < 0 || vt > V.length - 1)
          throw new Error('Item is out of range in "set-current-item" action');
        nr(V, vt, { animated: v });
      },
      setPreviousItem(vt, v, V) {
        const Y = jr("prev"), he = st();
        let d = Y - vt;
        nr(he, d, { animated: V, overflow: v });
      },
      setNextItem(vt, v, V) {
        const Y = L === "horizontal", he = le === "ltr" || !Y ? 1 : -1, d = Y ? Ce.scrollLeft * he + Ce.offsetWidth === Ce.scrollWidth : Ce.scrollTop + Ce.offsetHeight === Ce.scrollHeight, G = st();
        if (d && v === "ring") {
          nr(G, 0, { animated: V });
          return;
        }
        let Je = jr("next") + vt;
        nr(G, Je, { animated: V, overflow: v });
      },
      scrollToStart(vt) {
        et(0, vt);
      },
      scrollToEnd(vt) {
        et(
          le === "ltr" || L !== "horizontal" ? 1e6 : -1e6,
          vt
        );
      },
      scrollToPosition(vt, v) {
        et(
          le === "ltr" || L !== "horizontal" ? vt : -vt,
          v
        );
      },
      scrollCombined({ step: vt, offset: v, overflow: V, animated: Y }) {
        if (vt) {
          const d = jr(vt > 0 ? "next" : "prev") + vt;
          nr(st(), d, { animated: Y, extraOffset: v, overflow: V });
        } else
          v && Ar(v, { overflow: V, animated: Y });
      }
    })));
  }, [
    fe,
    Vt,
    Ce,
    rt,
    L,
    Ot,
    Ht,
    tr,
    w,
    Xe,
    Jt,
    bt,
    gt,
    hr,
    ze,
    ge,
    M,
    J,
    Q,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    He,
    $e,
    W,
    Et,
    Lt,
    Gt,
    mr,
    zt,
    Ut,
    Qt,
    ir,
    It,
    Ye,
    Le,
    qe,
    Te,
    cr,
    ke,
    ie,
    Yt,
    wt,
    or,
    E,
    i,
    n,
    le,
    H,
    I,
    U,
    _e,
    We,
    Ve,
    yt,
    je,
    ce,
    re,
    Bt,
    De,
    kr,
    Ir,
    gr,
    Er,
    Ze
  ];
}
class Xh extends $r {
  constructor(r) {
    super(), xr(this, r, Kh, qh, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1]);
  }
}
const Zh = "appkit-outer", Qh = "appkit-tabs", xh = "appkit-tabs__list", $h = "appkit-tabs__item", eg = "appkit-tabs__item_selected", tg = "appkit-tabs_animation_fade", rg = "appkit-tabs_animation_none", ng = "appkit-tabs__item_actionable", ig = "appkit-tabs__panels", og = "appkit-tabs__swiper", sg = "appkit-tabs__swiper_animated", lg = "appkit-tabs__swiper_inited", ag = "appkit-tabs__panel", ug = "appkit-tabs__panel_visible", cg = "appkit-tabs__separator", fg = "appkit-tabs__delimitier", hn = {
  outer: Zh,
  "root__any-actions": "appkit-root__any-actions",
  tabs: Qh,
  tabs__list: xh,
  "tabs__items-bg": "appkit-tabs__items-bg",
  "tabs__items-text": "appkit-tabs__items-text",
  tabs__item: $h,
  tabs__item_selected: eg,
  tabs_animation_fade: tg,
  tabs_animation_none: rg,
  tabs__item_actionable: ng,
  tabs__panels: ig,
  "tabs_own-height": "appkit-tabs_own-height",
  tabs__swiper: og,
  tabs__swiper_animated: sg,
  tabs__swiper_inited: lg,
  tabs__panel: ag,
  tabs__panel_visible: ug,
  "tabs_height-parent_yes": "appkit-tabs_height-parent_yes",
  tabs__separator: cg,
  tabs__delimitier: fg,
  "tabs__tabs-highlighter": "appkit-tabs__tabs-highlighter"
};
function dg(t, r) {
  var n, i;
  if (!t || !t.image_url || typeof t.image_url != "string")
    return r;
  const e = {
    url: t.image_url
  };
  return ((n = t.width) == null ? void 0 : n.type) === "fixed" && Hn(t.width.value) && (e.width = t.width.value), ((i = t.height) == null ? void 0 : i.type) === "fixed" && Hn(t.height.value) && (e.height = t.height.value), e;
}
const Ff = 37, Mf = 39, Pf = 36, Nf = 35;
function _g(t, r, e, n) {
  const i = [
    t["top-left"],
    t["top-right"],
    t["bottom-right"],
    t["bottom-left"]
  ];
  for (let o = 0; o < i.length; ++o)
    if (i[o] && !zn(i[o]))
      return n;
  return Xo(t, r, e);
}
function ou(t) {
  const r = t.touches[0], e = r.clientX || r.pageX, n = r.clientY || r.pageY;
  return { x: e, y: n };
}
function pg(t) {
  let r, e;
  return r = new ti({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function hg(t, r, e) {
  let { componentContext: n } = r, { layoutParams: i = void 0 } = r, { enabled: o } = r;
  const s = gi(o);
  return Yi(zl, { isEnabled: s }), t.$$set = (a) => {
    "componentContext" in a && e(0, n = a.componentContext), "layoutParams" in a && e(1, i = a.layoutParams), "enabled" in a && e(2, o = a.enabled);
  }, t.$$.update = () => {
    t.$$.dirty & /*enabled*/
    4 && s.set(o);
  }, [n, i, o];
}
class gg extends $r {
  constructor(r) {
    super(), xr(this, r, hg, pg, Vr, {
      componentContext: 0,
      layoutParams: 1,
      enabled: 2
    });
  }
}
const { Boolean: su, window: mg } = wi;
function lu(t, r, e) {
  const n = t.slice();
  n[97] = r[e];
  const i = (
    /*item*/
    n[97].index
  );
  n[98] = i;
  const o = (
    /*showedPanels*/
    n[31][
      /*index*/
      n[98]
    ]
  );
  return n[99] = o, n;
}
function au(t, r, e) {
  const n = t.slice();
  n[97] = r[e];
  const i = (
    /*item*/
    n[97].index
  );
  n[98] = i;
  const o = (
    /*index*/
    n[98] === /*selected*/
    n[17]
  );
  return n[102] = o, n;
}
function uu(t, r, e) {
  const n = t.slice();
  n[97] = r[e];
  const i = (
    /*item*/
    n[97].index
  );
  n[98] = i;
  const o = (
    /*index*/
    n[98] === /*selected*/
    n[17]
  );
  return n[102] = o, n;
}
function bg(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function yg(t) {
  let r, e;
  const n = [
    {
      cls: jt(
        "tabs",
        hn,
        /*mods*/
        t[24]
      )
    },
    {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    },
    { layoutParams: (
      /*layoutParams*/
      t[1]
    ) },
    { customActions: "tabs" },
    { parentOf: (
      /*parentOfItems*/
      t[45]
    ) },
    { parentOfSimpleMode: !0 },
    { replaceItems: (
      /*replaceItems*/
      t[51]
    ) },
    /*devapi*/
    t[50]
  ];
  let i = {
    $$slots: { default: [vg] },
    $$scope: { ctx: t }
  };
  for (let o = 0; o < n.length; o += 1)
    i = ui(i, n[o]);
  return r = new On({ props: i }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(o, s) {
      Kt(r, o, s), e = !0;
    },
    p(o, s) {
      const a = s[0] & /*mods, componentContext, layoutParams*/
      16777219 | s[1] & /*parentOfItems, replaceItems, devapi*/
      1589248 ? vi(n, [
        s[0] & /*mods*/
        16777216 && {
          cls: jt(
            "tabs",
            hn,
            /*mods*/
            o[24]
          )
        },
        s[0] & /*componentContext*/
        1 && {
          componentContext: (
            /*componentContext*/
            o[0]
          )
        },
        s[0] & /*layoutParams*/
        2 && { layoutParams: (
          /*layoutParams*/
          o[1]
        ) },
        n[3],
        s[1] & /*parentOfItems*/
        16384 && { parentOf: (
          /*parentOfItems*/
          o[45]
        ) },
        n[5],
        s[1] & /*replaceItems*/
        1048576 && { replaceItems: (
          /*replaceItems*/
          o[51]
        ) },
        s[1] & /*devapi*/
        524288 && vf(
          /*devapi*/
          o[50]
        )
      ]) : {};
      s[0] & /*panelsWrapper, isSwipeInitialized, isAnimated, swiperElem, $childStore, childLayoutParams, selected, $jsonSeparator, tabsElem, titlePadding, $direction, tabFontSize, tabPaddings, tabLineHeight, tabLetterSpacing, tabActiveFontWeight, tabInactiveFontWeight, tabActiveFontFamily, tabInactiveFontFamily, tabActiveTextColor, tabInactiveTextColor, tabActiveBackground, tabInactiveBackground, tabBorderRadius, tabItemSpacing, componentContext, delimitierStyle, animationType*/
      2130706425 | s[1] & /*$jsonRestrictParentScroll, isSwipeEnabled, visiblePanels, showedPanels, separatorStyle, animationDuration, selectedTabStyles*/
      32831 | s[3] & /*$$scope*/
      16384 && (a.$$scope = { dirty: s, ctx: o }), r.$set(a);
    },
    i(o) {
      e || (K(r.$$.fragment, o), e = !0);
    },
    o(o) {
      ae(r.$$.fragment, o), e = !1;
    },
    d(o) {
      Xt(r, o);
    }
  };
}
function cu(t) {
  let r;
  return {
    c() {
      r = Be("span"), m(r, "class", hn.tabs__delimitier), q(
        r,
        "width",
        /*delimitierStyle*/
        t[15].width ? Re(
          /*delimitierStyle*/
          t[15].width
        ) : void 0
      ), q(
        r,
        "height",
        /*delimitierStyle*/
        t[15].height ? Re(
          /*delimitierStyle*/
          t[15].height
        ) : void 0
      );
    },
    m(e, n) {
      x(e, r, n);
    },
    p(e, n) {
      n[0] & /*delimitierStyle*/
      32768 && q(
        r,
        "width",
        /*delimitierStyle*/
        e[15].width ? Re(
          /*delimitierStyle*/
          e[15].width
        ) : void 0
      ), n[0] & /*delimitierStyle*/
      32768 && q(
        r,
        "height",
        /*delimitierStyle*/
        e[15].height ? Re(
          /*delimitierStyle*/
          e[15].height
        ) : void 0
      );
    },
    d(e) {
      e && Z(r);
    }
  };
}
function fu(t) {
  let r, e, n = (
    /*item*/
    t[97].title + ""
  ), i, o, s = (
    /*delimitierStyle*/
    t[15] && /*index*/
    t[98] > 0 && cu(t)
  );
  return {
    c() {
      s && s.c(), r = wr(), e = Be("span"), i = ei(n), m(e, "class", o = jt("tabs__item", hn, {
        selected: (
          /*isSelected*/
          t[102]
        ),
        actionable: !!/*item*/
        t[97].title_click_action
      }));
    },
    m(a, l) {
      s && s.m(a, l), x(a, r, l), x(a, e, l), Tt(e, i);
    },
    p(a, l) {
      /*delimitierStyle*/
      a[15] && /*index*/
      a[98] > 0 ? s ? s.p(a, l) : (s = cu(a), s.c(), s.m(r.parentNode, r)) : s && (s.d(1), s = null), l[0] & /*$childStore*/
      262144 && n !== (n = /*item*/
      a[97].title + "") && Ti(i, n), l[0] & /*$childStore, selected*/
      393216 && o !== (o = jt("tabs__item", hn, {
        selected: (
          /*isSelected*/
          a[102]
        ),
        actionable: !!/*item*/
        a[97].title_click_action
      })) && m(e, "class", o);
    },
    d(a) {
      a && (Z(r), Z(e)), s && s.d(a);
    }
  };
}
function du(t) {
  let r, e;
  return {
    c() {
      r = Be("div"), m(r, "class", hn["tabs__tabs-highlighter"]), m(r, "style", e = Rt(
        /*selectedTabStyles*/
        t[34]
      ));
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i[1] & /*selectedTabStyles*/
      8 && e !== (e = Rt(
        /*selectedTabStyles*/
        n[34]
      )) && m(r, "style", e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function _u(t) {
  let r, e;
  return {
    c() {
      r = Be("img"), m(r, "class", hn.tabs__delimitier), m(r, "alt", ""), m(r, "loading", "lazy"), m(r, "decoding", "async"), Zn(r.src, e = /*delimitierStyle*/
      t[15].url) || m(r, "src", e), q(
        r,
        "width",
        /*delimitierStyle*/
        t[15].width ? Re(
          /*delimitierStyle*/
          t[15].width
        ) : void 0
      ), q(
        r,
        "height",
        /*delimitierStyle*/
        t[15].height ? Re(
          /*delimitierStyle*/
          t[15].height
        ) : void 0
      );
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i[0] & /*delimitierStyle*/
      32768 && !Zn(r.src, e = /*delimitierStyle*/
      n[15].url) && m(r, "src", e), i[0] & /*delimitierStyle*/
      32768 && q(
        r,
        "width",
        /*delimitierStyle*/
        n[15].width ? Re(
          /*delimitierStyle*/
          n[15].width
        ) : void 0
      ), i[0] & /*delimitierStyle*/
      32768 && q(
        r,
        "height",
        /*delimitierStyle*/
        n[15].height ? Re(
          /*delimitierStyle*/
          n[15].height
        ) : void 0
      );
    },
    d(n) {
      n && Z(r);
    }
  };
}
function wg(t) {
  let r = (
    /*item*/
    t[97].title + ""
  ), e;
  return {
    c() {
      e = ei(r);
    },
    m(n, i) {
      x(n, e, i);
    },
    p(n, i) {
      i[0] & /*$childStore*/
      262144 && r !== (r = /*item*/
      n[97].title + "") && Ti(e, r);
    },
    d(n) {
      n && Z(e);
    }
  };
}
function pu(t) {
  let r, e, n, i = (
    /*delimitierStyle*/
    t[15] && /*index*/
    t[98] > 0 && _u(t)
  );
  function o(...s) {
    return (
      /*func*/
      t[71](
        /*index*/
        t[98],
        ...s
      )
    );
  }
  return e = new Ls({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      cls: jt("tabs__item", hn, {
        selected: (
          /*isSelected*/
          t[102]
        ),
        actionable: !!/*item*/
        t[97].title_click_action
      }),
      actions: (
        /*item*/
        t[97].title_click_action && !/*componentContext*/
        t[0].fakeElement ? [
          /*item*/
          t[97].title_click_action
        ].filter(ys) : []
      ),
      attrs: {
        id: `${/*instId*/
        t[48]}-tab-${/*index*/
        t[98]}`,
        "aria-controls": `${/*instId*/
        t[48]}-panel-${/*index*/
        t[98]}`,
        role: "tab",
        // eslint-disable-next-line no-nested-ternary
        tabindex: (
          /*isSelected*/
          t[102] && !/*componentContext*/
          t[0].fakeElement ? (
            /*item*/
            t[97].title_click_action ? void 0 : "0"
          ) : "-1"
        ),
        "aria-selected": (
          /*isSelected*/
          t[102] ? "true" : "false"
        )
      },
      customAction: (
        /*componentContext*/
        t[0].fakeElement ? null : o
      ),
      $$slots: { default: [wg] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      i && i.c(), r = wr(), Zt(e.$$.fragment);
    },
    m(s, a) {
      i && i.m(s, a), x(s, r, a), Kt(e, s, a), n = !0;
    },
    p(s, a) {
      t = s, /*delimitierStyle*/
      t[15] && /*index*/
      t[98] > 0 ? i ? i.p(t, a) : (i = _u(t), i.c(), i.m(r.parentNode, r)) : i && (i.d(1), i = null);
      const l = {};
      a[0] & /*componentContext*/
      1 && (l.componentContext = /*componentContext*/
      t[0]), a[0] & /*$childStore, selected*/
      393216 && (l.cls = jt("tabs__item", hn, {
        selected: (
          /*isSelected*/
          t[102]
        ),
        actionable: !!/*item*/
        t[97].title_click_action
      })), a[0] & /*$childStore, componentContext*/
      262145 && (l.actions = /*item*/
      t[97].title_click_action && !/*componentContext*/
      t[0].fakeElement ? [
        /*item*/
        t[97].title_click_action
      ].filter(ys) : []), a[0] & /*$childStore, selected, componentContext*/
      393217 && (l.attrs = {
        id: `${/*instId*/
        t[48]}-tab-${/*index*/
        t[98]}`,
        "aria-controls": `${/*instId*/
        t[48]}-panel-${/*index*/
        t[98]}`,
        role: "tab",
        // eslint-disable-next-line no-nested-ternary
        tabindex: (
          /*isSelected*/
          t[102] && !/*componentContext*/
          t[0].fakeElement ? (
            /*item*/
            t[97].title_click_action ? void 0 : "0"
          ) : "-1"
        ),
        "aria-selected": (
          /*isSelected*/
          t[102] ? "true" : "false"
        )
      }), a[0] & /*componentContext, $childStore*/
      262145 && (l.customAction = /*componentContext*/
      t[0].fakeElement ? null : o), a[0] & /*$childStore*/
      262144 | a[3] & /*$$scope*/
      16384 && (l.$$scope = { dirty: a, ctx: t }), e.$set(l);
    },
    i(s) {
      n || (K(e.$$.fragment, s), n = !0);
    },
    o(s) {
      ae(e.$$.fragment, s), n = !1;
    },
    d(s) {
      s && Z(r), i && i.d(s), Xt(e, s);
    }
  };
}
function hu(t) {
  let r, e;
  return {
    c() {
      r = Be("div"), m(r, "class", hn.tabs__separator), m(r, "style", e = Rt(
        /*separatorStyle*/
        t[36]
      ));
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i[1] & /*separatorStyle*/
      32 && e !== (e = Rt(
        /*separatorStyle*/
        n[36]
      )) && m(r, "style", e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function gu(t) {
  let r, e;
  return r = new gg({
    props: {
      componentContext: (
        /*childComponentContext*/
        t[99]
      ),
      layoutParams: (
        /*childLayoutParams*/
        t[3]
      ),
      enabled: (
        /*index*/
        t[98] === /*selected*/
        t[17]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*$childStore*/
      262144 | i[1] & /*showedPanels*/
      1 && (o.componentContext = /*childComponentContext*/
      n[99]), i[0] & /*childLayoutParams*/
      8 && (o.layoutParams = /*childLayoutParams*/
      n[3]), i[0] & /*$childStore, selected*/
      393216 && (o.enabled = /*index*/
      n[98] === /*selected*/
      n[17]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function mu(t) {
  let r, e, n, i, o, s, a = (
    /*childComponentContext*/
    t[99] && gu(t)
  );
  return {
    c() {
      r = Be("div"), a && a.c(), e = wr(), m(r, "class", n = jt("tabs__panel", hn, {
        visible: (
          /*visiblePanels*/
          t[32][
            /*index*/
            t[98]
          ]
        )
      })), m(r, "role", "tabpanel"), m(r, "id", i = /*instId*/
      t[48] + "-panel-" + /*index*/
      t[98]), m(r, "aria-labelledby", o = /*instId*/
      t[48] + "-tab-" + /*index*/
      t[98]), q(
        r,
        "left",
        /*index*/
        t[98] * 100 + "%"
      );
    },
    m(l, u) {
      x(l, r, u), a && a.m(r, null), Tt(r, e), s = !0;
    },
    p(l, u) {
      /*childComponentContext*/
      l[99] ? a ? (a.p(l, u), u[0] & /*$childStore*/
      262144 | u[1] & /*showedPanels*/
      1 && K(a, 1)) : (a = gu(l), a.c(), K(a, 1), a.m(r, e)) : a && (_r(), ae(a, 1, 1, () => {
        a = null;
      }), pr()), (!s || u[0] & /*$childStore*/
      262144 | u[1] & /*visiblePanels*/
      2 && n !== (n = jt("tabs__panel", hn, {
        visible: (
          /*visiblePanels*/
          l[32][
            /*index*/
            l[98]
          ]
        )
      }))) && m(r, "class", n), (!s || u[0] & /*$childStore*/
      262144 && i !== (i = /*instId*/
      l[48] + "-panel-" + /*index*/
      l[98])) && m(r, "id", i), (!s || u[0] & /*$childStore*/
      262144 && o !== (o = /*instId*/
      l[48] + "-tab-" + /*index*/
      l[98])) && m(r, "aria-labelledby", o), (!s || u[0] & /*$childStore*/
      262144) && q(
        r,
        "left",
        /*index*/
        l[98] * 100 + "%"
      );
    },
    i(l) {
      s || (K(a), s = !0);
    },
    o(l) {
      ae(a), s = !1;
    },
    d(l) {
      l && Z(r), a && a.d();
    }
  };
}
function vg(t) {
  let r, e, n, i, o, s, a, l, u, c, f, _, g, y, p, w = lr(
    /*$childStore*/
    t[18]
  ), E = [];
  for (let I = 0; I < w.length; I += 1)
    E[I] = fu(uu(t, w, I));
  let Q = (
    /*animationType*/
    t[16] === "slide" && /*selectedTabStyles*/
    t[34] && du(t)
  ), J = lr(
    /*$childStore*/
    t[18]
  ), M = [];
  for (let I = 0; I < J.length; I += 1)
    M[I] = pu(au(t, J, I));
  const ge = (I) => ae(M[I], 1, 1, () => {
    M[I] = null;
  });
  let le = (
    /*$jsonSeparator*/
    t[20] && hu(t)
  ), H = lr(
    /*$childStore*/
    t[18]
  ), ee = [];
  for (let I = 0; I < H.length; I += 1)
    ee[I] = mu(lu(t, H, I));
  const X = (I) => ae(ee[I], 1, 1, () => {
    ee[I] = null;
  });
  return {
    c() {
      r = Be("div"), e = Be("div");
      for (let I = 0; I < E.length; I += 1)
        E[I].c();
      n = wr(), Q && Q.c(), i = wr(), o = Be("div");
      for (let I = 0; I < M.length; I += 1)
        M[I].c();
      a = wr(), le && le.c(), l = wr(), u = Be("div"), c = Be("div");
      for (let I = 0; I < ee.length; I += 1)
        ee[I].c();
      m(e, "class", hn["tabs__items-bg"]), m(e, "aria-hidden", "true"), m(o, "class", hn["tabs__items-text"]), m(r, "class", s = hn.tabs__list + " " + /*$jsonRestrictParentScroll*/
      (t[46] ? ur["root_restrict-scroll"] : "")), m(r, "role", "tablist"), q(
        r,
        "--divkit-tabs-title-padding",
        /*titlePadding*/
        t[14] ? li(
          /*titlePadding*/
          t[14],
          /*$direction*/
          t[19]
        ) : ""
      ), q(r, "--divkit-tabs-font-size", Re(
        /*tabFontSize*/
        t[4]
      )), q(
        r,
        "--divkit-tabs-paddings",
        /*tabPaddings*/
        t[5]
      ), q(
        r,
        "--divkit-tabs-line-height",
        /*tabLineHeight*/
        t[25]
      ), q(
        r,
        "--divkit-tabs-letter-spacing",
        /*tabLetterSpacing*/
        t[26]
      ), q(
        r,
        "--divkit-tabs-active-font-weight",
        /*tabActiveFontWeight*/
        t[7] || ""
      ), q(
        r,
        "--divkit-tabs-inactive-font-weight",
        /*tabInactiveFontWeight*/
        t[8] || ""
      ), q(
        r,
        "--divkit-tabs-active-font-family",
        /*tabActiveFontFamily*/
        t[27] || ""
      ), q(
        r,
        "--divkit-tabs-inactive-font-family",
        /*tabInactiveFontFamily*/
        t[28] || ""
      ), q(
        r,
        "--divkit-tabs-active-text-color",
        /*tabActiveTextColor*/
        t[9]
      ), q(
        r,
        "--divkit-tabs-inactive-text-color",
        /*tabInactiveTextColor*/
        t[10]
      ), q(
        r,
        "--divkit-tabs-active-background-color",
        /*tabActiveBackground*/
        t[11]
      ), q(
        r,
        "--divkit-tabs-inactive-background-color",
        /*tabInactiveBackground*/
        t[12]
      ), q(
        r,
        "--divkit-tabs-border-radius",
        /*tabBorderRadius*/
        t[6]
      ), q(
        r,
        "--divkit-tabs-items-spacing",
        /*tabItemSpacing*/
        t[13] ? dn(
          /*tabItemSpacing*/
          t[13] * 10 / /*tabFontSize*/
          t[4]
        ) : ""
      ), q(
        r,
        "--divkit-tabs-animation-duration",
        /*animationDuration*/
        t[33] !== void 0 ? `${/*animationDuration*/
        t[33]}ms` : ""
      ), m(c, "class", f = jt("tabs__swiper", hn, {
        inited: (
          /*isSwipeInitialized*/
          t[29]
        ),
        animated: (
          /*isAnimated*/
          t[30]
        )
      })), m(u, "class", _ = hn.tabs__panels + " " + /*$jsonRestrictParentScroll*/
      (t[46] ? ur["root_restrict-scroll"] : ""));
    },
    m(I, P) {
      x(I, r, P), Tt(r, e);
      for (let O = 0; O < E.length; O += 1)
        E[O] && E[O].m(e, null);
      Tt(r, n), Q && Q.m(r, null), Tt(r, i), Tt(r, o);
      for (let O = 0; O < M.length; O += 1)
        M[O] && M[O].m(o, null);
      t[72](r), x(I, a, P), le && le.m(I, P), x(I, l, P), x(I, u, P), Tt(u, c);
      for (let O = 0; O < ee.length; O += 1)
        ee[O] && ee[O].m(c, null);
      t[73](c), t[74](u), g = !0, y || (p = [
        Ge(
          r,
          "keydown",
          /*onTabKeydown*/
          t[53]
        ),
        Ge(u, "touchstart", function() {
          zr(
            /*isSwipeEnabled*/
            t[35] ? (
              /*onTouchStart*/
              t[54]
            ) : void 0
          ) && (t[35] ? (
            /*onTouchStart*/
            t[54]
          ) : void 0).apply(this, arguments);
        }),
        Ge(u, "touchmove", function() {
          zr(
            /*isSwipeEnabled*/
            t[35] ? (
              /*onTouchMove*/
              t[55]
            ) : void 0
          ) && (t[35] ? (
            /*onTouchMove*/
            t[55]
          ) : void 0).apply(this, arguments);
        }),
        Ge(u, "touchend", function() {
          zr(
            /*isSwipeEnabled*/
            t[35] ? (
              /*onTouchEnd*/
              t[56]
            ) : void 0
          ) && (t[35] ? (
            /*onTouchEnd*/
            t[56]
          ) : void 0).apply(this, arguments);
        }),
        Ge(u, "touchcancel", function() {
          zr(
            /*isSwipeEnabled*/
            t[35] ? (
              /*onTouchEnd*/
              t[56]
            ) : void 0
          ) && (t[35] ? (
            /*onTouchEnd*/
            t[56]
          ) : void 0).apply(this, arguments);
        })
      ], y = !0);
    },
    p(I, P) {
      if (t = I, P[0] & /*$childStore, selected, delimitierStyle*/
      425984) {
        w = lr(
          /*$childStore*/
          t[18]
        );
        let O;
        for (O = 0; O < w.length; O += 1) {
          const U = uu(t, w, O);
          E[O] ? E[O].p(U, P) : (E[O] = fu(U), E[O].c(), E[O].m(e, null));
        }
        for (; O < E.length; O += 1)
          E[O].d(1);
        E.length = w.length;
      }
      if (/*animationType*/
      t[16] === "slide" && /*selectedTabStyles*/
      t[34] ? Q ? Q.p(t, P) : (Q = du(t), Q.c(), Q.m(r, i)) : Q && (Q.d(1), Q = null), P[0] & /*componentContext, $childStore, selected, delimitierStyle*/
      425985 | P[1] & /*instId, selectItem*/
      2228224) {
        J = lr(
          /*$childStore*/
          t[18]
        );
        let O;
        for (O = 0; O < J.length; O += 1) {
          const U = au(t, J, O);
          M[O] ? (M[O].p(U, P), K(M[O], 1)) : (M[O] = pu(U), M[O].c(), K(M[O], 1), M[O].m(o, null));
        }
        for (_r(), O = J.length; O < M.length; O += 1)
          ge(O);
        pr();
      }
      if ((!g || P[1] & /*$jsonRestrictParentScroll*/
      32768 && s !== (s = hn.tabs__list + " " + /*$jsonRestrictParentScroll*/
      (t[46] ? ur["root_restrict-scroll"] : ""))) && m(r, "class", s), P[0] & /*titlePadding, $direction*/
      540672 && q(
        r,
        "--divkit-tabs-title-padding",
        /*titlePadding*/
        t[14] ? li(
          /*titlePadding*/
          t[14],
          /*$direction*/
          t[19]
        ) : ""
      ), P[0] & /*tabFontSize*/
      16 && q(r, "--divkit-tabs-font-size", Re(
        /*tabFontSize*/
        t[4]
      )), P[0] & /*tabPaddings*/
      32 && q(
        r,
        "--divkit-tabs-paddings",
        /*tabPaddings*/
        t[5]
      ), P[0] & /*tabLineHeight*/
      33554432 && q(
        r,
        "--divkit-tabs-line-height",
        /*tabLineHeight*/
        t[25]
      ), P[0] & /*tabLetterSpacing*/
      67108864 && q(
        r,
        "--divkit-tabs-letter-spacing",
        /*tabLetterSpacing*/
        t[26]
      ), P[0] & /*tabActiveFontWeight*/
      128 && q(
        r,
        "--divkit-tabs-active-font-weight",
        /*tabActiveFontWeight*/
        t[7] || ""
      ), P[0] & /*tabInactiveFontWeight*/
      256 && q(
        r,
        "--divkit-tabs-inactive-font-weight",
        /*tabInactiveFontWeight*/
        t[8] || ""
      ), P[0] & /*tabActiveFontFamily*/
      134217728 && q(
        r,
        "--divkit-tabs-active-font-family",
        /*tabActiveFontFamily*/
        t[27] || ""
      ), P[0] & /*tabInactiveFontFamily*/
      268435456 && q(
        r,
        "--divkit-tabs-inactive-font-family",
        /*tabInactiveFontFamily*/
        t[28] || ""
      ), P[0] & /*tabActiveTextColor*/
      512 && q(
        r,
        "--divkit-tabs-active-text-color",
        /*tabActiveTextColor*/
        t[9]
      ), P[0] & /*tabInactiveTextColor*/
      1024 && q(
        r,
        "--divkit-tabs-inactive-text-color",
        /*tabInactiveTextColor*/
        t[10]
      ), P[0] & /*tabActiveBackground*/
      2048 && q(
        r,
        "--divkit-tabs-active-background-color",
        /*tabActiveBackground*/
        t[11]
      ), P[0] & /*tabInactiveBackground*/
      4096 && q(
        r,
        "--divkit-tabs-inactive-background-color",
        /*tabInactiveBackground*/
        t[12]
      ), P[0] & /*tabBorderRadius*/
      64 && q(
        r,
        "--divkit-tabs-border-radius",
        /*tabBorderRadius*/
        t[6]
      ), P[0] & /*tabItemSpacing, tabFontSize*/
      8208 && q(
        r,
        "--divkit-tabs-items-spacing",
        /*tabItemSpacing*/
        t[13] ? dn(
          /*tabItemSpacing*/
          t[13] * 10 / /*tabFontSize*/
          t[4]
        ) : ""
      ), P[1] & /*animationDuration*/
      4 && q(
        r,
        "--divkit-tabs-animation-duration",
        /*animationDuration*/
        t[33] !== void 0 ? `${/*animationDuration*/
        t[33]}ms` : ""
      ), /*$jsonSeparator*/
      t[20] ? le ? le.p(t, P) : (le = hu(t), le.c(), le.m(l.parentNode, l)) : le && (le.d(1), le = null), P[0] & /*$childStore, childLayoutParams, selected*/
      393224 | P[1] & /*visiblePanels, instId, showedPanels*/
      131075) {
        H = lr(
          /*$childStore*/
          t[18]
        );
        let O;
        for (O = 0; O < H.length; O += 1) {
          const U = lu(t, H, O);
          ee[O] ? (ee[O].p(U, P), K(ee[O], 1)) : (ee[O] = mu(U), ee[O].c(), K(ee[O], 1), ee[O].m(c, null));
        }
        for (_r(), O = H.length; O < ee.length; O += 1)
          X(O);
        pr();
      }
      (!g || P[0] & /*isSwipeInitialized, isAnimated*/
      1610612736 && f !== (f = jt("tabs__swiper", hn, {
        inited: (
          /*isSwipeInitialized*/
          t[29]
        ),
        animated: (
          /*isAnimated*/
          t[30]
        )
      }))) && m(c, "class", f), (!g || P[1] & /*$jsonRestrictParentScroll*/
      32768 && _ !== (_ = hn.tabs__panels + " " + /*$jsonRestrictParentScroll*/
      (t[46] ? ur["root_restrict-scroll"] : ""))) && m(u, "class", _);
    },
    i(I) {
      if (!g) {
        for (let P = 0; P < J.length; P += 1)
          K(M[P]);
        for (let P = 0; P < H.length; P += 1)
          K(ee[P]);
        g = !0;
      }
    },
    o(I) {
      M = M.filter(su);
      for (let P = 0; P < M.length; P += 1)
        ae(M[P]);
      ee = ee.filter(su);
      for (let P = 0; P < ee.length; P += 1)
        ae(ee[P]);
      g = !1;
    },
    d(I) {
      I && (Z(r), Z(a), Z(l), Z(u)), gn(E, I), Q && Q.d(), gn(M, I), t[72](null), le && le.d(I), gn(ee, I), t[73](null), t[74](null), y = !1, Qr(p);
    }
  };
}
function kg(t) {
  let r, e, n, i, o, s;
  const a = [yg, bg], l = [];
  function u(c, f) {
    return (
      /*hasError*/
      c[2] ? -1 : 0
    );
  }
  return ~(r = u(t)) && (e = l[r] = a[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(c, f) {
      ~r && l[r].m(c, f), x(c, n, f), i = !0, o || (s = Ge(mg, "resize", function() {
        zr(
          /*animationType*/
          t[16] === "slide" ? (
            /*updateSlideAnimation*/
            t[57]
          ) : void 0
        ) && (t[16] === "slide" ? (
          /*updateSlideAnimation*/
          t[57]
        ) : void 0).apply(this, arguments);
      }), o = !0);
    },
    p(c, f) {
      t = c;
      let _ = r;
      r = u(t), r === _ ? ~r && l[r].p(t, f) : (e && (_r(), ae(l[_], 1, 1, () => {
        l[_] = null;
      }), pr()), ~r ? (e = l[r], e ? e.p(t, f) : (e = l[r] = a[r](t), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(c) {
      i || (K(e), i = !0);
    },
    o(c) {
      ae(e), i = !1;
    },
    d(c) {
      c && Z(n), ~r && l[r].d(c), o = !1, s();
    }
  };
}
function Eg(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge = T, le = () => (ge(), ge = B(a, (v) => e(65, M = v)), a), H, ee = T, X = () => (ee(), ee = B(y, (v) => e(66, H = v)), y), I, P = T, O = () => (P(), P = B(g, (v) => e(67, I = v)), g), U, me = T, nt = () => (me(), me = B(f, (v) => e(68, U = v)), f), _e, Me, tt = T, We = () => (tt(), tt = B(c, (v) => e(69, Me = v)), c), Ne, Ft = T, Ve = () => (Ft(), Ft = B(u, (v) => e(70, Ne = v)), u), Oe, Pe = T, yt = () => (Pe(), Pe = B(l, (v) => e(20, Oe = v)), l), ye, Ke = T, je = () => (Ke(), Ke = B(_, (v) => e(46, ye = v)), _);
  t.$$.on_destroy.push(() => ge()), t.$$.on_destroy.push(() => ee()), t.$$.on_destroy.push(() => P()), t.$$.on_destroy.push(() => me()), t.$$.on_destroy.push(() => tt()), t.$$.on_destroy.push(() => Ft()), t.$$.on_destroy.push(() => Pe()), t.$$.on_destroy.push(() => Ke());
  let { componentContext: te } = r, { layoutParams: ot = void 0 } = r;
  const ce = Xr(_n), pt = ce.direction;
  mn(t, pt, (v) => e(19, _e = v));
  const Ct = ce.genId("tabs");
  let re, $ = !1, pe = gi([]);
  mn(t, pe, (v) => e(18, J = v));
  let Bt = {}, De, ft, Mt, He = {}, ht = 12, qt = "", fe = "", Vt = "", be = "", $e, Ce = "", Xe, Jt = "", bt = "", Qt = "", rt = "", ir = "", W = 0, Et = "", It = "", Ye = null, L = !1, Le = !1, gt, qe = [], Te = [], cr = null, ke = null, hr = null, ie, ze = !1, Ot = !1, Yt, Ht, wt, Wt = "slide", Lt, Gt, tr, or;
  function mr() {
    e(4, ht = 12), e(5, qt = ""), e(6, be = ""), e(7, $e = void 0), e(27, Ce = ""), e(8, Xe = void 0), e(28, Jt = ""), e(9, bt = ""), e(10, Qt = ""), e(11, rt = ""), e(12, ir = ""), e(13, W = 0), e(59, Et = ""), e(60, It = ""), e(14, Ye = null), e(15, wt = void 0), e(16, Wt = "slide"), e(33, Lt = 300), e(34, Gt = void 0), it();
  }
  function zt(v) {
    te.json.items && e(0, te = tr = {
      ...te,
      json: {
        ...te.json,
        items: te.json.items.map((V, Y) => ({ ...V, div: v[Y] }))
      }
    });
  }
  function Ut(v) {
    if ($)
      return;
    const V = new Set(qe.filter(ki)), Y = /* @__PURE__ */ new Map();
    tr === te && qe.forEach((he) => {
      he && Y.set(he.json, he);
    }), e(31, qe = v.map((he, d) => {
      if ((d === p || qe[d]) && (he != null && he.div)) {
        const G = Y.get(he.div);
        return G ? (V.delete(G), G) : te.produceChildContext(he.div, { path: d });
      }
    })), e(32, Te = v.map((he, d) => d === p));
    for (const he of V)
      he.destroy();
    tr = te;
  }
  async function st(v, V, Y) {
    if (gt = p, e(17, p = v), gr(), Ar(Y), it(), V) {
      await jn();
      const he = De.querySelector(`.${hn.tabs__item_selected}`);
      he && he.focus();
    }
  }
  function et(v, V = !1) {
    const Y = J == null ? void 0 : J.length;
    if (!Y)
      return;
    const he = J.map((Je) => Je.index);
    let G = he.indexOf(p) + v;
    G >= Y ? G = 0 : G < 0 && (G = Y - 1);
    const Ie = he[G];
    st(Ie, V, !0);
  }
  function nr(v, V) {
    return p !== V ? (st(V, !1, !0), !1) : !0;
  }
  function Ar(v = !0) {
    e(30, Le = v), br(-p * 100), yr(), jr(), kr(), Ht = -p * ft.clientWidth;
  }
  async function br(v) {
    await jn(), e(23, Mt.style.transform = `translate3d(${v}%,0,0)`, Mt);
  }
  function yr(v = !1) {
    const V = v ? Math.max(0, p - 1) : Math.min(p, gt != null ? gt : p), Y = v ? Math.min(i.length - 1, p + 1) : Math.max(p, gt != null ? gt : p);
    ce.devtoolCreateHierarchy, qe.forEach((he) => {
      he == null || he.destroy();
    }), e(31, qe = qe.map((he, d) => {
      var Ie;
      if (he)
        return he;
      const G = (Ie = i[d]) == null ? void 0 : Ie.div;
      if ((d >= V && d <= Y || ce.devtoolCreateHierarchy === "eager" && !1) && G)
        return te.produceChildContext(G, { path: d });
    })), e(32, Te = Te.map((he, d) => d >= V && d <= Y));
  }
  async function jr() {
    var V;
    if (((V = te.json.height) == null ? void 0 : V.type) === "match_parent")
      return;
    await jn();
    const v = document.getElementById(`${Ct}-panel-${p}`);
    v && e(22, ft.style.height = Re(v.offsetHeight), ft);
  }
  function kr() {
    cr && clearTimeout(cr), cr = window.setTimeout(
      () => {
        e(32, Te = i.map((v, V) => V === p));
      },
      400
    );
  }
  function Ir(v) {
    if (!(v.ctrlKey || v.shiftKey || v.altKey || v.metaKey) && i) {
      if (v.which === Ff)
        et(-1, !0);
      else if (v.which === Mf)
        et(1, !0);
      else if (v.which === Pf)
        st(0, !0, !0);
      else if (v.which === Nf)
        st(i.length - 1, !0, !0);
      else
        return;
      v.preventDefault();
    }
  }
  function gr() {
    L || (e(29, L = !0), e(22, ft.style.height = Re(ft.clientHeight), ft), e(23, Mt.style.transform = `translate3d(${-(gt != null ? gt : p) * 100}%,0,0)`, Mt));
  }
  function Er(v) {
    var he;
    const V = v.target, Y = (he = V == null ? void 0 : V.closest) == null ? void 0 : he.call(V, `.${ur["root_restrict-scroll"]}`);
    i.length < 2 || v.touches.length > 1 || Y && Y !== ft || (ze = !1, Ot = !1, ke = ou(v), hr = null, ie = Date.now(), Yt = Ht || -p * ft.clientWidth, e(30, Le = !1), cr && clearTimeout(cr));
  }
  function Ze(v) {
    const V = ou(v);
    if (!ke || hr && hr.x === V.x && hr.y === V.y)
      return;
    hr = V;
    const Y = ft.clientWidth;
    if (ze) {
      Ht = V.x - ke.x + Yt;
      const he = Y * i.length;
      if (Ht > 0)
        Ht = Ht * Y / (Ht + Y * 3);
      else if (-Ht + Y > he) {
        let d = -Ht + Y - he;
        d = d * Y / (d + Y * 3), Ht = Y - he - d;
      }
      br(Ht * 100 / Y);
    } else
      Math.abs(V.y - ke.y) > 10 ? Ot = !0 : !Ot && Math.abs(V.x - ke.x) > 8 && (gr(), ze = !0, ke = V, br(-p * 100), yr(!0));
    ze && v.cancelable && v.preventDefault();
  }
  function ne() {
    Ot = !1, ke = null;
    let v = p;
    if (!ze)
      return;
    ze = !1;
    const V = Math.min(512, ft.clientWidth), Y = Math.abs(Yt - Ht), he = Math.min(1, (Date.now() - ie) / 750);
    Y > V / 4 * he && (v += Yt > Ht ? 1 : -1), v >= i.length ? v = i.length - 1 : v < 0 && (v = 0), v === p ? (e(30, Le = !0), Ht = -v * V, br(-v * 100), kr()) : st(v, !1, !0);
  }
  function we(v, V) {
    return v > i.length - 1 ? V === "ring" ? pi(v, i.length) : i.length - 1 : v < 0 ? V === "ring" ? pi(v, i.length) : 0 : v;
  }
  function it() {
    Wt === "slide" && jn().then(() => {
      const v = De == null ? void 0 : De.querySelector("." + hn.tabs__item_selected);
      if (!v)
        return;
      const V = De.getBoundingClientRect(), Y = v.getBoundingClientRect();
      e(34, Gt = {
        top: `${Y.top - V.top}px`,
        left: `${Y.left - V.left + De.scrollLeft}px`,
        width: `${Y.width}px`,
        height: `${Y.height}px`
      });
    });
  }
  Jn(() => {
    it(), ce.devtoolCreateHierarchy;
  }), bn(() => {
    qe.forEach((v) => {
      v == null || v.destroy();
    }), re && (ce.unregisterInstance(re), e(58, re = void 0));
  });
  const ut = (v, V) => nr(V, v);
  function dt(v) {
    Or[v ? "unshift" : "push"](() => {
      De = v, e(21, De);
    });
  }
  function Cr(v) {
    Or[v ? "unshift" : "push"](() => {
      Mt = v, e(23, Mt);
    });
  }
  function vt(v) {
    Or[v ? "unshift" : "push"](() => {
      ft = v, e(22, ft);
    });
  }
  return t.$$set = (v) => {
    "componentContext" in v && e(0, te = v.componentContext), "layoutParams" in v && e(1, ot = v.layoutParams);
  }, t.$$.update = () => {
    var v, V, Y, he, d, G, Ie, Je, ar, C;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(64, n = te.origJson), t.$$.dirty[2] & /*origJson*/
    4 && n && mr(), t.$$.dirty[0] & /*componentContext*/
    1 && e(61, i = Array.isArray(te.json.items) && te.json.items || []), t.$$.dirty[1] & /*items*/
    1073741824 && e(45, o = i.map((Qe) => {
      var mt;
      return { json: Qe.div, id: (mt = Qe.div) == null ? void 0 : mt.id };
    })), t.$$.dirty[0] & /*componentContext*/
    1 && e(63, s = te.getJsonWithVars(te.json.selected_tab)), t.$$.dirty[0] & /*componentContext*/
    1 && le(e(44, a = te.getDerivedFromVars(te.json.tab_title_style))), t.$$.dirty[0] & /*componentContext*/
    1 && yt(e(43, l = te.getDerivedFromVars(te.json.has_separator))), t.$$.dirty[0] & /*componentContext*/
    1 && Ve(e(42, u = te.getDerivedFromVars(te.json.separator_color))), t.$$.dirty[0] & /*componentContext*/
    1 && We(e(41, c = te.getDerivedFromVars(te.json.separator_paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && nt(e(40, f = te.getDerivedFromVars(te.json.switch_tabs_by_content_swipe_enabled))), t.$$.dirty[0] & /*componentContext*/
    1 && je(e(39, _ = te.getDerivedFromVars(te.json.restrict_parent_scroll))), t.$$.dirty[0] & /*componentContext*/
    1 && O(e(38, g = te.getDerivedFromVars(te.json.title_paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && X(e(37, y = te.getDerivedFromVars(te.json.tab_title_delimiter))), t.$$.dirty[2] & /*jsonSelectedTab*/
    2 && e(17, p = s && Number(s) || 0), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*items*/
    1073741824)
      if (Array.isArray(i) && i.length) {
        let Qe = [];
        i.forEach((mt, lt) => {
          const Dt = te.getJsonWithVars({
            index: lt,
            title: mt.title,
            title_click_action: mt.title_click_action
          });
          Dt.title && typeof Dt.title == "string" ? Qe.push(Dt) : te.logError(R(new Error("Incorrect title for the tab"), { additional: { index: lt } }));
        }), pe.set(Qe);
      } else
        pe.set([]);
    if (t.$$.dirty[0] & /*$childStore, componentContext*/
    262145 && (J != null && J.length ? e(2, $ = !1) : (e(2, $ = !0), te.logError(R(new Error('Incorrect or empty "items" prop for div "tabs"'))))), t.$$.dirty[0] & /*componentContext, childLayoutParams*/
    9) {
      let Qe = { parentContainerOrientation: "horizontal" };
      ((v = te.json.width) == null ? void 0 : v.type) === "wrap_content" && (Qe.parentHorizontalWrapContent = !0), (!te.json.height || te.json.height.type === "wrap_content") && (Qe.parentVerticalWrapContent = !0), e(3, Bt = Ni(Qe, Bt));
    }
    if (t.$$.dirty[0] & /*hasError, selected, componentContext*/
    131077 | t.$$.dirty[1] & /*items*/
    1073741824 && !$ && (p < 0 || p >= i.length) && (te.logError(R(new Error('Incorrect "selected_tab" prop for div "tabs"'), {
      additional: {
        selected: te.json.selected_tab,
        length: i.length
      }
    })), e(17, p = p < 0 ? 0 : i.length - 1)), t.$$.dirty[0] & /*hasError, $childStore, selected, componentContext*/
    393221 && !$ && !J.some((Qe) => p === Qe.index) && (te.logError(R(new Error('Incorrect "selected_tab" prop for div "tabs"'), {
      additional: {
        selected: te.json.selected_tab
      }
    })), e(17, p = ((V = J[0]) == null ? void 0 : V.index) || 0)), t.$$.dirty[2] & /*$jsonTabStyle*/
    8 && e(62, w = M || {}), t.$$.dirty[0] & /*tabFontSize*/
    16 | t.$$.dirty[2] & /*tabStyle*/
    1 && e(4, ht = Gn(w.font_size, ht)), t.$$.dirty[0] & /*tabFontSize, $direction, tabPaddings*/
    524336 | t.$$.dirty[2] & /*tabStyle*/
    1 && (w.font_size || w.paddings)) {
      const Qe = w.paddings || { top: 6, right: 8, bottom: 6, left: 8 }, mt = {
        top: (Number(Qe.top) || 0) / ht * 10,
        right: (Number(_e === "ltr" ? Qe.end : Qe.start) || Number(Qe.right) || 0) / ht * 10,
        bottom: (Number(Qe.bottom) || 0) / ht * 10,
        left: (Number(_e === "ltr" ? Qe.start : Qe.end) || Number(Qe.left) || 0) / ht * 10
      };
      e(5, qt = bs(mt, _e, qt));
    }
    if (t.$$.dirty[0] & /*tabFontSize*/
    16 | t.$$.dirty[2] & /*tabStyle*/
    1) {
      const Qe = w.line_height;
      Qe !== void 0 && Hn(Qe) && e(25, fe = Re(Qe / ht * 10));
    }
    if (t.$$.dirty[0] & /*tabFontSize*/
    16 | t.$$.dirty[2] & /*tabStyle*/
    1) {
      const Qe = w.letter_spacing;
      Qe !== void 0 && zn(Qe) && e(26, Vt = Re(Qe / ht * 10));
    }
    if (t.$$.dirty[0] & /*tabFontSize, tabBorderRadius*/
    80 | t.$$.dirty[2] & /*tabStyle*/
    1 && (w.corner_radius || w.corners_radius || w.font_size)) {
      const Qe = (Y = w.corner_radius) != null ? Y : 1e3;
      w.corners_radius ? e(6, be = _g(w.corners_radius, Qe, ht, be)) : zn(Qe) && e(6, be = Re(Qe / ht * 10));
    }
    t.$$.dirty[0] & /*tabActiveFontWeight*/
    128 | t.$$.dirty[2] & /*tabStyle*/
    1 && (e(7, $e = ho(w.active_font_weight || w.font_weight, void 0, $e)), w.font_family && typeof w.font_family == "string" ? e(27, Ce = ce.typefaceProvider(w.font_family, { fontWeight: $e || 400 })) : e(27, Ce = "")), t.$$.dirty[0] & /*tabInactiveFontWeight*/
    256 | t.$$.dirty[2] & /*tabStyle*/
    1 && (e(8, Xe = ho(w.inactive_font_weight || w.font_weight, void 0, Xe)), w.font_family && typeof w.font_family == "string" ? e(28, Jt = ce.typefaceProvider(w.font_family, { fontWeight: Xe || 400 })) : e(28, Jt = "")), t.$$.dirty[0] & /*tabActiveTextColor*/
    512 | t.$$.dirty[2] & /*tabStyle*/
    1 && e(9, bt = Tr(w.active_text_color, 1, bt)), t.$$.dirty[0] & /*tabInactiveTextColor*/
    1024 | t.$$.dirty[2] & /*tabStyle*/
    1 && e(10, Qt = Tr(w.inactive_text_color, 1, Qt)), t.$$.dirty[0] & /*tabActiveBackground*/
    2048 | t.$$.dirty[2] & /*tabStyle*/
    1 && e(11, rt = Tr(w.active_background_color, 1, rt)), t.$$.dirty[0] & /*tabInactiveBackground*/
    4096 | t.$$.dirty[2] & /*tabStyle*/
    1 && e(12, ir = Tr(w.inactive_background_color, 1, ir)), t.$$.dirty[0] & /*tabItemSpacing*/
    8192 | t.$$.dirty[2] & /*tabStyle*/
    1 && e(13, W = Kr(w.item_spacing, W)), t.$$.dirty[0] & /*$jsonSeparator, $direction*/
    1572864 | t.$$.dirty[1] & /*separatorBackground, separatorMargins*/
    805306368 | t.$$.dirty[2] & /*$jsonSeparatorColor, $jsonSeparatorPaddings*/
    384 && Oe && (Ne && e(59, Et = Tr(Ne, 1, Et)), Me && e(60, It = bs(Me, _e, It))), t.$$.dirty[1] & /*separatorBackground, separatorMargins*/
    805306368 && e(36, E = {
      background: Et,
      margin: It
    }), t.$$.dirty[2] & /*$jsonSwipeEnabled*/
    64 && e(35, Q = typeof U > "u" ? !0 : !!U), t.$$.dirty[0] & /*titlePadding*/
    16384 | t.$$.dirty[2] & /*$jsonTitlePaddings*/
    32 && e(14, Ye = wo(I || void 0, Ye)), t.$$.dirty[0] & /*delimitierStyle*/
    32768 | t.$$.dirty[2] & /*$jsonDelimiterStyle*/
    16 && e(15, wt = dg(H, wt)), t.$$.dirty[2] & /*$jsonTabStyle*/
    8 && ((M == null ? void 0 : M.animation_type) === "fade" || (M == null ? void 0 : M.animation_type) === "none") && e(16, Wt = M.animation_type), t.$$.dirty[2] & /*$jsonTabStyle*/
    8 && zn(M == null ? void 0 : M.animation_duration) && e(33, Lt = M.animation_duration), t.$$.dirty[1] & /*items*/
    1073741824 && Ut(i), t.$$.dirty[0] & /*componentContext, hasError, selected*/
    131077 | t.$$.dirty[1] & /*prevId, items*/
    1207959552 && te.json && (re && (ce.unregisterInstance(re), e(58, re = void 0)), te.id && !$ && !te.fakeElement && (e(58, re = te.id), ce.registerInstance(re, {
      setCurrentItem(Qe, mt) {
        if (Qe < 0 || Qe > i.length - 1)
          throw new Error('Item is out of range in "set-current-item" action');
        st(Qe, !1, mt);
      },
      setPreviousItem(Qe, mt, lt) {
        let Dt = we(p - Qe, mt);
        st(Dt, !1, lt);
      },
      setNextItem(Qe, mt, lt) {
        let Dt = we(p + Qe, mt);
        st(Dt, !1, lt);
      },
      scrollToStart(Qe) {
        st(0, !1, Qe);
      },
      scrollToEnd(Qe) {
        st(i.length - 1, !1, Qe);
      },
      scrollCombined({ step: Qe, overflow: mt, animated: lt }) {
        Qe && st(we(p + Qe, mt || "clamp"), !1, lt || !0);
      }
    }))), t.$$.dirty[0] & /*componentContext, selected, animationType*/
    196609 | t.$$.dirty[1] & /*items*/
    1073741824 && e(24, He = {
      "height-parent": ((he = te.json.height) == null ? void 0 : he.type) === "match_parent" ? "yes" : "",
      "own-height": (((d = te.json.height) == null ? void 0 : d.type) === "match_parent" || ((G = te.json.height) == null ? void 0 : G.type) === "fixed") && !(((ar = (Je = (Ie = i[p]) == null ? void 0 : Ie.div) == null ? void 0 : Je.height) == null ? void 0 : ar.type) === "wrap_content" && ((C = i[p].div) != null && C.height.constrained)),
      animation: Wt
    });
  }, [
    te,
    ot,
    $,
    Bt,
    ht,
    qt,
    be,
    $e,
    Xe,
    bt,
    Qt,
    rt,
    ir,
    W,
    Ye,
    wt,
    Wt,
    p,
    J,
    _e,
    Oe,
    De,
    ft,
    Mt,
    He,
    fe,
    Vt,
    Ce,
    Jt,
    L,
    Le,
    qe,
    Te,
    Lt,
    Gt,
    Q,
    E,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    o,
    ye,
    pt,
    Ct,
    pe,
    or,
    zt,
    nr,
    Ir,
    Er,
    Ze,
    ne,
    it,
    re,
    Et,
    It,
    i,
    w,
    s,
    n,
    M,
    H,
    I,
    U,
    Me,
    Ne,
    ut,
    dt,
    Cr,
    vt
  ];
}
class Ag extends $r {
  constructor(r) {
    super(), xr(this, r, Eg, kg, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1, -1]);
  }
}
const jg = "appkit-state", Cg = "appkit-state_overflow_visible", Sg = "appkit-state__animations", Qi = {
  state: jg,
  state_overflow_visible: Cg,
  state__animations: Sg,
  "state__animation-child": "appkit-state__animation-child",
  "state__animation-child-inner": "appkit-state__animation-child-inner"
};
function Rs(t) {
  return t < 0.5 ? 4 * t * t * t : 0.5 * Math.pow(2 * t - 2, 3) + 1;
}
function Vg(t) {
  return t * t * t;
}
function zf(t) {
  const r = t - 1;
  return r * r * r + 1;
}
function Of(t) {
  return (r) => {
    if (r <= 0)
      return 0;
    if (r >= 1)
      return 1;
    const e = r * t.length, n = Math.floor(e), i = t[n], o = t[n + 1], s = e - n;
    return i * s + o * (1 - s);
  };
}
const Ig = [
  21e-4,
  45e-4,
  71e-4,
  0.01,
  0.0131,
  0.0165,
  0.0202,
  0.0242,
  0.0284,
  0.033,
  0.0378,
  0.0429,
  0.0483,
  0.054,
  0.0601,
  0.0664,
  0.0731,
  0.08,
  0.0872,
  0.0948,
  0.1026,
  0.1108,
  0.1192,
  0.1279,
  0.1369,
  0.1461,
  0.1556,
  0.1653,
  0.1753,
  0.1855,
  0.1958,
  0.2064,
  0.2171,
  0.2279,
  0.2389,
  0.25,
  0.2612,
  0.2725,
  0.2839,
  0.2952,
  0.3067,
  0.3181,
  0.3295,
  0.341,
  0.3524,
  0.3637,
  0.375,
  0.3863,
  0.3974,
  0.4085,
  0.4195,
  0.4304,
  0.4412,
  0.4519,
  0.4624,
  0.4729,
  0.4832,
  0.4934,
  0.5034,
  0.5133,
  0.5231,
  0.5327,
  0.5422,
  0.5516,
  0.5608,
  0.5699,
  0.5788,
  0.5876,
  0.5963,
  0.6048,
  0.6132,
  0.6214,
  0.6295,
  0.6375,
  0.6453,
  0.653,
  0.6606,
  0.668,
  0.6754,
  0.6825,
  0.6896,
  0.6965,
  0.7034,
  0.7101,
  0.7166,
  0.7231,
  0.7295,
  0.7357,
  0.7418,
  0.7479,
  0.7538,
  0.7596,
  0.7653,
  0.7709,
  0.7764,
  0.7818,
  0.7871,
  0.7923,
  0.7974,
  0.8024,
  0.8073,
  0.8122,
  0.8169,
  0.8216,
  0.8261,
  0.8306,
  0.835,
  0.8394,
  0.8436,
  0.8478,
  0.8518,
  0.8558,
  0.8598,
  0.8636,
  0.8674,
  0.8711,
  0.8747,
  0.8783,
  0.8818,
  0.8852,
  0.8886,
  0.8919,
  0.8951,
  0.8983,
  0.9014,
  0.9044,
  0.9074,
  0.9103,
  0.9131,
  0.9159,
  0.9187,
  0.9213,
  0.924,
  0.9265,
  0.929,
  0.9315,
  0.9339,
  0.9362,
  0.9385,
  0.9408,
  0.943,
  0.9451,
  0.9472,
  0.9492,
  0.9512,
  0.9532,
  0.9551,
  0.9569,
  0.9587,
  0.9605,
  0.9622,
  0.9638,
  0.9655,
  0.967,
  0.9686,
  0.9701,
  0.9715,
  0.9729,
  0.9743,
  0.9756,
  0.9769,
  0.9782,
  0.9794,
  0.9805,
  0.9817,
  0.9828,
  0.9838,
  0.9848,
  0.9858,
  0.9868,
  0.9877,
  0.9886,
  0.9894,
  0.9902,
  0.991,
  0.9917,
  0.9924,
  0.9931,
  0.9937,
  0.9943,
  0.9949,
  0.9954,
  0.9959,
  0.9964,
  0.9969,
  0.9973,
  0.9977,
  0.998,
  0.9983,
  0.9986,
  0.9989,
  0.9991,
  0.9993,
  0.9995,
  0.9997,
  0.9998,
  0.9999,
  0.9999,
  1,
  1
], Dg = Of(Ig), Tg = [
  5e-4,
  2e-3,
  45e-4,
  78e-4,
  0.0119,
  0.0168,
  0.0224,
  0.0286,
  0.0355,
  0.0429,
  0.0508,
  0.0592,
  0.0681,
  0.0774,
  0.087,
  0.0969,
  0.1072,
  0.1177,
  0.1285,
  0.1395,
  0.1507,
  0.1621,
  0.1736,
  0.1853,
  0.197,
  0.2089,
  0.2208,
  0.2328,
  0.2448,
  0.2569,
  0.2689,
  0.281,
  0.293,
  0.305,
  0.317,
  0.3289,
  0.3408,
  0.3526,
  0.3644,
  0.376,
  0.3876,
  0.3991,
  0.4105,
  0.4218,
  0.433,
  0.444,
  0.455,
  0.4658,
  0.4765,
  0.4871,
  0.4975,
  0.5078,
  0.518,
  0.528,
  0.5379,
  0.5477,
  0.5573,
  0.5668,
  0.5761,
  0.5853,
  0.5944,
  0.6033,
  0.612,
  0.6206,
  0.6291,
  0.6374,
  0.6456,
  0.6537,
  0.6616,
  0.6693,
  0.677,
  0.6845,
  0.6918,
  0.699,
  0.7061,
  0.713,
  0.7199,
  0.7265,
  0.7331,
  0.7395,
  0.7458,
  0.752,
  0.758,
  0.764,
  0.7698,
  0.7755,
  0.781,
  0.7865,
  0.7918,
  0.7971,
  0.8022,
  0.8072,
  0.8121,
  0.8169,
  0.8216,
  0.8262,
  0.8307,
  0.8351,
  0.8394,
  0.8436,
  0.8477,
  0.8517,
  0.8557,
  0.8595,
  0.8633,
  0.8669,
  0.8705,
  0.874,
  0.8775,
  0.8808,
  0.8841,
  0.8873,
  0.8904,
  0.8934,
  0.8964,
  0.8993,
  0.9022,
  0.9049,
  0.9076,
  0.9103,
  0.9129,
  0.9154,
  0.9178,
  0.9202,
  0.9226,
  0.9249,
  0.9271,
  0.9293,
  0.9314,
  0.9335,
  0.9355,
  0.9375,
  0.9394,
  0.9413,
  0.9431,
  0.9449,
  0.9466,
  0.9483,
  0.95,
  0.9516,
  0.9532,
  0.9547,
  0.9562,
  0.9576,
  0.9591,
  0.9605,
  0.9618,
  0.9631,
  0.9644,
  0.9657,
  0.9669,
  0.9681,
  0.9692,
  0.9703,
  0.9714,
  0.9725,
  0.9736,
  0.9746,
  0.9756,
  0.9765,
  0.9775,
  0.9784,
  0.9793,
  0.9802,
  0.981,
  0.9818,
  0.9826,
  0.9834,
  0.9842,
  0.9849,
  0.9856,
  0.9863,
  0.987,
  0.9877,
  0.9883,
  0.989,
  0.9896,
  0.9902,
  0.9908,
  0.9913,
  0.9919,
  0.9924,
  0.993,
  0.9935,
  0.994,
  0.9944,
  0.9949,
  0.9954,
  0.9958,
  0.9963,
  0.9967,
  0.9971,
  0.9975,
  0.9979,
  0.9983,
  0.9986,
  0.999,
  0.9993,
  0.9997,
  1
], Fg = Of(Tg), dl = {
  linear: Ss,
  ease: Dg,
  ease_in: Vg,
  ease_out: zf,
  ease_in_out: Rs,
  spring: Fg
};
function Ul(t) {
  return dl[t];
}
const Lf = 200, Rf = 0, Mg = 0, Pg = 0;
function bu(t) {
  return Math.max(...t.map(
    (r) => (Number(r.duration) || Lf) + (Number(r.start_delay) || Rf)
  ));
}
function Ng(t, {
  transitions: r,
  elementBbox: e,
  rootBbox: n,
  direction: i,
  maxDuration: o,
  alpha: s
}) {
  const a = s != null ? s : 1;
  return {
    duration: Os() ? 0 : o,
    css: (l) => {
      const u = l * o, c = r.map((E) => {
        var ee, X, I;
        const Q = Number(E.start_delay) || Rf, J = Number(E.duration) || Lf, M = Math.max(0, Math.min(1, (u - Q) / J)), ge = i === "in" ? 1 - M : M, H = (Ul(E.interpolator || "ease_in_out") || Rs)(ge);
        if (E.type === "fade")
          return H >= 1 ? {
            active: !1,
            opacity: 0
          } : {
            active: H > 0 && H < 1,
            opacity: (1 - H) * a + H * (E.alpha || Mg)
          };
        if (E.type === "slide") {
          const P = E.edge === "top" || E.edge === "left" ? -1 : 1, O = E.edge === "top" || E.edge === "bottom" || !E.edge ? "translateY" : "translateX";
          let U = (ee = E.distance) == null ? void 0 : ee.value;
          U === void 0 && (E.edge === "top" || E.edge === "bottom" || !E.edge ? U = Math.abs(
            n[E.edge === "bottom" ? "bottom" : "top"] - e[E.edge === "bottom" ? "top" : "bottom"]
          ) : U = Math.abs(
            n[E.edge === "left" ? "left" : "right"] - e[E.edge === "left" ? "right" : "left"]
          ));
          const me = U * H;
          return {
            active: H > 0 && H < 1,
            translate: `${O}(${me * P}px)`
          };
        } else if (E.type === "scale") {
          const P = 1 - H + H * (E.scale || Pg), O = (X = E.pivot_x) != null ? X : 0.5, U = (I = E.pivot_y) != null ? I : 0.5, me = (1 - P) * e.width * O, nt = (1 - P) * e.height * U;
          return {
            active: H > 0 && H < 1,
            scale: `translate(${me}px, ${nt}px) scale(${P})`
          };
        }
        return {};
      }), f = c.map((E) => E.opacity).filter((E) => E !== void 0).reduce((E, Q) => E * Q, 1), _ = c.map((E) => E.translate).filter((E) => E !== void 0).join(" "), g = c.map((E) => E.scale).filter((E) => E !== void 0).join(" "), y = c.filter((E) => E.active).map((E) => E.scale).filter((E) => E !== void 0), p = y.length ? y[y.length - 1] : g;
      return `transform:${[_, p].filter(Boolean).join(" ") || "none"};opacity:${f}`;
    }
  };
}
function Si(t, r, e) {
  return t * (1 - e) + r * e;
}
const zg = 200, Og = 0;
function Lg(t, {
  rootBbox: r,
  beforeBbox: e,
  afterBbox: n,
  transition: i
}) {
  var o, s;
  return {
    delay: (o = i.start_delay) != null ? o : Og,
    duration: Os() ? 0 : (s = i.duration) != null ? s : zg,
    easing: i.interpolator && i.interpolator in dl ? dl[i.interpolator] : Rs,
    css: (a) => [
      `top:${Si(e.top, n.top, a) - r.top}px`,
      `left:${Si(e.left, n.left, a) - r.left}px`,
      `width:${Si(e.width, n.width, a)}px`,
      `height:${Si(e.height, n.height, a)}px`
    ].join(";")
  };
}
function Bf(t) {
  const r = [];
  return t.type === "set" ? (t.items || []).forEach((e) => {
    r.push(...Bf(e));
  }) : r.push(t), r;
}
const { Map: Rg } = wi;
function yu(t, r, e) {
  const n = t.slice();
  return n[37] = r[e], n;
}
function Bg(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Hg(t) {
  let r, e;
  const n = [
    {
      cls: jt(
        "state",
        Qi,
        /*mods*/
        t[8]
      )
    },
    {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    },
    { layoutParams: (
      /*layoutParams*/
      t[1]
    ) },
    { parentOf: (
      /*parentOfItems*/
      t[9]
    ) },
    { parentOfSimpleMode: !0 },
    { replaceItems: (
      /*replaceItems*/
      t[12]
    ) },
    /*devapi*/
    t[11]
  ];
  let i = {
    $$slots: { default: [Gg] },
    $$scope: { ctx: t }
  };
  for (let o = 0; o < n.length; o += 1)
    i = ui(i, n[o]);
  return r = new On({ props: i }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(o, s) {
      Kt(r, o, s), e = !0;
    },
    p(o, s) {
      const a = s[0] & /*mods, componentContext, layoutParams, parentOfItems, replaceItems, devapi*/
      6915 ? vi(n, [
        s[0] & /*mods*/
        256 && {
          cls: jt(
            "state",
            Qi,
            /*mods*/
            o[8]
          )
        },
        s[0] & /*componentContext*/
        1 && {
          componentContext: (
            /*componentContext*/
            o[0]
          )
        },
        s[0] & /*layoutParams*/
        2 && { layoutParams: (
          /*layoutParams*/
          o[1]
        ) },
        s[0] & /*parentOfItems*/
        512 && { parentOf: (
          /*parentOfItems*/
          o[9]
        ) },
        n[4],
        s[0] & /*replaceItems*/
        4096 && { replaceItems: (
          /*replaceItems*/
          o[12]
        ) },
        s[0] & /*devapi*/
        2048 && vf(
          /*devapi*/
          o[11]
        )
      ]) : {};
      s[0] & /*animationRoot, animationList, selectedId, selectedComponentContext, childContexts*/
      248 | s[1] & /*$$scope*/
      4096 && (a.$$scope = { dirty: s, ctx: o }), r.$set(a);
    },
    i(o) {
      e || (K(r.$$.fragment, o), e = !0);
    },
    o(o) {
      ae(r.$$.fragment, o), e = !1;
    },
    d(o) {
      Xt(r, o);
    }
  };
}
function wu(t) {
  let r = (
    /*selectedId*/
    t[5]
  ), e, n, i = vu(t);
  return {
    c() {
      i.c(), e = $t();
    },
    m(o, s) {
      i.m(o, s), x(o, e, s), n = !0;
    },
    p(o, s) {
      s[0] & /*selectedId*/
      32 && Vr(r, r = /*selectedId*/
      o[5]) ? (_r(), ae(i, 1, 1, T), pr(), i = vu(o), i.c(), K(i, 1), i.m(e.parentNode, e)) : i.p(o, s);
    },
    i(o) {
      n || (K(i), n = !0);
    },
    o(o) {
      ae(i), n = !1;
    },
    d(o) {
      o && Z(e), i.d(o);
    }
  };
}
function vu(t) {
  let r, e;
  return r = new ti({
    props: {
      componentContext: (
        /*selectedComponentContext*/
        t[6]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*selectedComponentContext*/
      64 && (o.componentContext = /*selectedComponentContext*/
      n[6]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Wg(t) {
  let r, e, n, i, o, s, a, l;
  n = new ti({
    props: {
      componentContext: (
        /*item*/
        t[37].componentContextCopy
      )
    }
  });
  function u() {
    return (
      /*introend_handler_1*/
      t[22](
        /*item*/
        t[37]
      )
    );
  }
  return {
    c() {
      r = Be("div"), e = Be("div"), Zt(n.$$.fragment), i = wr(), m(e, "class", Qi["state__animation-child-inner"]), m(r, "class", Qi["state__animation-child"]);
    },
    m(c, f) {
      x(c, r, f), Tt(r, e), Kt(n, e, null), Tt(r, i), s = !0, a || (l = Ge(r, "introend", u), a = !0);
    },
    p(c, f) {
      t = c;
      const _ = {};
      f[0] & /*animationList*/
      16 && (_.componentContext = /*item*/
      t[37].componentContextCopy), n.$set(_);
    },
    i(c) {
      s || (K(n.$$.fragment, c), o || Yn(() => {
        o = Ps(
          r,
          Lg,
          /*item*/
          t[37]
        ), o.start();
      }), s = !0);
    },
    o(c) {
      ae(n.$$.fragment, c), s = !1;
    },
    d(c) {
      c && Z(r), Xt(n), a = !1, l();
    }
  };
}
function Ug(t) {
  let r, e, n, i, o, s = `${/*item*/
  t[37].offsetLeft}px`, a = `${/*item*/
  t[37].offsetTop}px`, l = `${/*item*/
  t[37].width}px`, u = `${/*item*/
  t[37].height}px`, c, f, _;
  n = new ti({
    props: {
      componentContext: (
        /*item*/
        t[37].componentContextCopy
      )
    }
  });
  function g() {
    return (
      /*introend_handler*/
      t[21](
        /*item*/
        t[37]
      )
    );
  }
  return {
    c() {
      r = Be("div"), e = Be("div"), Zt(n.$$.fragment), i = wr(), m(e, "class", Qi["state__animation-child-inner"]), m(r, "class", Qi["state__animation-child"]), q(r, "left", s), q(r, "top", a), q(r, "width", l), q(r, "height", u);
    },
    m(y, p) {
      x(y, r, p), Tt(r, e), Kt(n, e, null), Tt(r, i), c = !0, f || (_ = Ge(r, "introend", g), f = !0);
    },
    p(y, p) {
      t = y;
      const w = {};
      p[0] & /*animationList*/
      16 && (w.componentContext = /*item*/
      t[37].componentContextCopy), n.$set(w), p[0] & /*animationList*/
      16 && s !== (s = `${/*item*/
      t[37].offsetLeft}px`) && q(r, "left", s), p[0] & /*animationList*/
      16 && a !== (a = `${/*item*/
      t[37].offsetTop}px`) && q(r, "top", a), p[0] & /*animationList*/
      16 && l !== (l = `${/*item*/
      t[37].width}px`) && q(r, "width", l), p[0] & /*animationList*/
      16 && u !== (u = `${/*item*/
      t[37].height}px`) && q(r, "height", u);
    },
    i(y) {
      c || (K(n.$$.fragment, y), o || Yn(() => {
        o = Ps(
          r,
          Ng,
          /*item*/
          t[37]
        ), o.start();
      }), c = !0);
    },
    o(y) {
      ae(n.$$.fragment, y), c = !1;
    },
    d(y) {
      y && Z(r), Xt(n), f = !1, _();
    }
  };
}
function ku(t, r) {
  let e, n, i, o, s;
  const a = [Ug, Wg], l = [];
  function u(c, f) {
    return "direction" in /*item*/
    c[37] ? 0 : 1;
  }
  return n = u(r), i = l[n] = a[n](r), {
    key: t,
    first: null,
    c() {
      e = $t(), i.c(), o = $t(), this.first = e;
    },
    m(c, f) {
      x(c, e, f), l[n].m(c, f), x(c, o, f), s = !0;
    },
    p(c, f) {
      r = c;
      let _ = n;
      n = u(r), n === _ ? l[n].p(r, f) : (_r(), ae(l[_], 1, 1, () => {
        l[_] = null;
      }), pr(), i = l[n], i ? i.p(r, f) : (i = l[n] = a[n](r), i.c()), K(i, 1), i.m(o.parentNode, o));
    },
    i(c) {
      s || (K(i), s = !0);
    },
    o(c) {
      ae(i), s = !1;
    },
    d(c) {
      c && (Z(e), Z(o)), l[n].d(c);
    }
  };
}
function Gg(t) {
  let r, e, n, i = [], o = new Rg(), s, a = !1, l = (
    /*selectedComponentContext*/
    t[6] && wu(t)
  ), u = lr(
    /*animationList*/
    t[4]
  );
  const c = (f) => (
    /*item*/
    f[37]
  );
  for (let f = 0; f < u.length; f += 1) {
    let _ = yu(t, u, f), g = c(_);
    o.set(g, i[f] = ku(g, _));
  }
  return {
    c() {
      r = wr(), l && l.c(), e = wr(), n = Be("div");
      for (let f = 0; f < i.length; f += 1)
        i[f].c();
      m(n, "class", Qi.state__animations), m(n, "aria-hidden", "true");
    },
    m(f, _) {
      x(f, r, _), l && l.m(f, _), x(f, e, _), x(f, n, _);
      for (let g = 0; g < i.length; g += 1)
        i[g] && i[g].m(n, null);
      t[23](n), s = !0;
    },
    p(f, _) {
      /*selectedComponentContext*/
      f[6] ? l ? (l.p(f, _), _[0] & /*selectedComponentContext*/
      64 && K(l, 1)) : (l = wu(f), l.c(), K(l, 1), l.m(e.parentNode, e)) : l && (_r(), ae(l, 1, 1, () => {
        l = null;
      }), pr()), _[0] & /*animationList, onOutro*/
      8208 && (u = lr(
        /*animationList*/
        f[4]
      ), _r(), i = wf(i, _, c, 1, f, u, o, n, yf, ku, null, yu), pr());
    },
    i(f) {
      if (!s) {
        K(a), K(l);
        for (let _ = 0; _ < u.length; _ += 1)
          K(i[_]);
        s = !0;
      }
    },
    o(f) {
      ae(a), ae(l);
      for (let _ = 0; _ < i.length; _ += 1)
        ae(i[_]);
      s = !1;
    },
    d(f) {
      f && (Z(r), Z(e), Z(n)), l && l.d(f);
      for (let _ = 0; _ < i.length; _ += 1)
        i[_].d();
      t[23](null);
    }
  };
}
function Yg(t) {
  let r, e, n, i;
  const o = [Hg, Bg], s = [];
  function a(l, u) {
    return (
      /*hasError*/
      l[2] ? -1 : 0
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function qg(t) {
  return t.some((r) => r.type === "fade");
}
function Hf(t) {
  return t.type === "change_bounds" ? t : t.type === "set" ? Hf(t.items[0]) : null;
}
function Jg(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g = T, y = () => (g(), g = B(o, (ye) => e(20, _ = ye)), o);
  t.$$.on_destroy.push(() => g());
  let { componentContext: p } = r, { layoutParams: w = void 0 } = r;
  const E = Xr(_n);
  let Q = !1, J, M = /* @__PURE__ */ new Map(), ge = /* @__PURE__ */ new Set(), le = [], H = [], ee = [], X = [], I, P, O, U, me = !1, nt;
  function _e() {
    e(15, me = !1);
  }
  function Me(ye) {
    O && O.destroy(), e(6, O = ye != null && ye.div ? p.produceChildContext(ye.div, {
      path: ye.state_id || "<unknown>"
    }) : void 0);
  }
  function tt(ye) {
    const Ke = p.json.states;
    if (!Ke)
      return;
    const je = /* @__PURE__ */ new Set();
    e(16, u = Ke.map((te, ot) => (u[ot].div !== ye[ot] && te.state_id && je.add(te.state_id), { ...te, div: ye[ot] }))), e(0, p.json = { ...p.json, states: u }, p), P && je.has(P) && Me(u.find((te) => te.state_id === P) || null);
  }
  function We(ye, Ke, je) {
    let { json: te, parentComponentContext: ot, transitions: ce, node: pt } = Ke;
    te = p.getJsonWithVars(te), ce = p.getJsonWithVars(ce);
    const Ct = Bf(ce), re = Ke.bbox || pt.getBoundingClientRect(), $ = {
      ...te,
      margins: void 0,
      alpha: qg(Ct) ? void 0 : te.alpha
    };
    return {
      id: ot.id || "",
      json: $,
      componentContextCopy: ot.produceChildContext($, { fake: ua }),
      elementBbox: re,
      rootBbox: ye,
      transitions: Ct,
      alpha: te.alpha,
      width: re.width,
      height: re.height,
      offsetTop: re.top - ye.top,
      offsetLeft: re.left - ye.left,
      direction: je,
      resolvePromise: Ke.resolvePromise,
      node: Ke.node
    };
  }
  async function Ne(ye) {
    if (P === ye)
      return p;
    E.setRunning("stateChange", !0);
    const Ke = new Set(ge);
    le.forEach(($) => {
      $.resolvePromise && $.resolvePromise();
    }), e(4, le = []);
    let je = [];
    if (J) {
      const $ = J.getBoundingClientRect();
      je = ee.map((pe) => We($, pe, "out"));
    }
    X.forEach(($) => {
      $.transitions && M.set($.id, {
        transitions: $.transitions,
        rect: $.node.getBoundingClientRect()
      });
    }), H = [], ee = [], X = [];
    const te = u.find(($) => $.state_id === ye) || null;
    if (te ? (e(5, P = ye), a == null || a.setValue(P), Me(te)) : p.logError(R(new Error("Cannot find state with id"), { additional: { stateId: ye } })), await jn(), !J)
      return;
    const ot = J.getBoundingClientRect();
    let ce = H.filter(($) => {
      var pe;
      return $.parentComponentContext.id && !Ke.has($.parentComponentContext.id) ? !0 : ((pe = $.resolvePromise) == null || pe.call($), !1);
    }).map(($) => We(ot, $, "in"));
    je = je.filter(($) => {
      var pe;
      return $.id && !ge.has($.id) ? !0 : ((pe = $.resolvePromise) == null || pe.call($), !1);
    });
    const pt = je.concat(ce), Ct = pt.reduce(
      ($, pe) => Math.max($, bu(pe.transitions)),
      0
    ), re = X.filter(($) => M.has($.id)).map(($) => {
      const pe = {
        ...$.json,
        margins: void 0,
        width: { type: "match_parent" },
        height: { type: "match_parent" }
      }, Bt = M.get($.id);
      return {
        id: $.parentComponentContext.id || "",
        json: pe,
        componentContextCopy: $.parentComponentContext.produceChildContext(pe, { fake: ua }),
        rootBbox: ot,
        beforeBbox: Bt.rect,
        afterBbox: $.node.getBoundingClientRect(),
        node: $.node,
        transition: p.getJsonWithVars(Hf(Bt.transitions)),
        resolvePromise: $.resolvePromise
      };
    });
    return e(4, le = [
      ...pt.map(($) => ({ ...$, maxDuration: Ct })),
      ...re
    ]), M.clear(), E.setRunning("stateChange", !1), p;
  }
  Yi(Pl, {
    // eslint-disable-next-line max-params
    runVisibilityTransition(ye, Ke, je, te, ot, ce) {
      if (!J)
        return Promise.resolve();
      const pt = J.getBoundingClientRect(), Ct = We(
        pt,
        {
          json: ye,
          parentComponentContext: Ke,
          transitions: je,
          node: te,
          bbox: ce
        },
        ot
      ), re = bu(Ct.transitions), $ = { ...Ct, maxDuration: re };
      return e(4, le = [...le.filter((pe) => pe.node !== Ct.node), $]), new Promise((pe) => {
        $.resolvePromise = pe;
      });
    },
    registerChildWithTransitionIn(ye, Ke, je, te) {
      const ot = {
        json: ye,
        parentComponentContext: Ke,
        transitions: je,
        node: te
      };
      return H.push(ot), new Promise((ce) => {
        ot.resolvePromise = ce;
      });
    },
    registerChildWithTransitionOut(ye, Ke, je, te) {
      const ot = {
        json: ye,
        parentComponentContext: Ke,
        transitions: je,
        node: te
      };
      return ee.push(ot), new Promise((ce) => {
        ot.resolvePromise = ce;
      });
    },
    registerChildWithTransitionChange(ye, Ke, je, te) {
      const ot = Ke.id;
      if (!ot)
        return Promise.resolve();
      const ce = {
        id: ot,
        json: ye,
        parentComponentContext: Ke,
        transitions: je,
        node: te
      };
      return X.push(ce), new Promise((pt) => {
        ce.resolvePromise = pt;
      });
    },
    hasTransitionChange(ye) {
      return ye ? M.has(ye) : !1;
    },
    registerChild(ye) {
      ge.add(ye);
    },
    unregisterChild(ye) {
      ge.delete(ye);
    }
  });
  function Ft(ye) {
    if (!me && (e(15, me = !0), ye.length)) {
      const Ke = (a == null ? void 0 : a.getValue()) || i;
      if (Ke) {
        e(5, P = Ke);
        const je = ye.find((te) => te.state_id === P) || null;
        Me(je), je || p.logError(R(new Error("Cannot find state for default_state_id"), { additional: { selectedId: P } }));
      } else {
        const je = ye[0];
        e(5, P = je.state_id), Me(je);
      }
      a && (a.setValue(P), a.subscribe((je) => {
        Ne(je);
      }));
    }
  }
  function Ve(ye) {
    e(4, le = le.filter((Ke) => Ke !== ye)), ye.resolvePromise && ye.resolvePromise();
  }
  bn(() => {
    O && O.destroy(), I && (I(), e(14, I = void 0));
  });
  const Oe = (ye) => Ve(ye), Pe = (ye) => Ve(ye);
  function yt(ye) {
    Or[ye ? "unshift" : "push"](() => {
      J = ye, e(3, J);
    });
  }
  return t.$$set = (ye) => {
    "componentContext" in ye && e(0, p = ye.componentContext), "layoutParams" in ye && e(1, w = ye.layoutParams);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*componentContext*/
    1 && e(17, n = p.json.div_id || p.id), t.$$.dirty[0] & /*componentContext*/
    1 && (i = p.getJsonWithVars(p.json.default_state_id)), t.$$.dirty[0] & /*componentContext*/
    1 && y(e(10, o = p.getDerivedFromVars(p.json.clip_to_bounds))), t.$$.dirty[0] & /*componentContext*/
    1 && e(19, s = p.json.state_id_variable), t.$$.dirty[0] & /*stateVariableName, componentContext*/
    524289 && (a = s ? p.getVariable(s, "string") || E.awaitGlobalVariable(s, "string", "") : null), t.$$.dirty[0] & /*componentContext*/
    1 && e(18, l = p.origJson), t.$$.dirty[0] & /*origJson*/
    262144 && l && _e(), t.$$.dirty[0] & /*stateId, componentContext*/
    131073 && (n ? e(2, Q = !1) : (e(2, Q = !0), p.logError(R(new Error('Missing "id" prop for div "state"'))))), t.$$.dirty[0] & /*componentContext*/
    1 && p.json && (ge = /* @__PURE__ */ new Set()), t.$$.dirty[0] & /*componentContext*/
    1 && e(16, u = Array.isArray(p.json.states) && p.json.states || []), t.$$.dirty[0] & /*items*/
    65536 && e(9, c = u.map((ye) => {
      var Ke;
      return { json: ye.div, id: (Ke = ye.div) == null ? void 0 : Ke.id };
    })), t.$$.dirty[0] & /*items, componentContext*/
    65537 && (u != null && u.length ? e(2, Q = !1) : (e(2, Q = !0), p.logError(R(new Error('Empty "states" prop for div "state"'))))), t.$$.dirty[0] & /*componentContext, stateUnregister, stateId*/
    147457 && p.json && (I && (I(), e(14, I = void 0)), n && !(p != null && p.fakeElement) && e(14, I = p.registerState(n, Ne))), t.$$.dirty[0] & /*inited, items*/
    98304 && !me && Ft(u), t.$$.dirty[0] & /*$jsonClipToBounds*/
    1048576 && e(8, f = {
      overflow: _ === !1 || _ === 0 ? "visible" : void 0
    });
  }, [
    p,
    w,
    Q,
    J,
    le,
    P,
    O,
    U,
    f,
    c,
    o,
    nt,
    tt,
    Ve,
    I,
    me,
    u,
    n,
    l,
    s,
    _,
    Oe,
    Pe,
    yt
  ];
}
class Kg extends $r {
  constructor(r) {
    super(), xr(this, r, Jg, Yg, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1]);
  }
}
const Xg = "appkit-pager", Zg = "appkit-pager__items", Qg = "appkit-pager_animated", xg = "appkit-pager__item", $g = "appkit-pager_clip", e0 = "appkit-pager_orientation_horizontal", t0 = "appkit-pager_orientation_vertical", r0 = "appkit-pager__item_height_content", n0 = "appkit-pager__item_height_fixed", i0 = "appkit-pager__item_width_content", o0 = "appkit-pager__item_width_fixed", s0 = "appkit-pager__arrow", bi = {
  pager: Xg,
  pager__items: Zg,
  pager_animated: Qg,
  pager__item: xg,
  "pager_scroll-align_start": "appkit-pager_scroll-align_start",
  "pager_scroll-align_center": "appkit-pager_scroll-align_center",
  "pager_scroll-align_end": "appkit-pager_scroll-align_end",
  pager_clip: $g,
  pager_orientation_horizontal: e0,
  pager_orientation_vertical: t0,
  "pager_cross-align_center": "appkit-pager_cross-align_center",
  "pager_cross-align_end": "appkit-pager_cross-align_end",
  pager__item_height_content: r0,
  pager__item_height_fixed: n0,
  "pager__item_height-constrained": "appkit-pager__item_height-constrained",
  pager__item_width_content: i0,
  pager__item_width_fixed: o0,
  "pager__item_width-constrained": "appkit-pager__item_width-constrained",
  pager__arrow: s0,
  "pager__arrow-icon-path": "appkit-pager__arrow-icon-path"
}, { window: l0 } = wi;
function Eu(t, r, e) {
  const n = t.slice();
  return n[93] = r[e], n;
}
function a0(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function u0(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "pager",
        bi,
        /*mods*/
        t[13]
      ),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      customPaddings: !0,
      parentOf: (
        /*items*/
        t[3]
      ),
      replaceItems: (
        /*replaceItems*/
        t[30]
      ),
      $$slots: { default: [d0] },
      $$scope: { ctx: t }
    }
  }), r.$on(
    "pointerdown",
    /*onPointerDown*/
    t[35]
  ), r.$on(
    "wheel",
    /*onWheel*/
    t[36]
  ), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      8192 && (o.cls = jt(
        "pager",
        bi,
        /*mods*/
        n[13]
      )), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*items*/
      8 && (o.parentOf = /*items*/
      n[3]), i[0] & /*$direction, hasScrollRight, shouldCheckArrows, hasScrollLeft, $jsonRestrictParentScroll, style, pagerItemsWrapper, visibleItems, orientation, childLayoutParams*/
      16801492 | i[3] & /*$$scope*/
      8 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Au(t) {
  let r, e, n, i, o, s, a;
  return e = new ti({
    props: {
      componentContext: (
        /*item*/
        t[93].componentContext
      ),
      layoutParams: (
        /*childLayoutParams*/
        t[9]
      )
    }
  }), {
    c() {
      r = Be("div"), Zt(e.$$.fragment), n = wr(), m(r, "class", i = jt("pager__item", bi, Su(
        /*orientation*/
        t[2],
        /*item*/
        t[93]
      ))), m(r, "role", "tabpanel"), m(r, "id", o = /*instId*/
      t[26] + "-panel-" + /*item*/
      t[93].index), m(r, "aria-labelledby", s = /*instId*/
      t[26] + "-tab-" + /*item*/
      t[93].index);
    },
    m(l, u) {
      x(l, r, u), Kt(e, r, null), Tt(r, n), a = !0;
    },
    p(l, u) {
      const c = {};
      u[0] & /*visibleItems*/
      16 && (c.componentContext = /*item*/
      l[93].componentContext), u[0] & /*childLayoutParams*/
      512 && (c.layoutParams = /*childLayoutParams*/
      l[9]), e.$set(c), (!a || u[0] & /*orientation, visibleItems*/
      20 && i !== (i = jt("pager__item", bi, Su(
        /*orientation*/
        l[2],
        /*item*/
        l[93]
      )))) && m(r, "class", i), (!a || u[0] & /*visibleItems*/
      16 && o !== (o = /*instId*/
      l[26] + "-panel-" + /*item*/
      l[93].index)) && m(r, "id", o), (!a || u[0] & /*visibleItems*/
      16 && s !== (s = /*instId*/
      l[26] + "-tab-" + /*item*/
      l[93].index)) && m(r, "aria-labelledby", s);
    },
    i(l) {
      a || (K(e.$$.fragment, l), a = !0);
    },
    o(l) {
      ae(e.$$.fragment, l), a = !1;
    },
    d(l) {
      l && Z(r), Xt(e);
    }
  };
}
function ju(t) {
  let r, e, n, i = !/*leftClass*/
  t[27] && c0();
  return {
    c() {
      r = Be("div"), i && i.c(), m(
        r,
        "class",
        /*leftClass*/
        t[27] || `${bi.pager__arrow} ${$n.arrow} ${$n.arrow_left}`
      );
    },
    m(o, s) {
      x(o, r, s), i && i.m(r, null), e || (n = Ge(
        r,
        "click",
        /*click_handler*/
        t[68]
      ), e = !0);
    },
    p: T,
    d(o) {
      o && Z(r), i && i.d(), e = !1, n();
    }
  };
}
function c0(t) {
  let r, e;
  return {
    c() {
      r = En("svg"), e = En("path"), m(e, "class", bi["pager__arrow-icon-path"]), m(e, "d", "m10 16 8.3 8 1.03-1-4-6-.7-1 .7-1 4-6-1.03-1z"), m(r, "class", $n.arrow__icon), m(r, "xmlns", "http://www.w3.org/2000/svg"), m(r, "width", "32"), m(r, "height", "32"), m(r, "viewBox", "0 0 32 32"), m(r, "fill", "none");
    },
    m(n, i) {
      x(n, r, i), Tt(r, e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function Cu(t) {
  let r, e, n, i = !/*rightClass*/
  t[28] && f0();
  return {
    c() {
      r = Be("div"), i && i.c(), m(
        r,
        "class",
        /*rightClass*/
        t[28] || `${bi.pager__arrow} ${$n.arrow} ${$n.arrow_right}`
      );
    },
    m(o, s) {
      x(o, r, s), i && i.m(r, null), e || (n = Ge(
        r,
        "click",
        /*click_handler_1*/
        t[69]
      ), e = !0);
    },
    p: T,
    d(o) {
      o && Z(r), i && i.d(), e = !1, n();
    }
  };
}
function f0(t) {
  let r, e;
  return {
    c() {
      r = En("svg"), e = En("path"), m(e, "class", bi["pager__arrow-icon-path"]), m(e, "d", "M22 16l-8.3 8-1.03-1 4-6 .7-1-.7-1-4-6 1.03-1 8.3 8z"), m(r, "class", $n.arrow__icon), m(r, "xmlns", "http://www.w3.org/2000/svg"), m(r, "width", "32"), m(r, "height", "32"), m(r, "viewBox", "0 0 32 32"), m(r, "fill", "none");
    },
    m(n, i) {
      x(n, r, i), Tt(r, e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function d0(t) {
  let r, e, n, i, o, s, a, l, u, c = lr(
    /*visibleItems*/
    t[4]
  ), f = [];
  for (let p = 0; p < c.length; p += 1)
    f[p] = Au(Eu(t, c, p));
  const _ = (p) => ae(f[p], 1, 1, () => {
    f[p] = null;
  });
  let g = (
    /*hasScrollLeft*/
    t[11] && /*shouldCheckArrows*/
    t[12] && ju(t)
  ), y = (
    /*hasScrollRight*/
    t[10] && /*shouldCheckArrows*/
    t[12] && Cu(t)
  );
  return {
    c() {
      r = Be("div");
      for (let p = 0; p < f.length; p += 1)
        f[p].c();
      i = wr(), g && g.c(), o = wr(), y && y.c(), s = $t(), m(r, "class", e = bi.pager__items + " " + /*$jsonRestrictParentScroll*/
      (t[24] ? ur["root_restrict-scroll"] : "")), m(r, "style", n = Rt(
        /*style*/
        t[14]
      ));
    },
    m(p, w) {
      x(p, r, w);
      for (let E = 0; E < f.length; E += 1)
        f[E] && f[E].m(r, null);
      t[67](r), x(p, i, w), g && g.m(p, w), x(p, o, w), y && y.m(p, w), x(p, s, w), a = !0, l || (u = [
        Ge(
          r,
          "transitionend",
          /*onTransitionEnd*/
          t[37]
        ),
        Ge(
          r,
          "focus",
          /*onFocus*/
          t[33],
          !0
        ),
        Ge(
          r,
          "click",
          /*onItemsClick*/
          t[34],
          !0
        )
      ], l = !0);
    },
    p(p, w) {
      if (w[0] & /*orientation, visibleItems, instId, childLayoutParams*/
      67109396) {
        c = lr(
          /*visibleItems*/
          p[4]
        );
        let E;
        for (E = 0; E < c.length; E += 1) {
          const Q = Eu(p, c, E);
          f[E] ? (f[E].p(Q, w), K(f[E], 1)) : (f[E] = Au(Q), f[E].c(), K(f[E], 1), f[E].m(r, null));
        }
        for (_r(), E = c.length; E < f.length; E += 1)
          _(E);
        pr();
      }
      (!a || w[0] & /*$jsonRestrictParentScroll*/
      16777216 && e !== (e = bi.pager__items + " " + /*$jsonRestrictParentScroll*/
      (p[24] ? ur["root_restrict-scroll"] : ""))) && m(r, "class", e), (!a || w[0] & /*style*/
      16384 && n !== (n = Rt(
        /*style*/
        p[14]
      ))) && m(r, "style", n), /*hasScrollLeft*/
      p[11] && /*shouldCheckArrows*/
      p[12] ? g ? g.p(p, w) : (g = ju(p), g.c(), g.m(o.parentNode, o)) : g && (g.d(1), g = null), /*hasScrollRight*/
      p[10] && /*shouldCheckArrows*/
      p[12] ? y ? y.p(p, w) : (y = Cu(p), y.c(), y.m(s.parentNode, s)) : y && (y.d(1), y = null);
    },
    i(p) {
      if (!a) {
        for (let w = 0; w < c.length; w += 1)
          K(f[w]);
        a = !0;
      }
    },
    o(p) {
      f = f.filter(Boolean);
      for (let w = 0; w < f.length; w += 1)
        ae(f[w]);
      a = !1;
    },
    d(p) {
      p && (Z(r), Z(i), Z(o), Z(s)), gn(f, p), t[67](null), g && g.d(p), y && y.d(p), l = !1, Qr(u);
    }
  };
}
function _0(t) {
  let r, e, n, i, o, s;
  const a = [u0, a0], l = [];
  function u(c, f) {
    return (
      /*hasError*/
      c[5] ? -1 : 0
    );
  }
  return ~(r = u(t)) && (e = l[r] = a[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(c, f) {
      ~r && l[r].m(c, f), x(c, n, f), i = !0, o || (s = Ge(
        l0,
        "resize",
        /*resnap*/
        t[38]
      ), o = !0);
    },
    p(c, f) {
      let _ = r;
      r = u(c), r === _ ? ~r && l[r].p(c, f) : (e && (_r(), ae(l[_], 1, 1, () => {
        l[_] = null;
      }), pr()), ~r ? (e = l[r], e ? e.p(c, f) : (e = l[r] = a[r](c), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(c) {
      i || (K(e), i = !0);
    },
    o(c) {
      ae(e), i = !1;
    },
    d(c) {
      c && Z(n), ~r && l[r].d(c), o = !1, s();
    }
  };
}
const Lo = {
  wrap_content: "content",
  fixed: "fixed",
  match_parent: "parent"
}, ni = 2, p0 = 400, h0 = 8;
function Su(t, r) {
  var n, i, o, s;
  if (t === "horizontal") {
    const a = ((n = r.height) == null ? void 0 : n.type) || "";
    return {
      height: a in Lo ? Lo[a] : "content",
      "height-constrained": ((i = r.height) == null ? void 0 : i.type) === "wrap_content" ? Tn(r.height.constrained, !1) : !1
    };
  }
  const e = ((o = r.width) == null ? void 0 : o.type) || "";
  return {
    width: e in Lo ? Lo[e] : "parent",
    "width-constrained": ((s = r.width) == null ? void 0 : s.type) === "wrap_content" ? Tn(r.width.constrained, !1) : !1
  };
}
function g0(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H = T, ee = () => (H(), H = B(c, (v) => e(58, le = v)), c), X, I = T, P = () => (I(), I = B(o, (v) => e(59, X = v)), o), O, U = T, me = () => (U(), U = B(f, (v) => e(60, O = v)), f), nt, _e = T, Me = () => (_e(), _e = B(l, (v) => e(61, nt = v)), l), tt, We = T, Ne = () => (We(), We = B(a, (v) => e(62, tt = v)), a), Ft, Ve = T, Oe = () => (Ve(), Ve = B(s, (v) => e(63, Ft = v)), s), Pe, yt = T, ye = () => (yt(), yt = B($e, (v) => e(64, Pe = v)), $e), Ke, je = T, te = () => (je(), je = B(i, (v) => e(65, Ke = v)), i), ot, ce = T, pt = () => (ce(), ce = B(_, (v) => e(66, ot = v)), _), Ct, re = T, $ = () => (re(), re = B(u, (v) => e(24, Ct = v)), u);
  t.$$.on_destroy.push(() => H()), t.$$.on_destroy.push(() => I()), t.$$.on_destroy.push(() => U()), t.$$.on_destroy.push(() => _e()), t.$$.on_destroy.push(() => We()), t.$$.on_destroy.push(() => Ve()), t.$$.on_destroy.push(() => yt()), t.$$.on_destroy.push(() => je()), t.$$.on_destroy.push(() => ce()), t.$$.on_destroy.push(() => re());
  let { componentContext: pe } = r, { layoutParams: Bt = void 0 } = r;
  const De = Xr(_n), ft = De.direction;
  mn(t, ft, (v) => e(6, M = v));
  const Mt = De.genId("pager"), He = De.getCustomization("pagerLeftClass"), ht = De.getCustomization("pagerRightClass"), qt = De.isDesktop;
  mn(t, qt, (v) => e(57, ge = v));
  let fe, Vt, be = !1, $e, Ce = 0, Xe = 0, Jt = !1, bt = "horizontal", Qt = "0em", rt = {}, ir = "", W = "", Et = {}, It = "start", Ye = "center", L = [], Le = 0, gt = [], qe = {}, Te = {}, cr, ke, hr = 0, ie = !1, ze = !1, Ot = !1, Yt = !1, Ht = 0, wt = "", Wt = 0, Lt;
  function Gt() {
    e(43, rt = {}), e(9, Et = {}), e(46, It = "start"), e(47, Ye = "center"), e(51, ie = !1), e(52, ze = !1), Yt = !1;
  }
  function tr(v) {
    e(0, pe = e(50, cr = {
      ...pe,
      json: {
        ...pe.json,
        items: v.filter(ki)
      }
    }));
  }
  function or(v, V) {
    ke && ke.update({
      instId: Mt,
      currentItem: Te[V],
      size: v,
      scrollToPagerItem(Y) {
        st(qe[Y]);
      }
    });
  }
  function mr(v) {
    var Y;
    if (v === Xe || (Xe = v, !L[v]))
      return;
    const V = (Y = L[v].json) == null ? void 0 : Y.selected_actions;
    V != null && V.length && pe.execAnyActions(V);
  }
  function zt(v) {
    const V = ze ? !1 : v === 0, Y = ze ? !1 : v === gt.length - 1, he = bt === "horizontal", d = Vt.children[v + (ze ? ni : 0)];
    if (!d)
      return 0;
    const G = he ? "offsetLeft" : "offsetTop", Ie = he ? "offsetWidth" : "offsetHeight", Je = Ir(), ar = jr(), C = kr(), Qe = gr();
    return Je >= Qe + ar + C || V ? 0 : Y ? (Je - ar - C - Qe) * (M === "rtl" ? -1 : 1) : Ye === "start" && M === "ltr" || Ye === "end" && M === "rtl" ? -(d[G] - ar) : Ye === "end" && M === "ltr" || Ye === "start" && M === "rtl" ? -(d[G] + d[Ie] - Je + C) : Vt[Ie] / 2 - (d[G] + d[Ie] / 2);
  }
  function Ut(v, V) {
    if (!Vt)
      return;
    const Y = zt(v);
    e(53, Ot = V), jn().then(() => {
      var he;
      Ht = Y, e(54, wt = et(Ht)), e(40, Ce = (he = qe[v]) != null ? he : 0), Yt = ze && (v < 0 || v >= Le);
    });
  }
  function st(v, V = !0) {
    var Y;
    Ut((Y = Te[v]) != null ? Y : 0, V);
  }
  function et(v) {
    return `${bt === "horizontal" ? "translateX" : "translateY"}(${dn(v)})`;
  }
  function nr(v, V) {
    return ze && v >= -ni && v < Le + ni ? v : v > gt.length - 1 ? V === "ring" ? pi(v, gt.length) : gt.length - 1 : v < 0 ? V === "ring" ? pi(v, gt.length) : 0 : v;
  }
  function Ar(v, V, Y) {
    const he = nr(Te[Ce] - v, V);
    Ut(he, Y);
  }
  function br(v, V, Y) {
    const he = nr(Te[Ce] + v, V);
    Ut(he, Y);
  }
  function yr() {
    ke == null || ke.destroy(), ke = void 0, fe && (De.unregisterInstance(fe), fe = void 0), pe.fakeElement || (ke = pe.registerPager(pe.id || void 0)), pe.id && !pe.fakeElement && (fe = pe.id, De.registerInstance(
      fe,
      {
        setCurrentItem(v, V) {
          if (v < 0 || v > L.length - 1)
            throw new Error('Item is out of range in "set-current-item" action');
          st(v, V);
        },
        setPreviousItem: Ar,
        setNextItem: br,
        scrollToStart(v) {
          st(gt[ze ? ni : 0].index, v);
        },
        scrollToEnd(v) {
          st(gt[gt.length - 1 - (ze ? ni : 0)].index, v);
        },
        scrollCombined({ step: v, overflow: V, animated: Y }) {
          v && st(nr(Te[Ce] + v, V || "clamp"), Y);
        }
      },
      "warn"
    ));
  }
  function jr() {
    var V, Y, he;
    return bt === "horizontal" ? (Y = (V = rt.start) != null ? V : M === "ltr" ? rt.left : rt.right) != null ? Y : 0 : (he = rt.top) != null ? he : 0;
  }
  function kr() {
    var V, Y, he;
    return bt === "horizontal" ? (Y = (V = rt.end) != null ? V : M === "ltr" ? rt.right : rt.left) != null ? Y : 0 : (he = rt.bottom) != null ? he : 0;
  }
  function Ir() {
    var V, Y;
    return Vt ? bt === "horizontal" ? ((V = Vt.parentElement) == null ? void 0 : V.offsetWidth) || 0 : ((Y = Vt.parentElement) == null ? void 0 : Y.offsetHeight) || 0 : 0;
  }
  function gr() {
    const v = bt === "horizontal", V = Array.from(Vt.children), Y = V[0].getBoundingClientRect(), he = V[V.length - 1].getBoundingClientRect();
    return v ? M === "rtl" ? Y.right - he.left : he.right - Y.left : he.bottom - Y.top;
  }
  function Er(v) {
    const V = v.target;
    if (!(V instanceof Element) || !Vt)
      return;
    let Y = V;
    for (; Y.parentElement && Y.parentElement !== Vt; )
      Y = Y.parentElement;
    if (!Y)
      return;
    const he = Array.from(Vt.children).indexOf(Y);
    if (he < 0)
      return;
    const d = he - (ze ? ni : 0);
    Ut(d, !0);
  }
  function Ze(v) {
    Date.now() - Wt < 300 && (v.preventDefault(), v.stopImmediatePropagation());
  }
  function ne(v) {
    if (!De.pagerMouseDragEnabled && v.pointerType === "mouse")
      return;
    const V = bt === "horizontal", Y = V ? v.pageX : v.pageY, he = Ht, d = Ir() - jr() - kr(), G = gr(), Ie = Date.now(), Je = (C) => {
      const Qe = V ? C.pageX : C.pageY;
      let mt = he + Qe - Y;
      if (!ze) {
        if (M === "rtl") {
          if (mt < 0)
            mt = mt * d / (mt + d * 3);
          else if (mt + d > G) {
            let lt = mt + d - G;
            lt = lt * d / (lt + d * 3), mt = -d + G + lt;
          }
        } else if (M === "ltr") {
          if (mt > 0)
            mt = mt * d / (mt + d * 3);
          else if (-mt + d > G) {
            let lt = -mt + d - G;
            lt = lt * d / (lt + d * 3), mt = d - G - lt;
          }
        }
      }
      Ht = mt, e(54, wt = et(Ht)), C.preventDefault();
    }, ar = (C) => {
      Lt == null || Lt(), Lt = void 0;
      const Qe = Math.min(512, d), mt = Math.abs(he - Ht);
      if (mt < h0) {
        Ut(Te[Ce], !0);
        return;
      }
      C.preventDefault(), Wt = Date.now();
      const lt = Math.min(1, (Date.now() - Ie) / 750);
      let Dt = Te[Ce];
      mt > Qe / 4 * lt && (Dt += (he > Ht ? 1 : -1) * (M === "rtl" ? -1 : 1)), ze || (Dt >= gt.length ? Dt = gt.length - 1 : Dt < 0 && (Dt = 0)), Ut(Dt, !0);
    };
    window.addEventListener("pointermove", Je), window.addEventListener("pointerup", ar), window.addEventListener("pointercancel", ar), Lt == null || Lt(), Lt = () => {
      window.removeEventListener("pointermove", Je), window.removeEventListener("pointerup", ar), window.removeEventListener("pointercancel", ar);
    };
  }
  function we(v) {
    if (!v.deltaX || Math.abs(v.deltaX) < Math.abs(v.deltaY))
      return;
    const V = Date.now();
    if (V - hr < p0)
      return;
    hr = V, (M === "rtl" ? -1 : 1) * v.deltaX > 0 ? br(1, "clamp", !0) : Ar(1, "clamp", !0);
  }
  function it() {
    e(53, Ot = !1), Yt && jn().then(() => {
      st(Ce, !1);
    });
  }
  function ut() {
    jn().then(() => {
      st(Ce, !1);
    });
  }
  Jn(() => {
    e(39, be = !0), Vt && st(Ce, !1);
  }), bn(() => {
    e(39, be = !1), Lt == null || Lt(), L.forEach((v) => {
      v.destroy();
    }), fe && (De.unregisterInstance(fe), fe = void 0), ke == null || ke.destroy(), ke = void 0;
  });
  function dt(v) {
    Or[v ? "unshift" : "push"](() => {
      Vt = v, e(7, Vt);
    });
  }
  const Cr = () => (M === "ltr" ? Ar : br)(1, "clamp", !0), vt = () => (M === "ltr" ? br : Ar)(1, "clamp", !0);
  return t.$$set = (v) => {
    "componentContext" in v && e(0, pe = v.componentContext), "layoutParams" in v && e(1, Bt = v.layoutParams);
  }, t.$$.update = () => {
    var v, V, Y, he, d;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(56, n = pe.origJson), t.$$.dirty[1] & /*origJson*/
    33554432 && n && Gt(), t.$$.dirty[0] & /*componentContext*/
    1 && te(e(23, i = typeof ((v = pe.json.item_builder) == null ? void 0 : v.data) == "string" ? pe.getDerivedFromVars((V = pe.json.item_builder) == null ? void 0 : V.data, void 0, !0) : (Y = pe.json.item_builder) != null && Y.data ? Ji(pe.json.item_builder.data) : void 0)), t.$$.dirty[0] & /*componentContext*/
    1 && P(e(22, o = pe.getDerivedFromVars(pe.json.layout_mode))), t.$$.dirty[0] & /*componentContext*/
    1 && Oe(e(21, s = pe.getDerivedFromVars(pe.json.orientation))), t.$$.dirty[0] & /*componentContext*/
    1 && Ne(e(20, a = pe.getDerivedFromVars(pe.json.item_spacing))), t.$$.dirty[0] & /*componentContext*/
    1 && Me(e(19, l = pe.getDerivedFromVars(pe.json.paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && $(e(18, u = pe.getDerivedFromVars(pe.json.restrict_parent_scroll))), t.$$.dirty[0] & /*componentContext*/
    1 && ee(e(17, c = pe.getDerivedFromVars(pe.json.cross_axis_alignment))), t.$$.dirty[0] & /*componentContext*/
    1 && me(e(16, f = pe.getDerivedFromVars(pe.json.scroll_axis_alignment))), t.$$.dirty[0] & /*componentContext*/
    1 && pt(e(15, _ = pe.getDerivedFromVars(pe.json.infinite_scroll))), t.$$.dirty[1] & /*infinite*/
    1048576 | t.$$.dirty[2] & /*$jsonInfiniteScroll*/
    16 && e(51, ie = Tn(ot, ie)), t.$$.dirty[0] & /*componentContext, items*/
    9 | t.$$.dirty[1] & /*prevContext*/
    524288 | t.$$.dirty[2] & /*$jsonItemBuilderData*/
    8) {
      let G = [];
      if (pe.json.item_builder && Array.isArray(Ke) && Array.isArray(pe.json.item_builder.prototypes)) {
        const C = pe.json.item_builder;
        G = Hl(Ke, De, pe, C);
      } else
        G = (Array.isArray(pe.json.items) && pe.json.items || []).map((C, Qe) => ({
          div: C,
          key: C.id || { index: Qe, data: C }
        }));
      const Ie = new Set(L), Je = /* @__PURE__ */ new Map();
      let ar = !1;
      cr === pe && L.forEach((C) => {
        C.key && (typeof C.key == "string" && Je.has(C.key) ? ar || (ar = !0, pe.logError(R(new Error("Duplicate key for child elements inside item_builder"), { additional: { key: C.key } }))) : Je.set(
          typeof C.key == "string" ? C.key : C.key.index,
          C
        ));
      }), e(3, L = G.map((C, Qe) => {
        let mt = !ar && Je.get(C.id), lt = Je.get(Qe);
        return !mt && !C.id && typeof C.key == "object" && typeof (lt == null ? void 0 : lt.key) == "object" && yo(lt.key.data, C.key.data) && (mt = lt), mt ? (Ie.delete(mt), mt) : pe.produceChildContext(C.div, {
          path: Qe,
          variables: C.vars,
          id: C.id,
          key: C.key
        });
      }));
      for (const C of Ie)
        C.destroy();
      e(50, cr = pe);
    }
    if (t.$$.dirty[0] & /*items, componentContext*/
    9) {
      let G = [];
      L.forEach((Ie) => {
        G.push(pe.getDerivedFromVars({
          width: Ie.json.width,
          height: Ie.json.height,
          visibility: Ie.json.visibility
        }));
      }), ye(e(8, $e = bo(G, (Ie) => [...Ie])));
    }
    if (t.$$.dirty[0] & /*items, visibleItems*/
    24 | t.$$.dirty[1] & /*infinite*/
    1048576 | t.$$.dirty[2] & /*$childStore*/
    4) {
      if (e(49, Te = {}), qe = {}, e(4, gt = Pe.map((G, Ie) => ({
        width: G.width,
        height: G.height,
        index: Ie,
        componentContext: L[Ie]
      })).filter((G, Ie) => Pe[Ie].visibility !== "gone")), gt.forEach((G, Ie) => {
        qe[Ie] = G.index, e(49, Te[G.index] = Ie, Te);
      }), e(48, Le = gt.length), ie && gt.length >= ni) {
        const G = gt.slice(0, ni).map((Je) => ({
          ...Je,
          componentContext: Je.componentContext.dup(Oi),
          duplicate: !0
        })), Ie = gt.slice(gt.length - ni).map((Je) => ({
          ...Je,
          componentContext: Je.componentContext.dup(Oi),
          duplicate: !0
        }));
        G.forEach((Je, ar) => {
          qe[gt.length + ar] = ar;
        }), Ie.forEach((Je, ar) => {
          qe[ar - ni] = gt.length - ni + ar;
        }), e(4, gt = [].concat(Ie, gt, G)), e(52, ze = !0);
      } else
        e(52, ze = !1);
      ut();
    }
    if (t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*$jsonLayoutMode*/
    268435456 && (X ? X.type !== "percentage" && X.type !== "fixed" && X.type !== "wrap_content" ? (e(41, Jt = !0), pe.logError(R(new Error('Incorrect value of "layout_mode.type" for div "pager"')))) : e(41, Jt = !1) : (e(41, Jt = !0), pe.logError(R(new Error('Empty "layout_mode" prop for div "pager"'))))), t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[2] & /*$jsonOrientation*/
    2 && e(2, bt = Wl(Ft, bt)), t.$$.dirty[2] & /*$jsonItemSpacing*/
    1) {
      const G = tt == null ? void 0 : tt.value;
      G && zn(G) && e(42, Qt = dn(G || 0));
    }
    if (t.$$.dirty[0] & /*$direction*/
    64 | t.$$.dirty[1] & /*$jsonPaddings, paddingObj*/
    1073745920 && (e(43, rt = wo(nt, rt)), e(44, ir = li(rt, M))), t.$$.dirty[0] & /*orientation*/
    4 && e(55, g = bt === "horizontal" ? "grid-auto-columns" : "grid-auto-rows"), t.$$.dirty[1] & /*$jsonScrollAxisAlignment*/
    536870912 && (O === "start" || O === "center" || O === "end") && (e(47, Ye = O), ut()), t.$$.dirty[0] & /*orientation, $direction*/
    68 | t.$$.dirty[1] & /*paddingObj, $jsonLayoutMode, scrollAxisAlignment, itemSpacing*/
    268507136) {
      const G = dn(bt === "horizontal" ? (rt == null ? void 0 : rt.start) || (M === "ltr" ? rt == null ? void 0 : rt.left : rt == null ? void 0 : rt.right) || 0 : (rt == null ? void 0 : rt.top) || 0), Ie = dn(bt === "horizontal" ? (rt == null ? void 0 : rt.end) || (M === "ltr" ? rt == null ? void 0 : rt.right : rt == null ? void 0 : rt.left) || 0 : (rt == null ? void 0 : rt.bottom) || 0);
      if ((X == null ? void 0 : X.type) === "fixed") {
        const Je = ((he = X.neighbour_page_width) == null ? void 0 : he.value) || 0;
        Ye === "center" ? e(45, W = `calc(100% + ${G} + ${Ie} - 2 * ${dn(Je)} - 2 * ${Qt})`) : Ye === "start" ? e(45, W = `calc(100% + ${Ie} - ${dn(Je)} - ${Qt})`) : e(45, W = `calc(100% + ${G} - ${dn(Je)} - ${Qt})`);
      } else if ((X == null ? void 0 : X.type) === "percentage") {
        let Je = (d = X.page_width) == null ? void 0 : d.value;
        (typeof Je != "number" || Je < 0) && (Je = 100), e(45, W = `calc(${(Je / 100).toFixed(2)} * (100% + ${G} + ${Ie}))`);
      } else
        (X == null ? void 0 : X.type) === "wrap_content" && e(45, W = "minmax(max-content, auto)");
    }
    if (t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[1] & /*$jsonCrossAxisAlignment, crossAxisAlignment*/
    134250496 && (le === "start" || le === "center" || le === "end") && (e(46, It = le), e(9, Et = {
      [bt === "horizontal" ? "parentVAlign" : "parentHAlign"]: It
    })), t.$$.dirty[1] & /*itemSpacing, padding, gridSizeProp, sizeVal, transformStr*/
    25192448 && e(14, y = {
      "grid-gap": Qt,
      padding: ir,
      [g]: W,
      transform: wt
    }), t.$$.dirty[0] & /*orientation*/
    4 | t.$$.dirty[1] & /*animated, crossAxisAlignment, scrollAxisAlignment*/
    4292608 && e(13, p = {
      animated: Ot,
      clip: De.pagerChildrenClipEnabled,
      orientation: bt,
      "cross-align": It,
      "scroll-align": Ye
    }), t.$$.dirty[1] & /*hasLayoutModeError*/
    1024 && e(5, w = Jt), t.$$.dirty[0] & /*hasError*/
    32 | t.$$.dirty[1] & /*$isDesktop, mounted*/
    67109120 && e(12, E = ge && be && !w), t.$$.dirty[0] & /*componentContext, items*/
    9 && pe.json) {
      const G = pe.getJsonWithVars(pe.json.default_item);
      typeof G == "number" && G >= 0 && G < L.length && (e(40, Ce = Xe = G), or(L.length, G)), yr();
    }
    t.$$.dirty[0] & /*$direction, visibleItems*/
    80 | t.$$.dirty[1] & /*hasDuplicates, allToVisibleMap, currentItem*/
    2359808 && e(11, Q = ze || (M === "ltr" ? Te[Ce] > 0 : Te[Ce] + 1 < gt.length)), t.$$.dirty[0] & /*$direction, visibleItems*/
    80 | t.$$.dirty[1] & /*hasDuplicates, allToVisibleMap, currentItem*/
    2359808 && e(10, J = ze || (M === "ltr" ? Te[Ce] + 1 < gt.length : Te[Ce] > 0)), t.$$.dirty[1] & /*visibleItemsWithOutDuplicates, currentItem*/
    131584 && or(Le, Ce), t.$$.dirty[1] & /*currentItem*/
    512 && mr(Ce);
  }, [
    pe,
    Bt,
    bt,
    L,
    gt,
    w,
    M,
    Vt,
    $e,
    Et,
    J,
    Q,
    E,
    p,
    y,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    i,
    Ct,
    ft,
    Mt,
    He,
    ht,
    qt,
    tr,
    Ar,
    br,
    Er,
    Ze,
    ne,
    we,
    it,
    ut,
    be,
    Ce,
    Jt,
    Qt,
    rt,
    ir,
    W,
    It,
    Ye,
    Le,
    Te,
    cr,
    ie,
    ze,
    Ot,
    wt,
    g,
    n,
    ge,
    le,
    X,
    O,
    nt,
    tt,
    Ft,
    Pe,
    Ke,
    ot,
    dt,
    Cr,
    vt
  ];
}
class m0 extends $r {
  constructor(r) {
    super(), xr(this, r, g0, _0, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1, -1]);
  }
}
const b0 = "appkit-indicator", y0 = "appkit-indicator_visible", w0 = "appkit-indicator__scroller", v0 = "appkit-indicator__items", k0 = "appkit-indicator__item", E0 = "appkit-indicator_placement_default", A0 = "appkit-indicator__item_active", j0 = "appkit-indicator_direction_ltr", C0 = "appkit-indicator_direction_rtl", S0 = "appkit-indicator_placement_stretch", xi = {
  indicator: b0,
  indicator_visible: y0,
  indicator__scroller: w0,
  indicator__items: v0,
  indicator__item: k0,
  indicator_placement_default: E0,
  indicator__item_active: A0,
  indicator_direction_ltr: j0,
  indicator_direction_rtl: C0,
  indicator_placement_stretch: S0
};
function Vu(t, r, e) {
  const n = t.slice();
  n[43] = r[e], n[46] = e;
  const i = (
    /*index*/
    n[46] === /*pagerData*/
    n[8].currentItem
  );
  return n[44] = i, n;
}
function Iu(t) {
  let r, e = lr(Array(
    /*pagerData*/
    t[8].size
  )), n = [];
  for (let i = 0; i < e.length; i += 1)
    n[i] = Du(Vu(t, e, i));
  return {
    c() {
      for (let i = 0; i < n.length; i += 1)
        n[i].c();
      r = $t();
    },
    m(i, o) {
      for (let s = 0; s < n.length; s += 1)
        n[s] && n[s].m(i, o);
      x(i, r, o);
    },
    p(i, o) {
      if (o[0] & /*pagerData, onIndicatorItemClick, onIndicatorItemKeydown*/
      6291712) {
        e = lr(Array(
          /*pagerData*/
          i[8].size
        ));
        let s;
        for (s = 0; s < e.length; s += 1) {
          const a = Vu(i, e, s);
          n[s] ? n[s].p(a, o) : (n[s] = Du(a), n[s].c(), n[s].m(r.parentNode, r));
        }
        for (; s < n.length; s += 1)
          n[s].d(1);
        n.length = e.length;
      }
    },
    d(i) {
      i && Z(r), gn(n, i);
    }
  };
}
function Du(t) {
  let r, e, n, i, o, s, a, l;
  function u() {
    return (
      /*click_handler*/
      t[34](
        /*index*/
        t[46]
      )
    );
  }
  return {
    c() {
      r = Be("div"), m(r, "class", e = jt("indicator__item", xi, { active: (
        /*isActiveItem*/
        t[44]
      ) }) + " " + ur.root__clickable), m(r, "role", "tab"), m(r, "id", n = /*pagerData*/
      t[8].instId + "-tab-" + /*index*/
      t[46]), m(r, "aria-controls", i = /*pagerData*/
      t[8].instId + "-panel-" + /*index*/
      t[46]), m(r, "aria-selected", o = /*isActiveItem*/
      t[44] ? "true" : "false"), m(r, "tabindex", s = /*isActiveItem*/
      t[44] ? 0 : -1);
    },
    m(c, f) {
      x(c, r, f), a || (l = [
        Ge(r, "click", u),
        Ge(
          r,
          "keydown",
          /*onIndicatorItemKeydown*/
          t[22]
        )
      ], a = !0);
    },
    p(c, f) {
      t = c, f[0] & /*pagerData*/
      256 && e !== (e = jt("indicator__item", xi, { active: (
        /*isActiveItem*/
        t[44]
      ) }) + " " + ur.root__clickable) && m(r, "class", e), f[0] & /*pagerData*/
      256 && n !== (n = /*pagerData*/
      t[8].instId + "-tab-" + /*index*/
      t[46]) && m(r, "id", n), f[0] & /*pagerData*/
      256 && i !== (i = /*pagerData*/
      t[8].instId + "-panel-" + /*index*/
      t[46]) && m(r, "aria-controls", i), f[0] & /*pagerData*/
      256 && o !== (o = /*isActiveItem*/
      t[44] ? "true" : "false") && m(r, "aria-selected", o), f[0] & /*pagerData*/
      256 && s !== (s = /*isActiveItem*/
      t[44] ? 0 : -1) && m(r, "tabindex", s);
    },
    d(c) {
      c && Z(r), a = !1, Qr(l);
    }
  };
}
function V0(t) {
  let r, e, n = (
    /*pagerData*/
    t[8] && Iu(t)
  );
  return {
    c() {
      r = Be("div"), e = Be("div"), n && n.c(), m(e, "class", xi.indicator__items), m(e, "role", "tablist"), q(
        e,
        "margin",
        /*placement*/
        t[4] === "default" ? `0 ${Re(Math.max(
          0,
          /*activeStyle*/
          t[2].width - /*inactiveStyle*/
          t[3].width
        ) / 2)}` : ""
      ), q(e, "--divkit-indicator-inactive-width", Re(
        /*inactiveStyle*/
        t[3].width
      )), q(e, "--divkit-indicator-inactive-height", Re(
        /*inactiveStyle*/
        t[3].height
      )), q(e, "--divkit-indicator-inactive-border-radius", Re(
        /*inactiveStyle*/
        t[3].borderRadius
      )), q(
        e,
        "--divkit-indicator-inactive-background",
        /*inactiveStyle*/
        t[3].background || ""
      ), q(
        e,
        "--divkit-indicator-inactive-box-shadow",
        /*inactiveStyle*/
        t[3].boxShadow || ""
      ), q(e, "--divkit-indicator-active-width", Re(
        /*activeStyle*/
        t[2].width
      )), q(e, "--divkit-indicator-active-height", Re(
        /*activeStyle*/
        t[2].height
      )), q(e, "--divkit-indicator-active-border-radius", Re(
        /*activeStyle*/
        t[2].borderRadius
      )), q(
        e,
        "--divkit-indicator-active-background",
        /*activeStyle*/
        t[2].background || ""
      ), q(
        e,
        "--divkit-indicator-active-box-shadow",
        /*activeStyle*/
        t[2].boxShadow || ""
      ), q(
        e,
        "--divkit-indicator-active-scale",
        /*activeStyle*/
        t[2].width / /*inactiveStyle*/
        t[3].width
      ), q(
        e,
        "--divkit-indicator-default-margin",
        /*placement*/
        t[4] === "default" ? `0 ${Re(
          /*spaceBetweenCenters*/
          (t[5] - /*inactiveStyle*/
          t[3].width) / 2
        )}` : ""
      ), q(
        e,
        "--divkit-indicator-stretch-margin",
        /*placement*/
        t[4] === "stretch" ? Re(
          /*itemSpacing*/
          t[7]
        ) : ""
      ), q(
        e,
        "--divkit-indicator-stretch-max-count",
        /*placement*/
        t[4] === "stretch" ? (
          /*maxVisibleItems*/
          t[6]
        ) : ""
      ), q(
        e,
        "--divkit-indicator-stretch-max-spacer",
        /*placement*/
        t[4] === "stretch" ? Re(
          /*maxVisibleItems*/
          (t[6] - 1) * /*itemSpacing*/
          t[7]
        ) : ""
      ), m(r, "class", xi.indicator__scroller);
    },
    m(i, o) {
      x(i, r, o), Tt(r, e), n && n.m(e, null), t[35](e), t[36](r);
    },
    p(i, o) {
      /*pagerData*/
      i[8] ? n ? n.p(i, o) : (n = Iu(i), n.c(), n.m(e, null)) : n && (n.d(1), n = null), o[0] & /*placement, activeStyle, inactiveStyle*/
      28 && q(
        e,
        "margin",
        /*placement*/
        i[4] === "default" ? `0 ${Re(Math.max(
          0,
          /*activeStyle*/
          i[2].width - /*inactiveStyle*/
          i[3].width
        ) / 2)}` : ""
      ), o[0] & /*inactiveStyle*/
      8 && q(e, "--divkit-indicator-inactive-width", Re(
        /*inactiveStyle*/
        i[3].width
      )), o[0] & /*inactiveStyle*/
      8 && q(e, "--divkit-indicator-inactive-height", Re(
        /*inactiveStyle*/
        i[3].height
      )), o[0] & /*inactiveStyle*/
      8 && q(e, "--divkit-indicator-inactive-border-radius", Re(
        /*inactiveStyle*/
        i[3].borderRadius
      )), o[0] & /*inactiveStyle*/
      8 && q(
        e,
        "--divkit-indicator-inactive-background",
        /*inactiveStyle*/
        i[3].background || ""
      ), o[0] & /*inactiveStyle*/
      8 && q(
        e,
        "--divkit-indicator-inactive-box-shadow",
        /*inactiveStyle*/
        i[3].boxShadow || ""
      ), o[0] & /*activeStyle*/
      4 && q(e, "--divkit-indicator-active-width", Re(
        /*activeStyle*/
        i[2].width
      )), o[0] & /*activeStyle*/
      4 && q(e, "--divkit-indicator-active-height", Re(
        /*activeStyle*/
        i[2].height
      )), o[0] & /*activeStyle*/
      4 && q(e, "--divkit-indicator-active-border-radius", Re(
        /*activeStyle*/
        i[2].borderRadius
      )), o[0] & /*activeStyle*/
      4 && q(
        e,
        "--divkit-indicator-active-background",
        /*activeStyle*/
        i[2].background || ""
      ), o[0] & /*activeStyle*/
      4 && q(
        e,
        "--divkit-indicator-active-box-shadow",
        /*activeStyle*/
        i[2].boxShadow || ""
      ), o[0] & /*activeStyle, inactiveStyle*/
      12 && q(
        e,
        "--divkit-indicator-active-scale",
        /*activeStyle*/
        i[2].width / /*inactiveStyle*/
        i[3].width
      ), o[0] & /*placement, spaceBetweenCenters, inactiveStyle*/
      56 && q(
        e,
        "--divkit-indicator-default-margin",
        /*placement*/
        i[4] === "default" ? `0 ${Re(
          /*spaceBetweenCenters*/
          (i[5] - /*inactiveStyle*/
          i[3].width) / 2
        )}` : ""
      ), o[0] & /*placement, itemSpacing*/
      144 && q(
        e,
        "--divkit-indicator-stretch-margin",
        /*placement*/
        i[4] === "stretch" ? Re(
          /*itemSpacing*/
          i[7]
        ) : ""
      ), o[0] & /*placement, maxVisibleItems*/
      80 && q(
        e,
        "--divkit-indicator-stretch-max-count",
        /*placement*/
        i[4] === "stretch" ? (
          /*maxVisibleItems*/
          i[6]
        ) : ""
      ), o[0] & /*placement, maxVisibleItems, itemSpacing*/
      208 && q(
        e,
        "--divkit-indicator-stretch-max-spacer",
        /*placement*/
        i[4] === "stretch" ? Re(
          /*maxVisibleItems*/
          (i[6] - 1) * /*itemSpacing*/
          i[7]
        ) : ""
      );
    },
    d(i) {
      i && Z(r), n && n.d(), t[35](null), t[36](null);
    }
  };
}
function I0(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "indicator",
        xi,
        /*mods*/
        t[11]
      ),
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      $$slots: { default: [V0] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      2048 && (o.cls = jt(
        "indicator",
        xi,
        /*mods*/
        n[11]
      )), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*scroller, indicatorItemsWrapper, placement, activeStyle, inactiveStyle, spaceBetweenCenters, itemSpacing, maxVisibleItems, pagerData*/
      2044 | i[1] & /*$$scope*/
      65536 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
const el = ["rounded_rectangle", "circle"];
function D0(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p = T, w = () => (p(), p = B(c, (be) => e(26, y = be)), c), E, Q = T, J = () => (Q(), Q = B(f, (be) => e(27, E = be)), f), M, ge = T, le = () => (ge(), ge = B(o, (be) => e(28, M = be)), o), H, ee = T, X = () => (ee(), ee = B(s, (be) => e(29, H = be)), s), I, P = T, O = () => (P(), P = B(i, (be) => e(30, I = be)), i), U, me = T, nt = () => (me(), me = B(a, (be) => e(31, U = be)), a), _e, Me = T, tt = () => (Me(), Me = B(u, (be) => e(32, _e = be)), u), We, Ne = T, Ft = () => (Ne(), Ne = B(l, (be) => e(33, We = be)), l);
  t.$$.on_destroy.push(() => p()), t.$$.on_destroy.push(() => Q()), t.$$.on_destroy.push(() => ge()), t.$$.on_destroy.push(() => ee()), t.$$.on_destroy.push(() => P()), t.$$.on_destroy.push(() => me()), t.$$.on_destroy.push(() => Me()), t.$$.on_destroy.push(() => Ne());
  let { componentContext: Ve } = r, { layoutParams: Oe = void 0 } = r;
  const yt = Xr(_n).direction;
  mn(t, yt, (be) => e(25, g = be));
  let ye = {
    width: 13,
    height: 13,
    borderRadius: 6.5,
    background: "#ffdc60"
  }, Ke = {
    width: 10,
    height: 10,
    borderRadius: 5,
    background: "#33919cb5"
  }, je = "default", te = 15, ot = 10, ce = 5, pt, Ct, re, $, pe = !1;
  function Bt() {
    e(4, je = "default"), e(5, te = 15), e(6, ot = 10), e(7, ce = 5), e(2, ye = {
      width: 13,
      height: 13,
      borderRadius: 6.5,
      background: "#ffdc60"
    }), e(3, Ke = {
      width: 10,
      height: 10,
      borderRadius: 5,
      background: "#33919cb5"
    });
  }
  async function De(be) {
    if (e(8, re = be), await jn(), Ct) {
      const $e = Ct.children[re.currentItem];
      if ($e) {
        const Ce = $e.offsetLeft;
        pt.scroll({
          left: Ce - pt.clientWidth / 2,
          behavior: "smooth"
        });
      }
    }
  }
  function ft(be) {
    be !== re.currentItem && re.scrollToPagerItem(be);
  }
  function Mt(be) {
    if (be.ctrlKey || be.shiftKey || be.altKey || be.metaKey)
      return;
    const { size: $e, currentItem: Ce } = re;
    if (be.which === Ff) {
      const Xe = Ce - 1 < 0 ? Ce : Ce - 1;
      He(Xe);
    } else if (be.which === Mf) {
      const Xe = Ce + 1 >= $e ? Ce : Ce + 1;
      He(Xe);
    } else if (be.which === Pf)
      He(0);
    else if (be.which === Nf)
      He($e - 1);
    else
      return;
    be.preventDefault();
  }
  async function He(be) {
    re.scrollToPagerItem(be), await jn();
    const $e = Ct.querySelector(`.${xi.indicator__item_active}`);
    $e && $e.focus();
  }
  function ht() {
    $ == null || $(), $ = void 0;
    const be = Ve.json.pager_id;
    $ = Ve.listenPager(be, De);
  }
  Jn(() => {
    e(23, pe = !0);
  }), bn(() => {
    e(23, pe = !1), $ == null || $(), $ = void 0;
  });
  const qt = (be) => ft(be);
  function fe(be) {
    Or[be ? "unshift" : "push"](() => {
      Ct = be, e(10, Ct);
    });
  }
  function Vt(be) {
    Or[be ? "unshift" : "push"](() => {
      pt = be, e(9, pt);
    });
  }
  return t.$$set = (be) => {
    "componentContext" in be && e(0, Ve = be.componentContext), "layoutParams" in be && e(1, Oe = be.layoutParams);
  }, t.$$.update = () => {
    var be, $e;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(24, n = Ve.origJson), t.$$.dirty[0] & /*origJson*/
    16777216 && n && Bt(), t.$$.dirty[0] & /*origJson, mounted*/
    25165824 && n && pe && ht(), t.$$.dirty[0] & /*componentContext*/
    1 && O(e(19, i = Ve.getDerivedFromVars(Ve.json.shape))), t.$$.dirty[0] & /*componentContext*/
    1 && le(e(18, o = Ve.getDerivedFromVars(Ve.json.active_item_color))), t.$$.dirty[0] & /*componentContext*/
    1 && X(e(17, s = Ve.getDerivedFromVars(Ve.json.inactive_item_color))), t.$$.dirty[0] & /*componentContext*/
    1 && nt(e(16, a = Ve.getDerivedFromVars(Ve.json.active_item_size))), t.$$.dirty[0] & /*componentContext*/
    1 && Ft(e(15, l = Ve.getDerivedFromVars(Ve.json.active_shape))), t.$$.dirty[0] & /*componentContext*/
    1 && tt(e(14, u = Ve.getDerivedFromVars(Ve.json.inactive_shape))), t.$$.dirty[0] & /*componentContext*/
    1 && w(e(13, c = Ve.getDerivedFromVars(Ve.json.space_between_centers))), t.$$.dirty[0] & /*componentContext*/
    1 && J(e(12, f = Ve.getDerivedFromVars(Ve.json.items_placement))), t.$$.dirty[0] & /*activeStyle, inactiveStyle, $jsonShape, $jsonInactiveItemColor, $jsonActiveItemColor*/
    1879048204 | t.$$.dirty[1] & /*$jsonActiveShape, $jsonInactiveShape, $jsonActiveItemSize*/
    7 && (We && e(2, ye = Qn(
      {
        type: "shape_drawable",
        shape: We
      },
      el,
      ye
    )), _e && e(3, Ke = Qn(
      {
        type: "shape_drawable",
        shape: _e
      },
      el,
      Ke
    )), !We && !_e && I)) {
      const Ce = Gn(U, 1.3);
      e(3, Ke = Qn(
        {
          type: "shape_drawable",
          shape: I,
          color: Ke.background
        },
        el,
        Ke
      )), e(3, Ke.background = Tr(H, 1, Ke.background), Ke), e(2, ye = {
        ...Ke,
        width: Ke.width * Ce,
        height: Ke.height * Ce,
        borderRadius: Ke.borderRadius * Ce,
        background: ye.background
      }), e(2, ye.background = Tr(M, 1, ye.background), ye);
    }
    if (t.$$.dirty[0] & /*$jsonItemsPlacement, placement, spaceBetweenCenters, maxVisibleItems, itemSpacing, $jsonSpaceBetweenCenters*/
    201326832)
      if (E && (E.type === "default" || E.type === "stretch")) {
        if (e(4, je = E.type), je === "default")
          e(5, te = Kr((be = E.space_between_centers) == null ? void 0 : be.value, te));
        else if (je === "stretch") {
          const Ce = E;
          e(6, ot = Gn(Ce.max_visible_items, ot)), e(7, ce = Kr(($e = Ce.item_spacing) == null ? void 0 : $e.value, ce));
        }
      } else
        e(4, je = "default"), y && e(5, te = Kr(y.value, te));
    t.$$.dirty[0] & /*placement, $direction, pagerData*/
    33554704 && e(11, _ = {
      placement: je,
      direction: g,
      visible: (re == null ? void 0 : re.size) > 1
    });
  }, [
    Ve,
    Oe,
    ye,
    Ke,
    je,
    te,
    ot,
    ce,
    re,
    pt,
    Ct,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    i,
    yt,
    ft,
    Mt,
    pe,
    n,
    g,
    y,
    E,
    M,
    H,
    I,
    U,
    _e,
    We,
    qt,
    fe,
    Vt
  ];
}
class T0 extends $r {
  constructor(r) {
    super(), xr(this, r, D0, I0, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1]);
  }
}
const F0 = "appkit-slider", M0 = "appkit-slider__input", P0 = "appkit-slider__input_secondary", N0 = "appkit-slider__thumb", z0 = "appkit-slider_direction_rtl", O0 = "appkit-slider__thumb_secondary", L0 = "appkit-slider__track", R0 = "appkit-slider__tick", B0 = "appkit-slider__tick_active", H0 = "appkit-slider__tick_inactive", Nr = {
  slider: F0,
  slider__input: M0,
  slider__input_secondary: P0,
  slider__thumb: N0,
  slider_direction_rtl: z0,
  slider__thumb_secondary: O0,
  "slider__tracks-wrapper": "appkit-slider__tracks-wrapper",
  "slider__tracks-inner": "appkit-slider__tracks-inner",
  "slider__tracks-ranges": "appkit-slider__tracks-ranges",
  "slider__tracks-ranges_rtl": "appkit-slider__tracks-ranges_rtl",
  slider__track: L0,
  "slider__thumb-text": "appkit-slider__thumb-text",
  "slider__thumb-text_secondary": "appkit-slider__thumb-text_secondary",
  slider__tick: R0,
  slider__tick_active: B0,
  slider__tick_inactive: H0
};
function Tu(t, r) {
  var o, s;
  if (!t || !t.font_size)
    return r;
  const e = t.offset, n = t.text_color && Tr(t.text_color) || "#000", i = ho(t.font_weight, t.font_weight_value, void 0);
  if (Hn(t.font_size) && n !== "transparent") {
    const a = {
      fontSize: Re(t.font_size),
      fontWeight: i,
      textColor: n
    };
    return typeof ((o = e == null ? void 0 : e.x) == null ? void 0 : o.value) == "number" && typeof ((s = e == null ? void 0 : e.y) == null ? void 0 : s.value) == "number" && (a.offset = {
      x: e.x.value,
      y: e.y.value
    }), a;
  }
}
function Vi(t, r, e) {
  return Math.max(r, Math.min(e, Number(t)));
}
function Gl(t) {
  return BigInt(t);
}
const Po = Gl("9223372036854775807"), No = Gl("-9223372036854775808");
function cn(t) {
  const r = Gl(t);
  if (r > Po || r < No)
    throw new Error("Integer overflow.");
  return r;
}
const $i = cn(0);
function Wf(t) {
  let r = t;
  return r < 0 && (r = -r), r;
}
function Uf(t) {
  let r = 0;
  return t > 0 ? r = 1 : t < 0 && (r = -1), cn(r);
}
function Kn(t, r) {
  var e;
  switch ((e = r[t.type]) == null || e.call(r, t), t.type) {
    case "TemplateLiteral":
      t.expressions.forEach((n) => {
        Kn(n, r);
      });
      break;
    case "BinaryExpression":
    case "LogicalExpression":
      Kn(t.left, r), Kn(t.right, r);
      break;
    case "UnaryExpression":
      Kn(t.argument, r);
      break;
    case "ConditionalExpression":
      Kn(t.test, r), Kn(t.consequent, r), Kn(t.alternate, r);
      break;
    case "TryExpression":
      Kn(t.test, r), Kn(t.alternate, r);
      break;
    case "CallExpression":
      t.arguments.forEach((n) => {
        Kn(n, r);
      });
      break;
    case "MethodExpression":
      Kn(t.object, r), t.arguments.forEach((n) => {
        Kn(n, r);
      });
      break;
  }
}
const W0 = 2147483647, U0 = -2147483648, G0 = Number.MAX_VALUE, Y0 = Number.MIN_VALUE, Ee = "string", ve = "integer", xe = "number", Wr = "boolean", un = "color", Xn = "url", Sr = "datetime", er = "dict", rr = "array";
function ws(t) {
  return t.type === "url" || t.type === "color" ? {
    type: "string",
    value: t.value
  } : t;
}
function Gf(t) {
  return t.toISOString().replace("T", " ").replace(/\.\d{3}Z$/, "");
}
function to(t, r) {
  if (t.type === "string")
    return t.value;
  if (t.type === "integer")
    return String(t.value);
  if (t.type === "number") {
    let e = String(t.value);
    return e.includes(".") || (e.includes("e") ? e = e.replace("e", ".0e") : e += ".0"), e = e.replace(/e\+?/i, "E"), e;
  } else {
    if (t.type === "boolean")
      return t.value ? "true" : "false";
    if (t.type === "datetime")
      return Gf(t.value);
    if (t.type === "color")
      return no(Bs(t.value));
    if (t.type === "url")
      return t.value;
    if ((t.type === "dict" || t.type === "array") && r)
      return JSON.stringify(t.value);
    if (t.type === "dict")
      return "<dict>";
    if (t.type === "array")
      return "<array>";
  }
  throw new Error(`Unexpected type ${t.type}`);
}
function on(t) {
  let r = to(t, !1);
  return t.type === "string" && (r = "'" + r.replace(/\\/g, "\\\\").replace(/'/g, "\\'") + "'"), r;
}
function qn(t) {
  return t === "datetime" ? "DateTime" : t.charAt(0).toUpperCase() + t.substring(1);
}
function ro(t, r) {
  return cn(r);
}
function Ln(t, r) {
  if (r < No || r > Po)
    throw new Error("Integer overflow.");
}
function ai(t) {
  if (typeof t != "string")
    throw new Error("Incorrect url value.");
  try {
    new URL(t);
  } catch {
    throw new Error("Incorrect url value.");
  }
}
function q0(t) {
  const r = /* @__PURE__ */ new Set();
  return Kn(t, {
    Variable(e) {
      r.add(e.id.name);
    }
  }), [...r];
}
function sn(t, r) {
  throw new Error(`Failed to evaluate [${t}]. ${r}`);
}
function Bs(t) {
  const r = si(t);
  if (r)
    return r;
  throw new Error("Unable to convert value to Color, expected format #AARRGGBB.");
}
function no(t) {
  return `#${[t.a, t.r, t.g, t.b].map((r) => {
    if (r < 0 || r > 255)
      throw new Error("Value out of range 0..1.");
    return kf(Math.round(r).toString(16), 2);
  }).join("").toUpperCase()}`;
}
function Li(t) {
  return no(Bs(t));
}
function _l(t) {
  return {
    type: xe,
    value: Number(t.value)
  };
}
const J0 = {
  string: "string",
  number: "number",
  integer: "number",
  boolean: "boolean",
  color: "string",
  url: "string",
  array: "array",
  dict: "object"
};
function Yl(t, r, e) {
  const n = J0[e];
  let i = typeof r;
  if (n === "array" && !Array.isArray(r) || n !== "array" && i !== n || i === "object" && r === null)
    throw i === "object" && (Array.isArray(r) ? i = "array" : r === null ? i = "null" : i = "dict"), new Error(`Incorrect value type: expected ${qn(e)}, got ${qn(i)}.`);
  if (n === "number" && e === "integer") {
    t && Ln(t, r);
    try {
      r = cn(r);
    } catch {
      throw new Error("Cannot convert value to integer.");
    }
  }
  return n === "string" && e === "color" && (r = Li(r)), n === "string" && e === "url" && ai(r), n === "boolean" && e === Wr && (r = r ? 1 : 0), {
    type: e,
    value: r
  };
}
function K0(t) {
  return t.type === "number" || t.type === "integer" ? Number(t.value) : t.type === "boolean" ? !!t.value : t.value;
}
function Hs(t) {
  return K0(
    Yl(void 0, t.value, t.type)
  );
}
class Fi {
  constructor(r, e) {
    dr(this, "name");
    dr(this, "value");
    dr(this, "store");
    const n = this.convertValue(e);
    this.name = r, this.value = n;
  }
  getName() {
    return this.name;
  }
  subscribe(r) {
    return this.store || (this.store = gi(this.value)), this.store.subscribe(r);
  }
  set(r) {
    const e = this.fromString(r);
    this.setValue(e);
  }
  setValue(r) {
    const e = this.convertValue(r);
    this.value = e, this.store && this.store.set(e);
  }
  getValue() {
    return this.value;
  }
}
class Yf extends Fi {
  convertValue(r) {
    if (typeof r != "string")
      throw new Error("Incorrect variable value");
    return r;
  }
  fromString(r) {
    return r;
  }
  getType() {
    return "string";
  }
}
class qf extends Fi {
  convertValue(r) {
    if (typeof r != "bigint" && typeof r != "number")
      throw new Error("Incorrect variable value");
    try {
      return cn(r);
    } catch {
      throw new Error("Incorrect variable value");
    }
  }
  fromString(r) {
    try {
      return cn(r);
    } catch {
      throw new Error("Incorrect variable value");
    }
  }
  getType() {
    return "integer";
  }
}
class Jf extends Fi {
  convertValue(r) {
    if (typeof r != "number" || Number.isNaN(r) || !isFinite(r))
      throw new Error("Incorrect variable value");
    return r;
  }
  fromString(r) {
    const e = Number(r);
    return this.convertValue(e);
  }
  getType() {
    return "number";
  }
}
class Kf extends Fi {
  convertValue(r) {
    if (r !== 1 && r !== 0 && r !== !0 && r !== !1)
      throw new Error("Incorrect variable value");
    return !!r;
  }
  fromString(r) {
    if (r === "1" || r === "true")
      return !0;
    if (r === "0" || r === "false")
      return !1;
    throw new Error("Incorrect variable value");
  }
  getType() {
    return "boolean";
  }
}
class Xf extends Fi {
  convertValue(r) {
    if (typeof r != "string" || !si(r))
      throw new Error("Incorrect variable value");
    return Li(r);
  }
  fromString(r) {
    return this.convertValue(r);
  }
  getType() {
    return "color";
  }
}
class Zf extends Fi {
  convertValue(r) {
    if (typeof r != "string")
      throw new Error("Incorrect variable value");
    return ai(r), r;
  }
  fromString(r) {
    return ai(r), r;
  }
  getType() {
    return "url";
  }
}
class Qf extends Fi {
  convertValue(r) {
    if (typeof r != "object" || !r)
      throw new Error("Incorrect variable value");
    return r;
  }
  fromString(r) {
    try {
      return JSON.parse(r);
    } catch {
      throw new Error("Incorrect dict value");
    }
  }
  getType() {
    return "dict";
  }
}
class xf extends Fi {
  convertValue(r) {
    if (!Array.isArray(r))
      throw new Error("Incorrect variable value");
    return r;
  }
  fromString(r) {
    try {
      return JSON.parse(r);
    } catch {
      throw new Error("Incorrect array value");
    }
  }
  getType() {
    return "array";
  }
}
const pl = {
  string: Yf,
  number: Jf,
  integer: qf,
  boolean: Kf,
  color: Xf,
  url: Zf,
  dict: Qf,
  array: xf
};
function mi(t, r, e) {
  if (!(r in pl))
    throw new Error("Unsupported variable type");
  return new pl[r](t, e);
}
function X0() {
}
function Z0(t) {
  return t(this.value), X0;
}
function Fu() {
  throw new Error("Cannot change the value of this type of variable");
}
class Q0 extends Yf {
}
class x0 extends Jf {
}
class $0 extends qf {
}
class em extends Kf {
}
class tm extends Xf {
}
class rm extends Zf {
}
class nm extends Qf {
}
class im extends xf {
}
class om extends Fi {
  convertValue(r) {
    if (!(r instanceof Date))
      throw new Error("Incorrect variable value");
    return r;
  }
  fromString() {
    throw new Error("Datetime variable does not support setter from string");
  }
  getType() {
    return "datetime";
  }
}
const vs = {
  string: Q0,
  number: x0,
  integer: $0,
  boolean: em,
  color: tm,
  url: rm,
  dict: nm,
  array: im,
  datetime: om
};
for (const t in vs) {
  const r = vs[t];
  r.prototype.subscribe = Z0, r.prototype.set = Fu, r.prototype.setValue = Fu;
}
function Zo(t, r, e) {
  if (!(r in vs))
    throw new Error("Unsupported variable type");
  return new vs[r](t, e);
}
function sm(t) {
  const r = t.getType();
  let e = t.getValue();
  return r === Wr && (e = e ? 1 : 0), {
    type: r,
    value: e
  };
}
function lm(t, r) {
  if (r === "string")
    return t;
  if (r === "integer")
    try {
      return cn(t);
    } catch {
      throw new Error("Incorrect variable value");
    }
  else if (r === "number") {
    const e = Number(t);
    if (Number.isNaN(e) || !isFinite(e))
      throw new Error("Incorrect variable value");
    return e;
  } else if (r === "boolean") {
    if (t === "1" || t === "true")
      return !0;
    if (t === "0" || t === "false")
      return !1;
    throw new Error("Incorrect variable value");
  } else if (r === "color") {
    if (typeof t != "string" || !si(t))
      throw new Error("Incorrect variable value");
    return Li(t);
  } else if (r === "url") {
    if (typeof t != "string")
      throw new Error("Incorrect variable value");
    return ai(t), t;
  } else if (r === "dict" || r === "array")
    try {
      return JSON.parse(t);
    } catch {
      throw new Error("Incorrect dict value");
    }
  throw new Error(`Unexpected type ${r}`);
}
function Mu(t, r, e) {
  const n = t.slice();
  return n[85] = r[e], n;
}
function Pu(t, r, e) {
  const n = t.slice();
  return n[85] = r[e], n;
}
function Nu(t, r, e) {
  const n = t.slice();
  return n[90] = r[e], n;
}
function am(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function um(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "slider",
        Nr,
        /*mods*/
        t[24]
      ),
      style: (
        /*stl*/
        t[25]
      ),
      customDescription: !0,
      customActions: "slider",
      hasInnerFocusable: !0,
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      $$slots: {
        default: [
          cm,
          ({ focusHandler: n, blurHandler: i }) => ({ 83: n, 84: i }),
          ({ focusHandler: n, blurHandler: i }) => [0, 0, (n ? 2097152 : 0) | (i ? 4194304 : 0)]
        ]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      16777216 && (o.cls = jt(
        "slider",
        Nr,
        /*mods*/
        n[24]
      )), i[0] & /*stl*/
      33554432 && (o.style = /*stl*/
      n[25]), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*tracksInner, switchedTracks, minValue, maxValue, value, value2, isEnabled, secondaryDescription, secondVariable, description, input, thumbSecondaryStyle, textSecondaryStyle, thumbStyle, textStyle, markInactiveTicks, markActiveTicks, $direction, renderRanges*/
      4193276 | i[2] & /*focusHandler, blurHandler*/
      6291456 | i[3] & /*$$scope*/
      1 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function zu(t) {
  let r;
  return {
    c() {
      r = Be("div"), m(r, "class", Nr.slider__track), q(
        r,
        "left",
        /*range*/
        t[90].left
      ), q(
        r,
        "right",
        /*range*/
        t[90].right
      ), q(
        r,
        "height",
        /*range*/
        t[90].height
      ), q(
        r,
        "border-radius",
        /*range*/
        t[90].borderRadius
      ), q(
        r,
        "background",
        /*range*/
        t[90].background
      ), q(
        r,
        "box-shadow",
        /*range*/
        t[90].boxShadow
      );
    },
    m(e, n) {
      x(e, r, n);
    },
    p(e, n) {
      n[0] & /*renderRanges*/
      2097152 && q(
        r,
        "left",
        /*range*/
        e[90].left
      ), n[0] & /*renderRanges*/
      2097152 && q(
        r,
        "right",
        /*range*/
        e[90].right
      ), n[0] & /*renderRanges*/
      2097152 && q(
        r,
        "height",
        /*range*/
        e[90].height
      ), n[0] & /*renderRanges*/
      2097152 && q(
        r,
        "border-radius",
        /*range*/
        e[90].borderRadius
      ), n[0] & /*renderRanges*/
      2097152 && q(
        r,
        "background",
        /*range*/
        e[90].background
      ), n[0] & /*renderRanges*/
      2097152 && q(
        r,
        "box-shadow",
        /*range*/
        e[90].boxShadow
      );
    },
    d(e) {
      e && Z(r);
    }
  };
}
function Ou(t) {
  let r;
  return {
    c() {
      r = Be("div"), m(r, "class", Nr.slider__tick + " " + Nr.slider__tick_active), q(
        r,
        "--divkit-slider-tick",
        /*val*/
        t[85]
      );
    },
    m(e, n) {
      x(e, r, n);
    },
    p(e, n) {
      n[0] & /*markActiveTicks*/
      131072 && q(
        r,
        "--divkit-slider-tick",
        /*val*/
        e[85]
      );
    },
    d(e) {
      e && Z(r);
    }
  };
}
function Lu(t) {
  let r;
  return {
    c() {
      r = Be("div"), m(r, "class", Nr.slider__tick + " " + Nr.slider__tick_inactive), q(
        r,
        "--divkit-slider-tick",
        /*val*/
        t[85]
      );
    },
    m(e, n) {
      x(e, r, n);
    },
    p(e, n) {
      n[0] & /*markInactiveTicks*/
      262144 && q(
        r,
        "--divkit-slider-tick",
        /*val*/
        e[85]
      );
    },
    d(e) {
      e && Z(r);
    }
  };
}
function Ru(t) {
  let r, e, n;
  return {
    c() {
      var i, o, s;
      r = Be("div"), e = Be("div"), n = ei(
        /*value*/
        t[11]
      ), m(e, "class", Nr["slider__thumb-text-inner"]), q(
        e,
        "font-size",
        /*textStyle*/
        ((i = t[7]) == null ? void 0 : i.fontSize) || "1em"
      ), q(
        e,
        "font-weight",
        /*textStyle*/
        ((o = t[7]) == null ? void 0 : o.fontWeight) || ""
      ), q(
        e,
        "color",
        /*textStyle*/
        ((s = t[7]) == null ? void 0 : s.textColor) || "#000"
      ), m(r, "class", Nr["slider__thumb-text"]);
    },
    m(i, o) {
      x(i, r, o), Tt(r, e), Tt(e, n);
    },
    p(i, o) {
      var s, a, l;
      o[0] & /*value*/
      2048 && Ti(
        n,
        /*value*/
        i[11]
      ), o[0] & /*textStyle*/
      128 && q(
        e,
        "font-size",
        /*textStyle*/
        ((s = i[7]) == null ? void 0 : s.fontSize) || "1em"
      ), o[0] & /*textStyle*/
      128 && q(
        e,
        "font-weight",
        /*textStyle*/
        ((a = i[7]) == null ? void 0 : a.fontWeight) || ""
      ), o[0] & /*textStyle*/
      128 && q(
        e,
        "color",
        /*textStyle*/
        ((l = i[7]) == null ? void 0 : l.textColor) || "#000"
      );
    },
    d(i) {
      i && Z(r);
    }
  };
}
function Bu(t) {
  let r, e = (
    /*textSecondaryStyle*/
    t[8] && Hu(t)
  );
  return {
    c() {
      r = Be("div"), e && e.c(), m(r, "class", Nr.slider__thumb + " " + Nr.slider__thumb_secondary), q(r, "border-radius", Re(
        /*thumbSecondaryStyle*/
        t[6].borderRadius
      )), q(
        r,
        "background",
        /*thumbSecondaryStyle*/
        t[6].background
      ), q(
        r,
        "box-shadow",
        /*thumbSecondaryStyle*/
        t[6].boxShadow || ""
      );
    },
    m(n, i) {
      x(n, r, i), e && e.m(r, null);
    },
    p(n, i) {
      /*textSecondaryStyle*/
      n[8] ? e ? e.p(n, i) : (e = Hu(n), e.c(), e.m(r, null)) : e && (e.d(1), e = null), i[0] & /*thumbSecondaryStyle*/
      64 && q(r, "border-radius", Re(
        /*thumbSecondaryStyle*/
        n[6].borderRadius
      )), i[0] & /*thumbSecondaryStyle*/
      64 && q(
        r,
        "background",
        /*thumbSecondaryStyle*/
        n[6].background
      ), i[0] & /*thumbSecondaryStyle*/
      64 && q(
        r,
        "box-shadow",
        /*thumbSecondaryStyle*/
        n[6].boxShadow || ""
      );
    },
    d(n) {
      n && Z(r), e && e.d();
    }
  };
}
function Hu(t) {
  let r, e, n;
  return {
    c() {
      var i, o, s;
      r = Be("div"), e = Be("div"), n = ei(
        /*value2*/
        t[12]
      ), m(e, "class", Nr["slider__thumb-text-inner"]), q(
        e,
        "font-size",
        /*textSecondaryStyle*/
        ((i = t[8]) == null ? void 0 : i.fontSize) || "1em"
      ), q(
        e,
        "font-weight",
        /*textSecondaryStyle*/
        ((o = t[8]) == null ? void 0 : o.fontWeight) || ""
      ), q(
        e,
        "color",
        /*textSecondaryStyle*/
        ((s = t[8]) == null ? void 0 : s.textColor) || "#000"
      ), m(r, "class", Nr["slider__thumb-text"] + " " + Nr["slider__thumb-text_secondary"]);
    },
    m(i, o) {
      x(i, r, o), Tt(r, e), Tt(e, n);
    },
    p(i, o) {
      var s, a, l;
      o[0] & /*value2*/
      4096 && Ti(
        n,
        /*value2*/
        i[12]
      ), o[0] & /*textSecondaryStyle*/
      256 && q(
        e,
        "font-size",
        /*textSecondaryStyle*/
        ((s = i[8]) == null ? void 0 : s.fontSize) || "1em"
      ), o[0] & /*textSecondaryStyle*/
      256 && q(
        e,
        "font-weight",
        /*textSecondaryStyle*/
        ((a = i[8]) == null ? void 0 : a.fontWeight) || ""
      ), o[0] & /*textSecondaryStyle*/
      256 && q(
        e,
        "color",
        /*textSecondaryStyle*/
        ((l = i[8]) == null ? void 0 : l.textColor) || "#000"
      );
    },
    d(i) {
      i && Z(r);
    }
  };
}
function Wu(t) {
  let r, e, n, i, o, s;
  return {
    c() {
      r = Be("input"), m(r, "type", "range"), m(r, "class", e = /*switchedTracks*/
      t[16] ? Nr.slider__input : `${Nr.slider__input} ${Nr.slider__input_secondary}`), m(
        r,
        "min",
        /*minValue*/
        t[3]
      ), m(
        r,
        "max",
        /*maxValue*/
        t[4]
      ), m(r, "step", "1"), r.value = n = /*switchedTracks*/
      t[16] ? (
        /*value*/
        t[11]
      ) : (
        /*value2*/
        t[12]
      ), r.disabled = i = !/*isEnabled*/
      t[9], m(
        r,
        "aria-label",
        /*secondaryDescription*/
        t[20]
      );
    },
    m(a, l) {
      x(a, r, l), o || (s = [
        Ge(
          r,
          "input",
          /*input_handler_1*/
          t[75]
        ),
        Ge(r, "mousedown", function() {
          zr(
            /*secondVariable*/
            t[13] ? (
              /*onSecondMousedown*/
              t[41]
            ) : null
          ) && (t[13] ? (
            /*onSecondMousedown*/
            t[41]
          ) : null).apply(this, arguments);
        }),
        Ge(r, "touchstart", function() {
          zr(
            /*secondVariable*/
            t[13] ? (
              /*onSecondMousedown*/
              t[41]
            ) : null
          ) && (t[13] ? (
            /*onSecondMousedown*/
            t[41]
          ) : null).apply(this, arguments);
        }),
        Ge(r, "focus", function() {
          zr(
            /*focusHandler*/
            t[83]
          ) && t[83].apply(this, arguments);
        }),
        Ge(r, "blur", function() {
          zr(
            /*blurHandler*/
            t[84]
          ) && t[84].apply(this, arguments);
        })
      ], o = !0);
    },
    p(a, l) {
      t = a, l[0] & /*switchedTracks*/
      65536 && e !== (e = /*switchedTracks*/
      t[16] ? Nr.slider__input : `${Nr.slider__input} ${Nr.slider__input_secondary}`) && m(r, "class", e), l[0] & /*minValue*/
      8 && m(
        r,
        "min",
        /*minValue*/
        t[3]
      ), l[0] & /*maxValue*/
      16 && m(
        r,
        "max",
        /*maxValue*/
        t[4]
      ), l[0] & /*switchedTracks, value, value2*/
      71680 && n !== (n = /*switchedTracks*/
      t[16] ? (
        /*value*/
        t[11]
      ) : (
        /*value2*/
        t[12]
      )) && (r.value = n), l[0] & /*isEnabled*/
      512 && i !== (i = !/*isEnabled*/
      t[9]) && (r.disabled = i), l[0] & /*secondaryDescription*/
      1048576 && m(
        r,
        "aria-label",
        /*secondaryDescription*/
        t[20]
      );
    },
    d(a) {
      a && Z(r), o = !1, Qr(s);
    }
  };
}
function cm(t) {
  let r, e, n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q = lr(
    /*renderRanges*/
    t[21]
  ), J = [];
  for (let P = 0; P < Q.length; P += 1)
    J[P] = zu(Nu(t, Q, P));
  let M = lr(
    /*markActiveTicks*/
    t[17]
  ), ge = [];
  for (let P = 0; P < M.length; P += 1)
    ge[P] = Ou(Pu(t, M, P));
  let le = lr(
    /*markInactiveTicks*/
    t[18]
  ), H = [];
  for (let P = 0; P < le.length; P += 1)
    H[P] = Lu(Mu(t, le, P));
  let ee = (
    /*textStyle*/
    t[7] && Ru(t)
  ), X = (
    /*secondVariable*/
    t[13] && Bu(t)
  ), I = (
    /*secondVariable*/
    t[13] && Wu(t)
  );
  return {
    c() {
      r = Be("div"), e = Be("div"), n = Be("div");
      for (let P = 0; P < J.length; P += 1)
        J[P].c();
      o = wr();
      for (let P = 0; P < ge.length; P += 1)
        ge[P].c();
      s = wr();
      for (let P = 0; P < H.length; P += 1)
        H[P].c();
      a = wr(), l = Be("div"), ee && ee.c(), u = wr(), X && X.c(), c = wr(), f = Be("input"), p = wr(), I && I.c(), m(n, "class", i = Nr["slider__tracks-ranges"] + /*$direction*/
      (t[14] === "rtl" ? " " + Nr["slider__tracks-ranges_rtl"] : "")), m(l, "class", Nr.slider__thumb), q(l, "border-radius", Re(
        /*thumbStyle*/
        t[5].borderRadius
      )), q(
        l,
        "background",
        /*thumbStyle*/
        t[5].background
      ), q(
        l,
        "box-shadow",
        /*thumbStyle*/
        t[5].boxShadow || ""
      ), m(f, "type", "range"), m(f, "class", _ = /*switchedTracks*/
      t[16] ? `${Nr.slider__input} ${Nr.slider__input_secondary}` : Nr.slider__input), m(
        f,
        "min",
        /*minValue*/
        t[3]
      ), m(
        f,
        "max",
        /*maxValue*/
        t[4]
      ), m(f, "step", "1"), f.value = g = /*switchedTracks*/
      t[16] ? (
        /*value2*/
        t[12]
      ) : (
        /*value*/
        t[11]
      ), f.disabled = y = !/*isEnabled*/
      t[9], m(
        f,
        "aria-label",
        /*description*/
        t[19]
      ), m(e, "class", Nr["slider__tracks-inner"]), m(r, "class", Nr["slider__tracks-wrapper"]);
    },
    m(P, O) {
      x(P, r, O), Tt(r, e), Tt(e, n);
      for (let U = 0; U < J.length; U += 1)
        J[U] && J[U].m(n, null);
      Tt(e, o);
      for (let U = 0; U < ge.length; U += 1)
        ge[U] && ge[U].m(e, null);
      Tt(e, s);
      for (let U = 0; U < H.length; U += 1)
        H[U] && H[U].m(e, null);
      Tt(e, a), Tt(e, l), ee && ee.m(l, null), Tt(e, u), X && X.m(e, null), Tt(e, c), Tt(e, f), t[74](f), Tt(e, p), I && I.m(e, null), t[76](e), w || (E = [
        Ge(
          f,
          "input",
          /*input_handler*/
          t[73]
        ),
        Ge(f, "focus", function() {
          zr(
            /*focusHandler*/
            t[83]
          ) && t[83].apply(this, arguments);
        }),
        Ge(f, "blur", function() {
          zr(
            /*blurHandler*/
            t[84]
          ) && t[84].apply(this, arguments);
        })
      ], w = !0);
    },
    p(P, O) {
      if (t = P, O[0] & /*renderRanges*/
      2097152) {
        Q = lr(
          /*renderRanges*/
          t[21]
        );
        let U;
        for (U = 0; U < Q.length; U += 1) {
          const me = Nu(t, Q, U);
          J[U] ? J[U].p(me, O) : (J[U] = zu(me), J[U].c(), J[U].m(n, null));
        }
        for (; U < J.length; U += 1)
          J[U].d(1);
        J.length = Q.length;
      }
      if (O[0] & /*$direction*/
      16384 && i !== (i = Nr["slider__tracks-ranges"] + /*$direction*/
      (t[14] === "rtl" ? " " + Nr["slider__tracks-ranges_rtl"] : "")) && m(n, "class", i), O[0] & /*markActiveTicks*/
      131072) {
        M = lr(
          /*markActiveTicks*/
          t[17]
        );
        let U;
        for (U = 0; U < M.length; U += 1) {
          const me = Pu(t, M, U);
          ge[U] ? ge[U].p(me, O) : (ge[U] = Ou(me), ge[U].c(), ge[U].m(e, s));
        }
        for (; U < ge.length; U += 1)
          ge[U].d(1);
        ge.length = M.length;
      }
      if (O[0] & /*markInactiveTicks*/
      262144) {
        le = lr(
          /*markInactiveTicks*/
          t[18]
        );
        let U;
        for (U = 0; U < le.length; U += 1) {
          const me = Mu(t, le, U);
          H[U] ? H[U].p(me, O) : (H[U] = Lu(me), H[U].c(), H[U].m(e, a));
        }
        for (; U < H.length; U += 1)
          H[U].d(1);
        H.length = le.length;
      }
      /*textStyle*/
      t[7] ? ee ? ee.p(t, O) : (ee = Ru(t), ee.c(), ee.m(l, null)) : ee && (ee.d(1), ee = null), O[0] & /*thumbStyle*/
      32 && q(l, "border-radius", Re(
        /*thumbStyle*/
        t[5].borderRadius
      )), O[0] & /*thumbStyle*/
      32 && q(
        l,
        "background",
        /*thumbStyle*/
        t[5].background
      ), O[0] & /*thumbStyle*/
      32 && q(
        l,
        "box-shadow",
        /*thumbStyle*/
        t[5].boxShadow || ""
      ), /*secondVariable*/
      t[13] ? X ? X.p(t, O) : (X = Bu(t), X.c(), X.m(e, c)) : X && (X.d(1), X = null), O[0] & /*switchedTracks*/
      65536 && _ !== (_ = /*switchedTracks*/
      t[16] ? `${Nr.slider__input} ${Nr.slider__input_secondary}` : Nr.slider__input) && m(f, "class", _), O[0] & /*minValue*/
      8 && m(
        f,
        "min",
        /*minValue*/
        t[3]
      ), O[0] & /*maxValue*/
      16 && m(
        f,
        "max",
        /*maxValue*/
        t[4]
      ), O[0] & /*switchedTracks, value2, value*/
      71680 && g !== (g = /*switchedTracks*/
      t[16] ? (
        /*value2*/
        t[12]
      ) : (
        /*value*/
        t[11]
      )) && (f.value = g), O[0] & /*isEnabled*/
      512 && y !== (y = !/*isEnabled*/
      t[9]) && (f.disabled = y), O[0] & /*description*/
      524288 && m(
        f,
        "aria-label",
        /*description*/
        t[19]
      ), /*secondVariable*/
      t[13] ? I ? I.p(t, O) : (I = Wu(t), I.c(), I.m(e, null)) : I && (I.d(1), I = null);
    },
    d(P) {
      P && Z(r), gn(J, P), gn(ge, P), gn(H, P), ee && ee.d(), X && X.d(), t[74](null), I && I.d(), t[76](null), w = !1, Qr(E);
    }
  };
}
function fm(t) {
  let r, e, n, i, o, s;
  const a = [um, am], l = [];
  function u(c, f) {
    return (
      /*hasError*/
      c[10] ? -1 : 0
    );
  }
  return ~(r = u(t)) && (e = l[r] = a[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(c, f) {
      ~r && l[r].m(c, f), x(c, n, f), i = !0, o || (s = Ge(
        window,
        "resize",
        /*checkTicksDebounced*/
        t[43]
      ), o = !0);
    },
    p(c, f) {
      let _ = r;
      r = u(c), r === _ ? ~r && l[r].p(c, f) : (e && (_r(), ae(l[_], 1, 1, () => {
        l[_] = null;
      }), pr()), ~r ? (e = l[r], e ? e.p(c, f) : (e = l[r] = a[r](c), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(c) {
      i || (K(e), i = !0);
    },
    o(c) {
      ae(e), i = !1;
    },
    d(c) {
      c && Z(n), ~r && l[r].d(c), o = !1, s();
    }
  };
}
const Un = {
  width: 10,
  height: 10,
  borderRadius: 5,
  background: "#000"
}, Ro = ["rounded_rectangle", "circle"], tl = ["rounded_rectangle"];
function Bo(t, r, e, n, i) {
  let o = [];
  if (i)
    for (let s = t; s < r; ++s)
      o.push((s - e) / (n - e));
  else {
    for (let s = e; s < t; ++s)
      o.push((s - e) / (n - e));
    for (let s = r; s < n + 1; ++s)
      o.push((s - e) / (n - e));
  }
  return o;
}
function dm(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee, X, I, P, O, U, me, nt, _e = T, Me = () => (_e(), _e = B(ge, (Y) => e(57, nt = Y)), ge), tt, We = T, Ne = () => (We(), We = B(J, (Y) => e(58, tt = Y)), J), Ft, Ve = T, Oe = () => (Ve(), Ve = B(M, (Y) => e(59, Ft = Y)), M), Pe, yt = T, ye = () => (yt(), yt = B(Q, (Y) => e(60, Pe = Y)), Q), Ke, je = T, te = () => (je(), je = B(E, (Y) => e(61, Ke = Y)), E), ot, ce = T, pt = () => (ce(), ce = B(w, (Y) => e(62, ot = Y)), w), Ct, re = T, $ = () => (re(), re = B(p, (Y) => e(63, Ct = Y)), p), pe, Bt = T, De = () => (Bt(), Bt = B(y, (Y) => e(64, pe = Y)), y), ft, Mt = T, He = () => (Mt(), Mt = B(g, (Y) => e(65, ft = Y)), g), ht, qt = T, fe = () => (qt(), qt = B(_, (Y) => e(66, ht = Y)), _), Vt, be = T, $e = () => (be(), be = B(f, (Y) => e(67, Vt = Y)), f), Ce, Xe = T, Jt = () => (Xe(), Xe = B(c, (Y) => e(68, Ce = Y)), c), bt, Qt = T, rt = () => (Qt(), Qt = B(a, (Y) => e(69, bt = Y)), a), ir, W = T, Et = () => (W(), W = B(s, (Y) => e(70, ir = Y)), s), It, Ye = T, L = () => (Ye(), Ye = B(u, (Y) => e(71, It = Y)), u), Le, gt = T, qe = () => (gt(), gt = B(l, (Y) => e(72, Le = Y)), l);
  t.$$.on_destroy.push(() => _e()), t.$$.on_destroy.push(() => We()), t.$$.on_destroy.push(() => Ve()), t.$$.on_destroy.push(() => yt()), t.$$.on_destroy.push(() => je()), t.$$.on_destroy.push(() => ce()), t.$$.on_destroy.push(() => re()), t.$$.on_destroy.push(() => Bt()), t.$$.on_destroy.push(() => Mt()), t.$$.on_destroy.push(() => qt()), t.$$.on_destroy.push(() => be()), t.$$.on_destroy.push(() => Xe()), t.$$.on_destroy.push(() => Qt()), t.$$.on_destroy.push(() => W()), t.$$.on_destroy.push(() => Ye()), t.$$.on_destroy.push(() => gt());
  let { componentContext: Te } = r, { layoutParams: cr = void 0 } = r;
  const ke = Xr(_n), hr = Xr(Zi), ie = ke.direction;
  mn(t, ie, (Y) => e(14, me = Y));
  let ze, Ot, Yt, Ht = !1, wt = 0, Wt = 100, Lt = Un, Gt = Lt, tr = Un, or = Un, mr, zt = null, Ut, st = null, et, nr = et, Ar = "", br = "", yr = !0, jr = !1, kr = [];
  function Ir() {
    e(5, Lt = Un), e(6, Gt = Lt), e(45, tr = Un), e(46, or = Un), e(47, zt = null), e(48, st = null), e(7, et = void 0), e(8, nr = void 0), e(19, Ar = ""), e(9, yr = !0), e(20, br = "");
  }
  let gr = Vi(ir || 0, wt, Wt), Er = Vi(bt || 0, wt, Wt);
  function Ze({ direction: Y, minValue: he, maxValue: d, trackActiveOffset: G, trackActivePart: Ie, trackInactiveStyle: Je, trackActiveStyle: ar, ranges: C = [] }) {
    const Qe = [], mt = (Dt, sr, Yr) => {
      var Ur, Vn, ue, ln;
      const qr = (Lr, pn, Cn, b) => {
        var N, D, Ue, de;
        const k = Math.max(Lr, sr);
        if (Math.min(pn, Yr) - k > 0) {
          const _t = b && (D = (N = b[Y === "ltr" ? "start" : "end"]) != null ? N : b.left) != null ? D : 0, at = b && (de = (Ue = b[Y === "ltr" ? "end" : "start"]) != null ? Ue : b.right) != null ? de : 0;
          Qe.push({
            left: Lr,
            right: pn,
            totalLeft: sr,
            totalRight: Yr,
            leftMargin: _t,
            rightMargin: at,
            style: Cn
          });
        }
      };
      if ((!C[0] || ((Ur = C[0].start) != null ? Ur : he) > sr) && qr(sr, C[0] ? (Vn = C[0].start) != null ? Vn : he : Yr, Dt === "inactive" ? Je : ar), C.forEach((Lr, pn) => {
        var de, _t, at, Se;
        const Cn = Lr[Dt === "inactive" ? "track_inactive_style" : "track_active_style"], k = Cn ? Qn(Cn, tl, Un) : Dt === "inactive" ? Je : ar, j = C[pn - 1], N = C[pn + 1], D = (_t = (de = Lr.start) != null ? de : j == null ? void 0 : j.end) != null ? _t : sr, Ue = (Se = (at = Lr.end) != null ? at : N == null ? void 0 : N.start) != null ? Se : Yr;
        qr(D, Ue, k, Lr.margins);
      }), C[C.length - 1] && ((ue = C[C.length - 1].end) != null ? ue : d) < Yr) {
        const Lr = (ln = C[C.length - 1].end) != null ? ln : d;
        qr(Lr, Yr, Dt === "inactive" ? Je : ar);
      }
    };
    mt("inactive", he, d), mt("active", G, G + Ie);
    const lt = d - he;
    e(21, kr = Qe.map((Dt) => {
      let sr = `${(Dt.left - he) * 100 / lt}%`;
      Dt.leftMargin && (sr = `calc(${sr} + ${dn(Dt.leftMargin)})`);
      let Yr;
      Dt.totalLeft < Dt.left ? Yr = sr : Dt.leftMargin ? Yr = `max(${(Dt.totalLeft - he) * 100 / lt}%, ${sr})` : Yr = `${(Math.max(Dt.totalLeft, Dt.left) - he) * 100 / lt}%`;
      let qr = `${(1 - (Dt.right - he) / lt) * 100}%`;
      Dt.rightMargin && (qr = `calc(${qr} + ${dn(Dt.rightMargin)})`);
      let Ur;
      return Dt.totalRight > Dt.right ? Ur = qr : Dt.rightMargin ? Ur = `max(${(1 - (Dt.totalRight - he) / lt) * 100}%, ${qr})` : Ur = `${(1 - (Math.max(Dt.totalRight, Dt.right) - he) / lt) * 100}%`, {
        left: Yr,
        right: Ur,
        height: Re(Dt.style.height),
        borderRadius: Re(Dt.style.borderRadius),
        background: Dt.style.background,
        boxShadow: Dt.style.boxShadow || ""
      };
    }));
  }
  function ne(Y) {
    var C, Qe;
    if (!yr)
      return;
    const he = "pageX" in Y ? Y.pageX : (Qe = (C = Y.changedTouches) == null ? void 0 : C[0]) == null ? void 0 : Qe.pageX;
    if (he === void 0)
      return;
    const d = Yt.getBoundingClientRect();
    let G = (he - d.left) / d.width;
    me === "rtl" && (G = 1 - G);
    const Ie = wt + (Wt - wt) * G, Je = Math.round(Vi(Ie, wt, Wt)), ar = (gr + Er) / 2;
    e(16, Ht = Je < ar == gr < Er);
  }
  function we(Y, he) {
    const d = Number(Y.target.value);
    Ht === (he === "first") ? (e(12, Er = d), a.setValue(d)) : (e(11, gr = d), s.setValue(d));
  }
  let it = !1;
  function ut() {
    if (!Yt)
      return;
    const Y = Wt - wt, he = (zt == null ? void 0 : zt.width) || 0, d = (st == null ? void 0 : st.width) || 0;
    Math.max(he, d) * Y >= (Yt == null ? void 0 : Yt.clientWidth) ? it || (Te.logError(R(new Error("Slider ticks overlap each other"), { level: "warn" })), it = !0) : it = !1;
  }
  const dt = Bl(ut, 50);
  Jn(() => {
    ut();
  }), bn(() => {
    ze && (ke.unregisterFocusable(ze), e(44, ze = void 0));
  });
  const Cr = (Y) => we(Y, "first");
  function vt(Y) {
    Or[Y ? "unshift" : "push"](() => {
      Ot = Y, e(2, Ot);
    });
  }
  const v = (Y) => we(Y, "second");
  function V(Y) {
    Or[Y ? "unshift" : "push"](() => {
      Yt = Y, e(15, Yt);
    });
  }
  return t.$$set = (Y) => {
    "componentContext" in Y && e(0, Te = Y.componentContext), "layoutParams" in Y && e(1, cr = Y.layoutParams);
  }, t.$$.update = () => {
    var Y, he, d, G;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(56, n = Te.origJson), t.$$.dirty[1] & /*origJson*/
    33554432 && n && Ir(), t.$$.dirty[0] & /*componentContext*/
    1 && e(55, i = Te.json.thumb_value_variable), t.$$.dirty[0] & /*componentContext*/
    1 && e(13, o = Te.json.thumb_secondary_value_variable), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*firstVariable*/
    16777216 && Et(e(22, s = i && (Te.getVariable(i, "integer") || ke.awaitGlobalVariable(i, "integer", 0)) || mi("temp", "integer", 0))), t.$$.dirty[0] & /*secondVariable, componentContext*/
    8193 && rt(e(23, a = o && (Te.getVariable(o, "integer") || ke.awaitGlobalVariable(o, "integer", 0)) || mi("temp", "integer", 0))), t.$$.dirty[0] & /*componentContext*/
    1 && qe(e(39, l = Te.getDerivedFromVars(Te.json.min_value))), t.$$.dirty[0] & /*componentContext*/
    1 && L(e(38, u = Te.getDerivedFromVars(Te.json.max_value))), t.$$.dirty[0] & /*componentContext*/
    1 && Jt(e(37, c = Te.getDerivedFromVars(Te.json.thumb_style))), t.$$.dirty[0] & /*componentContext*/
    1 && $e(e(36, f = Te.getDerivedFromVars(Te.json.thumb_secondary_style))), t.$$.dirty[0] & /*componentContext*/
    1 && fe(e(35, _ = Te.getDerivedFromVars(Te.json.track_inactive_style))), t.$$.dirty[0] & /*componentContext*/
    1 && He(e(34, g = Te.getDerivedFromVars(Te.json.track_active_style))), t.$$.dirty[0] & /*componentContext*/
    1 && De(e(33, y = Te.getDerivedFromVars(Te.json.tick_mark_active_style))), t.$$.dirty[0] & /*componentContext*/
    1 && $(e(32, p = Te.getDerivedFromVars(Te.json.tick_mark_inactive_style))), t.$$.dirty[0] & /*componentContext*/
    1 && pt(e(31, w = Te.getDerivedFromVars(Te.json.thumb_text_style))), t.$$.dirty[0] & /*componentContext*/
    1 && te(e(30, E = Te.getDerivedFromVars(Te.json.thumb_secondary_text_style))), t.$$.dirty[0] & /*componentContext*/
    1 && ye(e(29, Q = Te.getDerivedFromVars(Te.json.accessibility))), t.$$.dirty[0] & /*componentContext*/
    1 && Ne(e(28, J = Te.getDerivedFromVars(Te.json.secondary_value_accessibility))), t.$$.dirty[0] & /*componentContext*/
    1 && Oe(e(27, M = Te.getDerivedFromVars(Te.json.is_enabled))), t.$$.dirty[0] & /*componentContext*/
    1 && Me(e(26, ge = Te.getDerivedFromVars(Te.json.ranges))), t.$$.dirty[0] & /*minValue, maxValue*/
    24 | t.$$.dirty[2] & /*$jsonMinValue, $jsonMaxValue*/
    1536 && (e(3, wt = uo(Le, wt)), e(4, Wt = uo(It, Wt)), ut()), t.$$.dirty[0] & /*minValue, maxValue, value*/
    2072 | t.$$.dirty[2] & /*$valueVariable*/
    256) {
      const Ie = Vi(ir || 0, wt, Wt);
      Ie !== gr && e(11, gr = Ie);
    }
    if (t.$$.dirty[0] & /*minValue, maxValue, value2*/
    4120 | t.$$.dirty[2] & /*$value2Variable*/
    128) {
      const Ie = Vi(bt || 0, wt, Wt);
      Ie !== Er && e(12, Er = Ie);
    }
    if (t.$$.dirty[0] & /*thumbStyle*/
    32 | t.$$.dirty[2] & /*$jsonThumbStyle*/
    64 && e(5, Lt = Qn(Ce, Ro, Lt)), t.$$.dirty[0] & /*thumbStyle*/
    32 | t.$$.dirty[2] & /*$jsonThumbSecondaryStyle*/
    32 && e(6, Gt = Qn(Vt, Ro, Lt)), t.$$.dirty[1] & /*trackInactiveStyle*/
    16384 | t.$$.dirty[2] & /*$jsonTrackInactiveStyle*/
    16 && e(45, tr = Qn(ht, tl, tr)), t.$$.dirty[1] & /*trackActiveStyle*/
    32768 | t.$$.dirty[2] & /*$jsonTrackActiveStyle*/
    8 && e(46, or = Qn(ft, tl, or)), t.$$.dirty[2] & /*$jsonMarkActiveStyle*/
    4) {
      let Ie = Qn(pe, Ro, Un);
      Ie !== Un && e(47, zt = Ie);
    }
    if (t.$$.dirty[0] & /*secondVariable, value, value2, minValue, maxValue*/
    14360 | t.$$.dirty[1] & /*markActiveStyle*/
    65536 && (zt ? (e(17, mr = o ? Bo(Math.min(gr, Er), Math.max(gr, Er) + 1, wt, Wt, !0) : Bo(wt, gr, wt, Wt, !0)), ut()) : e(17, mr = [])), t.$$.dirty[2] & /*$jsonMarkInactiveStyle*/
    2) {
      let Ie = Qn(Ct, Ro, Un);
      Ie !== Un && e(48, st = Ie);
    }
    if (t.$$.dirty[0] & /*secondVariable, value, value2, minValue, maxValue*/
    14360 | t.$$.dirty[1] & /*markInactiveStyle*/
    131072 && (st ? (e(18, Ut = o ? Bo(Math.min(gr, Er), Math.max(gr, Er) + 1, wt, Wt, !1) : Bo(gr + 1, Wt + 1, wt, Wt, !0)), ut()) : e(18, Ut = [])), t.$$.dirty[0] & /*textStyle*/
    128 | t.$$.dirty[2] & /*$jsonTextStyle*/
    1 && e(7, et = Tu(ot, et)), t.$$.dirty[0] & /*textStyle*/
    128 | t.$$.dirty[1] & /*$jsonSecondaryTextStyle*/
    1073741824 && e(8, nr = Tu(Ke, et)), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*$jsonAccessibility*/
    536870912 && (Pe != null && Pe.description ? e(19, Ar = po(Pe)) : Te.logError(R(new Error('Missing accessibility "description" for slider'), { level: "warn" }))), t.$$.dirty[0] & /*isEnabled*/
    512 | t.$$.dirty[1] & /*$jsonIsEnabled*/
    268435456 && e(9, yr = Tn(Ft, yr)), t.$$.dirty[0] & /*secondVariable, componentContext*/
    8193 | t.$$.dirty[1] & /*$jsonSecondaryAccessibility*/
    134217728 && (tt != null && tt.description ? e(20, br = po(tt)) : o && Te.logError(R(new Error('Missing second accessibility "description" for slider'), { level: "warn" }))), t.$$.dirty[0] & /*componentContext, thumbStyle, hasError*/
    1057 | t.$$.dirty[1] & /*trackActiveStyle, trackInactiveStyle*/
    49152) {
      let Ie = !1;
      hr.hasAction() ? (Te.logError(R(new Error('Cannot show "slider" inside component with an action or inside accessibility mode=exclude'))), Ie = !0) : Lt === Un ? (Te.logError(R(new Error('Missing "thumb_style" in slider'))), Ie = !0) : or === Un ? (Te.logError(R(new Error('Missing "track_active_style" in slider'))), Ie = !0) : tr === Un && (Te.logError(R(new Error('Missing "track_inactive_style" in slider'))), Ie = !0), Ie !== jr && e(10, jr = Ie);
    }
    t.$$.dirty[0] & /*thumbStyle, thumbSecondaryStyle*/
    96 && e(52, le = Re(Math.max(...[Lt.width, Gt.width, 0].filter(zn)))), t.$$.dirty[0] & /*thumbStyle, thumbSecondaryStyle*/
    96 && e(51, H = Re(Math.max(...[Lt.height, Gt.height, 0].filter(zn)))), t.$$.dirty[0] & /*value, minValue, maxValue*/
    2072 && e(50, ee = (gr - wt) / (Wt - wt)), t.$$.dirty[0] & /*secondVariable, value2, minValue, maxValue*/
    12312 && e(49, X = o ? (Er - wt) / (Wt - wt) : void 0), t.$$.dirty[0] & /*value, value2, minValue*/
    6152 | t.$$.dirty[1] & /*trackSecondaryPart*/
    262144 && e(54, I = X !== void 0 ? Math.min(gr, Er) : wt), t.$$.dirty[0] & /*value2, value, minValue*/
    6152 | t.$$.dirty[1] & /*trackSecondaryPart*/
    262144 && e(53, P = X !== void 0 ? Math.abs(Er - gr) : gr - wt), t.$$.dirty[0] & /*$direction, minValue, maxValue*/
    16408 | t.$$.dirty[1] & /*trackActiveOffset, trackActivePart, trackInactiveStyle, trackActiveStyle, $jsonRanges*/
    79740928 && Ze({
      direction: me,
      minValue: wt,
      maxValue: Wt,
      trackActiveOffset: I,
      trackActivePart: P,
      trackInactiveStyle: tr,
      trackActiveStyle: or,
      ranges: nt
    }), t.$$.dirty[0] & /*thumbStyle, thumbSecondaryStyle, textStyle, textSecondaryStyle*/
    480 | t.$$.dirty[1] & /*markActiveStyle, markInactiveStyle, maxThumbWidth, maxThumbHeight, trackPart, trackSecondaryPart*/
    4128768 && e(25, O = {
      "--divkit-slider-thumb-width": Re(Lt.width),
      "--divkit-slider-thumb-height": Re(Lt.height),
      "--divkit-slider-thumb-secondary-width": Re(Gt.width),
      "--divkit-slider-thumb-secondary-height": Re(Gt.height),
      "--divkit-slider-text-offset-x": (Y = et == null ? void 0 : et.offset) != null && Y.x ? dn(et.offset.x) : void 0,
      "--divkit-slider-text-offset-y": (he = et == null ? void 0 : et.offset) != null && he.y ? dn(et.offset.y) : void 0,
      "--divkit-slider-text-secondary-offset-x": (d = nr == null ? void 0 : nr.offset) != null && d.x ? dn(nr.offset.x) : void 0,
      "--divkit-slider-text-secondary-offset-y": (G = nr == null ? void 0 : nr.offset) != null && G.y ? dn(nr.offset.y) : void 0,
      "--divkit-slider-tick-active-width": zt ? Re(zt.width) : void 0,
      "--divkit-slider-tick-active-height": zt ? Re(zt.height) : void 0,
      "--divkit-slider-tick-active-border-radius": zt ? Re(zt.borderRadius) : void 0,
      "--divkit-slider-tick-active-background": (zt == null ? void 0 : zt.background) || void 0,
      "--divkit-slider-tick-active-box-shadow": (zt == null ? void 0 : zt.boxShadow) || void 0,
      "--divkit-slider-tick-inactive-width": st ? Re(st.width) : void 0,
      "--divkit-slider-tick-inactive-height": st ? Re(st.height) : void 0,
      "--divkit-slider-tick-inactive-border-radius": st ? Re(st.borderRadius) : void 0,
      "--divkit-slider-tick-inactive-background": (st == null ? void 0 : st.background) || void 0,
      "--divkit-slider-tick-inactive-box-shadow": (st == null ? void 0 : st.boxShadow) || void 0,
      "--divkit-slider-max-thumb-width": le,
      "--divkit-slider-max-thumb-height": H,
      "--divkit-slider-track-part": ee,
      "--divkit-slider-track-secondary-part": X
    }), t.$$.dirty[0] & /*$direction*/
    16384 && e(24, U = { direction: me }), t.$$.dirty[0] & /*componentContext, input*/
    5 | t.$$.dirty[1] & /*prevId*/
    8192 && Te.json && Ot && (ze && (ke.unregisterFocusable(ze), e(44, ze = void 0)), Te.id && !Te.fakeElement && (e(44, ze = Te.id), ke.registerFocusable(ze, {
      focus() {
        Ot && Ot.focus();
      }
    })));
  }, [
    Te,
    cr,
    Ot,
    wt,
    Wt,
    Lt,
    Gt,
    et,
    nr,
    yr,
    jr,
    gr,
    Er,
    o,
    me,
    Yt,
    Ht,
    mr,
    Ut,
    Ar,
    br,
    kr,
    s,
    a,
    U,
    O,
    ge,
    M,
    J,
    Q,
    E,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    ie,
    ne,
    we,
    dt,
    ze,
    tr,
    or,
    zt,
    st,
    X,
    ee,
    H,
    le,
    P,
    I,
    i,
    n,
    nt,
    tt,
    Ft,
    Pe,
    Ke,
    ot,
    Ct,
    pe,
    ft,
    ht,
    Vt,
    Ce,
    bt,
    ir,
    It,
    Le,
    Cr,
    vt,
    v,
    V
  ];
}
class _m extends $r {
  constructor(r) {
    super(), xr(this, r, dm, fm, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1, -1]);
  }
}
const pm = "appkit-input", hm = "appkit-input__aligner", gm = "appkit-input__input", mm = "appkit-input__placeholder", bm = "appkit-input__input_singleline", ym = "appkit-input__input_multiline", yi = {
  input: pm,
  "input_alignment-horizontal_center": "appkit-input_alignment-horizontal_center",
  "input_alignment-horizontal_end": "appkit-input_alignment-horizontal_end",
  input__aligner: hm,
  input__input: gm,
  input__placeholder: mm,
  "input_alignment-vertical_start": "appkit-input_alignment-vertical_start",
  "input_alignment-vertical_end": "appkit-input_alignment-vertical_end",
  "input_alignment-vertical_baseline": "appkit-input_alignment-vertical_baseline",
  "input_highlight-color": "appkit-input_highlight-color",
  input__input_singleline: bm,
  "input__scroll-wrapper": "appkit-input__scroll-wrapper",
  input__input_multiline: ym,
  "input__input_has-custom-focus": "appkit-input__input_has-custom-focus"
};
function zo(t, r) {
  if (t === r)
    return {
      start: t.length,
      added: 0,
      removed: 0
    };
  if (t.length > r.length) {
    const o = zo(r, t);
    return {
      start: o.start,
      added: o.removed,
      removed: o.added
    };
  }
  let e = 0, n = r.length - 1;
  const i = r.length - t.length;
  for (; e < n && e < t.length && t[e] === r[e]; )
    ++e;
  for (; n - i >= e && t[n - i] === r[n]; )
    --n;
  return ++n, {
    start: e,
    added: n - e,
    removed: n - e - i
  };
}
class Uu {
  constructor(r) {
    this.char = r;
  }
}
class ii {
  constructor(r, e, n) {
    this.char = r, this.filter = e, this.placeholder = n;
  }
}
class ql {
  constructor(r) {
    dr(this, "maskData");
    dr(this, "filters", /* @__PURE__ */ new Map());
    dr(this, "destructedValue", []);
    dr(this, "cursorPos", 0);
    this.maskData = r, this.updateMaskData(r);
  }
  get cursorPosition() {
    return this.cursorPos;
  }
  get rawValue() {
    return this.collectValueRange(0, this.destructedValue.length - 1);
  }
  get value() {
    let r = "";
    for (let e = 0; e < this.destructedValue.length; ++e) {
      const n = this.destructedValue[e];
      if (n instanceof Uu)
        r += n.char;
      else if (n instanceof ii)
        if (n.char)
          r += n.char;
        else if (this.maskData.alwaysVisible)
          r += n.placeholder;
        else
          break;
    }
    return r;
  }
  firstEmptyHolderIndex() {
    const r = this.destructedValue.findIndex((e) => e instanceof ii && !e.char);
    return r !== -1 ? r : this.destructedValue.length;
  }
  updateMaskData(r, e = !0) {
    const n = this.maskData !== r && e ? this.rawValue : null;
    this.filters = /* @__PURE__ */ new Map(), this.maskData = r, this.maskData.decoding.forEach((i) => {
      if (i.filter)
        try {
          const o = new RegExp(i.filter);
          this.filters.set(i.key, o);
        } catch (o) {
          this.onException(R(o, {
            level: "error",
            additional: {
              key: i.key
            }
          }));
        }
    }), this.destructedValue = this.maskData.pattern.split("").map((i) => {
      const o = this.maskData.decoding.find((s) => s.key === i);
      return o ? new ii(
        null,
        this.filters.get(o.key),
        o.placeholder
      ) : new Uu(i);
    }), n !== null && this.overrideRawValue(n);
  }
  overrideRawValue(r) {
    this.clearRange(0, this.destructedValue.length), this.replaceChars(r, 0), this.cursorPos = Math.min(this.cursorPos, this.value.length);
  }
  applyChangeFrom(r, e) {
    const n = zo(this.value, r);
    e !== void 0 && (n.start = Math.max(0, e - n.added));
    const i = this.replaceBodyTail(n, r);
    this.calculateCursorPosition(n, i);
  }
  replaceBodyTail(r, e) {
    const n = this.buildBodySubstring(r, e), i = this.buildTailSubstring(r);
    this.cleanup(r);
    const o = this.firstEmptyHolderIndex(), s = i ? this.calculateMaxShift(i, o) : void 0;
    this.replaceChars(n, o, s);
    const a = this.firstEmptyHolderIndex();
    return this.replaceChars(i, a), a;
  }
  buildBodySubstring(r, e) {
    return e.substring(r.start, r.start + r.added);
  }
  buildTailSubstring(r) {
    return this.collectValueRange(
      r.start + r.removed,
      this.destructedValue.length - 1
    );
  }
  calculateMaxShift(r, e) {
    if (this.filters.size <= 1) {
      let o = 0, s = e;
      for (; s < this.destructedValue.length; )
        this.destructedValue[s] instanceof ii && ++o, ++s;
      return Math.max(0, o - r.length);
    }
    const n = this.calculateInsertableSubstring(r, e);
    let i = 0;
    for (; i < this.destructedValue.length && n === this.calculateInsertableSubstring(r, e + i); )
      ++i;
    return Math.max(0, i - 1);
  }
  cleanup(r) {
    if (r.added === 0 && r.removed === 1) {
      let e = r.start;
      for (; e >= 0; ) {
        const n = this.destructedValue[e];
        if (n instanceof ii && n.char !== null) {
          n.char = null;
          break;
        } else
          --e;
      }
    }
    this.clearRange(r.start, this.destructedValue.length);
  }
  clearRange(r, e) {
    let n = r;
    for (; n < e && n < this.destructedValue.length; ) {
      const i = this.destructedValue[n];
      i instanceof ii && (i.char = null), ++n;
    }
  }
  calculateCursorPosition(r, e) {
    const n = this.firstEmptyHolderIndex();
    let i;
    r.start < n ? i = Math.min(this.firstHolderAfter(e), this.value.length) : i = n, this.cursorPos = i;
  }
  calculateInsertableSubstring(r, e) {
    let n = "", i = e;
    const o = () => {
      var s;
      for (; i < this.destructedValue.length && !(this.destructedValue[i] instanceof ii); )
        ++i;
      return (s = this.destructedValue[i]) == null ? void 0 : s.filter;
    };
    return r.split("").forEach((s) => {
      const a = o();
      a != null && a.test(s) && (n += s, ++i);
    }), n;
  }
  collectValueRange(r, e) {
    let n = "", i = r;
    for (; i <= e; ) {
      const o = this.destructedValue[i];
      o instanceof ii && o.char !== null && (n += o.char), ++i;
    }
    return n;
  }
  replaceChars(r, e, n) {
    let i = this.calculateInsertableSubstring(r, e);
    n !== void 0 && (i = i.substring(0, n));
    let o = e, s = 0;
    for (; o < this.destructedValue.length && s < i.length; ) {
      const a = this.destructedValue[o], l = i[s];
      a instanceof ii && (a.char = l, ++s), ++o;
    }
  }
  firstHolderAfter(r) {
    let e = r;
    for (; e < this.destructedValue.length && !(this.destructedValue[e] instanceof ii); )
      ++e;
    return e;
  }
}
class wm extends ql {
  constructor(r, e) {
    super(r), this.logError = e;
  }
  onException(r) {
    this.logError(r);
  }
}
function vm(t, r, e) {
  if (typeof t.pattern == "string" && Array.isArray(t.pattern_elements) && t.pattern_elements.every((n) => n.key && typeof n.key == "string")) {
    const n = {
      pattern: t.pattern,
      alwaysVisible: !!t.always_visible,
      decoding: t.pattern_elements.map((i) => ({
        key: i.key,
        filter: i.regex && typeof i.regex == "string" ? i.regex : void 0,
        placeholder: i.placeholder && typeof i.placeholder == "string" ? i.placeholder : "_"
      }))
    };
    return e ? (e.updateMaskData(n), e) : new wm(n, r);
  }
  return e || null;
}
class km extends ql {
  constructor(e = void 0, n) {
    super({
      pattern: "",
      decoding: [],
      alwaysVisible: !1
    });
    dr(this, "currencyFormatter", new Intl.NumberFormat());
    dr(this, "decimalSeparator", ".");
    dr(this, "localeDigits", {});
    dr(this, "trimZeroRegExp", new RegExp(""));
    this.logError = n, this.initFormatter(e);
  }
  updateCurrencyParams(e) {
    const n = this.parseFormat(this.rawValue) || 0;
    this.initFormatter(e);
    const i = n.toString().replace(".", this.decimalSeparator);
    this.applyChangeFrom(i);
  }
  initFormatter(e) {
    try {
      this.currencyFormatter = new Intl.NumberFormat(e, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }), this.decimalSeparator = this.currencyFormatter.format(0)[1], this.localeDigits = new Array(10).fill("").reduce((n, i, o) => (n[o] = this.currencyFormatter.format(o)[0], n), {}), this.trimZeroRegExp = new RegExp(`^${this.localeDigits[0]}+`);
    } catch (n) {
      this.onException(R(n, {
        level: "error",
        additional: {
          locale: e
        }
      }));
    }
  }
  invalidateMaskDataForFormatted(e) {
    const n = this.currencyFormatter.format(e), i = this.formatPattern(n), o = [{
      key: "#",
      filter: `[${[...Object.values(this.localeDigits)].join("")}]`,
      placeholder: this.localeDigits[0]
    }, {
      key: this.decimalSeparator,
      filter: `[${this.decimalSeparator}]`,
      placeholder: this.decimalSeparator
    }];
    this.updateMaskData({
      pattern: i,
      decoding: o,
      alwaysVisible: this.maskData.alwaysVisible
    }, !1);
  }
  overrideRawValue(e) {
    const n = this.parseFormat(e) || 0;
    this.invalidateMaskDataForFormatted(n), super.overrideRawValue(e);
  }
  applyChangeFrom(e, n) {
    const i = zo(this.value, e), o = this.value.lastIndexOf(this.decimalSeparator), s = e.lastIndexOf(this.decimalSeparator), a = o !== s || o === -1 && s === -1, l = this.validFormat(e, i);
    this.cleanup(i);
    const u = this.parseFormat(l) || 0;
    a && this.invalidateMaskDataForFormatted(u), this.replaceChars(l, 0), this.value.length > i.start && !this.isDigit(this.value[i.start]) ? this.cursorPos = n != null ? n : this.cursorPosition : this.cursorPos = Math.abs(this.value.length - (e.length - (n != null ? n : this.cursorPosition)));
  }
  parseFormat(e) {
    return parseFloat(
      e.replace(/./g, (n) => {
        const i = this.localeDigits[n];
        return i || (n === this.decimalSeparator ? "." : "");
      })
    );
  }
  formatPattern(e) {
    let n = "";
    for (const i of e)
      n += this.isDigit(i) ? "#" : i;
    return n;
  }
  validFormat(e, n) {
    if (!e)
      return "";
    let i = -1, o = 0;
    for (; o < e.length; ) {
      if (e[o] === this.decimalSeparator && !this.inDiff(n, o)) {
        i = o;
        break;
      }
      o++;
    }
    let s = -1;
    n.added === 1 && n.removed === 0 && [",", "."].includes(e[n.start]) && (s = n.start);
    const a = this.currencyFormatter.resolvedOptions().maximumFractionDigits || 0;
    let l = a;
    if (i !== -1)
      for (o = i; o < e.length; )
        this.isDigit(e[o]) && !this.inDiff(n, o) && l--, o++;
    else {
      let _ = !1;
      for (let g = 0; g < e.length; g++) {
        const y = e[g];
        y === this.decimalSeparator ? _ = !0 : !this.inDiff(n, g) && _ && this.isDigit(y) && l--;
      }
    }
    const u = e.includes(this.decimalSeparator) || s !== -1, c = [];
    o = e.length - 1;
    let f = !1;
    for (; o >= 0; ) {
      const _ = e[o], g = c.length <= a;
      this.isDigit(_) ? this.inDiff(n, o) && !f && u ? l > 0 && (c.push(_), l--) : c.push(_) : g && i === -1 && o === s ? (c.push(this.decimalSeparator), f = !0) : g && _ === this.decimalSeparator && (i === o || i === -1) && (c.push(this.decimalSeparator), f = !0, i = o), o--;
    }
    return c.reverse().join("").replace(this.trimZeroRegExp, "");
  }
  inDiff(e, n) {
    return e.start <= n && n < e.start + e.added;
  }
  isDigit(e) {
    return !!this.localeDigits[e];
  }
  onException(e) {
    this.logError(e);
  }
}
function Em(t, r, e) {
  return e ? (e.updateCurrencyParams(t.locale), e) : new km(t.locale, r);
}
const $f = 3;
function hl(t) {
  const r = t.textContent;
  let e = 0;
  return typeof r == "string" && (e += r.length, t instanceof HTMLElement && (t.tagName === "DIV" || t.tagName === "BR") && ++e), e;
}
function Gu(t, r) {
  var e;
  try {
    let n = 0;
    const i = window.getSelection();
    if (!i)
      return 0;
    const o = i.getRangeAt(0);
    let s;
    if (o && (n += r === "end" ? o.endOffset : o.startOffset, s = r === "end" ? o.endContainer : o.startContainer), s instanceof HTMLElement) {
      let a = 0;
      for (let l = 0, u = Math.min(n, s.childNodes.length); l < u; ++l)
        a += hl(s.childNodes[l]);
      n = a;
    }
    for (; s && s !== t; ) {
      const a = s.parentNode;
      if (!a)
        return 0;
      const l = Array.from(a.childNodes).indexOf(s);
      for (let u = 0; u < l; ++u) {
        const c = a.childNodes[u];
        n += hl(c);
      }
      s instanceof HTMLElement && (s.tagName === "DIV" && ((e = a.childNodes[l - 1]) == null ? void 0 : e.nodeType) === $f || s.tagName === "BR") && ++n, s = a;
    }
    return n;
  } catch {
    return 0;
  }
}
function gl(t, r, e, n) {
  if (t.nodeType === $f) {
    try {
      e === "start" ? r.setStart(t, n) : r.setEnd(t, n);
    } catch {
    }
    return;
  }
  if (t instanceof HTMLElement && t.tagName === "BR") {
    try {
      const i = window.getSelection();
      if (i) {
        i.removeAllRanges();
        const o = document.createRange(), s = t.parentNode, a = Array.from(s.childNodes).indexOf(t) + 1;
        o.setStart(s, a), o.setEnd(s, a), i.addRange(o);
      }
    } catch {
    }
    return;
  }
  for (let i = 0, o = t.childNodes.length; i < o; ++i) {
    const s = t.childNodes[i], a = hl(s);
    if (n <= a) {
      gl(s, r, e, n);
      return;
    }
    n -= a;
  }
}
const Am = {
  rus_local: {
    value: "0 (000) 000-00-00"
  },
  rus: {
    value: "+0 (000) 000-00-00"
  },
  am: {
    value: "+000 (000) 000-00-00"
  },
  az: {
    value: "+000 (000) 000-00-00"
  },
  br: {
    value: "+00 (00) 0000-0000"
  },
  by: {
    value: "+000 (00) 000-00-00"
  },
  kg: {
    value: "+000 (000) 000-00-00"
  },
  md: {
    value: "+000 (000) 0-00-00"
  },
  kz: {
    value: "+0 (000) 000-00-00"
  },
  ua: {
    value: "+000 (00) 000-00-00"
  },
  uz: {
    value: "+000 (00) 000-00-00"
  },
  uk: {
    value: "+00 0000 000000"
  },
  swiss: {
    value: "+00 00 000-00-00"
  },
  angola: {
    value: "+000 000 000 000"
  },
  netherlands: {
    value: "+00 00 000 0000"
  },
  ge: {
    value: "+000 (000) 00-00-00"
  },
  short: {
    value: "+0 (000) 000-00-00"
  },
  middle: {
    value: "+00 (000) 000-00-00"
  },
  long: {
    value: "+000 (00) 000-00-00"
  },
  universal: {
    value: "+0000000000000"
  }
}, jm = {
  value: {
    default_value: {
      1: {
        $ref: "#/constants/short"
      },
      2: {
        0: {
          $ref: "#/constants/middle"
        },
        4: {
          4: {
            $ref: "#/constants/angola"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        7: {
          $ref: "#/constants/middle"
        },
        "*": {
          $ref: "#/constants/long"
        }
      },
      3: {
        1: {
          $ref: "#/constants/netherlands"
        },
        5: {
          0: {
            $ref: "#/constants/ua"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        7: {
          3: {
            $ref: "#/constants/md"
          },
          4: {
            $ref: "#/constants/am"
          },
          5: {
            $ref: "#/constants/by"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        8: {
          0: {
            $ref: "#/constants/ua"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      4: {
        1: {
          $ref: "#/constants/swiss"
        },
        2: {
          $ref: "#/constants/long"
        },
        4: {
          $ref: "#/constants/uk"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      5: {
        0: {
          $ref: "#/constants/long"
        },
        5: {
          $ref: "#/constants/br"
        },
        9: {
          $ref: "#/constants/long"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      6: {
        7: {
          $ref: "#/constants/long"
        },
        8: {
          $ref: "#/constants/long"
        },
        9: {
          $ref: "#/constants/long"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      7: {
        3: {
          3: {
            $ref: "#/constants/kz"
          },
          "*": {
            $ref: "#/constants/rus"
          }
        },
        7: {
          $ref: "#/constants/kz"
        },
        "*": {
          $ref: "#/constants/rus"
        }
      },
      8: {
        5: {
          $ref: "#/constants/long"
        },
        8: {
          $ref: "#/constants/long"
        },
        9: {
          $ref: "#/constants/rus_local"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      9: {
        6: {
          $ref: "#/constants/long"
        },
        7: {
          $ref: "#/constants/long"
        },
        9: {
          4: {
            $ref: "#/constants/az"
          },
          5: {
            $ref: "#/constants/ge"
          },
          6: {
            $ref: "#/constants/kg"
          },
          8: {
            $ref: "#/constants/uz"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      "*": {
        $ref: "#/constants/universal"
      }
    }
  }
}, ed = {
  constants: Am,
  properties: jm
}, Cm = "000000000000000", Yu = "*", Sm = "00", qu = [{
  key: "0",
  filter: "\\d",
  placeholder: "_"
}];
class Vm extends ql {
  constructor(e) {
    super({
      pattern: Ku(""),
      decoding: qu,
      alwaysVisible: !1
    });
    dr(this, "decimalSeparator", ".");
    dr(this, "localeDigits", {});
    dr(this, "trimZeroRegExp", new RegExp(""));
    this.logError = e;
  }
  overrideRawValue(e) {
    this.tryInvalidateMaskDataWith(e), super.overrideRawValue(e);
  }
  applyChangeFrom(e, n) {
    const i = zo(this.value, e);
    n !== void 0 && (i.start = Math.max(0, n - i.added));
    const o = this.rawValue, s = this.replaceBodyTail(i, e), a = this.rawValue, l = this.newMaskPatternFor(a);
    if (l == null) {
      this.calculateCursorPosition(i, s);
      return;
    }
    this.updateMaskDataWith(l), this.replaceChars(a, 0);
    const u = zo(o, a), c = u.start + u.added;
    this.calculateCursorPositionBy(c);
  }
  calculateCursorPositionBy(e) {
    let n = 0, i = 0;
    for (; n < this.destructedValue.length && i < e; )
      this.destructedValue[n++] instanceof ii && i++;
    this.cursorPos = this.firstHolderAfter(n);
  }
  tryInvalidateMaskDataWith(e) {
    const n = this.newMaskPatternFor(e);
    n && this.updateMaskDataWith(n);
  }
  newMaskPatternFor(e) {
    const n = Ku(e), i = this.maskData.pattern;
    return n !== i ? n : null;
  }
  updateMaskDataWith(e) {
    return this.updateMaskData({
      pattern: e,
      decoding: qu,
      alwaysVisible: this.maskData.alwaysVisible
    }, !1);
  }
  onException(e) {
    this.logError(e);
  }
}
function Ju(t) {
  return "$ref" in t ? ed.constants[t.$ref.split("/").pop()] : t;
}
function Ku(t) {
  if (!t)
    return Cm;
  let r = ed.properties.value.default_value, e = 0;
  for (; !("value" in r); ) {
    if (e >= t.length) {
      r = Ju(r[Yu]);
      break;
    }
    const n = t[e++];
    r = Ju(r[n in r ? n : Yu]);
  }
  return r.value + Sm;
}
function Im(t, r) {
  return r || new Vm(t);
}
function Dm(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Tm(t) {
  let r, e;
  return r = new On({
    props: {
      alwaysCustomFocus: !0,
      cls: jt(
        "input",
        yi,
        /*mods*/
        t[20]
      ),
      style: (
        /*stl*/
        t[19]
      ),
      customDescription: !0,
      customActions: "input",
      customPaddings: !0,
      hasInnerFocusable: !0,
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      $$slots: {
        default: [
          zm,
          ({ focusHandler: n, blurHandler: i, hasCustomFocus: o }) => ({
            120: n,
            121: i,
            122: o
          }),
          ({ focusHandler: n, blurHandler: i, hasCustomFocus: o }) => [
            0,
            0,
            0,
            (n ? 134217728 : 0) | (i ? 268435456 : 0) | (o ? 536870912 : 0)
          ]
        ]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      1048576 && (o.cls = jt(
        "input",
        yi,
        /*mods*/
        n[20]
      )), i[0] & /*stl*/
      524288 && (o.style = /*stl*/
      n[19]), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*autocapitalization, description, enterKeyType, describedBy, paddingStl, input, contentEditableValue, isEnabled, verticalPaddingStl, placeholder, isMultiline, inputType, inputMode, maxLength, value*/
      2555756 | i[1] & /*$jsonSelectAll*/
      32768 | i[3] & /*$$scope, hasCustomFocus, focusHandler, blurHandler*/
      2013265920 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Fm(t) {
  let r, e, n, i, o, s, a, l, u;
  return {
    c() {
      r = Be("input"), m(
        r,
        "type",
        /*inputType*/
        t[10]
      ), m(
        r,
        "inputmode",
        /*inputMode*/
        t[11]
      ), m(r, "class", e = jt("input__input", yi, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[122]
        ),
        singleline: !0
      })), m(r, "autocomplete", "off"), m(
        r,
        "autocapitalize",
        /*autocapitalization*/
        t[13]
      ), m(
        r,
        "aria-label",
        /*description*/
        t[12]
      ), m(r, "aria-describedby", n = /*describedBy*/
      t[15] || void 0), m(r, "style", i = Rt(
        /*paddingStl*/
        t[18]
      )), r.disabled = o = !/*isEnabled*/
      t[5], m(r, "maxlength", s = /*maxLength*/
      t[6] === 1 / 0 ? void 0 : (
        /*maxLength*/
        t[6]
      )), m(
        r,
        "placeholder",
        /*placeholder*/
        t[21]
      ), r.value = /*value*/
      t[3], m(r, "enterkeyhint", a = /*enterKeyType*/
      t[14] === "default" ? void 0 : (
        /*enterKeyType*/
        t[14]
      ));
    },
    m(c, f) {
      x(c, r, f), t[103](r), l || (u = [
        Ge(
          r,
          "input",
          /*onInput*/
          t[48]
        ),
        Ge(
          r,
          "keydown",
          /*onKeyDown*/
          t[50]
        ),
        Ge(r, "mousedown", function() {
          zr(
            /*$jsonSelectAll*/
            t[46] ? (
              /*onMousedown*/
              t[51]
            ) : void 0
          ) && (t[46] ? (
            /*onMousedown*/
            t[51]
          ) : void 0).apply(this, arguments);
        }),
        Ge(r, "click", function() {
          zr(
            /*$jsonSelectAll*/
            t[46] ? (
              /*onClick*/
              t[52]
            ) : void 0
          ) && (t[46] ? (
            /*onClick*/
            t[52]
          ) : void 0).apply(this, arguments);
        }),
        Ge(r, "focus", function() {
          zr(
            /*focusHandler*/
            t[120]
          ) && t[120].apply(this, arguments);
        }),
        Ge(r, "blur", function() {
          zr(
            /*blurHandler*/
            t[121]
          ) && t[121].apply(this, arguments);
        })
      ], l = !0);
    },
    p(c, f) {
      t = c, f[0] & /*inputType*/
      1024 && m(
        r,
        "type",
        /*inputType*/
        t[10]
      ), f[0] & /*inputMode*/
      2048 && m(
        r,
        "inputmode",
        /*inputMode*/
        t[11]
      ), f[3] & /*hasCustomFocus*/
      536870912 && e !== (e = jt("input__input", yi, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[122]
        ),
        singleline: !0
      })) && m(r, "class", e), f[0] & /*autocapitalization*/
      8192 && m(
        r,
        "autocapitalize",
        /*autocapitalization*/
        t[13]
      ), f[0] & /*description*/
      4096 && m(
        r,
        "aria-label",
        /*description*/
        t[12]
      ), f[0] & /*describedBy*/
      32768 && n !== (n = /*describedBy*/
      t[15] || void 0) && m(r, "aria-describedby", n), f[0] & /*paddingStl*/
      262144 && i !== (i = Rt(
        /*paddingStl*/
        t[18]
      )) && m(r, "style", i), f[0] & /*isEnabled*/
      32 && o !== (o = !/*isEnabled*/
      t[5]) && (r.disabled = o), f[0] & /*maxLength*/
      64 && s !== (s = /*maxLength*/
      t[6] === 1 / 0 ? void 0 : (
        /*maxLength*/
        t[6]
      )) && m(r, "maxlength", s), f[0] & /*placeholder*/
      2097152 && m(
        r,
        "placeholder",
        /*placeholder*/
        t[21]
      ), f[0] & /*value*/
      8 && r.value !== /*value*/
      t[3] && (r.value = /*value*/
      t[3]), f[0] & /*enterKeyType*/
      16384 && a !== (a = /*enterKeyType*/
      t[14] === "default" ? void 0 : (
        /*enterKeyType*/
        t[14]
      )) && m(r, "enterkeyhint", a);
    },
    d(c) {
      c && Z(r), t[103](null), l = !1, Qr(u);
    }
  };
}
function Mm(t) {
  let r, e, n, i, o, s, a = !/*contentEditableValue*/
  t[9] && /*placeholder*/
  t[21] && Xu(t);
  function l(f, _) {
    return (
      /*isEnabled*/
      f[5] ? Nm : Pm
    );
  }
  let u = l(t), c = u(t);
  return {
    c() {
      r = Be("span"), a && a.c(), e = wr(), n = Be("span"), i = ei("​"), s = wr(), c.c(), m(n, "class", yi.input__aligner), m(n, "aria-hidden", "true"), m(n, "style", o = Rt(
        /*verticalPaddingStl*/
        t[17]
      )), m(r, "class", yi["input__scroll-wrapper"]);
    },
    m(f, _) {
      x(f, r, _), a && a.m(r, null), Tt(r, e), Tt(r, n), Tt(n, i), Tt(r, s), c.m(r, null);
    },
    p(f, _) {
      !/*contentEditableValue*/
      f[9] && /*placeholder*/
      f[21] ? a ? a.p(f, _) : (a = Xu(f), a.c(), a.m(r, e)) : a && (a.d(1), a = null), _[0] & /*verticalPaddingStl*/
      131072 && o !== (o = Rt(
        /*verticalPaddingStl*/
        f[17]
      )) && m(n, "style", o), u === (u = l(f)) && c ? c.p(f, _) : (c.d(1), c = u(f), c && (c.c(), c.m(r, null)));
    },
    d(f) {
      f && Z(r), a && a.d(), c.d();
    }
  };
}
function Xu(t) {
  let r, e, n;
  return {
    c() {
      r = Be("div"), e = ei(
        /*placeholder*/
        t[21]
      ), m(r, "class", yi.input__placeholder), m(r, "aria-hidden", "true"), m(r, "style", n = Rt(
        /*paddingStl*/
        t[18]
      ));
    },
    m(i, o) {
      x(i, r, o), Tt(r, e);
    },
    p(i, o) {
      o[0] & /*placeholder*/
      2097152 && Ti(
        e,
        /*placeholder*/
        i[21]
      ), o[0] & /*paddingStl*/
      262144 && n !== (n = Rt(
        /*paddingStl*/
        i[18]
      )) && m(r, "style", n);
    },
    d(i) {
      i && Z(r);
    }
  };
}
function Pm(t) {
  let r, e, n, i, o;
  return {
    c() {
      r = Be("span"), m(r, "class", jt("input__input", yi, { multiline: !0 })), m(
        r,
        "autocapitalize",
        /*autocapitalization*/
        t[13]
      ), m(r, "contenteditable", "false"), m(r, "role", "textbox"), m(
        r,
        "aria-label",
        /*description*/
        t[12]
      ), m(r, "aria-disabled", "true"), m(r, "aria-multiline", "true"), m(r, "aria-describedby", e = /*describedBy*/
      t[15] || void 0), m(r, "style", n = Rt(
        /*paddingStl*/
        t[18]
      )), /*contentEditableValue*/
      t[9] === void 0 && Yn(() => (
        /*span_input_handler_1*/
        t[102].call(r)
      ));
    },
    m(s, a) {
      x(s, r, a), t[101](r), /*contentEditableValue*/
      t[9] !== void 0 && (r.innerText = /*contentEditableValue*/
      t[9]), i || (o = Ge(
        r,
        "input",
        /*span_input_handler_1*/
        t[102]
      ), i = !0);
    },
    p(s, a) {
      a[0] & /*autocapitalization*/
      8192 && m(
        r,
        "autocapitalize",
        /*autocapitalization*/
        s[13]
      ), a[0] & /*description*/
      4096 && m(
        r,
        "aria-label",
        /*description*/
        s[12]
      ), a[0] & /*describedBy*/
      32768 && e !== (e = /*describedBy*/
      s[15] || void 0) && m(r, "aria-describedby", e), a[0] & /*paddingStl*/
      262144 && n !== (n = Rt(
        /*paddingStl*/
        s[18]
      )) && m(r, "style", n), a[0] & /*contentEditableValue*/
      512 && /*contentEditableValue*/
      s[9] !== r.innerText && (r.innerText = /*contentEditableValue*/
      s[9]);
    },
    d(s) {
      s && Z(r), t[101](null), i = !1, o();
    }
  };
}
function Nm(t) {
  let r, e, n, i, o, s, a;
  return {
    c() {
      r = Be("span"), m(r, "class", e = jt("input__input", yi, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[122]
        ),
        multiline: !0
      })), m(
        r,
        "autocapitalize",
        /*autocapitalization*/
        t[13]
      ), m(r, "contenteditable", "true"), m(r, "role", "textbox"), m(r, "tabindex", "0"), m(
        r,
        "aria-label",
        /*description*/
        t[12]
      ), m(r, "aria-multiline", "true"), m(r, "enterkeyhint", n = /*enterKeyType*/
      t[14] === "default" ? void 0 : (
        /*enterKeyType*/
        t[14]
      )), m(r, "aria-describedby", i = /*describedBy*/
      t[15] || void 0), m(r, "style", o = Rt(
        /*paddingStl*/
        t[18]
      )), /*contentEditableValue*/
      t[9] === void 0 && Yn(() => (
        /*span_input_handler*/
        t[100].call(r)
      ));
    },
    m(l, u) {
      x(l, r, u), t[99](r), /*contentEditableValue*/
      t[9] !== void 0 && (r.innerText = /*contentEditableValue*/
      t[9]), s || (a = [
        Ge(
          r,
          "input",
          /*span_input_handler*/
          t[100]
        ),
        Ge(
          r,
          "input",
          /*onInput*/
          t[48]
        ),
        Ge(
          r,
          "keydown",
          /*blockOverflow*/
          t[49]
        ),
        Ge(
          r,
          "keydown",
          /*onKeyDown*/
          t[50]
        ),
        Ge(r, "paste", Bm),
        Ge(r, "mousedown", function() {
          zr(
            /*$jsonSelectAll*/
            t[46] ? (
              /*onMousedown*/
              t[51]
            ) : void 0
          ) && (t[46] ? (
            /*onMousedown*/
            t[51]
          ) : void 0).apply(this, arguments);
        }),
        Ge(r, "click", function() {
          zr(
            /*$jsonSelectAll*/
            t[46] ? (
              /*onClick*/
              t[52]
            ) : void 0
          ) && (t[46] ? (
            /*onClick*/
            t[52]
          ) : void 0).apply(this, arguments);
        }),
        Ge(r, "focus", function() {
          zr(
            /*focusHandler*/
            t[120]
          ) && t[120].apply(this, arguments);
        }),
        Ge(r, "blur", function() {
          zr(
            /*blurHandler*/
            t[121]
          ) && t[121].apply(this, arguments);
        })
      ], s = !0);
    },
    p(l, u) {
      t = l, u[3] & /*hasCustomFocus*/
      536870912 && e !== (e = jt("input__input", yi, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[122]
        ),
        multiline: !0
      })) && m(r, "class", e), u[0] & /*autocapitalization*/
      8192 && m(
        r,
        "autocapitalize",
        /*autocapitalization*/
        t[13]
      ), u[0] & /*description*/
      4096 && m(
        r,
        "aria-label",
        /*description*/
        t[12]
      ), u[0] & /*enterKeyType*/
      16384 && n !== (n = /*enterKeyType*/
      t[14] === "default" ? void 0 : (
        /*enterKeyType*/
        t[14]
      )) && m(r, "enterkeyhint", n), u[0] & /*describedBy*/
      32768 && i !== (i = /*describedBy*/
      t[15] || void 0) && m(r, "aria-describedby", i), u[0] & /*paddingStl*/
      262144 && o !== (o = Rt(
        /*paddingStl*/
        t[18]
      )) && m(r, "style", o), u[0] & /*contentEditableValue*/
      512 && /*contentEditableValue*/
      t[9] !== r.innerText && (r.innerText = /*contentEditableValue*/
      t[9]);
    },
    d(l) {
      l && Z(r), t[99](null), s = !1, Qr(a);
    }
  };
}
function zm(t) {
  let r;
  function e(o, s) {
    return (
      /*isMultiline*/
      o[8] ? Mm : Fm
    );
  }
  let n = e(t), i = n(t);
  return {
    c() {
      i.c(), r = $t();
    },
    m(o, s) {
      i.m(o, s), x(o, r, s);
    },
    p(o, s) {
      n === (n = e(o)) && i ? i.p(o, s) : (i.d(1), i = n(o), i && (i.c(), i.m(r.parentNode, r)));
    },
    d(o) {
      o && Z(r), i.d(o);
    }
  };
}
function Om(t) {
  let r, e, n, i;
  const o = [Tm, Dm], s = [];
  function a(l, u) {
    return (
      /*hasError*/
      l[4] ? -1 : 0
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
const Lm = typeof document < "u" && "inputMode" in document.createElement("input"), Zu = {
  email: "email",
  number: "number",
  phone: "tel",
  text: "text",
  single_line_text: "text",
  multi_line_text: "text",
  uri: "url",
  password: "password"
}, Rm = /* @__PURE__ */ new Set([
  "Backspace",
  "Delete",
  "Tab",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
  "Control",
  "Shift",
  "Alt",
  "Command",
  "Meta",
  "Escape"
]);
function Bm(t) {
  if (t.preventDefault(), t.clipboardData) {
    let r = t.clipboardData.getData("text/plain");
    r = r.trim(), document.execCommand("inserttext", !1, r);
  }
}
function Hm(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee, X, I, P, O, U, me, nt, _e, Me, tt, We, Ne, Ft, Ve, Oe = T, Pe = () => (Oe(), Oe = B(s, (Ae) => e(74, Ve = Ae)), s), yt, ye = T, Ke = () => (ye(), ye = B(a, (Ae) => e(75, yt = Ae)), a), je, te = T, ot = () => (te(), te = B(nt, (Ae) => e(108, je = Ae)), nt), ce, pt = T, Ct = () => (pt(), pt = B(U, (Ae) => e(76, ce = Ae)), U), re, $ = T, pe = () => ($(), $ = B(ee, (Ae) => e(77, re = Ae)), ee), Bt, De = T, ft = () => (De(), De = B(O, (Ae) => e(78, Bt = Ae)), O), Mt, He, ht = T, qt = () => (ht(), ht = B(H, (Ae) => e(80, He = Ae)), H), fe, Vt = T, be = () => (Vt(), Vt = B(le, (Ae) => e(81, fe = Ae)), le), $e, Ce = T, Xe = () => (Ce(), Ce = B(ge, (Ae) => e(82, $e = Ae)), ge), Jt, bt = T, Qt = () => (bt(), bt = B(M, (Ae) => e(83, Jt = Ae)), M), rt, ir = T, W = () => (ir(), ir = B(P, (Ae) => e(84, rt = Ae)), P), Et, It = T, Ye = () => (It(), It = B(I, (Ae) => e(85, Et = Ae)), I), L, Le = T, gt = () => (Le(), Le = B(J, (Ae) => e(86, L = Ae)), J), qe, Te = T, cr = () => (Te(), Te = B(Q, (Ae) => e(87, qe = Ae)), Q), ke, hr = T, ie = () => (hr(), hr = B(E, (Ae) => e(88, ke = Ae)), E), ze, Ot = T, Yt = () => (Ot(), Ot = B(w, (Ae) => e(89, ze = Ae)), w), Ht, wt = T, Wt = () => (wt(), wt = B(p, (Ae) => e(90, Ht = Ae)), p), Lt, Gt = T, tr = () => (Gt(), Gt = B(y, (Ae) => e(91, Lt = Ae)), y), or, mr = T, zt = () => (mr(), mr = B(g, (Ae) => e(92, or = Ae)), g), Ut, st = T, et = () => (st(), st = B(_, (Ae) => e(93, Ut = Ae)), _), nr, Ar = T, br = () => (Ar(), Ar = B(f, (Ae) => e(94, nr = Ae)), f), yr, jr = T, kr = () => (jr(), jr = B(c, (Ae) => e(95, yr = Ae)), c), Ir, gr = T, Er = () => (gr(), gr = B(u, (Ae) => e(96, Ir = Ae)), u), Ze, ne = T, we = () => (ne(), ne = B(l, (Ae) => e(97, Ze = Ae)), l), it, ut = T, dt = () => (ut(), ut = B(me, (Ae) => e(98, it = Ae)), me), Cr, vt = T, v = () => (vt(), vt = B(X, (Ae) => e(46, Cr = Ae)), X);
  t.$$.on_destroy.push(() => Oe()), t.$$.on_destroy.push(() => ye()), t.$$.on_destroy.push(() => te()), t.$$.on_destroy.push(() => pt()), t.$$.on_destroy.push(() => $()), t.$$.on_destroy.push(() => De()), t.$$.on_destroy.push(() => ht()), t.$$.on_destroy.push(() => Vt()), t.$$.on_destroy.push(() => Ce()), t.$$.on_destroy.push(() => bt()), t.$$.on_destroy.push(() => ir()), t.$$.on_destroy.push(() => It()), t.$$.on_destroy.push(() => Le()), t.$$.on_destroy.push(() => Te()), t.$$.on_destroy.push(() => hr()), t.$$.on_destroy.push(() => Ot()), t.$$.on_destroy.push(() => wt()), t.$$.on_destroy.push(() => Gt()), t.$$.on_destroy.push(() => mr()), t.$$.on_destroy.push(() => st()), t.$$.on_destroy.push(() => Ar()), t.$$.on_destroy.push(() => jr()), t.$$.on_destroy.push(() => gr()), t.$$.on_destroy.push(() => ne()), t.$$.on_destroy.push(() => ut()), t.$$.on_destroy.push(() => vt());
  let { componentContext: V } = r, { layoutParams: Y = void 0 } = r;
  const he = Xr(_n), d = Xr(Zi), G = he.direction;
  mn(t, G, (Ae) => e(79, Mt = Ae));
  let Ie, Je, ar = !1, C = null, Qe = "", mt = "", lt = !1, Dt = "", sr = 12, Yr, qr = "", Ur, Vn = "", ue = "#000", ln = "", Lr = "start", pn = "center", Cn = "multi_line_text", b = "text", k, j = "", N = null, D = "", Ue = "", de = "", _t = !0, at = 1 / 0, Se = "off", Pt = "default", ct = "", fr = !1, Fr = !0, Mr = 0, tn = 0;
  function fn() {
    e(55, Dt = ""), e(56, sr = 12), e(57, Yr = void 0), e(58, qr = ""), e(59, Ur = void 0), e(61, ue = "#000"), e(62, ln = ""), e(63, Lr = "left"), e(64, pn = "center"), e(65, Cn = "multi_line_text"), e(10, b = "text"), e(11, k = void 0), e(5, _t = !0), e(6, at = 1 / 0), e(13, Se = "off"), e(14, Pt = "default"), e(15, ct = ""), Mr = 0, tn = 0;
  }
  function yn(Ae) {
    (Ae == null ? void 0 : Ae.type) === "fixed_length" ? e(54, C = vm(Ae, V.logError, C)) : (Ae == null ? void 0 : Ae.type) === "currency" ? e(54, C = Em(Ae, V.logError, C)) : (Ae == null ? void 0 : Ae.type) === "phone" && e(54, C = Im(V.logError, C)), C && At();
  }
  function ri(Ae) {
    if (!Array.isArray(je))
      return !0;
    for (const xt of je)
      if (xt) {
        if (xt.type === "regex")
          try {
            if (!new RegExp("^" + (xt.pattern || "") + "$").test(Ae))
              return !1;
          } catch (an) {
            return V.logError(R(new Error("Failed to create a regex"), {
              additional: { originalError: String(an) }
            })), !0;
          }
        else if (xt.type === "expression" && !xt.condition)
          return !1;
      }
    return !0;
  }
  function Wn(Ae) {
    const xt = Ae.target;
    let an = (Me ? xt.innerText : xt.value) || "";
    an === `
` && (an = ""), an.length > at && (an = e(9, mt = Qe), xt instanceof HTMLInputElement && (xt.value = an)), Qe !== an && (ri(an) ? (e(3, Qe = e(9, mt = an)), s.setValue(an), C && se(), kt()) : (e(3, Qe = e(9, mt = an)), xt instanceof HTMLInputElement && (xt.value = an), jn().then(() => {
      oe(Mr, tn);
    })));
  }
  function In(Ae) {
    Qe.length >= at && !Rm.has(Ae.key) && !(Ae.ctrlKey || Ae.altKey || Ae.metaKey) && Ae.preventDefault();
  }
  function St(Ae) {
    if (Mr = z() || 0, tn = S() || 0, Ae.ctrlKey || Ae.metaKey || Ae.altKey || Ae.shiftKey)
      return;
    const xt = V.json.enter_key_actions;
    Ae.key === "Enter" && Array.isArray(xt) && xt.length && (Ae.preventDefault(), V.execAnyActions(xt));
  }
  function h() {
    ar = !1, setTimeout(
      () => {
        ar = !0;
      },
      250
    );
  }
  function A() {
    if (!ar)
      if (Je instanceof HTMLInputElement)
        Je.select();
      else {
        const Ae = window.getSelection(), xt = document.createRange();
        xt.selectNodeContents(Je), Ae && (Ae.removeAllRanges(), Ae.addRange(xt));
      }
  }
  function z() {
    return Je instanceof HTMLInputElement ? Je.selectionStart === null ? void 0 : Je.selectionStart : Gu(Je, "start");
  }
  function S() {
    return Je instanceof HTMLInputElement ? Je.selectionEnd === null ? void 0 : Je.selectionEnd : Gu(Je, "end");
  }
  function oe(Ae, xt) {
    if (Je instanceof HTMLInputElement)
      e(2, Je.selectionStart = Ae, Je), e(2, Je.selectionEnd = xt, Je);
    else {
      const an = window.getSelection();
      if (an) {
        an.removeAllRanges();
        const Fe = document.createRange();
        gl(Je, Fe, "start", Ae), gl(Je, Fe, "end", xt), an.addRange(Fe);
      }
    }
  }
  async function se() {
    if (!Je || !C)
      return;
    const Ae = z() || 0, xt = S() || 0;
    C.applyChangeFrom(Qe, xt === Ae ? xt : 0), a.set(C.rawValue), Gs(s, Ve = e(3, Qe = e(9, mt = C.value)), Ve);
    const an = C.cursorPosition;
    await jn(), document.activeElement === Je && oe(an, an);
  }
  async function At() {
    if (!Je || !C)
      return;
    C.overrideRawValue(yt), a.set(C.rawValue), Gs(s, Ve = e(3, Qe = e(9, mt = C.value)), Ve);
    const Ae = C.cursorPosition;
    await jn(), document.activeElement === Je && oe(Ae, Ae);
  }
  function kt() {
    const Ae = Fr;
    Fr = !1;
    const xt = V.json.validators;
    if (!Array.isArray(xt) || !xt.length)
      return;
    const Fe = V.getJsonWithVars(xt).filter((vr) => (vr.type === "regex" || vr.type === "expression") && vr.label_id && vr.variable), Pr = [];
    Fe.forEach((vr) => {
      const An = V.getVariable(vr.variable);
      if (!An)
        return;
      if (An.getType() !== "boolean") {
        Ae && V.logError(R(new Error("Incorrect variable type for the validator"), {
          additional: { variable: vr.variable }
        }));
        return;
      }
      let Rr = !1;
      if (Qe === "" && (vr.allow_empty === !0 || vr.allow_empty === 1))
        Rr = !0;
      else if (vr.type === "regex") {
        if (!vr.pattern || typeof vr.pattern != "string")
          return;
        try {
          Rr = new RegExp("^" + vr.pattern + "$").test(Qe);
        } catch {
          Ae && V.logError(R(new Error("Failed to create a regular expression using the validator pattern"), {
            additional: { pattern: vr.pattern }
          }));
          return;
        }
      } else if (vr.type === "expression")
        Rr = vr.condition === !0 || vr.condition === 1;
      else
        return;
      if (An.setValue(Rr), !Rr) {
        const Mn = he.getComponentId(vr.label_id);
        Mn && Pr.push(Mn);
      }
    }), e(15, ct = Pr.join(" "));
  }
  Jn(() => {
    e(70, fr = !0), Je && C && yt && (C.overrideRawValue(yt), Gs(s, Ve = e(3, Qe = e(9, mt = C.value)), Ve));
  }), bn(() => {
    e(70, fr = !1), Ie && (he.unregisterFocusable(Ie), e(53, Ie = void 0));
  });
  function Zr(Ae) {
    Or[Ae ? "unshift" : "push"](() => {
      Je = Ae, e(2, Je);
    });
  }
  function Dr() {
    mt = this.innerText, e(9, mt), e(54, C), e(3, Qe), e(74, Ve), e(6, at), e(7, s), e(84, rt), e(71, i), e(0, V);
  }
  function Jr(Ae) {
    Or[Ae ? "unshift" : "push"](() => {
      Je = Ae, e(2, Je);
    });
  }
  function Ei() {
    mt = this.innerText, e(9, mt), e(54, C), e(3, Qe), e(74, Ve), e(6, at), e(7, s), e(84, rt), e(71, i), e(0, V);
  }
  function fi(Ae) {
    Or[Ae ? "unshift" : "push"](() => {
      Je = Ae, e(2, Je);
    });
  }
  return t.$$set = (Ae) => {
    "componentContext" in Ae && e(0, V = Ae.componentContext), "layoutParams" in Ae && e(1, Y = Ae.layoutParams);
  }, t.$$.update = () => {
    var Ae;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(73, n = V.origJson), t.$$.dirty[2] & /*origJson*/
    2048 && n && fn(), t.$$.dirty[0] & /*componentContext*/
    1 && e(71, i = V.json.text_variable), t.$$.dirty[0] & /*componentContext*/
    1 && e(72, o = (Ae = V.json.mask) == null ? void 0 : Ae.raw_text_variable), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[2] & /*variable*/
    512 && Pe(e(7, s = i && (V.getVariable(i, "string") || he.awaitGlobalVariable(i, "string", "")) || mi("temp", "string", ""))), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[2] & /*rawVariable*/
    1024 && Ke(e(16, a = o && (V.getVariable(o, "string") || he.awaitGlobalVariable(o, "string", "")) || mi("temp", "string", ""))), t.$$.dirty[0] & /*componentContext*/
    1 && we(e(45, l = V.getDerivedFromVars(V.json.hint_text))), t.$$.dirty[0] & /*componentContext*/
    1 && Er(e(44, u = V.getDerivedFromVars(V.json.hint_color))), t.$$.dirty[0] & /*componentContext*/
    1 && kr(e(43, c = V.getDerivedFromVars(V.json.font_size))), t.$$.dirty[0] & /*componentContext*/
    1 && br(e(42, f = V.getDerivedFromVars(V.json.font_weight))), t.$$.dirty[0] & /*componentContext*/
    1 && et(e(41, _ = V.getDerivedFromVars(V.json.font_weight_value))), t.$$.dirty[0] & /*componentContext*/
    1 && zt(e(40, g = V.getDerivedFromVars(V.json.font_family))), t.$$.dirty[0] & /*componentContext*/
    1 && tr(e(39, y = V.getDerivedFromVars(V.json.line_height))), t.$$.dirty[0] & /*componentContext*/
    1 && Wt(e(38, p = V.getDerivedFromVars(V.json.letter_spacing))), t.$$.dirty[0] & /*componentContext*/
    1 && Yt(e(37, w = V.getDerivedFromVars(V.json.text_color))), t.$$.dirty[0] & /*componentContext*/
    1 && ie(e(36, E = V.getDerivedFromVars(V.json.highlight_color))), t.$$.dirty[0] & /*componentContext*/
    1 && cr(e(35, Q = V.getDerivedFromVars(V.json.text_alignment_horizontal))), t.$$.dirty[0] & /*componentContext*/
    1 && gt(e(34, J = V.getDerivedFromVars(V.json.text_alignment_vertical))), t.$$.dirty[0] & /*componentContext*/
    1 && Qt(e(33, M = V.getDerivedFromVars(V.json.keyboard_type))), t.$$.dirty[0] & /*componentContext*/
    1 && Xe(e(32, ge = V.getDerivedFromVars(V.json.mask))), t.$$.dirty[0] & /*componentContext*/
    1 && be(e(31, le = V.getDerivedFromVars(V.json.max_visible_lines))), t.$$.dirty[0] & /*componentContext*/
    1 && qt(e(30, H = V.getDerivedFromVars(V.json.paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && pe(e(29, ee = V.getDerivedFromVars(V.json.accessibility))), t.$$.dirty[0] & /*componentContext*/
    1 && v(e(28, X = V.getDerivedFromVars(V.json.select_all_on_focus))), t.$$.dirty[0] & /*componentContext*/
    1 && Ye(e(27, I = V.getDerivedFromVars(V.json.is_enabled))), t.$$.dirty[0] & /*componentContext*/
    1 && W(e(26, P = V.getDerivedFromVars(V.json.max_length))), t.$$.dirty[0] & /*componentContext*/
    1 && ft(e(25, O = V.getDerivedFromVars(V.json.autocapitalization))), t.$$.dirty[0] & /*componentContext*/
    1 && Ct(e(24, U = V.getDerivedFromVars(V.json.enter_key_type))), t.$$.dirty[0] & /*componentContext*/
    1 && dt(e(23, me = V.getDerivedFromVars(V.json.validators))), t.$$.dirty[0] & /*componentContext*/
    1 && ot(e(22, nt = V.getDerivedFromVars(V.json.filters))), t.$$.dirty[0] & /*componentContext, hasError*/
    17 | t.$$.dirty[2] & /*variable, $jsonAccessibility*/
    33280) {
      let xt = !1;
      i ? (d.hasAction() || (re == null ? void 0 : re.mode) === "exclude") && (xt = !0, V.logError(R(new Error('Cannot show "input" inside component with an action or inside accessibility mode=exclude')))) : (e(4, lt = !0), V.logError(R(new Error('Missing "text_variable" in "input"')))), lt !== xt && e(4, lt = xt);
    }
    if (t.$$.dirty[2] & /*$jsonMask*/
    1048576 && yn($e), t.$$.dirty[0] & /*maxLength*/
    64 | t.$$.dirty[2] & /*$jsonMaxLength*/
    4194304 && e(6, at = Gn(rt, at)), t.$$.dirty[0] & /*value, maxLength, valueVariable*/
    200 | t.$$.dirty[1] & /*inputMask*/
    8388608 | t.$$.dirty[2] & /*$valueVariable*/
    4096 && !C && Qe !== Ve) {
      let xt = Ve;
      xt.length > at && (xt = xt.slice(0, at), s.setValue(xt)), e(3, Qe = e(9, mt = xt)), kt();
    }
    if (t.$$.dirty[1] & /*inputMask*/
    8388608 | t.$$.dirty[2] & /*$rawValueVariable*/
    8192 && C && C.rawValue !== yt && (At(), kt()), t.$$.dirty[2] & /*mounted*/
    256 | t.$$.dirty[3] & /*$jsonValidators*/
    32 && it && fr && kt(), t.$$.dirty[3] & /*$jsonHintText*/
    16 && e(21, _e = Ze), t.$$.dirty[1] & /*hintColor*/
    16777216 | t.$$.dirty[3] & /*$jsonHintColor*/
    8 && e(55, Dt = Tr(Ir, 1, Dt)), t.$$.dirty[1] & /*fontSize*/
    33554432 | t.$$.dirty[3] & /*$jsonFontSize*/
    4 && e(56, sr = Gn(yr, sr)), t.$$.dirty[1] & /*fontWeight*/
    67108864 | t.$$.dirty[2] & /*$jsonFontFamily*/
    1073741824 | t.$$.dirty[3] & /*$jsonFontWeight, $jsonFontWeightValue*/
    3 && (e(57, Yr = ho(nr, Ut, Yr)), or && typeof or == "string" ? e(58, qr = he.typefaceProvider(or, { fontWeight: Yr || 400 })) : e(58, qr = "")), t.$$.dirty[1] & /*fontSize*/
    33554432 | t.$$.dirty[2] & /*$jsonLineHeight*/
    536870912) {
      const xt = Lt;
      Hn(xt) && e(59, Ur = xt / sr);
    }
    t.$$.dirty[2] & /*$jsonLetterSpacing*/
    268435456 && zs(Ht) && e(60, Vn = Re(Ht)), t.$$.dirty[1] & /*textColor*/
    1073741824 | t.$$.dirty[2] & /*$jsonTextColor*/
    134217728 && e(61, ue = Tr(ze, 1, ue)), t.$$.dirty[2] & /*$jsonHighlightColor, highlightColor*/
    67108865 && e(62, ln = Tr(ke, 1, ln)), t.$$.dirty[2] & /*$jsonAlignmentHorizontal, $direction, alignmentHorizontal*/
    33685506 && e(63, Lr = Ll(qe, Mt, Lr)), t.$$.dirty[2] & /*$jsonAlignmentVertical, alignmentVertical*/
    16777220 && e(64, pn = Rl(L, pn)), t.$$.dirty[0] & /*isEnabled*/
    32 | t.$$.dirty[2] & /*$jsonIsEnabled*/
    8388608 && e(5, _t = Tn(Et, _t)), t.$$.dirty[2] & /*$jsonKeyboardType, $jsonMask, keyboardType*/
    3145736 && (Jt && Jt in Zu && (e(10, b = Zu[Jt]), e(65, Cn = Jt)), ($e == null ? void 0 : $e.type) === "currency" ? (e(10, b = Lm ? "text" : "tel"), e(11, k = "decimal")) : Cn === "number" ? e(11, k = "decimal") : e(11, k = void 0)), t.$$.dirty[2] & /*keyboardType*/
    8 && e(8, Me = Cn === "multi_line_text"), t.$$.dirty[1] & /*lineHeight, fontSize*/
    301989888 | t.$$.dirty[2] & /*$jsonVisibleMaxLines, $jsonPaddings, selfPadding, $direction*/
    917536 && (Hn(fe) ? e(66, j = `calc(${fe * (Ur || 1.25) * (sr / 10) + "em"} + ${dn(Kr(He == null ? void 0 : He.top, 0) + Kr(He == null ? void 0 : He.bottom, 0))})`) : e(66, j = ""), e(67, N = wo(He || void 0, N)), e(68, D = N ? li(
      {
        top: (Number(N.top) || 0) / sr * 10,
        right: (Number(Mt === "ltr" ? N.end : N.start) || Number(N.right) || 0) / sr * 10,
        bottom: (Number(N.bottom) || 0) / sr * 10,
        left: (Number(Mt === "ltr" ? N.start : N.end) || Number(N.left) || 0) / sr * 10
      },
      Mt
    ) : ""), e(69, Ue = N ? li(
      {
        top: (Number(N.top) || 0) / sr * 10,
        bottom: (Number(N.bottom) || 0) / sr * 10
      },
      Mt
    ) : "")), t.$$.dirty[2] & /*$jsonAutocapitalization*/
    65536 && (Bt === "all_characters" ? e(13, Se = "characters") : Bt === "sentences" ? e(13, Se = "sentences") : Bt === "words" ? e(13, Se = "words") : (Bt === "none" || Bt === "auto") && e(13, Se = "off")), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[2] & /*$jsonAccessibility*/
    32768 && (re != null && re.description ? e(12, de = po(re)) : V.logError(R(new Error('Missing accessibility "description" for input'), { level: "warn" }))), t.$$.dirty[2] & /*$jsonEnterKeyType*/
    16384 && (ce === "default" || ce === "done" || ce === "go" || ce === "search" || ce === "send") && e(14, Pt = ce), t.$$.dirty[0] & /*isMultiline*/
    256 | t.$$.dirty[2] & /*highlightColor, alignmentHorizontal, alignmentVertical*/
    7 && e(20, tt = {
      "highlight-color": !!ln,
      multiline: Me,
      "alignment-horizontal": Lr,
      "alignment-vertical": pn
    }), t.$$.dirty[1] & /*hintColor, lineHeight, fontWeight, fontFamily, letterSpacing, textColor*/
    2097152e3 | t.$$.dirty[2] & /*highlightColor, maxHeight*/
    17 && e(19, We = {
      "--divkit-input-hint-color": Dt,
      "--divkit-input-highlight-color": ln,
      "--divkit-input-line-height": Ur,
      "font-weight": Yr,
      "font-family": qr,
      "letter-spacing": Vn,
      color: ue,
      "max-height": j
    }), t.$$.dirty[1] & /*fontSize*/
    33554432 | t.$$.dirty[2] & /*padding*/
    64 && e(18, Ne = { "font-size": Re(sr), padding: D }), t.$$.dirty[1] & /*fontSize*/
    33554432 | t.$$.dirty[2] & /*verticalPadding*/
    128 && e(17, Ft = {
      "font-size": Re(sr),
      padding: Ue
    }), t.$$.dirty[0] & /*input, componentContext, value*/
    13 | t.$$.dirty[1] & /*prevId*/
    4194304 && Je && V.json && (Ie && (he.unregisterFocusable(Ie), e(53, Ie = void 0)), V.id && !V.fakeElement && (e(53, Ie = V.id), he.registerFocusable(Ie, {
      focus() {
        Je && (Je.focus(), oe(Qe.length, Qe.length));
      }
    })));
  }, [
    V,
    Y,
    Je,
    Qe,
    lt,
    _t,
    at,
    s,
    Me,
    mt,
    b,
    k,
    de,
    Se,
    Pt,
    ct,
    a,
    Ft,
    Ne,
    We,
    tt,
    _e,
    nt,
    me,
    U,
    O,
    P,
    I,
    X,
    ee,
    H,
    le,
    ge,
    M,
    J,
    Q,
    E,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    Cr,
    G,
    Wn,
    In,
    St,
    h,
    A,
    Ie,
    C,
    Dt,
    sr,
    Yr,
    qr,
    Ur,
    Vn,
    ue,
    ln,
    Lr,
    pn,
    Cn,
    j,
    N,
    D,
    Ue,
    fr,
    i,
    o,
    n,
    Ve,
    yt,
    ce,
    re,
    Bt,
    Mt,
    He,
    fe,
    $e,
    Jt,
    rt,
    Et,
    L,
    qe,
    ke,
    ze,
    Ht,
    Lt,
    or,
    Ut,
    nr,
    yr,
    Ir,
    Ze,
    it,
    Zr,
    Dr,
    Jr,
    Ei,
    fi
  ];
}
class Wm extends $r {
  constructor(r) {
    super(), xr(this, r, Hm, Om, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1, -1]);
  }
}
const Um = "appkit-select", Gm = "appkit-select_hint", Ym = "appkit-select__select", qm = "appkit-select__option", _o = {
  select: Um,
  "select__select-text": "appkit-select__select-text",
  select_hint: Gm,
  select__select: Ym,
  "select__select_has-custom-focused": "appkit-select__select_has-custom-focused",
  "has-custom-focused": "appkit-has-custom-focused",
  select__option: qm
};
function Qu(t, r, e) {
  const n = t.slice();
  return n[59] = r[e], n;
}
function Jm(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Km(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "select",
        _o,
        /*mods*/
        t[11]
      ),
      style: (
        /*stl*/
        t[10]
      ),
      customDescription: !0,
      customActions: "select",
      customPaddings: !0,
      hasInnerFocusable: !0,
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      $$slots: {
        default: [
          Xm,
          ({ hasCustomFocus: n, focusHandler: i, blurHandler: o }) => ({
            56: n,
            57: i,
            58: o
          }),
          ({ hasCustomFocus: n, focusHandler: i, blurHandler: o }) => [
            0,
            (n ? 33554432 : 0) | (i ? 67108864 : 0) | (o ? 134217728 : 0)
          ]
        ]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      2048 && (o.cls = jt(
        "select",
        _o,
        /*mods*/
        n[11]
      )), i[0] & /*stl*/
      1024 && (o.style = /*stl*/
      n[10]), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*description, selectStl, select, $valueVariable, filteredItems, innerStl, selectText, $jsonHintText*/
      16778228 | i[1] & /*hasCustomFocus, focusHandler, blurHandler*/
      234881024 | i[2] & /*$$scope*/
      1 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function xu(t) {
  let r, e = (
    /*item*/
    (t[59].text || /*item*/
    t[59].value) + ""
  ), n, i;
  return {
    c() {
      r = Be("option"), n = ei(e), m(r, "class", _o.select__option), r.__value = i = /*item*/
      t[59].value, ta(r, r.__value);
    },
    m(o, s) {
      x(o, r, s), Tt(r, n);
    },
    p(o, s) {
      s[0] & /*filteredItems*/
      32 && e !== (e = /*item*/
      (o[59].text || /*item*/
      o[59].value) + "") && Ti(n, e), s[0] & /*filteredItems*/
      32 && i !== (i = /*item*/
      o[59].value) && (r.__value = i, ta(r, r.__value));
    },
    d(o) {
      o && Z(r);
    }
  };
}
function Xm(t) {
  let r, e = (
    /*selectText*/
    (t[4] || /*$jsonHintText*/
    t[24] || "​") + ""
  ), n, i, o, s, a, l, u, c, f = lr(
    /*filteredItems*/
    t[5]
  ), _ = [];
  for (let g = 0; g < f.length; g += 1)
    _[g] = xu(Qu(t, f, g));
  return {
    c() {
      r = Be("span"), n = ei(e), o = wr(), s = Be("select");
      for (let g = 0; g < _.length; g += 1)
        _[g].c();
      m(r, "class", _o["select__select-text"]), m(r, "style", i = Rt(
        /*innerStl*/
        t[9]
      )), m(r, "aria-hidden", "true"), m(s, "class", a = jt("select__select", _o, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[56]
        )
      })), m(
        s,
        "aria-label",
        /*description*/
        t[7]
      ), m(s, "style", l = Rt(
        /*selectStl*/
        t[8]
      )), /*$valueVariable*/
      t[6] === void 0 && Yn(() => (
        /*select_1_change_handler*/
        t[52].call(s)
      ));
    },
    m(g, y) {
      x(g, r, y), Tt(r, n), x(g, o, y), x(g, s, y);
      for (let p = 0; p < _.length; p += 1)
        _[p] && _[p].m(s, null);
      t[51](s), ra(
        s,
        /*$valueVariable*/
        t[6],
        !0
      ), u || (c = [
        Ge(
          s,
          "change",
          /*select_1_change_handler*/
          t[52]
        ),
        Ge(s, "focus", function() {
          zr(
            /*focusHandler*/
            t[57]
          ) && t[57].apply(this, arguments);
        }),
        Ge(s, "blur", function() {
          zr(
            /*blurHandler*/
            t[58]
          ) && t[58].apply(this, arguments);
        })
      ], u = !0);
    },
    p(g, y) {
      if (t = g, y[0] & /*selectText, $jsonHintText*/
      16777232 && e !== (e = /*selectText*/
      (t[4] || /*$jsonHintText*/
      t[24] || "​") + "") && Ti(n, e), y[0] & /*innerStl*/
      512 && i !== (i = Rt(
        /*innerStl*/
        t[9]
      )) && m(r, "style", i), y[0] & /*filteredItems*/
      32) {
        f = lr(
          /*filteredItems*/
          t[5]
        );
        let p;
        for (p = 0; p < f.length; p += 1) {
          const w = Qu(t, f, p);
          _[p] ? _[p].p(w, y) : (_[p] = xu(w), _[p].c(), _[p].m(s, null));
        }
        for (; p < _.length; p += 1)
          _[p].d(1);
        _.length = f.length;
      }
      y[1] & /*hasCustomFocus*/
      33554432 && a !== (a = jt("select__select", _o, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[56]
        )
      })) && m(s, "class", a), y[0] & /*description*/
      128 && m(
        s,
        "aria-label",
        /*description*/
        t[7]
      ), y[0] & /*selectStl*/
      256 && l !== (l = Rt(
        /*selectStl*/
        t[8]
      )) && m(s, "style", l), y[0] & /*$valueVariable, filteredItems*/
      96 && ra(
        s,
        /*$valueVariable*/
        t[6]
      );
    },
    d(g) {
      g && (Z(r), Z(o), Z(s)), gn(_, g), t[51](null), u = !1, Qr(c);
    }
  };
}
function Zm(t) {
  let r, e, n, i;
  const o = [Km, Jm], s = [];
  function a(l, u) {
    return (
      /*hasError*/
      l[3] ? -1 : 0
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function Qm(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q, J, M, ge, le, H, ee = T, X = () => (ee(), ee = B(Q, (ie) => e(40, H = ie)), Q), I, P = T, O = () => (P(), P = B(E, (ie) => e(41, I = ie)), E), U, me = T, nt = () => (me(), me = B(w, (ie) => e(42, U = ie)), w), _e, Me = T, tt = () => (Me(), Me = B(p, (ie) => e(43, _e = ie)), p), We, Ne = T, Ft = () => (Ne(), Ne = B(y, (ie) => e(44, We = ie)), y), Ve, Oe = T, Pe = () => (Oe(), Oe = B(g, (ie) => e(45, Ve = ie)), g), yt, ye = T, Ke = () => (ye(), ye = B(_, (ie) => e(46, yt = ie)), _), je, te = T, ot = () => (te(), te = B(f, (ie) => e(47, je = ie)), f), ce, pt = T, Ct = () => (pt(), pt = B(c, (ie) => e(48, ce = ie)), c), re, $, pe = T, Bt = () => (pe(), pe = B(l, (ie) => e(50, $ = ie)), l), De, ft = T, Mt = () => (ft(), ft = B(a, (ie) => e(6, De = ie)), a), He, ht = T, qt = () => (ht(), ht = B(u, (ie) => e(24, He = ie)), u);
  t.$$.on_destroy.push(() => ee()), t.$$.on_destroy.push(() => P()), t.$$.on_destroy.push(() => me()), t.$$.on_destroy.push(() => Me()), t.$$.on_destroy.push(() => Ne()), t.$$.on_destroy.push(() => Oe()), t.$$.on_destroy.push(() => ye()), t.$$.on_destroy.push(() => te()), t.$$.on_destroy.push(() => pt()), t.$$.on_destroy.push(() => pe()), t.$$.on_destroy.push(() => ft()), t.$$.on_destroy.push(() => ht());
  let { componentContext: fe } = r, { layoutParams: Vt = void 0 } = r;
  const be = Xr(_n), $e = Xr(Zi), Ce = be.direction;
  mn(t, Ce, (ie) => e(49, re = ie));
  let Xe, Jt, bt = !1, Qt = "", rt = null, ir = "", W = "rgba(0,0,0,.45)", Et = 12, It, Ye = "", L, Le = "", gt = "#000", qe = "", Te;
  function cr() {
    e(27, rt = null), e(29, W = "rgba(0,0,0,.45)"), e(30, Et = 12), e(31, It = void 0), e(32, Ye = ""), e(33, L = void 0), e(34, Le = ""), e(35, gt = "#000"), e(7, qe = "");
  }
  bn(() => {
    Xe && (be.unregisterFocusable(Xe), e(26, Xe = void 0));
  });
  function ke(ie) {
    Or[ie ? "unshift" : "push"](() => {
      Jt = ie, e(2, Jt);
    });
  }
  function hr() {
    De = Cd(this), a.set(De), e(5, s), e(38, o), e(0, fe);
  }
  return t.$$set = (ie) => {
    "componentContext" in ie && e(0, fe = ie.componentContext), "layoutParams" in ie && e(1, Vt = ie.layoutParams);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(39, n = fe.origJson), t.$$.dirty[1] & /*origJson*/
    256 && n && cr(), t.$$.dirty[0] & /*componentContext*/
    1 && e(37, i = fe.json.value_variable), t.$$.dirty[0] & /*componentContext*/
    1 && e(38, o = fe.json.options), t.$$.dirty[1] & /*items*/
    128 && e(5, s = Array.isArray(o) && o.filter((ie) => typeof ie.value == "string") || []), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*variable*/
    64 && Mt(e(23, a = i && (fe.getVariable(i, "string") || be.awaitGlobalVariable(i, "string", "")) || mi("temp", "string", ""))), t.$$.dirty[0] & /*componentContext*/
    1 && Bt(e(22, l = fe.getDerivedFromVars(fe.json.paddings))), t.$$.dirty[0] & /*componentContext*/
    1 && qt(e(21, u = fe.getDerivedFromVars(fe.json.hint_text))), t.$$.dirty[0] & /*componentContext*/
    1 && Ct(e(20, c = fe.getDerivedFromVars(fe.json.hint_color))), t.$$.dirty[0] & /*componentContext*/
    1 && ot(e(19, f = fe.getDerivedFromVars(fe.json.font_size))), t.$$.dirty[0] & /*componentContext*/
    1 && Ke(e(18, _ = fe.getDerivedFromVars(fe.json.font_weight))), t.$$.dirty[0] & /*componentContext*/
    1 && Pe(e(17, g = fe.getDerivedFromVars(fe.json.font_weight_value))), t.$$.dirty[0] & /*componentContext*/
    1 && Ft(e(16, y = fe.getDerivedFromVars(fe.json.font_family))), t.$$.dirty[0] & /*componentContext*/
    1 && tt(e(15, p = fe.getDerivedFromVars(fe.json.line_height))), t.$$.dirty[0] & /*componentContext*/
    1 && nt(e(14, w = fe.getDerivedFromVars(fe.json.letter_spacing))), t.$$.dirty[0] & /*componentContext*/
    1 && O(e(13, E = fe.getDerivedFromVars(fe.json.text_color))), t.$$.dirty[0] & /*componentContext*/
    1 && X(e(12, Q = fe.getDerivedFromVars(fe.json.accessibility))), t.$$.dirty[0] & /*filteredItems, componentContext*/
    33 && (Array.isArray(s) && s.length || fe.logError(R(new Error('Empty selection "items" in "select"')))), t.$$.dirty[0] & /*componentContext, hasError*/
    9 | t.$$.dirty[1] & /*variable, $jsonAccessibility*/
    576) {
      let ie = !1;
      i ? ($e.hasAction() || (H == null ? void 0 : H.mode) === "exclude") && (ie = !0, fe.logError(R(new Error('Cannot show "select" inside component with an action or inside accessibility mode=exclude')))) : (e(3, bt = !0), fe.logError(R(new Error('Missing "value_variable" in "select"')))), bt !== ie && e(3, bt = ie);
    }
    if (t.$$.dirty[0] & /*filteredItems, $valueVariable, componentContext*/
    97 | t.$$.dirty[1] & /*prevWarnValue*/
    32) {
      const ie = s.find((ze) => ze.value === De);
      ie ? e(4, Qt = (typeof ie.text == "string" ? ie.text : ie.value) || "") : (e(4, Qt = ""), De && Te !== De && (e(36, Te = De), fe.logError(R(new Error('Value from the variable was not found in the selection items for "select"')))));
    }
    if (t.$$.dirty[0] & /*fontSize*/
    1073741824 | t.$$.dirty[1] & /*$jsonFontSize*/
    65536 && e(30, Et = Gn(je, Et)), t.$$.dirty[0] & /*selfPadding, fontSize*/
    1207959552 | t.$$.dirty[1] & /*$jsonPaddings, $direction*/
    786432 && (e(27, rt = wo($ || void 0, rt)), e(28, ir = rt ? li(
      {
        top: (Number(rt.top) || 0) / Et * 10,
        right: (Number(re === "ltr" ? rt.end : rt.start) || Number(rt.right) || 0) / Et * 10,
        bottom: (Number(rt.bottom) || 0) / Et * 10,
        left: (Number(re === "ltr" ? rt.start : rt.end) || Number(rt.left) || 0) / Et * 10
      },
      re
    ) : "")), t.$$.dirty[0] & /*hintColor*/
    536870912 | t.$$.dirty[1] & /*$jsonHintColor*/
    131072 && e(29, W = Tr(ce, 1, W)), t.$$.dirty[1] & /*$jsonFontWeight, $jsonFontWeightValue, fontWeight, $jsonFontFamily*/
    57345 && (e(31, It = ho(yt, Ve, It)), We && typeof We == "string" ? e(32, Ye = be.typefaceProvider(We, { fontWeight: It || 400 })) : e(32, Ye = "")), t.$$.dirty[0] & /*fontSize*/
    1073741824 | t.$$.dirty[1] & /*$jsonLineHeight*/
    4096) {
      const ie = _e;
      Hn(ie) && e(33, L = ie / Et);
    }
    t.$$.dirty[0] & /*fontSize*/
    1073741824 | t.$$.dirty[1] & /*$jsonLetterSpacing*/
    2048 && zs(U) && e(34, Le = Re(U / Et * 10)), t.$$.dirty[1] & /*$jsonTextColor, textColor*/
    1040 && e(35, gt = Tr(I, 1, gt)), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*$jsonAccessibility*/
    512 && (H != null && H.description ? e(7, qe = po(H)) : fe.logError(R(new Error('Missing accessibility "description" for select'), { level: "warn" }))), t.$$.dirty[0] & /*selectText*/
    16 && e(11, J = { hint: !Qt }), t.$$.dirty[0] & /*hintColor*/
    536870912 | t.$$.dirty[1] & /*fontWeight, fontFamily, textColor*/
    19 && e(10, M = {
      "--divkit-input-hint-color": W,
      "font-weight": It,
      "font-family": Ye,
      color: gt
    }), t.$$.dirty[0] & /*padding, fontSize*/
    1342177280 | t.$$.dirty[1] & /*lineHeight, letterSpacing*/
    12 && e(9, ge = {
      padding: ir,
      "font-size": Re(Et),
      "line-height": L,
      "letter-spacing": Le
    }), t.$$.dirty[0] & /*fontSize*/
    1073741824 | t.$$.dirty[1] & /*lineHeight, letterSpacing*/
    12 && e(8, le = {
      "font-size": Re(Et),
      "line-height": L,
      "letter-spacing": Le
    }), t.$$.dirty[0] & /*componentContext, select, prevId*/
    67108869 && fe.json && Jt && (Xe && (be.unregisterFocusable(Xe), e(26, Xe = void 0)), fe.id && !fe.fakeElement && (e(26, Xe = fe.id), be.registerFocusable(Xe, {
      focus() {
        Jt && Jt.focus();
      }
    })));
  }, [
    fe,
    Vt,
    Jt,
    bt,
    Qt,
    s,
    De,
    qe,
    le,
    ge,
    M,
    J,
    Q,
    E,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    He,
    Ce,
    Xe,
    rt,
    ir,
    W,
    Et,
    It,
    Ye,
    L,
    Le,
    gt,
    Te,
    i,
    o,
    n,
    H,
    I,
    U,
    _e,
    We,
    Ve,
    yt,
    je,
    ce,
    re,
    $,
    ke,
    hr
  ];
}
class xm extends $r {
  constructor(r) {
    super(), xr(this, r, Qm, Zm, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1]);
  }
}
const $m = "appkit-video__video", e1 = "appkit-video__container", t1 = "appkit-video_absolute", eo = {
  video__video: $m,
  video__container: e1,
  "video__aspect-wrapper": "appkit-video__aspect-wrapper",
  video_absolute: t1
};
function r1(t, r) {
  return Array.isArray(t) && t.length ? t.filter((e) => (e == null ? void 0 : e.type) === "video_source" && typeof e.url == "string" && typeof e.mime_type == "string").map((e) => {
    const n = {
      src: e.url
    };
    return e.mime_type && (n.type = e.mime_type), n;
  }) : r;
}
function n1(t) {
  return t === "fill" ? "cover" : t === "no_scale" ? "none" : "contain";
}
function $u(t, r, e) {
  const n = t.slice();
  return n[60] = r[e], n;
}
function ec(t, r, e) {
  const n = t.slice();
  return n[60] = r[e], n;
}
function i1(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function o1(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "video",
        eo,
        /*mods*/
        t[15]
      ),
      customActions: "video",
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      heightByAspect: (
        /*aspectPaddingBottom*/
        t[11] !== "0"
      ),
      $$slots: { default: [f1] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      32768 && (o.cls = jt(
        "video",
        eo,
        /*mods*/
        n[15]
      )), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*aspectPaddingBottom*/
      2048 && (o.heightByAspect = /*aspectPaddingBottom*/
      n[11] !== "0"), i[0] & /*aspectPaddingBottom, videoParentElem, providedVideoTemplate, shouldUseVideoProvider, style, loop, autoplay, muted, poster, preload, videoElem, sources*/
      32760 | i[2] & /*$$scope*/
      8 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function s1(t) {
  let r, e, n, i, o, s = lr(
    /*sources*/
    t[4]
  ), a = [];
  for (let l = 0; l < s.length; l += 1)
    a[l] = rc($u(t, s, l));
  return {
    c() {
      r = Be("video");
      for (let l = 0; l < a.length; l += 1)
        a[l].c();
      m(r, "class", eo.video__video), m(r, "style", e = Rt(
        /*style*/
        t[14]
      )), r.playsInline = !0, r.loop = /*loop*/
      t[5], r.autoplay = /*autoplay*/
      t[6], r.muted = /*muted*/
      t[7], m(
        r,
        "poster",
        /*poster*/
        t[9]
      ), m(r, "preload", n = /*preload*/
      t[8] ? "metadata" : "auto");
    },
    m(l, u) {
      x(l, r, u);
      for (let c = 0; c < a.length; c += 1)
        a[c] && a[c].m(r, null);
      t[52](r), i || (o = [
        Ge(
          r,
          "timeupdate",
          /*onTimeUpdate*/
          t[26]
        ),
        Ge(
          r,
          "ended",
          /*onEnd*/
          t[27]
        ),
        Ge(
          r,
          "playing",
          /*onPlaying*/
          t[28]
        ),
        Ge(
          r,
          "pause",
          /*onPause*/
          t[29]
        ),
        Ge(
          r,
          "waiting",
          /*onWaiting*/
          t[30]
        ),
        Ge(
          r,
          "error",
          /*onError*/
          t[31]
        )
      ], i = !0);
    },
    p(l, u) {
      if (u[0] & /*sources*/
      16 | u[1] & /*onError*/
      1) {
        s = lr(
          /*sources*/
          l[4]
        );
        let c;
        for (c = 0; c < s.length; c += 1) {
          const f = $u(l, s, c);
          a[c] ? a[c].p(f, u) : (a[c] = rc(f), a[c].c(), a[c].m(r, null));
        }
        for (; c < a.length; c += 1)
          a[c].d(1);
        a.length = s.length;
      }
      u[0] & /*style*/
      16384 && e !== (e = Rt(
        /*style*/
        l[14]
      )) && m(r, "style", e), u[0] & /*loop*/
      32 && (r.loop = /*loop*/
      l[5]), u[0] & /*autoplay*/
      64 && (r.autoplay = /*autoplay*/
      l[6]), u[0] & /*muted*/
      128 && (r.muted = /*muted*/
      l[7]), u[0] & /*poster*/
      512 && m(
        r,
        "poster",
        /*poster*/
        l[9]
      ), u[0] & /*preload*/
      256 && n !== (n = /*preload*/
      l[8] ? "metadata" : "auto") && m(r, "preload", n);
    },
    d(l) {
      l && Z(r), gn(a, l), t[52](null), i = !1, Qr(o);
    }
  };
}
function l1(t) {
  let r;
  return {
    c() {
      r = Be("div"), m(r, "class", eo.video__container);
    },
    m(e, n) {
      x(e, r, n), r.innerHTML = /*providedVideoTemplate*/
      t[12], t[51](r);
    },
    p(e, n) {
      n[0] & /*providedVideoTemplate*/
      4096 && (r.innerHTML = /*providedVideoTemplate*/
      e[12]);
    },
    d(e) {
      e && Z(r), t[51](null);
    }
  };
}
function a1(t) {
  let r, e = `${/*aspectPaddingBottom*/
  t[11]}%`;
  function n(s, a) {
    return (
      /*shouldUseVideoProvider*/
      s[13] ? c1 : u1
    );
  }
  let i = n(t), o = i(t);
  return {
    c() {
      r = Be("div"), o.c(), m(r, "class", eo["video__aspect-wrapper"]), q(r, "padding-bottom", e);
    },
    m(s, a) {
      x(s, r, a), o.m(r, null);
    },
    p(s, a) {
      i === (i = n(s)) && o ? o.p(s, a) : (o.d(1), o = i(s), o && (o.c(), o.m(r, null))), a[0] & /*aspectPaddingBottom*/
      2048 && e !== (e = `${/*aspectPaddingBottom*/
      s[11]}%`) && q(r, "padding-bottom", e);
    },
    d(s) {
      s && Z(r), o.d();
    }
  };
}
function tc(t) {
  let r, e, n, i, o;
  return {
    c() {
      r = Be("source"), Zn(r.src, e = /*source*/
      t[60].src) || m(r, "src", e), m(r, "type", n = /*source*/
      t[60].type);
    },
    m(s, a) {
      x(s, r, a), i || (o = Ge(
        r,
        "error",
        /*onError*/
        t[31]
      ), i = !0);
    },
    p(s, a) {
      a[0] & /*sources*/
      16 && !Zn(r.src, e = /*source*/
      s[60].src) && m(r, "src", e), a[0] & /*sources*/
      16 && n !== (n = /*source*/
      s[60].type) && m(r, "type", n);
    },
    d(s) {
      s && Z(r), i = !1, o();
    }
  };
}
function rc(t) {
  let r = (
    /*source*/
    t[60]
  ), e, n = tc(t);
  return {
    c() {
      n.c(), e = $t();
    },
    m(i, o) {
      n.m(i, o), x(i, e, o);
    },
    p(i, o) {
      o[0] & /*sources*/
      16 && Vr(r, r = /*source*/
      i[60]) ? (n.d(1), n = tc(i), n.c(), n.m(e.parentNode, e)) : n.p(i, o);
    },
    d(i) {
      i && Z(e), n.d(i);
    }
  };
}
function u1(t) {
  let r, e, n, i, o, s = lr(
    /*sources*/
    t[4]
  ), a = [];
  for (let l = 0; l < s.length; l += 1)
    a[l] = ic(ec(t, s, l));
  return {
    c() {
      r = Be("video");
      for (let l = 0; l < a.length; l += 1)
        a[l].c();
      m(r, "class", eo.video__video), m(r, "style", e = Rt(
        /*style*/
        t[14]
      )), r.playsInline = !0, r.loop = /*loop*/
      t[5], r.autoplay = /*autoplay*/
      t[6], r.muted = /*muted*/
      t[7], m(
        r,
        "poster",
        /*poster*/
        t[9]
      ), m(r, "preload", n = /*preload*/
      t[8] ? "metadata" : "auto");
    },
    m(l, u) {
      x(l, r, u);
      for (let c = 0; c < a.length; c += 1)
        a[c] && a[c].m(r, null);
      t[50](r), i || (o = [
        Ge(
          r,
          "timeupdate",
          /*onTimeUpdate*/
          t[26]
        ),
        Ge(
          r,
          "ended",
          /*onEnd*/
          t[27]
        ),
        Ge(
          r,
          "playing",
          /*onPlaying*/
          t[28]
        ),
        Ge(
          r,
          "pause",
          /*onPause*/
          t[29]
        ),
        Ge(
          r,
          "waiting",
          /*onWaiting*/
          t[30]
        ),
        Ge(
          r,
          "error",
          /*onError*/
          t[31]
        )
      ], i = !0);
    },
    p(l, u) {
      if (u[0] & /*sources*/
      16 | u[1] & /*onError*/
      1) {
        s = lr(
          /*sources*/
          l[4]
        );
        let c;
        for (c = 0; c < s.length; c += 1) {
          const f = ec(l, s, c);
          a[c] ? a[c].p(f, u) : (a[c] = ic(f), a[c].c(), a[c].m(r, null));
        }
        for (; c < a.length; c += 1)
          a[c].d(1);
        a.length = s.length;
      }
      u[0] & /*style*/
      16384 && e !== (e = Rt(
        /*style*/
        l[14]
      )) && m(r, "style", e), u[0] & /*loop*/
      32 && (r.loop = /*loop*/
      l[5]), u[0] & /*autoplay*/
      64 && (r.autoplay = /*autoplay*/
      l[6]), u[0] & /*muted*/
      128 && (r.muted = /*muted*/
      l[7]), u[0] & /*poster*/
      512 && m(
        r,
        "poster",
        /*poster*/
        l[9]
      ), u[0] & /*preload*/
      256 && n !== (n = /*preload*/
      l[8] ? "metadata" : "auto") && m(r, "preload", n);
    },
    d(l) {
      l && Z(r), gn(a, l), t[50](null), i = !1, Qr(o);
    }
  };
}
function c1(t) {
  let r;
  return {
    c() {
      r = Be("div"), m(r, "class", eo.video__container);
    },
    m(e, n) {
      x(e, r, n), r.innerHTML = /*providedVideoTemplate*/
      t[12], t[49](r);
    },
    p(e, n) {
      n[0] & /*providedVideoTemplate*/
      4096 && (r.innerHTML = /*providedVideoTemplate*/
      e[12]);
    },
    d(e) {
      e && Z(r), t[49](null);
    }
  };
}
function nc(t) {
  let r, e, n, i, o;
  return {
    c() {
      r = Be("source"), Zn(r.src, e = /*source*/
      t[60].src) || m(r, "src", e), m(r, "type", n = /*source*/
      t[60].type);
    },
    m(s, a) {
      x(s, r, a), i || (o = Ge(
        r,
        "error",
        /*onError*/
        t[31]
      ), i = !0);
    },
    p(s, a) {
      a[0] & /*sources*/
      16 && !Zn(r.src, e = /*source*/
      s[60].src) && m(r, "src", e), a[0] & /*sources*/
      16 && n !== (n = /*source*/
      s[60].type) && m(r, "type", n);
    },
    d(s) {
      s && Z(r), i = !1, o();
    }
  };
}
function ic(t) {
  let r = (
    /*source*/
    t[60]
  ), e, n = nc(t);
  return {
    c() {
      n.c(), e = $t();
    },
    m(i, o) {
      n.m(i, o), x(i, e, o);
    },
    p(i, o) {
      o[0] & /*sources*/
      16 && Vr(r, r = /*source*/
      i[60]) ? (n.d(1), n = nc(i), n.c(), n.m(e.parentNode, e)) : n.p(i, o);
    },
    d(i) {
      i && Z(e), n.d(i);
    }
  };
}
function f1(t) {
  let r;
  function e(o, s) {
    return (
      /*aspectPaddingBottom*/
      o[11] !== "0" ? a1 : (
        /*shouldUseVideoProvider*/
        o[13] ? l1 : s1
      )
    );
  }
  let n = e(t), i = n(t);
  return {
    c() {
      i.c(), r = $t();
    },
    m(o, s) {
      i.m(o, s), x(o, r, s);
    },
    p(o, s) {
      n === (n = e(o)) && i ? i.p(o, s) : (i.d(1), i = n(o), i && (i.c(), i.m(r.parentNode, r)));
    },
    d(o) {
      o && Z(r), i.d(o);
    }
  };
}
function d1(t) {
  let r, e, n, i;
  const o = [o1, i1], s = [];
  function a(l, u) {
    return (
      /*hasError*/
      l[2] ? -1 : 0
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function _1(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g, y, p, w, E, Q = T, J = () => (Q(), Q = B(a, (ie) => e(39, E = ie)), a), M, ge = T, le = () => (ge(), ge = B(y, (ie) => e(40, M = ie)), y), H, ee = T, X = () => (ee(), ee = B(g, (ie) => e(41, H = ie)), g), I, P = T, O = () => (P(), P = B(_, (ie) => e(42, I = ie)), _), U, me = T, nt = () => (me(), me = B(f, (ie) => e(43, U = ie)), f), _e, Me = T, tt = () => (Me(), Me = B(c, (ie) => e(44, _e = ie)), c), We, Ne = T, Ft = () => (Ne(), Ne = B(u, (ie) => e(45, We = ie)), u), Ve, Oe = T, Pe = () => (Oe(), Oe = B(l, (ie) => e(46, Ve = ie)), l), yt, ye = T, Ke = () => (ye(), ye = B(s, (ie) => e(47, yt = ie)), s), je, te = T, ot = () => (te(), te = B(o, (ie) => e(48, je = ie)), o);
  t.$$.on_destroy.push(() => Q()), t.$$.on_destroy.push(() => ge()), t.$$.on_destroy.push(() => ee()), t.$$.on_destroy.push(() => P()), t.$$.on_destroy.push(() => me()), t.$$.on_destroy.push(() => Me()), t.$$.on_destroy.push(() => Ne()), t.$$.on_destroy.push(() => Oe()), t.$$.on_destroy.push(() => ye()), t.$$.on_destroy.push(() => te());
  let { componentContext: ce } = r, { layoutParams: pt = void 0 } = r;
  const Ct = Xr(_n), re = Ct.videoPlayerProvider;
  let $, pe = !1, Bt = !1, De, ft, Mt = [], He = !1, ht = !1, qt = !1, fe = !1, Vt, be = "fit", $e = "0", Ce = !1, Xe, Jt = "", bt, Qt = !!re;
  function rt(ie) {
    var Lt, Gt;
    const ze = ce.getJsonWithVars({
      sources: ie.video_sources,
      repeatable: ie.repeatable,
      autostart: ie.autostart,
      preloadRequired: ie.preload_required,
      muted: ie.muted,
      preview: ie.preview,
      aspect: ie.aspect,
      scale: ie.scale,
      payload: ie.player_settings_payload
    }), Ot = Tn(ze.repeatable, !1), Yt = Tn(ze.autostart, !1), Ht = Tn(ze.preloadRequired, !1), wt = Tn(ze.muted, !1), Wt = (Lt = ze.aspect) != null && Lt.ratio && Hn(ze.aspect.ratio) ? ze.aspect.ratio : void 0;
    if ((Gt = ze.sources) != null && Gt.length)
      return {
        sources: ze.sources,
        repeatable: Ot,
        autostart: Yt,
        preloadRequired: Ht,
        muted: wt,
        preview: ze.preview,
        aspect: Wt,
        scale: ze.scale,
        payload: ze.payload
      };
  }
  function ir(ie) {
    var ze;
    if (Bt) {
      Bt = !1;
      return;
    }
    bt ? (ze = bt.seek) == null || ze.call(bt, Number(ie)) : De && e(3, De.currentTime = Number(ie) / 1e3, De);
  }
  function W() {
    bt ? bt.pause() : De == null || De.pause();
  }
  function Et() {
    if (bt) {
      bt.play();
      return;
    }
    const ie = De == null ? void 0 : De.play();
    ie && ie.catch((ze) => {
      ce.logError(R(new Error("Video playing error"), {
        level: "error",
        additional: { originalText: String(ze) }
      }));
    });
  }
  function It() {
    De && (Bt = !0, i.setValue(Math.floor(De.currentTime * 1e3)));
  }
  function Ye() {
    ce.execAnyActions(ce.json.end_actions);
  }
  function L() {
    ce.execAnyActions(ce.json.resume_actions);
  }
  function Le() {
    ce.execAnyActions(ce.json.pause_actions);
  }
  function gt() {
    ce.execAnyActions(ce.json.buffering_actions);
  }
  function qe() {
    ce.execAnyActions(ce.json.fatal_actions);
  }
  Jn(() => {
    if (re && ft) {
      const ie = rt(ce.json);
      if (ie) {
        const ze = re.instance(ft, ie);
        ze ? e(36, bt = ze) : e(13, Qt = !1);
      }
    }
  }), bn(() => {
    $ && (Ct.unregisterInstance($), e(32, $ = void 0)), Xe && (Xe(), e(35, Xe = void 0)), bt && (bt.destroy(), e(36, bt = void 0));
  });
  function Te(ie) {
    Or[ie ? "unshift" : "push"](() => {
      ft = ie, e(10, ft);
    });
  }
  function cr(ie) {
    Or[ie ? "unshift" : "push"](() => {
      De = ie, e(3, De);
    });
  }
  function ke(ie) {
    Or[ie ? "unshift" : "push"](() => {
      ft = ie, e(10, ft);
    });
  }
  function hr(ie) {
    Or[ie ? "unshift" : "push"](() => {
      De = ie, e(3, De);
    });
  }
  return t.$$set = (ie) => {
    "componentContext" in ie && e(0, ce = ie.componentContext), "layoutParams" in ie && e(1, pt = ie.layoutParams);
  }, t.$$.update = () => {
    var ie;
    if (t.$$.dirty[0] & /*componentContext*/
    1 && ce.json && (e(5, He = !1), e(6, ht = !1), e(7, qt = !1), e(8, fe = !1), e(9, Vt = void 0), e(33, be = "fit"), e(34, Ce = !1), e(13, Qt = !!re)), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*customVideoInstance, $jsonSource, $jsonRepeatable, $jsonAutostart, $jsonMuted, $jsonPreload, $jsonPreview, $jsonScale, $jsonAspect*/
    260384 && ce.json && bt && (je || yt || E || Ve || We || _e || U || I)) {
      const ze = rt(ce.json);
      ze && ((ie = bt.update) == null || ie.call(bt, ze));
    }
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(38, n = ce.json.elapsed_time_variable), t.$$.dirty[0] & /*componentContext*/
    1 | t.$$.dirty[1] & /*elapsedVariableName*/
    128 && e(37, i = n && (ce.getVariable(n, "integer") || Ct.awaitGlobalVariable(n, "integer", 0)) || mi("temp", "integer", 0)), t.$$.dirty[1] & /*elapsedVariable, elapsedVariableUnsubscriber*/
    80 && i && (Xe && Xe(), e(35, Xe = i.subscribe(ir))), t.$$.dirty[0] & /*componentContext*/
    1 && ot(e(25, o = ce.getDerivedFromVars(ce.json.video_sources))), t.$$.dirty[0] & /*componentContext*/
    1 && Ke(e(24, s = ce.getDerivedFromVars(ce.json.repeatable))), t.$$.dirty[0] & /*componentContext*/
    1 && J(e(23, a = ce.getDerivedFromVars(ce.json.autostart))), t.$$.dirty[0] & /*componentContext*/
    1 && Pe(e(22, l = ce.getDerivedFromVars(ce.json.muted))), t.$$.dirty[0] & /*componentContext*/
    1 && Ft(e(21, u = ce.getDerivedFromVars(ce.json.preload_required))), t.$$.dirty[0] & /*componentContext*/
    1 && tt(e(20, c = ce.getDerivedFromVars(ce.json.preview))), t.$$.dirty[0] & /*componentContext*/
    1 && nt(e(19, f = ce.getDerivedFromVars(ce.json.scale))), t.$$.dirty[0] & /*componentContext*/
    1 && O(e(18, _ = ce.getDerivedFromVars(ce.json.aspect))), t.$$.dirty[0] & /*componentContext*/
    1 && X(e(17, g = ce.getDerivedFromVars(ce.json.width))), t.$$.dirty[0] & /*componentContext*/
    1 && le(e(16, y = ce.getDerivedFromVars(ce.json.height))), t.$$.dirty[0] & /*sources, componentContext*/
    17 | t.$$.dirty[1] & /*$jsonSource*/
    131072 && (e(4, Mt = r1(je, Mt)), Mt.length ? e(2, pe = !1) : (e(2, pe = !0), ce.logError(R(new Error('Missing "video_sources" in "video"'))))), t.$$.dirty[0] & /*loop*/
    32 | t.$$.dirty[1] & /*$jsonRepeatable*/
    65536 && e(5, He = Tn(yt, He)), t.$$.dirty[0] & /*autoplay*/
    64 | t.$$.dirty[1] & /*$jsonAutostart*/
    256 && e(6, ht = Tn(E, ht)), t.$$.dirty[0] & /*muted*/
    128 | t.$$.dirty[1] & /*$jsonMuted*/
    32768 && e(7, qt = Tn(Ve, qt)), t.$$.dirty[0] & /*preload*/
    256 | t.$$.dirty[1] & /*$jsonPreload*/
    16384 && e(8, fe = Tn(We, fe)), t.$$.dirty[0] & /*poster*/
    512 | t.$$.dirty[1] & /*$jsonPreview*/
    8192 && e(9, Vt = typeof _e == "string" ? Df(_e) : Vt), t.$$.dirty[1] & /*$jsonScale, scale*/
    4100 && e(33, be = n1(U) || be), t.$$.dirty[1] & /*$jsonAspect, $jsonWidth, $jsonHeight*/
    3584) {
      const ze = I == null ? void 0 : I.ratio;
      ze && Hn(ze) ? (e(11, $e = (100 / Number(ze)).toFixed(2)), e(34, Ce = !0)) : (e(11, $e = "0"), e(34, Ce = (!H || H.type === "match_parent") && (M == null ? void 0 : M.type) === "match_parent"));
    }
    t.$$.dirty[0] & /*componentContext, hasError*/
    5 | t.$$.dirty[1] & /*prevId*/
    2 && ce.json && ($ && (Ct.unregisterInstance($), e(32, $ = void 0)), ce.id && !pe && !ce.fakeElement && (e(32, $ = ce.id), Ct.registerInstance($, { pause: W, start: Et }))), t.$$.dirty[0] & /*componentContext, videoElem*/
    9 | t.$$.dirty[1] & /*$jsonAutostart*/
    256 && ce.json && E && De && Et(), t.$$.dirty[1] & /*isAbsolute*/
    8 && e(15, p = { absolute: Ce }), t.$$.dirty[1] & /*scale*/
    4 && e(14, w = { "object-fit": be });
  }, [
    ce,
    pt,
    pe,
    De,
    Mt,
    He,
    ht,
    qt,
    fe,
    Vt,
    ft,
    $e,
    Jt,
    Qt,
    w,
    p,
    y,
    g,
    _,
    f,
    c,
    u,
    l,
    a,
    s,
    o,
    It,
    Ye,
    L,
    Le,
    gt,
    qe,
    $,
    be,
    Ce,
    Xe,
    bt,
    i,
    n,
    E,
    M,
    H,
    I,
    U,
    _e,
    We,
    Ve,
    yt,
    je,
    Te,
    cr,
    ke,
    hr
  ];
}
class p1 extends $r {
  constructor(r) {
    super(), xr(this, r, _1, d1, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1, -1]);
  }
}
const h1 = "appkit-switch__tumbler", g1 = "appkit-switch__tumbler_checked", m1 = "appkit-switch_disabled", b1 = "appkit-switch__thumb", y1 = "appkit-switch_direction_rtl", w1 = "appkit-switch__input", Gi = {
  switch: "appkit-switch",
  switch__tumbler: h1,
  switch__tumbler_checked: g1,
  switch_disabled: m1,
  switch__thumb: b1,
  switch_direction_rtl: y1,
  switch__input: w1
};
function rl(t) {
  return t === !0 || t === 1;
}
function v1(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function k1(t) {
  let r, e;
  return r = new On({
    props: {
      cls: jt(
        "switch",
        Gi,
        /*mods*/
        t[9]
      ),
      style: (
        /*stl*/
        t[8]
      ),
      customDescription: !0,
      customActions: "switch",
      hasInnerFocusable: !0,
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      $$slots: {
        default: [
          E1,
          ({ focusHandler: n, blurHandler: i, hasCustomFocus: o }) => ({
            29: n,
            30: i,
            31: o
          }),
          ({ focusHandler: n, blurHandler: i, hasCustomFocus: o }) => [
            (n ? 536870912 : 0) | (i ? 1073741824 : 0),
            o ? 1 : 0
          ]
        ]
      },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*mods*/
      512 && (o.cls = jt(
        "switch",
        Gi,
        /*mods*/
        n[9]
      )), i[0] & /*stl*/
      256 && (o.style = /*stl*/
      n[8]), i[0] & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i[0] & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i[0] & /*description, isEnabled, value, input, focusHandler, blurHandler*/
      1610612844 | i[1] & /*$$scope, hasCustomFocus*/
      3 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function E1(t) {
  let r, e, n, i, o, s, a, l, u;
  return {
    c() {
      r = Be("div"), e = Be("div"), i = wr(), o = Be("input"), m(e, "class", Gi.switch__thumb), m(r, "class", n = jt("switch__tumbler", Gi, { checked: (
        /*value*/
        t[3]
      ) })), m(o, "type", "checkbox"), m(o, "class", s = jt("switch__input", Gi, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[31]
        )
      })), m(o, "autocomplete", "off"), m(
        o,
        "aria-label",
        /*description*/
        t[6]
      ), o.disabled = a = !/*isEnabled*/
      t[5], o.checked = /*value*/
      t[3];
    },
    m(c, f) {
      x(c, r, f), Tt(r, e), x(c, i, f), x(c, o, f), t[25](o), l || (u = [
        Ge(
          o,
          "input",
          /*onInput*/
          t[14]
        ),
        Ge(o, "focus", function() {
          zr(
            /*focusHandler*/
            t[29]
          ) && t[29].apply(this, arguments);
        }),
        Ge(o, "blur", function() {
          zr(
            /*blurHandler*/
            t[30]
          ) && t[30].apply(this, arguments);
        })
      ], l = !0);
    },
    p(c, f) {
      t = c, f[0] & /*value*/
      8 && n !== (n = jt("switch__tumbler", Gi, { checked: (
        /*value*/
        t[3]
      ) })) && m(r, "class", n), f[1] & /*hasCustomFocus*/
      1 && s !== (s = jt("switch__input", Gi, {
        "has-custom-focus": (
          /*hasCustomFocus*/
          t[31]
        )
      })) && m(o, "class", s), f[0] & /*description*/
      64 && m(
        o,
        "aria-label",
        /*description*/
        t[6]
      ), f[0] & /*isEnabled*/
      32 && a !== (a = !/*isEnabled*/
      t[5]) && (o.disabled = a), f[0] & /*value*/
      8 && (o.checked = /*value*/
      t[3]);
    },
    d(c) {
      c && (Z(r), Z(i), Z(o)), t[25](null), l = !1, Qr(u);
    }
  };
}
function A1(t) {
  let r, e, n, i;
  const o = [k1, v1], s = [];
  function a(l, u) {
    return (
      /*hasError*/
      l[4] ? -1 : 0
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, u) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function j1(t, r, e) {
  let n, i, o, s, a, l, u, c, f, _, g = T, y = () => (g(), g = B(s, (Pe) => e(21, _ = Pe)), s), p, w = T, E = () => (w(), w = B(l, (Pe) => e(22, p = Pe)), l), Q, J = T, M = () => (J(), J = B(a, (Pe) => e(23, Q = Pe)), a), ge, le = T, H = () => (le(), le = B(o, (Pe) => e(24, ge = Pe)), o);
  t.$$.on_destroy.push(() => g()), t.$$.on_destroy.push(() => w()), t.$$.on_destroy.push(() => J()), t.$$.on_destroy.push(() => le());
  let { componentContext: ee } = r, { layoutParams: X = void 0 } = r;
  const I = Xr(_n), P = Xr(Zi), O = I.direction;
  mn(t, O, (Pe) => e(20, f = Pe));
  let U, me, nt = !1, _e = !1, Me = "", tt = !0, We = "#129386", Ne = "#1293864c";
  function Ft() {
    e(5, tt = !0), e(16, We = "#129386"), e(17, Ne = "#1293864c");
  }
  function Ve(Pe) {
    e(3, nt = Pe.target.checked), o.setValue(nt);
  }
  bn(() => {
    U && (I.unregisterFocusable(U), e(15, U = void 0));
  });
  function Oe(Pe) {
    Or[Pe ? "unshift" : "push"](() => {
      me = Pe, e(2, me);
    });
  }
  return t.$$set = (Pe) => {
    "componentContext" in Pe && e(0, ee = Pe.componentContext), "layoutParams" in Pe && e(1, X = Pe.layoutParams);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & /*componentContext*/
    1 && e(19, n = ee.origJson), t.$$.dirty[0] & /*origJson*/
    524288 && n && Ft(), t.$$.dirty[0] & /*componentContext*/
    1 && e(18, i = ee.json.is_on_variable), t.$$.dirty[0] & /*variable, componentContext*/
    262145 && H(e(7, o = i && (ee.getVariable(i, "boolean") || I.awaitGlobalVariable(i, "boolean", !1)) || mi("temp", "boolean", !1))), t.$$.dirty[0] & /*componentContext*/
    1 && y(e(12, s = ee.getDerivedFromVars(ee.json.accessibility))), t.$$.dirty[0] & /*componentContext*/
    1 && M(e(11, a = ee.getDerivedFromVars(ee.json.is_enabled))), t.$$.dirty[0] & /*componentContext*/
    1 && E(e(10, l = ee.getDerivedFromVars(ee.json.on_color))), t.$$.dirty[0] & /*variable, componentContext, $jsonAccessibility, hasError*/
    2359313) {
      let Pe = !1;
      i ? (P.hasAction() || (_ == null ? void 0 : _.mode) === "exclude") && (Pe = !0, ee.logError(R(new Error('Cannot show "switch" inside component with an action or inside accessibility mode=exclude')))) : (Pe = !0, ee.logError(R(new Error('Missing "is_on_variable" in "switch"')))), _e !== Pe && e(4, _e = Pe);
    }
    if (t.$$.dirty[0] & /*value, $valueVariable*/
    16777224 && rl(nt) !== rl(ge) && e(3, nt = rl(ge)), t.$$.dirty[0] & /*$jsonIsEnabled, isEnabled*/
    8388640 && e(5, tt = Tn(Q, tt)), t.$$.dirty[0] & /*$jsonOnColor, onColor*/
    4259840 && (e(16, We = Tr(p, 1, We)), typeof p == "string")) {
      const Pe = si(p);
      Pe && (Pe.a *= 0.3, e(17, Ne = Ml(Pe)));
    }
    t.$$.dirty[0] & /*$jsonAccessibility, componentContext*/
    2097153 && (_ != null && _.description ? e(6, Me = po(_)) : ee.logError(R(new Error('Missing accessibility "description" for switch'), { level: "warn" }))), t.$$.dirty[0] & /*isEnabled, $direction*/
    1048608 && e(9, u = {
      disabled: !tt,
      direction: f
    }), t.$$.dirty[0] & /*onColor, onSubColor*/
    196608 && e(8, c = {
      "--divkit-switch-on-color": We,
      "--divkit-switch-on-sub-color": Ne
    }), t.$$.dirty[0] & /*input, componentContext, prevId*/
    32773 && me && ee.json && (U && (I.unregisterFocusable(U), e(15, U = void 0)), ee.id && !ee.fakeElement && (e(15, U = ee.id), I.registerFocusable(U, {
      focus() {
        me && me.focus();
      }
    })));
  }, [
    ee,
    X,
    me,
    nt,
    _e,
    tt,
    Me,
    o,
    c,
    u,
    l,
    a,
    s,
    O,
    Ve,
    U,
    We,
    Ne,
    i,
    n,
    f,
    _,
    p,
    Q,
    ge,
    Oe
  ];
}
class C1 extends $r {
  constructor(r) {
    super(), xr(this, r, j1, A1, Vr, { componentContext: 0, layoutParams: 1 }, null, [-1, -1]);
  }
}
function oc(t, r, e) {
  const n = t.slice();
  return n[11] = r[e], n;
}
function S1(t) {
  let r, e;
  return r = new ci({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      )
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function V1(t) {
  let r, e;
  return r = new On({
    props: {
      componentContext: (
        /*componentContext*/
        t[0]
      ),
      layoutParams: (
        /*layoutParams*/
        t[1]
      ),
      $$slots: { default: [I1] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i & /*componentContext*/
      1 && (o.componentContext = /*componentContext*/
      n[0]), i & /*layoutParams*/
      2 && (o.layoutParams = /*layoutParams*/
      n[1]), i & /*$$scope, componentContext, customElem, desc, jsonItems, items, hasItemsError, templateAttrs, templateContent*/
      16893 && (o.$$scope = { dirty: i, ctx: n }), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function sc(t) {
  let r, e = [
    /*templateAttrs*/
    t[8]
  ], n = {};
  for (let i = 0; i < e.length; i += 1)
    n = ui(n, e[i]);
  return {
    c() {
      r = Be("template"), Di(r, n);
    },
    m(i, o) {
      x(i, r, o), r.content.innerHTML = /*templateContent*/
      t[7];
    },
    p(i, o) {
      o & /*templateContent*/
      128 && (r.content.innerHTML = /*templateContent*/
      i[7]), Di(r, n = vi(e, [o & /*templateAttrs*/
      256 && /*templateAttrs*/
      i[8]]));
    },
    d(i) {
      i && Z(r);
    }
  };
}
function lc(t) {
  let r = (
    /*jsonItems*/
    t[5]
  ), e, n, i = uc(t);
  return {
    c() {
      i.c(), e = $t();
    },
    m(o, s) {
      i.m(o, s), x(o, e, s), n = !0;
    },
    p(o, s) {
      s & /*jsonItems*/
      32 && Vr(r, r = /*jsonItems*/
      o[5]) ? (_r(), ae(i, 1, 1, T), pr(), i = uc(o), i.c(), K(i, 1), i.m(e.parentNode, e)) : i.p(o, s);
    },
    i(o) {
      n || (K(i), n = !0);
    },
    o(o) {
      ae(i), n = !1;
    },
    d(o) {
      o && Z(e), i.d(o);
    }
  };
}
function ac(t) {
  let r, e;
  return r = new ti({
    props: { componentContext: (
      /*item*/
      t[11]
    ) }
  }), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i & /*items*/
      8 && (o.componentContext = /*item*/
      n[11]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function uc(t) {
  let r, e, n = lr(
    /*items*/
    t[3]
  ), i = [];
  for (let s = 0; s < n.length; s += 1)
    i[s] = ac(oc(t, n, s));
  const o = (s) => ae(i[s], 1, 1, () => {
    i[s] = null;
  });
  return {
    c() {
      for (let s = 0; s < i.length; s += 1)
        i[s].c();
      r = $t();
    },
    m(s, a) {
      for (let l = 0; l < i.length; l += 1)
        i[l] && i[l].m(s, a);
      x(s, r, a), e = !0;
    },
    p(s, a) {
      if (a & /*items*/
      8) {
        n = lr(
          /*items*/
          s[3]
        );
        let l;
        for (l = 0; l < n.length; l += 1) {
          const u = oc(s, n, l);
          i[l] ? (i[l].p(u, a), K(i[l], 1)) : (i[l] = ac(u), i[l].c(), K(i[l], 1), i[l].m(r.parentNode, r));
        }
        for (_r(), l = n.length; l < i.length; l += 1)
          o(l);
        pr();
      }
    },
    i(s) {
      if (!e) {
        for (let a = 0; a < n.length; a += 1)
          K(i[a]);
        e = !0;
      }
    },
    o(s) {
      i = i.filter(Boolean);
      for (let a = 0; a < i.length; a += 1)
        ae(i[a]);
      e = !1;
    },
    d(s) {
      s && Z(r), gn(i, s);
    }
  };
}
function nl(t) {
  let r, e, n, i = (
    /*templateContent*/
    t[7] && sc(t)
  ), o = !/*hasItemsError*/
  t[4] && /*jsonItems*/
  t[5] && lc(t), s = [
    /*componentContext*/
    t[0].json.custom_props || {}
  ], a = {};
  for (let l = 0; l < s.length; l += 1)
    a = ui(a, s[l]);
  return {
    c() {
      r = Be(
        /*desc*/
        t[2].element
      ), i && i.c(), e = wr(), o && o.c(), zi(
        /*desc*/
        t[2].element
      )(r, a);
    },
    m(l, u) {
      x(l, r, u), i && i.m(r, null), Tt(r, e), o && o.m(r, null), t[9](r), n = !0;
    },
    p(l, u) {
      /*templateContent*/
      l[7] ? i ? i.p(l, u) : (i = sc(l), i.c(), i.m(r, e)) : i && (i.d(1), i = null), !/*hasItemsError*/
      l[4] && /*jsonItems*/
      l[5] ? o ? (o.p(l, u), u & /*hasItemsError, jsonItems*/
      48 && K(o, 1)) : (o = lc(l), o.c(), K(o, 1), o.m(r, null)) : o && (_r(), ae(o, 1, 1, () => {
        o = null;
      }), pr()), zi(
        /*desc*/
        l[2].element
      )(r, a = vi(s, [
        u & /*componentContext*/
        1 && /*componentContext*/
        (l[0].json.custom_props || {})
      ]));
    },
    i(l) {
      n || (K(o), n = !0);
    },
    o(l) {
      ae(o), n = !1;
    },
    d(l) {
      l && Z(r), i && i.d(), o && o.d(), t[9](null);
    }
  };
}
function I1(t) {
  let r = (
    /*desc*/
    t[2].element
  ), e, n = (
    /*desc*/
    t[2].element && nl(t)
  );
  return {
    c() {
      n && n.c(), e = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, e, o);
    },
    p(i, o) {
      /*desc*/
      i[2].element ? r ? Vr(
        r,
        /*desc*/
        i[2].element
      ) ? (n.d(1), n = nl(i), r = /*desc*/
      i[2].element, n.c(), n.m(e.parentNode, e)) : n.p(i, o) : (n = nl(i), r = /*desc*/
      i[2].element, n.c(), n.m(e.parentNode, e)) : r && (n.d(1), n = null, r = /*desc*/
      i[2].element);
    },
    i: T,
    o(i) {
      ae(n, i);
    },
    d(i) {
      i && Z(e), n && n.d(i);
    }
  };
}
function D1(t) {
  let r, e, n, i;
  const o = [V1, S1], s = [];
  function a(l, u) {
    return (
      /*desc*/
      l[2] ? 0 : -1
    );
  }
  return ~(r = a(t)) && (e = s[r] = o[r](t)), {
    c() {
      e && e.c(), n = $t();
    },
    m(l, u) {
      ~r && s[r].m(l, u), x(l, n, u), i = !0;
    },
    p(l, [u]) {
      let c = r;
      r = a(l), r === c ? ~r && s[r].p(l, u) : (e && (_r(), ae(s[c], 1, 1, () => {
        s[c] = null;
      }), pr()), ~r ? (e = s[r], e ? e.p(l, u) : (e = s[r] = o[r](l), e.c()), K(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(l) {
      i || (K(e), i = !0);
    },
    o(l) {
      ae(e), i = !1;
    },
    d(l) {
      l && Z(n), ~r && s[r].d(l);
    }
  };
}
function T1(t, r, e) {
  let n, { componentContext: i } = r, { layoutParams: o = void 0 } = r;
  const s = Xr(_n);
  let a, l = null, u = "", c = {}, f = [], _ = !1;
  Jn(() => {
    if (a && "divKitApiCallback" in a && typeof a.divKitApiCallback == "function") {
      const y = s.getExtensionContext(i);
      a.divKitApiCallback(y);
    }
  }), bn(() => {
    f.forEach((y) => {
      y.destroy();
    });
  });
  function g(y) {
    Or[y ? "unshift" : "push"](() => {
      a = y, e(6, a);
    });
  }
  return t.$$set = (y) => {
    "componentContext" in y && e(0, i = y.componentContext), "layoutParams" in y && e(1, o = y.layoutParams);
  }, t.$$.update = () => {
    var y;
    if (t.$$.dirty & /*componentContext, desc*/
    5)
      if (typeof i.json.custom_type == "string" && i.json.custom_type && ((y = s.customComponents) != null && y.has(i.json.custom_type))) {
        if (e(2, l = s.customComponents.get(i.json.custom_type)), typeof l.template == "function") {
          const p = s.getExtensionContext(i), w = /* @__PURE__ */ new Map();
          for (const [E, Q] of p.variables)
            w.set(E, Q.getValue());
          e(7, u = l.template({
            props: i.json.custom_props,
            variables: w
          }));
        } else
          l.template && typeof l.template == "string" ? e(7, u = l.template) : e(7, u = "");
        e(8, c = {
          shadowrootmode: l.shadowRootMode || "open"
        });
      } else
        e(2, l = null), e(7, u = ";"), i.logError(R(new Error('Unknown or incorrect "custom_type" prop for div "custom"')));
    t.$$.dirty & /*componentContext*/
    1 && e(5, n = i.json.items), t.$$.dirty & /*jsonItems, componentContext*/
    33 && (n !== void 0 && !Array.isArray(n) ? (e(4, _ = !0), i.logError(R(new Error('Incorrect "items" prop for div "custom"')))) : e(4, _ = !1)), t.$$.dirty & /*items, hasItemsError, jsonItems, componentContext*/
    57 && (f.forEach((p) => {
      p.destroy();
    }), e(3, f = (!_ && n || []).map((p, w) => i.produceChildContext(p, { path: w }))));
  }, [
    i,
    o,
    l,
    f,
    _,
    n,
    a,
    u,
    c,
    g
  ];
}
class F1 extends $r {
  constructor(r) {
    super(), xr(this, r, T1, D1, Vr, { componentContext: 0, layoutParams: 1 });
  }
}
const td = {
  text: up,
  container: qp,
  separator: eh,
  image: Ga,
  gif: Ga,
  grid: Ih,
  gallery: Xh,
  tabs: Ag,
  state: Kg,
  pager: m0,
  indicator: T0,
  slider: _m,
  input: Wm,
  select: xm,
  video: p1,
  switch: C1,
  custom: F1
};
function cc(t) {
  let r, e, n;
  var i = (
    /*component*/
    t[2]
  );
  function o(s, a) {
    return {
      props: {
        componentContext: (
          /*componentContext*/
          s[0]
        ),
        layoutParams: (
          /*layoutParams*/
          s[1]
        )
      }
    };
  }
  return i && (r = na(i, o(t))), {
    c() {
      r && Zt(r.$$.fragment), e = $t();
    },
    m(s, a) {
      r && Kt(r, s, a), x(s, e, a), n = !0;
    },
    p(s, a) {
      if (a & /*component*/
      4 && i !== (i = /*component*/
      s[2])) {
        if (r) {
          _r();
          const l = r;
          ae(l.$$.fragment, 1, 0, () => {
            Xt(l, 1);
          }), pr();
        }
        i ? (r = na(i, o(s)), Zt(r.$$.fragment), K(r.$$.fragment, 1), Kt(r, e.parentNode, e)) : r = null;
      } else if (i) {
        const l = {};
        a & /*componentContext*/
        1 && (l.componentContext = /*componentContext*/
        s[0]), a & /*layoutParams*/
        2 && (l.layoutParams = /*layoutParams*/
        s[1]), r.$set(l);
      }
    },
    i(s) {
      n || (r && K(r.$$.fragment, s), n = !0);
    },
    o(s) {
      r && ae(r.$$.fragment, s), n = !1;
    },
    d(s) {
      s && Z(e), r && Xt(r, s);
    }
  };
}
function M1(t) {
  let r, e, n = (
    /*component*/
    t[2] && cc(t)
  );
  return {
    c() {
      n && n.c(), r = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, r, o), e = !0;
    },
    p(i, [o]) {
      /*component*/
      i[2] ? n ? (n.p(i, o), o & /*component*/
      4 && K(n, 1)) : (n = cc(i), n.c(), K(n, 1), n.m(r.parentNode, r)) : n && (_r(), ae(n, 1, 1, () => {
        n = null;
      }), pr());
    },
    i(i) {
      e || (K(n), e = !0);
    },
    o(i) {
      ae(n), e = !1;
    },
    d(i) {
      i && Z(r), n && n.d(i);
    }
  };
}
function P1(t, r, e) {
  let { componentContext: n } = r, { layoutParams: i = void 0 } = r;
  const o = Xr(_n);
  let s;
  return t.$$set = (a) => {
    "componentContext" in a && e(0, n = a.componentContext), "layoutParams" in a && e(1, i = a.layoutParams);
  }, t.$$.update = () => {
    if (t.$$.dirty & /*componentContext, component*/
    5) {
      const a = n.json;
      if (e(2, s = (a == null ? void 0 : a.type) && td[a.type] || void 0), !s) {
        let l;
        a != null && a.type && o.hasTemplate(a.type) ? l = "Recursive template" : l = "Unknown component", n.logError(R(new Error(l), {
          additional: {
            component: (a == null ? void 0 : a.type) || "<missing>"
          }
        }));
      }
    }
  }, [n, i, s];
}
class ti extends $r {
  constructor(r) {
    super(), xr(this, r, P1, M1, Vr, { componentContext: 0, layoutParams: 1 });
  }
}
const N1 = {
  "root-svg-filters": "appkit-root-svg-filters"
};
function fc(t, r, e) {
  const n = t.slice();
  n[1] = r[e];
  const i = (
    /*filterKey*/
    n[1].split(":")
  );
  return n[2] = i[0], n[3] = i[1], n;
}
function dc(t) {
  let r, e, n = lr([...Object.keys(
    /*svgFiltersMap*/
    t[0]
  )]), i = [];
  for (let o = 0; o < n.length; o += 1)
    i[o] = _c(fc(t, n, o));
  return {
    c() {
      r = En("svg"), e = En("defs");
      for (let o = 0; o < i.length; o += 1)
        i[o].c();
      m(r, "class", N1["root-svg-filters"]), m(r, "aria-hidden", "true");
    },
    m(o, s) {
      x(o, r, s), Tt(r, e);
      for (let a = 0; a < i.length; a += 1)
        i[a] && i[a].m(e, null);
    },
    p(o, s) {
      if (s & /*svgFiltersMap, Object*/
      1) {
        n = lr([...Object.keys(
          /*svgFiltersMap*/
          o[0]
        )]);
        let a;
        for (a = 0; a < n.length; a += 1) {
          const l = fc(o, n, a);
          i[a] ? i[a].p(l, s) : (i[a] = _c(l), i[a].c(), i[a].m(e, null));
        }
        for (; a < i.length; a += 1)
          i[a].d(1);
        i.length = n.length;
      }
    },
    d(o) {
      o && Z(r), gn(i, o);
    }
  };
}
function z1(t) {
  let r, e;
  return {
    c() {
      r = En("feBlend"), m(r, "in2", "SourceGraphic"), m(r, "mode", e = /*filterMode*/
      t[3]);
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i & /*svgFiltersMap*/
      1 && e !== (e = /*filterMode*/
      n[3]) && m(r, "mode", e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function O1(t) {
  let r;
  return {
    c() {
      r = En("feComposite"), m(r, "in2", "SourceGraphic"), m(r, "operator", "arithmetic"), m(r, "k1", "1"), m(r, "k2", "0"), m(r, "k3", "0"), m(r, "k4", "0");
    },
    m(e, n) {
      x(e, r, n);
    },
    p: T,
    d(e) {
      e && Z(r);
    }
  };
}
function L1(t) {
  let r, e;
  return {
    c() {
      r = En("feComposite"), m(r, "in2", "SourceGraphic"), m(r, "operator", e = /*filterMode*/
      t[3].split("_")[1]);
    },
    m(n, i) {
      x(n, r, i);
    },
    p(n, i) {
      i & /*svgFiltersMap*/
      1 && e !== (e = /*filterMode*/
      n[3].split("_")[1]) && m(r, "operator", e);
    },
    d(n) {
      n && Z(r);
    }
  };
}
function _c(t) {
  let r, e, n, i;
  function o(l, u) {
    return (
      /*filterMode*/
      l[3] === "source_in" || /*filterMode*/
      l[3] === "source_atop" ? L1 : (
        /*filterMode*/
        l[3] === "multiply" ? O1 : z1
      )
    );
  }
  let s = o(t), a = s(t);
  return {
    c() {
      r = En("filter"), e = En("feFlood"), a.c(), m(e, "flood-color", n = /*filterColor*/
      t[2]), m(r, "id", i = /*svgFiltersMap*/
      t[0][
        /*filterKey*/
        t[1]
      ]);
    },
    m(l, u) {
      x(l, r, u), Tt(r, e), a.m(r, null);
    },
    p(l, u) {
      u & /*svgFiltersMap*/
      1 && n !== (n = /*filterColor*/
      l[2]) && m(e, "flood-color", n), s === (s = o(l)) && a ? a.p(l, u) : (a.d(1), a = s(l), a && (a.c(), a.m(r, null))), u & /*svgFiltersMap*/
      1 && i !== (i = /*svgFiltersMap*/
      l[0][
        /*filterKey*/
        l[1]
      ]) && m(r, "id", i);
    },
    d(l) {
      l && Z(r), a.d();
    }
  };
}
function R1(t) {
  let r = Object.keys(
    /*svgFiltersMap*/
    t[0]
  ).length, e, n = r && dc(t);
  return {
    c() {
      n && n.c(), e = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, e, o);
    },
    p(i, [o]) {
      o & /*svgFiltersMap*/
      1 && (r = Object.keys(
        /*svgFiltersMap*/
        i[0]
      ).length), r ? n ? n.p(i, o) : (n = dc(i), n.c(), n.m(e.parentNode, e)) : n && (n.d(1), n = null);
    },
    i: T,
    o: T,
    d(i) {
      i && Z(e), n && n.d(i);
    }
  };
}
function B1(t, r, e) {
  let { svgFiltersMap: n } = r;
  return t.$$set = (i) => {
    "svgFiltersMap" in i && e(0, n = i.svgFiltersMap);
  }, [n];
}
class H1 extends $r {
  constructor(r) {
    super(), xr(this, r, B1, R1, Vr, { svgFiltersMap: 0 });
  }
}
function W1(t, r, e, n) {
  const i = e[t.type];
  if (!i)
    return n(R(new Error("No such template"), {
      additional: {
        template: t.type
      }
    })), {
      json: t,
      templateContext: r
    };
  let o;
  const s = {};
  for (o in r)
    r.hasOwnProperty(o) && (s[o] = r[o]);
  for (o in t)
    o === "type" || o === "__proto__" || t.hasOwnProperty(o) && (s[o] = t[o]);
  function a(u, c) {
    const f = Object.keys(c).filter((y) => y !== "__proto__"), _ = f.filter((y) => y.charAt(0) !== "$"), g = f.filter((y) => y.charAt(0) === "$");
    return _.forEach((y) => {
      const p = c[y];
      typeof p == "object" && p !== null ? (u[y] = Array.isArray(p) ? [] : {}, a(u[y], p)) : u[y] = p;
    }), g.forEach((y) => {
      const p = c[y], w = s[p];
      if (w !== void 0) {
        const E = y.substring(1);
        u[E] = w;
      }
    }), u;
  }
  const l = a({}, i);
  for (o in t)
    o === "type" || o === "__proto__" || t.hasOwnProperty(o) && (l[o] = t[o]);
  return {
    json: l,
    templateContext: s
  };
}
const Qo = /* @__PURE__ */ new Map(), ml = /* @__PURE__ */ new Map(), xo = /* @__PURE__ */ new Map(), bl = /* @__PURE__ */ new Map();
function F(t, r, e) {
  const n = {
    args: r,
    cb: e
  }, i = Qo.get(t) || [];
  Qo.has(t) || Qo.set(t, i), i.push(n);
  const o = t + ":" + r.map((s) => typeof s == "object" ? s.type : s).join("#");
  ml.set(o, n);
}
function Hr(t, r, e) {
  const n = {
    args: r,
    cb: e
  }, i = xo.get(t) || [];
  xo.has(t) || xo.set(t, i), i.push(n);
  const o = t + ":" + r.map((s) => typeof s == "object" ? s.type : s).join("#");
  bl.set(o, n);
}
function U1(t, r, e) {
  const n = t.args.length;
  let i = t.args.length, o = 0;
  const s = t.args[t.args.length - 1];
  if (typeof s == "object" && s.isVararg && (i = 1 / 0), r.length < n)
    return {
      type: "few",
      expected: n,
      found: r.length,
      def: t,
      hasOverloads: e
    };
  if (r.length > i)
    return {
      type: "many",
      expected: i,
      found: r.length,
      def: t,
      hasOverloads: e
    };
  for (let a = 0; a < r.length; ++a) {
    let l = a >= t.args.length ? t.args[t.args.length - 1] : t.args[a];
    if (typeof l != "object" && (l = {
      type: l
    }), l.type === xe && r[a].type === ve) {
      ++o;
      continue;
    }
    if (l.type !== r[a].type)
      return {
        type: "mismatch",
        expected: l.type,
        found: r[a].type,
        def: t,
        hasOverloads: e
      };
  }
  return {
    type: "match",
    conversions: o
  };
}
function yl(t, r, e) {
  const n = t.get(r);
  if (!n)
    return {
      type: "missing"
    };
  let i = null, o = null;
  for (let s = 0; s < n.length; ++s) {
    const a = U1(n[s], e, n.length > 1);
    if (a.type === "match") {
      (!o || o.conversions > a.conversions) && (o = {
        func: n[s],
        conversions: a.conversions
      });
      continue;
    }
    i || (i = a);
  }
  if (!o) {
    if (i)
      return i;
    throw new Error("Missing function");
  }
  return o;
}
function rd(t, r) {
  return r.map((e, n) => {
    let i = n >= t.args.length ? t.args[t.args.length - 1] : t.args[n];
    return typeof i != "object" && (i = {
      type: i
    }), i.type === xe && e.type === ve ? _l(e) : e;
  });
}
function pc(t, r) {
  return t + ":" + r.args.map((e) => typeof e == "string" ? e : e.type).join("#");
}
function Pn(t, r) {
  return {
    type: Ee,
    value: to(r, !0)
  };
}
function hc(t, r) {
  const e = Number(r.value);
  if (Number.isNaN(e) || !Number.isFinite(e))
    throw new Error("Unable to convert value to Number.");
  if (r.value === "")
    throw new Error("Unable to convert value to Number.");
  return {
    type: xe,
    value: e
  };
}
function G1(t, r) {
  if (r.value > Po || r.value < No)
    throw new Error("Unable to convert value to Integer.");
  const e = r.value - r.value % 1;
  return {
    type: ve,
    value: cn(e)
  };
}
function Y1(t, r) {
  let e;
  try {
    e = cn(r.value);
  } catch {
    throw new Error("Unable to convert value to Integer.");
  }
  return {
    type: ve,
    value: e
  };
}
function q1(t, r) {
  return {
    type: ve,
    value: cn(r.value ? 1 : 0)
  };
}
function J1(t, r) {
  const e = Number(r.value);
  if (e !== 1 && e !== 0)
    throw new Error("Unable to convert value to Boolean.");
  return {
    type: Wr,
    value: e
  };
}
function K1(t, r) {
  if (r.value !== "true" && r.value !== "false")
    throw new Error("Unable to convert value to Boolean.");
  return {
    type: Wr,
    value: r.value === "true" ? 1 : 0
  };
}
function X1(t, r) {
  return {
    type: un,
    value: Li(r.value)
  };
}
function Z1(t, r) {
  return ai(r.value), {
    type: Xn,
    value: r.value
  };
}
function Q1(t, r) {
  try {
    return {
      type: Ee,
      value: encodeURIComponent(r.value)
    };
  } catch {
    throw new Error("Unable to encodeUri string.");
  }
}
function x1(t, r) {
  try {
    return {
      type: Ee,
      value: decodeURIComponent(r.value)
    };
  } catch {
    throw new Error("Unable to decodeUri string.");
  }
}
function Jl(t, r, e, n) {
  const i = t.variables.get(r.value);
  let o;
  return i && i.getType() === n ? (o = i.getValue(), t.storeUsedVars || (t.storeUsedVars = /* @__PURE__ */ new Set()), t.storeUsedVars.add(i)) : o = e.value, n === "color" ? o = Li(o) : n === "url" && ai(o), {
    type: n,
    // value is synced with type by params
    value: o
  };
}
function Ho(t, r, e) {
  return Jl(t, r, e, e.type);
}
function gc(t, r, e) {
  return Jl(t, r, e, "color");
}
function mc(t, r, e) {
  return Jl(t, r, e, "url");
}
function nd(t, r) {
  for (let e = 0; e < r.length; ++e) {
    const n = t.charAt(e), i = r.charAt(e);
    if (n !== i && i)
      return i;
  }
  return "";
}
const ks = 1234567890;
function bc(t) {
  const r = new Intl.NumberFormat(t, {
    maximumFractionDigits: 0
  }), e = new Intl.NumberFormat(t, {
    minimumFractionDigits: 1
  }), n = r.format(ks), i = e.format(ks);
  return nd(n, i);
}
function $1(t) {
  const r = new Intl.NumberFormat(t, {
    useGrouping: !1
  }), e = new Intl.NumberFormat(t, {
    useGrouping: !0
  }), n = r.format(ks), i = e.format(ks);
  return nd(n, i);
}
function Pi(t, r, e, n) {
  const i = e.value, o = i.replace(/,/g, "");
  if (!/^((#+)|(#*0+))(\.0*#*)?$/.test(o) && !/^#*0*\.((0*#*)|(#+))$/.test(o) || /,.*,/.test(i) || i.indexOf(",") > i.indexOf(".") && i.indexOf(".") > -1)
    throw new Error("Incorrect format pattern.");
  const s = i.split("."), a = s[0], l = s[1] || "", u = i.replace(/[^#0.]/g, "").split("."), c = u[0], f = u[1] || "", _ = a.indexOf(","), g = _ > -1 ? a.length - _ - 1 : -1;
  if (_ > -1 && g < 1 || l.indexOf(",") > -1)
    throw new Error("Incorrect format pattern.");
  try {
    let y = 0;
    for (; c[c.length - 1 - y] === "0"; )
      ++y;
    let p = 0;
    for (; f[p] === "0"; )
      ++p;
    let w = p;
    for (; f[w] === "#"; )
      ++w;
    let Q = new Intl.NumberFormat((n == null ? void 0 : n.value) || void 0, {
      useGrouping: !1,
      minimumIntegerDigits: Math.min(Math.max(y, 1), 21),
      minimumFractionDigits: Math.min(Math.max(p, 0), 100),
      maximumFractionDigits: Math.min(Math.max(w, p, 0), 100),
      roundingMode: "halfEven"
    }).format(r.value);
    if (_ > -1 && g > 0) {
      const J = $1(n == null ? void 0 : n.value), M = bc(n == null ? void 0 : n.value);
      if (J && M) {
        const ge = Q.split(M), le = ge[0];
        let H = "";
        for (let ee = le.length - 1; ee >= 0; --ee)
          H = le[ee] + H, ee > 0 && (le.length - ee) % g === 0 && (H = J + H);
        Q = H + (ge.length > 1 ? M + ge[1] : "");
      }
    }
    if (p === 0 && w === 0 && i.endsWith(".")) {
      const J = bc(n == null ? void 0 : n.value);
      J && (Q += J);
    }
    return {
      type: Ee,
      value: Q
    };
  } catch (y) {
    throw new Error("Incorrect or unsupported number format." + y + " " + (n == null ? void 0 : n.value) || void 0);
  }
}
function eb() {
  F("toString", [ve], Pn), F("toString", [xe], Pn), F("toString", [Wr], Pn), F("toString", [un], Pn), F("toString", [Xn], Pn), F("toString", [Ee], Pn), F("toString", [rr], Pn), F("toString", [er], Pn), F("toNumber", [ve], hc), F("toNumber", [Ee], hc), F("toInteger", [xe], G1), F("toInteger", [Ee], Y1), F("toInteger", [Wr], q1), F("toBoolean", [ve], J1), F("toBoolean", [Ee], K1), F("toColor", [Ee], X1), F("toUrl", [Ee], Z1), F("encodeUri", [Ee], Q1), F("decodeUri", [Ee], x1), F("getIntegerValue", [Ee, ve], Ho), F("getNumberValue", [Ee, xe], Ho), F("getBooleanValue", [Ee, Wr], Ho), F("getStringValue", [Ee, Ee], Ho), F("getColorValue", [Ee, un], gc), F("getColorValue", [Ee, Ee], gc), F("getUrlValue", [Ee, Xn], mc), F("getUrlValue", [Ee, Ee], mc), Hr("toString", [ve], Pn), Hr("toString", [xe], Pn), Hr("toString", [Wr], Pn), Hr("toString", [un], Pn), Hr("toString", [Xn], Pn), Hr("toString", [Ee], Pn), Hr("toString", [rr], Pn), Hr("toString", [er], Pn), F("decimalFormat", [ve, Ee], Pi), F("decimalFormat", [xe, Ee], Pi), F("decimalFormat", [ve, Ee, Ee], Pi), F("decimalFormat", [xe, Ee, Ee], Pi), Hr("decimalFormat", [ve, Ee], Pi), Hr("decimalFormat", [xe, Ee], Pi), Hr("decimalFormat", [ve, Ee, Ee], Pi), Hr("decimalFormat", [xe, Ee, Ee], Pi);
}
function Nn(t, r) {
  return !t || !r ? t : t.padStart(r, "0");
}
const wl = {
  G(t, r) {
    let e;
    return t < 4 ? e = "short" : t === 5 ? e = "narrow" : e = "long", r({
      era: e
    }, "era");
  },
  d(t, r) {
    return Nn(r({
      day: "numeric"
    }, "day"), t > 1 ? t : 0);
  },
  D(t, r) {
    return Nn(r({}, "dayofyear"), t > 1 ? t : 0);
  },
  F(t, r) {
    return Nn(r({}, "dayofweekinmonth"), t > 1 ? t : 0);
  },
  M(t, r) {
    let e;
    return t === 1 ? e = "numeric" : t === 2 ? e = "2-digit" : t === 3 ? e = "short" : t === 5 ? e = "narrow" : e = "long", r({
      month: e,
      // to get a genitive case of month
      day: "numeric"
    }, "month");
  },
  y(t, r) {
    return Nn(r({
      year: t === 2 ? "2-digit" : "numeric"
    }, "year"), t > 2 ? t : void 0);
  },
  Y(t, r) {
    return Nn(r({
      year: t === 2 ? "2-digit" : "numeric"
    }, "weekyear"), t > 2 ? t : void 0);
  },
  u(t, r) {
    return Nn(r({
      year: "numeric"
    }, "extendedyear"), t > 1 ? t : void 0);
  },
  E(t, r) {
    let e;
    return t <= 3 ? e = "short" : t === 5 ? e = "narrow" : e = "long", r({
      weekday: e
    }, "weekday");
  },
  e(t, r) {
    return t > 2 ? wl.E(t, r) : Nn(r({}, "weekdaynumeric"), t > 1 ? t : void 0);
  },
  w(t, r) {
    return Nn(r({}, "week"), t > 1 ? t : void 0);
  },
  W(t, r) {
    return Nn(r({}, "weekofmonth"), t > 1 ? t : void 0);
  },
  H(t, r) {
    const e = r({
      hour: "numeric",
      hour12: !1,
      hourCycle: "h23"
    }, "hour");
    if (!e)
      return;
    const n = String(Number(e) % 24);
    return Nn(n, t > 1 ? t : void 0);
  },
  h(t, r) {
    return Nn(r({
      hour: "numeric",
      hour12: !0,
      hourCycle: "h12"
    }, "hour"), t > 1 ? t : void 0);
  },
  K(t, r) {
    const e = r({
      hour: "numeric",
      hour12: !0,
      hourCycle: "h11"
    }, "hour");
    if (!e)
      return;
    const n = String(Number(e) % 12);
    return Nn(n, t > 1 ? t : void 0);
  },
  k(t, r) {
    return Nn(r({
      hour: "numeric",
      hour12: !1,
      hourCycle: "h24"
    }, "hour"), t > 2 ? t : void 0);
  },
  a(t, r) {
    return r({
      hour: "numeric",
      hour12: !0,
      hourCycle: "h11",
      dayPeriod: void 0
    }, "dayPeriod");
  },
  m(t, r) {
    return Nn(r({
      minute: "numeric"
    }, "minute"), t > 1 ? t : void 0);
  },
  s(t, r) {
    return Nn(r({
      second: "numeric"
    }, "second"), t > 1 ? t : void 0);
  },
  S(t, r) {
    const e = r({
      fractionalSecondDigits: Math.min(3, t)
    }, "fractionalSecond");
    return e && t > 3 ? e.padEnd(t, "0") : e;
  },
  z(t, r) {
    return r({
      timeZoneName: t === 4 ? "long" : "short"
    }, "timeZoneName");
  },
  Z(t, r) {
    const e = -Number(r({}, "timezoneoffset")), n = Math.abs(e / 60), i = Math.floor(n) * 100 + (n - Math.floor(n)) * 60;
    return (e >= 0 ? "+" : "-") + Nn(String(i), 4);
  }
}, tb = /(\w)\1*|''|'(''|[^'])+('|$)|./g, rb = /^'([^]*?)'?$/, nb = /''/g, ib = /[a-zA-Z]/, Kl = 1e3 * 60 * 60 * 24;
function ob(t) {
  const r = t.match(rb);
  return r ? r[1].replace(nb, "'") : t;
}
function vl(t, r, e) {
  const n = t[r ? "getUTCDay" : "getDay"](), i = n < e ? e - n - 7 : e - n;
  return new Date(t.getTime() + Kl * i);
}
function yc(t, r, e) {
  const n = new Date(t);
  return n[r ? "setUTCDate" : "setDate"](1), n[r ? "setUTCMonth" : "setMonth"](0), vl(n, r, e);
}
function wc(t, r) {
  return Math.round((t.getTime() - r.getTime()) / Kl);
}
function vc(t, r, e) {
  let n = 0;
  const i = yc(t, r || !1, e), o = new Date(t);
  o[r ? "setUTCFullYear" : "setFullYear"](t[r ? "getUTCFullYear" : "getFullYear"]() + 1);
  const s = yc(o, r || !1, e), a = t.getTime() < i.getTime(), l = t.getTime() >= s.getTime();
  let u = t[r ? "getUTCFullYear" : "getFullYear"]();
  if (a) {
    --u, i[r ? "setUTCFullYear" : "setFullYear"](i[r ? "getUTCFullYear" : "getFullYear"]() - 1);
    const c = wc(vl(t, r, e), i);
    n = Math.round(c / 7) + 1;
  } else if (l)
    ++u, n = 1;
  else {
    const c = wc(vl(t, r, e), i);
    n = Math.round(c / 7) + 1;
  }
  return {
    week: n,
    year: u
  };
}
function sb(t, r, {
  locale: e,
  isUTC: n,
  weekStartDay: i = 0
} = {}) {
  const o = (s, a) => {
    if (a === "week") {
      const { week: c } = vc(t, n || !1, i);
      return String(c);
    }
    if (a === "weekofmonth") {
      const c = t[n ? "getUTCDay" : "getDay"](), f = new Date(t);
      f[n ? "setUTCDate" : "setDate"](1);
      const _ = f[n ? "getUTCDay" : "getDay"](), g = t[n ? "getUTCDate" : "getDate"]();
      return String(Math.ceil(g / 7) + (c < _ ? 1 : 0));
    }
    if (a === "dayofweekinmonth") {
      const c = t[n ? "getUTCDate" : "getDate"]();
      return String(Math.ceil(c / 7));
    }
    if (a === "weekdaynumeric") {
      let c = t[n ? "getUTCDay" : "getDay"]();
      return c < i && (c += 7), String(c - i + 1);
    }
    if (a === "dayofyear") {
      const c = new Date(t);
      c[n ? "setUTCMonth" : "setMonth"](0), c[n ? "setUTCDate" : "setDate"](1), c[n ? "setUTCHours" : "setHours"](1), c[n ? "setUTCMinutes" : "setMinutes"](1), c[n ? "setUTCSeconds" : "setSeconds"](1);
      const f = Math.ceil((t.getTime() - c.getTime()) / Kl);
      return String(f);
    }
    if (a === "weekyear") {
      let { year: c } = vc(t, n || !1, i);
      return c < 1 && (c = 1 - c), s.year === "2-digit" ? String(c % 100) : String(c);
    }
    if (a === "extendedyear") {
      const c = t[n ? "getUTCFullYear" : "getFullYear"]();
      return s.year === "2-digit" ? String(c % 100) : String(c);
    }
    if (a === "timezoneoffset")
      return n ? "0" : String(t.getTimezoneOffset());
    n && (s.timeZone = "UTC");
    const u = new Intl.DateTimeFormat(e, s).formatToParts(t);
    for (let c = 0; c < u.length; ++c)
      if (u[c].type === a)
        return u[c].value;
  };
  return (r.match(tb) || []).map((s) => {
    if (s === "''")
      return "'";
    const a = s[0];
    if (a === "'")
      return ob(s);
    if (wl[a])
      return wl[a](s.length, o);
    if (a.match(ib))
      throw new Error(
        `Format string contains an unescaped latin alphabet character "${a}"`
      );
    return s;
  }).join("");
}
function lb(t) {
  const r = new Date(t);
  return r.setUTCMonth(r.getUTCMonth() + 1), r.setUTCDate(0), r.getUTCDate();
}
function ab(t, r) {
  return {
    type: Sr,
    value: new Date(Number(r.value) * 1e3)
  };
}
function ub(t, r) {
  const e = new Date(Number(r.value) * 1e3), n = e.getTimezoneOffset();
  return e.setMinutes(e.getMinutes() - n), {
    type: Sr,
    value: e
  };
}
function cb() {
  return {
    type: Sr,
    value: /* @__PURE__ */ new Date()
  };
}
function fb(t, r, e) {
  return {
    type: Sr,
    value: new Date(r.value.getTime() + Number(e.value))
  };
}
function db(t, r, e) {
  const n = new Date(r.value);
  return n.setUTCFullYear(Number(e.value)), {
    type: Sr,
    value: n
  };
}
function _b(t, r, e) {
  const n = Number(e.value);
  if (n < 1 || n > 12)
    throw new Error(`Expecting month in [1..12], instead got ${n}.`);
  const i = new Date(r.value);
  return i.setUTCMonth(n - 1), {
    type: Sr,
    value: i
  };
}
function pb(t, r, e) {
  const n = new Date(r.value), i = Number(e.value);
  if (i <= 0 && i !== -1 || i > lb(n))
    throw new Error(`Unable to set day ${i} for date ${to(r, !1)}.`);
  return n.setUTCDate(i === -1 ? 0 : i), {
    type: Sr,
    value: n
  };
}
function hb(t, r, e) {
  const n = Number(e.value);
  if (n < 0 || n > 23)
    throw new Error(`Expecting hours in [0..23], instead got ${n}.`);
  const i = new Date(r.value);
  return i.setUTCHours(n), {
    type: Sr,
    value: i
  };
}
function gb(t, r, e) {
  const n = Number(e.value);
  if (n < 0 || n > 59)
    throw new Error(`Expecting minutes in [0..59], instead got ${n}.`);
  const i = new Date(r.value);
  return i.setUTCMinutes(n), {
    type: Sr,
    value: i
  };
}
function mb(t, r, e) {
  const n = Number(e.value);
  if (n < 0 || n > 59)
    throw new Error(`Expecting seconds in [0..59], instead got ${n}.`);
  const i = new Date(r.value);
  return i.setUTCSeconds(n), {
    type: Sr,
    value: i
  };
}
function bb(t, r, e) {
  const n = Number(e.value);
  if (n < 0 || n > 999)
    throw new Error(`Expecting millis in [0..999], instead got ${n}.`);
  const i = new Date(r.value);
  return i.setUTCMilliseconds(n), {
    type: Sr,
    value: i
  };
}
const Ri = (t) => (r, e) => {
  let i = new Date(e.value.getTime())[t]();
  return t === "getUTCMonth" ? ++i : t === "getUTCDay" && i === 0 && (i = 7), {
    type: ve,
    value: cn(i)
  };
};
function id(t) {
  return (r, e, n, i) => ({
    type: Ee,
    value: sb(e.value, n.value, {
      locale: i == null ? void 0 : i.value,
      isUTC: t,
      weekStartDay: r.weekStartDay
    })
  });
}
const yb = Ri("getUTCFullYear"), wb = Ri("getUTCMonth"), vb = Ri("getUTCDate"), kb = Ri("getUTCDay"), Eb = Ri("getUTCHours"), Ab = Ri("getUTCMinutes"), jb = Ri("getUTCSeconds"), Cb = Ri("getUTCMilliseconds"), kc = id(!1), Ec = id(!0);
function Sb() {
  F("parseUnixTime", [ve], ab), F("parseUnixTimeAsLocal", [ve], ub), F("nowLocal", [], cb), F("addMillis", [Sr, ve], fb), F("setYear", [Sr, ve], db), F("setMonth", [Sr, ve], _b), F("setDay", [Sr, ve], pb), F("setHours", [Sr, ve], hb), F("setMinutes", [Sr, ve], gb), F("setSeconds", [Sr, ve], mb), F("setMillis", [Sr, ve], bb), F("getYear", [Sr], yb), F("getMonth", [Sr], wb), F("getDay", [Sr], vb), F("getDayOfWeek", [Sr], kb), F("getHours", [Sr], Eb), F("getMinutes", [Sr], Ab), F("getSeconds", [Sr], jb), F("getMillis", [Sr], Cb), F("formatDateAsLocal", [Sr, Ee], kc), F("formatDateAsUTC", [Sr, Ee], Ec), F("formatDateAsLocalWithLocale", [Sr, Ee, Ee], kc), F("formatDateAsUTCWithLocale", [Sr, Ee, Ee], Ec);
}
function Vb(t) {
  return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Ib(t, r) {
  return {
    type: ve,
    value: cn(r.value.length)
  };
}
function Db(t, r, e) {
  return {
    type: Wr,
    value: r.value.includes(e.value) ? 1 : 0
  };
}
function Tb(t, r, e, n) {
  if (n.value < e.value)
    throw new Error("Indexes should be in ascending order.");
  if (e.value < 0 || e.value > r.value.length || n.value < 0 || n.value > r.value.length)
    throw new Error("Indexes are out of bounds.");
  return {
    type: Ee,
    value: r.value.substring(Number(e.value), Number(n.value))
  };
}
function Fb(t, r, e, n) {
  let i;
  return e.value ? i = r.value.replace(new RegExp(Vb(e.value), "g"), n.value) : i = r.value, {
    type: Ee,
    value: i
  };
}
function Mb(t, r, e) {
  return {
    type: ve,
    value: cn(r.value.indexOf(e.value))
  };
}
function Pb(t, r, e) {
  return {
    type: ve,
    value: cn(r.value.lastIndexOf(e.value))
  };
}
function Nb(t, r) {
  return {
    type: Ee,
    value: r.value.trim()
  };
}
function zb(t, r) {
  return {
    type: Ee,
    value: r.value.replace(/^\s+/, "")
  };
}
function Ob(t, r) {
  return {
    type: Ee,
    value: r.value.replace(/\s+$/, "")
  };
}
function Lb(t, r) {
  return {
    type: Ee,
    value: r.value.toUpperCase()
  };
}
function Rb(t, r) {
  return {
    type: Ee,
    value: r.value.toLowerCase()
  };
}
function od(t, r, e, n) {
  if (!n.value.length)
    return t.warnings.push(R(new Error("String for padding is empty."), {
      level: "warn"
    })), "";
  let i = "";
  const o = r.type === Ee ? r.value : to(r, !1);
  for (; i.length + o.length < e.value; )
    i += n.value;
  return i.length > 0 && i.length + o.length > e.value && (i = i.substring(0, Number(e.value) - Number(o.length))), i;
}
function Ac(t, r, e, n) {
  const i = od(t, r, e, n);
  return {
    type: Ee,
    value: i + to(r, !1)
  };
}
function jc(t, r, e, n) {
  const i = od(t, r, e, n);
  return {
    type: Ee,
    value: to(r, !1) + i
  };
}
function Bb(t, r, e) {
  let n;
  try {
    n = new RegExp(e.value);
  } catch {
    throw new Error("Invalid regular expression.");
  }
  return {
    type: Wr,
    value: n.test(r.value) ? 1 : 0
  };
}
function Hb(t, r) {
  return {
    type: Ee,
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions#escaping
    value: r.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  };
}
function Wb() {
  F("len", [Ee], Ib), F("contains", [Ee, Ee], Db), F("substring", [Ee, ve, ve], Tb), F("replaceAll", [Ee, Ee, Ee], Fb), F("index", [Ee, Ee], Mb), F("lastIndex", [Ee, Ee], Pb), F("trim", [Ee], Nb), F("trimLeft", [Ee], zb), F("trimRight", [Ee], Ob), F("toUpperCase", [Ee], Lb), F("toLowerCase", [Ee], Rb), F("padStart", [Ee, ve, Ee], Ac), F("padStart", [ve, ve, Ee], Ac), F("padEnd", [Ee, ve, Ee], jc), F("padEnd", [ve, ve, Ee], jc), F("testRegex", [Ee, Ee], Bb), F("encodeRegex", [Ee], Hb);
}
function Ub(t, r, e) {
  if (e.value === $i)
    throw new Error("Division by zero is not supported.");
  let n = r.value / e.value;
  return n = ro(t, n), Ln(t, n), {
    type: ve,
    value: n
  };
}
function Gb(t, r, e) {
  if (e.value === 0)
    throw new Error("Division by zero is not supported.");
  const n = r.value / e.value;
  return {
    type: xe,
    value: n
  };
}
function Yb(t, r, e) {
  if (e.value === $i)
    throw new Error("Division by zero is not supported.");
  let n = r.value % e.value;
  return n = ro(t, n), Ln(t, n), {
    type: ve,
    value: n
  };
}
function qb(t, r, e) {
  if (e.value === 0)
    throw new Error("Division by zero is not supported.");
  const n = r.value % e.value;
  return {
    type: xe,
    value: n
  };
}
function Jb(t, ...r) {
  let e = r.length ? r[0].value : $i;
  for (let n = 1; n < r.length; ++n)
    e *= r[n].value, e = ro(t, e), Ln(t, e);
  return {
    type: ve,
    value: e
  };
}
function Kb(t, ...r) {
  let e = r.length ? r[0].value : 0;
  for (let n = 1; n < r.length; ++n)
    e *= r[n].value;
  return {
    type: xe,
    value: e
  };
}
function Xb(t, ...r) {
  let e = r.length ? r[0].value : $i;
  for (let n = 1; n < r.length; ++n)
    e -= r[n].value, e = ro(t, e), Ln(t, e);
  return {
    type: ve,
    value: e
  };
}
function Zb(t, ...r) {
  let e = r.length ? r[0].value : 0;
  for (let n = 1; n < r.length; ++n)
    e -= r[n].value;
  return {
    type: xe,
    value: e
  };
}
function Qb(t, ...r) {
  let e = $i;
  for (let n = 0; n < r.length; ++n)
    e += r[n].value, e = ro(t, e), Ln(t, e);
  return {
    type: ve,
    value: e
  };
}
function xb(t, ...r) {
  let e = 0;
  for (let n = 0; n < r.length; ++n)
    e += r[n].value;
  return {
    type: xe,
    value: e
  };
}
function $b(t, r) {
  const e = Wf(r.value);
  return Ln(t, e), {
    type: r.type,
    value: e
  };
}
function ey(t, r) {
  const e = Math.abs(r.value);
  return {
    type: xe,
    value: e
  };
}
function ty(t, ...r) {
  if (!r.length)
    throw new Error("Function requires non empty argument list.");
  let e = r[0].value;
  for (let n = 1; n < r.length; ++n)
    r[n].value > e && (e = r[n].value);
  return {
    type: ve,
    value: e
  };
}
function ry(t, ...r) {
  if (!r.length)
    throw new Error("Function requires non empty argument list.");
  return {
    type: xe,
    value: Math.max(...r.map((e) => e.value))
  };
}
function ny(t, ...r) {
  if (!r.length)
    throw new Error("Function requires non empty argument list.");
  let e = r[0].value;
  for (let n = 1; n < r.length; ++n)
    r[n].value < e && (e = r[n].value);
  return {
    type: ve,
    value: e
  };
}
function iy(t, ...r) {
  if (!r.length)
    throw new Error("Function requires non empty argument list.");
  return {
    type: xe,
    value: Math.min(...r.map((e) => e.value))
  };
}
function oy() {
  return {
    type: xe,
    value: G0
  };
}
function sy() {
  return {
    type: xe,
    value: Y0
  };
}
function ly(t) {
  return Ln(t, Po), {
    type: ve,
    value: Po
  };
}
function ay(t) {
  return Ln(t, No), {
    type: ve,
    value: No
  };
}
function uy(t, r) {
  const e = Math.sign(r.value);
  return {
    type: xe,
    // js treats Math.round(-0.5) as 0, which is different to other platforms
    value: e * Math.round(Math.abs(r.value))
  };
}
function cy(t, r) {
  return {
    type: xe,
    value: Math.floor(r.value)
  };
}
function fy(t, r) {
  return {
    type: xe,
    value: Math.ceil(r.value)
  };
}
function dy(t, r) {
  return {
    type: ve,
    value: Uf(r.value)
  };
}
function _y(t, r) {
  return {
    type: xe,
    value: Math.sign(r.value)
  };
}
function py(t, r, e) {
  let n;
  if (e.value === $i)
    n = r.value;
  else if (r.value === $i)
    n = cn(0);
  else {
    const i = Uf(e.value);
    n = Wf(r.value) * i;
  }
  return Ln(t, n), {
    type: ve,
    value: n
  };
}
function hy(t, r, e) {
  let n = Math.sign(e.value);
  n === 0 && (n = Object.is(n, 0) ? 1 : -1);
  const i = Math.abs(r.value) * n;
  return {
    type: xe,
    value: i
  };
}
function gy() {
  F("div", [ve, ve], Ub), F("div", [xe, xe], Gb), F("mod", [ve, ve], Yb), F("mod", [xe, xe], qb), F("mul", [{
    type: ve,
    isVararg: !0
  }], Jb), F("mul", [{
    type: xe,
    isVararg: !0
  }], Kb), F("sub", [{
    type: ve,
    isVararg: !0
  }], Xb), F("sub", [{
    type: xe,
    isVararg: !0
  }], Zb), F("sum", [{
    type: ve,
    isVararg: !0
  }], Qb), F("sum", [{
    type: xe,
    isVararg: !0
  }], xb), F("abs", [ve], $b), F("abs", [xe], ey), F("max", [{
    type: ve,
    isVararg: !0
  }], ty), F("max", [{
    type: xe,
    isVararg: !0
  }], ry), F("min", [{
    type: ve,
    isVararg: !0
  }], ny), F("min", [{
    type: xe,
    isVararg: !0
  }], iy), F("maxNumber", [], oy), F("minNumber", [], sy), F("maxInteger", [], ly), F("minInteger", [], ay), F("round", [xe], uy), F("floor", [xe], cy), F("ceil", [xe], fy), F("signum", [ve], dy), F("signum", [xe], _y), F("copySign", [ve, ve], py), F("copySign", [xe, xe], hy);
}
function Ws(t) {
  return (r, e) => {
    const n = Bs(e.value);
    return {
      type: xe,
      value: n[t] / 255
    };
  };
}
function Us(t) {
  return (r, e, n) => {
    const i = Bs(e.value);
    return i[t] = n.value * 255, {
      type: un,
      value: no(i)
    };
  };
}
const Cc = Ws("a"), Sc = Ws("r"), Vc = Ws("g"), Ic = Ws("b"), Dc = Us("a"), Tc = Us("r"), Fc = Us("g"), Mc = Us("b");
function my(t, r, e, n) {
  const i = {
    a: 255,
    r: r.value * 255,
    g: e.value * 255,
    b: n.value * 255
  };
  return {
    type: un,
    value: no(i)
  };
}
function by(t, r, e, n, i) {
  const o = {
    a: r.value * 255,
    r: e.value * 255,
    g: n.value * 255,
    b: i.value * 255
  };
  return {
    type: un,
    value: no(o)
  };
}
function yy() {
  F("getColorAlpha", [Ee], Cc), F("getColorAlpha", [un], Cc), F("getColorRed", [Ee], Sc), F("getColorRed", [un], Sc), F("getColorGreen", [Ee], Vc), F("getColorGreen", [un], Vc), F("getColorBlue", [Ee], Ic), F("getColorBlue", [un], Ic), F("setColorAlpha", [Ee, xe], Dc), F("setColorAlpha", [un, xe], Dc), F("setColorRed", [Ee, xe], Tc), F("setColorRed", [un, xe], Tc), F("setColorGreen", [Ee, xe], Fc), F("setColorGreen", [un, xe], Fc), F("setColorBlue", [Ee, xe], Mc), F("setColorBlue", [un, xe], Mc), F("rgb", [xe, xe, xe], my), F("argb", [xe, xe, xe, xe], by);
}
function Bi(t, r, e, n) {
  if (r.value < 0)
    throw new Error("Expecting non-negative number of milliseconds.");
  let i = cn(r.value) / cn(e);
  return Ln(t, i), n && (i = cn(i) % cn(n)), {
    type: ve,
    value: i
  };
}
const sd = 1e3, wy = 60, ld = 1e3 * 60, vy = 60, ad = 1e3 * 60 * 60, ky = 24, Ey = 1e3 * 60 * 60 * 24, Ay = 1e3 * 60 * 60 * 24 * 7;
function jy(t, r) {
  return Bi(t, r, sd, wy);
}
function Cy(t, r) {
  return Bi(t, r, sd);
}
function Sy(t, r) {
  return Bi(t, r, ld, vy);
}
function Vy(t, r) {
  return Bi(t, r, ld);
}
function Iy(t, r) {
  return Bi(t, r, ad, ky);
}
function Dy(t, r) {
  return Bi(t, r, ad);
}
function Ty(t, r) {
  return Bi(t, r, Ey);
}
function Fy(t, r) {
  return Bi(t, r, Ay);
}
function My() {
  F("getIntervalSeconds", [ve], jy), F("getIntervalTotalSeconds", [ve], Cy), F("getIntervalMinutes", [ve], Sy), F("getIntervalTotalMinutes", [ve], Vy), F("getIntervalHours", [ve], Iy), F("getIntervalTotalHours", [ve], Dy), F("getIntervalTotalDays", [ve], Ty), F("getIntervalTotalWeeks", [ve], Fy);
}
function Py(t, r) {
  let e = t;
  for (let n = 0; n < r.length; ++n) {
    if (!e)
      throw new Error(`Missing property "${r[n]}" in the dict.`);
    const i = e[r[n]];
    if (i === void 0)
      throw new Error(`Missing property "${r[n]}" in the dict.`);
    e = i;
  }
  return e;
}
function Hi(t) {
  return (r, e, ...n) => {
    if (n.length === 0)
      throw new Error("Non empty argument list is required.");
    const i = Py(e.value, n.map((o) => o.value));
    return Yl(r, i, t);
  };
}
function vo(t, r) {
  return (e, n, i, ...o) => {
    try {
      return t(e, i, ...o);
    } catch {
      let a = n.value;
      return r === "color" ? a = Li(a) : r === "url" && ai(a), {
        type: r,
        value: a
      };
    }
  };
}
const $o = Hi(Ee), es = Hi(xe), ts = Hi(ve), rs = Hi(Wr), ns = Hi(un), is = Hi(Xn), kl = Hi(rr), El = Hi(er), Pc = vo($o, Ee), Nc = vo(es, xe), zc = vo(ts, ve), Oc = vo(rs, Wr), Wo = vo(ns, un), Uo = vo(is, Xn);
function Ny(t, r, ...e) {
  try {
    return kl(t, r, ...e);
  } catch {
    return {
      type: rr,
      value: []
    };
  }
}
function zy(t, r, ...e) {
  try {
    return El(t, r, ...e);
  } catch {
    return {
      type: er,
      value: {}
    };
  }
}
function Oy(t, r, e) {
  return {
    type: Wr,
    value: e.value in r.value ? 1 : 0
  };
}
function Ly(t, r) {
  return {
    type: Wr,
    value: Object.keys(r.value).length ? 0 : 1
  };
}
function Ry(t, r) {
  return {
    type: ve,
    value: cn(Object.keys(r.value).length)
  };
}
function By(t, r) {
  return {
    type: rr,
    value: Object.keys(r.value)
  };
}
function Hy(t, r) {
  return {
    type: rr,
    value: Object.values(r.value)
  };
}
function Wy() {
  const t = {
    type: Ee,
    isVararg: !0
  };
  F("getDictString", [er, t], $o), F("getStringFromDict", [er, t], $o), F("getDictNumber", [er, t], es), F("getNumberFromDict", [er, t], es), F("getDictInteger", [er, t], ts), F("getIntegerFromDict", [er, t], ts), F("getDictBoolean", [er, t], rs), F("getBooleanFromDict", [er, t], rs), F("getDictColor", [er, t], ns), F("getColorFromDict", [er, t], ns), F("getDictUrl", [er, t], is), F("getUrlFromDict", [er, t], is), F("getDictOptString", [Ee, er, t], Pc), F("getOptStringFromDict", [Ee, er, t], Pc), F("getDictOptNumber", [xe, er, t], Nc), F("getOptNumberFromDict", [xe, er, t], Nc), F("getDictOptInteger", [ve, er, t], zc), F("getOptIntegerFromDict", [ve, er, t], zc), F("getDictOptBoolean", [Wr, er, t], Oc), F("getOptBooleanFromDict", [Wr, er, t], Oc), F("getDictOptColor", [un, er, t], Wo), F("getOptColorFromDict", [un, er, t], Wo), F("getDictOptColor", [Ee, er, t], Wo), F("getOptColorFromDict", [Ee, er, t], Wo), F("getDictOptUrl", [Ee, er, t], Uo), F("getOptUrlFromDict", [Ee, er, t], Uo), F("getDictOptUrl", [Xn, er, t], Uo), F("getOptUrlFromDict", [Xn, er, t], Uo), F("getDictFromDict", [er, t], El), F("getArrayFromDict", [er, t], kl), F("getOptArrayFromDict", [er, t], Ny), F("getOptDictFromDict", [er, t], zy), Hr("getString", [er, t], $o), Hr("getBoolean", [er, t], rs), Hr("getInteger", [er, t], ts), Hr("getNumber", [er, t], es), Hr("getUrl", [er, t], is), Hr("getColor", [er, t], ns), Hr("getArray", [er, t], kl), Hr("getDict", [er, t], El), Hr("containsKey", [er, Ee], Oy), Hr("isEmpty", [er], Ly), F("len", [er], Ry), F("getDictKeys", [er], By), F("getDictValues", [er], Hy);
}
function Wi(t, r) {
  return (e, n, i) => {
    if (i.value < 0 || i.value >= n.value.length)
      throw new Error(`Requested index (${i.value}) out of bounds array size (${n.value.length}).`);
    let o = n.value[Number(i.value)], s = typeof o;
    if (t === "array" && !Array.isArray(o) || t !== "array" && s !== t || s === "object" && o === null)
      throw s === "object" && (Array.isArray(o) ? s = "Array" : o === null ? s = "Null" : s = "Dict"), new Error(`Incorrect value type: expected ${qn(r)}, got ${qn(s)}.`);
    if (t === "number" && r === "integer") {
      Ln(e, o);
      try {
        o = cn(o);
      } catch {
        throw new Error("Cannot convert value to integer.");
      }
    }
    return t === "string" && r === "color" && (o = Li(o)), t === "string" && r === "url" && ai(o), {
      type: r,
      value: o
    };
  };
}
function ko(t, r) {
  return (e, n, i, o) => {
    try {
      return t(e, n, i);
    } catch {
      let a = o.value;
      return r === "color" ? a = Li(a) : r === "url" && ai(a), {
        type: r,
        value: a
      };
    }
  };
}
const os = Wi("string", "string"), ss = Wi("number", "number"), ls = Wi("number", "integer"), as = Wi("boolean", "boolean"), us = Wi("string", "color"), cs = Wi("string", "url"), Al = Wi("array", "array"), jl = Wi("object", "dict"), Lc = ko(os, "string"), Rc = ko(ss, "number"), Bc = ko(ls, "integer"), Hc = ko(as, "boolean"), Go = ko(us, "color"), Yo = ko(cs, "url");
function Uy(t, r, e) {
  try {
    return Al(t, r, e);
  } catch {
    return {
      type: rr,
      value: []
    };
  }
}
function Gy(t, r, e) {
  try {
    return jl(t, r, e);
  } catch {
    return {
      type: er,
      value: {}
    };
  }
}
function Yy(t, r) {
  return {
    type: ve,
    value: cn(r.value.length)
  };
}
function qy(t, r) {
  return {
    type: Wr,
    value: r.value.length === 0 ? 1 : 0
  };
}
function Jy() {
  F("getArrayString", [
    rr,
    ve
  ], os), F("getStringFromArray", [
    rr,
    ve
  ], os), F("getArrayNumber", [
    rr,
    ve
  ], ss), F("getNumberFromArray", [
    rr,
    ve
  ], ss), F("getArrayInteger", [
    rr,
    ve
  ], ls), F("getIntegerFromArray", [
    rr,
    ve
  ], ls), F("getArrayBoolean", [
    rr,
    ve
  ], as), F("getBooleanFromArray", [
    rr,
    ve
  ], as), F("getArrayColor", [
    rr,
    ve
  ], us), F("getColorFromArray", [
    rr,
    ve
  ], us), F("getArrayUrl", [
    rr,
    ve
  ], cs), F("getUrlFromArray", [
    rr,
    ve
  ], cs), F("getArrayFromArray", [
    rr,
    ve
  ], Al), F("getDictFromArray", [
    rr,
    ve
  ], jl), F("getArrayOptString", [
    rr,
    ve,
    Ee
  ], Lc), F("getOptStringFromArray", [
    rr,
    ve,
    Ee
  ], Lc), F("getArrayOptNumber", [
    rr,
    ve,
    xe
  ], Rc), F("getOptNumberFromArray", [
    rr,
    ve,
    xe
  ], Rc), F("getArrayOptInteger", [
    rr,
    ve,
    ve
  ], Bc), F("getOptIntegerFromArray", [
    rr,
    ve,
    ve
  ], Bc), F("getArrayOptBoolean", [
    rr,
    ve,
    Wr
  ], Hc), F("getOptBooleanFromArray", [
    rr,
    ve,
    Wr
  ], Hc), F("getArrayOptColor", [
    rr,
    ve,
    un
  ], Go), F("getOptColorFromArray", [
    rr,
    ve,
    un
  ], Go), F("getArrayOptColor", [
    rr,
    ve,
    Ee
  ], Go), F("getOptColorFromArray", [
    rr,
    ve,
    Ee
  ], Go), F("getArrayOptUrl", [
    rr,
    ve,
    Xn
  ], Yo), F("getOptUrlFromArray", [
    rr,
    ve,
    Xn
  ], Yo), F("getArrayOptUrl", [
    rr,
    ve,
    Ee
  ], Yo), F("getOptUrlFromArray", [
    rr,
    ve,
    Ee
  ], Yo), F("getOptArrayFromArray", [
    rr,
    ve
  ], Uy), F("getOptDictFromArray", [
    rr,
    ve
  ], Gy), F("len", [
    rr
  ], Yy), Hr("getString", [rr, ve], os), Hr("getInteger", [rr, ve], ls), Hr("getNumber", [rr, ve], ss), Hr("getBoolean", [rr, ve], as), Hr("getUrl", [rr, ve], cs), Hr("getColor", [rr, ve], us), Hr("getArray", [rr, ve], Al), Hr("getDict", [rr, ve], jl), Hr("isEmpty", [rr], qy);
}
function di(t) {
  return (r, e, n) => {
    if (!r.store) {
      if (!n)
        throw new Error("Missing value.");
      return {
        type: t,
        value: n.value
      };
    }
    let i;
    t === "boolean" ? i = "boolean" : t === "number" || t === "integer" ? i = "number" : i = "string";
    let o;
    if (r.store.get ? o = r.store.get(e.value, t) : r.store.getValue && (o = r.store.getValue(e.value, i)), o === void 0) {
      if (!n)
        throw new Error("Missing value.");
      return t === "url" && ai(n.value), {
        type: t,
        value: n.value
      };
    } else
      t === "url" && ai(o);
    return Yl(r, o, t);
  };
}
function Ky() {
  F("getStoredIntegerValue", [Ee, ve], di(ve)), F("getStoredNumberValue", [Ee, xe], di(xe)), F("getStoredStringValue", [Ee, Ee], di(Ee)), F("getStoredUrlValue", [Ee, Xn], di(Xn)), F("getStoredUrlValue", [Ee, Ee], di(Xn)), F("getStoredColorValue", [Ee, un], di(un)), F("getStoredColorValue", [Ee, Ee], di(un)), F("getStoredBooleanValue", [Ee, Wr], di(Wr)), F("getStoredArrayValue", [Ee], di(rr)), F("getStoredDictValue", [Ee], di(er));
}
function Xy() {
  return {
    type: xe,
    value: Math.PI
  };
}
function Zy(t, r) {
  return {
    type: xe,
    value: r.value / 180 * Math.PI
  };
}
function Qy(t, r) {
  return {
    type: xe,
    value: r.value / Math.PI * 180
  };
}
function xy(t, r) {
  return {
    type: xe,
    value: Math.sin(r.value)
  };
}
function $y(t, r) {
  return {
    type: xe,
    value: Math.cos(r.value)
  };
}
function ew(t, r) {
  return {
    type: xe,
    value: Math.tan(r.value)
  };
}
function tw(t, r) {
  const e = Math.tan(r.value);
  if (Math.abs(e) < 1e-12)
    throw new Error("Cotangent is undefined for the given value.");
  return {
    type: xe,
    value: 1 / e
  };
}
function rw(t, r) {
  return {
    type: xe,
    value: Math.atan(r.value)
  };
}
function nw(t, r, e) {
  return {
    type: xe,
    value: Math.atan2(r.value, e.value)
  };
}
function iw(t, r) {
  if (r.value > 1 || r.value < -1)
    throw new Error("Arcsine is undefined for the given value.");
  return {
    type: xe,
    value: Math.asin(r.value)
  };
}
function ow(t, r) {
  if (r.value > 1 || r.value < -1)
    throw new Error("Arccosine is undefined for the given value.");
  return {
    type: xe,
    value: Math.acos(r.value)
  };
}
function sw() {
  F("pi", [], Xy), F("toRadians", [xe], Zy), F("toDegrees", [xe], Qy), F("sin", [xe], xy), F("cos", [xe], $y), F("tan", [xe], ew), F("cot", [xe], tw), F("atan", [xe], rw), F("atan2", [xe, xe], nw), F("asin", [xe], iw), F("acos", [xe], ow);
}
function lw() {
  eb(), Sb(), My(), Wb(), gy(), yy(), Wy(), Jy(), Ky(), sw();
}
lw();
function aw(t, r) {
  return {
    type: Ee,
    value: r.value
  };
}
function uw(t, r) {
  return {
    type: xe,
    value: r.value
  };
}
function cw(t, r) {
  return Ln(t, r.value), {
    type: ve,
    value: r.value
  };
}
function fw(t, r) {
  return {
    type: Wr,
    value: r.value ? 1 : 0
  };
}
function dw(t, r) {
  const e = ws(Fn(t, r.argument));
  switch (r.operator) {
    case "!":
      if (e.type === Wr)
        return {
          type: Wr,
          value: e.value ? 0 : 1
        };
      sn(`${r.operator}${on(e)}`, "A Boolean is expected after a unary not.");
    case "+":
    case "-":
      const n = r.operator === "+" ? 1 : -1;
      if (e.type === ve) {
        const i = e.value * cn(n);
        return Ln(t, i), {
          type: ve,
          value: i
        };
      } else {
        if (e.type === xe)
          return {
            type: xe,
            value: e.value * n
          };
        sn(
          `${r.operator}${on(e)}`,
          `A Number is expected after a unary ${r.operator === "+" ? "plus" : "minus"}.`
        );
      }
  }
}
function _w(t, r) {
  const e = ws(Fn(t, r.test));
  if (e.type === Wr)
    return e.value ? Fn(t, r.consequent) : Fn(t, r.alternate);
  sn(
    `${on(e)} ? ${on(Fn(t, r.consequent))} : ${on(Fn(t, r.alternate))}`,
    "Ternary must be called with a Boolean value as a condition."
  );
}
function pw(t, r) {
  try {
    return Fn(t, r.test);
  } catch {
    return Fn(t, r.alternate);
  }
}
function hw(t, r) {
  let e = "";
  if (r.quasis.length === 2 && r.quasis[0].value === "" && r.quasis[1].value === "")
    return Fn(t, r.expressions[0]);
  for (let n = 0; n < r.expressions.length; ++n)
    e += r.quasis[n].value, e += to(Fn(t, r.expressions[n]), !0);
  return e += r.quasis[r.quasis.length - 1].value, {
    type: Ee,
    value: e
  };
}
function gw(t, r) {
  const e = ws(Fn(t, r.left));
  if (e.type !== Wr && sn(
    `${on(e)} ${r.operator} ...`,
    `'${r.operator}' must be called with boolean operands.`
  ), r.operator === "||" && e.value)
    return e;
  if (r.operator === "&&" && !e.value)
    return {
      type: Wr,
      value: 0
    };
  const n = ws(Fn(t, r.right));
  return n.type !== Wr && sn(
    `${on(e)} ${r.operator} ${on(n)}`,
    `Operator '${r.operator}' cannot be applied to different types: Boolean and ${qn(n.type)}.`
  ), {
    type: Wr,
    value: n.value
  };
}
function mw(t, r, e) {
  let n;
  return r.type === Sr && e.type === Sr ? n = r.value.getTime() === e.value.getTime() : n = r.value === e.value, t === "!=" && (n = !n), {
    type: Wr,
    value: n ? 1 : 0
  };
}
function bw(t, r, e) {
  (r.type !== xe && r.type !== ve && r.type !== Sr || e.type !== xe && e.type !== ve && e.type !== Sr) && sn(
    `${on(r)} ${t} ${on(e)}`,
    `Operator '${t}' cannot be applied to ${qn(r.type)} type.`
  );
  let n;
  const i = r.type === Sr ? r.value.getTime() : r.value, o = e.type === Sr ? e.value.getTime() : e.value;
  return t === ">" ? n = i > o : t === ">=" ? n = i >= o : t === "<" ? n = i < o : n = i <= o, {
    type: Wr,
    value: n ? 1 : 0
  };
}
function yw(t, r, e, n) {
  if (e.type !== Ee && e.type !== xe && e.type !== ve && sn(
    `${on(e)} ${r} ${on(n)}`,
    `Operator '${r}' cannot be applied to ${qn(e.type)} type.`
  ), e.type === Ee)
    return r === "-" && sn(
      `${on(e)} - ${on(n)}`,
      `Operator '${r}' cannot be applied to ${qn(e.type)} type.`
    ), {
      type: Ee,
      value: e.value + n.value
    };
  let i = r === "+" ? e.value + n.value : e.value - n.value;
  if (e.type === ve)
    try {
      i = ro(t, i), Ln(t, i);
    } catch (o) {
      sn(
        `${on(e)} ${r} ${on(n)}`,
        o.message
      );
    }
  return {
    type: e.type,
    value: i
  };
}
function ww(t, r, e, n) {
  e.type !== ve && e.type !== xe && sn(
    `${on(e)} ${r} ${on(n)}`,
    `Operator '${r}' cannot be applied to ${qn(e.type)} type.`
  );
  let i;
  if (r === "*")
    i = e.value * n.value;
  else if (r === "/" || r === "%")
    Number(n.value) === 0 && sn(
      `${on(e)} ${r} ${on(n)}`,
      "Division by zero is not supported."
    ), r === "/" ? i = e.value / n.value : i = e.value % n.value;
  else
    throw new Error(`Unsupported operation ${r}`);
  if (e.type === ve)
    try {
      i = ro(t, i), Ln(t, i);
    } catch (o) {
      sn(
        `${on(e)} ${r} ${on(n)}`,
        o.message
      );
    }
  return {
    type: e.type,
    value: i
  };
}
function vw(t, r) {
  const e = r.operator;
  let n = Fn(t, r.left), i = Fn(t, r.right);
  if ((n.type === "number" && i.type === "integer" || n.type === "integer" && i.type === "number") && (n.type === "integer" ? n = _l(n) : i.type === "integer" && (i = _l(i))), n.type !== i.type && sn(
    `${on(n)} ${r.operator} ${on(i)}`,
    `Operator '${e}' cannot be applied to different types: ${qn(n.type)} and ${qn(i.type)}.`
  ), e === "==" || e === "!=")
    return mw(e, n, i);
  if (e === ">" || e === ">=" || e === "<" || e === "<=")
    return bw(e, n, i);
  if (e === "+" || e === "-")
    return yw(t, e, n, i);
  if (e === "/" || e === "*" || e === "%")
    return ww(t, e, n, i);
  throw new Error(`Unsupported operation ${e}`);
}
function Es(t) {
  return t.map(on).join(", ");
}
function kw(t, r) {
  const e = r.callee.name;
  let n, i = r.arguments.map((a) => Fn(t, a));
  const o = e + ":" + i.map((a) => a.type).join("#");
  let s;
  if (t.customFunctions && (s = yl(t.customFunctions, e, i)), !s || !("func" in s))
    if (ml.has(o))
      s = {
        func: ml.get(o),
        conversions: 0
      };
    else {
      const a = yl(Qo, e, i);
      ("func" in a || !s) && (s = a);
    }
  if (s && (("expected" in s || "type" in s && s.type === "missing") && Ew(e, i, s), n = s.func, s.conversions && (i = rd(n, i))), !n)
    throw new Error("Function not found");
  try {
    return n.cb(t, ...i);
  } catch (a) {
    const l = `${e}(${Es(i)})`;
    sn(l, a.message);
  }
}
function Ew(t, r, e) {
  const n = r.map((o) => qn(o.type)).join(", "), i = `${t}(${Es(r)})`;
  if (e.type === "few" && r.length === 0 && e.hasOverloads)
    sn(i, "Function requires non empty argument list.");
  else if (e.type === "many" || e.type === "few" || e.type === "mismatch")
    if (e.hasOverloads)
      sn(i, `Function has no matching overload for given argument types: ${n}.`);
    else if (e.type === "many" || e.type === "few")
      e.def.args.some((o) => typeof o == "object" && o.isVararg) ? sn(i, `At least ${e.def.args.length} argument(s) expected.`) : sn(i, `Exactly ${e.def.args.length} argument(s) expected.`);
    else {
      const o = e.def.args.map((s) => qn(typeof s == "string" ? s : s.type)).join(", ");
      sn(i, `Invalid argument type: expected ${o}, got ${n}.`);
    }
  else
    sn(i, `Unknown function name: ${t}.`);
}
function Aw(t, r) {
  const e = r.method.name;
  let n, i = [r.object, ...r.arguments].map((s) => Fn(t, s));
  const o = e + ":" + i.map((s) => s.type).join("#");
  if (bl.has(o))
    n = bl.get(o);
  else {
    const s = yl(xo, e, i);
    if ("expected" in s || "type" in s && s.type === "missing") {
      const a = i.slice(1).map((u) => qn(u.type)).join(", "), l = `${e}(${Es(i.slice(1))})`;
      s.type === "few" && i.length === 1 ? sn(l, "Method requires non empty argument list.") : s.type === "many" ? sn(l, `Method has no matching overload for given argument types: ${a}.`) : s.type === "few" || s.type === "mismatch" ? sn(l, `Method has no matching overload for given argument types: ${a}.`) : sn(l, `Unknown method name: ${e}.`);
    }
    n = s.func, s.conversions && (i = rd(n, i));
  }
  if (!n)
    throw new Error("Method not found");
  try {
    return n.cb(t, ...i);
  } catch (s) {
    const a = `${e}(${Es(i.slice(1))})`;
    sn(a, s.message);
  }
}
function jw(t, r) {
  const e = r.id.name, n = t.variables.get(e);
  if (n)
    return sm(n);
  throw new Error(`Variable '${e}' is missing.`);
}
const Wc = {
  StringLiteral: aw,
  NumberLiteral: uw,
  IntegerLiteral: cw,
  BooleanLiteral: fw,
  UnaryExpression: dw,
  ConditionalExpression: _w,
  TryExpression: pw,
  TemplateLiteral: hw,
  LogicalExpression: gw,
  BinaryExpression: vw,
  CallExpression: kw,
  MethodExpression: Aw,
  Variable: jw
};
function Fn(t, r) {
  if (r.type in Wc)
    return Wc[r.type](t, r);
  throw new Error("Unsupported expression");
}
function Xl(t, r, e, n, i) {
  try {
    const o = {
      variables: t,
      customFunctions: r,
      warnings: [],
      store: e,
      weekStartDay: (i == null ? void 0 : i.weekStartDay) || 0
    };
    return {
      result: Fn(o, n),
      warnings: o.warnings,
      usedVars: o.storeUsedVars
    };
  } catch (o) {
    return {
      result: {
        type: "error",
        value: o.message
      },
      warnings: []
    };
  }
}
function Cw(t, r) {
  return r && r[3] && r[7] ? { type: "ConditionalExpression", test: t, consequent: r[3], alternate: r[7] } : t;
}
function Sw(t, r) {
  return r && r[3] ? { type: "TryExpression", test: t, alternate: r[3] } : t;
}
function qo(t, r) {
  return r.length ? r.reduce((e, n) => ({
    type: "BinaryExpression",
    operator: n[1],
    left: e,
    right: n[3]
  }), t) : t;
}
function Uc(t, r) {
  return r.length ? r.reduce((e, n) => ({
    type: "LogicalExpression",
    operator: n[1],
    left: e,
    right: n[3]
  }), t) : t;
}
function Vw(t, r) {
  return r.length ? r.reduce((e, n) => {
    if (!n[5])
      throw new Error("Method expected after .");
    return {
      type: "MethodExpression",
      object: e,
      method: n[3],
      arguments: n[5][2]
    };
  }, t) : t;
}
function Iw(t) {
  return t === "true" || t === "false" ? { type: "BooleanLiteral", value: t === "true" } : { type: "Variable", id: { type: "Identifier", name: t } };
}
function Gc(t) {
  if (t.every((e) => typeof e == "string"))
    return { type: "StringLiteral", value: t.join("") };
  let r = t.reduce((e, n) => (typeof n == "string" && typeof e[e.length - 1] == "string" ? e[e.length - 1] += n : e.push(n), e), []).reduce((e, n) => (typeof n == "string" ? e.quasis.push({ type: "StringLiteral", value: n }) : (e.quasis.length === e.expressions.length && e.quasis.push({ type: "StringLiteral", value: "" }), e.expressions.push(n)), e), {
    type: "TemplateLiteral",
    quasis: [],
    expressions: []
  });
  return r.quasis.length === r.expressions.length && r.quasis.push({ type: "StringLiteral", value: "" }), r;
}
function Dw(t) {
  try {
    return cn(t);
  } catch {
    throw new Error(`Value ${t} can't be converted to Integer type.`);
  }
}
function Yc(t) {
  if (t === "'" || t === "\\")
    return t;
  throw new Error("Incorrect string escape");
}
function Tw(t, r) {
  function e() {
    this.constructor = t;
  }
  e.prototype = r.prototype, t.prototype = new e();
}
function go(t, r, e, n) {
  var i = Error.call(this, t);
  return Object.setPrototypeOf && Object.setPrototypeOf(i, go.prototype), i.expected = r, i.found = e, i.location = n, i.name = "SyntaxError", i;
}
Tw(go, Error);
function il(t, r, e) {
  return e = e || " ", t.length > r ? t : (r -= t.length, e += e.repeat(r), t + e.slice(0, r));
}
go.prototype.format = function(t) {
  var r = "Error: " + this.message;
  if (this.location) {
    var e = null, n;
    for (n = 0; n < t.length; n++)
      if (t[n].source === this.location.source) {
        e = t[n].text.split(/\r\n|\n|\r/g);
        break;
      }
    var i = this.location.start, o = this.location.source && typeof this.location.source.offset == "function" ? this.location.source.offset(i) : i, s = this.location.source + ":" + o.line + ":" + o.column;
    if (e) {
      var a = this.location.end, l = il("", o.line.toString().length, " "), u = e[i.line - 1], c = i.line === a.line ? a.column : u.length + 1, f = c - i.column || 1;
      r += `
 --> ` + s + `
` + l + ` |
` + o.line + " | " + u + `
` + l + " | " + il("", i.column - 1, " ") + il("", f, "^");
    } else
      r += `
 at ` + s;
  }
  return r;
};
go.buildMessage = function(t, r) {
  var e = {
    literal: function(u) {
      return '"' + i(u.text) + '"';
    },
    class: function(u) {
      var c = u.parts.map(function(f) {
        return Array.isArray(f) ? o(f[0]) + "-" + o(f[1]) : o(f);
      });
      return "[" + (u.inverted ? "^" : "") + c.join("") + "]";
    },
    any: function() {
      return "any character";
    },
    end: function() {
      return "end of input";
    },
    other: function(u) {
      return u.description;
    }
  };
  function n(u) {
    return u.charCodeAt(0).toString(16).toUpperCase();
  }
  function i(u) {
    return u.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(c) {
      return "\\x0" + n(c);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(c) {
      return "\\x" + n(c);
    });
  }
  function o(u) {
    return u.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(c) {
      return "\\x0" + n(c);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(c) {
      return "\\x" + n(c);
    });
  }
  function s(u) {
    return e[u.type](u);
  }
  function a(u) {
    var c = u.map(s), f, _;
    if (c.sort(), c.length > 0) {
      for (f = 1, _ = 1; f < c.length; f++)
        c[f - 1] !== c[f] && (c[_] = c[f], _++);
      c.length = _;
    }
    switch (c.length) {
      case 1:
        return c[0];
      case 2:
        return c[0] + " or " + c[1];
      default:
        return c.slice(0, -1).join(", ") + ", or " + c[c.length - 1];
    }
  }
  function l(u) {
    return u ? '"' + i(u) + '"' : "end of input";
  }
  return "Expected " + a(t) + " but " + l(r) + " found.";
};
function ud(t, r) {
  r = r !== void 0 ? r : {};
  var e = {}, n = r.grammarSource, i = { start: Lr, JsonStringContents: pn }, o = Lr, s = "@{", a = "}", l = "@{}", u = "\\", c = "?", f = ":", _ = "!:", g = "||", y = "&&", p = "==", w = "!=", E = ">=", Q = ">", J = "<=", M = "<", ge = "+", le = "-", H = "/", ee = "*", X = "%", I = "!", P = ".", O = "(", U = ")", me = ",", nt = "'", _e = "e", Me = "E", tt = /^[^}]/, We = /^[^'}]/, Ne = /^[0-9]/, Ft = /^[a-zA-Z_]/, Ve = /^[a-zA-Z_0-9]/, Oe = /^[ \t\r\n]/, Pe = lt("@{", !1), yt = lt("}", !1), ye = lt("@{}", !1), Ke = lt("\\", !1), je = sr(), te = Dt(["}"], !0, !1), ot = lt("?", !1), ce = lt(":", !1), pt = lt("!:", !1), Ct = lt("||", !1), re = lt("&&", !1), $ = lt("==", !1), pe = lt("!=", !1), Bt = lt(">=", !1), De = lt(">", !1), ft = lt("<=", !1), Mt = lt("<", !1), He = lt("+", !1), ht = lt("-", !1), qt = lt("/", !1), fe = lt("*", !1), Vt = lt("%", !1), be = lt("!", !1), $e = lt(".", !1), Ce = lt("(", !1), Xe = lt(")", !1), Jt = lt(",", !1), bt = qr("string"), Qt = lt("'", !1), rt = Dt(["'", "}"], !0, !1), ir = qr("integer"), W = Dt([["0", "9"]], !1, !1), Et = qr("number"), It = lt("e", !1), Ye = lt("E", !1), L = Dt([["a", "z"], ["A", "Z"], "_"], !1, !1), Le = Dt([["a", "z"], ["A", "Z"], "_", ["0", "9"]], !1, !1), gt = qr("whitespace"), qe = Dt([" ", "	", "\r", `
`], !1, !1), Te = function(h) {
    return h;
  }, cr = function(h) {
    return Gc(h);
  }, ke = function(h) {
    return h;
  }, hr = function() {
    return "";
  }, ie = function() {
    return mt();
  }, ze = function() {
    throw new Error("Error tokenizing '" + t + "'.");
  }, Ot = function() {
    throw new Error("Error tokenizing '" + t + "'.");
  }, Yt = function(h) {
    return h;
  }, Ht = function(h) {
    return Yc(h);
  }, wt = function() {
    throw new Error("Error tokenizing '" + t + "'.");
  }, Wt = function(h, A) {
    return Cw(h, A);
  }, Lt = function(h, A) {
    return Sw(h, A);
  }, Gt = function(h, A) {
    return Uc(h, A);
  }, tr = function(h, A) {
    return Uc(h, A);
  }, or = function(h, A) {
    return qo(h, A);
  }, mr = function(h, A) {
    return qo(h, A);
  }, zt = function(h, A) {
    return qo(h, A);
  }, Ut = function(h, A) {
    return qo(h, A);
  }, st = function(h) {
    return h;
  }, et = function(h) {
    return h;
  }, nr = function(h, A) {
    return { type: "UnaryExpression", operator: h, argument: A };
  }, Ar = function() {
    throw new Error("Incorrect unary operator");
  }, br = function(h, A) {
    return Vw(h, A);
  }, yr = function(h, A) {
    return { type: "CallExpression", callee: h, arguments: A };
  }, jr = function(h, A) {
    return [h, ...A];
  }, kr = function(h) {
    return h;
  }, Ir = function(h) {
    return h;
  }, gr = function(h) {
    return Gc(h);
  }, Er = function(h) {
    return h;
  }, Ze = function() {
    return "";
  }, ne = function() {
    return mt();
  }, we = function() {
    throw new Error("Error tokenizing '" + t + "'.");
  }, it = function() {
    throw new Error("Error tokenizing '" + t + "'.");
  }, ut = function(h) {
    return h;
  }, dt = function(h) {
    return Yc(h);
  }, Cr = function() {
    throw new Error("Error tokenizing '" + t + "'.");
  }, vt = function() {
    return { type: "IntegerLiteral", value: Dw(mt()) };
  }, v = function() {
    return { type: "NumberLiteral", value: parseFloat(mt()) };
  }, V = function() {
    return { type: "NumberLiteral", value: parseFloat(mt()) };
  }, Y = function() {
    const h = mt();
    if (/\.\./.test(h) || /\.$/.test(h))
      throw new Error("Unexpected token: .");
    return Iw(h);
  }, he = function() {
    return { type: "Identifier", name: mt() };
  }, d = 0, G = 0, Ie = [{ line: 1, column: 1 }], Je = 0, ar = [], C = 0, Qe;
  if ("startRule" in r) {
    if (!(r.startRule in i))
      throw new Error(`Can't start parsing from rule "` + r.startRule + '".');
    o = i[r.startRule];
  }
  function mt() {
    return t.substring(G, d);
  }
  function lt(h, A) {
    return { type: "literal", text: h, ignoreCase: A };
  }
  function Dt(h, A, z) {
    return { type: "class", parts: h, inverted: A, ignoreCase: z };
  }
  function sr() {
    return { type: "any" };
  }
  function Yr() {
    return { type: "end" };
  }
  function qr(h) {
    return { type: "other", description: h };
  }
  function Ur(h) {
    var A = Ie[h], z;
    if (A)
      return A;
    for (z = h - 1; !Ie[z]; )
      z--;
    for (A = Ie[z], A = {
      line: A.line,
      column: A.column
    }; z < h; )
      t.charCodeAt(z) === 10 ? (A.line++, A.column = 1) : A.column++, z++;
    return Ie[h] = A, A;
  }
  function Vn(h, A, z) {
    var S = Ur(h), oe = Ur(A), se = {
      source: n,
      start: {
        offset: h,
        line: S.line,
        column: S.column
      },
      end: {
        offset: A,
        line: oe.line,
        column: oe.column
      }
    };
    return se;
  }
  function ue(h) {
    d < Je || (d > Je && (Je = d, ar = []), ar.push(h));
  }
  function ln(h, A, z) {
    return new go(
      go.buildMessage(h, A),
      h,
      A,
      z
    );
  }
  function Lr() {
    var h, A;
    return h = d, St(), A = b(), A !== e ? (St(), G = h, h = Te(A)) : (d = h, h = e), h;
  }
  function pn() {
    var h, A, z;
    for (h = d, A = [], z = Cn(); z !== e; )
      A.push(z), z = Cn();
    return G = h, A = cr(A), h = A, h;
  }
  function Cn() {
    var h, A, z, S, oe;
    if (h = d, t.substr(d, 2) === s ? (A = s, d += 2) : (A = e, C === 0 && ue(Pe)), A !== e ? (z = St(), S = b(), S !== e ? (St(), t.charCodeAt(d) === 125 ? (oe = a, d++) : (oe = e, C === 0 && ue(yt)), oe !== e ? (G = h, h = ke(S)) : (d = h, h = e)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, t.substr(d, 3) === l ? (A = l, d += 3) : (A = e, C === 0 && ue(ye)), A !== e && (G = h, A = hr()), h = A, h === e && (h = d, A = d, C++, t.charCodeAt(d) === 92 ? (z = u, d++) : (z = e, C === 0 && ue(Ke)), z === e && (t.substr(d, 2) === s ? (z = s, d += 2) : (z = e, C === 0 && ue(Pe))), C--, z === e ? A = void 0 : (d = A, A = e), A !== e ? (t.length > d ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(je)), z !== e ? (G = h, h = ie()) : (d = h, h = e)) : (d = h, h = e), h === e))) {
      if (h = d, t.substr(d, 2) === s ? (A = s, d += 2) : (A = e, C === 0 && ue(Pe)), A !== e) {
        if (z = [], tt.test(t.charAt(d)) ? (S = t.charAt(d), d++) : (S = e, C === 0 && ue(te)), S !== e)
          for (; S !== e; )
            z.push(S), tt.test(t.charAt(d)) ? (S = t.charAt(d), d++) : (S = e, C === 0 && ue(te));
        else
          z = e;
        z !== e ? (t.charCodeAt(d) === 125 ? (S = a, d++) : (S = e, C === 0 && ue(yt)), S !== e ? (G = h, h = ze()) : (d = h, h = e)) : (d = h, h = e);
      } else
        d = h, h = e;
      h === e && (h = d, t.substr(d, 2) === s ? (A = s, d += 2) : (A = e, C === 0 && ue(Pe)), A !== e && (G = h, A = Ot()), h = A, h === e && (h = d, t.charCodeAt(d) === 92 ? (A = u, d++) : (A = e, C === 0 && ue(Ke)), A !== e ? (t.substr(d, 2) === s ? (z = s, d += 2) : (z = e, C === 0 && ue(Pe)), z !== e ? (G = h, h = Yt(z)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, t.charCodeAt(d) === 92 ? (A = u, d++) : (A = e, C === 0 && ue(Ke)), A !== e ? (t.length > d ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(je)), z !== e ? (G = h, h = Ht(z)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, t.charCodeAt(d) === 92 ? (A = u, d++) : (A = e, C === 0 && ue(Ke)), A !== e && (G = h, A = wt()), h = A))));
    }
    return h;
  }
  function b() {
    var h, A, z, S, oe, se, At, kt, Zr, Dr, Jr;
    return h = d, A = k(), A !== e ? (z = d, S = St(), t.charCodeAt(d) === 63 ? (oe = c, d++) : (oe = e, C === 0 && ue(ot)), oe !== e ? (se = St(), At = b(), At !== e ? (kt = St(), t.charCodeAt(d) === 58 ? (Zr = f, d++) : (Zr = e, C === 0 && ue(ce)), Zr !== e ? (Dr = St(), Jr = b(), Jr !== e ? (S = [S, oe, se, At, kt, Zr, Dr, Jr], z = S) : (d = z, z = e)) : (d = z, z = e)) : (d = z, z = e)) : (d = z, z = e), z === e && (z = null), G = h, h = Wt(A, z)) : (d = h, h = e), h;
  }
  function k() {
    var h, A, z, S, oe, se, At;
    return h = d, A = j(), A !== e ? (z = d, S = St(), t.substr(d, 2) === _ ? (oe = _, d += 2) : (oe = e, C === 0 && ue(pt)), oe !== e ? (se = St(), At = b(), At !== e ? (S = [S, oe, se, At], z = S) : (d = z, z = e)) : (d = z, z = e), z === e && (z = null), G = h, h = Lt(A, z)) : (d = h, h = e), h;
  }
  function j() {
    var h, A, z, S, oe, se, At, kt;
    if (h = d, A = N(), A !== e) {
      for (z = [], S = d, oe = St(), t.substr(d, 2) === g ? (se = g, d += 2) : (se = e, C === 0 && ue(Ct)), se !== e ? (At = St(), kt = N(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, oe = St(), t.substr(d, 2) === g ? (se = g, d += 2) : (se = e, C === 0 && ue(Ct)), se !== e ? (At = St(), kt = N(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e);
      G = h, h = Gt(A, z);
    } else
      d = h, h = e;
    return h;
  }
  function N() {
    var h, A, z, S, oe, se, At, kt;
    if (h = d, A = D(), A !== e) {
      for (z = [], S = d, oe = St(), t.substr(d, 2) === y ? (se = y, d += 2) : (se = e, C === 0 && ue(re)), se !== e ? (At = St(), kt = D(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, oe = St(), t.substr(d, 2) === y ? (se = y, d += 2) : (se = e, C === 0 && ue(re)), se !== e ? (At = St(), kt = D(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e);
      G = h, h = tr(A, z);
    } else
      d = h, h = e;
    return h;
  }
  function D() {
    var h, A, z, S, oe, se, At, kt;
    if (h = d, A = Ue(), A !== e) {
      for (z = [], S = d, oe = St(), t.substr(d, 2) === p ? (se = p, d += 2) : (se = e, C === 0 && ue($)), se === e && (t.substr(d, 2) === w ? (se = w, d += 2) : (se = e, C === 0 && ue(pe))), se !== e ? (At = St(), kt = Ue(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, oe = St(), t.substr(d, 2) === p ? (se = p, d += 2) : (se = e, C === 0 && ue($)), se === e && (t.substr(d, 2) === w ? (se = w, d += 2) : (se = e, C === 0 && ue(pe))), se !== e ? (At = St(), kt = Ue(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e);
      G = h, h = or(A, z);
    } else
      d = h, h = e;
    return h;
  }
  function Ue() {
    var h, A, z, S, oe, se, At, kt;
    if (h = d, A = de(), A !== e) {
      for (z = [], S = d, oe = St(), t.substr(d, 2) === E ? (se = E, d += 2) : (se = e, C === 0 && ue(Bt)), se === e && (t.charCodeAt(d) === 62 ? (se = Q, d++) : (se = e, C === 0 && ue(De)), se === e && (t.substr(d, 2) === J ? (se = J, d += 2) : (se = e, C === 0 && ue(ft)), se === e && (t.charCodeAt(d) === 60 ? (se = M, d++) : (se = e, C === 0 && ue(Mt))))), se !== e ? (At = St(), kt = de(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, oe = St(), t.substr(d, 2) === E ? (se = E, d += 2) : (se = e, C === 0 && ue(Bt)), se === e && (t.charCodeAt(d) === 62 ? (se = Q, d++) : (se = e, C === 0 && ue(De)), se === e && (t.substr(d, 2) === J ? (se = J, d += 2) : (se = e, C === 0 && ue(ft)), se === e && (t.charCodeAt(d) === 60 ? (se = M, d++) : (se = e, C === 0 && ue(Mt))))), se !== e ? (At = St(), kt = de(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e);
      G = h, h = mr(A, z);
    } else
      d = h, h = e;
    return h;
  }
  function de() {
    var h, A, z, S, oe, se, At, kt;
    if (h = d, A = _t(), A !== e) {
      for (z = [], S = d, oe = St(), t.charCodeAt(d) === 43 ? (se = ge, d++) : (se = e, C === 0 && ue(He)), se === e && (t.charCodeAt(d) === 45 ? (se = le, d++) : (se = e, C === 0 && ue(ht))), se !== e ? (At = St(), kt = _t(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, oe = St(), t.charCodeAt(d) === 43 ? (se = ge, d++) : (se = e, C === 0 && ue(He)), se === e && (t.charCodeAt(d) === 45 ? (se = le, d++) : (se = e, C === 0 && ue(ht))), se !== e ? (At = St(), kt = _t(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e);
      G = h, h = zt(A, z);
    } else
      d = h, h = e;
    return h;
  }
  function _t() {
    var h, A, z, S, oe, se, At, kt;
    if (h = d, A = at(), A !== e) {
      for (z = [], S = d, oe = St(), t.charCodeAt(d) === 47 ? (se = H, d++) : (se = e, C === 0 && ue(qt)), se === e && (t.charCodeAt(d) === 42 ? (se = ee, d++) : (se = e, C === 0 && ue(fe)), se === e && (t.charCodeAt(d) === 37 ? (se = X, d++) : (se = e, C === 0 && ue(Vt)))), se !== e ? (At = St(), kt = at(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, oe = St(), t.charCodeAt(d) === 47 ? (se = H, d++) : (se = e, C === 0 && ue(qt)), se === e && (t.charCodeAt(d) === 42 ? (se = ee, d++) : (se = e, C === 0 && ue(fe)), se === e && (t.charCodeAt(d) === 37 ? (se = X, d++) : (se = e, C === 0 && ue(Vt)))), se !== e ? (At = St(), kt = at(), kt !== e ? (oe = [oe, se, At, kt], S = oe) : (d = S, S = e)) : (d = S, S = e);
      G = h, h = Ut(A, z);
    } else
      d = h, h = e;
    return h;
  }
  function at() {
    var h, A, z, S;
    return h = d, A = d, C++, t.charCodeAt(d) === 45 ? (z = le, d++) : (z = e, C === 0 && ue(ht)), C--, z !== e ? (d = A, A = void 0) : A = e, A !== e ? (z = ri(), z !== e ? (G = h, h = st(z)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, A = d, C++, t.charCodeAt(d) === 45 ? (z = le, d++) : (z = e, C === 0 && ue(ht)), C--, z !== e ? (d = A, A = void 0) : A = e, A !== e ? (z = yn(), z !== e ? (G = h, h = et(z)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, t.charCodeAt(d) === 33 ? (A = I, d++) : (A = e, C === 0 && ue(be)), A === e && (t.charCodeAt(d) === 43 ? (A = ge, d++) : (A = e, C === 0 && ue(He)), A === e && (t.charCodeAt(d) === 45 ? (A = le, d++) : (A = e, C === 0 && ue(ht)))), A !== e ? (z = St(), S = Se(), S === e && (S = Pt()), S !== e ? (G = h, h = nr(A, S)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = Pt()))), h;
  }
  function Se() {
    var h, A;
    return h = d, t.charCodeAt(d) === 43 ? (A = ge, d++) : (A = e, C === 0 && ue(He)), A === e && (t.charCodeAt(d) === 45 ? (A = le, d++) : (A = e, C === 0 && ue(ht))), A !== e && (G = h, A = Ar()), h = A, h;
  }
  function Pt() {
    var h, A, z, S, oe, se, At, kt, Zr, Dr, Jr, Ei, fi, Ae, xt;
    if (h = d, A = ct(), A !== e) {
      for (z = [], S = d, oe = St(), t.charCodeAt(d) === 46 ? (se = P, d++) : (se = e, C === 0 && ue($e)), se !== e ? (At = St(), kt = In(), kt !== e ? (Zr = St(), Dr = d, t.charCodeAt(d) === 40 ? (Jr = O, d++) : (Jr = e, C === 0 && ue(Ce)), Jr !== e ? (Ei = St(), fi = fr(), fi !== e ? (Ae = St(), t.charCodeAt(d) === 41 ? (xt = U, d++) : (xt = e, C === 0 && ue(Xe)), xt !== e ? (Jr = [Jr, Ei, fi, Ae, xt], Dr = Jr) : (d = Dr, Dr = e)) : (d = Dr, Dr = e)) : (d = Dr, Dr = e), Dr === e && (Dr = null), oe = [oe, se, At, kt, Zr, Dr], S = oe) : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, oe = St(), t.charCodeAt(d) === 46 ? (se = P, d++) : (se = e, C === 0 && ue($e)), se !== e ? (At = St(), kt = In(), kt !== e ? (Zr = St(), Dr = d, t.charCodeAt(d) === 40 ? (Jr = O, d++) : (Jr = e, C === 0 && ue(Ce)), Jr !== e ? (Ei = St(), fi = fr(), fi !== e ? (Ae = St(), t.charCodeAt(d) === 41 ? (xt = U, d++) : (xt = e, C === 0 && ue(Xe)), xt !== e ? (Jr = [Jr, Ei, fi, Ae, xt], Dr = Jr) : (d = Dr, Dr = e)) : (d = Dr, Dr = e)) : (d = Dr, Dr = e), Dr === e && (Dr = null), oe = [oe, se, At, kt, Zr, Dr], S = oe) : (d = S, S = e)) : (d = S, S = e);
      G = h, h = br(A, z);
    } else
      d = h, h = e;
    return h;
  }
  function ct() {
    var h, A, z, S, oe;
    return h = d, A = In(), A !== e ? (St(), t.charCodeAt(d) === 40 ? (z = O, d++) : (z = e, C === 0 && ue(Ce)), z !== e ? (St(), S = fr(), S !== e ? (St(), t.charCodeAt(d) === 41 ? (oe = U, d++) : (oe = e, C === 0 && ue(Xe)), oe !== e ? (G = h, h = yr(A, S)) : (d = h, h = e)) : (d = h, h = e)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = Fr()), h;
  }
  function fr() {
    var h, A, z, S, oe, se;
    if (h = d, A = b(), A !== e) {
      for (z = [], S = d, St(), t.charCodeAt(d) === 44 ? (oe = me, d++) : (oe = e, C === 0 && ue(Jt)), oe !== e ? (St(), se = b(), se !== e ? S = se : (d = S, S = e)) : (d = S, S = e); S !== e; )
        z.push(S), S = d, St(), t.charCodeAt(d) === 44 ? (oe = me, d++) : (oe = e, C === 0 && ue(Jt)), oe !== e ? (St(), se = b(), se !== e ? S = se : (d = S, S = e)) : (d = S, S = e);
      G = h, h = jr(A, z);
    } else
      d = h, h = e;
    return h === e && (h = St()), h;
  }
  function Fr() {
    var h, A, z, S;
    return h = Wn(), h === e && (h = Mr(), h === e && (h = ri(), h === e && (h = yn(), h === e && (h = d, t.charCodeAt(d) === 40 ? (A = O, d++) : (A = e, C === 0 && ue(Ce)), A !== e ? (St(), z = b(), z !== e ? (St(), t.charCodeAt(d) === 41 ? (S = U, d++) : (S = e, C === 0 && ue(Xe)), S !== e ? (G = h, h = kr(z)) : (d = h, h = e)) : (d = h, h = e)) : (d = h, h = e))))), h;
  }
  function Mr() {
    var h, A, z, S;
    return C++, h = d, t.charCodeAt(d) === 39 ? (A = nt, d++) : (A = e, C === 0 && ue(Qt)), A !== e ? (z = tn(), t.charCodeAt(d) === 39 ? (S = nt, d++) : (S = e, C === 0 && ue(Qt)), S !== e ? (G = h, h = Ir(z)) : (d = h, h = e)) : (d = h, h = e), C--, h === e && (A = e, C === 0 && ue(bt)), h;
  }
  function tn() {
    var h, A, z;
    for (h = d, A = [], z = fn(); z !== e; )
      A.push(z), z = fn();
    return G = h, A = gr(A), h = A, h;
  }
  function fn() {
    var h, A, z, S, oe;
    if (h = d, t.substr(d, 2) === s ? (A = s, d += 2) : (A = e, C === 0 && ue(Pe)), A !== e ? (z = St(), S = b(), S !== e ? (St(), t.charCodeAt(d) === 125 ? (oe = a, d++) : (oe = e, C === 0 && ue(yt)), oe !== e ? (G = h, h = Er(S)) : (d = h, h = e)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, t.substr(d, 3) === l ? (A = l, d += 3) : (A = e, C === 0 && ue(ye)), A !== e && (G = h, A = Ze()), h = A, h === e && (h = d, A = d, C++, t.charCodeAt(d) === 92 ? (z = u, d++) : (z = e, C === 0 && ue(Ke)), z === e && (t.charCodeAt(d) === 39 ? (z = nt, d++) : (z = e, C === 0 && ue(Qt)), z === e && (t.substr(d, 2) === s ? (z = s, d += 2) : (z = e, C === 0 && ue(Pe)))), C--, z === e ? A = void 0 : (d = A, A = e), A !== e ? (t.length > d ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(je)), z !== e ? (G = h, h = ne()) : (d = h, h = e)) : (d = h, h = e), h === e))) {
      if (h = d, t.substr(d, 2) === s ? (A = s, d += 2) : (A = e, C === 0 && ue(Pe)), A !== e) {
        if (z = [], We.test(t.charAt(d)) ? (S = t.charAt(d), d++) : (S = e, C === 0 && ue(rt)), S !== e)
          for (; S !== e; )
            z.push(S), We.test(t.charAt(d)) ? (S = t.charAt(d), d++) : (S = e, C === 0 && ue(rt));
        else
          z = e;
        z !== e ? (t.charCodeAt(d) === 125 ? (S = a, d++) : (S = e, C === 0 && ue(yt)), S !== e ? (G = h, h = we()) : (d = h, h = e)) : (d = h, h = e);
      } else
        d = h, h = e;
      h === e && (h = d, t.substr(d, 2) === s ? (A = s, d += 2) : (A = e, C === 0 && ue(Pe)), A !== e && (G = h, A = it()), h = A, h === e && (h = d, t.charCodeAt(d) === 92 ? (A = u, d++) : (A = e, C === 0 && ue(Ke)), A !== e ? (t.substr(d, 2) === s ? (z = s, d += 2) : (z = e, C === 0 && ue(Pe)), z !== e ? (G = h, h = ut(z)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, t.charCodeAt(d) === 92 ? (A = u, d++) : (A = e, C === 0 && ue(Ke)), A !== e ? (t.length > d ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(je)), z !== e ? (G = h, h = dt(z)) : (d = h, h = e)) : (d = h, h = e), h === e && (h = d, t.charCodeAt(d) === 92 ? (A = u, d++) : (A = e, C === 0 && ue(Ke)), A !== e && (G = h, A = Cr()), h = A))));
    }
    return h;
  }
  function yn() {
    var h, A, z;
    if (C++, h = d, t.charCodeAt(d) === 45 ? d++ : C === 0 && ue(ht), A = [], Ne.test(t.charAt(d)) ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(W)), z !== e)
      for (; z !== e; )
        A.push(z), Ne.test(t.charAt(d)) ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(W));
    else
      A = e;
    return A !== e ? (G = h, h = vt()) : (d = h, h = e), C--, h === e && C === 0 && ue(ir), h;
  }
  function ri() {
    var h, A, z, S, oe, se, At, kt, Zr;
    for (C++, h = d, t.charCodeAt(d) === 45 ? d++ : C === 0 && ue(ht), A = [], Ne.test(t.charAt(d)) ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(W)); z !== e; )
      A.push(z), Ne.test(t.charAt(d)) ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(W));
    if (t.charCodeAt(d) === 46 ? (z = P, d++) : (z = e, C === 0 && ue($e)), z !== e) {
      if (S = [], Ne.test(t.charAt(d)) ? (oe = t.charAt(d), d++) : (oe = e, C === 0 && ue(W)), oe !== e)
        for (; oe !== e; )
          S.push(oe), Ne.test(t.charAt(d)) ? (oe = t.charAt(d), d++) : (oe = e, C === 0 && ue(W));
      else
        S = e;
      if (S !== e) {
        if (oe = d, t.charCodeAt(d) === 101 ? (se = _e, d++) : (se = e, C === 0 && ue(It)), se === e && (t.charCodeAt(d) === 69 ? (se = Me, d++) : (se = e, C === 0 && ue(Ye))), se !== e) {
          if (t.charCodeAt(d) === 43 ? (At = ge, d++) : (At = e, C === 0 && ue(He)), At === e && (t.charCodeAt(d) === 45 ? (At = le, d++) : (At = e, C === 0 && ue(ht))), At === e && (At = null), kt = [], Ne.test(t.charAt(d)) ? (Zr = t.charAt(d), d++) : (Zr = e, C === 0 && ue(W)), Zr !== e)
            for (; Zr !== e; )
              kt.push(Zr), Ne.test(t.charAt(d)) ? (Zr = t.charAt(d), d++) : (Zr = e, C === 0 && ue(W));
          else
            kt = e;
          kt !== e ? (se = [se, At, kt], oe = se) : (d = oe, oe = e);
        } else
          d = oe, oe = e;
        oe === e && (oe = null), G = h, h = v();
      } else
        d = h, h = e;
    } else
      d = h, h = e;
    if (h === e) {
      if (h = d, t.charCodeAt(d) === 45 ? d++ : C === 0 && ue(ht), A = [], Ne.test(t.charAt(d)) ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(W)), z !== e)
        for (; z !== e; )
          A.push(z), Ne.test(t.charAt(d)) ? (z = t.charAt(d), d++) : (z = e, C === 0 && ue(W));
      else
        A = e;
      if (A !== e)
        if (t.charCodeAt(d) === 101 ? (z = _e, d++) : (z = e, C === 0 && ue(It)), z === e && (t.charCodeAt(d) === 69 ? (z = Me, d++) : (z = e, C === 0 && ue(Ye))), z !== e) {
          if (t.charCodeAt(d) === 43 ? (S = ge, d++) : (S = e, C === 0 && ue(He)), S === e && (t.charCodeAt(d) === 45 ? (S = le, d++) : (S = e, C === 0 && ue(ht))), S === e && (S = null), oe = [], Ne.test(t.charAt(d)) ? (se = t.charAt(d), d++) : (se = e, C === 0 && ue(W)), se !== e)
            for (; se !== e; )
              oe.push(se), Ne.test(t.charAt(d)) ? (se = t.charAt(d), d++) : (se = e, C === 0 && ue(W));
          else
            oe = e;
          oe !== e ? (G = h, h = V()) : (d = h, h = e);
        } else
          d = h, h = e;
      else
        d = h, h = e;
    }
    return C--, h === e && C === 0 && ue(Et), h;
  }
  function Wn() {
    var h, A, z, S, oe, se, At, kt, Zr, Dr, Jr;
    if (h = d, Ft.test(t.charAt(d)) ? (A = t.charAt(d), d++) : (A = e, C === 0 && ue(L)), A !== e) {
      if (z = [], S = [], Ve.test(t.charAt(d)) ? (oe = t.charAt(d), d++) : (oe = e, C === 0 && ue(Le)), oe !== e)
        for (; oe !== e; )
          S.push(oe), Ve.test(t.charAt(d)) ? (oe = t.charAt(d), d++) : (oe = e, C === 0 && ue(Le));
      else
        S = e;
      for (S === e && (S = d, t.charCodeAt(d) === 46 ? (oe = P, d++) : (oe = e, C === 0 && ue($e)), oe !== e ? (se = d, C++, At = d, kt = St(), Zr = In(), Zr !== e ? (Dr = St(), t.charCodeAt(d) === 40 ? (Jr = O, d++) : (Jr = e, C === 0 && ue(Ce)), Jr !== e ? (kt = [kt, Zr, Dr, Jr], At = kt) : (d = At, At = e)) : (d = At, At = e), C--, At === e ? se = void 0 : (d = se, se = e), se !== e ? (oe = [oe, se], S = oe) : (d = S, S = e)) : (d = S, S = e)); S !== e; ) {
        if (z.push(S), S = [], Ve.test(t.charAt(d)) ? (oe = t.charAt(d), d++) : (oe = e, C === 0 && ue(Le)), oe !== e)
          for (; oe !== e; )
            S.push(oe), Ve.test(t.charAt(d)) ? (oe = t.charAt(d), d++) : (oe = e, C === 0 && ue(Le));
        else
          S = e;
        S === e && (S = d, t.charCodeAt(d) === 46 ? (oe = P, d++) : (oe = e, C === 0 && ue($e)), oe !== e ? (se = d, C++, At = d, kt = St(), Zr = In(), Zr !== e ? (Dr = St(), t.charCodeAt(d) === 40 ? (Jr = O, d++) : (Jr = e, C === 0 && ue(Ce)), Jr !== e ? (kt = [kt, Zr, Dr, Jr], At = kt) : (d = At, At = e)) : (d = At, At = e), C--, At === e ? se = void 0 : (d = se, se = e), se !== e ? (oe = [oe, se], S = oe) : (d = S, S = e)) : (d = S, S = e));
      }
      G = h, h = Y();
    } else
      d = h, h = e;
    return h;
  }
  function In() {
    var h, A, z, S;
    if (h = d, Ft.test(t.charAt(d)) ? (A = t.charAt(d), d++) : (A = e, C === 0 && ue(L)), A !== e) {
      for (z = [], Ve.test(t.charAt(d)) ? (S = t.charAt(d), d++) : (S = e, C === 0 && ue(Le)); S !== e; )
        z.push(S), Ve.test(t.charAt(d)) ? (S = t.charAt(d), d++) : (S = e, C === 0 && ue(Le));
      G = h, h = he();
    } else
      d = h, h = e;
    return h;
  }
  function St() {
    var h, A;
    for (C++, h = [], Oe.test(t.charAt(d)) ? (A = t.charAt(d), d++) : (A = e, C === 0 && ue(qe)); A !== e; )
      h.push(A), Oe.test(t.charAt(d)) ? (A = t.charAt(d), d++) : (A = e, C === 0 && ue(qe));
    return C--, A = e, C === 0 && ue(gt), h;
  }
  if (Qe = o(), Qe !== e && d === t.length)
    return Qe;
  throw Qe !== e && d < t.length && ue(Yr()), ln(
    ar,
    Je < t.length ? t.charAt(Je) : null,
    Je < t.length ? Vn(Je, Je + 1) : Vn(Je, Je)
  );
}
const Fw = 128, ao = /* @__PURE__ */ new Map();
let qc;
function cd(t) {
  return ao.get(t);
}
function fd(t, r) {
  t !== qc && (ao.delete(t), ao.size >= Fw && ao.delete(ao.keys().next().value), ao.set(t, r), qc = t);
}
const Jc = /* @__PURE__ */ new Set([
  "string",
  "integer",
  "number",
  "boolean",
  "datetime",
  "color",
  "url",
  "dict",
  "array"
]);
function Mw(t) {
  if (!(typeof t.name == "string" && t.name))
    throw new Error("Incorrect function name");
  if (!(typeof t.body == "string" && t.body))
    throw new Error("Incorrect function body");
  if (!(t.return_type && Jc.has(t.return_type)))
    throw new Error("Incorrect function return_type");
  if (!Array.isArray(t.arguments))
    throw new Error("Incorrect function arguments");
  const r = /* @__PURE__ */ new Set();
  t.arguments.forEach((e) => {
    if (!(typeof e.name == "string" && e.name))
      throw new Error("Incorrect argument name");
    if (!(e.type && Jc.has(e.type)))
      throw new Error("Incorrect argument type");
    if (r.has(e.name))
      throw new Error("Duplicate argument name");
    r.add(e.name);
  });
}
function Pw(t) {
  let r;
  return {
    args: t.arguments.map((e) => ({
      type: e.type
    })),
    cb(e, ...n) {
      r || (r = cd(t.body) || ud(t.body, {
        startRule: "JsonStringContents"
      }), fd(t.body, r));
      const i = /* @__PURE__ */ new Map();
      n.forEach((a, l) => {
        const u = Zo(t.arguments[l].name, a.type, a.value);
        i.set(u.getName(), u);
      });
      const o = Xl(i, e.customFunctions, e.store, r, {
        weekStartDay: e.weekStartDay
      });
      o.warnings.forEach((a) => {
        e.warnings.push(a);
      });
      const s = o.result;
      if (s.type === "error")
        throw new Error(s.value);
      if (s.type !== t.return_type)
        throw new Error("Incorrect function return_type");
      return s;
    }
  };
}
function Nw(t, r) {
  if (!t)
    return r || void 0;
  if (!r)
    return t || void 0;
  const e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
  for (const [i, o] of r) {
    for (const s of o) {
      const a = pc(i, s);
      n.add(a);
    }
    e.set(i, o);
  }
  for (const [i, o] of t)
    for (const s of o) {
      const a = pc(i, s);
      if (!n.has(a)) {
        n.add(a);
        const l = e.get(i) || [];
        l.push(s), e.set(i, l);
      }
    }
  return e;
}
function zw(t) {
  if (!t)
    return R(new Error("Missing object"));
  const r = t.card, e = t.templates || {};
  if (!r)
    return R(new Error("Missing card"));
  if (!r.states || !r.states.length)
    return R(new Error("Missing states"));
  for (const n in e)
    if (e.hasOwnProperty(n) && n in td)
      return R(new Error("Template name collision"), {
        additional: {
          templateName: n
        }
      });
  for (let n = 0; n < r.states.length; ++n) {
    if (!r.states[n].div)
      return R(new Error("Missing state div"), {
        additional: {
          stateId: r.states[n].state_id
        }
      });
    if (typeof r.states[n].state_id != "number")
      return R(new Error("Missing state_id"), {
        additional: {
          index: n
        }
      });
  }
  return null;
}
function Ow(t) {
  return [...new Set(t)];
}
class dd {
  constructor(r, e) {
    dr(this, "ast");
    dr(this, "expr");
    this.ast = r, this.expr = e;
  }
  /**
   * Applies variables into ast
   * @param variables
   * @param logError
   */
  apply({
    variables: r,
    customFunctions: e,
    logError: n,
    store: i,
    weekStartDay: o,
    keepComplex: s
  }) {
    let a;
    try {
      a = Xl(r, e, i, this.ast, {
        weekStartDay: o
      }), a.warnings.forEach(n);
      const l = a.result;
      if (l.type === "error")
        return n(R(new Error("Expression execution error"), {
          additional: {
            message: l.value,
            expression: this.expr
          }
        })), {
          result: void 0,
          usedVars: a.usedVars
        };
      const u = l.value;
      if (u instanceof Date)
        return {
          result: Gf(u),
          usedVars: a.usedVars
        };
      if (l.type === "boolean")
        return {
          result: !!u,
          usedVars: a.usedVars
        };
      if (l.type === "color") {
        const c = si(String(u));
        if (c)
          return {
            result: no(c),
            usedVars: a.usedVars
          };
        n(R(new Error("Expression execution error")));
      }
      if (l.type === "integer")
        return u > W0 || u < U0 ? (n(R(new Error("Expression result is out of 32-bit int range"))), {
          result: void 0,
          usedVars: a.usedVars
        }) : {
          result: Number(u),
          usedVars: a.usedVars
        };
      if (!s && (l.type === "array" || l.type === "dict"))
        try {
          return {
            result: JSON.stringify(u),
            usedVars: a.usedVars
          };
        } catch {
          return n(R(new Error(`Failed to stringify ${l.type}`))), {
            result: `<${l.type}>`,
            usedVars: a.usedVars
          };
        }
      return {
        result: u,
        usedVars: a.usedVars
      };
    } catch {
      return n(R(new Error("Expression execution error"), {
        additional: {
          expression: this.expr
        }
      })), {
        result: void 0,
        usedVars: a == null ? void 0 : a.usedVars
      };
    }
  }
}
function Lw(t) {
  return t.indexOf("@{") > -1 || t.indexOf("\\") > -1;
}
function Cl(t, r, e) {
  if (t)
    if (typeof t == "string") {
      if (Lw(t)) {
        r.hasExpression = !0;
        try {
          const n = cd(t) || ud(t, {
            startRule: "JsonStringContents"
          });
          fd(t, n);
          const i = q0(n);
          return r.vars.push(...i), new dd(n, t);
        } catch {
          e(R(new Error("Unable to parse expression"), {
            additional: {
              expression: t
            }
          }));
          return;
        }
      }
    } else {
      if (Array.isArray(t))
        return t.map((n) => Cl(n, r, e));
      if (typeof t == "object") {
        const n = {};
        for (const i in t)
          n[i] = Cl(t[i], r, e);
        return n;
      }
    }
  return t;
}
function Sl(t, r) {
  if (t) {
    if (t instanceof dd)
      return t.apply(r);
    if (Array.isArray(t)) {
      let e;
      return {
        result: t.map((i) => {
          const o = Sl(i, r);
          if (o.usedVars) {
            e || (e = /* @__PURE__ */ new Set());
            for (const s of o.usedVars)
              e.add(s);
          }
          return o.result;
        }),
        usedVars: e
      };
    } else if (typeof t == "object") {
      const e = {};
      let n;
      for (const i in t) {
        const o = Sl(t[i], r);
        if (e[i] = o.result, o.usedVars) {
          n || (n = /* @__PURE__ */ new Set());
          for (const s of o.usedVars)
            n.add(s);
        }
      }
      return {
        result: e,
        usedVars: n
      };
    }
  }
  return {
    result: t
  };
}
function Kc(t, r, e, n) {
  const i = {
    vars: [],
    hasExpression: !1
  }, o = Cl(t, i, r);
  return {
    vars: Ow(i.vars),
    hasExpression: i.hasExpression,
    applyVars(a, l, u) {
      return Sl(o, {
        variables: a,
        customFunctions: l,
        logError: r,
        store: e,
        weekStartDay: n,
        keepComplex: u
      });
    }
  };
}
class _d {
  constructor() {
    dr(this, "_vars", /* @__PURE__ */ new Map());
    dr(this, "_lastAddedVariable", gi(""));
  }
  setVariable(r) {
    const e = r.getName();
    if (this._vars.has(e))
      throw new Error("Variable with the same name already exist");
    this._vars.set(e, r), this._lastAddedVariable.set(e);
  }
  getVariable(r) {
    return this._vars.get(r);
  }
  list() {
    return this._vars.values();
  }
  getVariables() {
    return this._vars;
  }
  getLastAddedVariableStore() {
    return this._lastAddedVariable;
  }
}
function Rv() {
  return new _d();
}
const Rw = ["start", "stop", "pause", "resume", "cancel", "reset"], Bw = new Set(Rw);
class Hw {
  constructor(r) {
    dr(this, "timers", /* @__PURE__ */ new Map());
    dr(this, "logError");
    dr(this, "applyVars");
    dr(this, "hasVariableWithType");
    dr(this, "setVariableValue");
    dr(this, "execAnyActions");
    dr(this, "visibilityHandler");
    dr(this, "awaitActions", []);
    this.logError = r.logError, this.applyVars = r.applyVars, this.hasVariableWithType = r.hasVariableWithType, this.setVariableValue = r.setVariableValue, this.execAnyActions = r.execAnyActions, this.visibilityHandler = () => {
      document.visibilityState === "visible" ? (this.awaitActions.forEach(({ id: e, action: n }) => {
        this.execTimerAction(e, n);
      }), this.awaitActions = [], this.unholdAll()) : this.holdAll();
    }, document.addEventListener("visibilitychange", this.visibilityHandler);
  }
  destroy() {
    document.removeEventListener("visibilitychange", this.visibilityHandler);
    for (const [r, e] of this.timers)
      this.stopTimerTimeouts(e);
  }
  createTimer(r) {
    if (!(r != null && r.id)) {
      this.logError(R(new Error("Missing timer id")));
      return;
    }
    if (!(r.duration || r.tick_interval && (r.value_variable || r.tick_actions))) {
      this.logError(R(new Error("Misconfigured timer"), {
        additional: {
          id: r.id
        }
      }));
      return;
    }
    this.timers.set(r.id, {
      state: "stopped",
      definition: r
    });
  }
  execTimerAction(r, e) {
    if (!r || !e || !this.timers.has(r) || !Bw.has(e)) {
      this.logError(R(new Error("Incorrect timer action"), {
        additional: {
          id: r,
          action: e
        }
      }));
      return;
    }
    const n = e;
    if (document.visibilityState !== "visible") {
      this.awaitActions.push({
        id: r,
        action: n
      });
      return;
    }
    const i = this.timers.get(r);
    this[n](i);
  }
  stopTimerTimeouts(r) {
    r.durationTimeout && (clearTimeout(r.durationTimeout), r.durationTimeout = void 0), r.tickTimeout && (clearTimeout(r.tickTimeout), r.tickTimeout = void 0);
  }
  async tickOrUnholdAction(r) {
    const e = performance.now(), n = (r.durationPassed || 0) + e - (r.durationStarted || 0);
    r.duration && n > r.duration || (this.updateVariable(r, n), await this.callActions(r, "tick"), r.tickCount !== void 0 && ++r.tickCount);
  }
  startOrResume(r) {
    r.state = "running", r.hold = !1, r.durationStarted = performance.now();
    const e = r.duration;
    e && (r.durationTimeout = window.setTimeout(async () => {
      this.updateVariable(r, e), r.tickCountPredict && r.tickCount !== void 0 && r.tickCount < r.tickCountPredict && await this.callActions(r, "tick"), this.stop(r);
    }, Math.max(0, e - (r.durationPassed || 0))));
    const n = r.tick;
    if (n) {
      const i = () => {
        const o = r.tickStarted = performance.now(), s = Math.max(0, n - (r.tickPassed || 0));
        r.tickTimeout = window.setTimeout(async () => {
          await this.tickOrUnholdAction(r), r.tickPassed = (performance.now() - o - s) % n, r.state === "running" && i();
        }, s);
      };
      i();
    }
  }
  applyVarsInt(r) {
    let e = this.applyVars(r);
    if (typeof e == "string") {
      if (e === r)
        return;
      e = Number(e);
    }
    if (!(e === void 0 || Number.isNaN(e) || Math.round(e) !== e))
      return e;
  }
  start(r) {
    if (r.state === "running") {
      this.logError(R(new Error("The timer is already running")));
      return;
    } else if (r.state === "paused") {
      this.logError(R(new Error("The timer is paused")));
      return;
    }
    const e = r.definition.value_variable;
    if (e && !this.hasVariableWithType(e, "integer")) {
      this.logError(R(new Error("Cannot find variable"), {
        additional: {
          name: e
        }
      }));
      return;
    }
    if (e && this.setVariableValue(e, 0), r.definition.duration !== void 0 && (r.duration = this.applyVarsInt(r.definition.duration), r.duration === void 0 || r.duration < 0)) {
      this.logError(R(new Error("Incorrect timer properties"), {
        additional: {
          id: r.definition.id
        }
      }));
      return;
    }
    if (r.definition.tick_interval !== void 0 && (r.tick = this.applyVarsInt(r.definition.tick_interval), r.tick === void 0 || r.tick <= 0)) {
      this.logError(R(new Error("Incorrect timer properties"), {
        additional: {
          id: r.definition.id
        }
      }));
      return;
    }
    r.duration !== void 0 && r.tick !== void 0 && (r.tickCount = 0, r.tickCountPredict = Math.floor(r.duration / r.tick)), this.startOrResume(r);
  }
  stop(r) {
    if (r.state === "stopped") {
      this.logError(R(new Error("The timer has already been stopped")));
      return;
    }
    r.state = "stopped", r.durationPassed = 0, r.tickPassed = 0, this.stopTimerTimeouts(r), this.callActions(r, "end");
  }
  pause(r) {
    if (r.state === "stopped") {
      this.logError(R(new Error("The timer has already been stopped")));
      return;
    } else if (r.state === "paused") {
      this.logError(R(new Error("The timer has already been paused")));
      return;
    }
    r.state = "paused", this.stopTimerTimeouts(r);
    const e = performance.now();
    r.durationStarted && (r.durationPassed = (r.durationPassed || 0) + e - r.durationStarted), r.tickStarted && (r.tickPassed = (r.tickPassed || 0) + e - r.tickStarted);
    const n = r.definition.value_variable;
    n && r.durationPassed && this.setVariableValue(n, Math.round(r.durationPassed));
  }
  resume(r) {
    if (r.state === "stopped") {
      this.logError(R(new Error("The timer has already been stopped")));
      return;
    } else if (r.state === "running") {
      this.logError(R(new Error("The timer is already running")));
      return;
    }
    this.startOrResume(r);
  }
  cancel(r) {
    r.state !== "stopped" && (r.state = "stopped", r.durationPassed = 0, r.tickPassed = 0, this.stopTimerTimeouts(r));
  }
  reset(r) {
    this.cancel(r), this.start(r);
  }
  updateVariable(r, e) {
    const n = r.definition.value_variable;
    n && this.setVariableValue(n, Math.round(e));
  }
  async callActions(r, e) {
    const n = r.definition[e === "end" ? "end_actions" : "tick_actions"];
    if (n)
      return this.execAnyActions(n, {
        processUrls: !1
      });
  }
  holdAll() {
    for (const [r, e] of this.timers)
      e.state === "running" && (e.hold = !0, this.stopTimerTimeouts(e));
  }
  async unholdAll() {
    for (const [r, e] of this.timers)
      if (e.state === "running" && e.hold) {
        const n = performance.now();
        e.durationStarted && (e.durationPassed = (e.durationPassed || 0) + n - e.durationStarted), e.tickStarted && (e.tickPassed = (e.tickPassed || 0) + n - e.tickStarted), e.tick && await this.tickOrUnholdAction(e), this.startOrResume(e);
      }
  }
}
function Ww(t, r, e, n) {
  const { variable_name: i, index: o, value: s } = n;
  if (!s || typeof o != "number" && o !== void 0) {
    e(R(new Error("Incorrect array_insert_value action"), {
      additional: {
        name: i
      }
    }));
    return;
  }
  Zl(t, r, e, n, (a) => {
    const l = a.getValue();
    if (typeof o == "number" && (o < 0 || o > l.length))
      e(R(new Error(`Index out of bound for mutation ${n.type}`), {
        additional: {
          name: i,
          index: o,
          length: l.length
        }
      }));
    else if (!s.type)
      e(R(new Error("Incorrect value type"), {
        additional: {
          name: i
        }
      }));
    else {
      const u = l.slice(), c = Hs(s);
      typeof o == "number" ? u.splice(o, 0, c) : u.push(c), a.setValue(u);
    }
  });
}
function Uw(t, r, e, n) {
  const { variable_name: i, index: o } = n;
  if (typeof o != "number") {
    e(R(new Error("Incorrect array_remove_value action"), {
      additional: {
        name: i
      }
    }));
    return;
  }
  Zl(t, r, e, n, (s) => {
    const a = s.getValue();
    if (typeof o == "number" && (o < 0 || o >= a.length))
      e(R(new Error(`Index out of bound for mutation ${n.type}`), {
        additional: {
          name: i,
          index: o,
          length: a.length
        }
      }));
    else {
      const l = a.slice();
      l.splice(o, 1), s.setValue(l);
    }
  });
}
function Gw(t, r, e, n) {
  const { variable_name: i, index: o, value: s } = n;
  if (!s || typeof o != "number") {
    e(R(new Error("Incorrect array_set_value action"), {
      additional: {
        name: i
      }
    }));
    return;
  }
  Zl(t, r, e, n, (a) => {
    const l = a.getValue();
    if (typeof o == "number" && (o < 0 || o >= l.length))
      e(R(new Error(`Index out of bound for mutation ${n.type}`), {
        additional: {
          name: i,
          index: o,
          length: l.length
        }
      }));
    else if (!s.type)
      e(R(new Error("Incorrect value type"), {
        additional: {
          name: i
        }
      }));
    else {
      const u = l.slice();
      u[o] = Hs(s), a.setValue(u);
    }
  });
}
function Zl(t, r, e, n, i) {
  const { variable_name: o } = n;
  if (!o) {
    e(R(new Error(`Incorrect ${n.type} action`), {
      additional: {
        name: o
      }
    }));
    return;
  }
  const s = (t == null ? void 0 : t.getVariable(o)) || r.get(o);
  if (!s) {
    e(R(new Error("Cannot find variable"), {
      additional: {
        name: o
      }
    }));
    return;
  }
  const a = s.getType();
  a === "array" ? i(s) : e(R(new Error("Trying to insert value into the non-array"), {
    additional: {
      name: o,
      type: a
    }
  }));
}
function Yw(t, r, e, n) {
  const { variable_name: i, key: o, value: s } = n;
  if (typeof o != "string") {
    e(R(new Error("Incorrect dict_set_value action"), {
      additional: {
        name: i
      }
    }));
    return;
  }
  if (!i) {
    e(R(new Error(`Incorrect ${n.type} action`), {
      additional: {
        name: i
      }
    }));
    return;
  }
  s && !s.type && e(R(new Error("Incorrect value type"), {
    additional: {
      name: i
    }
  }));
  const a = (t == null ? void 0 : t.getVariable(i)) || r.get(i);
  if (!a) {
    e(R(new Error("Cannot find variable"), {
      additional: {
        name: i
      }
    }));
    return;
  }
  const l = a.getType();
  if (l === "dict") {
    const c = { ...a.getValue() };
    s ? c[o] = Hs(s) : delete c[o], a.setValue(c);
  } else
    e(R(new Error("Trying to set value into the non-dict"), {
      additional: {
        name: i,
        type: l
      }
    }));
}
function qw(t, r) {
  if (!(r.content && (r.content.type === "text" || r.content.type === "url") && typeof r.content.value == "string")) {
    t(R(new Error("Incorrect action"), {
      additional: {
        action: r
      }
    }));
    return;
  }
  if (!(typeof navigator < "u" && "clipboard" in navigator && navigator.clipboard && "writeText" in navigator.clipboard && typeof navigator.clipboard.writeText == "function")) {
    t(R(new Error("Clipboard is unavailable"), {
      additional: {
        action: r
      }
    }));
    return;
  }
  navigator.clipboard.writeText(r.content.value).catch((e) => {
    t(R(new Error("Failed to copy to the clipboard"), {
      additional: {
        originalError: String(e)
      }
    }));
  });
}
function Jw(t) {
  if (t === "normal" || t === "reverse" || t === "alternate" || t === "alternate_reverse")
    return t;
}
function Kw(t, r, e, n) {
  var J, M, ge, le;
  const i = Gn(t.duration, 0);
  if (!i || t.type !== "color_animator" && t.type !== "number_animator")
    return;
  const o = (J = t.start_value_typed ? t.start_value_typed.value : t.start_value) != null ? J : r.getValue(), s = t.end_value_typed ? t.end_value_typed.value : t.end_value;
  if (o === void 0 || s === void 0 || t.type === "color_animator" && (typeof o != "string" && o !== void 0 || typeof s != "string") || t.type === "number_animator" && (typeof o != "number" && o !== void 0 || typeof s != "number"))
    return;
  const a = t.type === "color_animator" && si(o), l = t.type === "color_animator" && si(s);
  if (t.type === "color_animator" && (!a || !l))
    return;
  const u = Kr(t.start_delay, 0), c = Ul(t.interpolator || "linear"), f = Jw(t.direction) || "normal", _ = ((M = t.repeat_count) == null ? void 0 : M.type) === "infinity" ? 1 / 0 : ((ge = t.repeat_count) == null ? void 0 : ge.type) === "fixed" ? Kr((le = t.repeat_count) == null ? void 0 : le.value, 1) : 1;
  let g = 0, y = performance.now();
  const p = _ === 1 / 0 ? 1 / 0 : _ * i + u;
  function w(H) {
    if (t.type === "color_animator") {
      if (!a || !l)
        throw new Error("Missing start/end value");
      return no({
        a: Vi(Si(a.a, l.a, H), 0, 255),
        r: Vi(Si(a.r, l.r, H), 0, 255),
        g: Vi(Si(a.g, l.g, H), 0, 255),
        b: Vi(Si(a.b, l.b, H), 0, 255)
      });
    }
    return Si(o, s, H);
  }
  function E(H) {
    const ee = H - y;
    if (y = H, g += ee, g >= u) {
      let X = Math.floor((g - u) / i), I = (g - u - X * i) / i;
      X >= _ && (X = _ - 1, I = 1);
      let P;
      f === "normal" || f === "alternate" && X % 2 === 0 || f === "alternate_reverse" && X % 2 === 1 ? P = "normal" : P = "reverse", P === "reverse" && (I = 1 - I);
      const O = w(c(I));
      r.setValue(O);
    }
    g < p ? Q = requestAnimationFrame(E) : (e(), n(t.end_actions));
  }
  let Q = requestAnimationFrame(E);
  return {
    stop() {
      cancelAnimationFrame(Q), n(t.cancel_actions), n(t.end_actions);
    }
  };
}
function Xw(t) {
  let r = t;
  for (; r && !r.isTooltipRoot; )
    r = r.parent;
  return r;
}
function Zw(t) {
  let r = t;
  for (; r != null && r.parent && r.json.type !== "state" && !r.isRootState && !r.isTooltipRoot; )
    r = r.parent;
  return r;
}
function As(t) {
  return !!(t && typeof t == "string");
}
const Qw = /* @__PURE__ */ new Set([
  "get",
  "post",
  "put",
  "patch",
  "delete",
  "head",
  "options"
]);
function xw(t) {
  return t === void 0 || Qw.has(t);
}
function $w(t) {
  return t === void 0 || Array.isArray(t) && t.every((r) => As(r.name) && As(r.value));
}
function ev(t) {
  var r, e, n;
  return As(t.container_id) && As((r = t.request) == null ? void 0 : r.url) && xw((e = t.request) == null ? void 0 : e.method) && $w((n = t.request) == null ? void 0 : n.headers);
}
function tv(t, r, e, n) {
  const { variable_name: i, path: o, value: s } = n;
  if (!(s != null && s.value)) {
    e(R(new Error("Missing value for an action"), {
      additional: {
        name: i
      }
    }));
    return;
  }
  if (typeof o != "string" || !o || o.charAt(0) === "/" || o.charAt(o.length - 1) === "/") {
    e(R(new Error(`Value '${o}' for key 'path' is not valid`), {
      additional: {
        name: i
      }
    }));
    return;
  }
  if (!i) {
    e(R(new Error(`Incorrect ${n.type} action`), {
      additional: {
        name: i
      }
    }));
    return;
  }
  const a = (t == null ? void 0 : t.getVariable(i)) || r.get(i);
  if (!a) {
    e(R(new Error("Cannot find variable"), {
      additional: {
        name: i
      }
    }));
    return;
  }
  const l = a.getType();
  if (l === "dict" || l === "array") {
    const u = a.getValue(), c = o.replace(/\/+/g, "/");
    if (c === "/") {
      e(R(new Error(`Value '${o}' for key 'path' is not valid`), {
        additional: {
          name: i,
          type: l,
          path: o
        }
      }));
      return;
    }
    const f = c.split("/"), _ = l === "array" ? u.slice() : { ...u };
    let g = _;
    for (let y = 0; y < f.length; ++y) {
      const p = f[y];
      if (!p) {
        e(R(new Error("Path is empty"), {
          additional: {
            name: i,
            type: l,
            path: o
          }
        }));
        return;
      }
      if (!g || typeof g != "object") {
        e(R(new Error(`Element with path '${f.slice(0, y).join("/")}' is not ${g === void 0 ? "found" : "a structure"}`), {
          additional: {
            name: i,
            type: l,
            path: o
          }
        }));
        return;
      }
      if (Array.isArray(g)) {
        const w = Number(p);
        if (Number.isNaN(w)) {
          e(R(new Error(`Unable to use '${p}' as array index`), {
            additional: {
              name: i,
              type: l,
              path: o
            }
          }));
          return;
        }
        if (y + 1 === f.length && (w < 0 || w > g.length)) {
          e(R(new Error(`Position '${w}' is out of array bounds`), {
            additional: {
              name: i,
              type: l,
              path: o
            }
          }));
          return;
        }
      }
      y + 1 < f.length && (g = g[p]);
    }
    g[f[f.length - 1]] = Hs(s), a.setValue(_);
  } else
    e(R(new Error("Action requires array or dictionary variable"), {
      additional: {
        name: i,
        type: l
      }
    }));
}
const rv = "appkit-outer", nv = "appkit-root__clickable", iv = "undefined", ov = "appkit-tooltip", sv = "appkit-tooltip_visible", lv = "appkit-tooltip_modal", av = "appkit-tooltip__inner", uv = "appkit-tooltip__overlay", Ii = {
  outer: rv,
  root__clickable: nv,
  "root__clickable-no-transition": "appkit-root__clickable-no-transition",
  root__selectable: iv,
  tooltip: ov,
  tooltip_visible: sv,
  tooltip_modal: lv,
  tooltip__inner: av,
  tooltip__overlay: uv
}, pd = 300, hd = 0;
function cv(t) {
  return Math.max(...t.map(
    (r) => (Number(r.duration) || pd) + (Number(r.start_delay) || hd)
  ));
}
function js(t, {
  animations: r,
  direction: e
}) {
  if (!r)
    return {};
  const n = Nl(r), i = cv(n);
  return n.some((s) => s.name === "no_animation") ? {} : {
    duration: Os() ? 0 : i,
    css: (s) => {
      const a = s * i, l = n.map((p) => {
        var ge, le, H, ee, X, I, P, O, U, me, nt, _e;
        const w = Number(p.start_delay) || hd, E = Number(p.duration) || pd, Q = e === "in" ? Math.max(0, Math.min(1, (a - w) / E)) : Math.max(0, Math.min(1, (a - (i - E) + w) / E)), M = (Ul(p.interpolator || "ease_in_out") || Rs)(Q);
        if (p.name === "fade") {
          const Me = e === "in" ? (ge = p.start_value) != null ? ge : 0 : (le = p.end_value) != null ? le : 0, tt = e === "in" ? (H = p.end_value) != null ? H : 1 : (ee = p.start_value) != null ? ee : 1;
          return {
            active: M > 0 && M < 1,
            opacity: (1 - M) * Me + M * tt
          };
        } else if (p.name === "translate") {
          const Me = -(e === "in" ? (X = p.start_value) != null ? X : 10 : (I = p.end_value) != null ? I : 10), tt = -(e === "in" ? (P = p.end_value) != null ? P : 0 : (O = p.start_value) != null ? O : 0);
          return {
            active: M > 0 && M < 1,
            translate: `translateY(${(1 - M) * Me + M * tt}${e === "in" && p.start_value !== void 0 || e === "out" && p.end_value !== void 0 ? "%" : "px"})`
          };
        } else if (p.name === "scale") {
          const Me = e === "in" ? (U = p.start_value) != null ? U : 0 : (me = p.end_value) != null ? me : 0, tt = e === "in" ? (nt = p.end_value) != null ? nt : 1 : (_e = p.start_value) != null ? _e : 1;
          return {
            active: M > 0 && M < 1,
            scale: `scale(${(1 - M) * Me + M * tt})`
          };
        }
        return {};
      }), u = l.map((p) => p.opacity).filter((p) => p !== void 0).reduce((p, w) => p * w, 1), c = l.map((p) => p.translate).filter((p) => p !== void 0).join(" "), f = l.map((p) => p.scale).filter((p) => p !== void 0).join(" "), _ = l.filter((p) => p.active).map((p) => p.scale).filter((p) => p !== void 0), g = _.length ? _[_.length - 1] : f;
      return `transform:${[c, g].filter(Boolean).join(" ") || "none"};opacity:${u}`;
    }
  };
}
const Vo = typeof window < "u" && "HTMLDialogElement" in window, { document: fv, window: dv } = wi;
function _v(t) {
  let r, e, n, i, o, s, a, l, u, c, f = (
    /*visible*/
    t[1] && /*modal*/
    t[3] && Xc(t)
  );
  return i = new ti({
    props: {
      componentContext: (
        /*componentContext*/
        t[2]
      )
    }
  }), {
    c() {
      f && f.c(), r = wr(), e = Be("div"), n = Be("div"), Zt(i.$$.fragment), m(n, "class", Ii.tooltip__inner), m(e, "class", o = jt(
        "tooltip",
        Ii,
        /*mods*/
        t[9]
      ) + " " + /*$isDesktop*/
      (t[15] ? ur.root_platform_desktop : "")), m(e, "role", "dialog"), m(
        e,
        "aria-modal",
        /*modal*/
        t[3]
      ), q(
        e,
        "top",
        /*tooltipY*/
        t[6]
      ), q(
        e,
        "left",
        /*tooltipX*/
        t[5]
      ), q(
        e,
        "width",
        /*tooltipWidth*/
        t[7]
      ), q(
        e,
        "height",
        /*tooltipHeight*/
        t[8]
      );
    },
    m(_, g) {
      f && f.m(_, g), x(_, r, g), x(_, e, g), Tt(e, n), Kt(i, n, null), t[28](e), l = !0, u || (c = Ge(
        e,
        "keydown",
        /*onKeyDown*/
        t[22]
      ), u = !0);
    },
    p(_, g) {
      t = _, /*visible*/
      t[1] && /*modal*/
      t[3] ? f ? f.p(t, g) : (f = Xc(t), f.c(), f.m(r.parentNode, r)) : f && (f.d(1), f = null);
      const y = {};
      g[0] & /*componentContext*/
      4 && (y.componentContext = /*componentContext*/
      t[2]), i.$set(y), (!l || g[0] & /*mods, $isDesktop*/
      33280 && o !== (o = jt(
        "tooltip",
        Ii,
        /*mods*/
        t[9]
      ) + " " + /*$isDesktop*/
      (t[15] ? ur.root_platform_desktop : ""))) && m(e, "class", o), (!l || g[0] & /*modal*/
      8) && m(
        e,
        "aria-modal",
        /*modal*/
        t[3]
      ), g[0] & /*tooltipY*/
      64 && q(
        e,
        "top",
        /*tooltipY*/
        t[6]
      ), g[0] & /*tooltipX*/
      32 && q(
        e,
        "left",
        /*tooltipX*/
        t[5]
      ), g[0] & /*tooltipWidth*/
      128 && q(
        e,
        "width",
        /*tooltipWidth*/
        t[7]
      ), g[0] & /*tooltipHeight*/
      256 && q(
        e,
        "height",
        /*tooltipHeight*/
        t[8]
      );
    },
    i(_) {
      l || (K(i.$$.fragment, _), Yn(() => {
        l && (a && a.end(1), s = Ps(e, js, {
          animations: (
            /*$animationIn*/
            t[16] || Cs
          ),
          direction: "in"
        }), s.start());
      }), l = !0);
    },
    o(_) {
      ae(i.$$.fragment, _), s && s.invalidate(), a = bf(e, js, {
        animations: (
          /*$animationOut*/
          t[17] || Cs
        ),
        direction: "out"
      }), l = !1;
    },
    d(_) {
      _ && (Z(r), Z(e)), f && f.d(_), Xt(i), t[28](null), _ && a && a.end(), u = !1, c();
    }
  };
}
function pv(t) {
  let r, e, n, i, o, s, a, l, u, c, f = (
    /*visible*/
    t[1] && /*modal*/
    t[3] && /*data*/
    t[0].background_accessibility_description && Zc(t)
  );
  return i = new ti({
    props: {
      componentContext: (
        /*componentContext*/
        t[2]
      )
    }
  }), {
    c() {
      r = Be("dialog"), f && f.c(), e = wr(), n = Be("div"), Zt(i.$$.fragment), m(n, "class", Ii.tooltip__inner), m(r, "class", o = jt(
        "tooltip",
        Ii,
        /*mods*/
        t[9]
      ) + " " + /*$isDesktop*/
      (t[15] ? ur.root_platform_desktop : "")), q(
        r,
        "top",
        /*tooltipY*/
        t[6]
      ), q(
        r,
        "left",
        /*tooltipX*/
        t[5]
      ), q(
        r,
        "width",
        /*tooltipWidth*/
        t[7]
      ), q(
        r,
        "height",
        /*tooltipHeight*/
        t[8]
      );
    },
    m(_, g) {
      x(_, r, g), f && f.m(r, null), Tt(r, e), Tt(r, n), Kt(i, n, null), t[27](r), l = !0, u || (c = [
        Ge(
          r,
          "keydown",
          /*onKeyDown*/
          t[22]
        ),
        Ge(
          r,
          "close",
          /*onClose*/
          t[23]
        ),
        Ge(
          r,
          "cancel",
          /*onClose*/
          t[23]
        ),
        Ge(
          r,
          "click",
          /*onOutClick*/
          t[19]
        )
      ], u = !0);
    },
    p(_, g) {
      t = _, /*visible*/
      t[1] && /*modal*/
      t[3] && /*data*/
      t[0].background_accessibility_description ? f ? f.p(t, g) : (f = Zc(t), f.c(), f.m(r, e)) : f && (f.d(1), f = null);
      const y = {};
      g[0] & /*componentContext*/
      4 && (y.componentContext = /*componentContext*/
      t[2]), i.$set(y), (!l || g[0] & /*mods, $isDesktop*/
      33280 && o !== (o = jt(
        "tooltip",
        Ii,
        /*mods*/
        t[9]
      ) + " " + /*$isDesktop*/
      (t[15] ? ur.root_platform_desktop : ""))) && m(r, "class", o), g[0] & /*tooltipY*/
      64 && q(
        r,
        "top",
        /*tooltipY*/
        t[6]
      ), g[0] & /*tooltipX*/
      32 && q(
        r,
        "left",
        /*tooltipX*/
        t[5]
      ), g[0] & /*tooltipWidth*/
      128 && q(
        r,
        "width",
        /*tooltipWidth*/
        t[7]
      ), g[0] & /*tooltipHeight*/
      256 && q(
        r,
        "height",
        /*tooltipHeight*/
        t[8]
      );
    },
    i(_) {
      l || (K(i.$$.fragment, _), Yn(() => {
        l && (a && a.end(1), s = Ps(r, js, {
          animations: (
            /*$animationIn*/
            t[16] || Cs
          ),
          direction: "in"
        }), s.start());
      }), l = !0);
    },
    o(_) {
      ae(i.$$.fragment, _), s && s.invalidate(), a = bf(r, js, {
        animations: (
          /*$animationOut*/
          t[17] || Cs
        ),
        direction: "out"
      }), l = !1;
    },
    d(_) {
      _ && Z(r), f && f.d(), Xt(i), t[27](null), _ && a && a.end(), u = !1, Qr(c);
    }
  };
}
function Xc(t) {
  let r;
  function e(o, s) {
    return (
      /*data*/
      o[0].background_accessibility_description ? gv : hv
    );
  }
  let n = e(t), i = n(t);
  return {
    c() {
      i.c(), r = $t();
    },
    m(o, s) {
      i.m(o, s), x(o, r, s);
    },
    p(o, s) {
      n === (n = e(o)) && i ? i.p(o, s) : (i.d(1), i = n(o), i && (i.c(), i.m(r.parentNode, r)));
    },
    d(o) {
      o && Z(r), i.d(o);
    }
  };
}
function hv(t) {
  let r, e, n;
  return {
    c() {
      r = Be("div"), m(r, "class", Ii.tooltip__overlay);
    },
    m(i, o) {
      x(i, r, o), e || (n = Ge(
        r,
        "click",
        /*closeByOutside*/
        t[20]
      ), e = !0);
    },
    p: T,
    d(i) {
      i && Z(r), e = !1, n();
    }
  };
}
function gv(t) {
  let r, e, n, i;
  return {
    c() {
      r = Be("button"), m(r, "class", Ii.tooltip__overlay), m(r, "type", "button"), m(r, "aria-label", e = /*data*/
      t[0].background_accessibility_description);
    },
    m(o, s) {
      x(o, r, s), n || (i = Ge(
        r,
        "click",
        /*closeByOutside*/
        t[20]
      ), n = !0);
    },
    p(o, s) {
      s[0] & /*data*/
      1 && e !== (e = /*data*/
      o[0].background_accessibility_description) && m(r, "aria-label", e);
    },
    d(o) {
      o && Z(r), n = !1, i();
    }
  };
}
function Zc(t) {
  let r, e, n, i;
  return {
    c() {
      r = Be("button"), m(r, "class", Ii.tooltip__overlay), m(r, "type", "button"), m(r, "aria-label", e = /*data*/
      t[0].background_accessibility_description);
    },
    m(o, s) {
      x(o, r, s), n || (i = Ge(
        r,
        "click",
        /*closeByOutside*/
        t[20]
      ), n = !0);
    },
    p(o, s) {
      s[0] & /*data*/
      1 && e !== (e = /*data*/
      o[0].background_accessibility_description) && m(r, "aria-label", e);
    },
    d(o) {
      o && Z(r), n = !1, i();
    }
  };
}
function mv(t) {
  let r, e, n, i, o, s, a;
  const l = [pv, _v], u = [];
  function c(f, _) {
    return Vo ? 0 : 1;
  }
  return e = c(), n = u[e] = l[e](t), {
    c() {
      r = wr(), n.c(), i = $t();
    },
    m(f, _) {
      x(f, r, _), u[e].m(f, _), x(f, i, _), o = !0, s || (a = [
        Ge(
          dv,
          "resize",
          /*onWindowResize*/
          t[21]
        ),
        Ge(
          fv.body,
          "click",
          /*onOutClick*/
          t[19],
          !0
        )
      ], s = !0);
    },
    p(f, _) {
      n.p(f, _);
    },
    i(f) {
      o || (K(n), o = !0);
    },
    o(f) {
      ae(n), o = !1;
    },
    d(f) {
      f && (Z(r), Z(i)), u[e].d(f), s = !1, Qr(a);
    }
  };
}
const Cs = {
  name: "set",
  items: [{ name: "translate" }, { name: "fade" }]
};
let Bn = [];
function bv(t, r, e) {
  let n, i, o, s, a, l, u, c = T, f = () => (c(), c = B(o, (re) => e(31, u = re)), o), _, g = T, y = () => (g(), g = B(i, (re) => e(32, _ = re)), i), p, w = T, E = () => (w(), w = B(n, (re) => e(33, p = re)), n), Q, J, M = T, ge = () => (M(), M = B(s, (re) => e(16, J = re)), s), le, H = T, ee = () => (H(), H = B(a, (re) => e(17, le = re)), a);
  t.$$.on_destroy.push(() => c()), t.$$.on_destroy.push(() => g()), t.$$.on_destroy.push(() => w()), t.$$.on_destroy.push(() => M()), t.$$.on_destroy.push(() => H());
  let { ownerNode: X } = r, { data: I } = r, { internalId: P } = r, { parentComponentContext: O } = r;
  const U = Xr(_n), me = U.isDesktop;
  mn(t, me, (re) => e(15, Q = re));
  const nt = Date.now();
  let _e, Me = !1, tt = "", We = "", Ne = "", Ft = "", Ve = null, Oe, Pe = !0, yt = null;
  function ye() {
    var $e, Ce;
    if (!_e || !X)
      return;
    const re = _e.parentElement;
    if (!re)
      return;
    const $ = _e.style.cssText;
    e(4, _e.style.cssText += ";transform: none !important", _e);
    const pe = X.getBoundingClientRect(), Bt = _e.getBoundingClientRect(), De = re.getBoundingClientRect();
    e(4, _e.style.cssText = $, _e);
    let ft = 0, Mt = 0, He = null, ht = null, qt = 0, fe = 0;
    const Vt = ($e = Oe == null ? void 0 : Oe.json) == null ? void 0 : $e.width, be = (Ce = Oe == null ? void 0 : Oe.json) == null ? void 0 : Ce.height;
    if (!Vt || Vt.type === "match_parent" ? qt = He = window.innerWidth : Vt.type === "fixed" && Vt.value ? qt = He = Vt.value : qt = Bt.width, (be == null ? void 0 : be.type) === "match_parent" ? fe = ht = window.innerHeight : (be == null ? void 0 : be.type) === "fixed" && be.value ? fe = ht = be.value : fe = Bt.height, p === "left" || p === "bottom-left" || p === "top-left")
      ft = pe.left - qt;
    else if (p === "top" || p === "bottom" || p === "center")
      ft = (pe.left + pe.right) / 2 - qt / 2;
    else if (p === "right" || p === "bottom-right" || p === "top-right")
      ft = pe.right;
    else
      return;
    if (p === "top" || p === "top-left" || p === "top-right")
      Mt = pe.top - fe;
    else if (p === "left" || p === "right" || p === "center")
      Mt = (pe.top + pe.bottom) / 2 - fe / 2;
    else if (p === "bottom-left" || p === "bottom" || p === "bottom-right")
      Mt = pe.bottom;
    else
      return;
    Vo && Pe || (ft -= De.left, Mt -= De.top), ft += _ || 0, Mt += u || 0, e(5, tt = `${ft}px`), e(6, We = `${Mt}px`), e(7, Ne = He !== null ? `${He}px` : ""), e(8, Ft = ht !== null ? `${ht}px` : ""), e(1, Me = !0), He === null || ht === null ? typeof ResizeObserver < "u" && !Ve && (Ve = new ResizeObserver(() => {
      requestAnimationFrame(ye);
    }), Ve.observe(_e)) : Ve == null || Ve.disconnect();
  }
  function Ke(re) {
    if (Bn.length && Bn[Bn.length - 1] !== _e)
      return;
    const $ = re.composedPath();
    Date.now() - nt < 100 || $.includes(_e) && !(Vo && $[0] === _e) || je();
  }
  function je(re) {
    re == null || re.stopPropagation(), re == null || re.preventDefault(), Oe.getJsonWithVars(I.close_by_tap_outside) !== !1 && (Bn = Bn.filter(($) => $ !== _e), U.onTooltipClose(P)), I.tap_outside_actions && Oe.execAnyActions(I.tap_outside_actions, { processUrls: !0 });
  }
  function te() {
    ye();
  }
  function ot(re) {
    Bn.length && Bn[Bn.length - 1] !== _e || re.key === "Escape" && !re.ctrlKey && !re.shiftKey && !re.altKey && !re.metaKey && (Bn = Bn.filter(($) => $ !== _e), U.onTooltipClose(P));
  }
  function ce(re) {
    Bn = Bn.filter(($) => $ !== _e), U.onTooltipClose(P), re.preventDefault();
  }
  Jn(() => {
    try {
      yt = document.activeElement;
    } catch {
    }
    if (U.tooltipRoot) {
      const re = window.getComputedStyle(_e);
      e(4, _e.style.fontSize = re.fontSize, _e), e(4, _e.style.fontFamily = re.fontFamily, _e), e(4, _e.style.lineHeight = re.lineHeight, _e), U.tooltipRoot.appendChild(_e);
    }
    Vo && _e && _e instanceof HTMLDialogElement && _e[Pe ? "showModal" : "show"](), Pe && Bn.push(_e);
  }), Ms(() => {
    Me || ye();
  }), bn(() => {
    if (Oe && Oe.destroy(), Ve == null || Ve.disconnect(), Bn = Bn.filter((re) => re !== _e), Pe && yt && yt instanceof HTMLElement) {
      Vo && _e && _e instanceof HTMLDialogElement && _e.close();
      try {
        yt.focus({ preventScroll: !0 });
      } catch {
      }
    }
  });
  function pt(re) {
    Or[re ? "unshift" : "push"](() => {
      _e = re, e(4, _e);
    });
  }
  function Ct(re) {
    Or[re ? "unshift" : "push"](() => {
      _e = re, e(4, _e);
    });
  }
  return t.$$set = (re) => {
    "ownerNode" in re && e(24, X = re.ownerNode), "data" in re && e(0, I = re.data), "internalId" in re && e(25, P = re.internalId), "parentComponentContext" in re && e(26, O = re.parentComponentContext);
  }, t.$$.update = () => {
    var re, $, pe, Bt, De;
    t.$$.dirty[0] & /*componentContext, parentComponentContext, data*/
    67108869 && (Oe && Oe.destroy(), e(2, Oe = O.produceChildContext(I.div || {}, { isTooltipRoot: !0 }))), t.$$.dirty[0] & /*parentComponentContext, data*/
    67108865 && E(e(14, n = O.getDerivedFromVars(I.position))), t.$$.dirty[0] & /*parentComponentContext, data*/
    67108865 && y(e(13, i = O.getDerivedFromVars(($ = (re = I.offset) == null ? void 0 : re.x) == null ? void 0 : $.value))), t.$$.dirty[0] & /*parentComponentContext, data*/
    67108865 && f(e(12, o = O.getDerivedFromVars((Bt = (pe = I.offset) == null ? void 0 : pe.y) == null ? void 0 : Bt.value))), t.$$.dirty[0] & /*parentComponentContext, data*/
    67108865 && ge(e(11, s = O.getDerivedFromVars(I.animation_in))), t.$$.dirty[0] & /*parentComponentContext, data*/
    67108865 && ee(e(10, a = O.getDerivedFromVars(I.animation_out))), t.$$.dirty[0] & /*data*/
    1 && (((De = I.mode) == null ? void 0 : De.type) === "non_modal" ? e(3, Pe = !1) : e(3, Pe = !0)), t.$$.dirty[0] & /*visible, modal*/
    10 && e(9, l = { visible: Me, modal: Pe });
  }, [
    I,
    Me,
    Oe,
    Pe,
    _e,
    tt,
    We,
    Ne,
    Ft,
    l,
    a,
    s,
    o,
    i,
    n,
    Q,
    J,
    le,
    me,
    Ke,
    je,
    te,
    ot,
    ce,
    X,
    P,
    O,
    pt,
    Ct
  ];
}
class yv extends $r {
  constructor(r) {
    super(), xr(
      this,
      r,
      bv,
      mv,
      Vr,
      {
        ownerNode: 24,
        data: 0,
        internalId: 25,
        parentComponentContext: 26
      },
      null,
      [-1, -1]
    );
  }
}
function Qc(t, { delay: r = 0, duration: e = 400, easing: n = zf, x: i = 0, y: o = 0, opacity: s = 0 } = {}) {
  const a = getComputedStyle(t), l = +a.opacity, u = a.transform === "none" ? "" : a.transform, c = l * (1 - s), [f, _] = ea(i), [g, y] = ea(o);
  return {
    delay: r,
    duration: e,
    easing: n,
    css: (p, w) => `
			transform: ${u} translate(${(1 - p) * f}${_}, ${(1 - p) * g}${y});
			opacity: ${l - c * w}`
  };
}
const wv = "appkit-root_platform_desktop", vv = "appkit-menu", kv = "appkit-menu_visible", Ev = "appkit-menu__list", Av = "appkit-menu__item", fs = {
  root_platform_desktop: wv,
  menu: vv,
  menu_visible: kv,
  menu__list: Ev,
  menu__item: Av
}, { window: xc } = wi;
function $c(t, r, e) {
  const n = t.slice();
  return n[23] = r[e], n;
}
function jv(t) {
  let r = (
    /*item*/
    t[23].text + ""
  ), e;
  return {
    c() {
      e = ei(r);
    },
    m(n, i) {
      x(n, e, i);
    },
    p(n, i) {
      i & /*items*/
      1 && r !== (r = /*item*/
      n[23].text + "") && Ti(e, r);
    },
    d(n) {
      n && Z(e);
    }
  };
}
function ef(t) {
  let r, e, n, i;
  return e = new Ls({
    props: {
      componentContext: (
        /*parentComponentContext*/
        t[1]
      ),
      actions: (
        /*item*/
        t[23].actions || /*item*/
        t[23].action && [
          /*item*/
          t[23].action
        ]
      ),
      cls: fs.menu__item + " " + /*itemMix*/
      t[10],
      customAction: (
        /*onItemAction*/
        t[14]
      ),
      $$slots: { default: [jv] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      r = Be("li"), Zt(e.$$.fragment), n = wr();
    },
    m(o, s) {
      x(o, r, s), Kt(e, r, null), Tt(r, n), i = !0;
    },
    p(o, s) {
      const a = {};
      s & /*parentComponentContext*/
      2 && (a.componentContext = /*parentComponentContext*/
      o[1]), s & /*items*/
      1 && (a.actions = /*item*/
      o[23].actions || /*item*/
      o[23].action && [
        /*item*/
        o[23].action
      ]), s & /*$$scope, items*/
      67108865 && (a.$$scope = { dirty: s, ctx: o }), e.$set(a);
    },
    i(o) {
      i || (K(e.$$.fragment, o), i = !0);
    },
    o(o) {
      ae(e.$$.fragment, o), i = !1;
    },
    d(o) {
      o && Z(r), Xt(e);
    }
  };
}
function Cv(t) {
  let r, e, n, i, o, s, a, l = lr(
    /*items*/
    t[0]
  ), u = [];
  for (let f = 0; f < l.length; f += 1)
    u[f] = ef($c(t, l, f));
  const c = (f) => ae(u[f], 1, 1, () => {
    u[f] = null;
  });
  return {
    c() {
      r = Be("div"), e = Be("ul");
      for (let f = 0; f < u.length; f += 1)
        u[f].c();
      m(e, "class", fs.menu__list), m(r, "class", n = jt(
        "menu",
        fs,
        /*mods*/
        t[7]
      ) + " " + /*$isDesktop*/
      (t[8] ? ur.root_platform_desktop : "") + " " + /*popupMix*/
      t[9]), q(
        r,
        "top",
        /*menuY*/
        t[4]
      ), q(
        r,
        "left",
        /*menuX*/
        t[3]
      ), q(
        r,
        "width",
        /*menuWidth*/
        t[5]
      ), q(
        r,
        "height",
        /*menuHeight*/
        t[6]
      );
    },
    m(f, _) {
      x(f, r, _), Tt(r, e);
      for (let g = 0; g < u.length; g += 1)
        u[g] && u[g].m(e, null);
      t[17](r), o = !0, s || (a = [
        Ge(
          xc,
          "click",
          /*onWindowClick*/
          t[12]
        ),
        Ge(
          xc,
          "resize",
          /*onWindowResize*/
          t[13]
        )
      ], s = !0);
    },
    p(f, [_]) {
      if (_ & /*parentComponentContext, items, itemMix, onItemAction*/
      17411) {
        l = lr(
          /*items*/
          f[0]
        );
        let g;
        for (g = 0; g < l.length; g += 1) {
          const y = $c(f, l, g);
          u[g] ? (u[g].p(y, _), K(u[g], 1)) : (u[g] = ef(y), u[g].c(), K(u[g], 1), u[g].m(e, null));
        }
        for (_r(), g = l.length; g < u.length; g += 1)
          c(g);
        pr();
      }
      (!o || _ & /*mods, $isDesktop*/
      384 && n !== (n = jt(
        "menu",
        fs,
        /*mods*/
        f[7]
      ) + " " + /*$isDesktop*/
      (f[8] ? ur.root_platform_desktop : "") + " " + /*popupMix*/
      f[9])) && m(r, "class", n), _ & /*menuY*/
      16 && q(
        r,
        "top",
        /*menuY*/
        f[4]
      ), _ & /*menuX*/
      8 && q(
        r,
        "left",
        /*menuX*/
        f[3]
      ), _ & /*menuWidth*/
      32 && q(
        r,
        "width",
        /*menuWidth*/
        f[5]
      ), _ & /*menuHeight*/
      64 && q(
        r,
        "height",
        /*menuHeight*/
        f[6]
      );
    },
    i(f) {
      if (!o) {
        for (let _ = 0; _ < l.length; _ += 1)
          K(u[_]);
        f && Yn(() => {
          o && (i || (i = oa(r, Qc, { y: 20 }, !0)), i.run(1));
        }), o = !0;
      }
    },
    o(f) {
      u = u.filter(Boolean);
      for (let _ = 0; _ < u.length; _ += 1)
        ae(u[_]);
      f && (i || (i = oa(r, Qc, { y: 20 }, !1)), i.run(0)), o = !1;
    },
    d(f) {
      f && Z(r), gn(u, f), t[17](null), f && i && i.end(), s = !1, Qr(a);
    }
  };
}
function Sv(t, r, e) {
  let n, i, { ownerNode: o } = r, { items: s } = r, { parentComponentContext: a } = r;
  const l = Xr(_n), u = l.getCustomization("menuPopupClass") || "", c = l.getCustomization("menuItemClass") || "", f = l.isDesktop;
  mn(t, f, (I) => e(8, i = I));
  const _ = Date.now(), g = Dd();
  let y, p = !1, w = "", E = "", Q = "", J = "", M = null;
  function ge() {
    if (!y || !o)
      return;
    const I = y.parentElement;
    if (!I)
      return;
    const P = o.getBoundingClientRect(), O = y.getBoundingClientRect(), U = I.getBoundingClientRect(), me = window.innerWidth, nt = window.innerHeight;
    let _e = 0, Me = 0, tt = O.width, We = O.height;
    _e = P.left - U.left, Me = P.bottom - U.top, _e + tt > me && (_e = me - tt), _e < 0 && (_e = 0), Me + We > nt && (P.top - U.top - We > 0 ? Me = P.top - U.top - We : Me = nt - We), Me < 0 && (Me = 0), e(3, w = `${_e}px`), e(4, E = `${Me}px`), e(5, Q = ""), e(6, J = ""), e(16, p = !0), typeof ResizeObserver < "u" && !M && (M = new ResizeObserver(() => {
      requestAnimationFrame(ge);
    }), M.observe(y));
  }
  function le(I) {
    Date.now() - _ < 100 || I.composedPath().includes(y) || g("close");
  }
  function H() {
    ge();
  }
  function ee() {
    return g("close"), !0;
  }
  Jn(() => {
    if (l.tooltipRoot) {
      const I = window.getComputedStyle(y);
      e(2, y.style.fontSize = I.fontSize, y), e(2, y.style.fontFamily = I.fontFamily, y), e(2, y.style.lineHeight = I.lineHeight, y), l.tooltipRoot.appendChild(y);
    }
  }), Ms(() => {
    p || ge();
  }), bn(() => {
    M == null || M.disconnect();
  });
  function X(I) {
    Or[I ? "unshift" : "push"](() => {
      y = I, e(2, y);
    });
  }
  return t.$$set = (I) => {
    "ownerNode" in I && e(15, o = I.ownerNode), "items" in I && e(0, s = I.items), "parentComponentContext" in I && e(1, a = I.parentComponentContext);
  }, t.$$.update = () => {
    t.$$.dirty & /*visible*/
    65536 && e(7, n = { visible: p });
  }, [
    s,
    a,
    y,
    w,
    E,
    Q,
    J,
    n,
    i,
    u,
    c,
    f,
    le,
    H,
    ee,
    o,
    p,
    X
  ];
}
class Vv extends $r {
  constructor(r) {
    super(), xr(this, r, Sv, Cv, Vr, {
      ownerNode: 15,
      items: 0,
      parentComponentContext: 1
    });
  }
}
const { Map: Iv } = wi;
function tf(t, r, e) {
  const n = t.slice();
  return n[134] = r[e], n;
}
function rf(t) {
  let r, e, n, i, o, s, a, l, u, c;
  e = new H1({
    props: { svgFiltersMap: (
      /*svgFiltersMap*/
      t[5]
    ) }
  }), i = new ti({
    props: {
      componentContext: (
        /*rootStateComponentContext*/
        t[6]
      )
    }
  });
  let f = (
    /*tooltips*/
    t[3] && nf(t)
  ), _ = (
    /*menu*/
    t[4] && sf(t)
  );
  return {
    c() {
      r = Be("div"), Zt(e.$$.fragment), n = wr(), Zt(i.$$.fragment), o = wr(), f && f.c(), s = wr(), _ && _.c(), m(r, "class", a = ur.root + /*$isDesktop*/
      (t[7] ? ` ${ur.root_platform_desktop}` : "") + /*mix*/
      (t[0] ? ` ${/*mix*/
      t[0]}` : "")), m(
        r,
        "dir",
        /*$directionStore*/
        t[8]
      );
    },
    m(g, y) {
      x(g, r, y), Kt(e, r, null), Tt(r, n), Kt(i, r, null), Tt(r, o), f && f.m(r, null), Tt(r, s), _ && _.m(r, null), l = !0, u || (c = Ge(r, "touchstart", Mv, { passive: !0 }), u = !0);
    },
    p(g, y) {
      const p = {};
      y[0] & /*svgFiltersMap*/
      32 && (p.svgFiltersMap = /*svgFiltersMap*/
      g[5]), e.$set(p);
      const w = {};
      y[0] & /*rootStateComponentContext*/
      64 && (w.componentContext = /*rootStateComponentContext*/
      g[6]), i.$set(w), /*tooltips*/
      g[3] ? f ? (f.p(g, y), y[0] & /*tooltips*/
      8 && K(f, 1)) : (f = nf(g), f.c(), K(f, 1), f.m(r, s)) : f && (_r(), ae(f, 1, 1, () => {
        f = null;
      }), pr()), /*menu*/
      g[4] ? _ ? (_.p(g, y), y[0] & /*menu*/
      16 && K(_, 1)) : (_ = sf(g), _.c(), K(_, 1), _.m(r, null)) : _ && (_r(), ae(_, 1, 1, () => {
        _ = null;
      }), pr()), (!l || y[0] & /*$isDesktop, mix*/
      129 && a !== (a = ur.root + /*$isDesktop*/
      (g[7] ? ` ${ur.root_platform_desktop}` : "") + /*mix*/
      (g[0] ? ` ${/*mix*/
      g[0]}` : ""))) && m(r, "class", a), (!l || y[0] & /*$directionStore*/
      256) && m(
        r,
        "dir",
        /*$directionStore*/
        g[8]
      );
    },
    i(g) {
      l || (K(e.$$.fragment, g), K(i.$$.fragment, g), K(f), K(_), l = !0);
    },
    o(g) {
      ae(e.$$.fragment, g), ae(i.$$.fragment, g), ae(f), ae(_), l = !1;
    },
    d(g) {
      g && Z(r), Xt(e), Xt(i), f && f.d(), _ && _.d(), u = !1, c();
    }
  };
}
function nf(t) {
  let r = [], e = new Iv(), n, i, o = lr(
    /*tooltips*/
    t[3]
  );
  const s = (a) => (
    /*item*/
    a[134].internalId
  );
  for (let a = 0; a < o.length; a += 1) {
    let l = tf(t, o, a), u = s(l);
    e.set(u, r[a] = of(u, l));
  }
  return {
    c() {
      for (let a = 0; a < r.length; a += 1)
        r[a].c();
      n = $t();
    },
    m(a, l) {
      for (let u = 0; u < r.length; u += 1)
        r[u] && r[u].m(a, l);
      x(a, n, l), i = !0;
    },
    p(a, l) {
      l[0] & /*tooltips, rootStateComponentContext*/
      72 && (o = lr(
        /*tooltips*/
        a[3]
      ), _r(), r = wf(r, l, s, 1, a, o, e, n.parentNode, yf, of, n, tf), pr());
    },
    i(a) {
      if (!i) {
        for (let l = 0; l < o.length; l += 1)
          K(r[l]);
        i = !0;
      }
    },
    o(a) {
      for (let l = 0; l < r.length; l += 1)
        ae(r[l]);
      i = !1;
    },
    d(a) {
      a && Z(n);
      for (let l = 0; l < r.length; l += 1)
        r[l].d(a);
    }
  };
}
function of(t, r) {
  let e, n, i;
  return n = new yv({
    props: {
      ownerNode: (
        /*item*/
        r[134].ownerNode
      ),
      data: (
        /*item*/
        r[134].desc
      ),
      internalId: (
        /*item*/
        r[134].internalId
      ),
      parentComponentContext: (
        /*item*/
        r[134].componentContext || /*rootStateComponentContext*/
        r[6]
      )
    }
  }), {
    key: t,
    first: null,
    c() {
      e = $t(), Zt(n.$$.fragment), this.first = e;
    },
    m(o, s) {
      x(o, e, s), Kt(n, o, s), i = !0;
    },
    p(o, s) {
      r = o;
      const a = {};
      s[0] & /*tooltips*/
      8 && (a.ownerNode = /*item*/
      r[134].ownerNode), s[0] & /*tooltips*/
      8 && (a.data = /*item*/
      r[134].desc), s[0] & /*tooltips*/
      8 && (a.internalId = /*item*/
      r[134].internalId), s[0] & /*tooltips, rootStateComponentContext*/
      72 && (a.parentComponentContext = /*item*/
      r[134].componentContext || /*rootStateComponentContext*/
      r[6]), n.$set(a);
    },
    i(o) {
      i || (K(n.$$.fragment, o), i = !0);
    },
    o(o) {
      ae(n.$$.fragment, o), i = !1;
    },
    d(o) {
      o && Z(e), Xt(n, o);
    }
  };
}
function sf(t) {
  let r, e;
  return r = new Vv({
    props: {
      ownerNode: (
        /*menu*/
        t[4].node
      ),
      items: (
        /*menu*/
        t[4].items
      ),
      parentComponentContext: (
        /*menu*/
        t[4].componentContext || /*rootStateComponentContext*/
        t[6]
      )
    }
  }), r.$on(
    "close",
    /*close_handler*/
    t[45]
  ), {
    c() {
      Zt(r.$$.fragment);
    },
    m(n, i) {
      Kt(r, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i[0] & /*menu*/
      16 && (o.ownerNode = /*menu*/
      n[4].node), i[0] & /*menu*/
      16 && (o.items = /*menu*/
      n[4].items), i[0] & /*menu, rootStateComponentContext*/
      80 && (o.parentComponentContext = /*menu*/
      n[4].componentContext || /*rootStateComponentContext*/
      n[6]), r.$set(o);
    },
    i(n) {
      e || (K(r.$$.fragment, n), e = !0);
    },
    o(n) {
      ae(r.$$.fragment, n), e = !1;
    },
    d(n) {
      Xt(r, n);
    }
  };
}
function Dv(t) {
  let r, e, n = !/*hasError*/
  t[1] && !/*hasIdError*/
  t[2] && /*rootStateComponentContext*/
  t[6] && rf(t);
  return {
    c() {
      n && n.c(), r = $t();
    },
    m(i, o) {
      n && n.m(i, o), x(i, r, o), e = !0;
    },
    p(i, o) {
      !/*hasError*/
      i[1] && !/*hasIdError*/
      i[2] && /*rootStateComponentContext*/
      i[6] ? n ? (n.p(i, o), o[0] & /*hasError, hasIdError, rootStateComponentContext*/
      70 && K(n, 1)) : (n = rf(i), n.c(), K(n, 1), n.m(r.parentNode, r)) : n && (_r(), ae(n, 1, 1, () => {
        n = null;
      }), pr());
    },
    i(i) {
      e || (K(n), e = !0);
    },
    o(i) {
      ae(n), e = !1;
    },
    d(i) {
      i && Z(r), n && n.d(i);
    }
  };
}
let Ql = gi(!0), Jo = 0;
function lf() {
  Ql.set(!1);
}
function af() {
  Ql.set(!0);
}
const Tv = /* @__PURE__ */ new Set(["string", "integer", "number", "url", "color", "boolean"]), Fv = /* @__PURE__ */ new Set(["string", "integer", "number", "url", "color", "boolean", "array", "dict"]);
function Ci(t, r) {
  if (t && r)
    return new Map([...t, ...r]);
  if (t)
    return t;
  if (r)
    return r;
}
function Mv() {
}
function Pv(t, r, e) {
  var Lr, pn, Cn;
  let n, i, o, s, { id: a } = r, { json: l = {} } = r, { platform: u = "auto" } = r, { theme: c = "system" } = r, { globalVariablesController: f = void 0 } = r, { mix: _ = "" } = r, { customization: g = {} } = r, { builtinProtocols: y = ["http", "https", "tel", "mailto", "intent"] } = r, { extensions: p = /* @__PURE__ */ new Map() } = r, { onError: w = void 0 } = r, { onStat: E = void 0 } = r, { onSubmit: Q = void 0 } = r, { onCustomAction: J = void 0 } = r, { onComponent: M = void 0 } = r, { typefaceProvider: ge = (b) => "" } = r, { fetchInit: le = {} } = r, { tooltipRoot: H = void 0 } = r, { customComponents: ee = void 0 } = r, { direction: X = "ltr" } = r, { store: I = void 0 } = r, { pagerChildrenClipEnabled: P = !0 } = r, { pagerMouseDragEnabled: O = !0 } = r, { weekStartDay: U = 0 } = r, { videoPlayerProvider: me = void 0 } = r, { devtoolCreateHierarchy: nt = "lazy" } = r, _e = !0, Me = gi(u === "desktop");
  if (mn(t, Me, (b) => e(7, o = b)), u === "auto" && typeof matchMedia < "u") {
    const b = matchMedia("(any-pointer: coarse)");
    Me.set(!b.matches), b.addListener(() => {
      Me.set(!b.matches);
    });
  }
  let tt = "light", We = null;
  const Ne = gi(X === "rtl" ? "rtl" : "ltr");
  mn(t, Ne, (b) => e(8, s = b));
  function Ft() {
    c !== "system" || !We || e(41, tt = We.matches ? "dark" : "light");
  }
  function Ve(b) {
    e(12, c = b);
  }
  function Oe() {
    return /* @__PURE__ */ new Map();
  }
  function Pe() {
    return /* @__PURE__ */ new Map();
  }
  function yt(b) {
    e(11, l = b);
  }
  function ye(b) {
    return Wt(b, Xe);
  }
  const Ke = new Set(y);
  let je = !1, te = !1;
  a || (te = !0, Xe(R(new Error('"id" prop is required'))));
  const ot = { stateChange: !1 }, ce = f || new _d(), pt = ce.getLastAddedVariableStore(), Ct = ce.getVariables(), re = /* @__PURE__ */ new Map(), $ = /* @__PURE__ */ new Map(), pe = /* @__PURE__ */ new Map(), Bt = /* @__PURE__ */ new Map();
  let De = null;
  const ft = /* @__PURE__ */ new Map();
  let Mt = 0, He = [];
  const ht = /* @__PURE__ */ new Set();
  let qt;
  const fe = [];
  function Vt(b) {
    return g == null ? void 0 : g[b];
  }
  function be(b, k, { additionalVars: j, keepComplex: N = !1, customFunctions: D, emptyVarsError: Ue } = {}) {
    var Se;
    if (!k)
      return Ji(k);
    const de = Ci($, j), _t = Kc(k, b, I, U);
    if (!_t.vars.length)
      if (_t.hasExpression) {
        const Pt = _t.applyVars(de, D);
        if (!((Se = Pt.usedVars) != null && Se.size))
          return Ue && Ue(), Ji(Pt.result);
      } else
        return Ue && Ue(), Ji(k);
    const at = _t.vars.map((Pt) => de.get(Pt) || vt(Pt)).filter(ki);
    return gi(void 0, (Pt) => {
      const ct = /* @__PURE__ */ new Map();
      let fr;
      const Fr = () => {
        var tn;
        const Mr = _t.applyVars(de, D, N);
        for (const [fn, yn] of ct)
          (tn = Mr.usedVars) != null && tn.has(fn) || (yn(), ct.delete(fn));
        if (Mr.usedVars) {
          for (const fn of Mr.usedVars)
            if (!ct.has(fn)) {
              let yn = !0;
              ct.set(fn, fn.subscribe(() => {
                yn || Pt(Fr()), yn = !1;
              }));
            }
        }
        return Mr.result;
      };
      return fr = bo(at, Fr).subscribe((Mr) => {
        Pt(Mr);
      }), () => {
        fr == null || fr();
        for (const [Mr, tn] of ct)
          tn();
      };
    });
  }
  function $e(b, k, j, N = !1, D = void 0) {
    const Ue = Kc(k, b, I, U);
    if (!Ue.hasExpression)
      return k;
    const de = Ci($, j);
    return Ue.applyVars(de, D, N).result;
  }
  function Ce(b, k, j) {
    const N = /* @__PURE__ */ new Map(), D = Zo(b, "dict", k);
    N.set(b, D);
    const Ue = Zo("index", "integer", j);
    return N.set("index", Ue), N;
  }
  function Xe(b) {
    w ? w({ error: b }) : (b == null ? void 0 : b.level) === "warn" ? console.warn(b) : console.error(b);
  }
  function Jt(b, k) {
    E && E({ type: b, action: k });
  }
  function bt(b) {
    return b in n;
  }
  function Qt(b, k) {
    if (!b)
      return { json: b, templateContext: k };
    const j = /* @__PURE__ */ new Set([b.type]);
    for (; b.type && b.type in n; ) {
      if ({ json: b, templateContext: k } = W1(b, k, n, Xe), j.has(b.type))
        return { json: b, templateContext: k };
      j.add(b.type);
    }
    return { json: b, templateContext: k };
  }
  function rt({ type: b, node: k, json: j, origJson: N, templateContext: D, componentContext: Ue, devapi: de }) {
    M && M({
      type: b,
      node: k,
      json: j,
      origJson: N,
      templateContext: D,
      componentContext: Ue,
      devapi: de
    });
  }
  let ir = 0;
  function W(b) {
    return `${a}-${ir++}`;
  }
  function Et(b) {
    return `divkit-${W()}`;
  }
  let It = {}, Ye = {};
  function L(b, k) {
    const j = `${b}:${k}`;
    if (Ye[j] = Ye[j] || 0, ++Ye[j], It[j])
      return It[j];
    const N = `${W()}-svg-filter`;
    return e(5, It = { ...It, [j]: N }), N;
  }
  function Le(b, k) {
    if (!b)
      return;
    const j = `${b}:${k}`;
    Ye[j] && --Ye[j] === 0 && e(5, It = Object.keys(It).reduce(
      (N, D) => (Ye[D] && (N[D] = It[D]), N),
      {}
    ));
  }
  const gt = W() + "-id-", qe = /* @__PURE__ */ new Map(), Te = /* @__PURE__ */ new Map();
  function cr(b) {
    return gt + b;
  }
  function ke(b, k) {
    let j = qe.get(b) || [];
    return qe.has(b) || qe.set(b, j), j.push(k), () => {
      j = j.filter((D) => D !== k), j.length || qe.delete(b);
      const N = cr(b);
      Te.has(N) && Te.delete(N);
    };
  }
  function hr(b) {
    var j, N;
    const k = (N = (j = qe.get(b)) == null ? void 0 : j[0]) == null ? void 0 : N.node();
    if (k) {
      const D = cr(b), Ue = Te.get(D);
      return Ue && Ue !== k && Ue.removeAttribute("id"), k.setAttribute("id", D), Te.set(D, k), D;
    }
    return "";
  }
  async function ie(b, k) {
    var de, _t;
    if (!b)
      throw new Error("Missing state id");
    let j = b.split("/");
    const N = j.length % 2 === 0 && Xw(k);
    let D = N || Ur;
    const Ue = (k == null ? void 0 : k.logError) || Xe;
    if (!N)
      if ((de = D.states) != null && de.root) {
        const at = D.states.root;
        if (at.length > 1) {
          Ue(R(new Error("Error resolving state. Found multiple elements that respond to path"), { additional: { stateId: b } }));
          return;
        }
        if (D = await at[0](j[0]), !D)
          return;
        j = j.slice(1);
      } else
        return;
    for (let at = 0; at < j.length; at += 2) {
      const Se = j[at], Pt = j[at + 1];
      if ((_t = D.states) != null && _t[Se]) {
        const ct = D.states[Se];
        if (ct.length > 1) {
          Ue(R(new Error("Error resolving state. Found multiple elements that respond to path"), { additional: { stateId: b } }));
          return;
        }
        if (D = await ct[0](Pt), !D)
          return;
      } else
        return;
    }
  }
  async function ze(b, k, j) {
    var fr;
    const N = (b == null ? void 0 : b.logError) || Xe;
    if (!ev(k)) {
      N(R(new Error("Incorrect submit action"), {
        additional: { containerId: k.container_id }
      }));
      return;
    }
    const D = qe.get(k.container_id);
    if ((D == null ? void 0 : D.length) !== 1) {
      N(R(new Error("Error resolving container. Found multiple elements that respond to id"), {
        additional: { containerId: k.container_id }
      }));
      return;
    }
    const Ue = D[0].context(), de = {};
    if (Ue.variables)
      for (const [Fr, Mr] of Ue.variables) {
        const tn = Mr.getValue();
        typeof tn == "bigint" ? de[Fr] = Number(tn) : de[Fr] = tn;
      }
    if (Q) {
      Promise.resolve().then(() => Q(k, de)).then(() => {
        Ut(j.on_success_actions, { componentContext: b });
      }).catch(() => {
        Ut(j.on_fail_actions, { componentContext: b });
      });
      return;
    }
    const _t = Object.keys(de).length > 0, at = (k.request.method || "post").toLowerCase();
    if ((at === "get" || at === "head") && _t) {
      N(R(new Error("Can't send variables using the get/head method."), { additional: { url: k.request.url } }));
      return;
    }
    let Se = !1;
    const Pt = [];
    (fr = k.request.headers) == null || fr.forEach((Fr) => {
      Pt.push([Fr.name, Fr.value]), Fr.name.toLowerCase() === "content-type" && (Se = !0);
    }), Se || Pt.push(["Content-Type", "application/json"]);
    let ct;
    typeof le == "function" ? ct = le(k.request.url) : ct = le, fetch(k.request.url, {
      ...ct,
      method: at,
      headers: Pt,
      body: _t ? JSON.stringify(de) : void 0
    }).then((Fr) => {
      if (!Fr.ok)
        throw new Error("Response is not ok");
      Ut(j.on_success_actions, { componentContext: b });
    }).catch((Fr) => {
      N(R(new Error("Failed to submit"), {
        additional: {
          url: k.request.url,
          originalError: Fr
        }
      })), Ut(j.on_fail_actions, { componentContext: b });
    });
  }
  function Ot(b, k) {
    var D, Ue, de, _t, at, Se, Pt, ct, fr;
    const j = (b == null ? void 0 : b.logError) || Xe, N = k.id && Ze(k.id);
    if (!N) {
      j(R(new Error('Missing component for "scroll_to" action'), { additional: { id: k.id } }));
      return;
    }
    if (k.animated !== void 0 && typeof k.animated != "boolean") {
      j(R(new Error('Missing properties for "scroll_to" action'), { additional: { id: k.id } }));
      return;
    }
    switch ((D = k.destination) == null ? void 0 : D.type) {
      case "index": {
        typeof k.destination.value == "number" && N.setCurrentItem(k.destination.value, (Ue = k.animated) != null ? Ue : !0);
        break;
      }
      case "offset": {
        typeof k.destination.value == "number" && ((_t = N.scrollToPosition) == null || _t.call(N, k.destination.value, (de = k.animated) != null ? de : !0));
        break;
      }
      case "start": {
        (Se = N.scrollToStart) == null || Se.call(N, (at = k.animated) != null ? at : !0);
        break;
      }
      case "end": {
        (ct = N.scrollToEnd) == null || ct.call(N, (Pt = k.animated) != null ? Pt : !0);
        break;
      }
      default:
        j(R(new Error('Unknown destination for "scroll_to" action'), {
          additional: {
            id: k.id,
            destination: (fr = k.destination) == null ? void 0 : fr.type
          }
        }));
    }
  }
  function Yt(b, k) {
    var D;
    const j = (b == null ? void 0 : b.logError) || Xe, N = k.id && Ze(k.id);
    if (!N) {
      j(R(new Error('Missing component for "scroll_by" action'), { additional: { id: k.id } }));
      return;
    }
    if (typeof k.item_count != "number" && k.item_count !== void 0 || typeof k.offset != "number" && k.offset !== void 0 || k.overflow !== void 0 && k.overflow !== "clamp" && k.overflow !== "ring" || k.animated !== void 0 && typeof k.animated != "boolean") {
      j(R(new Error('Missing properties for "scroll_by" action'), { additional: { id: k.id } }));
      return;
    }
    (D = N.scrollCombined) == null || D.call(N, {
      step: k.item_count,
      offset: k.offset,
      overflow: k.overflow,
      animated: k.animated
    });
  }
  function Ht(b, k, { item: j, step: N, overflow: D, animated: Ue }) {
    var Pt, ct, fr, Fr, Mr;
    if (!k)
      throw new Error(`Missing id for "${b}" action`);
    const de = Number(j);
    if (b === "set_current_item" && Number.isNaN(de))
      throw new Error(`Incorrect item for "${b}" action`);
    let _t = Number(N);
    if (!N && (b === "set_previous_item" || b === "set_next_item") && (_t = 1), !N && (b === "scroll_backward" || b === "scroll_forward" || b === "scroll_to_position") || Number.isNaN(_t))
      throw new Error(`Incorrect step value for "${b}" action`);
    if (D && D !== "clamp" && D !== "ring")
      throw new Error(`Incorrect overflow value for "${b}" action`);
    D = D || "clamp";
    const at = Ue === null || Ue !== "0" && Ue !== "false", Se = Ze(k);
    if (Se)
      switch (b) {
        case "set_current_item":
          Se.setCurrentItem(de, at);
          return;
        case "set_previous_item":
          Se.setPreviousItem(_t, D, at);
          return;
        case "set_next_item":
          Se.setNextItem(_t, D, at);
          return;
        case "scroll_to_start":
          (Pt = Se.scrollToStart) == null || Pt.call(Se, at);
          return;
        case "scroll_to_end":
          (ct = Se.scrollToEnd) == null || ct.call(Se, at);
          return;
        case "scroll_backward":
          (fr = Se.scrollCombined) == null || fr.call(Se, {
            offset: -_t,
            overflow: D,
            animated: at
          });
          return;
        case "scroll_forward":
          (Fr = Se.scrollCombined) == null || Fr.call(Se, {
            offset: _t,
            overflow: D,
            animated: at
          });
          return;
        case "scroll_to_position":
          (Mr = Se.scrollToPosition) == null || Mr.call(Se, _t, at);
          return;
      }
  }
  function wt(b, k, j) {
    const N = (j == null ? void 0 : j.logError) || Xe;
    if (b) {
      const D = Ze(b);
      D ? k === "start" ? D.start() : k === "pause" ? D.pause() : N(R(new Error("Unknown video action"), { additional: { id: b, action: k } })) : N(R(new Error("Video component is not found"), { additional: { id: b, action: k } }));
    } else
      N(R(new Error("Missing id in video action"), { additional: { action: k } }));
  }
  function Wt(b, k, j) {
    var N, D, Ue;
    if (b.templates)
      for (const de in b.templates)
        n.hasOwnProperty(de) || (n[de] = b.templates[de]);
    if (Array.isArray((N = b.patch) == null ? void 0 : N.changes)) {
      if (b.patch.mode === "transactional") {
        const de = b.patch.changes.find((_t) => {
          const at = yr.get(_t.id);
          if (!at)
            return !0;
          const Se = Array.isArray(_t.items) ? _t.items.length : 0;
          return !!(at.isSingleMode && Se !== 1);
        });
        if (de)
          return k(R(new Error("Skipping transactional, child is not found or broken"), { additional: { url: j, id: de.id } })), Ut((D = b.patch) == null ? void 0 : D.on_failed_actions), !1;
      }
      return b.patch.changes.forEach((de) => {
        const _t = yr.get(de.id);
        _t && _t.replaceWith(de.id, de.items);
      }), Ut((Ue = b.patch) == null ? void 0 : Ue.on_applied_actions), !0;
    }
    return !1;
  }
  function Lt(b, k, j) {
    const N = (j == null ? void 0 : j.logError) || Xe;
    if (b) {
      let D;
      typeof le == "function" ? D = le(b) : D = le, fetch(b, D).then((Ue) => {
        if (!Ue.ok)
          throw new Error("Response is not ok");
        return Ue.json();
      }).then((Ue) => {
        if (!Ue) {
          N(R(new Error("Incorrect patch"), { additional: { url: b } })), Ut(k == null ? void 0 : k.on_fail_actions, { componentContext: j });
          return;
        }
        Wt(Ue, N, b) ? Ut(k == null ? void 0 : k.on_success_actions, { componentContext: j }) : Ut(k == null ? void 0 : k.on_fail_actions, { componentContext: j });
      }).catch((Ue) => {
        N(R(new Error("Failed to download the patch"), { additional: { url: b, originalError: Ue } })), Ut(k == null ? void 0 : k.on_fail_actions, { componentContext: j });
      });
    } else
      N(R(new Error("Missing url in download action"), { additional: { url: b } }));
  }
  function Gt(b, k, j) {
    var _t;
    const N = (j == null ? void 0 : j.logError) || Xe;
    if (!b) {
      N(R(new Error("Missing id in show_tooltip action")));
      return;
    }
    const D = kr.get(b);
    if (!D) {
      N(R(new Error("Tooltip with the provided id is not found"), { additional: { id: b } }));
      return;
    }
    if (k !== "true" && k !== !0 && ht.has(b))
      return;
    ht.add(b);
    const Ue = {
      internalId: ++Mt,
      ownerNode: D.onwerNode,
      desc: D.tooltip,
      timeoutId: 0,
      componentContext: j
    };
    e(3, He = [...He, Ue]);
    const de = (_t = D.tooltip.duration) != null ? _t : 5e3;
    de && (Ue.timeoutId = window.setTimeout(
      () => {
        Ue.timeoutId = 0, e(3, He = He.filter((at) => at.internalId !== Ue.internalId));
      },
      de
    ));
  }
  function tr(b, k) {
    const j = (k == null ? void 0 : k.logError) || Xe;
    if (!b) {
      j(R(new Error("Missing id in hide_tooltip action")));
      return;
    }
    e(3, He = He.filter((N) => {
      const D = N.desc.id !== b;
      return !D && N.timeoutId && (clearTimeout(N.timeoutId), N.timeoutId = null), D;
    }));
  }
  function or(b, k, j, N, D) {
    const Ue = (b == null ? void 0 : b.logError) || Xe;
    if (!I) {
      Ue(R(new Error("Store is not configured")));
      return;
    }
    let de = j;
    if (!k || !de || !N || !D) {
      Ue(R(new Error("Missing required params for set_stored_value")));
      return;
    }
    if (!Fv.has(N)) {
      Ue(R(new Error("Incorrect stored type")));
      return;
    }
    if (N === "boolean" && (de = de === "true" || de === "1"), I.set)
      I.set(k, N, de, Number(D));
    else if (I.setValue) {
      if (!Tv.has(N)) {
        Ue(R(new Error("Incorrect stored type")));
        return;
      }
      if (typeof de != "string" && typeof de != "number" && typeof de != "boolean") {
        Ue(R(new Error("Incorrect stored value")));
        return;
      }
      (N === "integer" || N === "number") && (de = Number(de)), I.setValue(k, N, de, Number(D));
    }
  }
  function mr(b) {
    zt($e(Xe, b, void 0, !0), b);
  }
  async function zt(b, k, j) {
    var _t, at;
    const N = b.scope_id, D = (j == null ? void 0 : j.logError) || Xe;
    if (N) {
      const Se = Ir.get(N);
      if (Se && (Se == null ? void 0 : Se.size) > 1)
        D(R(new Error(`Ambiguous scope id. There are ${Se.size} divs with id '${N}'`), { additional: { count: Se.size, scopeId: N } }));
      else if ((Se == null ? void 0 : Se.size) === 1) {
        const Pt = Se.values().next().value;
        Pt && (j = Pt);
      } else {
        D(R(new Error("The scope with the specified scope_id is missing"), { additional: { scopeId: N } }));
        return;
      }
    }
    const Ue = b.url ? String(b.url) : "", de = b.typed;
    if (ys(b)) {
      if (de)
        switch (de.type) {
          case "set_variable": {
            const { variable_name: Se, value: Pt } = de;
            if (Se && Pt) {
              const ct = (j == null ? void 0 : j.getVariable(Se)) || $.get(Se);
              ct ? ct.getType() === Pt.type ? ct.setValue(Pt.value) : D(R(new Error("Trying to set value with invalid type"), { additional: { name: Se, type: Pt.type } })) : D(R(new Error("Cannot find variable"), { additional: { name: Se } }));
            } else
              D(R(new Error("Incorrect set_variable action"), { additional: { name: Se } }));
            break;
          }
          case "array_insert_value":
            Ww(j, $, D, de);
            break;
          case "array_remove_value":
            Uw(j, $, D, de);
            break;
          case "array_set_value":
            Gw(j, $, D, de);
            break;
          case "copy_to_clipboard":
            qw(D, de);
            break;
          case "focus_element": {
            const Se = de.element_id && jr.get(de.element_id);
            Se ? Se.focus() : D(R(new Error("Incorrect focus_element action"), {
              additional: { elementId: de.element_id }
            }));
            break;
          }
          case "clear_focus": {
            try {
              document.activeElement instanceof HTMLElement && document.activeElement.blur();
            } catch {
            }
            break;
          }
          case "dict_set_value": {
            Yw(j, $, D, de);
            break;
          }
          case "animator_start": {
            const Se = de.animator_id && (j == null ? void 0 : j.getAnimator(de.animator_id));
            if (!Se) {
              D(R(new Error("Missing animator"), {
                additional: { animator_id: de.animator_id }
              }));
              return;
            }
            const { duration: Pt, start_delay: ct, interpolator: fr, direction: Fr, repeat_count: Mr, start_value: tn, end_value: fn } = de, yn = j ? j.getJsonWithVars(Se) : $e(Xe, Se), ri = {
              ...yn,
              end_actions: Se.end_actions,
              cancel_actions: Se.cancel_actions,
              duration: Pt !== void 0 ? Pt : yn.duration,
              start_delay: ct !== void 0 ? ct : yn.start_delay,
              interpolator: fr !== void 0 ? fr : yn.interpolator,
              direction: Fr !== void 0 ? Fr : yn.direction,
              repeat_count: Mr !== void 0 ? Mr : yn.repeat_count,
              start_value_typed: tn,
              end_value_typed: fn
            }, Wn = Se.variable_name && ((j == null ? void 0 : j.getVariable(Se.variable_name)) || $.get(Se.variable_name));
            if (!Wn)
              return;
            const In = ft.get(Se.id);
            In && In.stop();
            const St = Kw(
              ri,
              Wn,
              () => {
                ft.delete(Se.id);
              },
              (h, A) => ((j == null ? void 0 : j.execAnyActions) || Ut)(h, A)
            );
            St && ft.set(Se.id, St);
            break;
          }
          case "animator_stop": {
            const Se = ft.get(de.animator_id);
            Se && (Se.stop(), ft.delete(de.animator_id));
            break;
          }
          case "show_tooltip": {
            Gt(de.id, de.multiple, j);
            break;
          }
          case "hide_tooltip": {
            tr(de.id, j);
            break;
          }
          case "timer": {
            De ? De.execTimerAction(de.id, de.action) : D(R(new Error("Incorrect timer action"), {
              additional: {
                id: de.id,
                action: de.action
              }
            }));
            break;
          }
          case "download": {
            Lt(de.url, k.typed, j);
            break;
          }
          case "video": {
            wt(de.id, de.action, j);
            break;
          }
          case "set_stored_value": {
            or(j, de.name, (_t = de.value) == null ? void 0 : _t.value, (at = de.value) == null ? void 0 : at.type, de.lifetime);
            break;
          }
          case "set_state": {
            await ie(de.state_id, j);
            break;
          }
          case "submit": {
            await ze(j, de, k.typed);
            break;
          }
          case "scroll_to": {
            Ot(j, de);
            break;
          }
          case "scroll_by": {
            Yt(j, de);
            break;
          }
          case "update_structure": {
            tv(j, $, D, de);
            break;
          }
          default:
            D(R(new Error("Unknown type of action"), { additional: { type: de.type } }));
        }
      else if (Ue)
        try {
          const Se = Ue.replace(/div-action:\/\//, ""), Pt = /([^?]+)\?(.+)/.exec(Se);
          if (!Pt)
            return;
          const ct = new URLSearchParams(Pt[2]);
          switch (Pt[1]) {
            case "set_state":
              await ie(ct.get("state_id"), j);
              break;
            case "set_current_item":
            case "set_previous_item":
            case "set_next_item":
            case "scroll_to_start":
            case "scroll_to_end":
            case "scroll_backward":
            case "scroll_forward":
            case "scroll_to_position":
              Ht(Pt[1], ct.get("id"), {
                item: ct.get("item"),
                step: ct.get("step"),
                overflow: ct.get("overflow"),
                animated: ct.get("animated")
              });
              break;
            case "set_variable":
              const fr = ct.get("name"), Fr = ct.get("value");
              if (fr && Fr !== null) {
                const fn = (j == null ? void 0 : j.getVariable(fr)) || $.get(fr);
                fn ? fn.set(Fr) : D(R(new Error("Cannot find variable"), { additional: { name: fr } }));
              } else
                D(R(new Error("Incorrect set_variable_action"), { additional: { url: Se } }));
              break;
            case "timer":
              const Mr = ct.get("action"), tn = ct.get("id");
              De ? De.execTimerAction(tn, Mr) : D(R(new Error("Incorrect timer action"), {
                additional: { id: tn, action: Mr }
              }));
              break;
            case "video":
              wt(ct.get("id"), ct.get("action"), j);
              break;
            case "download":
              Lt(ct.get("url"), k.download_callbacks, j);
              break;
            case "show_tooltip":
              Gt(ct.get("id"), ct.get("multiple"), j);
              break;
            case "hide_tooltip":
              tr(ct.get("id"), j);
              break;
            case "set_stored_value": {
              or(j, ct.get("name"), ct.get("value"), ct.get("type"), ct.get("lifetime"));
              break;
            }
            default:
              D(R(new Error("Unknown type of action"), { additional: { url: Ue } }));
          }
        } catch (Se) {
          D(R(Se, { additional: { url: Ue } }));
        }
    }
  }
  async function Ut(b, k = {}) {
    var Ue;
    if (!b || !Array.isArray(b))
      return;
    const j = ((Ue = k.componentContext) == null ? void 0 : Ue.logError) || Xe, N = (de) => k.componentContext ? k.componentContext.getJsonWithVars(de, k.additionalVars, !0) : $e(j, de, k.additionalVars, !0), D = b.filter((de) => {
      const _t = N(de.is_enabled);
      return _t !== 0 && _t !== !1;
    });
    for (let de = 0; de < D.length; ++de) {
      let _t = N(D[de]);
      const at = _t.url;
      if (_t.typed)
        await zt(_t, D[de], k.componentContext);
      else if (at) {
        const Pt = al(at);
        if (Pt)
          if (ul(Pt, Ke)) {
            if (k.processUrls)
              if (_t.target === "_blank") {
                const ct = window.open("", "_blank");
                ct && (ct.opener = null, ct.location = at);
              } else
                location.href = at;
          } else
            Pt === "div-action" ? (await zt(_t, D[de], k.componentContext), await jn()) : _t.log_id && (st(_t), await jn());
      } else
        k.node && Array.isArray(_t.menu_items) && _t.menu_items.length && e(4, qt = {
          items: _t.menu_items,
          node: k.node,
          componentContext: k.componentContext
        });
    }
    D.forEach((de) => {
      de.log_id && Jt(k.logType || "click", de);
    });
  }
  function st(b) {
    J == null || J(b);
  }
  function et(b, k) {
    const j = (b == null ? void 0 : b.logError) || Xe;
    if (!Array.isArray(k) || !k.length)
      return;
    const N = [];
    return k.forEach((D) => {
      let Ue = !1;
      if (typeof D.condition != "string") {
        j(R(new Error("variable_trigger has a condition that is not a string"), {
          additional: { condition: D.condition }
        }));
        return;
      }
      if (!Array.isArray(D.actions)) {
        j(R(new Error("variable_trigger has no actions"), {
          additional: { condition: D.condition }
        }));
        return;
      }
      const de = D.mode || "on_condition";
      if (de !== "on_variable" && de !== "on_condition") {
        j(R(new Error("variable_trigger has an unsupported mode"), { additional: { mode: de } }));
        return;
      }
      const at = be(j, { condition: D.condition }, {
        additionalVars: b == null ? void 0 : b.variables,
        customFunctions: b == null ? void 0 : b.customFunctions,
        emptyVarsError: () => {
          j(R(new Error("variable_trigger must have variables in the condition"), {
            additional: { condition: D.condition }
          }));
        }
      }).subscribe(async (Se) => {
        Se.condition !== void 0 && (// if condition is truthy
        Se.condition && // and trigger mode matches
        (de === "on_variable" || de === "on_condition" && Ue === !1) ? (Ue = !!Se.condition, b ? await b.execAnyActions(D.actions, { logType: "trigger" }) : await Ut(D.actions, { logType: "trigger" })) : Ue = !!Se.condition);
      });
      N.push(at);
    }), () => {
      N.forEach((D) => {
        D();
      });
    };
  }
  function nr(b) {
    return ot[b];
  }
  function Ar(b, k) {
    ot[b] = k;
  }
  const br = /* @__PURE__ */ new Map(), yr = /* @__PURE__ */ new Map(), jr = /* @__PURE__ */ new Map(), kr = /* @__PURE__ */ new Map(), Ir = /* @__PURE__ */ new Map();
  function gr(b, k, j = "error") {
    if (br.has(b)) {
      Xe(R(new Error("Duplicate instance id"), {
        level: j,
        additional: { id: b }
      }));
      return;
    }
    br.set(b, k);
  }
  function Er(b) {
    br.delete(b);
  }
  function Ze(b) {
    if (!br.has(b)) {
      Xe(R(new Error("Missing instance with id"), { additional: { id: b } }));
      return;
    }
    return br.get(b);
  }
  function ne(b, k) {
    yr.set(b, k);
  }
  function we(b) {
    yr.delete(b);
  }
  function it(b, k) {
    jr.set(b, k);
  }
  function ut(b) {
    jr.delete(b);
  }
  function dt(b, k) {
    const j = k.id;
    j && (kr.has(j) && Xe(R(new Error("Duplicate tooltip id"), { additional: { id: j } })), kr.set(j, { onwerNode: b, tooltip: k }));
  }
  function Cr(b) {
    const k = b.id;
    k && (kr.delete(k), He.some((j) => j.desc.id === k) && e(3, He = He.filter((j) => j.desc.id !== k)));
  }
  function vt(b) {
    const k = pe.get(b) || gi(void 0);
    return pe.has(b) || pe.set(b, k), k;
  }
  function v(b, k, j) {
    const N = Bt.get(b);
    if (N)
      return N;
    const D = mi(b, k, j);
    return Bt.set(b, D), D;
  }
  function V() {
    if (!sr)
      return;
    sr[tt].forEach((k) => {
      const j = $.get(k.name);
      j && j.setValue(k.color);
    });
  }
  function Y() {
    return Ke;
  }
  function he(b, k) {
    const j = p.get(b);
    if (j)
      return new j(k || {});
  }
  function d(b) {
    return {
      variables: Ci($, b.variables),
      derviedExpression(k) {
        return b.getDerivedFromVars(k);
      },
      processExpressions(k) {
        return b.getJsonWithVars(k);
      },
      execAction: mr,
      logError: Xe,
      getComponentProperty(k) {
        return b.getJsonWithVars(b.json[k]);
      },
      direction: X
    };
  }
  function G(b, k) {
    const j = /* @__PURE__ */ new Map(), N = (k == null ? void 0 : k.logError) || Xe;
    return b.forEach((D) => {
      if (j) {
        try {
          Mw(D);
        } catch (_t) {
          N(R(_t));
          return;
        }
        const Ue = D, de = j.get(Ue.name) || [];
        de.push(Pw(Ue)), j.set(Ue.name, de);
      }
    }), j;
  }
  function Ie(b) {
    const k = {
      id: "",
      json: {},
      path: [],
      templateContext: {},
      logError(j) {
        j.additional = j.additional || {}, j.additional.path = k.path.join("/"), Xe(j);
      },
      execAnyActions(j, N = {}) {
        return Ut(j, {
          componentContext: k,
          processUrls: N.processUrls,
          node: N.node,
          logType: N.logType,
          additionalVars: N.additionalVars
        });
      },
      getDerivedFromVars(j, N, D = !1) {
        return be(k.logError, j, {
          additionalVars: Ci(k.variables, N),
          keepComplex: D,
          customFunctions: k.customFunctions
        });
      },
      getJsonWithVars(j, N, D = !1) {
        return $e(k.logError, j, Ci(k.variables, N), D, k.customFunctions);
      },
      evalExpression(j, N, D) {
        return Xl(Ci($, k.variables), k.customFunctions, j, N, D);
      },
      produceChildContext(j, N = {}) {
        const D = Ie(this);
        let Ue = j, de = this.templateContext;
        const { templateContext: _t, json: at } = Qt(Ue, de);
        if (D.json = at, D.templateContext = _t, D.origJson = j, D.id = N.id || at.id || "", D.id) {
          let ct = Ir.get(D.id);
          ct || (ct = /* @__PURE__ */ new Set(), Ir.set(D.id, ct)), ct.add(D);
        }
        N.key && (D.key = N.key), N.path !== void 0 && D.path.push(String(N.path)), j.type && !N.isRootState && D.path.push(j.type), N.isTooltipRoot && (D.isTooltipRoot = !0);
        let Se;
        Array.isArray(at.variables) ? (Se = Ci(this.variables, Ci(N.variables, /* @__PURE__ */ new Map())), at.variables.forEach((ct) => {
          const fr = mt(ct, D, Se);
          fr && Se && Se.set(fr.getName(), fr);
        })) : N.variables ? Se = Ci(this.variables, N.variables) : this.variables && (Se = this.variables), D.variables = Se;
        let Pt;
        return Array.isArray(at.functions) && (Pt = G(at.functions, this)), D.customFunctions = Nw(this.customFunctions, Pt), Array.isArray(at.animators) && (D.animators = at.animators.reduce(
          (ct, fr) => (fr.id && (ct[fr.id] = fr), ct),
          {}
        )), N.fake && (D.fakeElement = N.fake), N.isRootState && (D.isRootState = !0), D;
      },
      dup(j) {
        return { ...k, fakeElement: j };
      },
      getVariable(j, N) {
        var Ue;
        const D = ((Ue = k.variables) == null ? void 0 : Ue.get(j)) || $.get(j);
        if (D) {
          const de = D.getType();
          if (N && de !== N) {
            k.logError(R(new Error(`Variable should have type "${N}"`), { additional: { name: j, foundType: de } }));
            return;
          }
        }
        return D;
      },
      getAnimator(j) {
        var N, D;
        return ((N = k.animators) == null ? void 0 : N[j]) || ((D = k.parent) == null ? void 0 : D.getAnimator(j)) || void 0;
      },
      registerState(j, N) {
        const D = Zw(k.parent);
        return D && (D.states = D.states || {}, D.states[j] = D.states[j] || [], D.states[j].push(N)), () => {
          var Ue;
          (Ue = D == null ? void 0 : D.states) != null && Ue[j] && (D.states[j] = D.states[j].filter((de) => de !== N), D.states[j].length || delete D.states[j]);
        };
      },
      registerPager(j) {
        const N = k.parent;
        return N ? (N.pagers = N.pagers || /* @__PURE__ */ new Map(), N.pagers.has(j) ? {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          update() {
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          destroy() {
          }
        } : (N.pagers.set(j, null), {
          update(D) {
            var at, Se;
            N.pagers && N.pagers.set(j, D);
            const Ue = j ? (at = N.pagerListeners) == null ? void 0 : at.get(j) : void 0, de = (Se = N.pagerListeners) == null ? void 0 : Se.get(void 0), _t = [...Ue || [], ...de || []];
            _t && _t.forEach((Pt) => {
              Pt(D);
            });
          },
          destroy() {
            N.pagers && N.pagers.delete(j);
          }
        })) : {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          update() {
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          destroy() {
          }
        };
      },
      listenPager(j, N) {
        var at, Se, Pt;
        let D = k.parent;
        for (; D && !(D.pagers && (j ? D.pagers.get(j) : (at = D.pagers) != null && at.size)); )
          D = D.parent;
        if (!D)
          return () => {
          };
        D.pagerListeners = k.pagerListeners || /* @__PURE__ */ new Map();
        const Ue = D.pagerListeners.get(j) || [];
        D.pagerListeners.has(j) || D.pagerListeners.set(j, Ue), Ue.push(N);
        const de = j || ((Se = D.pagers) == null ? void 0 : Se.keys().next().value) || void 0, _t = (Pt = D.pagers) == null ? void 0 : Pt.get(de);
        return _t && N(_t), () => {
          if (!D.pagerListeners)
            return;
          let ct = D.pagerListeners.get(de);
          ct && (ct = ct.filter((fr) => fr !== N) || [], ct.length ? D.pagerListeners.set(j, ct) : D.pagerListeners.delete(j));
        };
      },
      destroy() {
        const j = Ir.get(k.id);
        j && (j.delete(k), j.size || Ir.delete(k.id));
      }
    };
    return b ? (k.parent = b, k.path = b.path.slice(), b.fakeElement && (k.fakeElement = b.fakeElement)) : (k.json = { type: "root" }, k.isRootState = !0), k;
  }
  function Je(b) {
    _e ? fe.push(b) : clearTimeout(b);
  }
  Yi(_n, {
    logStat: Jt,
    hasTemplate: bt,
    genId: W,
    genClass: Et,
    execCustomAction: st,
    processVariableTriggers: et,
    isRunning: nr,
    setRunning: Ar,
    pagerChildrenClipEnabled: P,
    pagerMouseDragEnabled: O,
    registerInstance: gr,
    unregisterInstance: Er,
    registerParentOf: ne,
    unregisterParentOf: we,
    registerTooltip: dt,
    unregisterTooltip: Cr,
    onTooltipClose: ue,
    tooltipRoot: H,
    registerFocusable: it,
    unregisterFocusable: ut,
    addSvgFilter: L,
    removeSvgFilter: Le,
    registerId: ke,
    getComponentId: hr,
    preparePrototypeVariables: Ce,
    getCustomization: Vt,
    getBuiltinProtocols: Y,
    getExtension: he,
    getExtensionContext: d,
    registerTimeout: Je,
    typefaceProvider: ge,
    isDesktop: Me,
    isPointerFocus: Ql,
    customComponents: ee,
    direction: Ne,
    videoPlayerProvider: me,
    awaitGlobalVariable: v,
    componentDevtool: M ? rt : void 0,
    devtoolCreateHierarchy: M ? nt || "eager" : "lazy"
  }), Yi(Zi, {
    hasAction() {
      return !1;
    }
  }), Yi(Pl, {
    runVisibilityTransition(b, k, j, N, D) {
      return Promise.resolve();
    },
    registerChildWithTransitionIn(b, k, j, N) {
      return Promise.resolve();
    },
    registerChildWithTransitionOut(b, k, j, N) {
      return Promise.resolve();
    },
    registerChildWithTransitionChange(b, k, j, N) {
      return Promise.resolve();
    },
    hasTransitionChange(b) {
      return !1;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    registerChild(b) {
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    unregisterChild(b) {
    }
  }), Yi(zl, { isEnabled: Ji(!0) });
  function ar(b, k) {
    const j = $.get(b);
    return (j == null ? void 0 : j.getType()) === k;
  }
  function C(b, k) {
    const j = $.get(b);
    j ? j.setValue(k) : Xe(R(new Error("Cannot find variable"), { additional: { name: b } }));
  }
  function Qe(b, k, j) {
    const N = (k == null ? void 0 : k.logError) || Xe, D = b.name, Ue = b.value_type;
    if (typeof b.get != "string" || !b.get) {
      N(R(new Error("Incorrect property getter"), { additional: { name: D } }));
      return;
    }
    if (!D) {
      N(R(new Error("Missing property name")));
      return;
    }
    if (!Ue) {
      N(R(new Error("Missing property value_type")));
      return;
    }
    const de = k ? k.getDerivedFromVars(b.get, void 0, !0) : be(Xe, b.get, { keepComplex: !0 });
    if (ol(de) === void 0)
      return;
    const at = (Se) => {
      const Pt = Zo(b.new_value_variable_name || "new_value", b.value_type, Se), ct = new Map(j);
      ct.set(Pt.getName(), Pt), Array.isArray(b.set) && b.set.length ? k ? k.execAnyActions(b.set, { additionalVars: ct }) : Ut(b.set, { additionalVars: ct }) : N(R(new Error("Cannot set property. No setters provided."), { additional: { name: D } }));
    };
    return {
      getName() {
        return D;
      },
      subscribe(Se) {
        return de.subscribe(Se);
      },
      set(Se) {
        const Pt = lm(Se, Ue);
        at(Pt);
      },
      setValue: at,
      getValue() {
        return ol(de);
      },
      getType() {
        return Ue;
      }
    };
  }
  function mt(b, k, j) {
    if (b.type === "property")
      return Qe(b, k, j);
    if (!b.type || !b.name || !(b.type in pl) || !("value" in b))
      return;
    const N = b.value;
    let D = k ? k.getJsonWithVars(N, j, !0) : $e(Xe, N, j, !0);
    if (!(N && typeof N == "string" && D === void 0)) {
      b.type === "integer" && typeof D == "number" && (D > Number.MAX_SAFE_INTEGER || D < Number.MIN_SAFE_INTEGER) && Xe(R(new Error("The value of the integer variable could lose accuracy"), {
        level: "warn",
        additional: { name: b.name, value: D }
      }));
      try {
        return mi(b.name, b.type, D);
      } catch (Ue) {
        Xe(R(Ue, { additional: { name: b.name } }));
      }
    }
  }
  function lt(b) {
    const k = mt(b);
    k && (re.set(b.name, k), $.set(b.name, k));
  }
  for (const [b, k] of Ct)
    $.has(b) || $.set(b, k);
  const Dt = (Lr = l == null ? void 0 : l.card) == null ? void 0 : Lr.variables;
  Array.isArray(Dt) && Dt.forEach((b) => {
    if (b && b.name) {
      if (re.has(b.name)) {
        Xe(R(new Error("Duplicate variable"), { additional: { name: b.name } }));
        return;
      }
      lt(b);
    }
  });
  const sr = l.palette;
  sr && sr[tt].forEach((k) => {
    if (re.has(k.name)) {
      Xe(R(new Error("Duplicate variable"), { additional: { name: k.name } }));
      return;
    }
    try {
      const j = mi(k.name, "color", k.color);
      re.set(k.name, j), $.set(k.name, j);
    } catch (j) {
      Xe(R(j, { additional: { name: k.name } }));
    }
  }), pt.subscribe((b) => {
    if (b && !$.has(b)) {
      const k = Ct.get(b);
      $.set(b, k);
      const j = pe.get(b);
      if (j) {
        let D = 0;
        k.subscribe(() => {
          j.set(++D);
        });
      }
      const N = Bt.get(b);
      N && N.getType() === k.getType() && k.subscribe((D) => {
        N.set(D);
      });
    }
  });
  const Yr = () => {
    var b;
    et(void 0, (b = l == null ? void 0 : l.card) == null ? void 0 : b.variable_triggers);
  }, qr = (pn = l == null ? void 0 : l.card) == null ? void 0 : pn.timers;
  if (qr && typeof document < "u") {
    const b = De = new Hw({
      logError: Xe,
      applyVars: (k) => $e(Xe, k),
      hasVariableWithType: ar,
      setVariableValue: C,
      execAnyActions: Ut
    });
    qr.forEach((k) => b.createTimer(k));
  }
  const Ur = Ie();
  Array.isArray((Cn = l.card) == null ? void 0 : Cn.functions) && (Ur.customFunctions = G(l.card.functions));
  let Vn;
  function ue(b) {
    e(3, He = He.filter((k) => k.internalId !== b));
  }
  Jn(() => {
    Jo++, Jo === 1 && (window.addEventListener("keydown", lf), window.addEventListener("pointerdown", af)), jn().then(() => {
      _e && Yr();
    });
  }), bn(() => {
    _e = !1, Jo--, Jo || (window.removeEventListener("keydown", lf), window.removeEventListener("pointerdown", af));
    for (const [b, k] of ft)
      k.stop();
    De && De.destroy(), He.forEach((b) => {
      b.timeoutId && (clearTimeout(b.timeoutId), b.timeoutId = null);
    }), fe.forEach((b) => {
      clearTimeout(b);
    });
  });
  const ln = () => e(4, qt = void 0);
  return t.$$set = (b) => {
    "id" in b && e(13, a = b.id), "json" in b && e(11, l = b.json), "platform" in b && e(14, u = b.platform), "theme" in b && e(12, c = b.theme), "globalVariablesController" in b && e(15, f = b.globalVariablesController), "mix" in b && e(0, _ = b.mix), "customization" in b && e(16, g = b.customization), "builtinProtocols" in b && e(17, y = b.builtinProtocols), "extensions" in b && e(18, p = b.extensions), "onError" in b && e(19, w = b.onError), "onStat" in b && e(20, E = b.onStat), "onSubmit" in b && e(21, Q = b.onSubmit), "onCustomAction" in b && e(22, J = b.onCustomAction), "onComponent" in b && e(23, M = b.onComponent), "typefaceProvider" in b && e(24, ge = b.typefaceProvider), "fetchInit" in b && e(25, le = b.fetchInit), "tooltipRoot" in b && e(26, H = b.tooltipRoot), "customComponents" in b && e(27, ee = b.customComponents), "direction" in b && e(28, X = b.direction), "store" in b && e(29, I = b.store), "pagerChildrenClipEnabled" in b && e(30, P = b.pagerChildrenClipEnabled), "pagerMouseDragEnabled" in b && e(31, O = b.pagerMouseDragEnabled), "weekStartDay" in b && e(32, U = b.weekStartDay), "videoPlayerProvider" in b && e(33, me = b.videoPlayerProvider), "devtoolCreateHierarchy" in b && e(34, nt = b.devtoolCreateHierarchy);
  }, t.$$.update = () => {
    var b, k;
    if (t.$$.dirty[0] & /*theme*/
    4096 | t.$$.dirty[1] & /*themeQuery*/
    2048 && (c === "light" || c === "dark" ? e(41, tt = c) : c === "system" ? typeof matchMedia < "u" ? (We || (e(42, We = matchMedia("(prefers-color-scheme: dark)")), We.addListener(Ft)), e(41, tt = We.matches ? "dark" : "light")) : e(41, tt = "light") : Xe(R(new Error("Unsupported theme")))), t.$$.dirty[1] & /*currentTheme*/
    1024 && tt && V(), t.$$.dirty[0] & /*json*/
    2048) {
      e(1, je = !1);
      const j = zw(l);
      j && (e(1, je = !0), Xe(j));
    }
    if (t.$$.dirty[0] & /*json*/
    2048 && (n = l.templates || {}), t.$$.dirty[0] & /*json*/
    2048 && (b = l == null ? void 0 : l.card) != null && b.variables && Array.isArray(l.card.variables) && l.card.variables !== Dt && l.card.variables.forEach((j) => {
      j && j.name && !re.has(j.name) && !$.has(j.name) && lt(j);
    }), t.$$.dirty[0] & /*json*/
    2048 && e(44, i = (k = l == null ? void 0 : l.card) == null ? void 0 : k.states), t.$$.dirty[0] & /*hasError, hasIdError*/
    6 | t.$$.dirty[1] & /*states, rootComponentContext*/
    12288 && i && !je && !te) {
      const j = {
        type: "state",
        id: "root",
        width: { type: "match_parent" },
        height: { type: "match_parent" },
        states: i.map((N) => ({
          state_id: N.state_id.toString(),
          div: N.div
        }))
      };
      e(6, Vn = Ur.produceChildContext(j, { isRootState: !0 }));
    }
  }, [
    _,
    je,
    te,
    He,
    qt,
    It,
    Vn,
    o,
    s,
    Me,
    Ne,
    l,
    c,
    a,
    u,
    f,
    g,
    y,
    p,
    w,
    E,
    Q,
    J,
    M,
    ge,
    le,
    H,
    ee,
    X,
    I,
    P,
    O,
    U,
    me,
    nt,
    Ve,
    Oe,
    Pe,
    yt,
    ye,
    mr,
    tt,
    We,
    Ur,
    i,
    ln
  ];
}
class Nv extends $r {
  constructor(r) {
    super(), xr(
      this,
      r,
      Pv,
      Dv,
      Vr,
      {
        id: 13,
        json: 11,
        platform: 14,
        theme: 12,
        globalVariablesController: 15,
        mix: 0,
        customization: 16,
        builtinProtocols: 17,
        extensions: 18,
        onError: 19,
        onStat: 20,
        onSubmit: 21,
        onCustomAction: 22,
        onComponent: 23,
        typefaceProvider: 24,
        fetchInit: 25,
        tooltipRoot: 26,
        customComponents: 27,
        direction: 28,
        store: 29,
        pagerChildrenClipEnabled: 30,
        pagerMouseDragEnabled: 31,
        weekStartDay: 32,
        videoPlayerProvider: 33,
        devtoolCreateHierarchy: 34,
        setTheme: 35,
        getDebugVariables: 36,
        getDebugAllVariables: 37,
        setData: 38,
        applyPatch: 39,
        execAction: 40
      },
      null,
      [-1, -1, -1, -1, -1]
    );
  }
  get setTheme() {
    return this.$$.ctx[35];
  }
  get getDebugVariables() {
    return this.$$.ctx[36];
  }
  get getDebugAllVariables() {
    return this.$$.ctx[37];
  }
  get setData() {
    return this.$$.ctx[38];
  }
  get applyPatch() {
    return this.$$.ctx[39];
  }
  get execAction() {
    return this.$$.ctx[40];
  }
}
const zv = 8;
class Bv {
  constructor(r) {
    dr(this, "widthVariableName");
    dr(this, "heightVariableName");
    dr(this, "resizeObserver");
    dr(this, "context");
    dr(this, "node");
    dr(this, "sizeHistory", {});
    this.widthVariableName = r.width_variable_name, this.heightVariableName = r.height_variable_name;
  }
  setVariable(r, e) {
    if (!this.context)
      return !1;
    if (r) {
      const n = this.context.variables.get(r);
      if (n && n.getType() === "integer") {
        if (e = Math.round(e), this.sizeHistory[r] || (this.sizeHistory[r] = /* @__PURE__ */ new Set()), !this.sizeHistory[r].has(e))
          return n.setValue(e), this.sizeHistory[r].add(e), !0;
      } else {
        const i = new Error("Missing variable");
        i.level = "error", i.additional = {
          variableName: r
        }, this.context.logError(i);
      }
    }
    return !1;
  }
  recalcProps() {
    if (!this.node || !this.context)
      return !1;
    const r = this.node.getBoundingClientRect(), e = this.setVariable(this.widthVariableName, r.width), n = this.setVariable(this.heightVariableName, r.height);
    return e || n;
  }
  mountView(r, e) {
    var n;
    this.node = r, this.context = e, !this.resizeObserver && typeof ResizeObserver < "u" && (this.resizeObserver = new ResizeObserver(async () => {
      let i = 0;
      for (; this.recalcProps(); ) {
        if (++i > zv) {
          const o = new Error("Recursive layout in size_provider");
          o.level = "warn", o.additional = {
            widthVariableName: this.widthVariableName,
            heightVariableName: this.heightVariableName
          }, e.logError(o);
          break;
        }
        await jn();
      }
      this.sizeHistory = {};
    })), (n = this.resizeObserver) == null || n.observe(r), this.recalcProps();
  }
  unmountView(r, e) {
    var n;
    (n = this.resizeObserver) == null || n.disconnect(), this.resizeObserver = void 0;
  }
}
const so = 8;
class Hv {
  constructor(r) {
    dr(this, "context");
    dr(this, "params");
    dr(this, "startCoords");
    this.params = r, this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this);
  }
  processActions(r) {
    const e = this.params[r];
    Array.isArray(e) && e.length && this.context && this.context.processExpressions(e).forEach((i) => {
      var o;
      (o = this.context) == null || o.execAction(i);
    });
  }
  onPointerDown(r) {
    this.startCoords = {
      pageX: r.pageX,
      pageY: r.pageY
    };
  }
  onPointerMove(r) {
    if (!this.startCoords)
      return;
    const e = r.pageX - this.startCoords.pageX, n = r.pageY - this.startCoords.pageY;
    (Math.abs(e) > so || Math.abs(n) > so) && (Math.abs(e) > Math.abs(n) ? e > so ? this.processActions("swipe_right") : e < -so && this.processActions("swipe_left") : n > so ? this.processActions("swipe_down") : n < -so && this.processActions("swipe_up"), this.startCoords = void 0);
  }
  onPointerUp() {
    this.startCoords = void 0;
  }
  mountView(r, e) {
    this.context = e, r.addEventListener("pointerdown", this.onPointerDown), r.addEventListener("pointermove", this.onPointerMove), r.addEventListener("pointerup", this.onPointerUp), r.addEventListener("pointercancel", this.onPointerUp), r.style.pointerEvents = "auto";
  }
  updateView(r) {
    r.style.pointerEvents = "auto";
  }
  unmountView(r, e) {
    r.removeEventListener("pointerdown", this.onPointerDown), r.removeEventListener("pointermove", this.onPointerMove), r.removeEventListener("pointerup", this.onPointerUp), r.removeEventListener("pointercancel", this.onPointerUp), r.style.pointerEvents = "";
  }
}
function Ov(t) {
  return t instanceof HTMLElement;
}
function Uv(t) {
  return class {
    constructor(e) {
      dr(this, "params");
      dr(this, "animItem");
      dr(this, "wrapper");
      dr(this, "isPlayingUnsubscriber");
      dr(this, "isPlaying", !0);
      dr(this, "unsubscribe");
      this.params = e;
    }
    loadData(e) {
      return this.params.lottie_json ? Promise.resolve(this.params.lottie_json) : e ? fetch(e).then((n) => {
        if (!n.ok)
          throw new Error("Response is not ok");
        return n.json();
      }) : Promise.reject("Missing data");
    }
    getRatio(e) {
      var i;
      const n = (i = e.getComponentProperty("aspect")) == null ? void 0 : i.ratio;
      if (typeof n == "number" && n > 0)
        return n;
    }
    getScale(e) {
      const n = e.getComponentProperty("scale");
      if (n === "stretch")
        return {
          attribute: "none",
          noScale: !1,
          hAlign: "center",
          vAlign: "center"
        };
      let i = e.getComponentProperty("content_alignment_horizontal"), o = e.getComponentProperty("content_alignment_vertical"), s = "Mid", a = "Mid";
      return i === "start" ? i = e.direction === "ltr" ? "start" : "end" : i === "end" ? i = e.direction === "ltr" ? "end" : "start" : i === "left" ? i = "start" : i === "right" ? i = "end" : i = "center", o === "top" ? o = "start" : o === "bottom" ? o = "end" : o = "center", n === "no_scale" ? {
        attribute: "xMidYMid meet",
        noScale: !0,
        hAlign: i,
        vAlign: o
      } : (i === "start" ? s = "Min" : i === "end" && (s = "Max"), o === "start" ? a = "Min" : o === "end" && (a = "Max"), n === "fit" || n === "no_scale" ? {
        attribute: `x${s}Y${a} meet`,
        noScale: !1,
        hAlign: i,
        vAlign: o
      } : {
        attribute: `x${s}Y${a} slice`,
        noScale: !1,
        hAlign: i,
        vAlign: o
      });
    }
    getSvg() {
      var n;
      const e = (n = this.wrapper) == null ? void 0 : n.firstElementChild;
      if (e instanceof SVGElement)
        return e;
    }
    setWrapperScale(e) {
      this.wrapper && (e.noScale ? (this.wrapper.style.display = "flex", this.wrapper.style.alignItems = e.vAlign, this.wrapper.style.justifyContent = e.hAlign) : (this.wrapper.style.display = "", this.wrapper.style.alignItems = "", this.wrapper.style.justifyContent = ""));
    }
    setSvgScale(e) {
      const n = this.getSvg();
      n && (e.noScale ? (n.style.flex = "0 0 auto", n.style.width = "", n.style.height = "") : (n.style.flex = "", n.style.width = "100%", n.style.height = "100%"));
    }
    mountView(e, n) {
      var f;
      if (!this.params.lottie_url && !this.params.lottie_json)
        return;
      const i = Array.from(e.children).filter(Ov);
      i.forEach((_) => {
        _.style.display = "none";
      }), e.setAttribute("data-lottie", "true");
      const o = this.wrapper = document.createElement("div");
      this.wrapper.style.width = "100%", this.wrapper.style.height = "100%";
      const s = this.getRatio(n), a = this.getScale(n);
      s && (this.wrapper.style.aspectRatio = String(s)), this.setWrapperScale(a), e.appendChild(this.wrapper);
      const l = Number((f = n.processExpressions(this.params.repeat_count)) != null ? f : -1), u = n.processExpressions(this.params.repeat_mode), c = () => {
        var g, y;
        (g = this.animItem) == null || g.destroy(), i.forEach((p) => {
          p.style.display = "";
        }), e.removeAttribute("data-lottie"), this.wrapper && ((y = this.wrapper.parentNode) == null || y.removeChild(this.wrapper), this.wrapper = void 0);
        const _ = new Error("Failed to load lottie animation");
        _.level = "error", _.additional = {
          url: this.params.lottie_url
        }, n.logError(_);
      };
      this.unsubscribe = n.derviedExpression(this.params.lottie_url).subscribe((_) => {
        this.loadData(_).then((g) => {
          var p;
          (p = this.animItem) == null || p.destroy();
          const y = this.animItem = t({
            container: o,
            animationData: g,
            renderer: "svg",
            loop: !0,
            rendererSettings: {
              preserveAspectRatio: a.attribute
            }
          });
          if (this.setSvgScale(a), this.animItem.addEventListener("data_failed", c), u === "reverse" || l !== -1) {
            let w = 1, E = 0;
            y.addEventListener("loopComplete", () => {
              ++E, l !== -1 && E === l ? (y.stop(), y.goToAndStop(y.totalFrames, !0)) : (u === "reverse" && (w *= -1, y.setDirection(w)), y.goToAndPlay(w === 1 ? 0 : y.totalFrames, !0));
            });
          }
        }).catch(c);
      }), this.isPlayingUnsubscriber = n.derviedExpression(this.params.is_playing).subscribe((_) => {
        this.isPlaying = _ !== !1, this.animItem && this.animItem[this.isPlaying ? "play" : "pause"]();
      });
    }
    updateView(e, n) {
      if (!this.wrapper)
        return;
      const i = this.getRatio(n);
      i && (this.wrapper.style.aspectRatio = String(i));
      const o = this.getSvg();
      if (o) {
        const s = this.getScale(n);
        this.setWrapperScale(s), this.setSvgScale(s), o.setAttribute("preserveAspectRatio", s.attribute);
      }
    }
    unmountView(e, n) {
      var i, o, s, a;
      (i = this.animItem) == null || i.destroy(), this.wrapper && ((o = this.wrapper.parentNode) == null || o.removeChild(this.wrapper), this.wrapper = void 0), e.removeAttribute("data-lottie"), (s = this.unsubscribe) == null || s.call(this), (a = this.isPlayingUnsubscriber) == null || a.call(this);
    }
  };
}
function Yv(t, r = {}) {
  return class {
    constructor() {
      dr(this, "prevDOM", null);
    }
    recalc(n, i) {
      const o = n.firstElementChild, s = o == null ? void 0 : o.firstElementChild;
      if (!s)
        return;
      this.prevDOM = o.cloneNode(!0);
      const a = i.getComponentProperty("text") || "", l = t(a), u = document.createElement("div");
      u.innerHTML = l, r != null && r.cssClass && u.classList.add(r.cssClass);
      const c = Array.from(o.childNodes);
      for (let f = 0, _ = c.length; f < _; ++f) {
        const g = c[f];
        (g.nodeType !== 1 || g !== s) && o.removeChild(g);
      }
      s.innerHTML = "", s.appendChild(u);
    }
    mountView(n, i) {
      this.recalc(n, i);
    }
    updateView(n, i) {
      this.recalc(n, i);
    }
    unmountView(n) {
      if (this.prevDOM) {
        const i = n.firstElementChild;
        i && i.replaceWith(this.prevDOM), this.prevDOM = null;
      }
    }
  };
}
function qv(t) {
  const { target: r, hydrate: e, ...n } = t, i = new Nv({
    target: r,
    props: n,
    hydrate: e
  });
  return {
    $destroy() {
      i.$destroy();
    },
    execAction(o) {
      i.execAction(o);
    },
    setTheme(o) {
      i.setTheme(o);
    },
    setData(o) {
      i.setData(o);
    },
    applyPatch(o) {
      return i.applyPatch(o);
    }
  };
}
export {
  Hv as Gesture,
  Bv as SizeProvider,
  Rv as createGlobalVariablesController,
  mi as createVariable,
  Uv as lottieExtensionBuilder,
  Yv as markdownExtensionBuilder,
  qv as render
};
//# sourceMappingURL=client.mjs.map
